var H2 = Object.defineProperty;
var G2 = (e, t, n) => t in e ? H2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var m0 = (e, t, n) => G2(e, typeof t != "symbol" ? t + "" : t, n);
import ae from "@emotion/styled";
import * as oi from "react";
import qe, { useReducer as yv, useCallback as ot, forwardRef as Up, useContext as Mo, memo as Kt, useMemo as Ce, useState as Te, useEffect as tt, useRef as sr, useImperativeHandle as V2, Fragment as Q2, isValidElement as Av, cloneElement as q2 } from "react";
import { pickBy as X2, capitalize as vv, isEqual as Ys, merge as g0, debounce as J2, downloadFile as K2, isString as Z2, isObject as ad, getCodeLanguageByFileExtension as Zu, getUUID as xv, startCase as eC, getFileExtension as tC, eraseCookie as y0, getFormatDateFromNow as bv, getFormatDateAndTime as Vn, isAiGeneratedMetadata as nC, parseActions as Ec, getStatusColor as A0, createHeadersFromMetadataAttributes as rC, isAiMetadataName as iC, separateSearchFilters as wv, populateColumnsConfigWithSort as aC, parseMetadataValues as _v, isEmpty as oC, api as Nn, getSortDirection as sC, formatBytes as v0 } from "@prometheus/utils";
import { ValidationMessageSeverity as hr, FileExtension as tn, MediaType as Go, HealthStatus as ar, AnalysisSubmissionStatus as dr, EntityType as We, ConceptSetSectionTabs as Dr, TypesOfContainer as ge, EntityIconNames as wt, analysisTypesMap as Hp, studyStatuses as x0, AnalysisTypes as pa, analysisBaseInfoActions as lC, MetaAttributeTypes as Lt, containerTypes as Gp, EntityTypes as ef, OtherImportTypes as si, ImportAtlasAsset as ki, NameConflictResolution as Ct, atlasAssetList as cC } from "@prometheus/enums";
import { produce as uC } from "immer";
import { Box as we, transparentize as Bi, Spinner as gt, useTheme as Xr, SeverityIcons as fC, Button as Ee, CollapsiblePanel as dC, Grid as O, FilterPanel as Vp, Table as xl, Block as lr, Tooltip as yt, Icon as he, Typography as le, Input as xr, useNotifications as bi, IconActionButton as Ue, DialogTitle as Sv, DialogContent as Cv, DialogActions as Ev, Dialog as kv, Textarea as hC, Checkbox as Tv, StatusTag as Qp, Skeleton as ii, LoaderProgress as pC, Placeholder as mC, IconButton as bl, BlockTitle as Mv, FavoriteIcon as gC, Avatar as Iv, MenuItem as mh, MenuList as yC, Divider as xa, Menu as AC, ClickAwayListener as Nv, Badge as qp, PopoverContent as Ov, Popover as Rv, ComparisonIcon as gh, HierarchyIcons as vC, tooltipClasses as b0, MuiTooltip as xC, ContentBlock as zr, NewTable as ua, EmptyTableStub as bC, DropDownMenu as Dv, setLightness as w0, StudyStatuses as wC, EditableInput as Xt, AnalysisIcon as Pv, LogoBox as _C, IconActionDropdown as SC, EditableAutocomplete as CC, EditableDatePicker as _0, WelcomePageIcon as tf, InputFilter as Lv, ButtonGroup as EC, Paper as vr, Select as mr, Autocomplete as zv, Alert as Bv, SEARCH_PRECISION_OPTIONS as S0, Radio as Vc } from "@prometheus/components";
import { IconActionButton as VG } from "@prometheus/components";
import { Status as ve, InvitationTypes as It, ListActions as kc, EntityActions as kC, AiSuggestionStatus as C0 } from "@prometheus/types";
import TC from "@monaco-editor/react";
import { setLightness as MC, transparentize as Yn, darken as IC } from "polished";
import { useTranslation as Ma } from "react-i18next";
import { DialogContext as Xp, useInterval as Fv, ModalContext as Jp, useDownloadAnalysisTypes as NC, useMetadata as Yv, useEntityList as jv, useVersions as OC, useExportList as RC, useMetadataValues as $v, UseMetadataValuesStatus as tr, useSelectedConcepts as DC, useList as PC, UseFileExplorerStatus as LC, useFileExplorer as zC } from "@prometheus/hooks";
import { pdfjs as BC, Page as FC, Document as YC } from "react-pdf";
import { useTheme as Sr } from "@emotion/react";
import yh from "clsx";
import { useDispatch as Hi, useSelector as Ot } from "react-redux";
import { Link as jC, NavLink as Wv, matchPath as Uv, useBlocker as $C, useNavigate as cr, useSearchParams as Hv } from "react-router-dom";
import { getIncluded as E0, reloadCompareData as WC, removeCompareItem as UC, getImage as HC, setBreadcrumbs as GC, getSummary as VC, switchTenant as QC } from "@prometheus/redux";
import qC, { isNumber as XC } from "lodash";
import { LineChart as Gv, Line as Vv, ResponsiveContainer as JC, CartesianGrid as KC, XAxis as ZC, YAxis as eE, Tooltip as tE } from "recharts";
import nE from "react-virtualized-auto-sizer";
const EH = ae.div`
  padding: 16px;
`, rE = ae.div`
  font-size: 13px;
  label {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.header;
}};
    font-weight: 700;
    display: ${({ inline: e }) => e ? "inline-block" : "block"};
    /* font-size: 12px; */
    margin-bottom: 5px;
  }
  .required {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.error.main;
}};
  }
  p {
    margin: 0;
    margin-top: 2px;
    font-size: 12px;
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.secondary;
}};
  }
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.secondary;
}};
`, nf = ae.div`
  text-align: right;
  button:last-child {
    margin-left: 10px;
  }
`, kH = ae.div`
  margin-bottom: 10px;
  h5 {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #626262;
  }
`, Qv = {
  isLoading: !0,
  messages: [],
  filteredMessages: [],
  filters: [],
  filter: [],
  messagesCnt: 0,
  severity: hr.INFO,
  latestCheckedEntity: null
};
var ci = /* @__PURE__ */ ((e) => (e.GET_ENTITY_MESSAGES_PENDING = "GET_ENTITY_MESSAGES_PENDING", e.GET_ENTITY_MESSAGES_SUCCESS = "GET_ENTITY_MESSAGES_SUCCESS", e.GET_ENTITY_MESSAGES_FAILURE = "GET_ENTITY_MESSAGES_FAILURE", e.SET_FILTER = "SET_FILTER", e))(ci || {});
function k0(e = [], t = []) {
  return Array.isArray(t) && t.length ? e.filter((n) => t.includes(n.severity)) : e;
}
function iE(e = []) {
  if (!e.length) return [];
  const t = X2(
    qv(e),
    (r) => r > 0
  );
  return [
    {
      label: "Severity",
      type: "checkbox",
      collapsible: !0,
      name: "severity",
      options: Object.keys(t).map(
        (r) => ({
          name: `${vv(r)} (${t[r]})`,
          value: r
        })
      )
    }
  ];
}
function qv(e = []) {
  const t = Object.keys(
    hr
  ).reduce(
    (n, r) => ({ ...n, [r]: 0 }),
    {}
  );
  return e.reduce((n, r) => ({
    ...n,
    [r.severity]: n[r.severity] + 1
  }), t);
}
function aE(e = []) {
  const t = qv(e);
  return t[hr.CRITICAL] ? hr.CRITICAL : t[hr.WARNING] ? hr.WARNING : hr.INFO;
}
function Xv(e, t) {
  var n, r, i, a, o;
  switch (e) {
    case hr.WARNING:
      return ((n = t == null ? void 0 : t.palette) == null ? void 0 : n.warning.main) || "orange";
    case hr.CRITICAL:
      return ((r = t == null ? void 0 : t.palette) == null ? void 0 : r.error.main) || "red";
    case hr.INFO:
      return ((i = t == null ? void 0 : t.palette) == null ? void 0 : i.grey[500]) || "grey";
    case hr.DEFAULT:
      return ((a = t == null ? void 0 : t.palette) == null ? void 0 : a.info.main) || "blue";
    default:
      return ((o = t == null ? void 0 : t.palette) == null ? void 0 : o.grey[500]) || "grey";
  }
}
const oE = (e = Qv, t) => uC(e, (n) => {
  switch (t.type) {
    case ci.GET_ENTITY_MESSAGES_PENDING:
      n.isLoading = !0;
      break;
    case ci.GET_ENTITY_MESSAGES_SUCCESS:
      const { messages: r = [], latestCheckedEntity: i } = t.payload;
      n.isLoading = !1, n.latestCheckedEntity = i, n.messages = r, n.filters = iE(r), n.filteredMessages = k0(r, n.filter), n.messagesCnt = r.length || 0, n.severity = aE(r);
      break;
    case ci.GET_ENTITY_MESSAGES_FAILURE:
      n.isLoading = !1, n.latestCheckedEntity = null;
      break;
    case ci.SET_FILTER:
      n.filter = t.payload, n.filteredMessages = k0(
        n.messages,
        n.filter
      );
      break;
  }
});
function TH(e) {
  const { getMessages: t, fixEntity: n, fixEntityAvailability: r } = e, [i, a] = yv(
    oE,
    Qv
  ), {
    filteredMessages: o,
    messagesCnt: s,
    filter: c,
    filters: l,
    isLoading: u,
    severity: d,
    latestCheckedEntity: f
  } = i, h = ot(
    async (y) => {
      if (!Ys(f, y))
        try {
          a({
            type: ci.GET_ENTITY_MESSAGES_PENDING
          });
          const v = await t(
            y.expression
          );
          a({
            type: ci.GET_ENTITY_MESSAGES_SUCCESS,
            payload: {
              messages: v,
              latestCheckedEntity: y
            }
          });
        } catch (v) {
          console.error(v), a({
            type: ci.GET_ENTITY_MESSAGES_FAILURE
          });
        }
    },
    [f]
  ), m = ot(
    (y, v) => {
      a({
        type: ci.SET_FILTER,
        payload: v
      });
    },
    []
  );
  return {
    messages: o,
    messagesCnt: s,
    isLoading: u,
    filters: l,
    filter: c,
    severity: d,
    runCheck: h,
    fixEntity: n,
    setFilters: m,
    fixEntityAvailability: r
  };
}
var ba = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function sE(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Ah = { exports: {} }, Vo = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T0;
function lE() {
  if (T0) return Vo;
  T0 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, a) {
    var o = null;
    if (a !== void 0 && (o = "" + a), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      a = {};
      for (var s in i)
        s !== "key" && (a[s] = i[s]);
    } else a = i;
    return i = a.ref, {
      $$typeof: e,
      type: r,
      key: o,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return Vo.Fragment = t, Vo.jsx = n, Vo.jsxs = n, Vo;
}
var Qo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M0;
function cE() {
  return M0 || (M0 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(S) {
      if (S == null) return null;
      if (typeof S == "function")
        return S.$$typeof === R ? null : S.displayName || S.name || null;
      if (typeof S == "string") return S;
      switch (S) {
        case y:
          return "Fragment";
        case w:
          return "Profiler";
        case v:
          return "StrictMode";
        case g:
          return "Suspense";
        case A:
          return "SuspenseList";
        case _:
          return "Activity";
      }
      if (typeof S == "object")
        switch (typeof S.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), S.$$typeof) {
          case m:
            return "Portal";
          case M:
            return (S.displayName || "Context") + ".Provider";
          case I:
            return (S._context.displayName || "Context") + ".Consumer";
          case k:
            var $ = S.render;
            return S = S.displayName, S || (S = $.displayName || $.name || "", S = S !== "" ? "ForwardRef(" + S + ")" : "ForwardRef"), S;
          case b:
            return $ = S.displayName || null, $ !== null ? $ : e(S.type) || "Memo";
          case x:
            $ = S._payload, S = S._init;
            try {
              return e(S($));
            } catch {
            }
        }
      return null;
    }
    function t(S) {
      return "" + S;
    }
    function n(S) {
      try {
        t(S);
        var $ = !1;
      } catch {
        $ = !0;
      }
      if ($) {
        $ = console;
        var j = $.error, N = typeof Symbol == "function" && Symbol.toStringTag && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return j.call(
          $,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          N
        ), t(S);
      }
    }
    function r(S) {
      if (S === y) return "<>";
      if (typeof S == "object" && S !== null && S.$$typeof === x)
        return "<...>";
      try {
        var $ = e(S);
        return $ ? "<" + $ + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var S = P.A;
      return S === null ? null : S.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function o(S) {
      if (E.call(S, "key")) {
        var $ = Object.getOwnPropertyDescriptor(S, "key").get;
        if ($ && $.isReactWarning) return !1;
      }
      return S.key !== void 0;
    }
    function s(S, $) {
      function j() {
        D || (D = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          $
        ));
      }
      j.isReactWarning = !0, Object.defineProperty(S, "key", {
        get: j,
        configurable: !0
      });
    }
    function c() {
      var S = e(this.type);
      return z[S] || (z[S] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), S = this.props.ref, S !== void 0 ? S : null;
    }
    function l(S, $, j, N, q, G, X, Y) {
      return j = G.ref, S = {
        $$typeof: h,
        type: S,
        key: $,
        props: G,
        _owner: q
      }, (j !== void 0 ? j : null) !== null ? Object.defineProperty(S, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(S, "ref", { enumerable: !1, value: null }), S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(S, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(S, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: X
      }), Object.defineProperty(S, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Y
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    }
    function u(S, $, j, N, q, G, X, Y) {
      var Q = $.children;
      if (Q !== void 0)
        if (N)
          if (C(Q)) {
            for (N = 0; N < Q.length; N++)
              d(Q[N]);
            Object.freeze && Object.freeze(Q);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(Q);
      if (E.call($, "key")) {
        Q = e(S);
        var V = Object.keys($).filter(function(Z) {
          return Z !== "key";
        });
        N = 0 < V.length ? "{key: someKey, " + V.join(": ..., ") + ": ...}" : "{key: someKey}", L[Q + N] || (V = 0 < V.length ? "{" + V.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          N,
          Q,
          V,
          Q
        ), L[Q + N] = !0);
      }
      if (Q = null, j !== void 0 && (n(j), Q = "" + j), o($) && (n($.key), Q = "" + $.key), "key" in $) {
        j = {};
        for (var U in $)
          U !== "key" && (j[U] = $[U]);
      } else j = $;
      return Q && s(
        j,
        typeof S == "function" ? S.displayName || S.name || "Unknown" : S
      ), l(
        S,
        Q,
        G,
        q,
        i(),
        j,
        X,
        Y
      );
    }
    function d(S) {
      typeof S == "object" && S !== null && S.$$typeof === h && S._store && (S._store.validated = 1);
    }
    var f = qe, h = Symbol.for("react.transitional.element"), m = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), I = Symbol.for("react.consumer"), M = Symbol.for("react.context"), k = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), A = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), _ = Symbol.for("react.activity"), R = Symbol.for("react.client.reference"), P = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, E = Object.prototype.hasOwnProperty, C = Array.isArray, T = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      react_stack_bottom_frame: function(S) {
        return S();
      }
    };
    var D, z = {}, B = f.react_stack_bottom_frame.bind(
      f,
      a
    )(), W = T(r(a)), L = {};
    Qo.Fragment = y, Qo.jsx = function(S, $, j, N, q) {
      var G = 1e4 > P.recentlyCreatedOwnerStacks++;
      return u(
        S,
        $,
        j,
        !1,
        N,
        q,
        G ? Error("react-stack-top-frame") : B,
        G ? T(r(S)) : W
      );
    }, Qo.jsxs = function(S, $, j, N, q) {
      var G = 1e4 > P.recentlyCreatedOwnerStacks++;
      return u(
        S,
        $,
        j,
        !0,
        N,
        q,
        G ? Error("react-stack-top-frame") : B,
        G ? T(r(S)) : W
      );
    };
  }()), Qo;
}
process.env.NODE_ENV === "production" ? Ah.exports = lE() : Ah.exports = cE();
var Di = Ah.exports;
function uE(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function fE(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var dE = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(fE(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = uE(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), dn = "-ms-", Qc = "-moz-", ct = "-webkit-", Jv = "comm", Kp = "rule", Zp = "decl", hE = "@import", Kv = "@keyframes", pE = "@layer", mE = Math.abs, af = String.fromCharCode, gE = Object.assign;
function yE(e, t) {
  return on(e, 0) ^ 45 ? (((t << 2 ^ on(e, 0)) << 2 ^ on(e, 1)) << 2 ^ on(e, 2)) << 2 ^ on(e, 3) : 0;
}
function Zv(e) {
  return e.trim();
}
function AE(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ut(e, t, n) {
  return e.replace(t, n);
}
function vh(e, t) {
  return e.indexOf(t);
}
function on(e, t) {
  return e.charCodeAt(t) | 0;
}
function js(e, t, n) {
  return e.slice(t, n);
}
function Pr(e) {
  return e.length;
}
function em(e) {
  return e.length;
}
function ql(e, t) {
  return t.push(e), e;
}
function vE(e, t) {
  return e.map(t).join("");
}
var of = 1, Ao = 1, ex = 0, Rn = 0, $t = 0, Io = "";
function sf(e, t, n, r, i, a, o) {
  return { value: e, root: t, parent: n, type: r, props: i, children: a, line: of, column: Ao, length: o, return: "" };
}
function qo(e, t) {
  return gE(sf("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function xE() {
  return $t;
}
function bE() {
  return $t = Rn > 0 ? on(Io, --Rn) : 0, Ao--, $t === 10 && (Ao = 1, of--), $t;
}
function Gn() {
  return $t = Rn < ex ? on(Io, Rn++) : 0, Ao++, $t === 10 && (Ao = 1, of++), $t;
}
function Wr() {
  return on(Io, Rn);
}
function Tc() {
  return Rn;
}
function wl(e, t) {
  return js(Io, e, t);
}
function $s(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function tx(e) {
  return of = Ao = 1, ex = Pr(Io = e), Rn = 0, [];
}
function nx(e) {
  return Io = "", e;
}
function Mc(e) {
  return Zv(wl(Rn - 1, xh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function wE(e) {
  for (; ($t = Wr()) && $t < 33; )
    Gn();
  return $s(e) > 2 || $s($t) > 3 ? "" : " ";
}
function _E(e, t) {
  for (; --t && Gn() && !($t < 48 || $t > 102 || $t > 57 && $t < 65 || $t > 70 && $t < 97); )
    ;
  return wl(e, Tc() + (t < 6 && Wr() == 32 && Gn() == 32));
}
function xh(e) {
  for (; Gn(); )
    switch ($t) {
      case e:
        return Rn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && xh($t);
        break;
      case 40:
        e === 41 && xh(e);
        break;
      case 92:
        Gn();
        break;
    }
  return Rn;
}
function SE(e, t) {
  for (; Gn() && e + $t !== 57; )
    if (e + $t === 84 && Wr() === 47)
      break;
  return "/*" + wl(t, Rn - 1) + "*" + af(e === 47 ? e : Gn());
}
function CE(e) {
  for (; !$s(Wr()); )
    Gn();
  return wl(e, Rn);
}
function EE(e) {
  return nx(Ic("", null, null, null, [""], e = tx(e), 0, [0], e));
}
function Ic(e, t, n, r, i, a, o, s, c) {
  for (var l = 0, u = 0, d = o, f = 0, h = 0, m = 0, y = 1, v = 1, w = 1, I = 0, M = "", k = i, g = a, A = r, b = M; v; )
    switch (m = I, I = Gn()) {
      case 40:
        if (m != 108 && on(b, d - 1) == 58) {
          vh(b += ut(Mc(I), "&", "&\f"), "&\f") != -1 && (w = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        b += Mc(I);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        b += wE(m);
        break;
      case 92:
        b += _E(Tc() - 1, 7);
        continue;
      case 47:
        switch (Wr()) {
          case 42:
          case 47:
            ql(kE(SE(Gn(), Tc()), t, n), c);
            break;
          default:
            b += "/";
        }
        break;
      case 123 * y:
        s[l++] = Pr(b) * w;
      case 125 * y:
      case 59:
      case 0:
        switch (I) {
          case 0:
          case 125:
            v = 0;
          case 59 + u:
            w == -1 && (b = ut(b, /\f/g, "")), h > 0 && Pr(b) - d && ql(h > 32 ? N0(b + ";", r, n, d - 1) : N0(ut(b, " ", "") + ";", r, n, d - 2), c);
            break;
          case 59:
            b += ";";
          default:
            if (ql(A = I0(b, t, n, l, u, i, s, M, k = [], g = [], d), a), I === 123)
              if (u === 0)
                Ic(b, t, A, A, k, a, d, s, g);
              else
                switch (f === 99 && on(b, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ic(e, A, A, r && ql(I0(e, A, A, 0, 0, i, s, M, i, k = [], d), g), i, g, d, s, r ? k : g);
                    break;
                  default:
                    Ic(b, A, A, A, [""], g, 0, s, g);
                }
        }
        l = u = h = 0, y = w = 1, M = b = "", d = o;
        break;
      case 58:
        d = 1 + Pr(b), h = m;
      default:
        if (y < 1) {
          if (I == 123)
            --y;
          else if (I == 125 && y++ == 0 && bE() == 125)
            continue;
        }
        switch (b += af(I), I * y) {
          case 38:
            w = u > 0 ? 1 : (b += "\f", -1);
            break;
          case 44:
            s[l++] = (Pr(b) - 1) * w, w = 1;
            break;
          case 64:
            Wr() === 45 && (b += Mc(Gn())), f = Wr(), u = d = Pr(M = b += CE(Tc())), I++;
            break;
          case 45:
            m === 45 && Pr(b) == 2 && (y = 0);
        }
    }
  return a;
}
function I0(e, t, n, r, i, a, o, s, c, l, u) {
  for (var d = i - 1, f = i === 0 ? a : [""], h = em(f), m = 0, y = 0, v = 0; m < r; ++m)
    for (var w = 0, I = js(e, d + 1, d = mE(y = o[m])), M = e; w < h; ++w)
      (M = Zv(y > 0 ? f[w] + " " + I : ut(I, /&\f/g, f[w]))) && (c[v++] = M);
  return sf(e, t, n, i === 0 ? Kp : s, c, l, u);
}
function kE(e, t, n) {
  return sf(e, t, n, Jv, af(xE()), js(e, 2, -2), 0);
}
function N0(e, t, n, r) {
  return sf(e, t, n, Zp, js(e, 0, r), js(e, r + 1, -1), r);
}
function ro(e, t) {
  for (var n = "", r = em(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function TE(e, t, n, r) {
  switch (e.type) {
    case pE:
      if (e.children.length) break;
    case hE:
    case Zp:
      return e.return = e.return || e.value;
    case Jv:
      return "";
    case Kv:
      return e.return = e.value + "{" + ro(e.children, r) + "}";
    case Kp:
      e.value = e.props.join(",");
  }
  return Pr(n = ro(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function ME(e) {
  var t = em(e);
  return function(n, r, i, a) {
    for (var o = "", s = 0; s < t; s++)
      o += e[s](n, r, i, a) || "";
    return o;
  };
}
function IE(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function NE(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var OE = function(t, n, r) {
  for (var i = 0, a = 0; i = a, a = Wr(), i === 38 && a === 12 && (n[r] = 1), !$s(a); )
    Gn();
  return wl(t, Rn);
}, RE = function(t, n) {
  var r = -1, i = 44;
  do
    switch ($s(i)) {
      case 0:
        i === 38 && Wr() === 12 && (n[r] = 1), t[r] += OE(Rn - 1, n, r);
        break;
      case 2:
        t[r] += Mc(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = Wr() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += af(i);
    }
  while (i = Gn());
  return t;
}, DE = function(t, n) {
  return nx(RE(tx(t), n));
}, O0 = /* @__PURE__ */ new WeakMap(), PE = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !O0.get(r)) && !i) {
      O0.set(t, !0);
      for (var a = [], o = DE(n, a), s = r.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = a[c] ? o[c].replace(/&\f/g, s[u]) : s[u] + " " + o[c];
    }
  }
}, LE = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function rx(e, t) {
  switch (yE(e, t)) {
    case 5103:
      return ct + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ct + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ct + e + Qc + e + dn + e + e;
    case 6828:
    case 4268:
      return ct + e + dn + e + e;
    case 6165:
      return ct + e + dn + "flex-" + e + e;
    case 5187:
      return ct + e + ut(e, /(\w+).+(:[^]+)/, ct + "box-$1$2" + dn + "flex-$1$2") + e;
    case 5443:
      return ct + e + dn + "flex-item-" + ut(e, /flex-|-self/, "") + e;
    case 4675:
      return ct + e + dn + "flex-line-pack" + ut(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return ct + e + dn + ut(e, "shrink", "negative") + e;
    case 5292:
      return ct + e + dn + ut(e, "basis", "preferred-size") + e;
    case 6060:
      return ct + "box-" + ut(e, "-grow", "") + ct + e + dn + ut(e, "grow", "positive") + e;
    case 4554:
      return ct + ut(e, /([^-])(transform)/g, "$1" + ct + "$2") + e;
    case 6187:
      return ut(ut(ut(e, /(zoom-|grab)/, ct + "$1"), /(image-set)/, ct + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ut(e, /(image-set\([^]*)/, ct + "$1$`$1");
    case 4968:
      return ut(ut(e, /(.+:)(flex-)?(.*)/, ct + "box-pack:$3" + dn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ct + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ut(e, /(.+)-inline(.+)/, ct + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Pr(e) - 1 - t > 6) switch (on(e, t + 1)) {
        case 109:
          if (on(e, t + 4) !== 45) break;
        case 102:
          return ut(e, /(.+:)(.+)-([^]+)/, "$1" + ct + "$2-$3$1" + Qc + (on(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~vh(e, "stretch") ? rx(ut(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (on(e, t + 1) !== 115) break;
    case 6444:
      switch (on(e, Pr(e) - 3 - (~vh(e, "!important") && 10))) {
        case 107:
          return ut(e, ":", ":" + ct) + e;
        case 101:
          return ut(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ct + (on(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ct + "$2$3$1" + dn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (on(e, t + 11)) {
        case 114:
          return ct + e + dn + ut(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ct + e + dn + ut(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ct + e + dn + ut(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return ct + e + dn + e + e;
  }
  return e;
}
var zE = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Zp:
      t.return = rx(t.value, t.length);
      break;
    case Kv:
      return ro([qo(t, {
        value: ut(t.value, "@", "@" + ct)
      })], i);
    case Kp:
      if (t.length) return vE(t.props, function(a) {
        switch (AE(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return ro([qo(t, {
              props: [ut(a, /:(read-\w+)/, ":" + Qc + "$1")]
            })], i);
          case "::placeholder":
            return ro([qo(t, {
              props: [ut(a, /:(plac\w+)/, ":" + ct + "input-$1")]
            }), qo(t, {
              props: [ut(a, /:(plac\w+)/, ":" + Qc + "$1")]
            }), qo(t, {
              props: [ut(a, /:(plac\w+)/, dn + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, BE = [zE], FE = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(y) {
      var v = y.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || BE, a = {}, o, s = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(y) {
      for (var v = y.getAttribute("data-emotion").split(" "), w = 1; w < v.length; w++)
        a[v[w]] = !0;
      s.push(y);
    }
  );
  var c, l = [PE, LE];
  {
    var u, d = [TE, IE(function(y) {
      u.insert(y);
    })], f = ME(l.concat(i, d)), h = function(v) {
      return ro(EE(v), f);
    };
    c = function(v, w, I, M) {
      u = I, h(v ? v + "{" + w.styles + "}" : w.styles), M && (m.inserted[w.name] = !0);
    };
  }
  var m = {
    key: n,
    sheet: new dE({
      key: n,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return m.sheet.hydrate(s), m;
}, bh = { exports: {} }, ht = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R0;
function YE() {
  if (R0) return ht;
  R0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function M(g) {
    if (typeof g == "object" && g !== null) {
      var A = g.$$typeof;
      switch (A) {
        case t:
          switch (g = g.type, g) {
            case c:
            case l:
            case r:
            case a:
            case i:
            case d:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return g;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function k(g) {
    return M(g) === l;
  }
  return ht.AsyncMode = c, ht.ConcurrentMode = l, ht.ContextConsumer = s, ht.ContextProvider = o, ht.Element = t, ht.ForwardRef = u, ht.Fragment = r, ht.Lazy = m, ht.Memo = h, ht.Portal = n, ht.Profiler = a, ht.StrictMode = i, ht.Suspense = d, ht.isAsyncMode = function(g) {
    return k(g) || M(g) === c;
  }, ht.isConcurrentMode = k, ht.isContextConsumer = function(g) {
    return M(g) === s;
  }, ht.isContextProvider = function(g) {
    return M(g) === o;
  }, ht.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }, ht.isForwardRef = function(g) {
    return M(g) === u;
  }, ht.isFragment = function(g) {
    return M(g) === r;
  }, ht.isLazy = function(g) {
    return M(g) === m;
  }, ht.isMemo = function(g) {
    return M(g) === h;
  }, ht.isPortal = function(g) {
    return M(g) === n;
  }, ht.isProfiler = function(g) {
    return M(g) === a;
  }, ht.isStrictMode = function(g) {
    return M(g) === i;
  }, ht.isSuspense = function(g) {
    return M(g) === d;
  }, ht.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === r || g === l || g === a || g === i || g === d || g === f || typeof g == "object" && g !== null && (g.$$typeof === m || g.$$typeof === h || g.$$typeof === o || g.$$typeof === s || g.$$typeof === u || g.$$typeof === v || g.$$typeof === w || g.$$typeof === I || g.$$typeof === y);
  }, ht.typeOf = M, ht;
}
var pt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D0;
function jE() {
  return D0 || (D0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function M(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === r || H === l || H === a || H === i || H === d || H === f || typeof H == "object" && H !== null && (H.$$typeof === m || H.$$typeof === h || H.$$typeof === o || H.$$typeof === s || H.$$typeof === u || H.$$typeof === v || H.$$typeof === w || H.$$typeof === I || H.$$typeof === y);
    }
    function k(H) {
      if (typeof H == "object" && H !== null) {
        var ee = H.$$typeof;
        switch (ee) {
          case t:
            var ie = H.type;
            switch (ie) {
              case c:
              case l:
              case r:
              case a:
              case i:
              case d:
                return ie;
              default:
                var re = ie && ie.$$typeof;
                switch (re) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return re;
                  default:
                    return ee;
                }
            }
          case n:
            return ee;
        }
      }
    }
    var g = c, A = l, b = s, x = o, _ = t, R = u, P = r, E = m, C = h, T = n, D = a, z = i, B = d, W = !1;
    function L(H) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), S(H) || k(H) === c;
    }
    function S(H) {
      return k(H) === l;
    }
    function $(H) {
      return k(H) === s;
    }
    function j(H) {
      return k(H) === o;
    }
    function N(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function q(H) {
      return k(H) === u;
    }
    function G(H) {
      return k(H) === r;
    }
    function X(H) {
      return k(H) === m;
    }
    function Y(H) {
      return k(H) === h;
    }
    function Q(H) {
      return k(H) === n;
    }
    function V(H) {
      return k(H) === a;
    }
    function U(H) {
      return k(H) === i;
    }
    function Z(H) {
      return k(H) === d;
    }
    pt.AsyncMode = g, pt.ConcurrentMode = A, pt.ContextConsumer = b, pt.ContextProvider = x, pt.Element = _, pt.ForwardRef = R, pt.Fragment = P, pt.Lazy = E, pt.Memo = C, pt.Portal = T, pt.Profiler = D, pt.StrictMode = z, pt.Suspense = B, pt.isAsyncMode = L, pt.isConcurrentMode = S, pt.isContextConsumer = $, pt.isContextProvider = j, pt.isElement = N, pt.isForwardRef = q, pt.isFragment = G, pt.isLazy = X, pt.isMemo = Y, pt.isPortal = Q, pt.isProfiler = V, pt.isStrictMode = U, pt.isSuspense = Z, pt.isValidElementType = M, pt.typeOf = k;
  }()), pt;
}
process.env.NODE_ENV === "production" ? bh.exports = YE() : bh.exports = jE();
var tm = bh.exports, ix = tm, $E = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, WE = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ax = {};
ax[ix.ForwardRef] = $E;
ax[ix.Memo] = WE;
var UE = !0;
function HE(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (r += i + " ");
  }), r;
}
var ox = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  UE === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, GE = function(t, n, r) {
  ox(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + i : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function VE(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var QE = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, qE = /[A-Z]|^ms/g, XE = /_EMO_([^_]+?)_([^]*?)_EMO_/g, sx = function(t) {
  return t.charCodeAt(1) === 45;
}, P0 = function(t) {
  return t != null && typeof t != "boolean";
}, od = /* @__PURE__ */ NE(function(e) {
  return sx(e) ? e : e.replace(qE, "-$&").toLowerCase();
}), L0 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(XE, function(r, i, a) {
          return Lr = {
            name: i,
            styles: a,
            next: Lr
          }, i;
        });
  }
  return QE[t] !== 1 && !sx(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Ws(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Lr = {
          name: i.name,
          styles: i.styles,
          next: Lr
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var o = a.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Lr = {
              name: o.name,
              styles: o.styles,
              next: Lr
            }, o = o.next;
        var s = a.styles + ";";
        return s;
      }
      return JE(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Lr, l = n(e);
        return Lr = c, Ws(e, t, l);
      }
      break;
    }
  }
  var u = n;
  return u;
}
function JE(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += Ws(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var o = n[a];
      if (typeof o != "object") {
        var s = o;
        P0(s) && (r += od(a) + ":" + L0(a, s) + ";");
      } else if (Array.isArray(o) && typeof o[0] == "string" && t == null)
        for (var c = 0; c < o.length; c++)
          P0(o[c]) && (r += od(a) + ":" + L0(a, o[c]) + ";");
      else {
        var l = Ws(e, t, o);
        switch (a) {
          case "animation":
          case "animationName": {
            r += od(a) + ":" + l + ";";
            break;
          }
          default:
            r += a + "{" + l + "}";
        }
      }
    }
  return r;
}
var z0 = /label:\s*([^\s;{]+)\s*(;|$)/g, Lr;
function KE(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Lr = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += Ws(n, t, a);
  else {
    var o = a;
    i += o[0];
  }
  for (var s = 1; s < e.length; s++)
    if (i += Ws(n, t, e[s]), r) {
      var c = a;
      i += c[s];
    }
  z0.lastIndex = 0;
  for (var l = "", u; (u = z0.exec(i)) !== null; )
    l += "-" + u[1];
  var d = VE(i) + l;
  return {
    name: d,
    styles: i,
    next: Lr
  };
}
var ZE = function(t) {
  return t();
}, ek = oi.useInsertionEffect ? oi.useInsertionEffect : !1, tk = ek || ZE, lx = /* @__PURE__ */ oi.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ FE({
    key: "css"
  }) : null
);
lx.Provider;
var nk = function(t) {
  return /* @__PURE__ */ Up(function(n, r) {
    var i = Mo(lx);
    return t(n, i, r);
  });
}, rk = /* @__PURE__ */ oi.createContext({}), lf = {}.hasOwnProperty, wh = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", cx = function(t, n) {
  var r = {};
  for (var i in n)
    lf.call(n, i) && (r[i] = n[i]);
  return r[wh] = t, r;
}, ik = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return ox(n, r, i), tk(function() {
    return GE(n, r, i);
  }), null;
}, ak = /* @__PURE__ */ nk(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var i = e[wh], a = [r], o = "";
  typeof e.className == "string" ? o = HE(t.registered, a, e.className) : e.className != null && (o = e.className + " ");
  var s = KE(a, void 0, oi.useContext(rk));
  o += t.key + "-" + s.name;
  var c = {};
  for (var l in e)
    lf.call(e, l) && l !== "css" && l !== wh && (c[l] = e[l]);
  return c.className = o, n && (c.ref = n), /* @__PURE__ */ oi.createElement(oi.Fragment, null, /* @__PURE__ */ oi.createElement(ik, {
    cache: t,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ oi.createElement(i, c));
}), ux = ak, ze = Di.Fragment, p = function(t, n, r) {
  return lf.call(n, "css") ? Di.jsx(ux, cx(t, n), r) : Di.jsx(t, n, r);
}, F = function(t, n, r) {
  return lf.call(n, "css") ? Di.jsxs(ux, cx(t, n), r) : Di.jsxs(t, n, r);
};
const Nc = ae(we, {
  shouldForwardProp: (e) => e !== "color" && e !== "dense" && e !== "disabled" && e !== "inverted"
})(
  ({ theme: e, color: t = "info", dense: n, disabled: r, inverted: i }) => ({
    backgroundColor: i ? Bi(0.6, "#ffffff") : Bi(
      t === "info" ? 0.85 : 0.2,
      r ? e.palette.grey[400] : e.palette[t].main
    ),
    borderRadius: "2px",
    color: function() {
      return r ? e.palette.grey[400] : i ? "#ffffff" : t === "info" ? e.palette.textColor.primary : "#ffffff";
    }(),
    fontSize: n ? 11 : 12,
    padding: n ? "2px 5px" : "3px 6px",
    display: "inline-flex",
    height: n ? 17 : 19,
    lineHeight: "14px",
    boxSizing: "border-box",
    fontWeight: 400
  })
), ok = ae("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  ".tab-title": {
    marginRight: "8px"
  }
})), _h = ({
  status: e,
  count: t,
  title: n,
  severity: r = "info",
  dense: i,
  hideZeroCount: a = !1,
  hideTitle: o = !1
}) => /* @__PURE__ */ F(ok, { className: "tab-wrapper", children: [
  !o && /* @__PURE__ */ p("div", { className: "tab-title", children: n }),
  !a && (() => {
    switch (e) {
      case ve.IN_PROGRESS:
        return /* @__PURE__ */ p(Nc, { dense: i, className: "tab-count", children: /* @__PURE__ */ p(gt, { size: 11, color: "info" }) });
      case ve.IN_PROGRESS_RELOAD:
      case ve.SUCCESS:
        return /* @__PURE__ */ p(Nc, { color: r, dense: i, className: "tab-count", children: t });
      case ve.ERROR:
      case ve.INITIAL:
      default:
        return /* @__PURE__ */ p(Nc, { color: r, dense: i, className: "tab-count", children: "0" });
    }
  })()
] }), MH = Kt((e) => {
  const {
    title: t = "Messages",
    messagesCnt: n,
    severity: r,
    showCnt: i = !0,
    isLoading: a = !1,
    max: o,
    hideTitle: s = !1
  } = e, c = o && !Number.isNaN(Number(o)) && Number(n) > Number(o) ? `${o}+` : n;
  return /* @__PURE__ */ p(
    _h,
    {
      title: t,
      status: a ? ve.IN_PROGRESS : ve.SUCCESS,
      count: c,
      severity: {
        INFO: "info",
        WARNING: "warning",
        CRITICAL: "error",
        DEFAULT: "info"
      }[r],
      hideTitle: s
    }
  );
}), sk = ae.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
`, lk = Kt((e) => {
  const { severity: t } = e, n = Xr(), r = Xv(t, n);
  return /* @__PURE__ */ p(sk, { children: /* @__PURE__ */ p(fC, { iconName: t.toLowerCase(), color: r }) });
}), ck = ae.span`
  margin-right: 10px;
`, uk = Kt((e) => {
  const { text: t, data: n, fixEntity: r, fixEntityAvailability: i } = e, { original: a } = n, o = Ce(
    () => i == null ? void 0 : i(a),
    []
  ), s = ot(
    (c) => {
      c.preventDefault(), r == null || r(a);
    },
    [a]
  );
  return /* @__PURE__ */ F("div", { children: [
    /* @__PURE__ */ p(ck, { children: vv(t) }),
    o && /* @__PURE__ */ p(Ee, { size: "small", variant: "outlined", onClick: s, children: "Fix it" })
  ] });
}), fk = ae.div`
  display: flex;
  color: #fff;
  background-color: ${({ severity: e, theme: t }) => Xv(e, t)};
  /* margin-left: 5px; */
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 16px;
  min-width: 8px;
  border-radius: 10px;
`, dk = ae.div`
  display: flex;
  margin-left: 5px;
  height: 16px;
  width: 16px;
  align-items: center;
`, IH = Kt(
  (e) => {
    const { visible: t, cnt: n, severity: r, isLoading: i } = e;
    return t ? /* @__PURE__ */ p(ze, { children: i ? /* @__PURE__ */ p(dk, { children: /* @__PURE__ */ p(gt, { size: 12 }) }) : /* @__PURE__ */ p(
      fk,
      {
        severity: r,
        className: "counter-badge",
        children: n
      }
    ) }) : null;
  }
), hk = {
  columns: (e, t) => [
    {
      Header: "Severity",
      accessor: "severity",
      Cell: ({ value: n }) => /* @__PURE__ */ p(lk, { severity: n })
      // @NOTICE: Use this syntax to enable typescript props checking
    },
    {
      Header: "Message",
      accessor: "message",
      sortType: (n, r, i) => {
        const a = n.original[i].toLowerCase(), o = r.original[i].toLowerCase();
        return a > o ? 1 : o > a ? -1 : 0;
      },
      Cell: ({ value: n, row: r }) => /* @__PURE__ */ p(
        uk,
        {
          text: n,
          data: r,
          fixEntity: e,
          fixEntityAvailability: t
        }
      )
    }
  ]
}, pk = ae(dC)`
  margin-right: 20px;
  min-width: 150px;
  box-shadow: none;
  .content-block__heading {
    /* font-size: 14px; */
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  .filter-panel__content {
    padding: 12px;
  }
  .c-filter-panel {
    border: none;
    padding-bottom: 0;
  }
`, NH = Kt((e) => {
  const {
    messages: t,
    filters: n,
    setFilters: r,
    isLoading: i,
    loadingMessage: a = "Loading Messages",
    filter: o,
    fixEntity: s,
    fixEntityAvailability: c
  } = e, l = Ce(
    () => hk.columns(s, c),
    [s]
  ), u = Ce(() => ({ severity: o }), [o]);
  return /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ F(O, { container: !0, p: 2, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 3, children: /* @__PURE__ */ p(pk, { title: "Severity", visible: !0, collapsible: !0, children: /* @__PURE__ */ p("div", { className: "filter-panel__content", children: /* @__PURE__ */ p(
      Vp,
      {
        showLabel: !1,
        filters: n,
        value: u,
        isLoading: i,
        onChange: r
      }
    ) }) }) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 9, children: /* @__PURE__ */ p(
      xl,
      {
        columns: l,
        data: t,
        isLoading: i,
        loadingMessage: a,
        enableSorting: !0,
        enablePagination: !0,
        showColumnToggle: !0
      }
    ) })
  ] }) });
}), Us = ae(Ee)`
  padding: 2px;
  min-width: 20px;
`;
ae.div`
  /* padding: 20px; */
`;
const mk = ae.div`
  background-color: #d8e1ef;
  color: #343434;
  margin-right: -2px;
  padding: 8px 12px;
  justify-content: space-between;
`, gk = ae.div`
  position: relative;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-end;

  .monaco-editor {
    border: 1px solid #d8e1ef;
    /* border-top: none; */

    .line-numbers,
    .active-line-number {
      color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    }
    .margin {
      .current-line {
        background-color: ${({ theme: e }) => {
  var t;
  return MC(0.9, ((t = e.palette) == null ? void 0 : t.primary.main) || "#000000");
}};
      }
    }
    .margin {
      background-color: #e6ecf5;
    }
  }
`, yk = ae.div`
  display: flex;
  padding-bottom: 10px;
  position: absolute;
  right: 16px;
  top: 2px;
  z-index: 4;
`;
var fx = /* @__PURE__ */ ((e) => (e.APPLICATION_JSON = "application/json", e.APPLICATION_TEXT = "application/text", e))(fx || {});
const B0 = {
  contextmenu: !1,
  readOnly: !0,
  domReadOnly: !0,
  scrollBeyondLastLine: !1,
  wordWrap: "wordWrapColumn",
  wrappingStrategy: "advanced",
  tabSize: 2,
  minimap: {
    enabled: !1
  },
  parameterHints: {
    enabled: !1
  },
  // inlineHints: {
  //   enabled: false,
  // },
  hover: {
    enabled: !1
  }
}, Ak = {
  parameterHints: {
    enabled: !0
  },
  // inlineHints: {
  //   enabled: true,
  // },
  hover: {
    enabled: !0
  }
};
function vk(e, t = !0) {
  return !e.readOnly && t ? g0(
    B0,
    Ak,
    e
  ) : g0(B0, e);
}
function xk(e) {
  try {
    return JSON.parse(e);
  } catch {
    return !1;
  }
}
const _l = Kt((e) => {
  const { t } = Ma(), [n, r] = Te(!1), {
    title: i = "",
    tooltipText: a = t("features.code_editor.tooltip_text"),
    fileName: o = t("features.code_editor.file"),
    fileExtension: s = tn.JSON,
    contentType: c = fx.APPLICATION_JSON,
    editorOptions: l = {},
    data: u,
    language: d = "plaintext",
    placeholder: f,
    placeholderStyles: h = {},
    height: m = "500px",
    containerStyles: y = {},
    readOnly: v = !1,
    enableValidation: w = !0,
    enableCopy: I = !0,
    enableDownload: M = !0,
    onChange: k,
    remoteFile: g = !1,
    downloadMethod: A
  } = e, b = Ce(
    () => vk(
      { ...l, readOnly: v, copyWithSyntaxHighlighting: !0 },
      w
    ),
    [l, w, v]
  ), [x, _] = Te(""), R = I || M, P = f && !x, E = ot(() => {
    r(!0), navigator.clipboard.writeText(x), J2(() => r(!1), 2e3)();
  }, [x]), C = ot(() => {
    K2(x, `${o}.${s}`, c);
  }, [u, o, s, c, x]), T = ot((D) => {
    k == null || k(D);
  }, []);
  return tt(() => {
    if (!g) {
      if (d === "json")
        if (u && Z2(u)) {
          const B = xk(u);
          _(B ? JSON.stringify(B, null, 2) : u);
        } else {
          const B = ad(u) ? JSON.stringify(u, null, 2) : u;
          _(B);
        }
      else
        _(u);
      return;
    }
    async function D() {
      const z = await A(
        ad(u) ? u == null ? void 0 : u.id : u
      ), B = ad(z) ? JSON.stringify(z, null, 2) : z;
      _(B);
    }
    D == null || D();
  }, [u]), /* @__PURE__ */ F(we, { sx: y, children: [
    i && /* @__PURE__ */ p(mk, { title: i, children: i }),
    /* @__PURE__ */ F(gk, { children: [
      R && /* @__PURE__ */ F(yk, { className: "actions-container", children: [
        I && /* @__PURE__ */ p(
          Us,
          {
            onClick: E,
            className: "actions-container__button-copy",
            name: "copyToClipboard",
            children: /* @__PURE__ */ p(
              yt,
              {
                text: a,
                controlled: !0,
                show: n,
                width: 130,
                children: /* @__PURE__ */ p(
                  he,
                  {
                    iconName: "copy",
                    sx: { fontSize: 18 },
                    name: "Copy to clipboard"
                  }
                )
              }
            )
          }
        ),
        M && /* @__PURE__ */ p(
          Us,
          {
            onClick: C,
            className: "actions-container__button-download",
            name: "downloadFile",
            children: /* @__PURE__ */ p(
              he,
              {
                iconName: "download",
                sx: { fontSize: 18 },
                name: "Download as file"
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ p(
        TC,
        {
          height: m,
          language: d,
          value: x,
          options: b,
          onChange: T
        }
      ),
      P && /* @__PURE__ */ p(
        we,
        {
          sx: {
            color: "text.disabled",
            fontFamily: "monospace",
            fontSize: 13,
            left: 66,
            lineHeight: "19px",
            pointerEvents: "none",
            position: "absolute",
            right: 16,
            top: 6,
            whiteSpace: "pre",
            zIndex: 3,
            ...h
          },
          children: f
        }
      )
    ] })
  ] });
}), nn = Kt((e) => {
  const { name: t, textLabel: n, required: r, children: i, inline: a } = e;
  return /* @__PURE__ */ F(rE, { inline: a, children: [
    /* @__PURE__ */ F("label", { htmlFor: t, children: [
      n,
      r ? /* @__PURE__ */ p("sup", { className: "required", children: "*" }) : /* @__PURE__ */ p(ze, {})
    ] }),
    i
  ] });
}), OH = (e) => {
  const { htmlFor: t, label: n, required: r, children: i } = e;
  return /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
    /* @__PURE__ */ F(
      le,
      {
        variant: "subtitle1",
        component: "label",
        sx: {
          sup: {
            color: "error.main",
            ml: 0.25
          }
        },
        htmlFor: t,
        children: [
          n,
          r ? /* @__PURE__ */ p("sup", { className: "required", children: " *" }) : /* @__PURE__ */ p(ze, {})
        ]
      }
    ),
    i
  ] });
}, RH = (e) => {
  const {
    name: t,
    textLabel: n,
    htmlFor: r,
    required: i,
    children: a,
    description: o,
    labelSize: s,
    fullSize: c,
    dense: l
  } = e;
  return /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(
    O,
    {
      container: !0,
      alignItems: "center",
      columnSpacing: l ? 1.5 : 2,
      p: l ? 0 : 1,
      children: [
        /* @__PURE__ */ F(O, { item: !0, ...c ? {} : { xs: s || 7 }, children: [
          /* @__PURE__ */ F(
            le,
            {
              component: "label",
              variant: "subtitle2",
              htmlFor: r || t,
              sx: {
                // fontSize: 14,
                fontWeight: 700,
                ".required": { color: "error.main" }
              },
              children: [
                n,
                i ? /* @__PURE__ */ p("span", { className: "required", children: "*" }) : /* @__PURE__ */ p(ze, {})
              ]
            }
          ),
          o && /* @__PURE__ */ p(le, { variant: "subtitle2", children: o })
        ] }),
        /* @__PURE__ */ p(
          O,
          {
            item: !0,
            ...c ? { flexGrow: 1 } : { xs: 12 - (s || 7) },
            children: a
          }
        )
      ]
    }
  ) });
}, bk = Kt((e) => {
  const {
    nameKey: t,
    codeKey: n,
    editorHeight: r,
    editorTitle: i,
    fields: a = [],
    fileExtension: o,
    contentType: s,
    onSubmit: c,
    onFieldValueChange: l,
    isLoading: u = !1,
    submitButtonText: d = "Import",
    isSubmitDisabled: f = !1,
    fieldErrors: h = {},
    onCancel: m,
    footerStart: y
  } = e, v = Ce(
    () => Zu(tn.JSON),
    []
  ), [w, I] = Te({
    [n]: "",
    ...a.reduce((g, A) => ({ ...g, [A.name]: A.defaultValue ?? "" }), {})
  }), M = (g) => {
    const A = typeof g == "string" ? n : g.target.name, b = typeof g == "string" ? g : g.target.value, x = { [A]: b };
    I((_) => ({ ..._, ...x })), l == null || l(A, b);
  }, k = ot(
    (g) => {
      g.preventDefault(), c == null || c(w);
    },
    [w]
  );
  return /* @__PURE__ */ F(O, { container: !0, spacing: 1, children: [
    (a == null ? void 0 : a.length) && a.map(
      ({ name: g, label: A, type: b, Component: x, ..._ }) => /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(nn, { name: g, textLabel: A, children: [
        /* @__PURE__ */ p(
          x,
          {
            id: g,
            type: b,
            name: g,
            value: w[g] || "",
            onChange: M,
            fullWidth: !0,
            ..._
          }
        ),
        (h == null ? void 0 : h[g]) && /* @__PURE__ */ p(le, { color: "error.main", variant: "caption", children: h[g] })
      ] }) }, g)
    ),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ p(
      _l,
      {
        title: i,
        data: w[n] || "",
        fileName: w[t] || "File",
        height: r,
        language: v,
        onChange: M,
        fileExtension: o,
        contentType: s
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nf, { children: /* @__PURE__ */ F(O, { container: !0, alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ p(O, { item: !0, children: y }),
      /* @__PURE__ */ F(O, { item: !0, children: [
        m && /* @__PURE__ */ p(
          Ee,
          {
            variant: "outlined",
            onClick: m,
            size: "small",
            startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ p(
          Ee,
          {
            variant: "contained",
            onClick: k,
            color: "success",
            startIcon: u ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "import" }),
            disabled: u || f || !w.name || !w.expression,
            children: d
          }
        )
      ] })
    ] }) }) })
  ] });
}), F0 = [
  {
    Component: xr,
    name: "name",
    label: "Name",
    type: "text"
  },
  {
    Component: xr,
    name: "description",
    label: "Description",
    type: "text"
  }
], DH = (e) => {
  const { enqueueSnackbar: t } = bi(), n = Ce(() => F0, [F0]), [r, i] = Te(!1), { onChange: a, createMethod: o } = e, s = ot(
    async (c) => {
      const { expression: l, name: u, ...d } = c;
      let f;
      i(!0);
      try {
        const h = JSON.parse(l);
        f = {
          name: u || "Imported Cohort",
          expression: h,
          ...d
        };
      } catch {
        t({
          message: "Cohort Definition is not valid!",
          variant: "error"
        }), i(!1);
        return;
      }
      try {
        const h = await o(f);
        a == null || a(h);
      } catch (h) {
        console.error(h), i(!1), t({
          message: "Failed to import Cohort!",
          variant: "error"
        });
      }
    },
    []
  );
  return /* @__PURE__ */ p(
    bk,
    {
      onSubmit: s,
      codeKey: "expression",
      nameKey: "name",
      editorTitle: "Cohort Definition",
      fields: n,
      isLoading: r,
      fileExtension: tn.JSON
    }
  );
}, wk = (e) => {
  const { onEdit: t, iconSize: n = 18 } = e;
  return /* @__PURE__ */ p(
    Ue,
    {
      iconName: "edit",
      onClick: (r) => {
        r.stopPropagation(), t(r);
      },
      color: "default",
      noExpand: !0,
      size: "small"
    }
  );
}, nm = (e) => {
  const {
    onSubmit: t,
    onDecline: n,
    onClose: r,
    title: i,
    text: a,
    confirmButtonText: o,
    cancelButtonText: s,
    TextField: c,
    variant: l = "info"
  } = e, [u, d] = Te(""), f = c;
  return /* @__PURE__ */ F(kv, { open: e.open, children: [
    i && /* @__PURE__ */ p(Sv, { children: i }),
    /* @__PURE__ */ F(Cv, { children: [
      /* @__PURE__ */ p("div", { className: "alert-dialog-description", children: a || "Are you sure you want to delete this item?" }),
      f && /* @__PURE__ */ p(
        f,
        {
          sx: { width: "100%" },
          value: u,
          onChange: (h) => {
            var m;
            d((m = h == null ? void 0 : h.target) == null ? void 0 : m.value);
          }
        }
      )
    ] }),
    /* @__PURE__ */ F(Ev, { children: [
      /* @__PURE__ */ p(
        Ee,
        {
          onClick: () => {
            n && n(), d(""), r && r();
          },
          variant: "outlined",
          name: "cancel",
          color: "darkGrey",
          children: s || "CANCEL"
        }
      ),
      /* @__PURE__ */ p(
        Ee,
        {
          onClick: () => {
            t && t({ dismissNote: u }), d(""), r && r();
          },
          variant: "contained",
          name: "confirm",
          color: l,
          children: o || "CONFIRM"
        }
      )
    ] })
  ] });
}, PH = (e) => {
  const { onSubmit: t, onDecline: n, onClose: r, text: i } = e, [a, o] = Te(!1);
  return /* @__PURE__ */ F(kv, { open: e.open, children: [
    /* @__PURE__ */ p(Sv, { children: "Consent Form" }),
    /* @__PURE__ */ p(Cv, { children: /* @__PURE__ */ p(O, { container: !0, children: /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      hC,
      {
        id: "consent",
        name: "consent",
        value: i,
        onChange: () => {
        },
        maxRows: 20,
        minRows: 5,
        readOnly: !0,
        placeholder: "Enter consent form",
        disableHorizontalResize: !0
      },
      ""
    ) }) }) }),
    /* @__PURE__ */ p(Ev, { children: /* @__PURE__ */ F(O, { container: !0, px: 2, mt: -2, children: [
      /* @__PURE__ */ p(O, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ F("label", { children: [
        /* @__PURE__ */ p(
          Tv,
          {
            name: "createNew",
            onChange: () => {
              o(!a);
            },
            checked: a
          }
        ),
        /* @__PURE__ */ p(le, { sx: { ml: 1 }, variant: "caption", children: "I confirm that I have read, understood, and will follow the agreement outlined in the consent form." })
      ] }) }),
      /* @__PURE__ */ F(O, { item: !0, xs: 12, display: "flex", justifyContent: "flex-end", children: [
        /* @__PURE__ */ p(
          Ee,
          {
            onClick: () => {
              t && t(), r && r();
            },
            variant: "contained",
            name: "confirm",
            disabled: !a,
            color: "success",
            startIcon: /* @__PURE__ */ p(he, { iconName: "submit" }),
            children: "Accept"
          }
        ),
        /* @__PURE__ */ p(
          Ee,
          {
            onClick: () => {
              n && n(), r && r();
            },
            variant: "outlined",
            startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
            name: "cancel",
            sx: { ml: 1 },
            children: "Reject"
          }
        )
      ] })
    ] }) })
  ] });
}, _k = (e) => {
  const {
    onRemove: t,
    withConfirmation: n = !1,
    confirmationMessage: r = "Are you sure you want to delete this item?",
    iconSize: i = 18
  } = e, a = qe.useContext(Xp), o = (c) => {
    c == null || c.stopPropagation(), t(c);
  };
  return /* @__PURE__ */ p(
    Ue,
    {
      size: "small",
      iconName: "delete",
      onClick: (c) => {
        c.stopPropagation(), n && a ? a.showDialog(nm, {
          onSubmit: () => o(c),
          onClose: a == null ? void 0 : a.hideDialog,
          text: r,
          confirmButtonText: "DELETE",
          variant: "error"
        }) : o(c);
      },
      color: "error",
      noExpand: !0
    }
  );
}, Sk = ae.div`
  max-height: calc(100vh - 116px);
  overflow-y: scroll;
  padding: 16px;
`;
var dx = { exports: {} };
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ba, function n() {
    var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i = !r.document && !!r.postMessage, a = r.IS_PAPA_WORKER || !1, o = {}, s = 0, c = { parse: function(x, _) {
      var R = (_ = _ || {}).dynamicTyping || !1;
      if (b(R) && (_.dynamicTypingFunction = R, R = {}), _.dynamicTyping = R, _.transform = !!b(_.transform) && _.transform, _.worker && c.WORKERS_SUPPORTED) {
        var P = function() {
          if (!c.WORKERS_SUPPORTED) return !1;
          var C = (D = r.URL || r.webkitURL || null, z = n.toString(), c.BLOB_URL || (c.BLOB_URL = D.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", z, ")();"], { type: "text/javascript" })))), T = new r.Worker(C), D, z;
          return T.onmessage = I, T.id = s++, o[T.id] = T;
        }();
        return P.userStep = _.step, P.userChunk = _.chunk, P.userComplete = _.complete, P.userError = _.error, _.step = b(_.step), _.chunk = b(_.chunk), _.complete = b(_.complete), _.error = b(_.error), delete _.worker, void P.postMessage({ input: x, config: _, workerId: P.id });
      }
      var E = null;
      return c.NODE_STREAM_INPUT, typeof x == "string" ? (x = function(C) {
        return C.charCodeAt(0) === 65279 ? C.slice(1) : C;
      }(x), E = _.download ? new d(_) : new h(_)) : x.readable === !0 && b(x.read) && b(x.on) ? E = new m(_) : (r.File && x instanceof File || x instanceof Object) && (E = new f(_)), E.stream(x);
    }, unparse: function(x, _) {
      var R = !1, P = !0, E = ",", C = `\r
`, T = '"', D = T + T, z = !1, B = null, W = !1;
      (function() {
        if (typeof _ == "object") {
          if (typeof _.delimiter != "string" || c.BAD_DELIMITERS.filter(function(j) {
            return _.delimiter.indexOf(j) !== -1;
          }).length || (E = _.delimiter), (typeof _.quotes == "boolean" || typeof _.quotes == "function" || Array.isArray(_.quotes)) && (R = _.quotes), typeof _.skipEmptyLines != "boolean" && typeof _.skipEmptyLines != "string" || (z = _.skipEmptyLines), typeof _.newline == "string" && (C = _.newline), typeof _.quoteChar == "string" && (T = _.quoteChar), typeof _.header == "boolean" && (P = _.header), Array.isArray(_.columns)) {
            if (_.columns.length === 0) throw new Error("Option columns is empty");
            B = _.columns;
          }
          _.escapeChar !== void 0 && (D = _.escapeChar + T), (typeof _.escapeFormulae == "boolean" || _.escapeFormulae instanceof RegExp) && (W = _.escapeFormulae instanceof RegExp ? _.escapeFormulae : /^[=+\-@\t\r].*$/);
        }
      })();
      var L = new RegExp(v(T), "g");
      if (typeof x == "string" && (x = JSON.parse(x)), Array.isArray(x)) {
        if (!x.length || Array.isArray(x[0])) return S(null, x, z);
        if (typeof x[0] == "object") return S(B || Object.keys(x[0]), x, z);
      } else if (typeof x == "object") return typeof x.data == "string" && (x.data = JSON.parse(x.data)), Array.isArray(x.data) && (x.fields || (x.fields = x.meta && x.meta.fields || B), x.fields || (x.fields = Array.isArray(x.data[0]) ? x.fields : typeof x.data[0] == "object" ? Object.keys(x.data[0]) : []), Array.isArray(x.data[0]) || typeof x.data[0] == "object" || (x.data = [x.data])), S(x.fields || [], x.data || [], z);
      throw new Error("Unable to serialize unrecognized input");
      function S(j, N, q) {
        var G = "";
        typeof j == "string" && (j = JSON.parse(j)), typeof N == "string" && (N = JSON.parse(N));
        var X = Array.isArray(j) && 0 < j.length, Y = !Array.isArray(N[0]);
        if (X && P) {
          for (var Q = 0; Q < j.length; Q++) 0 < Q && (G += E), G += $(j[Q], Q);
          0 < N.length && (G += C);
        }
        for (var V = 0; V < N.length; V++) {
          var U = X ? j.length : N[V].length, Z = !1, H = X ? Object.keys(N[V]).length === 0 : N[V].length === 0;
          if (q && !X && (Z = q === "greedy" ? N[V].join("").trim() === "" : N[V].length === 1 && N[V][0].length === 0), q === "greedy" && X) {
            for (var ee = [], ie = 0; ie < U; ie++) {
              var re = Y ? j[ie] : ie;
              ee.push(N[V][re]);
            }
            Z = ee.join("").trim() === "";
          }
          if (!Z) {
            for (var K = 0; K < U; K++) {
              0 < K && !H && (G += E);
              var se = X && Y ? j[K] : K;
              G += $(N[V][se], K);
            }
            V < N.length - 1 && (!q || 0 < U && !H) && (G += C);
          }
        }
        return G;
      }
      function $(j, N) {
        if (j == null) return "";
        if (j.constructor === Date) return JSON.stringify(j).slice(1, 25);
        var q = !1;
        W && typeof j == "string" && W.test(j) && (j = "'" + j, q = !0);
        var G = j.toString().replace(L, D);
        return (q = q || R === !0 || typeof R == "function" && R(j, N) || Array.isArray(R) && R[N] || function(X, Y) {
          for (var Q = 0; Q < Y.length; Q++) if (-1 < X.indexOf(Y[Q])) return !0;
          return !1;
        }(G, c.BAD_DELIMITERS) || -1 < G.indexOf(E) || G.charAt(0) === " " || G.charAt(G.length - 1) === " ") ? T + G + T : G;
      }
    } };
    if (c.RECORD_SEP = "", c.UNIT_SEP = "", c.BYTE_ORDER_MARK = "\uFEFF", c.BAD_DELIMITERS = ["\r", `
`, '"', c.BYTE_ORDER_MARK], c.WORKERS_SUPPORTED = !i && !!r.Worker, c.NODE_STREAM_INPUT = 1, c.LocalChunkSize = 10485760, c.RemoteChunkSize = 5242880, c.DefaultDelimiter = ",", c.Parser = w, c.ParserHandle = y, c.NetworkStreamer = d, c.FileStreamer = f, c.StringStreamer = h, c.ReadableStreamStreamer = m, r.jQuery) {
      var l = r.jQuery;
      l.fn.parse = function(x) {
        var _ = x.config || {}, R = [];
        return this.each(function(C) {
          if (!(l(this).prop("tagName").toUpperCase() === "INPUT" && l(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var T = 0; T < this.files.length; T++) R.push({ file: this.files[T], inputElem: this, instanceConfig: l.extend({}, _) });
        }), P(), this;
        function P() {
          if (R.length !== 0) {
            var C, T, D, z, B = R[0];
            if (b(x.before)) {
              var W = x.before(B.file, B.inputElem);
              if (typeof W == "object") {
                if (W.action === "abort") return C = "AbortError", T = B.file, D = B.inputElem, z = W.reason, void (b(x.error) && x.error({ name: C }, T, D, z));
                if (W.action === "skip") return void E();
                typeof W.config == "object" && (B.instanceConfig = l.extend(B.instanceConfig, W.config));
              } else if (W === "skip") return void E();
            }
            var L = B.instanceConfig.complete;
            B.instanceConfig.complete = function(S) {
              b(L) && L(S, B.file, B.inputElem), E();
            }, c.parse(B.file, B.instanceConfig);
          } else b(x.complete) && x.complete();
        }
        function E() {
          R.splice(0, 1), P();
        }
      };
    }
    function u(x) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(_) {
        var R = g(_);
        R.chunkSize = parseInt(R.chunkSize), _.step || _.chunk || (R.chunkSize = null), this._handle = new y(R), (this._handle.streamer = this)._config = R;
      }).call(this, x), this.parseChunk = function(_, R) {
        if (this.isFirstChunk && b(this._config.beforeFirstChunk)) {
          var P = this._config.beforeFirstChunk(_);
          P !== void 0 && (_ = P);
        }
        this.isFirstChunk = !1, this._halted = !1;
        var E = this._partialLine + _;
        this._partialLine = "";
        var C = this._handle.parse(E, this._baseIndex, !this._finished);
        if (!this._handle.paused() && !this._handle.aborted()) {
          var T = C.meta.cursor;
          this._finished || (this._partialLine = E.substring(T - this._baseIndex), this._baseIndex = T), C && C.data && (this._rowCount += C.data.length);
          var D = this._finished || this._config.preview && this._rowCount >= this._config.preview;
          if (a) r.postMessage({ results: C, workerId: c.WORKER_ID, finished: D });
          else if (b(this._config.chunk) && !R) {
            if (this._config.chunk(C, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            C = void 0, this._completeResults = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(C.data), this._completeResults.errors = this._completeResults.errors.concat(C.errors), this._completeResults.meta = C.meta), this._completed || !D || !b(this._config.complete) || C && C.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), D || C && C.meta.paused || this._nextChunk(), C;
        }
        this._halted = !0;
      }, this._sendError = function(_) {
        b(this._config.error) ? this._config.error(_) : a && this._config.error && r.postMessage({ workerId: c.WORKER_ID, error: _, finished: !1 });
      };
    }
    function d(x) {
      var _;
      (x = x || {}).chunkSize || (x.chunkSize = c.RemoteChunkSize), u.call(this, x), this._nextChunk = i ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(R) {
        this._input = R, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished) this._chunkLoaded();
        else {
          if (_ = new XMLHttpRequest(), this._config.withCredentials && (_.withCredentials = this._config.withCredentials), i || (_.onload = A(this._chunkLoaded, this), _.onerror = A(this._chunkError, this)), _.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !i), this._config.downloadRequestHeaders) {
            var R = this._config.downloadRequestHeaders;
            for (var P in R) _.setRequestHeader(P, R[P]);
          }
          if (this._config.chunkSize) {
            var E = this._start + this._config.chunkSize - 1;
            _.setRequestHeader("Range", "bytes=" + this._start + "-" + E);
          }
          try {
            _.send(this._config.downloadRequestBody);
          } catch (C) {
            this._chunkError(C.message);
          }
          i && _.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        _.readyState === 4 && (_.status < 200 || 400 <= _.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : _.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(R) {
          var P = R.getResponseHeader("Content-Range");
          return P === null ? -1 : parseInt(P.substring(P.lastIndexOf("/") + 1));
        }(_), this.parseChunk(_.responseText)));
      }, this._chunkError = function(R) {
        var P = _.statusText || R;
        this._sendError(new Error(P));
      };
    }
    function f(x) {
      var _, R;
      (x = x || {}).chunkSize || (x.chunkSize = c.LocalChunkSize), u.call(this, x);
      var P = typeof FileReader < "u";
      this.stream = function(E) {
        this._input = E, R = E.slice || E.webkitSlice || E.mozSlice, P ? ((_ = new FileReader()).onload = A(this._chunkLoaded, this), _.onerror = A(this._chunkError, this)) : _ = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var E = this._input;
        if (this._config.chunkSize) {
          var C = Math.min(this._start + this._config.chunkSize, this._input.size);
          E = R.call(E, this._start, C);
        }
        var T = _.readAsText(E, this._config.encoding);
        P || this._chunkLoaded({ target: { result: T } });
      }, this._chunkLoaded = function(E) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(E.target.result);
      }, this._chunkError = function() {
        this._sendError(_.error);
      };
    }
    function h(x) {
      var _;
      u.call(this, x = x || {}), this.stream = function(R) {
        return _ = R, this._nextChunk();
      }, this._nextChunk = function() {
        if (!this._finished) {
          var R, P = this._config.chunkSize;
          return P ? (R = _.substring(0, P), _ = _.substring(P)) : (R = _, _ = ""), this._finished = !_, this.parseChunk(R);
        }
      };
    }
    function m(x) {
      u.call(this, x = x || {});
      var _ = [], R = !0, P = !1;
      this.pause = function() {
        u.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        u.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(E) {
        this._input = E, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        P && _.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), _.length ? this.parseChunk(_.shift()) : R = !0;
      }, this._streamData = A(function(E) {
        try {
          _.push(typeof E == "string" ? E : E.toString(this._config.encoding)), R && (R = !1, this._checkIsFinished(), this.parseChunk(_.shift()));
        } catch (C) {
          this._streamError(C);
        }
      }, this), this._streamError = A(function(E) {
        this._streamCleanUp(), this._sendError(E);
      }, this), this._streamEnd = A(function() {
        this._streamCleanUp(), P = !0, this._streamData("");
      }, this), this._streamCleanUp = A(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function y(x) {
      var _, R, P, E = Math.pow(2, 53), C = -E, T = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, D = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, z = this, B = 0, W = 0, L = !1, S = !1, $ = [], j = { data: [], errors: [], meta: {} };
      if (b(x.step)) {
        var N = x.step;
        x.step = function(V) {
          if (j = V, X()) G();
          else {
            if (G(), j.data.length === 0) return;
            B += V.data.length, x.preview && B > x.preview ? R.abort() : (j.data = j.data[0], N(j, z));
          }
        };
      }
      function q(V) {
        return x.skipEmptyLines === "greedy" ? V.join("").trim() === "" : V.length === 1 && V[0].length === 0;
      }
      function G() {
        return j && P && (Q("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + c.DefaultDelimiter + "'"), P = !1), x.skipEmptyLines && (j.data = j.data.filter(function(V) {
          return !q(V);
        })), X() && function() {
          if (!j) return;
          function V(Z, H) {
            b(x.transformHeader) && (Z = x.transformHeader(Z, H)), $.push(Z);
          }
          if (Array.isArray(j.data[0])) {
            for (var U = 0; X() && U < j.data.length; U++) j.data[U].forEach(V);
            j.data.splice(0, 1);
          } else j.data.forEach(V);
        }(), function() {
          if (!j || !x.header && !x.dynamicTyping && !x.transform) return j;
          function V(Z, H) {
            var ee, ie = x.header ? {} : [];
            for (ee = 0; ee < Z.length; ee++) {
              var re = ee, K = Z[ee];
              x.header && (re = ee >= $.length ? "__parsed_extra" : $[ee]), x.transform && (K = x.transform(K, re)), K = Y(re, K), re === "__parsed_extra" ? (ie[re] = ie[re] || [], ie[re].push(K)) : ie[re] = K;
            }
            return x.header && (ee > $.length ? Q("FieldMismatch", "TooManyFields", "Too many fields: expected " + $.length + " fields but parsed " + ee, W + H) : ee < $.length && Q("FieldMismatch", "TooFewFields", "Too few fields: expected " + $.length + " fields but parsed " + ee, W + H)), ie;
          }
          var U = 1;
          return !j.data.length || Array.isArray(j.data[0]) ? (j.data = j.data.map(V), U = j.data.length) : j.data = V(j.data, 0), x.header && j.meta && (j.meta.fields = $), W += U, j;
        }();
      }
      function X() {
        return x.header && $.length === 0;
      }
      function Y(V, U) {
        return Z = V, x.dynamicTypingFunction && x.dynamicTyping[Z] === void 0 && (x.dynamicTyping[Z] = x.dynamicTypingFunction(Z)), (x.dynamicTyping[Z] || x.dynamicTyping) === !0 ? U === "true" || U === "TRUE" || U !== "false" && U !== "FALSE" && (function(H) {
          if (T.test(H)) {
            var ee = parseFloat(H);
            if (C < ee && ee < E) return !0;
          }
          return !1;
        }(U) ? parseFloat(U) : D.test(U) ? new Date(U) : U === "" ? null : U) : U;
        var Z;
      }
      function Q(V, U, Z, H) {
        var ee = { type: V, code: U, message: Z };
        H !== void 0 && (ee.row = H), j.errors.push(ee);
      }
      this.parse = function(V, U, Z) {
        var H = x.quoteChar || '"';
        if (x.newline || (x.newline = function(re, K) {
          re = re.substring(0, 1048576);
          var se = new RegExp(v(K) + "([^]*?)" + v(K), "gm"), xe = (re = re.replace(se, "")).split("\r"), ke = re.split(`
`), ue = 1 < ke.length && ke[0].length < xe[0].length;
          if (xe.length === 1 || ue) return `
`;
          for (var fe = 0, de = 0; de < xe.length; de++) xe[de][0] === `
` && fe++;
          return fe >= xe.length / 2 ? `\r
` : "\r";
        }(V, H)), P = !1, x.delimiter) b(x.delimiter) && (x.delimiter = x.delimiter(V), j.meta.delimiter = x.delimiter);
        else {
          var ee = function(re, K, se, xe, ke) {
            var ue, fe, de, ce;
            ke = ke || [",", "	", "|", ";", c.RECORD_SEP, c.UNIT_SEP];
            for (var te = 0; te < ke.length; te++) {
              var oe = ke[te], J = 0, ne = 0, ye = 0;
              de = void 0;
              for (var Ae = new w({ comments: xe, delimiter: oe, newline: K, preview: 10 }).parse(re), be = 0; be < Ae.data.length; be++) if (se && q(Ae.data[be])) ye++;
              else {
                var je = Ae.data[be].length;
                ne += je, de !== void 0 ? 0 < je && (J += Math.abs(je - de), de = je) : de = je;
              }
              0 < Ae.data.length && (ne /= Ae.data.length - ye), (fe === void 0 || J <= fe) && (ce === void 0 || ce < ne) && 1.99 < ne && (fe = J, ue = oe, ce = ne);
            }
            return { successful: !!(x.delimiter = ue), bestDelimiter: ue };
          }(V, x.newline, x.skipEmptyLines, x.comments, x.delimitersToGuess);
          ee.successful ? x.delimiter = ee.bestDelimiter : (P = !0, x.delimiter = c.DefaultDelimiter), j.meta.delimiter = x.delimiter;
        }
        var ie = g(x);
        return x.preview && x.header && ie.preview++, _ = V, R = new w(ie), j = R.parse(_, U, Z), G(), L ? { meta: { paused: !0 } } : j || { meta: { paused: !1 } };
      }, this.paused = function() {
        return L;
      }, this.pause = function() {
        L = !0, R.abort(), _ = b(x.chunk) ? "" : _.substring(R.getCharIndex());
      }, this.resume = function() {
        z.streamer._halted ? (L = !1, z.streamer.parseChunk(_, !0)) : setTimeout(z.resume, 3);
      }, this.aborted = function() {
        return S;
      }, this.abort = function() {
        S = !0, R.abort(), j.meta.aborted = !0, b(x.complete) && x.complete(j), _ = "";
      };
    }
    function v(x) {
      return x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function w(x) {
      var _, R = (x = x || {}).delimiter, P = x.newline, E = x.comments, C = x.step, T = x.preview, D = x.fastMode, z = _ = x.quoteChar === void 0 || x.quoteChar === null ? '"' : x.quoteChar;
      if (x.escapeChar !== void 0 && (z = x.escapeChar), (typeof R != "string" || -1 < c.BAD_DELIMITERS.indexOf(R)) && (R = ","), E === R) throw new Error("Comment character same as delimiter");
      E === !0 ? E = "#" : (typeof E != "string" || -1 < c.BAD_DELIMITERS.indexOf(E)) && (E = !1), P !== `
` && P !== "\r" && P !== `\r
` && (P = `
`);
      var B = 0, W = !1;
      this.parse = function(L, S, $) {
        if (typeof L != "string") throw new Error("Input must be a string");
        var j = L.length, N = R.length, q = P.length, G = E.length, X = b(C), Y = [], Q = [], V = [], U = B = 0;
        if (!L) return Oe();
        if (x.header && !S) {
          var Z = L.split(P)[0].split(R), H = [], ee = {}, ie = !1;
          for (var re in Z) {
            var K = Z[re];
            b(x.transformHeader) && (K = x.transformHeader(K, re));
            var se = K, xe = ee[K] || 0;
            for (0 < xe && (ie = !0, se = K + "_" + xe), ee[K] = xe + 1; H.includes(se); ) se = se + "_" + xe;
            H.push(se);
          }
          if (ie) {
            var ke = L.split(P);
            ke[0] = H.join(R), L = ke.join(P);
          }
        }
        if (D || D !== !1 && L.indexOf(_) === -1) {
          for (var ue = L.split(P), fe = 0; fe < ue.length; fe++) {
            if (V = ue[fe], B += V.length, fe !== ue.length - 1) B += P.length;
            else if ($) return Oe();
            if (!E || V.substring(0, G) !== E) {
              if (X) {
                if (Y = [], ye(V.split(R)), Ve(), W) return Oe();
              } else ye(V.split(R));
              if (T && T <= fe) return Y = Y.slice(0, T), Oe(!0);
            }
          }
          return Oe();
        }
        for (var de = L.indexOf(R, B), ce = L.indexOf(P, B), te = new RegExp(v(z) + v(_), "g"), oe = L.indexOf(_, B); ; ) if (L[B] !== _) if (E && V.length === 0 && L.substring(B, B + G) === E) {
          if (ce === -1) return Oe();
          B = ce + q, ce = L.indexOf(P, B), de = L.indexOf(R, B);
        } else if (de !== -1 && (de < ce || ce === -1)) V.push(L.substring(B, de)), B = de + N, de = L.indexOf(R, B);
        else {
          if (ce === -1) break;
          if (V.push(L.substring(B, ce)), je(ce + q), X && (Ve(), W)) return Oe();
          if (T && Y.length >= T) return Oe(!0);
        }
        else for (oe = B, B++; ; ) {
          if ((oe = L.indexOf(_, oe + 1)) === -1) return $ || Q.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: Y.length, index: B }), be();
          if (oe === j - 1) return be(L.substring(B, oe).replace(te, _));
          if (_ !== z || L[oe + 1] !== z) {
            if (_ === z || oe === 0 || L[oe - 1] !== z) {
              de !== -1 && de < oe + 1 && (de = L.indexOf(R, oe + 1)), ce !== -1 && ce < oe + 1 && (ce = L.indexOf(P, oe + 1));
              var J = Ae(ce === -1 ? de : Math.min(de, ce));
              if (L.substr(oe + 1 + J, N) === R) {
                V.push(L.substring(B, oe).replace(te, _)), L[B = oe + 1 + J + N] !== _ && (oe = L.indexOf(_, B)), de = L.indexOf(R, B), ce = L.indexOf(P, B);
                break;
              }
              var ne = Ae(ce);
              if (L.substring(oe + 1 + ne, oe + 1 + ne + q) === P) {
                if (V.push(L.substring(B, oe).replace(te, _)), je(oe + 1 + ne + q), de = L.indexOf(R, B), oe = L.indexOf(_, B), X && (Ve(), W)) return Oe();
                if (T && Y.length >= T) return Oe(!0);
                break;
              }
              Q.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: Y.length, index: B }), oe++;
            }
          } else oe++;
        }
        return be();
        function ye(_e) {
          Y.push(_e), U = B;
        }
        function Ae(_e) {
          var Re = 0;
          if (_e !== -1) {
            var Le = L.substring(oe + 1, _e);
            Le && Le.trim() === "" && (Re = Le.length);
          }
          return Re;
        }
        function be(_e) {
          return $ || (_e === void 0 && (_e = L.substring(B)), V.push(_e), B = j, ye(V), X && Ve()), Oe();
        }
        function je(_e) {
          B = _e, ye(V), V = [], ce = L.indexOf(P, B);
        }
        function Oe(_e) {
          return { data: Y, errors: Q, meta: { delimiter: R, linebreak: P, aborted: W, truncated: !!_e, cursor: U + (S || 0) } };
        }
        function Ve() {
          C(Oe()), Y = [], Q = [];
        }
      }, this.abort = function() {
        W = !0;
      }, this.getCharIndex = function() {
        return B;
      };
    }
    function I(x) {
      var _ = x.data, R = o[_.workerId], P = !1;
      if (_.error) R.userError(_.error, _.file);
      else if (_.results && _.results.data) {
        var E = { abort: function() {
          P = !0, M(_.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: k, resume: k };
        if (b(R.userStep)) {
          for (var C = 0; C < _.results.data.length && (R.userStep({ data: _.results.data[C], errors: _.results.errors, meta: _.results.meta }, E), !P); C++) ;
          delete _.results;
        } else b(R.userChunk) && (R.userChunk(_.results, E, _.file), delete _.results);
      }
      _.finished && !P && M(_.workerId, _.results);
    }
    function M(x, _) {
      var R = o[x];
      b(R.userComplete) && R.userComplete(_), R.terminate(), delete o[x];
    }
    function k() {
      throw new Error("Not implemented.");
    }
    function g(x) {
      if (typeof x != "object" || x === null) return x;
      var _ = Array.isArray(x) ? [] : {};
      for (var R in x) _[R] = g(x[R]);
      return _;
    }
    function A(x, _) {
      return function() {
        x.apply(_, arguments);
      };
    }
    function b(x) {
      return typeof x == "function";
    }
    return a && (r.onmessage = function(x) {
      var _ = x.data;
      if (c.WORKER_ID === void 0 && _ && (c.WORKER_ID = _.workerId), typeof _.input == "string") r.postMessage({ workerId: c.WORKER_ID, results: c.parse(_.input, _.config), finished: !0 });
      else if (r.File && _.input instanceof File || _.input instanceof Object) {
        var R = c.parse(_.input, _.config);
        R && r.postMessage({ workerId: c.WORKER_ID, results: R, finished: !0 });
      }
    }), (d.prototype = Object.create(u.prototype)).constructor = d, (f.prototype = Object.create(u.prototype)).constructor = f, (h.prototype = Object.create(h.prototype)).constructor = h, (m.prototype = Object.create(u.prototype)).constructor = m, c;
  });
})(dx);
var Ck = dx.exports;
const Ek = ae.div`
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
function kk(e, t) {
  return (e || []).map((n) => ({
    Header: t.includes(n) ? "" : eC(n).toUpperCase(),
    accessor: n,
    Cell: ({ value: i }) => /* @__PURE__ */ p(Ek, { title: i, children: i })
  }));
}
function Tk(e) {
  const t = [], n = Ck.parse(e, {
    header: !0,
    skipEmptyLines: "greedy",
    transformHeader(o) {
      let s = o;
      if (!o) {
        const c = xv();
        s = c, t.push(c);
      }
      return s;
    }
  }), { data: r = [], meta: i = {} } = n, a = (i == null ? void 0 : i.fields) || [];
  return {
    columns: kk(a, t),
    rows: r
  };
}
const hx = Kt((e) => {
  const { data: t, height: n = 500, downloadMethod: r } = e, [i, a] = Te("");
  tt(() => {
    async function c() {
      const l = r ? await r(t.id) : t.content || t;
      a(l);
    }
    return c(), () => {
      a("");
    };
  }, [t]);
  const { columns: o, rows: s } = Ce(() => Tk(i), [i]);
  return /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ p(Sk, { children: /* @__PURE__ */ p(
    xl,
    {
      columns: o,
      data: s,
      isLoading: !i,
      enableSorting: !0,
      enablePagination: !0,
      totalElements: s == null ? void 0 : s.length
    }
  ) }) });
});
var px = { exports: {} }, Xl = { exports: {} }, cn = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y0;
function Mk() {
  if (Y0) return cn;
  Y0 = 1;
  var e = qe;
  function t(c) {
    var l = "https://react.dev/errors/" + c;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var u = 2; u < arguments.length; u++)
        l += "&args[]=" + encodeURIComponent(arguments[u]);
    }
    return "Minified React error #" + c + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function n() {
  }
  var r = {
    d: {
      f: n,
      r: function() {
        throw Error(t(522));
      },
      D: n,
      C: n,
      L: n,
      m: n,
      X: n,
      S: n,
      M: n
    },
    p: 0,
    findDOMNode: null
  }, i = Symbol.for("react.portal");
  function a(c, l, u) {
    var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: i,
      key: d == null ? null : "" + d,
      children: c,
      containerInfo: l,
      implementation: u
    };
  }
  var o = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function s(c, l) {
    if (c === "font") return "";
    if (typeof l == "string")
      return l === "use-credentials" ? l : "";
  }
  return cn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, cn.createPortal = function(c, l) {
    var u = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11)
      throw Error(t(299));
    return a(c, l, null, u);
  }, cn.flushSync = function(c) {
    var l = o.T, u = r.p;
    try {
      if (o.T = null, r.p = 2, c) return c();
    } finally {
      o.T = l, r.p = u, r.d.f();
    }
  }, cn.preconnect = function(c, l) {
    typeof c == "string" && (l ? (l = l.crossOrigin, l = typeof l == "string" ? l === "use-credentials" ? l : "" : void 0) : l = null, r.d.C(c, l));
  }, cn.prefetchDNS = function(c) {
    typeof c == "string" && r.d.D(c);
  }, cn.preinit = function(c, l) {
    if (typeof c == "string" && l && typeof l.as == "string") {
      var u = l.as, d = s(u, l.crossOrigin), f = typeof l.integrity == "string" ? l.integrity : void 0, h = typeof l.fetchPriority == "string" ? l.fetchPriority : void 0;
      u === "style" ? r.d.S(
        c,
        typeof l.precedence == "string" ? l.precedence : void 0,
        {
          crossOrigin: d,
          integrity: f,
          fetchPriority: h
        }
      ) : u === "script" && r.d.X(c, {
        crossOrigin: d,
        integrity: f,
        fetchPriority: h,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0
      });
    }
  }, cn.preinitModule = function(c, l) {
    if (typeof c == "string")
      if (typeof l == "object" && l !== null) {
        if (l.as == null || l.as === "script") {
          var u = s(
            l.as,
            l.crossOrigin
          );
          r.d.M(c, {
            crossOrigin: u,
            integrity: typeof l.integrity == "string" ? l.integrity : void 0,
            nonce: typeof l.nonce == "string" ? l.nonce : void 0
          });
        }
      } else l == null && r.d.M(c);
  }, cn.preload = function(c, l) {
    if (typeof c == "string" && typeof l == "object" && l !== null && typeof l.as == "string") {
      var u = l.as, d = s(u, l.crossOrigin);
      r.d.L(c, u, {
        crossOrigin: d,
        integrity: typeof l.integrity == "string" ? l.integrity : void 0,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0,
        type: typeof l.type == "string" ? l.type : void 0,
        fetchPriority: typeof l.fetchPriority == "string" ? l.fetchPriority : void 0,
        referrerPolicy: typeof l.referrerPolicy == "string" ? l.referrerPolicy : void 0,
        imageSrcSet: typeof l.imageSrcSet == "string" ? l.imageSrcSet : void 0,
        imageSizes: typeof l.imageSizes == "string" ? l.imageSizes : void 0,
        media: typeof l.media == "string" ? l.media : void 0
      });
    }
  }, cn.preloadModule = function(c, l) {
    if (typeof c == "string")
      if (l) {
        var u = s(l.as, l.crossOrigin);
        r.d.m(c, {
          as: typeof l.as == "string" && l.as !== "script" ? l.as : void 0,
          crossOrigin: u,
          integrity: typeof l.integrity == "string" ? l.integrity : void 0
        });
      } else r.d.m(c);
  }, cn.requestFormReset = function(c) {
    r.d.r(c);
  }, cn.unstable_batchedUpdates = function(c, l) {
    return c(l);
  }, cn.useFormState = function(c, l, u) {
    return o.H.useFormState(c, l, u);
  }, cn.useFormStatus = function() {
    return o.H.useHostTransitionStatus();
  }, cn.version = "19.1.1", cn;
}
var un = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j0;
function Ik() {
  return j0 || (j0 = 1, process.env.NODE_ENV !== "production" && function() {
    function e() {
    }
    function t(d) {
      return "" + d;
    }
    function n(d, f, h) {
      var m = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        t(m);
        var y = !1;
      } catch {
        y = !0;
      }
      return y && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && m[Symbol.toStringTag] || m.constructor.name || "Object"
      ), t(m)), {
        $$typeof: l,
        key: m == null ? null : "" + m,
        children: d,
        containerInfo: f,
        implementation: h
      };
    }
    function r(d, f) {
      if (d === "font") return "";
      if (typeof f == "string")
        return f === "use-credentials" ? f : "";
    }
    function i(d) {
      return d === null ? "`null`" : d === void 0 ? "`undefined`" : d === "" ? "an empty string" : 'something with type "' + typeof d + '"';
    }
    function a(d) {
      return d === null ? "`null`" : d === void 0 ? "`undefined`" : d === "" ? "an empty string" : typeof d == "string" ? JSON.stringify(d) : typeof d == "number" ? "`" + d + "`" : 'something with type "' + typeof d + '"';
    }
    function o() {
      var d = u.H;
      return d === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var s = qe, c = {
      d: {
        f: e,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: e,
        C: e,
        L: e,
        m: e,
        X: e,
        S: e,
        M: e
      },
      p: 0,
      findDOMNode: null
    }, l = Symbol.for("react.portal"), u = s.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), un.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = c, un.createPortal = function(d, f) {
      var h = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!f || f.nodeType !== 1 && f.nodeType !== 9 && f.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return n(d, f, null, h);
    }, un.flushSync = function(d) {
      var f = u.T, h = c.p;
      try {
        if (u.T = null, c.p = 2, d)
          return d();
      } finally {
        u.T = f, c.p = h, c.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, un.preconnect = function(d, f) {
      typeof d == "string" && d ? f != null && typeof f != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        a(f)
      ) : f != null && typeof f.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        i(f.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        i(d)
      ), typeof d == "string" && (f ? (f = f.crossOrigin, f = typeof f == "string" ? f === "use-credentials" ? f : "" : void 0) : f = null, c.d.C(d, f));
    }, un.prefetchDNS = function(d) {
      if (typeof d != "string" || !d)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          i(d)
        );
      else if (1 < arguments.length) {
        var f = arguments[1];
        typeof f == "object" && f.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(f)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(f)
        );
      }
      typeof d == "string" && c.d.D(d);
    }, un.preinit = function(d, f) {
      if (typeof d == "string" && d ? f == null || typeof f != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        a(f)
      ) : f.as !== "style" && f.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        a(f.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        i(d)
      ), typeof d == "string" && f && typeof f.as == "string") {
        var h = f.as, m = r(h, f.crossOrigin), y = typeof f.integrity == "string" ? f.integrity : void 0, v = typeof f.fetchPriority == "string" ? f.fetchPriority : void 0;
        h === "style" ? c.d.S(
          d,
          typeof f.precedence == "string" ? f.precedence : void 0,
          {
            crossOrigin: m,
            integrity: y,
            fetchPriority: v
          }
        ) : h === "script" && c.d.X(d, {
          crossOrigin: m,
          integrity: y,
          fetchPriority: v,
          nonce: typeof f.nonce == "string" ? f.nonce : void 0
        });
      }
    }, un.preinitModule = function(d, f) {
      var h = "";
      if (typeof d == "string" && d || (h += " The `href` argument encountered was " + i(d) + "."), f !== void 0 && typeof f != "object" ? h += " The `options` argument encountered was " + i(f) + "." : f && "as" in f && f.as !== "script" && (h += " The `as` option encountered was " + a(f.as) + "."), h)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          h
        );
      else
        switch (h = f && typeof f.as == "string" ? f.as : "script", h) {
          case "script":
            break;
          default:
            h = a(h), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              h,
              d
            );
        }
      typeof d == "string" && (typeof f == "object" && f !== null ? (f.as == null || f.as === "script") && (h = r(
        f.as,
        f.crossOrigin
      ), c.d.M(d, {
        crossOrigin: h,
        integrity: typeof f.integrity == "string" ? f.integrity : void 0,
        nonce: typeof f.nonce == "string" ? f.nonce : void 0
      })) : f == null && c.d.M(d));
    }, un.preload = function(d, f) {
      var h = "";
      if (typeof d == "string" && d || (h += " The `href` argument encountered was " + i(d) + "."), f == null || typeof f != "object" ? h += " The `options` argument encountered was " + i(f) + "." : typeof f.as == "string" && f.as || (h += " The `as` option encountered was " + i(f.as) + "."), h && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        h
      ), typeof d == "string" && typeof f == "object" && f !== null && typeof f.as == "string") {
        h = f.as;
        var m = r(
          h,
          f.crossOrigin
        );
        c.d.L(d, h, {
          crossOrigin: m,
          integrity: typeof f.integrity == "string" ? f.integrity : void 0,
          nonce: typeof f.nonce == "string" ? f.nonce : void 0,
          type: typeof f.type == "string" ? f.type : void 0,
          fetchPriority: typeof f.fetchPriority == "string" ? f.fetchPriority : void 0,
          referrerPolicy: typeof f.referrerPolicy == "string" ? f.referrerPolicy : void 0,
          imageSrcSet: typeof f.imageSrcSet == "string" ? f.imageSrcSet : void 0,
          imageSizes: typeof f.imageSizes == "string" ? f.imageSizes : void 0,
          media: typeof f.media == "string" ? f.media : void 0
        });
      }
    }, un.preloadModule = function(d, f) {
      var h = "";
      typeof d == "string" && d || (h += " The `href` argument encountered was " + i(d) + "."), f !== void 0 && typeof f != "object" ? h += " The `options` argument encountered was " + i(f) + "." : f && "as" in f && typeof f.as != "string" && (h += " The `as` option encountered was " + i(f.as) + "."), h && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        h
      ), typeof d == "string" && (f ? (h = r(
        f.as,
        f.crossOrigin
      ), c.d.m(d, {
        as: typeof f.as == "string" && f.as !== "script" ? f.as : void 0,
        crossOrigin: h,
        integrity: typeof f.integrity == "string" ? f.integrity : void 0
      })) : c.d.m(d));
    }, un.requestFormReset = function(d) {
      c.d.r(d);
    }, un.unstable_batchedUpdates = function(d, f) {
      return d(f);
    }, un.useFormState = function(d, f, h) {
      return o().useFormState(d, f, h);
    }, un.useFormStatus = function() {
      return o().useHostTransitionStatus();
    }, un.version = "19.1.1", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), un;
}
var $0;
function Nk() {
  if ($0) return Xl.exports;
  $0 = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (t) {
        console.error(t);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (e(), Xl.exports = Mk()) : Xl.exports = Ik(), Xl.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(qe, Nk());
  })(ba, function(n, r) {
    return function(i) {
      var a = {};
      function o(s) {
        if (a[s]) return a[s].exports;
        var c = a[s] = { i: s, l: !1, exports: {} };
        return i[s].call(c.exports, c, c.exports, o), c.l = !0, c.exports;
      }
      return o.m = i, o.c = a, o.d = function(s, c, l) {
        o.o(s, c) || Object.defineProperty(s, c, { enumerable: !0, get: l });
      }, o.r = function(s) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
      }, o.t = function(s, c) {
        if (1 & c && (s = o(s)), 8 & c || 4 & c && typeof s == "object" && s && s.__esModule) return s;
        var l = /* @__PURE__ */ Object.create(null);
        if (o.r(l), Object.defineProperty(l, "default", { enumerable: !0, value: s }), 2 & c && typeof s != "string") for (var u in s) o.d(l, u, (function(d) {
          return s[d];
        }).bind(null, u));
        return l;
      }, o.n = function(s) {
        var c = s && s.__esModule ? function() {
          return s.default;
        } : function() {
          return s;
        };
        return o.d(c, "a", c), c;
      }, o.o = function(s, c) {
        return Object.prototype.hasOwnProperty.call(s, c);
      }, o.p = "", o(o.s = 4);
    }([function(i, a) {
      i.exports = n;
    }, function(i, a, o) {
      var s;
      /*!
        Copyright (c) 2017 Jed Watson.
        Licensed under the MIT License (MIT), see
        http://jedwatson.github.io/classnames
      */
      (function() {
        var c = {}.hasOwnProperty;
        function l() {
          for (var u = [], d = 0; d < arguments.length; d++) {
            var f = arguments[d];
            if (f) {
              var h = typeof f;
              if (h === "string" || h === "number") u.push(f);
              else if (Array.isArray(f) && f.length) {
                var m = l.apply(null, f);
                m && u.push(m);
              } else if (h === "object") for (var y in f) c.call(f, y) && f[y] && u.push(y);
            }
          }
          return u.join(" ");
        }
        i.exports ? (l.default = l, i.exports = l) : (s = (function() {
          return l;
        }).apply(a, [])) === void 0 || (i.exports = s);
      })();
    }, function(i, a) {
      i.exports = "data:application/vnd.ms-fontobject;base64,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";
    }, function(i, a) {
      i.exports = r;
    }, function(i, a, o) {
      i.exports = o(13);
    }, function(i, a, o) {
      var s = o(6);
      typeof s == "string" && (s = [[i.i, s, ""]]);
      var c = { insert: "head", singleton: !1 };
      o(12)(s, c), s.locals && (i.exports = s.locals);
    }, function(i, a, o) {
      a = i.exports = o(7)(!1);
      var s = o(8), c = s(o(2)), l = s(o(2) + "?#iefix"), u = s(o(9)), d = s(o(10)), f = s(o(11));
      a.push([i.i, `@font-face {
  font-family: 'icomoon';
  src: url(` + c + `);
  src: url(` + l + ") format('embedded-opentype'), url(" + u + ") format('truetype'), url(" + d + ") format('woff'), url(" + f + `) format('svg');
  font-weight: normal;
  font-style: normal;
}
.react-viewer {
  opacity: 0;
}
.react-viewer-inline {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
}
.react-viewer ul {
  margin: 0;
  padding: 0;
}
.react-viewer li {
  list-style: none;
}
.react-viewer-mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: #373737;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  filter: alpha(opacity=50);
  z-index: 1000;
}
.react-viewer-btn {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
}
.react-viewer-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.react-viewer-close {
  position: fixed;
  top: 0px;
  right: 0px;
  overflow: hidden;
  width: 40px;
  height: 40px;
  border-radius: 0 0 0 40px;
  cursor: pointer;
  z-index: 1010;
}
.react-viewer-close > i {
  position: relative;
  top: 4px;
  left: 18px;
}
.react-viewer-canvas {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1005;
}
.react-viewer-canvas > img {
  display: block;
  width: auto;
  height: auto;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
.react-viewer-canvas > img.drag {
  cursor: move;
}
.react-viewer-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  text-align: center;
  z-index: 1005;
}
.react-viewer-inline > .react-viewer-mask,
.react-viewer-inline > .react-viewer-close,
.react-viewer-inline > .react-viewer-canvas,
.react-viewer-inline > .react-viewer-footer {
  position: absolute;
}
.react-viewer-attribute {
  margin: 0 20px;
  margin-bottom: 6px;
  opacity: 0.8;
  color: #ccc;
  font-size: 15px;
}
.react-viewer-showTotal {
  float: right;
}
.react-viewer-toolbar {
  overflow: hidden;
  height: 28px;
  margin-bottom: 6px !important;
}
.react-viewer-toolbar li {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 28px;
  margin-right: 3px;
  cursor: pointer;
  line-height: 28px;
}
.react-viewer-toolbar li:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.react-viewer li.empty {
  background-color: transparent;
  cursor: default;
}
.react-viewer-navbar {
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
}
.react-viewer-list {
  height: 50px;
  padding: 1px;
  text-align: left;
}
.react-viewer-list > li {
  display: inline-block;
  width: 30px;
  height: 50px;
  cursor: pointer;
  overflow: hidden;
  margin-right: 1px;
}
.react-viewer-list > li > img {
  width: 60px;
  height: 50px;
  margin-left: -15px;
  opacity: 0.5;
}
.react-viewer-list > li.active > img {
  opacity: 1;
}
.react-viewer-transition {
  -webkit-transition: opacity 0.3s ease-out;
  -o-transition: opacity 0.3s ease-out;
  transition: opacity 0.3s ease-out;
}
.react-viewer-image-transition {
  -webkit-transition-property: width, height, margin, -webkit-transform;
  transition-property: width, height, margin, -webkit-transform;
  -o-transition-property: width, height, margin, transform;
  transition-property: width, height, margin, transform;
  transition-property: width, height, margin, transform, -webkit-transform;
  -webkit-transition-duration: 0.3s;
       -o-transition-duration: 0.3s;
          transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
       -o-transition-timing-function: ease-out;
          transition-timing-function: ease-out;
}
.react-viewer-list-transition {
  -webkit-transition: margin 0.3s ease-out;
  -o-transition: margin 0.3s ease-out;
  transition: margin 0.3s ease-out;
}
.react-viewer-icon {
  font-family: 'icomoon' !important;
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  font-size: 13px;
}
.react-viewer-icon-zoomIn:before {
  content: '\\ea0a';
}
.react-viewer-icon-zoomOut:before {
  content: '\\ea0b';
}
.react-viewer-icon-prev:before {
  content: '\\ea38';
}
.react-viewer-icon-next:before {
  content: '\\ea34';
}
.react-viewer-icon-close:before {
  content: '\\ea0f';
}
.react-viewer-icon-rotateLeft:before {
  content: '\\e967';
}
.react-viewer-icon-rotateRight:before {
  content: '\\e968';
}
.react-viewer-icon-reset:before {
  content: '\\e984';
}
.react-viewer-icon-scaleX:before {
  content: '\\ea60';
}
.react-viewer-icon-scaleY:before {
  content: '\\ea5f';
}
.react-viewer-icon-download:before {
  content: '\\e9c7';
}
.circle-loading {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  border: 10px solid rgba(255, 255, 255, 0.2);
  border-top-color: #FFF;
  -webkit-animation: spin 1s infinite linear;
          animation: spin 1s infinite linear;
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
`, ""]);
    }, function(i, a, o) {
      i.exports = function(s) {
        var c = [];
        return c.toString = function() {
          return this.map(function(l) {
            var u = function(d, f) {
              var h = d[1] || "", m = d[3];
              if (!m) return h;
              if (f && typeof btoa == "function") {
                var y = (w = m, I = btoa(unescape(encodeURIComponent(JSON.stringify(w)))), M = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(I), "/*# ".concat(M, " */")), v = m.sources.map(function(k) {
                  return "/*# sourceURL=".concat(m.sourceRoot).concat(k, " */");
                });
                return [h].concat(v).concat([y]).join(`
`);
              }
              var w, I, M;
              return [h].join(`
`);
            }(l, s);
            return l[2] ? "@media ".concat(l[2], "{").concat(u, "}") : u;
          }).join("");
        }, c.i = function(l, u) {
          typeof l == "string" && (l = [[null, l, ""]]);
          for (var d = {}, f = 0; f < this.length; f++) {
            var h = this[f][0];
            h != null && (d[h] = !0);
          }
          for (var m = 0; m < l.length; m++) {
            var y = l[m];
            y[0] != null && d[y[0]] || (u && !y[2] ? y[2] = u : u && (y[2] = "(".concat(y[2], ") and (").concat(u, ")")), c.push(y));
          }
        }, c;
      };
    }, function(i, a, o) {
      i.exports = function(s, c) {
        return typeof (s = s.__esModule ? s.default : s) != "string" ? s : (/^['"].*['"]$/.test(s) && (s = s.slice(1, -1)), /["'() \t\n]/.test(s) || c ? '"'.concat(s.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : s);
      };
    }, function(i, a) {
      i.exports = "data:font/ttf;base64,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";
    }, function(i, a) {
      i.exports = "data:font/woff;base64,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";
    }, function(i, a) {
      i.exports = "data:image/svg+xml;base64,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";
    }, function(i, a, o) {
      var s, c = {}, l = function() {
        return s === void 0 && (s = !!(window && document && document.all && !window.atob)), s;
      }, u = /* @__PURE__ */ function() {
        var g = {};
        return function(A) {
          if (g[A] === void 0) {
            var b = document.querySelector(A);
            if (window.HTMLIFrameElement && b instanceof window.HTMLIFrameElement) try {
              b = b.contentDocument.head;
            } catch {
              b = null;
            }
            g[A] = b;
          }
          return g[A];
        };
      }();
      function d(g, A) {
        for (var b = [], x = {}, _ = 0; _ < g.length; _++) {
          var R = g[_], P = A.base ? R[0] + A.base : R[0], E = { css: R[1], media: R[2], sourceMap: R[3] };
          x[P] ? x[P].parts.push(E) : b.push(x[P] = { id: P, parts: [E] });
        }
        return b;
      }
      function f(g, A) {
        for (var b = 0; b < g.length; b++) {
          var x = g[b], _ = c[x.id], R = 0;
          if (_) {
            for (_.refs++; R < _.parts.length; R++) _.parts[R](x.parts[R]);
            for (; R < x.parts.length; R++) _.parts.push(k(x.parts[R], A));
          } else {
            for (var P = []; R < x.parts.length; R++) P.push(k(x.parts[R], A));
            c[x.id] = { id: x.id, refs: 1, parts: P };
          }
        }
      }
      function h(g) {
        var A = document.createElement("style");
        if (g.attributes.nonce === void 0) {
          var b = o.nc;
          b && (g.attributes.nonce = b);
        }
        if (Object.keys(g.attributes).forEach(function(_) {
          A.setAttribute(_, g.attributes[_]);
        }), typeof g.insert == "function") g.insert(A);
        else {
          var x = u(g.insert || "head");
          if (!x) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          x.appendChild(A);
        }
        return A;
      }
      var m, y = (m = [], function(g, A) {
        return m[g] = A, m.filter(Boolean).join(`
`);
      });
      function v(g, A, b, x) {
        var _ = b ? "" : x.css;
        if (g.styleSheet) g.styleSheet.cssText = y(A, _);
        else {
          var R = document.createTextNode(_), P = g.childNodes;
          P[A] && g.removeChild(P[A]), P.length ? g.insertBefore(R, P[A]) : g.appendChild(R);
        }
      }
      function w(g, A, b) {
        var x = b.css, _ = b.media, R = b.sourceMap;
        if (_ && g.setAttribute("media", _), R && btoa && (x += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(R)))), " */")), g.styleSheet) g.styleSheet.cssText = x;
        else {
          for (; g.firstChild; ) g.removeChild(g.firstChild);
          g.appendChild(document.createTextNode(x));
        }
      }
      var I = null, M = 0;
      function k(g, A) {
        var b, x, _;
        if (A.singleton) {
          var R = M++;
          b = I || (I = h(A)), x = v.bind(null, b, R, !1), _ = v.bind(null, b, R, !0);
        } else b = h(A), x = w.bind(null, b, A), _ = function() {
          (function(P) {
            if (P.parentNode === null) return !1;
            P.parentNode.removeChild(P);
          })(b);
        };
        return x(g), function(P) {
          if (P) {
            if (P.css === g.css && P.media === g.media && P.sourceMap === g.sourceMap) return;
            x(g = P);
          } else _();
        };
      }
      i.exports = function(g, A) {
        (A = A || {}).attributes = typeof A.attributes == "object" ? A.attributes : {}, A.singleton || typeof A.singleton == "boolean" || (A.singleton = l());
        var b = d(g, A);
        return f(b, A), function(x) {
          for (var _ = [], R = 0; R < b.length; R++) {
            var P = b[R], E = c[P.id];
            E && (E.refs--, _.push(E));
          }
          x && f(d(x, A), A);
          for (var C = 0; C < _.length; C++) {
            var T = _[C];
            if (T.refs === 0) {
              for (var D = 0; D < T.parts.length; D++) T.parts[D]();
              delete c[T.id];
            }
          }
        };
      };
    }, function(i, a, o) {
      o.r(a);
      var s = o(0), c = o(3);
      o(5);
      function l(E) {
        return s.createElement("div", { className: "loading-wrap", style: E.style }, s.createElement("div", { className: "circle-loading" }));
      }
      var u, d = o(1), f = o.n(d);
      function h(E, C) {
        return function(T) {
          if (Array.isArray(T)) return T;
        }(E) || function(T, D) {
          if (Symbol.iterator in Object(T) || Object.prototype.toString.call(T) === "[object Arguments]") {
            var z = [], B = !0, W = !1, L = void 0;
            try {
              for (var S, $ = T[Symbol.iterator](); !(B = (S = $.next()).done) && (z.push(S.value), !D || z.length !== D); B = !0) ;
            } catch (j) {
              W = !0, L = j;
            } finally {
              try {
                B || $.return == null || $.return();
              } finally {
                if (W) throw L;
              }
            }
            return z;
          }
        }(E, C) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function m(E) {
        var C = s.useRef(!1), T = s.useRef({ x: 0, y: 0 }), D = h(s.useState({ x: 0, y: 0 }), 2), z = D[0], B = D[1];
        function W(Z) {
          E.onResize();
        }
        function L(Z) {
          Z.button === 0 && E.visible && E.drag && (Z.preventDefault(), Z.stopPropagation(), C.current = !0, T.current = { x: Z.nativeEvent.clientX, y: Z.nativeEvent.clientY });
        }
        s.useEffect(function() {
          return function() {
            N(!0), j(!0);
          };
        }, []), s.useEffect(function() {
          return j(), function() {
            j(!0);
          };
        }), s.useEffect(function() {
          return E.visible && E.drag && N(), !E.visible && E.drag && $(), function() {
            N(!0);
          };
        }, [E.drag, E.visible]), s.useEffect(function() {
          var Z = z.x - T.current.x, H = z.y - T.current.y;
          T.current = { x: z.x, y: z.y }, E.onChangeImgState(E.width, E.height, E.top + H, E.left + Z);
        }, [z]);
        var S = function(Z) {
          C.current && B({ x: Z.clientX, y: Z.clientY });
        };
        function $(Z) {
          C.current = !1;
        }
        function j(Z) {
          var H = "addEventListener";
          Z && (H = "removeEventListener"), window[H]("resize", W, !1);
        }
        function N(Z) {
          var H = "addEventListener";
          Z && (H = "removeEventListener"), document[H]("click", $, !1), document[H]("mousemove", S, !1);
        }
        var q, G, X, Y = { width: "".concat(E.width, "px"), height: "".concat(E.height, "px"), transform: `
translateX(`.concat(E.left !== null ? E.left + "px" : "aoto", ") translateY(").concat(E.top, `px)
    rotate(`).concat(E.rotate, "deg) scaleX(").concat(E.scaleX, ") scaleY(").concat(E.scaleY, ")") }, Q = f()("".concat(E.prefixCls, "-image"), (q = { drag: E.drag }, G = "".concat(E.prefixCls, "-image-transition"), X = !C.current, G in q ? Object.defineProperty(q, G, { value: X, enumerable: !0, configurable: !0, writable: !0 }) : q[G] = X, q)), V = { zIndex: E.zIndex }, U = null;
        return E.imgSrc !== "" && (U = s.createElement("img", { className: Q, src: E.imgSrc, style: Y, onMouseDown: L })), E.loading && (U = s.createElement("div", { style: { display: "flex", height: "".concat(window.innerHeight - 84, "px"), justifyContent: "center", alignItems: "center" } }, s.createElement(l, null))), s.createElement("div", { className: "".concat(E.prefixCls, "-canvas"), onMouseDown: function(Z) {
          E.onCanvasMouseDown(Z), L(Z);
        }, style: V }, U);
      }
      function y(E) {
        var C = E.activeIndex, T = C === void 0 ? 0 : C, D = { marginLeft: "calc(50% - ".concat(T + 1, " * 31px)") };
        return s.createElement("div", { className: "".concat(E.prefixCls, "-navbar") }, s.createElement("ul", { className: "".concat(E.prefixCls, "-list ").concat(E.prefixCls, "-list-transition"), style: D }, E.images.map(function(z, B) {
          return s.createElement("li", { key: B, className: B === T ? "active" : "", onClick: function() {
            var W;
            T !== (W = B) && E.onChangeImg(W);
          } }, s.createElement("img", { src: z.src, alt: z.alt }));
        })));
      }
      function v(E) {
        return s.createElement("i", { className: "".concat("react-viewer-icon", " ").concat("react-viewer-icon", "-").concat(u[E.type]) });
      }
      (function(E) {
        E[E.zoomIn = 1] = "zoomIn", E[E.zoomOut = 2] = "zoomOut", E[E.prev = 3] = "prev", E[E.next = 4] = "next", E[E.rotateLeft = 5] = "rotateLeft", E[E.rotateRight = 6] = "rotateRight", E[E.reset = 7] = "reset", E[E.close = 8] = "close", E[E.scaleX = 9] = "scaleX", E[E.scaleY = 10] = "scaleY", E[E.download = 11] = "download";
      })(u || (u = {}));
      var w = [{ key: "zoomIn", actionType: u.zoomIn }, { key: "zoomOut", actionType: u.zoomOut }, { key: "prev", actionType: u.prev }, { key: "reset", actionType: u.reset }, { key: "next", actionType: u.next }, { key: "rotateLeft", actionType: u.rotateLeft }, { key: "rotateRight", actionType: u.rotateRight }, { key: "scaleX", actionType: u.scaleX }, { key: "scaleY", actionType: u.scaleY }, { key: "download", actionType: u.download }];
      function I(E, C) {
        return E.filter(function(T) {
          return C.indexOf(T.key) < 0;
        });
      }
      function M(E) {
        function C(z) {
          var B = null;
          return u[z.actionType] !== void 0 && (B = s.createElement(v, { type: z.actionType })), z.render && (B = z.render), s.createElement("li", { key: z.key, className: "".concat(E.prefixCls, "-btn"), onClick: function() {
            (function(W) {
              E.onAction(W);
            })(z);
          }, "data-key": z.key }, B);
        }
        var T = E.attribute ? s.createElement("p", { className: "".concat(E.prefixCls, "-attribute") }, E.alt && "".concat(E.alt), E.noImgDetails || s.createElement("span", { className: "".concat(E.prefixCls, "-img-details") }, "(".concat(E.width, " x ").concat(E.height, ")")), E.showTotal && s.createElement("span", { className: "".concat(E.prefixCls, "-showTotal") }, "".concat(E.activeIndex + 1, " of ").concat(E.count))) : null, D = E.toolbars;
        return E.zoomable || (D = I(D, ["zoomIn", "zoomOut"])), E.changeable || (D = I(D, ["prev", "next"])), E.rotatable || (D = I(D, ["rotateLeft", "rotateRight"])), E.scalable || (D = I(D, ["scaleX", "scaleY"])), E.downloadable || (D = I(D, ["download"])), s.createElement("div", null, T, s.createElement("ul", { className: "".concat(E.prefixCls, "-toolbar") }, D.map(function(z) {
          return C(z);
        })));
      }
      function k(E, C, T) {
        return C in E ? Object.defineProperty(E, C, { value: T, enumerable: !0, configurable: !0, writable: !0 }) : E[C] = T, E;
      }
      function g(E, C) {
        return function(T) {
          if (Array.isArray(T)) return T;
        }(E) || function(T, D) {
          if (Symbol.iterator in Object(T) || Object.prototype.toString.call(T) === "[object Arguments]") {
            var z = [], B = !0, W = !1, L = void 0;
            try {
              for (var S, $ = T[Symbol.iterator](); !(B = (S = $.next()).done) && (z.push(S.value), !D || z.length !== D); B = !0) ;
            } catch (j) {
              W = !0, L = j;
            } finally {
              try {
                B || $.return == null || $.return();
              } finally {
                if (W) throw L;
              }
            }
            return z;
          }
        }(E, C) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function A() {
        return (A = Object.assign || function(E) {
          for (var C = 1; C < arguments.length; C++) {
            var T = arguments[C];
            for (var D in T) Object.prototype.hasOwnProperty.call(T, D) && (E[D] = T[D]);
          }
          return E;
        }).apply(this, arguments);
      }
      function b() {
      }
      var x = { setVisible: "setVisible", setActiveIndex: "setActiveIndex", update: "update", clear: "clear" };
      function _(E, C) {
        return { type: E, payload: C || {} };
      }
      var R = function(E) {
        var C, T = E.visible, D = T !== void 0 && T, z = E.onClose, B = z === void 0 ? b : z, W = E.images, L = W === void 0 ? [] : W, S = E.activeIndex, $ = S === void 0 ? 0 : S, j = E.zIndex, N = j === void 0 ? 1e3 : j, q = E.drag, G = q === void 0 || q, X = E.attribute, Y = X === void 0 || X, Q = E.zoomable, V = Q === void 0 || Q, U = E.rotatable, Z = U === void 0 || U, H = E.scalable, ee = H === void 0 || H, ie = E.onMaskClick, re = ie === void 0 ? b : ie, K = E.changeable, se = K === void 0 || K, xe = E.customToolbar, ke = xe === void 0 ? function(Ie) {
          return Ie;
        } : xe, ue = E.zoomSpeed, fe = ue === void 0 ? 0.05 : ue, de = E.disableKeyboardSupport, ce = de !== void 0 && de, te = E.noResetZoomAfterChange, oe = te !== void 0 && te, J = E.noLimitInitializationSize, ne = J !== void 0 && J, ye = E.defaultScale, Ae = ye === void 0 ? 1 : ye, be = E.loop, je = be === void 0 || be, Oe = E.disableMouseZoom, Ve = Oe !== void 0 && Oe, _e = E.downloadable, Re = _e !== void 0 && _e, Le = E.noImgDetails, Ge = Le !== void 0 && Le, Ke = E.noToolbar, Ht = Ke !== void 0 && Ke, kr = E.showTotal, Mt = kr === void 0 || kr, xn = E.minScale, Pt = xn === void 0 ? 0.1 : xn, en = { visible: !1, visibleStart: !1, transitionEnd: !1, activeIndex: E.activeIndex, width: 0, height: 0, top: 15, left: null, rotate: 0, imageWidth: 0, imageHeight: 0, scaleX: Ae, scaleY: Ae, loading: !1, loadFailed: !1, startLoading: !1 };
        function Tr() {
          var Ie = window.innerWidth, Je = window.innerHeight;
          return E.container && (Ie = E.container.offsetWidth, Je = E.container.offsetHeight), { width: Ie, height: Je };
        }
        var at = s.useRef(Tr()), Zr = 84, Zi = s.useRef(null), Xn = s.useRef(!1), za = s.useRef(0), Ba = g(s.useReducer(function(Ie, Je) {
          switch (Je.type) {
            case x.setVisible:
              return A(A({}, Ie), { visible: Je.payload.visible });
            case x.setActiveIndex:
              return A(A({}, Ie), { activeIndex: Je.payload.index, startLoading: !0 });
            case x.update:
              return A(A({}, Ie), Je.payload);
            case x.clear:
              return A(A({}, Ie), { width: 0, height: 0, scaleX: Ae, scaleY: Ae, rotate: 1, imageWidth: 0, imageHeight: 0, loadFailed: !1, top: 0, left: 0, loading: !1 });
          }
          return Ie;
        }, en), 2), Pe = Ba[0], an = Ba[1];
        function jo(Ie) {
          var Je = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
          an(_(x.update, { loading: !0, loadFailed: !1 }));
          var xt = null;
          L.length > 0 && (xt = L[Ie]);
          var Bt = !1, Vt = new Image();
          function Ln(Gl, Fa, Uo) {
            if (Ie === za.current) {
              var ta = Gl, na = Fa;
              E.defaultSize && (ta = E.defaultSize.width, na = E.defaultSize.height), xt.defaultSize && (ta = xt.defaultSize.width, na = xt.defaultSize.height);
              var Mr = g(Wl(ta, na), 2), Ir = Mr[0], Ho = Mr[1], Vl = (at.current.width - Ir) / 2, Ql = (at.current.height - Ho - Zr) / 2, ra = Ae, ia = Ae;
              oe && !Je && (ra = Pe.scaleX, ia = Pe.scaleY), an(_(x.update, { width: Ir, height: Ho, left: Vl, top: Ql, imageWidth: Gl, imageHeight: Fa, loading: !1, rotate: 0, scaleX: ra, scaleY: ia, loadFailed: !Uo, startLoading: !1 }));
            }
          }
          Vt.onload = function() {
            Xn.current && (Bt || Ln(Vt.width, Vt.height, !0));
          }, Vt.onerror = function() {
            Xn.current && (E.defaultImg ? (an(_(x.update, { loading: !1, loadFailed: !0, startLoading: !1 })), Ln(E.defaultImg.width || 0.5 * at.current.width, E.defaultImg.height || 0.5 * at.current.height, !1)) : an(_(x.update, { loading: !1, loadFailed: !1, startLoading: !1 })));
          }, Vt.src = xt.src, Vt.complete && (Bt = !0, Ln(Vt.width, Vt.height, !0));
        }
        function Wl(Ie, Je) {
          var xt = 0, Bt = 0, Vt = 0.8 * at.current.width, Ln = 0.8 * (at.current.height - Zr);
          return (Bt = (xt = Math.min(Vt, Ie)) / Ie * Je) > Ln && (xt = (Bt = Ln) / Je * Ie), ne && (xt = Ie, Bt = Je), [xt, Bt];
        }
        function ea(Ie) {
          if ((je || !(Ie >= L.length || Ie < 0)) && (Ie >= L.length && (Ie = 0), Ie < 0 && (Ie = L.length - 1), Ie !== Pe.activeIndex)) {
            if (E.onChange) {
              var Je = Ci(Ie);
              E.onChange(Je, Ie);
            }
            an(_(x.setActiveIndex, { index: Ie }));
          }
        }
        function Ci() {
          var Ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, Je = { src: "", alt: "", downloadUrl: "" }, xt = null;
          return xt = Ie !== void 0 ? Ie : Pe.activeIndex, L.length > 0 && xt >= 0 && (Je = L[xt]), Je;
        }
        function $o() {
          var Ie = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
          an(_(x.update, { rotate: Pe.rotate + 90 * (Ie ? 1 : -1) }));
        }
        function ei(Ie) {
          switch (Ie) {
            case u.prev:
              ea(Pe.activeIndex - 1);
              break;
            case u.next:
              ea(Pe.activeIndex + 1);
              break;
            case u.zoomIn:
              var Je = nt();
              Gt(Je.x, Je.y, 1, fe);
              break;
            case u.zoomOut:
              var xt = nt();
              Gt(xt.x, xt.y, -1, fe);
              break;
            case u.rotateLeft:
              $o();
              break;
            case u.rotateRight:
              $o(!0);
              break;
            case u.reset:
              jo(Pe.activeIndex, !0);
              break;
            case u.scaleX:
              Vt = -1, an(_(x.update, { scaleX: Pe.scaleX * Vt }));
              break;
            case u.scaleY:
              (function(Ln) {
                an(_(x.update, { scaleY: Pe.scaleY * Ln }));
              })(-1);
              break;
            case u.download:
              (Bt = Ci()).downloadUrl && (E.downloadInNewWindow ? window.open(Bt.downloadUrl, "_blank") : location.href = Bt.downloadUrl);
          }
          var Bt, Vt;
        }
        function Ul() {
          var Ie = "addEventListener";
          arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (Ie = "removeEventListener"), ce || document[Ie]("keydown", Wo, !0), Zi.current && Zi.current[Ie]("wheel", Hl, !1);
        }
        function Wo(Ie) {
          var Je = !1;
          switch (Ie.keyCode || Ie.which || Ie.charCode) {
            case 27:
              B(), Je = !0;
              break;
            case 37:
              Ie.ctrlKey ? ei(u.rotateLeft) : ei(u.prev), Je = !0;
              break;
            case 39:
              Ie.ctrlKey ? ei(u.rotateRight) : ei(u.next), Je = !0;
              break;
            case 38:
              ei(u.zoomIn), Je = !0;
              break;
            case 40:
              ei(u.zoomOut), Je = !0;
              break;
            case 49:
              Ie.ctrlKey && (jo(Pe.activeIndex), Je = !0);
          }
          Je && (Ie.preventDefault(), Ie.stopPropagation());
        }
        function Hl(Ie) {
          if (!Ve && !Pe.loading) {
            Ie.preventDefault();
            var Je = 0, xt = Ie.deltaY;
            if ((Je = xt === 0 ? 0 : xt > 0 ? -1 : 1) != 0) {
              var Bt = Ie.clientX, Vt = Ie.clientY;
              if (E.container) {
                var Ln = E.container.getBoundingClientRect();
                Bt -= Ln.left, Vt -= Ln.top;
              }
              Gt(Bt, Vt, Je, fe);
            }
          }
        }
        function nt() {
          return { x: Pe.left + Pe.width / 2, y: Pe.top + Pe.height / 2 };
        }
        function Gt(Ie, Je, xt, Bt) {
          var Vt = nt(), Ln = Ie - Vt.x, Gl = Je - Vt.y, Fa = 0, Uo = 0, ta = 0, na = 0, Mr = 0, Ir = 0;
          if (Pe.width === 0) {
            var Ho = g(Wl(Pe.imageWidth, Pe.imageHeight), 2), Vl = Ho[0], Ql = Ho[1];
            Uo = (at.current.width - Vl) / 2, Fa = (at.current.height - Zr - Ql) / 2, ta = Pe.width + Vl, na = Pe.height + Ql, Mr = Ir = 1;
          } else {
            var ra = Pe.scaleX > 0 ? 1 : -1, ia = Pe.scaleY > 0 ? 1 : -1;
            Mr = Pe.scaleX + Bt * xt * ra, Ir = Pe.scaleY + Bt * xt * ia, E.maxScale !== void 0 && (Math.abs(Mr) > E.maxScale && (Mr = E.maxScale * ra), Math.abs(Ir) > E.maxScale && (Ir = E.maxScale * ia)), Math.abs(Mr) < Pt && (Mr = Pt * ra), Math.abs(Ir) < Pt && (Ir = Pt * ia), Fa = Pe.top + -xt * Gl / Pe.scaleX * Bt * ra, Uo = Pe.left + -xt * Ln / Pe.scaleY * Bt * ia, ta = Pe.width, na = Pe.height;
          }
          an(_(x.update, { width: ta, scaleX: Mr, scaleY: Ir, height: na, top: Fa, left: Uo, loading: !1 }));
        }
        s.useEffect(function() {
          return Xn.current = !0, function() {
            Xn.current = !1;
          };
        }, []), s.useEffect(function() {
          at.current = Tr();
        }, [E.container]), s.useEffect(function() {
          D && Xn.current && an(_(x.setVisible, { visible: !0 }));
        }, [D]), s.useEffect(function() {
          return Ul(), function() {
            Ul(!0);
          };
        }), s.useEffect(function() {
          return D ? E.container || (document.body.style.overflow = "hidden", document.body.scrollHeight > document.body.clientHeight && (document.body.style.paddingRight = "15px")) : an(_(x.clear, {})), function() {
            document.body.style.overflow = "", document.body.style.paddingRight = "";
          };
        }, [Pe.visible]), s.useEffect(function() {
          D && an(_(x.setActiveIndex, { index: $ }));
        }, [$, D, L]), s.useEffect(function() {
          Pe.startLoading && (za.current = Pe.activeIndex, jo(Pe.activeIndex));
        }, [Pe.startLoading, Pe.activeIndex]);
        var bn = "react-viewer", W2 = f()("".concat(bn), "".concat(bn, "-transition"), (k(C = {}, "".concat(bn, "-inline"), E.container), k(C, E.className, E.className), C)), U2 = { opacity: D && Pe.visible ? 1 : 0, display: D || Pe.visible ? "block" : "none" }, id = { src: "", alt: "" };
        return D && Pe.visible && !Pe.loading && Pe.activeIndex !== null && !Pe.startLoading && (id = Ci()), s.createElement("div", { className: W2, style: U2, onTransitionEnd: function() {
          D || an(_(x.setVisible, { visible: !1 }));
        }, ref: Zi }, s.createElement("div", { className: "".concat(bn, "-mask"), style: { zIndex: N } }), E.noClose || s.createElement("div", { className: "".concat(bn, "-close ").concat(bn, "-btn"), onClick: function() {
          B();
        }, style: { zIndex: N + 10 } }, s.createElement(v, { type: u.close })), s.createElement(m, { prefixCls: bn, imgSrc: Pe.loadFailed && E.defaultImg.src || id.src, visible: D, width: Pe.width, height: Pe.height, top: Pe.top, left: Pe.left, rotate: Pe.rotate, onChangeImgState: function(Ie, Je, xt, Bt) {
          an(_(x.update, { width: Ie, height: Je, top: xt, left: Bt }));
        }, onResize: function() {
          if (at.current = Tr(), D) {
            var Ie = (at.current.width - Pe.width) / 2, Je = (at.current.height - Pe.height - Zr) / 2;
            an(_(x.update, { left: Ie, top: Je }));
          }
        }, zIndex: N + 5, scaleX: Pe.scaleX, scaleY: Pe.scaleY, loading: Pe.loading, drag: G, container: E.container, onCanvasMouseDown: function(Ie) {
          re(Ie);
        } }), E.noFooter || s.createElement("div", { className: "".concat(bn, "-footer"), style: { zIndex: N + 5 } }, Ht || s.createElement(M, { prefixCls: bn, onAction: function(Ie) {
          if (ei(Ie.actionType), Ie.onClick) {
            var Je = Ci();
            Ie.onClick(Je);
          }
        }, alt: id.alt, width: Pe.imageWidth, height: Pe.imageHeight, attribute: Y, zoomable: V, rotatable: Z, scalable: ee, changeable: se, downloadable: Re, noImgDetails: Ge, toolbars: ke(w), activeIndex: Pe.activeIndex, count: L.length, showTotal: Mt }), E.noNavbar || s.createElement(y, { prefixCls: bn, images: E.images, activeIndex: Pe.activeIndex, onChangeImg: ea })));
      };
      function P(E, C) {
        return function(T) {
          if (Array.isArray(T)) return T;
        }(E) || function(T, D) {
          if (Symbol.iterator in Object(T) || Object.prototype.toString.call(T) === "[object Arguments]") {
            var z = [], B = !0, W = !1, L = void 0;
            try {
              for (var S, $ = T[Symbol.iterator](); !(B = (S = $.next()).done) && (z.push(S.value), !D || z.length !== D); B = !0) ;
            } catch (j) {
              W = !0, L = j;
            } finally {
              try {
                B || $.return == null || $.return();
              } finally {
                if (W) throw L;
              }
            }
            return z;
          }
        }(E, C) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      a.default = function(E) {
        var C = s.useRef(typeof document < "u" ? document.createElement("div") : null), T = P(s.useState(E.container), 2), D = T[0], z = T[1], B = P(s.useState(!1), 2), W = B[0], L = B[1];
        return s.useEffect(function() {
          document.body.appendChild(C.current);
        }, []), s.useEffect(function() {
          E.visible && !W && L(!0);
        }, [E.visible, W]), s.useEffect(function() {
          E.container ? z(E.container) : z(C.current);
        }, [E.container]), W ? c.createPortal(s.createElement(R, E), D) : null;
      };
    }]);
  });
})(px);
var Ok = px.exports;
const Rk = /* @__PURE__ */ rf(Ok), Dk = ae.div`
  height: 100%;

  .react-viewer-image {
    border: ${({ theme: e }) => {
  var t;
  return `1px solid ${(t = e.palette) == null ? void 0 : t.secondary.main}`;
}};
  }
  .react-viewer-mask {
    background-color: #fff;
  }
`, Pk = (e) => {
  const { data: t, height: n = 500 } = e, r = sr(null), [i, a] = Te(!1), o = Ce(() => `data:image;base64,${t}`, [t]);
  return tt(() => {
    r.current && a(!0);
  }, [r.current]), /* @__PURE__ */ p(Dk, { ref: r, children: i && /* @__PURE__ */ p(
    Rk,
    {
      attribute: !1,
      visible: !0,
      container: r.current,
      images: [{ src: o }],
      noNavbar: !0,
      noClose: !0,
      customToolbar: (s) => s.filter((c) => ![3, 4, 7, 11].includes(c.actionType))
    }
  ) });
}, Lk = ae.div`
  //background: .;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 40px;
  top: 80px;
`, zk = ae.div`
  padding: 6px 0;
  color: ${({ theme: e }) => e.palette.primary.main};
`, W0 = ae.div`
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  :not(:last-of-type) {
    margin-right: 5px;
  }
  &:hover {
    opacity: 1;
    background-color: ${(e) => {
  var t;
  return Yn(0.9, (t = e.theme.palette) == null ? void 0 : t.secondary.main);
}};
  }
  ${({ disabled: e, theme: t }) => {
  var n;
  return e && `
    .icon {
      color: ${(n = t.palette) == null ? void 0 : n.grey[400]}
    }
    &:hover {
      cursor: default;
      background-color: transparent;
    }
  `;
}}
`, Bk = (e) => {
  const { scale: n, onChange: r } = e, i = (o) => {
    o.preventDefault();
    const s = n + 0.1;
    r(s);
  }, a = (o) => {
    const s = n - 0.1;
    s > 0.1 && r(s);
  };
  return /* @__PURE__ */ F(Lk, { children: [
    /* @__PURE__ */ p(W0, { onClick: i, children: /* @__PURE__ */ p(he, { iconName: "zoomIn", color: "primary" }) }),
    /* @__PURE__ */ F(zk, { children: [
      parseInt(String(n * 100), 10),
      "%"
    ] }),
    /* @__PURE__ */ p(W0, { onClick: a, children: /* @__PURE__ */ p(he, { iconName: "zoomOut", color: "primary" }) })
  ] });
}, Fk = ae.div`
  position: relative;
  overflow: ${(e) => e.scroll ? "auto" : "hidden"};
  .react-pdf__Page__textContent,
  .react-pdf__Page__annotations {
    display: none;
  }
  .react-pdf__Page {
    display: flex;
    justify-content: space-around;
    background-color: transparent !important;
    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  }
  .react-pdf__Page__canvas {
    border-radius: 4px;
    box-shadow: ${({ theme: e }) => e.customShadows[3]};
    border: 1px solid
      ${({ theme: e }) => e.palette.borderColor.main};
  }
`, Yk = ae.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-transform: uppercase;
  font-weight: bold;
  height: 100%;
`, jk = ae.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px 0;
`;
BC.GlobalWorkerOptions.workerSrc = "/assets/scripts/pdf.worker.min.mjs";
const mx = Kt((e) => {
  const { data: t, height: n = 500, linkDownload: r, scaleDefault: i, scroll: a } = e, [o, s] = Te(1), [c, l] = Te(i || 1);
  return /* @__PURE__ */ F(Fk, { height: n, scroll: a, children: [
    /* @__PURE__ */ p(
      YC,
      {
        onLoadSuccess: (d) => {
          s(d.numPages);
        },
        file: r || `/api/documents/${t.id}/preview`,
        loading: /* @__PURE__ */ p(jk, { children: /* @__PURE__ */ p(gt, {}) }),
        children: Array.from({ length: o }).map((d, f) => /* @__PURE__ */ p(
          FC,
          {
            pageNumber: f + 1,
            scale: c,
            loading: ""
          },
          `page_${f + 1}`
        ))
      }
    ),
    /* @__PURE__ */ p(Bk, { scale: c, onChange: l })
  ] });
}), LH = (e) => {
  const {
    data: t,
    height: n = 500,
    downloadMethod: r,
    remoteFile: i = !0,
    pdfLink: a
  } = e;
  if (!t.mediaType)
    return null;
  switch (t.mediaType) {
    case Go.CODE:
      return /* @__PURE__ */ p(
        _l,
        {
          data: t,
          height: n,
          containerStyles: { padding: 0 },
          enableDownload: !1,
          enableCopy: !0,
          remoteFile: i,
          downloadMethod: r,
          language: t.codeLanguage
        }
      );
    case Go.CSV:
      return /* @__PURE__ */ p(
        hx,
        {
          data: t,
          height: n,
          downloadMethod: r
        }
      );
    case Go.PDF:
      return /* @__PURE__ */ p(mx, { data: t, height: n, linkDownload: a });
    case Go.IMAGE:
      return /* @__PURE__ */ p(Pk, { data: t, height: n });
    case Go.ARCHIVE:
    default:
      return /* @__PURE__ */ p(Yk, { children: "Content of this file cannot be displayed" });
  }
}, $k = ae.div`
  display: inline-flex;
  align-items: center;
  font-size: ${({ isHeader: e }) => e ? "24px" : "13px"};
  max-width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme: e }) => e.palette.textColor.primary};
  font-weight: ${({ isHeader: e }) => e ? 300 : 600};
`;
ae(he)`
  color: ${({ color: e }) => e};
  margin-right: 8px;
`;
const U0 = ae.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
function Wk(e) {
  const { id: t, published: n, name: r } = e, { name: i } = Uk(e.dataNode);
  return {
    healthStatusTitle: Gk(ar.GREEN),
    healthStatusColor: Hk(ar.GREEN),
    id: t,
    tooltip: `${i}: ${r}`,
    name: `${r}`,
    published: n
  };
}
function Uk(e) {
  const {
    id: t,
    name: n,
    /* healthStatus, */
    published: r
  } = e;
  return {
    // healthStatusTitle: getHealthStatusTitle(healthStatus),
    // healthStatusColor: getHealthStatusIconColor(healthStatus),
    id: t,
    name: n || "Not published",
    published: r
  };
}
function Hk(e) {
  const { palette: t } = Sr();
  switch (e) {
    case ar.GREEN:
      return t.success.main;
    case ar.RED:
    case ar.NOT_CONNECTED:
      return t.error.main;
    case ar.NOT_COLLECTED:
    case ar.AMBER:
      return t.warning.main;
    default:
      return t.grey[400];
  }
}
function Gk(e) {
  switch (e) {
    case ar.GREEN:
      return "Online";
    case ar.RED:
    case ar.NOT_CONNECTED:
      return "Disconnected";
    case ar.NOT_COLLECTED:
      return "Not enough statistics";
    case ar.AMBER:
      return "Unstable";
    default:
      return "";
  }
}
const gx = Kt((e) => {
  const { dataSource: t, withTooltip: n = !0, isHeader: r } = e, { healthStatusTitle: i, healthStatusColor: a, name: o, tooltip: s } = Wk(t);
  return /* @__PURE__ */ F($k, { isHeader: r, children: [
    /* @__PURE__ */ p(yt, { text: i, width: "auto", color: "primary", children: /* @__PURE__ */ p(
      we,
      {
        sx: {
          backgroundColor: a,
          width: 10,
          height: 10,
          minWidth: 10,
          mr: 1,
          borderRadius: "50%",
          boxShadow: "inset -4px -4px 10px rgba(255,255,255,.4)",
          cursor: "pointer",
          transition: "300ms",
          ":hover": {
            filter: "brightness(90%)"
          }
        }
      }
    ) }),
    n ? /* @__PURE__ */ p(yt, { text: s, color: "primary", width: 150, children: /* @__PURE__ */ p(U0, { children: o }) }) : /* @__PURE__ */ p(U0, { children: o })
  ] });
});
function Vk(e) {
  const { palette: t } = Xr();
  switch (e) {
    case dr.FAILED:
    case dr.DISMISSED:
    case dr.PROCESSING_RESULTS_FAILED:
      return t.error.main;
    case dr.PENDING:
    case dr.INITIAL:
    case dr.AWAITING_APPROVAL:
    case dr.AWAITING_PUBLISHING_APPROVAL:
      return t.warning.main;
    case dr.PUBLISHED:
      return t.success.main;
    case dr.QUEUED:
    case dr.IN_PROGRESS:
    case dr.PROCESSING_RESULTS:
      return t.info.main;
    default:
      return t.grey[400];
  }
}
const Qk = Kt((e) => {
  const { status: t } = e;
  if (!t) return null;
  const n = Vk(t.value);
  return /* @__PURE__ */ p(Qp, { color: n, text: t.title, light: !0, align: "center" });
}), zH = () => {
  var t;
  const e = Xr();
  return /* @__PURE__ */ p(we, { sx: { margin: "10px auto", width: "100%", maxWidth: "1400px" }, children: /* @__PURE__ */ p(O, { container: !0, spacing: 1, direction: "column", children: /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
    ii,
    {
      animation: "wave",
      height: 300,
      width: "100%",
      sx: { bgcolor: Yn(0.7, (t = e.palette) == null ? void 0 : t.secondary.main) }
    }
  ) }) }) });
}, BH = () => {
  var t, n, r, i, a, o;
  const e = Xr();
  return /* @__PURE__ */ p(we, { sx: { margin: "10px auto", width: "100%" }, children: /* @__PURE__ */ F(O, { container: !0, spacing: 2, direction: "row", flexWrap: "wrap", children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 3, children: /* @__PURE__ */ p(
      ii,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Yn(0.7, (t = e.palette) == null ? void 0 : t.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 9, children: /* @__PURE__ */ p(
      ii,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Yn(0.7, (n = e.palette) == null ? void 0 : n.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 3, children: /* @__PURE__ */ p(
      ii,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Yn(0.7, (r = e.palette) == null ? void 0 : r.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 9, children: /* @__PURE__ */ p(
      ii,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Yn(0.7, (i = e.palette) == null ? void 0 : i.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 2, children: /* @__PURE__ */ p(
      ii,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Yn(0.7, (a = e.palette) == null ? void 0 : a.secondary.main)
        }
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 2, children: /* @__PURE__ */ p(
      ii,
      {
        animation: "wave",
        height: 26,
        width: "100%",
        sx: {
          bgcolor: Yn(0.7, (o = e.palette) == null ? void 0 : o.secondary.main)
        }
      }
    ) })
  ] }) });
};
var Sh = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var sd, H0;
function qk() {
  if (H0) return sd;
  H0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return sd = i() ? Object.assign : function(a, o) {
    for (var s, c = r(a), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (c[d] = s[d]);
      if (e) {
        l = e(s);
        for (var f = 0; f < l.length; f++)
          n.call(s, l[f]) && (c[l[f]] = s[l[f]]);
      }
    }
    return c;
  }, sd;
}
var ld, G0;
function rm() {
  if (G0) return ld;
  G0 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ld = e, ld;
}
var cd, V0;
function yx() {
  return V0 || (V0 = 1, cd = Function.call.bind(Object.prototype.hasOwnProperty)), cd;
}
var ud, Q0;
function Xk() {
  if (Q0) return ud;
  Q0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = rm(), n = {}, r = yx();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in a)
        if (r(a, u)) {
          var d;
          try {
            if (typeof a[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[u](o, u, c, s, null, t);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ud = i, ud;
}
var fd, q0;
function Jk() {
  if (q0) return fd;
  q0 = 1;
  var e = tm, t = qk(), n = rm(), r = yx(), i = Xk(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return fd = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(S) {
      var $ = S && (l && S[l] || S[u]);
      if (typeof $ == "function")
        return $;
    }
    var f = "<<anonymous>>", h = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: I(),
      arrayOf: M,
      element: k(),
      elementType: g(),
      instanceOf: A,
      node: R(),
      objectOf: x,
      oneOf: b,
      oneOfType: _,
      shape: E,
      exact: C
    };
    function m(S, $) {
      return S === $ ? S !== 0 || 1 / S === 1 / $ : S !== S && $ !== $;
    }
    function y(S, $) {
      this.message = S, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function v(S) {
      if (process.env.NODE_ENV !== "production")
        var $ = {}, j = 0;
      function N(G, X, Y, Q, V, U, Z) {
        if (Q = Q || f, U = U || Y, Z !== n) {
          if (c) {
            var H = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw H.name = "Invariant Violation", H;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ee = Q + ":" + Y;
            !$[ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[ee] = !0, j++);
          }
        }
        return X[Y] == null ? G ? X[Y] === null ? new y("The " + V + " `" + U + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new y("The " + V + " `" + U + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : S(X, Y, Q, V, U);
      }
      var q = N.bind(null, !1);
      return q.isRequired = N.bind(null, !0), q;
    }
    function w(S) {
      function $(j, N, q, G, X, Y) {
        var Q = j[N], V = z(Q);
        if (V !== S) {
          var U = B(Q);
          return new y(
            "Invalid " + G + " `" + X + "` of type " + ("`" + U + "` supplied to `" + q + "`, expected ") + ("`" + S + "`."),
            { expectedType: S }
          );
        }
        return null;
      }
      return v($);
    }
    function I() {
      return v(o);
    }
    function M(S) {
      function $(j, N, q, G, X) {
        if (typeof S != "function")
          return new y("Property `" + X + "` of component `" + q + "` has invalid PropType notation inside arrayOf.");
        var Y = j[N];
        if (!Array.isArray(Y)) {
          var Q = z(Y);
          return new y("Invalid " + G + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + q + "`, expected an array."));
        }
        for (var V = 0; V < Y.length; V++) {
          var U = S(Y, V, q, G, X + "[" + V + "]", n);
          if (U instanceof Error)
            return U;
        }
        return null;
      }
      return v($);
    }
    function k() {
      function S($, j, N, q, G) {
        var X = $[j];
        if (!s(X)) {
          var Y = z(X);
          return new y("Invalid " + q + " `" + G + "` of type " + ("`" + Y + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(S);
    }
    function g() {
      function S($, j, N, q, G) {
        var X = $[j];
        if (!e.isValidElementType(X)) {
          var Y = z(X);
          return new y("Invalid " + q + " `" + G + "` of type " + ("`" + Y + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(S);
    }
    function A(S) {
      function $(j, N, q, G, X) {
        if (!(j[N] instanceof S)) {
          var Y = S.name || f, Q = L(j[N]);
          return new y("Invalid " + G + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + q + "`, expected ") + ("instance of `" + Y + "`."));
        }
        return null;
      }
      return v($);
    }
    function b(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function $(j, N, q, G, X) {
        for (var Y = j[N], Q = 0; Q < S.length; Q++)
          if (m(Y, S[Q]))
            return null;
        var V = JSON.stringify(S, function(Z, H) {
          var ee = B(H);
          return ee === "symbol" ? String(H) : H;
        });
        return new y("Invalid " + G + " `" + X + "` of value `" + String(Y) + "` " + ("supplied to `" + q + "`, expected one of " + V + "."));
      }
      return v($);
    }
    function x(S) {
      function $(j, N, q, G, X) {
        if (typeof S != "function")
          return new y("Property `" + X + "` of component `" + q + "` has invalid PropType notation inside objectOf.");
        var Y = j[N], Q = z(Y);
        if (Q !== "object")
          return new y("Invalid " + G + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + q + "`, expected an object."));
        for (var V in Y)
          if (r(Y, V)) {
            var U = S(Y, V, q, G, X + "." + V, n);
            if (U instanceof Error)
              return U;
          }
        return null;
      }
      return v($);
    }
    function _(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var $ = 0; $ < S.length; $++) {
        var j = S[$];
        if (typeof j != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(j) + " at index " + $ + "."
          ), o;
      }
      function N(q, G, X, Y, Q) {
        for (var V = [], U = 0; U < S.length; U++) {
          var Z = S[U], H = Z(q, G, X, Y, Q, n);
          if (H == null)
            return null;
          H.data && r(H.data, "expectedType") && V.push(H.data.expectedType);
        }
        var ee = V.length > 0 ? ", expected one of type [" + V.join(", ") + "]" : "";
        return new y("Invalid " + Y + " `" + Q + "` supplied to " + ("`" + X + "`" + ee + "."));
      }
      return v(N);
    }
    function R() {
      function S($, j, N, q, G) {
        return T($[j]) ? null : new y("Invalid " + q + " `" + G + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return v(S);
    }
    function P(S, $, j, N, q) {
      return new y(
        (S || "React class") + ": " + $ + " type `" + j + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + q + "`."
      );
    }
    function E(S) {
      function $(j, N, q, G, X) {
        var Y = j[N], Q = z(Y);
        if (Q !== "object")
          return new y("Invalid " + G + " `" + X + "` of type `" + Q + "` " + ("supplied to `" + q + "`, expected `object`."));
        for (var V in S) {
          var U = S[V];
          if (typeof U != "function")
            return P(q, G, X, V, B(U));
          var Z = U(Y, V, q, G, X + "." + V, n);
          if (Z)
            return Z;
        }
        return null;
      }
      return v($);
    }
    function C(S) {
      function $(j, N, q, G, X) {
        var Y = j[N], Q = z(Y);
        if (Q !== "object")
          return new y("Invalid " + G + " `" + X + "` of type `" + Q + "` " + ("supplied to `" + q + "`, expected `object`."));
        var V = t({}, j[N], S);
        for (var U in V) {
          var Z = S[U];
          if (r(S, U) && typeof Z != "function")
            return P(q, G, X, U, B(Z));
          if (!Z)
            return new y(
              "Invalid " + G + " `" + X + "` key `" + U + "` supplied to `" + q + "`.\nBad object: " + JSON.stringify(j[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(S), null, "  ")
            );
          var H = Z(Y, U, q, G, X + "." + U, n);
          if (H)
            return H;
        }
        return null;
      }
      return v($);
    }
    function T(S) {
      switch (typeof S) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !S;
        case "object":
          if (Array.isArray(S))
            return S.every(T);
          if (S === null || s(S))
            return !0;
          var $ = d(S);
          if ($) {
            var j = $.call(S), N;
            if ($ !== S.entries) {
              for (; !(N = j.next()).done; )
                if (!T(N.value))
                  return !1;
            } else
              for (; !(N = j.next()).done; ) {
                var q = N.value;
                if (q && !T(q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(S, $) {
      return S === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function z(S) {
      var $ = typeof S;
      return Array.isArray(S) ? "array" : S instanceof RegExp ? "object" : D($, S) ? "symbol" : $;
    }
    function B(S) {
      if (typeof S > "u" || S === null)
        return "" + S;
      var $ = z(S);
      if ($ === "object") {
        if (S instanceof Date)
          return "date";
        if (S instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function W(S) {
      var $ = B(S);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function L(S) {
      return !S.constructor || !S.constructor.name ? f : S.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, fd;
}
var dd, X0;
function Kk() {
  if (X0) return dd;
  X0 = 1;
  var e = rm();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, dd = function() {
    function r(o, s, c, l, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, dd;
}
if (process.env.NODE_ENV !== "production") {
  var Zk = tm, eT = !0;
  Sh.exports = Jk()(Zk.isElement, eT);
} else
  Sh.exports = Kk()();
var tT = Sh.exports;
const bt = /* @__PURE__ */ rf(tT);
function No(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      u.done ? a(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, [])).next());
  });
}
function Oo(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (n = 0)), n; ) try {
      if (r = 1, i && (a = l[0] & 2 ? i.return : l[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, l[1])).done) return a;
      switch (i = 0, a && (l = [l[0] & 2, a.value]), l[0]) {
        case 0:
        case 1:
          a = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, i = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!a || l[1] > a[0] && l[1] < a[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = l;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(l);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = t.call(e, n);
    } catch (u) {
      l = [6, u], i = 0;
    } finally {
      r = a = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function J0(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) a.push(i.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function K0(e, t, n) {
  if (arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var nT = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Sl(e, t) {
  var n = rT(e);
  if (typeof n.path != "string") {
    var r = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof t == "string" ? t : typeof r == "string" && r.length > 0 ? r : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function rT(e) {
  var t = e.name, n = t && t.lastIndexOf(".") !== -1;
  if (n && !e.type) {
    var r = t.split(".").pop().toLowerCase(), i = nT.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var iT = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function aT(e) {
  return No(this, void 0, void 0, function() {
    return Oo(this, function(t) {
      return qc(e) && oT(e.dataTransfer) ? [2, uT(e.dataTransfer, e.type)] : sT(e) ? [2, lT(e)] : Array.isArray(e) && e.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, cT(e)] : [2, []];
    });
  });
}
function oT(e) {
  return qc(e);
}
function sT(e) {
  return qc(e) && qc(e.target);
}
function qc(e) {
  return typeof e == "object" && e !== null;
}
function lT(e) {
  return Ch(e.target.files).map(function(t) {
    return Sl(t);
  });
}
function cT(e) {
  return No(this, void 0, void 0, function() {
    var t;
    return Oo(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(e.map(function(r) {
            return r.getFile();
          }))];
        case 1:
          return t = n.sent(), [2, t.map(function(r) {
            return Sl(r);
          })];
      }
    });
  });
}
function uT(e, t) {
  return No(this, void 0, void 0, function() {
    var n, r;
    return Oo(this, function(i) {
      switch (i.label) {
        case 0:
          return e.items ? (n = Ch(e.items).filter(function(a) {
            return a.kind === "file";
          }), t !== "drop" ? [2, n] : [4, Promise.all(n.map(fT))]) : [3, 2];
        case 1:
          return r = i.sent(), [2, Z0(Ax(r))];
        case 2:
          return [2, Z0(Ch(e.files).map(function(a) {
            return Sl(a);
          }))];
      }
    });
  });
}
function Z0(e) {
  return e.filter(function(t) {
    return iT.indexOf(t.name) === -1;
  });
}
function Ch(e) {
  if (e === null)
    return [];
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n];
    t.push(r);
  }
  return t;
}
function fT(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return ey(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? vx(t) : ey(e);
}
function Ax(e) {
  return e.reduce(function(t, n) {
    return K0(K0([], J0(t), !1), J0(Array.isArray(n) ? Ax(n) : [n]), !1);
  }, []);
}
function ey(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var n = Sl(t);
  return Promise.resolve(n);
}
function dT(e) {
  return No(this, void 0, void 0, function() {
    return Oo(this, function(t) {
      return [2, e.isDirectory ? vx(e) : hT(e)];
    });
  });
}
function vx(e) {
  var t = e.createReader();
  return new Promise(function(n, r) {
    var i = [];
    function a() {
      var o = this;
      t.readEntries(function(s) {
        return No(o, void 0, void 0, function() {
          var c, l, u;
          return Oo(this, function(d) {
            switch (d.label) {
              case 0:
                if (s.length) return [3, 5];
                d.label = 1;
              case 1:
                return d.trys.push([1, 3, , 4]), [4, Promise.all(i)];
              case 2:
                return c = d.sent(), n(c), [3, 4];
              case 3:
                return l = d.sent(), r(l), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                u = Promise.all(s.map(dT)), i.push(u), a(), d.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(s) {
        r(s);
      });
    }
    a();
  });
}
function hT(e) {
  return No(this, void 0, void 0, function() {
    return Oo(this, function(t) {
      return [2, new Promise(function(n, r) {
        e.file(function(i) {
          var a = Sl(i, e.fullPath);
          n(a);
        }, function(i) {
          r(i);
        });
      })];
    });
  });
}
var hd = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(",");
    if (n.length === 0)
      return !0;
    var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
    return n.some(function(o) {
      var s = o.trim().toLowerCase();
      return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? a === s.replace(/\/.*$/, "") : i === s;
    });
  }
  return !0;
};
function ty(e) {
  return gT(e) || mT(e) || bx(e) || pT();
}
function pT() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mT(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function gT(e) {
  if (Array.isArray(e)) return Eh(e);
}
function ny(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ry(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ny(Object(n), !0).forEach(function(r) {
      xx(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ny(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xx(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Hs(e, t) {
  return vT(e) || AT(e, t) || bx(e, t) || yT();
}
function yT() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bx(e, t) {
  if (e) {
    if (typeof e == "string") return Eh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Eh(e, t);
  }
}
function Eh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AT(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (c) {
      a = !0, s = c;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function vT(e) {
  if (Array.isArray(e)) return e;
}
var xT = typeof hd == "function" ? hd : hd.default, bT = "file-invalid-type", wT = "file-too-large", _T = "file-too-small", ST = "too-many-files", CT = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var n = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: bT,
    message: "File type must be ".concat(n)
  };
}, iy = function(t) {
  return {
    code: wT,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, ay = function(t) {
  return {
    code: _T,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, ET = {
  code: ST,
  message: "Too many files"
};
function wx(e, t) {
  var n = e.type === "application/x-moz-file" || xT(e, t);
  return [n, n ? null : CT(t)];
}
function _x(e, t, n) {
  if (fa(e.size))
    if (fa(t) && fa(n)) {
      if (e.size > n) return [!1, iy(n)];
      if (e.size < t) return [!1, ay(t)];
    } else {
      if (fa(t) && e.size < t) return [!1, ay(t)];
      if (fa(n) && e.size > n) return [!1, iy(n)];
    }
  return [!0, null];
}
function fa(e) {
  return e != null;
}
function kT(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, o = e.maxFiles, s = e.validator;
  return !a && t.length > 1 || a && o >= 1 && t.length > o ? !1 : t.every(function(c) {
    var l = wx(c, n), u = Hs(l, 1), d = u[0], f = _x(c, r, i), h = Hs(f, 1), m = h[0], y = s ? s(c) : null;
    return d && m && !y;
  });
}
function Xc(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Jl(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function oy(e) {
  e.preventDefault();
}
function TT(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function MT(e) {
  return e.indexOf("Edge/") !== -1;
}
function IT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return TT(e) || MT(e);
}
function Nr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)
      a[o - 1] = arguments[o];
    return t.some(function(s) {
      return !Xc(r) && s && s.apply(void 0, [r].concat(a)), Xc(r);
    });
  };
}
function NT() {
  return "showOpenFilePicker" in window;
}
function OT(e) {
  if (fa(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Hs(n, 2), i = r[0], a = r[1], o = !0;
      return Sx(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), o = !1), (!Array.isArray(a) || !a.every(Cx)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), o = !1), o;
    }).reduce(function(n, r) {
      var i = Hs(r, 2), a = i[0], o = i[1];
      return ry(ry({}, n), {}, xx({}, a, o));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function RT(e) {
  if (fa(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Hs(n, 2), i = r[0], a = r[1];
      return [].concat(ty(t), [i], ty(a));
    }, []).filter(function(t) {
      return Sx(t) || Cx(t);
    }).join(",");
}
function DT(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function PT(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Sx(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Cx(e) {
  return /^.*\.[\w]+$/.test(e);
}
var LT = ["children"], zT = ["open"], BT = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], FT = ["refKey", "onChange", "onClick"];
function YT(e) {
  return WT(e) || $T(e) || Ex(e) || jT();
}
function jT() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $T(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function WT(e) {
  if (Array.isArray(e)) return kh(e);
}
function pd(e, t) {
  return GT(e) || HT(e, t) || Ex(e, t) || UT();
}
function UT() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ex(e, t) {
  if (e) {
    if (typeof e == "string") return kh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kh(e, t);
  }
}
function kh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function HT(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (c) {
      a = !0, s = c;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function GT(e) {
  if (Array.isArray(e)) return e;
}
function sy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sy(Object(n), !0).forEach(function(r) {
      Th(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sy(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Th(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Jc(e, t) {
  if (e == null) return {};
  var n = VT(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function VT(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var im = /* @__PURE__ */ Up(function(e, t) {
  var n = e.children, r = Jc(e, LT), i = Tx(r), a = i.open, o = Jc(i, zT);
  return V2(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ qe.createElement(Q2, null, n(Rt(Rt({}, o), {}, {
    open: a
  })));
});
im.displayName = "Dropzone";
var kx = {
  disabled: !1,
  getFilesFromEvent: aT,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
im.defaultProps = kx;
im.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: bt.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: bt.objectOf(bt.arrayOf(bt.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: bt.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: bt.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: bt.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: bt.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: bt.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: bt.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: bt.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: bt.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: bt.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: bt.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: bt.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: bt.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: bt.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: bt.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: bt.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: bt.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: bt.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: bt.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: bt.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: bt.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: bt.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: bt.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: bt.func
};
var Mh = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Tx() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Rt(Rt({}, kx), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, o = t.minSize, s = t.multiple, c = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, d = t.onDragOver, f = t.onDrop, h = t.onDropAccepted, m = t.onDropRejected, y = t.onFileDialogCancel, v = t.onFileDialogOpen, w = t.useFsAccessApi, I = t.autoFocus, M = t.preventDropOnDocument, k = t.noClick, g = t.noKeyboard, A = t.noDrag, b = t.noDragEventsBubbling, x = t.onError, _ = t.validator, R = Ce(function() {
    return RT(n);
  }, [n]), P = Ce(function() {
    return OT(n);
  }, [n]), E = Ce(function() {
    return typeof v == "function" ? v : ly;
  }, [v]), C = Ce(function() {
    return typeof y == "function" ? y : ly;
  }, [y]), T = sr(null), D = sr(null), z = yv(QT, Mh), B = pd(z, 2), W = B[0], L = B[1], S = W.isFocused, $ = W.isFileDialogActive, j = sr(typeof window < "u" && window.isSecureContext && w && NT()), N = function() {
    !j.current && $ && setTimeout(function() {
      if (D.current) {
        var oe = D.current.files;
        oe.length || (L({
          type: "closeDialog"
        }), C());
      }
    }, 300);
  };
  tt(function() {
    return window.addEventListener("focus", N, !1), function() {
      window.removeEventListener("focus", N, !1);
    };
  }, [D, $, C, j]);
  var q = sr([]), G = function(oe) {
    T.current && T.current.contains(oe.target) || (oe.preventDefault(), q.current = []);
  };
  tt(function() {
    return M && (document.addEventListener("dragover", oy, !1), document.addEventListener("drop", G, !1)), function() {
      M && (document.removeEventListener("dragover", oy), document.removeEventListener("drop", G));
    };
  }, [T, M]), tt(function() {
    return !r && I && T.current && T.current.focus(), function() {
    };
  }, [T, I, r]);
  var X = ot(function(te) {
    x ? x(te) : console.error(te);
  }, [x]), Y = ot(function(te) {
    te.preventDefault(), te.persist(), ue(te), q.current = [].concat(YT(q.current), [te.target]), Jl(te) && Promise.resolve(i(te)).then(function(oe) {
      if (!(Xc(te) && !b)) {
        var J = oe.length, ne = J > 0 && kT({
          files: oe,
          accept: R,
          minSize: o,
          maxSize: a,
          multiple: s,
          maxFiles: c,
          validator: _
        }), ye = J > 0 && !ne;
        L({
          isDragAccept: ne,
          isDragReject: ye,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), l && l(te);
      }
    }).catch(function(oe) {
      return X(oe);
    });
  }, [i, l, X, b, R, o, a, s, c, _]), Q = ot(function(te) {
    te.preventDefault(), te.persist(), ue(te);
    var oe = Jl(te);
    if (oe && te.dataTransfer)
      try {
        te.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return oe && d && d(te), !1;
  }, [d, b]), V = ot(function(te) {
    te.preventDefault(), te.persist(), ue(te);
    var oe = q.current.filter(function(ne) {
      return T.current && T.current.contains(ne);
    }), J = oe.indexOf(te.target);
    J !== -1 && oe.splice(J, 1), q.current = oe, !(oe.length > 0) && (L({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Jl(te) && u && u(te));
  }, [T, u, b]), U = ot(function(te, oe) {
    var J = [], ne = [];
    te.forEach(function(ye) {
      var Ae = wx(ye, R), be = pd(Ae, 2), je = be[0], Oe = be[1], Ve = _x(ye, o, a), _e = pd(Ve, 2), Re = _e[0], Le = _e[1], Ge = _ ? _(ye) : null;
      if (je && Re && !Ge)
        J.push(ye);
      else {
        var Ke = [Oe, Le];
        Ge && (Ke = Ke.concat(Ge)), ne.push({
          file: ye,
          errors: Ke.filter(function(Ht) {
            return Ht;
          })
        });
      }
    }), (!s && J.length > 1 || s && c >= 1 && J.length > c) && (J.forEach(function(ye) {
      ne.push({
        file: ye,
        errors: [ET]
      });
    }), J.splice(0)), L({
      acceptedFiles: J,
      fileRejections: ne,
      type: "setFiles"
    }), f && f(J, ne, oe), ne.length > 0 && m && m(ne, oe), J.length > 0 && h && h(J, oe);
  }, [L, s, R, o, a, c, f, h, m, _]), Z = ot(function(te) {
    te.preventDefault(), te.persist(), ue(te), q.current = [], Jl(te) && Promise.resolve(i(te)).then(function(oe) {
      Xc(te) && !b || U(oe, te);
    }).catch(function(oe) {
      return X(oe);
    }), L({
      type: "reset"
    });
  }, [i, U, X, b]), H = ot(function() {
    if (j.current) {
      L({
        type: "openDialog"
      }), E();
      var te = {
        multiple: s,
        types: P
      };
      window.showOpenFilePicker(te).then(function(oe) {
        return i(oe);
      }).then(function(oe) {
        U(oe, null), L({
          type: "closeDialog"
        });
      }).catch(function(oe) {
        DT(oe) ? (C(oe), L({
          type: "closeDialog"
        })) : PT(oe) ? (j.current = !1, D.current ? (D.current.value = null, D.current.click()) : X(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : X(oe);
      });
      return;
    }
    D.current && (L({
      type: "openDialog"
    }), E(), D.current.value = null, D.current.click());
  }, [L, E, C, w, U, X, P, s]), ee = ot(function(te) {
    !T.current || !T.current.isEqualNode(te.target) || (te.key === " " || te.key === "Enter" || te.keyCode === 32 || te.keyCode === 13) && (te.preventDefault(), H());
  }, [T, H]), ie = ot(function() {
    L({
      type: "focus"
    });
  }, []), re = ot(function() {
    L({
      type: "blur"
    });
  }, []), K = ot(function() {
    k || (IT() ? setTimeout(H, 0) : H());
  }, [k, H]), se = function(oe) {
    return r ? null : oe;
  }, xe = function(oe) {
    return g ? null : se(oe);
  }, ke = function(oe) {
    return A ? null : se(oe);
  }, ue = function(oe) {
    b && oe.stopPropagation();
  }, fe = Ce(function() {
    return function() {
      var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, oe = te.refKey, J = oe === void 0 ? "ref" : oe, ne = te.role, ye = te.onKeyDown, Ae = te.onFocus, be = te.onBlur, je = te.onClick, Oe = te.onDragEnter, Ve = te.onDragOver, _e = te.onDragLeave, Re = te.onDrop, Le = Jc(te, BT);
      return Rt(Rt(Th({
        onKeyDown: xe(Nr(ye, ee)),
        onFocus: xe(Nr(Ae, ie)),
        onBlur: xe(Nr(be, re)),
        onClick: se(Nr(je, K)),
        onDragEnter: ke(Nr(Oe, Y)),
        onDragOver: ke(Nr(Ve, Q)),
        onDragLeave: ke(Nr(_e, V)),
        onDrop: ke(Nr(Re, Z)),
        role: typeof ne == "string" && ne !== "" ? ne : "presentation"
      }, J, T), !r && !g ? {
        tabIndex: 0
      } : {}), Le);
    };
  }, [T, ee, ie, re, K, Y, Q, V, Z, g, A, r]), de = ot(function(te) {
    te.stopPropagation();
  }, []), ce = Ce(function() {
    return function() {
      var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, oe = te.refKey, J = oe === void 0 ? "ref" : oe, ne = te.onChange, ye = te.onClick, Ae = Jc(te, FT), be = Th({
        accept: R,
        multiple: s,
        type: "file",
        style: {
          display: "none"
        },
        onChange: se(Nr(ne, Z)),
        onClick: se(Nr(ye, de)),
        tabIndex: -1
      }, J, D);
      return Rt(Rt({}, be), Ae);
    };
  }, [D, n, s, Z, r]);
  return Rt(Rt({}, W), {}, {
    isFocused: S && !r,
    getRootProps: fe,
    getInputProps: ce,
    rootRef: T,
    inputRef: D,
    open: se(H)
  });
}
function QT(e, t) {
  switch (t.type) {
    case "focus":
      return Rt(Rt({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Rt(Rt({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Rt(Rt({}, Mh), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Rt(Rt({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Rt(Rt({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Rt(Rt({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return Rt({}, Mh);
    default:
      return e;
  }
}
function ly() {
}
const qT = ae.div`
  margin: 16px;
  background: #fff;
  border: 1.5px dashed ${({ theme: e }) => e.palette.info.main + 60};
  border-radius: 2px;
  display: flex;
  color: ${({ theme: e }) => e.palette.grey[800]};
  align-items: center;
  justify-content: center;
  height: 150px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
`;
ae.div`
  text-align: center;
  color: #8f8f8f;
  font-size: 12px;
  font-style: italic;
  margin-top: 0.5rem;
`;
const XT = ae.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-weight: 400;
`, JT = ae(pC)`
  height: 12px;
  border-radius: 2px;
  margin: 10px 0;
`, KT = ae.span`
  font-weight: bold;
`, ZT = (e) => {
  const { fileName: t, progress: n, fileNumber: r, amountFiles: i } = e;
  return /* @__PURE__ */ F(XT, { children: [
    /* @__PURE__ */ F("div", { children: [
      "Uploading file ",
      r,
      " of ",
      i,
      ":",
      " ",
      /* @__PURE__ */ p(KT, { children: t })
    ] }),
    /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(JT, { progress: n }) }),
    /* @__PURE__ */ F("div", { children: [
      n,
      " %"
    ] })
  ] });
};
function eM(e) {
  if (e)
    return e.reduce((t, n) => (t[n] = [], t), {});
}
const FH = (e) => {
  const {
    onDrop: t,
    onDropReject: n = () => {
    },
    acceptExt: r,
    freeUpload: i,
    textAvailableExt: a,
    maxSize: o = 50 * 1024 * 1024,
    placeholder: s = "filePlaceholder",
    uploadText: c
  } = e, [l, u] = Te(null), [d, f] = Te(null), h = async (k, g) => new Promise((A, b) => {
    const x = new FileReader();
    x.readAsArrayBuffer(k), x.onprogress = (_) => {
      if (_.lengthComputable) {
        const R = Math.round(_.loaded / _.total * 100);
        u({ ...g, progress: R });
      }
    }, x.onload = (_) => {
      u(null), A(_);
    }, x.onerror = (_) => {
      u(null), b(_);
    };
  }), m = ot(async (k) => {
    f(k.length);
    for (let [g, A] of k.entries()) {
      const b = {
        fileName: A.name,
        progress: 0,
        fileNumber: g + 1
      };
      u(b), await h(A, b);
    }
    f(null), setTimeout(() => {
      t == null || t(k);
    }, 100);
  }, []), y = ot((k) => {
    n == null || n(k);
  }, []), { getRootProps: v, getInputProps: w, isDragActive: I, isDragReject: M } = Tx({
    onDrop: m,
    onDropRejected: y,
    accept: eM(
      i ? null : r || [
        "text/plain",
        "text/csv",
        "application/json",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ]
    ),
    maxSize: o
  });
  return /* @__PURE__ */ F(qT, { ...v(), className: "dropzone", children: [
    /* @__PURE__ */ p("input", { ...w() }),
    I ? /* @__PURE__ */ p("p", { children: "Drop the files here ..." }) : l ? /* @__PURE__ */ p(
      ZT,
      {
        fileName: l.fileName,
        progress: l.progress,
        fileNumber: l.fileNumber,
        amountFiles: d
      }
    ) : /* @__PURE__ */ F("div", { children: [
      s && /* @__PURE__ */ p(we, { width: "100%", textAlign: "center", mb: 2, children: /* @__PURE__ */ p(
        mC,
        {
          name: s,
          sx: { fontSize: 46 }
        }
      ) }),
      /* @__PURE__ */ p(
        le,
        {
          color: "textColor.label",
          fontSize: 14,
          fontWeight: 700,
          textAlign: "center",
          children: c || "Drag 'n' drop some files here, or click to select files"
        }
      ),
      /* @__PURE__ */ F(
        le,
        {
          color: "textColor.label",
          fontSize: 14,
          fontWeight: 400,
          textAlign: "center",
          mt: 0.5,
          children: [
            /* @__PURE__ */ p("b", { children: "Formats: " }),
            a || "TXT, PDF, JSON, CSV, XLS/XLSX, DOC/DOCX, PPT/PPTX"
          ]
        }
      )
    ] })
  ] });
};
ae.div`
  display: flex;
  background-color: #fff;
  flex-direction: column;
  margin-top: 16px;
  position: relative;

  .content-block__title {
    flex-grow: 1;
  }
`;
ae.div`
  display: flex;
  font-weight: bold;
  flex-grow: 1;
`;
const tM = ae.div`
  display: flex;
  background-color: ${({ theme: e }) => e.palette.info.main + 20};
  color: ${({ theme: e }) => e.palette.grey[800]};
  margin-left: 8px;
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 20px;
  min-width: 8px;
  border-radius: 2px;
`;
ae.div`
  display: flex;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  justify-content: space-between;
  margin: 0 16px;
`;
const cy = ae.div`
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  position: relative;
  max-width: 100%;
  align-items: center;
  font-size: 14px;
`;
ae.div`
  min-width: 30px;
`;
const nM = ae.div`
  /* display: flex;
  align-items: center; */
  text-align: center;
  flex-grow: 1;
  color: ${({ theme: e }) => e.palette.grey[400]};
  font-size: 14px;
  padding: 0;
`;
ae.span`
  /* text-decoration: underline; */
  margin-left: -4px;
`;
ae(
  bl
)`
  padding-right: 0px;
  padding-left: 0px;
`;
const rM = ae.span`
  margin-left: 8px;
`, iM = ae.div`
  display: flex;
`, aM = (e) => {
  const {
    items: t = [],
    title: n,
    headerText: r = n,
    itemComponent: i,
    onRemove: a,
    primaryKey: o,
    emptyText: s = "There is no attachment",
    buttonText: c = "Delete all files",
    children: l
  } = e, u = t.length;
  Xr();
  const d = ot(
    (h) => {
      h.stopPropagation(), t.forEach((m) => a(h, m));
    },
    [t]
  ), f = Ce(() => /* @__PURE__ */ F(iM, { children: [
    /* @__PURE__ */ p(rM, { children: r }),
    /* @__PURE__ */ p(
      tM,
      {
        className: "items-cart__count-badge",
        count: u,
        children: u
      }
    )
  ] }), [r, u]);
  return /* @__PURE__ */ F(ze, { children: [
    /* @__PURE__ */ p(
      Mv,
      {
        startIcon: /* @__PURE__ */ p(he, { iconName: "uploadFiles", name: "Upload", fontSize: "small" }),
        title: f,
        children: /* @__PURE__ */ p(
          Ee,
          {
            className: "items-cart__clear-btn",
            size: "small",
            variant: "text",
            onClick: d,
            disabled: !u,
            startIcon: /* @__PURE__ */ p(
              he,
              {
                iconName: "delete",
                name: "Remove all",
                color: u ? "error" : void 0,
                sx: { fontSize: 16 }
              }
            ),
            children: c
          }
        )
      }
    ),
    l,
    u > 0 ? t.map((h, m) => /* @__PURE__ */ F(
      cy,
      {
        className: "cart-item__container",
        children: [
          a && /* @__PURE__ */ p(
            Us,
            {
              className: "cart-item__remove-btn",
              onClick: (y) => a(y, h),
              color: "error",
              children: /* @__PURE__ */ p(
                he,
                {
                  iconName: "delete",
                  name: "Remove",
                  sx: { fontSize: "16px" }
                }
              )
            }
          ),
          i(h)
        ]
      },
      o ? h[o] : m
    )) : /* @__PURE__ */ p(cy, { className: "cart-item__container", children: /* @__PURE__ */ p(nM, { children: s }) })
  ] });
}, YH = Kt(aM);
ae.div`
  display: inline-flex;
  position: relative;
  overflow: hidden;
`;
ae.div``;
const oM = ae.div`
  display: flex;
  position: relative;
  overflow: hidden;
`, sM = ae.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
`, lM = ae.div`
  margin-left: 8px;
      overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  }
    
`, jH = Kt((e) => {
  const {
    file: t,
    onClick: n,
    disableIcon: r = !1,
    iconProps: i = {},
    containerProps: a = {},
    showMetaInfo: o = !1
  } = e, {
    size: s,
    iconName: c,
    className: l = ""
  } = i, { className: u, style: d = {} } = a;
  return Ce(() => (tC(t.name), c || "fileExt"), [t.name, c]), /* @__PURE__ */ p(
    we,
    {
      onClick: n,
      className: yh("file-item__container", u),
      sx: {
        display: "inline-flex",
        position: "relative",
        overflow: "hidden",
        ...d
      },
      children: /* @__PURE__ */ p(oM, { className: "file-item__content", children: /* @__PURE__ */ p(sM, { className: "file-item__label-container", children: /* @__PURE__ */ p(
        lM,
        {
          title: t.name,
          className: "file-item__label-container",
          children: t.name
        }
      ) }) })
    }
  );
}), $H = ae(gt)`
  align-self: center;
`, cM = ae.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: #eff8fd96;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  z-index: 1000;
`, WH = ae.div`
  position: absolute;
  width: calc(100vw);
  height: calc(100vh);
  top: 0;
  right: 0;
  background: #eff8fd96;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  z-index: 1000;
`, cf = ae.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden; /* Чтобы фон не мигал */
  flex-grow: 1;
  min-height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ background: e }) => e ? `url(${e})` : "none"};
    background-size: cover;
    background-position: center;
    opacity: 0;
    transition: opacity 0.8s ease-in-out;
    z-index: 2;
  }

  ${({ background: e }) => e && `
    &::before {
      opacity: 0.5; 
    }
  `}
`, uM = ae.div`
  cursor: ${({ viewMode: e }) => e ? "default" : "pointer"};
  display: inline-flex;
`, UH = ae("div")(({ theme: e }) => ({
  fontSize: 15,
  fontWeight: "bold",
  color: e == null ? void 0 : e.palette.textColor.header
})), HH = ({ isFavorite: e, onClick: t, size: n = 20, viewMode: r = !1 }) => {
  var c;
  const i = Ce(
    () => e ? "Remove from favorites" : "Mark as favorite",
    [e]
  ), a = Xr(), o = "#FCD733", s = (c = a.palette) == null ? void 0 : c.textColor.label;
  return /* @__PURE__ */ p(
    yt,
    {
      text: i,
      arrow: !0,
      color: "primary",
      placement: "bottom",
      disabled: r,
      children: /* @__PURE__ */ p(
        uM,
        {
          onClick: (l) => {
            l.stopPropagation(), t && !r && t();
          },
          viewMode: r,
          children: /* @__PURE__ */ p(
            gC,
            {
              selected: e,
              name: "favorite",
              size: n,
              color: e ? o : s
            }
          )
        }
      )
    }
  );
}, fM = ({
  isPrivate: e,
  onClick: t,
  viewMode: n,
  size: r = 18,
  tooltipText: i
}) => {
  const a = Sr(), { t: o } = Ma(), s = Ce(
    () => n ? void 0 : o(e ? "tooltips.mark_public" : "tooltips.mark_private"),
    [e]
  );
  return /* @__PURE__ */ p(yt, { text: s, arrow: !0, placement: "bottom", children: /* @__PURE__ */ p(
    we,
    {
      className: "access-status",
      onClick: (c) => {
        c.stopPropagation(), !n && t && t();
      },
      sx: {
        cursor: n ? "default" : "pointer",
        display: "inline-flex"
      },
      children: /* @__PURE__ */ p(
        he,
        {
          iconName: e ? "private" : "public",
          sx: { color: a.palette.textColor.label, fontSize: r }
        }
      )
    }
  ) });
}, dM = ae.div`
  color: #fff;
  font-size: 14px;
  div {
    font-weight: 500;
    white-space: nowrap;
  }
  span {
    font-size: 12px;
    display: ${({ hasTenant: e }) => e ? "inline-block" : "none"};
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, hM = ae.div`
  display: flex;
  align-items: center;
  color: #ffffff;
`;
ae.div`
  line-height: 14px;

  svg {
    padding: 0 12px 0 24px;
    cursor: pointer;
    font-size: 18px;
  }
`;
const pM = ae.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`, mM = ae(Iv)`
  width: 32px;
  height: 32px;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0 12px 0 16px;
  & {
    color: #ffffff;
  }
  background-color: ${({ theme: e }) => e.palette.grey[400]};
`, gM = ({ onContextSwitch: e, currentUser: t, currentTenant: n }) => {
  var a;
  const r = Hi(), i = (o) => {
    r(e(o));
  };
  return /* @__PURE__ */ p(yC, { children: (a = t == null ? void 0 : t.tenants) == null ? void 0 : a.map((o, s) => {
    var l;
    const c = o.object.id === n.object.id;
    return /* @__PURE__ */ F(
      mh,
      {
        className: "tenant-" + s,
        sx: (u) => ({
          backgroundColor: c ? u.palette.backgroundColor.main : "inherit",
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          py: 0.5,
          fontWeight: 400
        }),
        onClick: () => !c && i(o.object.id),
        children: [
          /* @__PURE__ */ p(
            O,
            {
              item: !0,
              sx: { fontSize: 14 },
              maxWidth: 300,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              children: (l = o.object) == null ? void 0 : l.title
            }
          ),
          c ? /* @__PURE__ */ p(
            he,
            {
              iconName: "checkmark",
              sx: { width: 16, color: "success.dark", ml: 2 }
            }
          ) : /* @__PURE__ */ p(we, { sx: { width: "32px" } })
        ]
      },
      o.id
    );
  }) });
}, yM = ({
  anchorEl: e,
  open: t,
  onClose: n,
  onContextSwitch: r,
  currentUser: i,
  logout: a,
  showMenu: o
}) => {
  var l;
  const s = Xr(), c = qe.useMemo(
    () => {
      var u;
      return (u = i.tenants) == null ? void 0 : u.find(
        (d) => d.object.id === i.activeTenant
      );
    },
    [i]
  );
  return /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ F(
    AC,
    {
      id: "user-menu",
      anchorEl: e,
      open: t,
      onClose: n,
      MenuListProps: {
        "aria-labelledby": "user-menu-button",
        role: "listbox"
      },
      slotProps: {
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            boxShadow: s.customShadows[1],
            mt: 1.5,
            minWidth: 200,
            ".MuiList-root": {
              py: 0
            }
          }
        }
      },
      transformOrigin: { horizontal: "center", vertical: "top" },
      anchorOrigin: { horizontal: "center", vertical: "bottom" },
      children: [
        ((l = i.tenants) == null ? void 0 : l.length) > 0 && o && [
          /* @__PURE__ */ p(
            mh,
            {
              sx: {
                px: 2,
                py: 1,
                justifyContent: "space-between",
                color: "#56617A",
                fontSize: 14,
                fontWeight: 400,
                pointerEvents: "none"
              },
              className: "context-switch",
              disableRipple: !0,
              children: "Tenant"
            },
            "tenant-label"
          ),
          /* @__PURE__ */ p(
            gM,
            {
              onContextSwitch: r,
              currentUser: i,
              currentTenant: c
            },
            "tenant-list"
          ),
          /* @__PURE__ */ p(xa, { sx: { mx: 1, mt: 1 } }, "divider")
        ],
        /* @__PURE__ */ F(
          mh,
          {
            sx: {
              px: 2,
              py: 1,
              justifyContent: "space-between",
              color: "#56617A",
              fontSize: 13,
              fontWeight: 400
            },
            className: "logout",
            onClick: a,
            children: [
              /* @__PURE__ */ p("div", { children: "Log Out" }),
              /* @__PURE__ */ p(he, { iconName: "logout", sx: { width: 16, color: "secondary.main" } })
            ]
          }
        )
      ]
    }
  ) });
}, GH = ({ onLogout: e, onContextSwitch: t, showMenu: n = !1 }) => {
  var m, y, v, w, I;
  const r = Hi(), i = Ot(
    (M) => M.user.data
  ), [a, o] = qe.useState(null), s = !!a, c = i.firstName && i.lastName ? `${i.firstName} ${i.lastName}` : i.email ? i.email : "", l = ((v = (y = (m = i == null ? void 0 : i.tenants) == null ? void 0 : m.find(
    (M) => {
      var k;
      return ((k = M.object) == null ? void 0 : k.id) === (i == null ? void 0 : i.activeTenant);
    }
  )) == null ? void 0 : y.object) == null ? void 0 : v.title) || "", u = () => {
    y0("RecordCountsDataSource"), r(e());
  }, d = (M) => (y0("RecordCountsDataSource"), t == null ? void 0 : t(M)), f = (M) => {
    o(M.currentTarget);
  }, h = () => {
    o(null);
  };
  return /* @__PURE__ */ F(ze, { children: [
    /* @__PURE__ */ p(hM, { children: /* @__PURE__ */ F(pM, { onClick: f, children: [
      /* @__PURE__ */ p(mM, { children: i.firstName || i.lastName ? (((w = i.firstName) == null ? void 0 : w[0]) || "") + (((I = i.lastName) == null ? void 0 : I[0]) || "") : /* @__PURE__ */ p(he, { iconName: "users", fontSize: "small" }) }),
      /* @__PURE__ */ F(dM, { hasTenant: n, children: [
        /* @__PURE__ */ p("div", { title: c, children: c }),
        /* @__PURE__ */ p("span", { title: l, children: l })
      ] }),
      /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
        we,
        {
          sx: {
            px: 2,
            svg: {
              width: 10,
              height: 5
            },
            transform: s ? "rotate(180deg)" : "rotate(0deg)",
            mt: s ? "2px" : "-2px",
            transition: "transform 200ms"
          },
          children: /* @__PURE__ */ p(he, { iconName: "arrowDown", sx: { color: "white" } })
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p(
      yM,
      {
        onClose: h,
        open: s,
        anchorEl: a,
        onContextSwitch: d,
        currentUser: i,
        logout: u,
        showMenu: n
      }
    )
  ] });
}, AM = ({
  updateNote: e,
  note: t,
  onCancel: n,
  onSubmit: r,
  disabled: i
}) => /* @__PURE__ */ F(
  O,
  {
    item: !0,
    xs: 12,
    container: !0,
    flexWrap: "nowrap",
    spacing: 1,
    className: "invitation-decline-form",
    children: [
      /* @__PURE__ */ p(O, { item: !0, flex: 1, children: /* @__PURE__ */ p(
        xr,
        {
          size: "small",
          value: t,
          multiline: !0,
          placeholder: "Enter message...",
          fullWidth: !0,
          onChange: (a) => e(a.target.value),
          name: "invitation-decline-message",
          disabled: i
        }
      ) }),
      /* @__PURE__ */ F(O, { item: !0, display: "flex", children: [
        /* @__PURE__ */ p(yt, { text: "Submit", children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
          Ee,
          {
            size: "small",
            sx: {
              minWidth: 26,
              height: 30,
              padding: 1,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            },
            variant: "outlined",
            onClick: r,
            name: "invitation-decline-accept",
            disabled: i,
            children: /* @__PURE__ */ p(he, { iconName: "submit", color: "success", sx: { fontSize: 18 } })
          }
        ) }) }),
        /* @__PURE__ */ p(yt, { text: "Cancel", children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
          Ee,
          {
            size: "small",
            sx: {
              minWidth: 26,
              padding: 1,
              height: 30,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              marginLeft: "-1px"
            },
            variant: "outlined",
            color: "primary",
            onClick: n,
            name: "invitation-decline-cancel",
            disabled: i,
            children: /* @__PURE__ */ p(he, { iconName: "deactivate", color: "error", sx: { fontSize: 18 } })
          }
        ) }) })
      ] })
    ]
  }
), vM = ae(O)`
  button {
    /* height: 22px; */
  }
  button:first-of-type {
    margin-right: 6px;
  }
`, xM = [
  It.LIBRARY_COHORT,
  It.LIBRARY_CONCEPT_SET,
  It.LIBRARY_CUSTOM_CODE,
  It.LIBRARY_FEATURE_ANALYSIS
], bM = [
  We.LIBRARY_COHORT,
  We.LIBRARY_CONCEPT_SET,
  We.LIBRARY_FEATURE_ANALYSIS
];
function zn({
  item: e,
  invitationId: t,
  invitationType: n,
  affinity: r
}) {
  const i = function() {
    if (!e.type) return "#";
    const a = bM.includes(e.type) || (n ? xM.includes(n) : !1);
    switch (e.type) {
      case We.ADMIN:
      case We.PARTICIPANT:
      case We.SUBMISSION:
      case We.USER:
        return "#";
      case We.ANALYSIS: {
        if (r) {
          const [o] = r;
          let s = `/${io[o.type]}`;
          return o.type === We.STUDY && (s += `/${o == null ? void 0 : o.id}`), s += `/${io[We.ANALYSIS]}/${e.id}`, n === It.SUBMISSION_PUBLISHING && (s += "/executions"), s;
        }
        return "#";
      }
      default:
        return `/${io[e.type]}` + (e.id ? `/${e.id}` : "") + (a ? `?from=LIBRARY&typePublish=INCOMING&id=${t}` : "");
    }
  }();
  switch (e.type) {
    case We.ADMIN:
    case We.PARTICIPANT:
    case We.SUBMISSION:
    case We.USER:
      return /* @__PURE__ */ p(
        le,
        {
          color: "primary",
          component: "span",
          fontWeight: 500,
          fontSize: 14,
          children: e.name
        },
        t + e.type + e.id
      );
    case We.ANALYSIS:
      return status === ve.IN_PROGRESS ? /* @__PURE__ */ p(
        le,
        {
          color: "primary",
          component: "span",
          fontWeight: 500,
          fontSize: 14,
          children: e.name
        },
        t + e.type + e.id
      ) : /* @__PURE__ */ p(Kc, { to: i, children: e.name }, t + e.type + e.id);
    default:
      return /* @__PURE__ */ p(Kc, { to: i, children: e.name }, t + e.type + e.id);
  }
}
const wM = ({
  invitation: e,
  onInvitationAccept: t,
  onInvitationDecline: n
}) => {
  const [r, i] = Te(""), [a, o] = Te(!1), [s, c] = Te(!1), [l, u] = Te(!1), d = Ce(() => {
    const { author: y, subject: v, activity: w, analysis: I, affinity: M } = e, k = I || v, g = [];
    switch (y && e.type !== It.SUBMISSION_PUBLISHING && g.push(
      /* @__PURE__ */ p(zn, { item: y, invitationId: e.id })
    ), e.type) {
      case It.STUDY_DATASOURCE:
        g.push(
          " has invited your data source ",
          /* @__PURE__ */ p(zn, { item: v, invitationId: e.id }),
          " to study ",
          /* @__PURE__ */ p(zn, { item: w, invitationId: e.id })
        );
        break;
      case It.STUDY_PARTICIPANT:
        g.push(
          " has invited you to join study ",
          /* @__PURE__ */ p(zn, { item: w, invitationId: e.id })
        );
        break;
      case It.WORKSPACE_DATASOURCE:
        g.push(
          " has invited your data source ",
          /* @__PURE__ */ p(zn, { item: v, invitationId: e.id }),
          " to workspace "
        );
        break;
      case It.LIBRARY_COHORT:
        g.push(
          " has requested to publish cohort ",
          /* @__PURE__ */ p(
            zn,
            {
              item: v,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case It.LIBRARY_FEATURE_ANALYSIS:
        g.push(
          " has requested to publish feature analysis ",
          /* @__PURE__ */ p(
            zn,
            {
              item: {
                ...k,
                type: We.LIBRARY_FEATURE_ANALYSIS
              },
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case It.LIBRARY_CUSTOM_CODE:
        g.push(
          " has requested to publish custom code ",
          /* @__PURE__ */ p(
            zn,
            {
              item: v,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case It.LIBRARY_CONCEPT_SET:
        g.push(
          " has requested to publish concept set ",
          /* @__PURE__ */ p(
            zn,
            {
              item: v,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " to library "
        );
        break;
      case It.SUBMISSION_EXECUTION:
        g.push(
          " requested to execute an ",
          /* @__PURE__ */ p(
            zn,
            {
              item: { ...I, type: We.ANALYSIS },
              affinity: M,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " on ",
          /* @__PURE__ */ p(
            zn,
            {
              item: { ...v, type: We.DATASOURCE },
              invitationId: e.id
            }
          )
        );
        break;
      case It.SUBMISSION_PUBLISHING:
        g.push(
          " The results of ",
          /* @__PURE__ */ p(
            zn,
            {
              item: { ...I, type: We.ANALYSIS },
              affinity: M,
              invitationId: e.id,
              invitationType: e.type
            }
          ),
          " on ",
          /* @__PURE__ */ p(
            zn,
            {
              item: { ...v, type: We.DATASOURCE },
              invitationId: e.id
            }
          ),
          " are available to review and approval to publish "
        );
        break;
    }
    return g;
  }, [e]), f = qe.useMemo(() => {
    switch (e.type) {
      case It.STUDY_DATASOURCE:
        return {
          accept: `/studies/datasource/invites/${e.id}/accept`,
          decline: `/studies/datasource/invites/${e.id}/dismiss`
        };
      case It.STUDY_PARTICIPANT:
        return {
          accept: `/studies/invites/${e.id}/accept`,
          decline: `/studies/invites/${e.id}/dismiss`
        };
      case It.WORKSPACE_DATASOURCE:
        return {
          accept: `/workspace/datasource/invites/${e.id}/accept`,
          decline: `/workspace/datasource/invites/${e.id}/dismiss`
        };
      case It.LIBRARY_COHORT:
        return {
          accept: `/library/cohort/invites/${e.id}/accept`,
          decline: `/library/cohort/invites/${e.id}/dismiss`
        };
      case It.LIBRARY_FEATURE_ANALYSIS:
        return {
          accept: `/library/feature-analyses/invites/${e.id}/accept`,
          decline: `/library/feature-analyses/invites/${e.id}/dismiss`
        };
      case It.LIBRARY_CONCEPT_SET:
        return {
          accept: `/library/concept-set/invites/${e.id}/accept`,
          decline: `/library/concept-set/invites/${e.id}/dismiss`
        };
      case It.SUBMISSION_EXECUTION:
        return {
          accept: `/submissions/${e.id}/approve`,
          decline: `/submissions/${e.id}/dismiss`
        };
      case It.LIBRARY_CUSTOM_CODE:
        return {
          accept: `/library/custom-code/invites/${e.id}/accept`,
          decline: `/library/custom-code/invites/${e.id}/dismiss`
        };
      case It.SUBMISSION_PUBLISHING:
        return {
          accept: `/submissions/${e.id}/approve-publishing`,
          decline: `/submissions/${e.id}/dismiss-publishing`
        };
    }
  }, [e]), h = () => {
    o(!0), t(f.accept);
  }, m = () => {
    u(!0);
  };
  return /* @__PURE__ */ p(
    O,
    {
      container: !0,
      item: !0,
      xs: 12,
      px: 2,
      py: 1,
      className: "list-item",
      sx: {
        "&:hover": {
          bgcolor: "backgroundColor.dark"
        }
      },
      children: /* @__PURE__ */ p(Nv, { onClickAway: () => u(!1), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ F(Nx, { container: !0, className: "invitations-list-item ", children: [
        /* @__PURE__ */ F(O, { item: !0, zeroMinWidth: !0, xs: 12, mb: 1, children: [
          d,
          e.message ? ` with message: "${e.message}"` : ""
        ] }),
        /* @__PURE__ */ F(
          O,
          {
            item: !0,
            xs: 12,
            container: !0,
            spacing: 1,
            justifyContent: "space-between",
            alignItems: "center",
            mb: l ? 1 : 0,
            children: [
              /* @__PURE__ */ F(vM, { item: !0, children: [
                /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "contained",
                    color: "success",
                    onClick: h,
                    disabled: a || s || l,
                    name: "accept-invitation",
                    startIcon: a ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "submit" }),
                    children: "Accept"
                  }
                ),
                /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "outlined",
                    onClick: m,
                    disabled: a || s || l,
                    name: "decline-invitation",
                    startIcon: s ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "deactivate" }),
                    children: "Reject"
                  }
                )
              ] }),
              /* @__PURE__ */ p(Ox, { item: !0, children: bv(e.timestamp) })
            ]
          }
        ),
        l && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
          AM,
          {
            note: r,
            updateNote: i,
            onCancel: () => u(!1),
            disabled: a || s,
            onSubmit: () => {
              c(!0), n(r, f.decline);
            }
          }
        ) })
      ] }) }) })
    }
  );
}, _M = ({
  showMore: e,
  invitations: t,
  size: n,
  onInvitationAccept: r,
  onInvitationDecline: i
}) => /* @__PURE__ */ F(Rx, { container: !0, width: 500, className: "invitations-list-content", children: [
  t.slice(0, n).map((a) => /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
    wM,
    {
      invitation: a,
      onInvitationAccept: r,
      onInvitationDecline: i
    }
  ) }, a.id)),
  n < (t == null ? void 0 : t.length) && /* @__PURE__ */ p(O, { item: !0, xs: 12, textAlign: "right", px: 2, py: 1, children: /* @__PURE__ */ p(Ee, { onClick: e, size: "small", variant: "text", children: "Show more" }) })
] }), am = ae.div``, Mx = ae(O)`
  padding: 8px 8px 8px 16px;
  height: 42px;
  display: flex;
  background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  color: ${({ theme: e }) => e.palette.primary.main};
  font-size: 14px;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  font-weight: bold;
`, Ix = ae(O)`
  padding: 16px;
  color: ${({ theme: e }) => e.palette.grey[500]};
  font-size: 13px;
  width: 450px;
  line-height: 30px;
  height: 66px;
`, om = ae(
  Up(({ text: e, ...t }, n) => /* @__PURE__ */ p(Ee, { ...t, ref: n, variant: "text", sx: { p: 0 }, children: /* @__PURE__ */ p(
    le,
    {
      className: "button-text",
      component: "span",
      color: "inherit",
      fontSize: "inherit",
      children: e
    }
  ) })),
  {
    shouldForwardProp: (e) => e !== "hasNotifications" && e !== "count"
  }
)(({ theme: e, hasNotifications: t, count: n }) => `
  min-width: 50px;
  @media (min-width: 1000px) {
    min-width: 70px;
  }
  cursor: pointer;
  position: relative;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  cursor: pointer;
  border-radius: 6px;
  color: #ffffff;
  :hover {
    svg {
      * {
        color: #A0A8BA;
      }
    }
  }
  .start-icon {
    position: relative;
    margin: 0;
    margin-bottom: 4px;
    svg {
      font-size: 20px;
      font-weight: 500;
      width: 20px;
      height: 20px;
      * {
        color: #A0A8BA;
      }
    }
  }
  .button-text {
    font-size: 12px;
    line-height: 12px;
    width: 100%;

  }
  @media (max-width: 1000px) {
    .button-text {
      display: none;
    }
    .start-icon {
      margin-bottom:0
    }
  }
  &.Mui-disabled {
    color: #91a1b3;
    .MuiSvgIcon-root {
      fill: #7a8ea4;
    }
  }
`), Nx = ae(O)`
  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  border-radius: 2px;
  color: #424242;
`, Kc = ae(jC)`
  color: ${({ theme: e }) => e.palette.primary.main};
  font-weight: 400;
  text-decoration: underline;
`, Ox = ae(O)`
  color: ${({ theme: e }) => e.palette.grey[500]};
  font-size: 12px;
`, Rx = ae(O)`
  > div:not(:last-child) {
    .list-item {
      border-bottom: 1px solid #45a8ff1c;
    }
    /* padding: 4px; */
  }
  .list-item {
    padding-bottom: 8px;
    &.active {
      background-color: #45a8ff14;
      border-bottom: 1px solid #3d9cf025;
    }
    &:hover {
      background-color: #45a8ff29;
    }
  }
`, VH = ({
  getList: e,
  accept: t,
  decline: n,
  getCount: r
}) => {
  var x;
  const i = Hi(), a = Xr(), o = Yn(0.7, (x = a == null ? void 0 : a.palette) == null ? void 0 : x.primary.main), s = () => i(e()), c = () => i(r()), l = (_) => i(t(_)), u = (_, R) => i(n(_, R)), d = Ot(
    (_) => _.invitations.invitations
  ), f = Ot((_) => _.invitations.status), h = Ot((_) => _.invitations.count), m = 5, [y, v] = qe.useState(null), [w, I] = qe.useState(m), M = !!y, k = (_) => {
    v(_.currentTarget), s();
  }, g = () => {
    v(null), c();
  }, A = async (_) => {
    l(_);
  }, b = (_, R) => {
    u(_, R);
  };
  return qe.useEffect(() => (c(), () => {
  }), [c]), Fv(() => {
    f !== ve.INITIAL && f !== ve.IN_PROGRESS && f !== ve.IN_PROGRESS_RELOAD && c();
  }, 15e3), /* @__PURE__ */ F(am, { children: [
    /* @__PURE__ */ p(yt, { text: "Invitations", children: /* @__PURE__ */ p(
      om,
      {
        onClick: k,
        hasNotifications: h > 0,
        count: h,
        startIcon: /* @__PURE__ */ p(
          qp,
          {
            badgeContent: h,
            color: "error",
            sx: {
              "& .MuiBadge-badge": {
                padding: "2px 4px",
                fontSize: 10,
                height: 14
              }
            },
            max: 999,
            children: /* @__PURE__ */ p(he, { iconName: "invitation" })
          }
        ),
        text: "Invitations"
      }
    ) }),
    /* @__PURE__ */ p(
      Rv,
      {
        id: "popover",
        anchorEl: y,
        open: M,
        onClose: g,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        sx: { ".MuiPaper-root": { mr: 3 } },
        children: /* @__PURE__ */ F(Ov, { className: "invitations-list", children: [
          /* @__PURE__ */ F(
            Mx,
            {
              container: !0,
              alignItems: "center",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ F(O, { item: !0, alignItems: "center", display: "flex", children: [
                  /* @__PURE__ */ p(
                    he,
                    {
                      iconName: "invitation",
                      color: "primary",
                      sx: { fontSize: 16, color: o, pr: 1.5 }
                    }
                  ),
                  /* @__PURE__ */ p("div", { children: "Invitations" })
                ] }),
                /* @__PURE__ */ p(
                  Ee,
                  {
                    sx: { minWidth: 30, p: 0 },
                    onClick: s,
                    className: "reload",
                    children: f === ve.IN_PROGRESS || f === ve.IN_PROGRESS_RELOAD ? /* @__PURE__ */ p(gt, { size: 14, color: "secondary" }) : /* @__PURE__ */ p(he, { iconName: "reload", sx: { fontSize: 16, color: o } })
                  }
                )
              ]
            }
          ),
          f === ve.IN_PROGRESS ? /* @__PURE__ */ p(we, { textAlign: "center", py: 2, width: 494, children: /* @__PURE__ */ p(gt, { size: 30, color: "secondary" }) }) : h > 0 ? /* @__PURE__ */ p(
            _M,
            {
              invitations: d,
              size: w,
              showMore: () => I((_) => _ += m),
              onInvitationAccept: A,
              onInvitationDecline: b
            }
          ) : /* @__PURE__ */ p(Ix, { item: !0, p: 2, children: "No invitations..." })
        ] })
      }
    )
  ] });
}, SM = (e, t, n) => !e || !(e != null && e.length) ? "" : e.map((r) => CM(r, t, n)), CM = (e, t, n) => {
  if (typeof e == "string")
    return e;
  if (e.analysis) {
    const [[r, i]] = Object.entries(e.analysis);
    let a = io[We.ANALYSIS];
    if (e.study) {
      const [o] = Object.keys(e.study);
      a = `${io[We.STUDY]}/${o}/` + a;
    } else
      a = "workspace/" + a;
    return /* @__PURE__ */ p("span", { onClick: n, children: /* @__PURE__ */ p(Kc, { to: `/${a}/${r}`, children: i }, t + r) }, "analysis-" + r);
  } else {
    const [[r, i]] = Object.entries(e), [[a, o]] = Object.entries(i), s = io[r];
    return r === We.USER || r === We.BUNDLE || r === We.TENANT || r === We.STUDY_TYPE || r === We.SUBMISSION || r === We.DATA_NODE ? /* @__PURE__ */ p(
      le,
      {
        color: "primary",
        component: "span",
        fontWeight: 500,
        fontSize: 14,
        children: o
      },
      r + a
    ) : /* @__PURE__ */ p("span", { onClick: n, children: /* @__PURE__ */ p(Kc, { to: `/${s}/${a}`, children: o }, t + a) }, r + a);
  }
}, EM = Kt(
  ({ notification: e, onRead: t }) => {
    const n = e.read ? void 0 : () => t([e.id]);
    return /* @__PURE__ */ p(
      O,
      {
        container: !0,
        item: !0,
        xs: 12,
        px: 2,
        py: 1,
        className: "list-item " + (e.read ? "" : "active"),
        children: /* @__PURE__ */ F(Nx, { container: !0, children: [
          /* @__PURE__ */ p(O, { item: !0, zeroMinWidth: !0, children: SM(e.message, e.id, n) }),
          /* @__PURE__ */ F(
            Ox,
            {
              item: !0,
              xs: 12,
              textAlign: "right",
              display: "flex",
              justifyContent: "space-between",
              mt: 1,
              children: [
                /* @__PURE__ */ p(we, { children: bv(e.timestamp) }),
                /* @__PURE__ */ p("div", { children: !e.read && /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "text",
                    onClick: n,
                    size: "small",
                    sx: (r) => ({
                      ml: -0.5,
                      fontWeight: "normal",
                      color: r.palette.grey[600]
                    }),
                    startIcon: /* @__PURE__ */ p(he, { iconName: "submit", sx: { fontSize: 12 } }),
                    children: "Mark as read"
                  }
                ) })
              ]
            }
          )
        ] })
      }
    );
  }
), kM = ({
  notifications: e,
  size: t,
  totalElements: n,
  showMore: r,
  onRead: i,
  status: a
}) => /* @__PURE__ */ F(Rx, { container: !0, width: 450, className: "notifications-list-content", children: [
  e.map((o) => /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(EM, { notification: o, onRead: i }) }, o.id)),
  a === ve.IN_PROGRESS_RELOAD && /* @__PURE__ */ p(we, { textAlign: "center", py: 2, width: 394, children: /* @__PURE__ */ p(gt, { size: 30, color: "secondary" }) }),
  t < n && /* @__PURE__ */ p(
    O,
    {
      item: !0,
      xs: 12,
      textAlign: "right",
      px: 2,
      py: 1,
      position: "sticky",
      bottom: 0,
      bgcolor: "white",
      children: /* @__PURE__ */ p(Ee, { onClick: r, size: "small", variant: "text", children: "Show more" })
    }
  )
] }), QH = ({
  getNotifications: e,
  getNotificationsUnread: t,
  updateNotifications: n
}) => {
  var C;
  const r = Hi(), i = Xr(), a = Yn(0.7, (C = i.palette) == null ? void 0 : C.primary.main), o = Ot(
    (T) => T.notifications.notifications
  ), s = Ot((T) => T.notifications.status), c = Ot(
    (T) => T.notifications.unreadStatus
  ), l = Ot(
    (T) => T.notifications.unreadNotificationsIds
  ), u = Ot(
    (T) => T.notifications.count
  ), d = Ot(
    (T) => T.notifications.totalElements
  ), f = 5, [h, m] = qe.useState(null), [y, v] = qe.useState(f), [w, I] = Te("All"), M = () => {
    c !== ve.IN_PROGRESS && c !== ve.IN_PROGRESS_RELOAD && r(t());
  }, k = () => {
    r(
      e({
        size: y,
        ...w === "Unread" ? { read: !1 } : {}
      })
    );
  }, g = () => {
    M(), k();
  }, A = (T) => r(n(T)), b = () => {
    u && r(n(l));
  }, x = !!h, _ = (T) => {
    m(T.currentTarget), k();
  }, R = async (T) => {
    A(T);
  }, P = () => {
    m(null);
  };
  qe.useEffect(() => (M(), () => {
  }), []), Fv(() => {
    c !== ve.INITIAL && M();
  }, 15e3), tt(() => {
    s !== ve.INITIAL && s !== ve.IN_PROGRESS && s !== ve.IN_PROGRESS_RELOAD && k();
  }, [y]), tt(() => {
    s !== ve.INITIAL && s !== ve.IN_PROGRESS && s !== ve.IN_PROGRESS_RELOAD && k();
  }, [w]);
  const E = w === "All" ? (o == null ? void 0 : o.length) > 0 : u > 0;
  return /* @__PURE__ */ F(am, { children: [
    /* @__PURE__ */ p(yt, { text: "Notifications", children: /* @__PURE__ */ p(
      om,
      {
        onClick: _,
        hasNotifications: u > 0,
        count: u,
        disableRipple: !0,
        startIcon: /* @__PURE__ */ p(
          qp,
          {
            badgeContent: u,
            color: "error",
            sx: {
              "& .MuiBadge-badge": {
                padding: "2px 4px",
                fontSize: 10,
                height: 14
              }
            },
            max: 999,
            children: /* @__PURE__ */ p(he, { iconName: "notification" })
          }
        ),
        name: "notifications",
        text: "Notifications"
      }
    ) }),
    /* @__PURE__ */ p(
      Rv,
      {
        id: "popover",
        anchorEl: h,
        open: x,
        onClose: P,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        sx: { ".MuiPaper-root": { mr: 2 } },
        children: /* @__PURE__ */ F(Ov, { children: [
          /* @__PURE__ */ F(we, { position: "sticky", top: 0, bgcolor: "white", zIndex: 2, children: [
            /* @__PURE__ */ F(
              Mx,
              {
                container: !0,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ F(O, { item: !0, alignItems: "center", display: "flex", children: [
                    /* @__PURE__ */ p(
                      he,
                      {
                        iconName: "notification",
                        color: "primary",
                        sx: {
                          fontSize: 16,
                          color: a,
                          pr: 1.5
                        }
                      }
                    ),
                    /* @__PURE__ */ p("div", { children: "Notifications" })
                  ] }),
                  /* @__PURE__ */ p(Ee, { sx: { minWidth: 30, p: 0 }, onClick: g, children: s === ve.IN_PROGRESS || s === ve.IN_PROGRESS_RELOAD ? /* @__PURE__ */ p(gt, { size: 14, color: "secondary" }) : /* @__PURE__ */ p(
                    he,
                    {
                      iconName: "reload",
                      sx: {
                        fontSize: 16,
                        color: a
                      }
                    }
                  ) })
                ]
              }
            ),
            /* @__PURE__ */ F(we, { display: "flex", px: 1.5, py: 1, justifyContent: "space-between", children: [
              /* @__PURE__ */ p(we, { display: "flex", children: ["All", "Unread"].map((T) => /* @__PURE__ */ p(
                Ee,
                {
                  size: "small",
                  sx: {
                    mr: 1,
                    minWidth: "auto",
                    borderRadius: 0.5,
                    px: 1,
                    ...w === T ? {
                      bgcolor: "backgroundColor.dark"
                    } : {}
                  },
                  onClick: () => I(T),
                  children: T
                },
                T
              )) }),
              /* @__PURE__ */ p(
                Ee,
                {
                  onClick: b,
                  variant: "text",
                  color: "info",
                  size: "small",
                  disabled: !u,
                  children: "Mark all as read"
                }
              )
            ] })
          ] }),
          s === ve.IN_PROGRESS ? /* @__PURE__ */ p(we, { textAlign: "center", py: 2, width: 450, children: /* @__PURE__ */ p(gt, { size: 30, color: "secondary" }) }) : E ? /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
            kM,
            {
              notifications: o,
              totalElements: d,
              size: y,
              showMore: () => v((T) => T + f),
              onRead: R,
              status: s
            }
          ) }) : /* @__PURE__ */ p(Ix, { item: !0, p: 2, children: "No notifications..." })
        ] })
      }
    )
  ] });
}, io = {
  [We.STUDY]: "study-manager",
  [We.USER]: "user",
  [We.PARTICIPANT]: "user",
  [We.DATASET]: "data-catalog",
  [We.DATASOURCE]: "data-catalog",
  [We.WORKSPACE]: "workspace",
  [We.ADMIN]: "admin",
  [We.LIBRARY]: "library",
  [We.COHORT]: "cohort",
  [We.CONCEPT_SET]: "concept_set",
  [We.LIBRARY_CONCEPT_SET]: "library/concept-sets",
  [We.CUSTOM_CODE]: "library/custom-code",
  [We.CUSTOMCODE]: "library/custom-code",
  [We.LIBRARY_COHORT]: "library/cohorts",
  [We.LIBRARY_FEATURE_ANALYSIS]: "library/custom-features/publish-requests",
  [We.ANALYSIS]: "analyses",
  [We.SUBMISSION]: "",
  [We.BUNDLE]: "",
  [We.TENANT]: "",
  [We.STUDY_TYPE]: "",
  [We.DATA_NODE]: ""
}, TM = {
  CONCEPT_CLASS_ID: "Class",
  CONCEPT_CODE: "Code",
  CONCEPT_ID: "ID",
  CONCEPT_NAME: "Name",
  DOMAIN_ID: "Domain",
  DISTANCE: "Distance",
  INVALID_REASON: "Invalid reason",
  INVALID_REASON_CAPTION: "Invalid reason",
  STANDARD_CONCEPT: "Standard concept",
  STANDARD_CONCEPT_CAPTION: "Standard concept (caption)",
  VOCABULARY_ID: "Vocabulary",
  RECORD_COUNT: "Record count",
  DESCENDANT_RECORD_COUNT: "Descendant record count",
  PERSON_COUNT: "Person count",
  DESCENDANT_PERSON_COUNT: "Descendant person count"
};
function MM(e, t) {
  const n = Object.values(t).map((r) => r == null ? void 0 : r[e]);
  return new Set(n).size > 1;
}
function IM(e, t = !1) {
  const n = {}, r = [];
  return e.forEach((a) => {
    const o = a.id + a.versionId;
    Object.values(a.items || {}).forEach((s) => {
      const c = s.conceptId;
      n[c] || (n[c] = {}), n[c][o] = s;
    }), r.push(o);
  }), Object.entries(n).map(([a, o]) => {
    var u;
    const s = [
      "excluded",
      "mapped",
      "descendants",
      "hierarchy"
    ], c = Object.fromEntries(
      s.map((d) => [d, MM(d, o)])
    );
    Object.values(c).some(Boolean);
    const l = {};
    for (const d of r) {
      const f = o[d], h = !f, m = Object.fromEntries(
        s.map((y) => {
          const v = c[y] && Object.values(o).some(
            (w) => (w == null ? void 0 : w[y]) !== (f == null ? void 0 : f[y])
          );
          return [y, v];
        })
      );
      l[d] = {
        ...f ?? {},
        _diff: m,
        _missing: h,
        _entireConceptMissing: h
      };
    }
    return {
      conceptId: Number(a),
      concept: ((u = Object.values(o)[0]) == null ? void 0 : u.concept) ?? {},
      perSetData: l,
      differences: c,
      hasDiff: Object.values(l).some((d) => {
        let f = { ...Object.values(l)[0] }, h = { ...d };
        return delete f.id, delete h.id, delete f.concept, delete h.concept, !Ys(f, h);
      })
    };
  }).filter((a) => t ? a == null ? void 0 : a.hasDiff : a);
}
const NM = [
  {
    attribute: "Container",
    source: "conceptSetIds",
    getValue: (e, t) => e[t].typeContainer ?? "N/A"
  },
  {
    attribute: "Version ordinal",
    source: "conceptSets",
    getValue: (e, t) => {
      var n, r;
      return ((n = e[t]) == null ? void 0 : n.ordinal) ?? ((r = e[t].modified) == null ? void 0 : r.ordinal);
    }
  },
  {
    attribute: "Modified date",
    source: "conceptSets",
    getValue: (e, t) => {
      var n, r;
      return (n = e[t].modified) != null && n.timestamp ? Vn((r = e[t].modified) == null ? void 0 : r.timestamp) : "-";
    }
  },
  {
    attribute: "Is latest version",
    source: "conceptSets",
    getValue: (e, t) => {
      const n = e[t];
      return n.versionId === n.latest ? "Yes" : "No";
    }
  },
  {
    attribute: "Expression items",
    source: "conceptSets",
    getValue: (e, t) => Object.keys(e[t].items || {}).length
  },
  {
    attribute: "Included concepts",
    source: "includedConceptsCounts",
    getValue: (e, t) => e[t] ?? 0
  },
  {
    attribute: "Included source codes",
    source: "includedSourceCodesCounts",
    getValue: (e, t) => e[t] ?? 0
  },
  {
    attribute: "Metadata",
    source: "metadataCounts",
    getValue: (e, t) => e[t] ?? 0
  }
];
function Dx(e, t) {
  return JSON.stringify(e) === JSON.stringify(t);
}
function OM(e, t = [], n = [], r = [], i = !1, a) {
  if (!e.length) return [];
  const o = {
    conceptSets: e,
    includedConceptsCounts: t,
    includedSourceCodesCounts: n,
    metadataCounts: r,
    conceptSetIds: a
  }, s = [];
  for (const c of NM) {
    const l = o[c.source], u = e.map(
      (m, y) => c.getValue(l, y)
    ), d = u[0], f = u.some((m) => !Dx(m, d));
    if (i && !f)
      continue;
    const h = {
      attribute: c.attribute,
      hasDiff: f
      // in this case we only count of whole row has diff
    };
    e.forEach((m, y) => {
      const v = `${m.id}${m.versionId}`, w = u[y];
      h[v] = { value: w, hasDiff: f };
    }), s.push(h);
  }
  return console.log(s), s;
}
function RM(e, t, n = !1) {
  const r = [], i = /* @__PURE__ */ new Set(), a = [];
  e.forEach((o, s) => {
    var c;
    a[s] = 0;
    for (const l of o.content || []) {
      const u = ((c = l.attribute) == null ? void 0 : c.name) ?? "";
      u.startsWith("ai-") || (i.add(u), a[s]++);
    }
  });
  for (const o of i) {
    const s = e.map((d, f) => {
      var v, w;
      const h = (d.content || []).filter(
        (I) => {
          var M;
          return ((M = I.attribute) == null ? void 0 : M.name) === o;
        }
      );
      if (h.length === 0) return;
      if (((v = h[0].attribute) == null ? void 0 : v.type) === "ENUM_MULTI")
        return h.map((I) => {
          var M;
          return (M = I.attributeOption) == null ? void 0 : M.value;
        }).sort().join(", ");
      const y = h[0];
      return ((w = y.attributeOption) == null ? void 0 : w.value) || y.value || "—";
    }), c = s[0], l = s.some((d) => !Dx(d, c));
    if (n && !l) continue;
    const u = { attribute: o, hasDiff: l };
    t.forEach((d, f) => {
      u[d.id + d.versionId] = {
        value: s[f],
        hasDiff: l,
        isMissing: s[f] == null
      };
    }), r.push(u);
  }
  return { rows: r, counts: a };
}
function uy(e, t, n = !1) {
  const r = {};
  e.forEach((o, s) => {
    var u;
    const c = o.id + o.versionId;
    (((u = t == null ? void 0 : t[s]) == null ? void 0 : u.content) || []).forEach((d) => {
      const f = d.CONCEPT_ID;
      r[f] || (r[f] = {}), r[f][c] = d;
    });
  });
  const i = e.map((o) => o.id + o.versionId);
  return Object.entries(r).map(([o, s]) => {
    const c = Number(o), l = i.map(
      (f) => !!s[f]
    ), u = new Set(l).size > 1;
    if (n && !u) return null;
    const d = {};
    for (const f of i)
      d[f] = {
        present: !!s[f]
      };
    return {
      conceptId: c,
      concept: Object.values(s)[0],
      perSetData: d,
      isDifferent: u
    };
  }).filter(Boolean);
}
const sm = "#faf1c880", Px = "#ffed9480", DM = "#f4cf71", uf = "#fcdada80", lm = (e) => ({ getValue: t, row: n }) => {
  const r = t() || {}, i = n.original.hasDiff || n.original.isDifferent;
  return /* @__PURE__ */ p(
    yt,
    {
      text: e ? /* @__PURE__ */ p(we, { children: Object.keys(n.original.concept).map((a) => /* @__PURE__ */ F(we, { sx: { mb: 0.5 }, children: [
        /* @__PURE__ */ F("strong", { children: [
          TM[a],
          ":"
        ] }),
        " ",
        n.original.concept[a] || "—"
      ] }, a)) }) : "",
      color: "primary",
      width: "auto",
      children: /* @__PURE__ */ p(
        we,
        {
          sx: {
            display: "flex",
            backgroundColor: i ? Px : "transparent",
            pl: 1.5,
            ...i ? {
              "::before": {
                content: "''",
                display: "inline-block",
                width: "6px",
                height: "100%",
                backgroundColor: DM,
                position: "absolute",
                left: 0
              }
            } : {}
          },
          children: r
        }
      )
    }
  );
}, PM = [
  {
    id: "id",
    header: "Id",
    accessorKey: "concept.CONCEPT_ID",
    enableColumnFilter: !1,
    size: 180,
    enableResizing: !1,
    enableHiding: !1,
    cell: lm(!0)
  }
], Kl = (e, t, n, r, i) => ({
  id: `${e}___${n + r}`,
  header: () => /* @__PURE__ */ p(
    yt,
    {
      text: /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(we, { sx: { paddingBottom: "4px", fontWeight: "bold" }, children: t }),
        /* @__PURE__ */ p(we, { component: "text", sx: { whiteSpace: "pre-line" }, children: i })
      ] }),
      placement: "top",
      children: /* @__PURE__ */ p(vC, { iconName: t, width: 20, sx: { mr: 0.5 } })
    }
  ),
  accessorFn: (a) => {
    var u, d;
    const o = (u = a.perSetData) == null ? void 0 : u[n + r], s = o == null ? void 0 : o[e];
    o == null || o._missing;
    const c = o == null ? void 0 : o._entireConceptMissing, l = ((d = o == null ? void 0 : o._diff) == null ? void 0 : d[e]) === !0;
    return {
      value: s,
      highlight: c ? "red" : l ? "yellow" : null
    };
  },
  cell: ({ getValue: a }) => {
    const { value: o, highlight: s } = a();
    return /* @__PURE__ */ F(
      we,
      {
        sx: {
          backgroundColor: s === "red" ? uf : s === "yellow" ? sm : "transparent",
          textAlign: "center",
          lineHeight: "40px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        children: [
          o === !0 && /* @__PURE__ */ p(
            gh,
            {
              iconName: "check",
              fontSize: "small",
              sx: { fontSize: 18, overflow: "hidden", pt: 0.25 }
            }
          ),
          o === !1 && /* @__PURE__ */ p(
            gh,
            {
              iconName: "border",
              fontSize: "small",
              sx: { fontSize: 18, overflow: "hidden", pt: 0.25 }
            }
          ),
          o === void 0 && "—"
        ]
      }
    );
  },
  enableResizing: !1,
  meta: { align: "center", headerAlign: "center" },
  size: 45,
  enableSorting: !1
});
function LM(e) {
  const t = [...PM];
  return t.splice(
    1,
    0,
    ...e.map((n) => ({
      header: () => /* @__PURE__ */ p(
        we,
        {
          alignItems: "center",
          width: "100%",
          whiteSpace: "nowrap",
          flexGrow: 1,
          maxHeight: 36,
          overflow: "hidden",
          py: 0.5,
          textOverflow: "ellipsis",
          title: n.name,
          children: n.name
        }
      ),
      id: n.id + n.versionId,
      enableResizing: !1,
      size: 180,
      maxSize: 180,
      meta: { align: "center", headerAlign: "center" },
      columns: [
        Kl(
          "excluded",
          "Exclude",
          n.id,
          n.versionId,
          `Marks the concept to be explicitly excluded from the concept Set.
It is possible to exclude a whole sub-trees of concepts by combining Exclude and Descendants/Hierarchy options.
Overrides the implicit inclusion of concepts from Descendants option.`
        ),
        Kl(
          "descendants",
          "Descendants",
          n.id,
          n.versionId,
          `Includes child concepts from the standard hierarchy, utilizing OMOP CDM relation table data.
Option is available only for standard and classification concepts.`
        ),
        Kl(
          "mapped",
          "Mapped",
          n.id,
          n.versionId,
          `Includes additional non-standard concepts, that this concept has a 'Maps to' relationship with.
If the concept is not mapped to any other concepts with 'Maps to' relationship, it will be excluded from the final list.
Option is available only for standard and classification concepts.`
        ),
        Kl(
          "hierarchy",
          "Hierarchy",
          n.id,
          n.versionId,
          `Includes child concepts from the native hierarchy of source data, utilizing OMOP CDM relation table data.
Work same way as Descendants, but for non-standard concepts.
Option is available only for non-standard concepts.`
        )
      ]
    }))
  ), t;
}
function zM(e) {
  switch (e.typeContainer) {
    case ge.LIBRARY:
      return `/library/concept-sets/${e.id}`;
    case ge.WORKSPACE:
      return `/workspace/concept-sets/${e.id}`;
    case ge.STUDY:
      return `/study-manager/${e.parentId}/concept-sets/${e.id}`;
    default:
      return null;
  }
}
function fy(e, t, n = "0") {
  const r = [
    {
      id: "attribute",
      header: "Name",
      accessorKey: "attribute",
      enableSorting: !1,
      size: 180,
      maxSize: 180,
      enableResizing: !1,
      cell: lm(!1)
    }
  ];
  for (const i of e)
    r.push({
      id: i.id + i.versionId,
      header: () => /* @__PURE__ */ p(yt, { text: "Navigate to Consept Set", placement: "top", children: /* @__PURE__ */ F(
        we,
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: [
            /* @__PURE__ */ p(we, { flexGrow: 1, title: i.name, maxWidth: "calc(100% - 20px)", children: /* @__PURE__ */ p(Wv, { to: zM(i), children: /* @__PURE__ */ p(
              we,
              {
                whiteSpace: "nowrap",
                maxHeight: 36,
                overflow: "hidden",
                py: 0.5,
                textOverflow: "ellipsis",
                title: i.name,
                children: i.name
              }
            ) }) }),
            t && /* @__PURE__ */ p(
              he,
              {
                iconName: "close",
                sx: { ml: 1, cursor: "pointer", fontSize: 12 },
                onClick: () => {
                  t({ id: i.id, versionId: i.versionId });
                }
              }
            )
          ]
        }
      ) }),
      accessorKey: i.id + i.versionId,
      enableSorting: !1,
      size: 180,
      enableResizing: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: ({ getValue: a }) => {
        const { value: o, hasDiff: s, isMissing: c } = a() || {};
        return /* @__PURE__ */ p(
          we,
          {
            sx: {
              backgroundColor: s ? c ? uf : sm : "transparent",
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: o ?? n
          }
        );
      }
    });
  return r;
}
function BM(e) {
  return [
    {
      id: "id",
      header: "Id",
      accessorKey: "concept.CONCEPT_ID",
      enableColumnFilter: !1,
      size: 180,
      enableResizing: !1,
      enableHiding: !1,
      cell: lm(!0)
    },
    ...e.map((n) => FM(n))
  ];
}
const FM = (e) => ({
  id: `presence___${e.id + e.versionId}`,
  header: () => /* @__PURE__ */ p(we, { whiteSpace: "wrap", children: e.name }),
  accessorKey: `perSetData.${e.id + e.versionId}.present`,
  enableResizing: !1,
  cell: ({ getValue: t, row: n }) => {
    var a;
    const r = !t(), i = (a = n.original) == null ? void 0 : a.isDifferent;
    return /* @__PURE__ */ p(
      we,
      {
        sx: {
          backgroundColor: i ? r ? uf : sm : "transparent",
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        children: t() ? /* @__PURE__ */ p(
          gh,
          {
            iconName: "check",
            sx: { fontSize: 18, overflow: "hidden", pt: 0.25 }
          }
        ) : "—"
      }
    );
  },
  meta: { align: "center", headerAlign: "center" },
  size: 180,
  disableSorting: !0
}), YM = (e) => [
  {
    value: Dr.EXPRESSION,
    title: "Expression",
    onTabClick: e
  },
  {
    value: Dr.INCLUDED_CONCEPTS,
    title: "Included Concepts",
    onTabClick: e
  },
  {
    value: Dr.INCLUDED_SOURCE_CODES,
    title: "Included Source Codes",
    onTabClick: e
  }
], jM = (e) => ({
  [e.breakpoints.up("xs")]: { padding: "14px 8px" },
  [e.breakpoints.up("lg")]: { padding: "14px 12px" },
  [e.breakpoints.up("xl")]: { padding: "14px" }
}), $M = ae("div", {
  shouldForwardProp: (e) => e !== "secondary" && e !== "hasRightTabs"
})(
  ({
    theme: e,
    secondary: t,
    hasRightTabs: n
  }) => ({
    position: "relative",
    display: "flex",
    justifyContent: n ? "space-between" : "flex-start",
    alignItems: "stretch",
    padding: 0,
    minWidth: 0,
    ".tabs-group": {
      display: "flex",
      alignItems: "stretch",
      minWidth: 0
    },
    ".tabs-group-left": {
      flexShrink: 1,
      overflow: "hidden"
    },
    ".tabs-group-right": {
      flexShrink: 0,
      marginLeft: "auto",
      gap: t ? 12 : 16
    },
    ".tab-tooltip-wrapper": {
      display: "inline-flex",
      alignItems: "stretch"
    },
    ".tab": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      fontSize: t ? 14 : 16,
      fontWeight: 400,
      textAlign: "center",
      color: e.palette.textColor.primary,
      opacity: 0.8,
      cursor: "pointer",
      overflowX: "hidden",
      padding: "14px 12px",
      // default
      ...jM(e),
      ".tab-wrapper": {
        display: "flex",
        flex: 1,
        alignItems: "center",
        minWidth: 0
      },
      ".tab-title": {
        flex: 1,
        minWidth: 0,
        overflowX: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      "::after": {
        content: "''",
        position: "absolute",
        bottom: 0,
        left: "50%",
        height: 4,
        width: "0",
        backgroundColor: e.palette.info.main,
        transition: "300ms",
        transform: "translateX(-50%, 0)"
      },
      "&.active": {
        fontWeight: 700,
        "::after": {
          left: 0,
          width: "100%",
          transform: "none"
        },
        ".tab-count": {
          fontWeight: 700
        }
      },
      "&.tab-icon-only": {
        flex: "0 0 auto",
        overflow: "visible",
        padding: t ? "12px 10px" : "14px 12px",
        minWidth: t ? 42 : 46,
        justifyContent: "center",
        gap: 6,
        ".tab-wrapper": {
          flex: "0 0 auto"
        },
        ".tab-wrapper .tab-title": {
          display: "none"
        },
        ".tab-count": {
          marginLeft: 0
        },
        "&::after": {
          height: 0
        },
        "&.active": {
          opacity: 1
        },
        "&:focus, &:focus-visible": {
          outline: "none",
          boxShadow: "none"
        }
      }
    },
    ".tabs-group .tab:not(:last-of-type)": {
      marginRight: t ? 0 : "12px"
    }
  })
), ff = (e) => {
  const { tabs: t, active: n, withRouting: r, end: i = !1, secondary: a = !1 } = e, o = t.filter((l) => l.align !== "right"), s = t.filter((l) => l.align === "right"), c = (l, u) => {
    const d = l.tooltipText || Zc(l.title) || WM(l), f = typeof d == "string" ? d : Zc(l.title), h = (I) => l.iconName ? /* @__PURE__ */ p(
      he,
      {
        iconName: l.iconName,
        sx: {
          fontSize: l.iconOnly ? 20 : a ? 16 : 18,
          mr: l.iconOnly ? 0 : 0.75,
          color: l.iconOnly ? I ? "textColor.primary" : "black.light" : I ? "black.main" : "black.light"
        }
      }
    ) : null, m = yh(
      l != null && l.iconName ? "tab-title-with-icon" : "",
      typeof l.title == "string" ? "tab-title" : ""
    ), y = l.iconOnly ? Av(l.title) ? q2(l.title, {
      hideTitle: !0
    }) : null : l.title, v = (I) => yh("tab", l.iconOnly ? "tab-icon-only" : "", I && "active"), w = r ? /* @__PURE__ */ p(
      Wv,
      {
        end: i || l.end,
        to: { pathname: l.value, search: location == null ? void 0 : location.search },
        className: ({ isActive: I }) => v(I),
        title: l.iconOnly ? void 0 : f,
        children: ({ isActive: I }) => /* @__PURE__ */ F(ze, { children: [
          h(I),
          /* @__PURE__ */ p("div", { className: m, children: y })
        ] })
      },
      u
    ) : /* @__PURE__ */ F(
      "a",
      {
        className: v(n === l.value),
        onClick: () => l.onTabClick(l.value),
        title: l.iconOnly ? void 0 : f,
        children: [
          h(n === l.value),
          /* @__PURE__ */ p("div", { className: m, children: y })
        ]
      },
      u
    );
    return l.iconOnly ? /* @__PURE__ */ p(
      xC,
      {
        title: d,
        placement: "top",
        arrow: !0,
        enterDelay: 100,
        enterNextDelay: 100,
        leaveDelay: 0,
        disableInteractive: !0,
        slotProps: {
          popper: {
            sx: {
              [`& .${b0.tooltip}`]: {
                mb: "6px !important",
                px: 1.25,
                py: 0.5,
                borderRadius: "5px",
                backgroundColor: "#7d88a6",
                color: "#ffffff",
                boxShadow: "none",
                fontSize: 14,
                lineHeight: "18px",
                fontWeight: 400
              },
              [`& .${b0.arrow}`]: {
                color: "#7d88a6"
              }
            }
          }
        },
        children: /* @__PURE__ */ p("span", { className: "tab-tooltip-wrapper", children: w })
      },
      u
    ) : w;
  };
  return /* @__PURE__ */ F($M, { secondary: a, hasRightTabs: s.length > 0, children: [
    /* @__PURE__ */ p("div", { className: "tabs-group tabs-group-left", children: o.map((l, u) => c(l, u)) }),
    s.length > 0 && /* @__PURE__ */ p("div", { className: "tabs-group tabs-group-right", children: s.map((l, u) => c(l, u)) })
  ] });
};
function Zc(e) {
  if (typeof e == "string" || typeof e == "number") return String(e);
  if (Array.isArray(e)) return e.map(Zc).join("");
  if (Av(e)) {
    if (typeof e.props.title == "string")
      return e.props.title;
    if (e.props.children)
      return Zc(e.props.children);
  }
  return "";
}
function WM(e) {
  const t = (e.id || e.value || "").replace(/^\/+|\/+$/g, "");
  return {
    versions: "Versions",
    versioning: "Versions",
    messages: "Messages",
    "meta-attributes": "Metadata",
    "ai-meta-attributes": "Generative AI",
    usage: "Used In",
    statistics: "Utilization Statistics",
    "ai-suggested": "External Publications (AI)"
  }[t] || t;
}
const dy = ({
  text: e,
  color: t
}) => /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", p: 1.5, children: [
  /* @__PURE__ */ p(
    we,
    {
      sx: {
        backgroundColor: t,
        width: 14,
        height: 14,
        borderRadius: "2px",
        boxShadow: "inset -3px -3px 6px rgba(255,255,255,.4)",
        cursor: "pointer",
        transition: "300ms",
        position: "relative",
        filter: "brightness(96%)",
        ":hover": {
          filter: "brightness(90%)"
        }
      }
    }
  ),
  /* @__PURE__ */ F(le, { variant: "subtitle2", ml: 0.5, children: [
    "— ",
    e
  ] })
] }), UM = ae.div``, HM = ae.span`
  margin-right: 8px;
  font-weight: bold;
  font-size: 14px;
`, GM = (e) => {
  const { title: t, count: n, loading: r = !1 } = e;
  return /* @__PURE__ */ F(UM, { children: [
    /* @__PURE__ */ p(HM, { children: t }),
    XC(n) && n >= 0 && /* @__PURE__ */ p(Nc, { className: "all-counter", dense: !0, children: r ? /* @__PURE__ */ p(gt, { size: 12, sx: { opacity: 0.6 } }) : n })
  ] });
}, VM = () => {
  const e = Hi(), t = sr(null), n = sr(null), r = sr(null), i = Ot(
    (W) => W.compare.data.conceptSets
  ), a = Ot((W) => W.compare.data), o = Ot(
    (W) => {
      var L;
      return (L = W.compare.ids) == null ? void 0 : L.conceptSets;
    }
  ), s = Ot((W) => W.compare.status), c = Ot((W) => W.compare.metadata), [l, u] = Te(!1), [d, f] = Te(Dr.EXPRESSION), [h, m] = Te(!1), y = Ot(
    (W) => W.compare.counts.includedConceptsCounts
  ), v = Ot(
    (W) => W.compare.counts.includedSourceCodesCounts
  ), w = (W) => {
    e(UC("conceptSets", W));
  }, I = () => {
    i.forEach((W) => w(W));
  }, M = Ce(
    () => LM(i),
    [i]
  ), k = Ce(
    () => BM(i),
    [i]
  ), g = Ce(
    () => fy(i, null, "—"),
    [i]
  ), A = Ce(
    () => fy(
      i.map((W, L) => ({
        ...W,
        ...o[L]
      })),
      w
    ),
    [i, o, w]
  ), b = Ce(
    () => RM(c.conceptSets, i, l),
    [c.conceptSets, i, l]
  ), x = Ce(
    () => OM(
      i,
      y,
      v,
      b.counts,
      l,
      o
    ),
    [
      i,
      y,
      v,
      l,
      b,
      o
    ]
  ), _ = Ce(
    () => IM(i, l),
    [i, l]
  ), R = Ce(
    () => uy(
      i,
      a.includedConcepts,
      l
    ),
    [i, l, a.includedConcepts]
  ), P = Ce(
    () => uy(
      i,
      a.includedSourceCodes,
      l
    ),
    [i, l, a.includedSourceCodes]
  ), E = Ce(() => YM(f), []);
  tt(() => {
    i.length == 1 && u(!1);
  }, [i]);
  const C = i.length > 0, T = C && x.length > 0, D = C && b.rows.length > 0, z = C && _.length > 0, B = (...W) => (L) => {
    h || (m(!0), W.forEach((S) => {
      S.current && (S.current.scrollLeft = L.target.scrollLeft);
    }), requestAnimationFrame(() => {
      m(!1);
    }));
  };
  return tt(() => {
    switch (d) {
      case Dr.INCLUDED_CONCEPTS:
        e(E0("included"));
        break;
      case Dr.INCLUDED_SOURCE_CODES:
        e(E0("included-source-code"));
        break;
    }
  }, [d]), tt(() => {
    e(WC());
  }, []), /* @__PURE__ */ p(O, { container: !0, p: 2, className: "compare-container", children: /* @__PURE__ */ F(O, { container: !0, spacing: 1, sx: {}, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(
      zr,
      {
        outlined: !0,
        elevated: !0,
        size: "dense",
        title: /* @__PURE__ */ F(
          we,
          {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 0.5,
            mx: -1,
            children: [
              /* @__PURE__ */ F("label", { children: [
                /* @__PURE__ */ p(
                  Tv,
                  {
                    name: "onlyDifferent",
                    onChange: () => {
                      u(!l);
                    },
                    disabled: i.length <= 1,
                    checked: l,
                    size: "small"
                  }
                ),
                /* @__PURE__ */ p(le, { sx: { ml: 1 }, variant: "caption", children: "Show only different items" })
              ] }),
              C && /* @__PURE__ */ p(
                Ue,
                {
                  color: "error",
                  title: "Clear all",
                  onClick: I,
                  iconName: "delete",
                  noCollapse: !0
                }
              )
            ]
          }
        ),
        children: /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ p(dy, { color: Px, text: "Row has differences" }),
          /* @__PURE__ */ p(dy, { color: uf, text: "Missing item" })
        ] })
      }
    ) }),
    C ? /* @__PURE__ */ F(ze, { children: [
      /* @__PURE__ */ p(O, { item: !0, xs: 12, className: "no-group", children: T && /* @__PURE__ */ p(
        zr,
        {
          outlined: !0,
          elevated: !0,
          collapsible: !0,
          title: /* @__PURE__ */ p(
            GM,
            {
              title: "General",
              count: i.length
            }
          ),
          size: "dense",
          children: /* @__PURE__ */ p(
            ua,
            {
              variant: "uncontrolled",
              hideSettings: !0,
              hidePagination: !0,
              columns: A,
              data: x,
              onScroll: B(
                n,
                r
              ),
              ref: t,
              pinnedColumns: { left: ["attribute"] }
            }
          )
        }
      ) }),
      /* @__PURE__ */ p(O, { item: !0, xs: 12, className: "no-group", children: D && /* @__PURE__ */ p(
        zr,
        {
          outlined: !0,
          elevated: !0,
          collapsible: !0,
          title: "Metadata",
          size: "dense",
          children: /* @__PURE__ */ p(
            ua,
            {
              variant: "uncontrolled",
              hideSettings: !0,
              hidePagination: !0,
              columns: g,
              data: b.rows,
              onScroll: B(
                n,
                t
              ),
              ref: r,
              pinnedColumns: { left: ["attribute"] }
            }
          )
        }
      ) }),
      z && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
        zr,
        {
          outlined: !0,
          elevated: !0,
          collapsible: !0,
          title: "Items",
          size: "dense",
          children: /* @__PURE__ */ F(O, { item: !0, container: !0, children: [
            /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
              /* @__PURE__ */ p(
                ff,
                {
                  tabs: E,
                  active: d,
                  secondary: !0
                }
              ),
              /* @__PURE__ */ p(xa, {})
            ] }),
            /* @__PURE__ */ F(
              O,
              {
                item: !0,
                xs: 12,
                className: d != Dr.EXPRESSION ? "no-group" : "",
                children: [
                  d == Dr.EXPRESSION && /* @__PURE__ */ p(
                    ua,
                    {
                      variant: "uncontrolled",
                      hideSettings: !0,
                      columns: M,
                      data: _,
                      withDuplicates: !0,
                      loading: s.conceptSets === ve.IN_PROGRESS,
                      ref: n,
                      onScroll: B(
                        r,
                        t
                      ),
                      pinnedColumns: { left: ["id"] }
                    }
                  ),
                  d == Dr.INCLUDED_CONCEPTS && /* @__PURE__ */ p(
                    ua,
                    {
                      variant: "uncontrolled",
                      hideSettings: !0,
                      columns: k,
                      data: R,
                      withDuplicates: !0,
                      loading: s.includedConcepts === ve.IN_PROGRESS,
                      ref: n,
                      onScroll: B(
                        r,
                        t
                      ),
                      pinnedColumns: { left: ["id"] }
                    }
                  ),
                  d == Dr.INCLUDED_SOURCE_CODES && /* @__PURE__ */ p(
                    ua,
                    {
                      variant: "uncontrolled",
                      hideSettings: !0,
                      columns: k,
                      data: P,
                      withDuplicates: !0,
                      loading: s.includedSourceCodes === ve.IN_PROGRESS,
                      ref: n,
                      onScroll: B(
                        r,
                        t
                      ),
                      pinnedColumns: { left: ["id"] }
                    }
                  )
                ]
              }
            )
          ] })
        }
      ) })
    ] }) : /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(zr, { outlined: !0, elevated: !0, title: "No data", size: "dense", children: /* @__PURE__ */ p(le, { variant: "body2", p: 2, children: "Please select at least one concept set for comparison" }) }) })
  ] }) });
}, qH = ({}) => {
  const { openModal: e, closeModal: t } = Mo(Jp), r = Ot((o) => o.compare.ids).conceptSets, i = r == null ? void 0 : r.length;
  return /* @__PURE__ */ p(am, { children: /* @__PURE__ */ p(yt, { text: "Compare", children: /* @__PURE__ */ p(
    om,
    {
      onClick: () => {
        e(() => /* @__PURE__ */ p(VM, {}), "Compare", {
          closeOnClickOutside: !0,
          width: i * 180 + 300 + "px",
          onClose: t
        });
      },
      hasNotifications: i > 0,
      count: i,
      disabled: i < 1,
      startIcon: /* @__PURE__ */ p(
        qp,
        {
          badgeContent: i,
          color: "error",
          sx: {
            "& .MuiBadge-badge": {
              padding: "2px 4px",
              fontSize: 10,
              height: 14
            }
          },
          max: 999,
          children: /* @__PURE__ */ p(he, { iconName: "compare" })
        }
      ),
      text: "Compare"
    }
  ) }) });
}, QM = ae.div`
  /* padding: 10px 0; */
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[400];
}};
  font-size: 14px;
`, XH = ({ children: e, isInsert: t }) => {
  const n = Ce(() => t ? `No ${e} available` : e, [e]);
  return /* @__PURE__ */ p(QM, { children: n });
};
function qM(e) {
  switch (e) {
    case wt.ANALYSIS_SUBMISSION:
      return "green";
    case wt.ANALYSIS:
      return "blue";
    case wt.COHORT:
      return "purple";
    case wt.CONCEPT_SET:
      return "teal";
    case wt.CUSTOM_CODE:
      return "green";
  }
}
const Lx = (e) => {
  if (Array.isArray(e))
    return e.some(Lx);
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    return t === "yes" || t === "true";
  }
  return !1;
}, Gi = ({
  value: e,
  cell: t,
  size: n = 26,
  renderValue: r,
  row: i
}) => {
  var d, f, h, m;
  const a = e || (r == null ? void 0 : r()), o = qM(a), s = (n - n * 0.56) / 2, c = n * 0.55, l = (h = (f = (d = i == null ? void 0 : i.original) == null ? void 0 : d.values) == null ? void 0 : f.find(
    (y) => nC(y == null ? void 0 : y.fieldName)
  )) == null ? void 0 : h.value, u = (a === wt.COHORT || a === wt.CONCEPT_SET) && (Array.isArray(l) ? l.includes("Yes") : (m = l == null ? void 0 : l.includes) == null ? void 0 : m.call(l, "Yes"));
  return Lx(l), /* @__PURE__ */ p(yt, { text: u ? "AI generated" : "", children: /* @__PURE__ */ F(
    we,
    {
      sx: {
        display: t ? "block" : "inline-block",
        backgroundColor: o + ".light",
        padding: s < 1 ? 2 : s + "px",
        width: n,
        height: n,
        borderRadius: "50%",
        boxSizing: "border-box",
        position: "relative",
        m: t ? -0.5 : 0
      },
      children: [
        /* @__PURE__ */ p(
          he,
          {
            iconName: a,
            sx: {
              fontSize: c,
              color: o + ".main"
            }
          }
        ),
        u && /* @__PURE__ */ p(
          he,
          {
            iconName: "aiStars",
            sx: {
              fontSize: 18,
              position: "absolute",
              bottom: 10,
              right: -10,
              // left: -8,
              // top: -4,
              color: o + ".main"
            }
          }
        )
      ]
    }
  ) });
}, XM = ae.div`
  font-size: 13px;
  .date {
    white-space: nowrap;
  }
  .time {
    color: ${({ theme: e }) => e.palette.textColor.label};
  }
`, Fi = (e) => {
  var r;
  const t = e.value || ((r = e.renderValue) == null ? void 0 : r.call(e)), n = (() => {
    try {
      return Vn(t);
    } catch (i) {
      return console.error("WRONG DATE TIME FORMAT, value:", t, i), null;
    }
  })();
  return /* @__PURE__ */ p(XM, { children: n ? /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p("div", { className: "date", children: n }) }) : "-" });
}, JM = ae.div`
  justify-content: flex-end;
  display: flex;
  margin: -4px;
  > *:not(:last-child) {
    margin-right: 6px;
  }
`, KM = ({
  onEdit: e,
  onRemove: t,
  withConfirmation: n,
  entityType: r,
  entityName: i,
  children: a
}) => {
  const { t: o } = Ma(), s = qe.useMemo(
    () => `${o("tables.cells.confirm_message_action", {
      entityType: r || "this item"
    })} ${i || ""}?`,
    [i, r]
  );
  return /* @__PURE__ */ F(JM, { children: [
    a,
    e && /* @__PURE__ */ p(wk, { onEdit: e }),
    t && /* @__PURE__ */ p(
      _k,
      {
        onRemove: t,
        withConfirmation: n,
        confirmationMessage: s
      }
    )
  ] });
}, ZM = ae("div")(({ theme: e }) => ({
  fontWeight: 700
})), eI = ae("div")(({ theme: e }) => ({
  color: e.palette.textColor.label,
  fontSize: 12
})), tI = {
  [wt.ANALYSIS]: "Analysis",
  [wt.COHORT]: "Cohort",
  [wt.CONCEPT_SET]: "Concept set",
  [wt.ANALYSIS_SUBMISSION]: "Analysis execution"
}, hy = {
  [wt.ANALYSIS]: "analyses",
  [wt.COHORT]: "cohorts",
  [wt.CONCEPT_SET]: "concept-sets",
  [wt.ANALYSIS_SUBMISSION]: "analyses"
}, nI = ({
  value: e,
  row: t
}) => {
  var i, a;
  const n = (i = t.original) == null ? void 0 : i.type, r = (a = t.original) == null ? void 0 : a.entityType;
  return /* @__PURE__ */ F("div", { children: [
    /* @__PURE__ */ p(ZM, { children: e }),
    /* @__PURE__ */ F(eI, { children: [
      r ? tI[r] : "",
      " ",
      n ? " - " + Hp[n] : ""
    ] })
  ] });
}, rI = ae("span")(({ theme: e }) => ({
  fontWeight: 500,
  color: e.palette.text.primary
})), Ih = ({ value: e, renderValue: t }) => /* @__PURE__ */ p(rI, { children: e || (t == null ? void 0 : t()) }), JH = ({ value: e, renderValue: t }) => {
  const n = e || (t == null ? void 0 : t()), r = (n == null ? void 0 : n.length) - 1;
  return Array.isArray(n) ? n != null && n.length ? /* @__PURE__ */ p(
    yt,
    {
      text: r && n ? n.map((i, a) => /* @__PURE__ */ p("div", { children: i }, i + a)) : "",
      children: /* @__PURE__ */ F(we, { component: "span", children: [
        n[0],
        !!r && /* @__PURE__ */ F(
          we,
          {
            sx: (i) => ({
              backgroundColor: Bi(0.9, i.palette.grey[800]),
              borderRadius: "2px",
              color: i.palette.textColor.primary,
              fontSize: 12,
              p: "3px 4px",
              display: "inline-flex",
              height: 20,
              boxSizing: "border-box",
              ml: 1
            }),
            children: [
              "+ ",
              r
            ]
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ p(ze, { children: "-" }) : (console.error("WRONG DATA TYPE PROVIDED FOR <ListCell>"), /* @__PURE__ */ p(ze, { children: "-" }));
}, py = ({
  value: e,
  renderValue: t
}) => {
  const n = e || (t == null ? void 0 : t());
  return /* @__PURE__ */ p(ze, { children: n != null && n.user ? `${n.user.firstName} ${n.user.lastName}` : n });
}, iI = ({ onChange: e, value: t = "", item: n, aliases: r = [] }) => {
  var d;
  const [i, a] = Te(t), o = ((d = r == null ? void 0 : r.filter((f) => f === i)) == null ? void 0 : d.length) < 2, s = !i, c = s || !o, l = s ? "Alias should not be empty" : o ? "" : "Alias should be unique", u = (f) => {
    f == null || f.preventDefault(), i && t !== i && e({ ...n, alias: i });
  };
  return /* @__PURE__ */ p(Nv, { onClickAway: u, children: /* @__PURE__ */ p("form", { onSubmit: u, action: "", children: /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", mr: 1, children: [
      /* @__PURE__ */ p(le, { variant: "subtitle2", sx: { opacity: 0.7, mr: 0.75 }, children: "Alias" }),
      /* @__PURE__ */ p(yt, { text: "Alias/Variable name for each target cohort", children: /* @__PURE__ */ p(he, { iconName: "info", sx: { fontSize: 14, color: "#9FA8BD" } }) })
    ] }),
    /* @__PURE__ */ p(yt, { text: l, show: c, placement: "right", children: /* @__PURE__ */ p(
      xr,
      {
        value: i || "",
        name: "alias",
        onClick: (f) => f.preventDefault(),
        onChange: (f) => {
          a(f.target.value);
        },
        sx: { width: 250 },
        InputProps: { error: c }
      }
    ) })
  ] }) }) });
}, KH = ({ hasAlias: e, entityType: t, ...n }) => {
  const {
    value: r,
    row: {
      original: { versionOrdinal: i, shortcut: a }
    },
    onChange: o,
    aliases: s = []
  } = n;
  return /* @__PURE__ */ F(
    we,
    {
      display: { lg: "flex", xs: "block" },
      justifyContent: "space-between",
      alignItems: "center",
      my: { xs: 0.5, lg: 0 },
      sx: { minHeight: "28px" },
      children: [
        /* @__PURE__ */ F(
          we,
          {
            display: "flex",
            alignItems: "center",
            sx: {
              maxWidth: { lg: "calc(100% - 320px)" },
              "& *:first-child": {
                mr: 1.5
              }
            },
            children: [
              /* @__PURE__ */ p(Gi, { value: t, size: 26 }),
              /* @__PURE__ */ p(
                le,
                {
                  variant: "h3",
                  fontSize: 14,
                  sx: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  },
                  children: r
                }
              ),
              i ? /* @__PURE__ */ F(
                le,
                {
                  sx: { ml: 1, fontWeight: 400 },
                  variant: "subtitle1",
                  component: "i",
                  children: [
                    "( ",
                    a ? `ID: ${a}, ` : "",
                    "Version: ",
                    i,
                    " )"
                  ]
                }
              ) : ""
            ]
          }
        ),
        e && /* @__PURE__ */ p(we, { mt: { lg: 0, xs: 1.5 }, children: /* @__PURE__ */ p(
          iI,
          {
            value: n.row.original.alias,
            item: n.row.original,
            onChange: o,
            aliases: s
          }
        ) })
      ]
    }
  );
}, ZH = (e) => {
  var i, a, o, s, c, l;
  const t = e.value || e.getValue(), n = `${((a = (i = t.user) == null ? void 0 : i.firstName) == null ? void 0 : a[0]) || ""}${((s = (o = t.user) == null ? void 0 : o.lastName) == null ? void 0 : s[0]) || ""}`, r = `${((c = t.user) == null ? void 0 : c.firstName) || ""} ${((l = t.user) == null ? void 0 : l.lastName) || ""}`;
  return /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", maxWidth: "100%", children: [
    /* @__PURE__ */ p(
      Iv,
      {
        sx: (u) => ({
          fontSize: 12,
          width: 30,
          height: 30,
          // fontWeight: 'bold',
          backgroundColor: u.palette.secondary.main,
          color: u.palette.primary.main
          // my: -0.5,
        }),
        children: n
      }
    ),
    /* @__PURE__ */ p(
      we,
      {
        ml: 1,
        fontWeight: "bold",
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        title: r,
        children: r
      }
    )
  ] });
}, eG = ({
  value: e,
  row: { original: t }
}) => {
  const n = Sr(), r = Ce(() => (t == null ? void 0 : t.diff) > 0 ? n.palette.success.main : (t == null ? void 0 : t.diff) < 0 ? n.palette.error.main : n.palette.grey[500], [t == null ? void 0 : t.diff]);
  return /* @__PURE__ */ p(we, { my: -0.5, display: "flex", alignItems: "center", children: /* @__PURE__ */ p(Gv, { width: 300, height: 30, data: e, children: /* @__PURE__ */ p(
    Vv,
    {
      dataKey: "count",
      stroke: r,
      strokeWidth: 1.5,
      type: "linear",
      dot: { strokeWidth: 0, r: 0 }
    }
  ) }) });
}, aI = (e) => ({
  header: "",
  id: "icon",
  size: 40,
  minSize: 40,
  enableResizing: !1,
  enableSorting: !1,
  accessorKey: "type",
  enableHiding: !1,
  meta: { columnType: "action" },
  ...e || {}
}), zx = (e) => ({
  header: "Id",
  accessorKey: "shortcut",
  id: "shortcut",
  size: 65,
  minSize: 65,
  maxSize: 100,
  ...e || {}
}), cm = (e) => ({
  id: "name",
  // old
  Header: "Name",
  accessor: "name",
  minWidth: 100,
  maxWidth: 1e3,
  width: "80%",
  isCropped: !0,
  Cell: Ih,
  // new
  header: "Name",
  accessorKey: "name",
  size: 500,
  minSize: 200,
  maxSize: 800,
  cell: Ih,
  ...e || {}
}), um = (e) => ({
  Header: "Updated",
  header: "Updated",
  id: "modified.timestamp",
  accessorKey: "modified.timestamp",
  accessor: "modified.timestamp",
  cell: Fi,
  Cell: Fi,
  isCropped: !0,
  enableResizing: !1,
  size: 152,
  maxSize: 152,
  maxWidth: 152,
  ...e || {}
}), fm = (e) => ({
  Header: "Created",
  header: "Created",
  accessorKey: "created.timestamp",
  accessor: "created.timestamp",
  id: "created.timestamp",
  Cell: Fi,
  cell: Fi,
  isCropped: !0,
  enableResizing: !1,
  size: 152,
  maxSize: 152,
  maxWidth: 152,
  ...e || {}
}), tG = (e) => ({
  Header: "Date",
  header: "Date",
  accessorKey: "timestamp",
  accessor: "timestamp",
  id: "timestamp",
  Cell: Fi,
  cell: Fi,
  isCropped: !0,
  enableResizing: !1,
  size: 152,
  maxSize: 152,
  maxWidth: 152,
  meta: {
    minWidth: 152,
    maxWidth: 152
  },
  ...e || {}
}), dm = (e) => ({
  Header: "Author",
  header: "Author",
  id: "created.user.name",
  accessorKey: "created.user.name",
  accessor: "created.user.name",
  Cell: py,
  cell: py,
  size: 152,
  minSize: 60,
  maxSize: 300,
  ...e || {}
}), oI = {
  columns: [
    zx(),
    cm(),
    fm(),
    um(),
    dm()
  ],
  entityBreadcrumbs: (e) => {
    const t = [], { rootTitle: n, parentTitle: r, title: i, rootPath: a, parentId: o, path: s } = e;
    return n && (t[0] = {
      name: n,
      path: `${a}`
    }), o && (t[1] = {
      name: r,
      path: `${a}/${o}`
    }), n !== i && (o ? t[2] = {
      name: i,
      path: s
    } : t[1] = {
      name: i,
      path: s
    }), t;
  }
}, my = (e, t) => {
  var r;
  const n = localStorage.getItem(e) ? JSON.parse(localStorage.getItem(e)) : {
    filters: {},
    pageSize: 15,
    sort: null,
    columns: t || {
      shortcut: !1,
      "created.timestamp": !1
    }
  };
  return {
    ...n,
    columns: n.columns && ((r = Object.keys(n.columns)) != null && r.length) ? n.columns : t
  };
}, sI = (e, t) => ({
  storage: my(e, t),
  setStorage: (r, i) => {
    const a = my(e, t);
    localStorage.setItem(
      e,
      JSON.stringify({
        ...a,
        [r]: i
      })
    );
  }
}), nG = ({
  children: e
}) => /* @__PURE__ */ p(
  O,
  {
    item: !0,
    xs: 12,
    sx: (t) => ({
      boxShadow: t.customShadows[2],
      background: "#ffffff",
      zIndex: 4,
      px: 6
    }),
    children: e
  }
), rG = ({
  children: e
}) => /* @__PURE__ */ p(
  O,
  {
    item: !0,
    xs: 12,
    sx: (t) => ({
      minHeight: "inherit",
      // backgroundColor: theme.palette.backgroundColor.dark,
      display: "flex",
      flexDirection: "column"
    }),
    children: e
  }
), iG = ({ children: e }) => /* @__PURE__ */ p(O, { container: !0, flexGrow: 1, className: "base-entity-content", children: e }), aG = (e) => {
  const {
    addButtonText: t,
    onAddClick: n,
    status: r,
    actions: i,
    isEmpty: a,
    listName: o,
    children: s,
    emptyTableText: c,
    viewMode: l,
    loadingSkeleton: u
  } = e, d = qe.useMemo(
    () => !!(!i || Ec(i)[kc.CREATE] || !l),
    [i]
  );
  return /* @__PURE__ */ p(ze, { children: r === ve.IN_PROGRESS || r === ve.IN_PROGRESS_RELOAD ? /* @__PURE__ */ p(
    O,
    {
      container: !0,
      py: 2,
      px: 3,
      alignContent: "space-between",
      minHeight: "calc(300px - 45px)",
      children: u || /* @__PURE__ */ p(O, { container: !0, pt: 10, justifyContent: "space-around", children: /* @__PURE__ */ p(gt, { size: 60, thickness: 6, color: "secondary" }) })
    }
  ) : (r === ve.SUCCESS || r === ve.ERROR) && a ? /* @__PURE__ */ p(O, { container: !0, pt: 2, children: /* @__PURE__ */ p(
    bC,
    {
      addButtonText: d && t ? t : void 0,
      onAdd: d && n ? n : void 0,
      size: "small",
      buttonName: o,
      noDataText: c
    }
  ) }) : /* @__PURE__ */ F(
    O,
    {
      container: !0,
      py: 2,
      px: 3,
      alignContent: "space-between",
      minHeight: "calc(300px - 45px)",
      children: [
        s,
        r === ve.SUCCESS && d && /* @__PURE__ */ p(O, { item: !0, xs: 12, textAlign: "right", mt: 1, children: /* @__PURE__ */ p(
          Ee,
          {
            onClick: n,
            className: "create-" + o,
            size: "small",
            startIcon: /* @__PURE__ */ p(he, { iconName: "add" }),
            color: "info",
            children: t
          }
        ) })
      ]
    }
  ) });
}, oG = ({
  children: e
}) => /* @__PURE__ */ p(
  O,
  {
    item: !0,
    xs: 12,
    sx: (t) => ({
      // boxShadow: theme.customShadows[2],
      background: "#ffffff",
      zIndex: 3
      // px: 6,
    }),
    className: "nested-entity-wrapper",
    children: e
  }
), hm = ({
  children: e
}) => /* @__PURE__ */ p(O, { item: !0, xs: 12, bgcolor: "backgroundColor.dark", p: 1, borderRadius: 1, children: e }), sG = ({ children: e, onButtonClick: t }) => /* @__PURE__ */ p(hm, { children: /* @__PURE__ */ F(lr, { children: [
  t && /* @__PURE__ */ p(O, { item: !0, xs: 12, px: 2, pt: 2, children: /* @__PURE__ */ F(
    Ee,
    {
      onClick: t,
      variant: "contained",
      size: "small",
      color: "info",
      sx: { px: 2 },
      children: [
        "Export to ",
        ">"
      ]
    }
  ) }),
  /* @__PURE__ */ p(O, { item: !0, xs: 12, container: !0, p: 2, sx: { width: "100%" }, children: /* @__PURE__ */ p(O, { item: !0, xs: 12, children: e }) })
] }) }), lI = ({
  value: e,
  statusHints: t,
  disabled: n = !1,
  onSubmit: r
}) => {
  var s;
  const i = A0(e), a = x0.map((c) => ({
    ...c,
    component: /* @__PURE__ */ p(
      Qp,
      {
        text: c.name,
        color: A0(c.id),
        light: !0,
        align: "center",
        iconSize: 6
      }
    ),
    message: t[c.id],
    disabled: t[c.id] !== void 0
  })), o = x0.find((c) => c.id === e);
  return /* @__PURE__ */ p(
    yt,
    {
      text: n ? void 0 : "Change Status",
      arrow: !0,
      placement: "bottom",
      children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
        Dv,
        {
          variant: "contained",
          title: o.name,
          sx: {
            fontSize: 13,
            fontWeight: 700,
            pointerEvents: n ? "none" : "auto",
            borderRadius: "2px",
            backgroundColor: w0(0.95, i),
            color: i,
            ".start-icon.MuiButton-iconSizeMedium svg, svg": {
              fontSize: 18
            },
            "&.MuiButton-containedPrimary:hover": {
              backgroundColor: w0(0.9, i),
              color: i
            },
            px: 1.5
          },
          onClick: (c) => {
            r(c.id);
          },
          startIcon: /* @__PURE__ */ p(
            wC,
            {
              name: (s = o.id) == null ? void 0 : s.toLowerCase()
            }
          ),
          endIcon: n ? /* @__PURE__ */ p(ze, {}) : /* @__PURE__ */ p(he, { iconName: "chevronFilled", fontSize: "small" }),
          options: a,
          tooltipPlacement: "right"
        }
      ) })
    }
  );
}, lG = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  AdditionalActions: r,
  actions: i,
  alerts: a
}) => {
  const o = Sr(), s = !i.update || i["consent.accept"], c = (u, d) => {
    n({ ...e, [u]: d });
  }, l = Uv("study-manager/:id", location.pathname);
  return /* @__PURE__ */ F(ze, { children: [
    /* @__PURE__ */ p(
      O,
      {
        item: !0,
        xs: 12,
        mx: -5,
        mt: a ? 1 : 0,
        height: a ? "100%" : "0px",
        sx: { transition: "all 1000ms" },
        children: a
      }
    ),
    /* @__PURE__ */ F(O, { container: !0, py: 1, alignItems: "center", className: "study-base-info", children: [
      /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
        lI,
        {
          value: e.status,
          statusHints: e.unavailableStatusHints,
          disabled: s,
          onSubmit: (u) => {
            c("status", u);
          }
        }
      ) }),
      /* @__PURE__ */ p(O, { item: !0, ml: 1, display: "inline-flex", children: /* @__PURE__ */ p(
        fM,
        {
          isPrivate: e.privacy,
          size: 20,
          onClick: () => {
            c("privacy", !e.privacy);
          },
          viewMode: s
        }
      ) }),
      /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, ml: 0.5, children: /* @__PURE__ */ p(
        Xt,
        {
          size: "large",
          name: "study-title",
          value: e.title,
          fullWidth: !0,
          color: o.palette.textColor.primary,
          onSubmit: function(u) {
            c("title", u);
          },
          disabled: s,
          required: !0
        }
      ) }),
      !!l && /* @__PURE__ */ F(ze, { children: [
        r && /* @__PURE__ */ p(O, { item: !0, ml: 1, className: "study-base-info__actions-additional", children: r }),
        !s && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            name: "study-delete",
            tooltipText: "Delete Study",
            noExpand: !0
          }
        ) })
      ] })
    ] })
  ] });
}, cI = ({
  onClick: e,
  size: t,
  children: n,
  iconName: r,
  tooltipText: i = "",
  id: a,
  name: o,
  className: s
}) => /* @__PURE__ */ p(yt, { text: i, children: /* @__PURE__ */ p(
  Ee,
  {
    id: a,
    name: o,
    className: s,
    color: "info",
    variant: "contained",
    onClick: e,
    size: t,
    startIcon: /* @__PURE__ */ p(he, { iconName: r }),
    children: n
  }
) }), uI = ({
  onClick: e,
  size: t,
  children: n,
  iconName: r,
  tooltipText: i = "",
  id: a,
  name: o,
  disabled: s = !1,
  isLoading: c = !1,
  sx: l
}) => /* @__PURE__ */ p(yt, { text: i, children: /* @__PURE__ */ p(
  Ee,
  {
    id: a,
    name: o,
    color: "info",
    onClick: e,
    variant: "outlined",
    size: t,
    disabled: s,
    startIcon: c ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: r }),
    sx: (u) => ({
      fontSize: { small: 14, medium: 16 }[t] || 14,
      px: 1.5,
      fontWeight: 700,
      borderColor: u.palette.borderColor.main
    }),
    children: n
  }
) }), Cl = ({
  onVersionRevert: e,
  onVersionSave: t,
  viewMode: n
}) => /* @__PURE__ */ F(ze, { children: [
  /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
    uI,
    {
      size: "small",
      iconName: "reload",
      name: "version-revert",
      onClick: () => {
        e();
      },
      tooltipText: "Back to current version",
      children: "Back to current version"
    }
  ) }),
  !n && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
    cI,
    {
      size: "small",
      iconName: "submit",
      name: "version-apply",
      tooltipText: "Restore version",
      onClick: () => {
        t();
      },
      children: "Restore version"
    }
  ) })
] });
function pm(e, t, n, r) {
  const { showDialog: i, hideDialog: a } = Mo(Xp);
  let o = $C(({ currentLocation: f, nextLocation: h }) => {
    const m = r ? !(r != null && r.some((y) => Uv(y, h.pathname))) : !0;
    return e && f.pathname !== h.pathname && m;
  });
  const s = sr(o);
  tt(() => {
    s.current = o;
  }, [o]);
  const c = ot(() => {
    const f = s.current;
    f.state === "blocked" && f.reset();
  }, []), l = ot(() => {
    const f = s.current;
    f.state === "blocked" && f.proceed();
  }, []), u = (f, h) => i(nm, {
    onSubmit: f,
    onDecline: h,
    onClose: a,
    text: /* @__PURE__ */ F(O, { container: !0, children: [
      /* @__PURE__ */ F(
        O,
        {
          item: !0,
          xs: 12,
          sx: {
            fontSize: 18,
            display: "flex",
            justifyContent: "space-between"
          },
          children: [
            /* @__PURE__ */ p(O, { item: !0, children: "Unsaved changes" }),
            /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
              bl,
              {
                onClick: () => {
                  a == null || a(), c();
                },
                size: "small",
                children: /* @__PURE__ */ p(he, { iconName: "close", sx: { fontSize: 16 } })
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
        /* @__PURE__ */ p(xa, { sx: { my: 1 } }),
        "Would you like to save ",
        /* @__PURE__ */ p("b", { children: t }),
        " changes?"
      ] })
    ] }),
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    variant: "error"
  });
  function d(f) {
    return function() {
      e ? u(
        async () => {
          await (n == null ? void 0 : n()), f == null || f();
        },
        () => {
          f == null || f();
        }
      ) : f == null || f();
    };
  }
  return tt(() => {
    o.state === "blocked" && u(
      () => {
        l(), n == null || n();
      },
      () => {
        l();
      }
    );
  }, [o.state, l]), tt(() => () => {
    c();
  }, [c]), {
    beforeLeave: d
  };
}
const cG = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onAnalysisSubmit: i,
  onSave: a,
  onCopy: o,
  AdditionalActions: s,
  AnalysisIcon: c,
  disableSave: l,
  versionPreview: u,
  onVersionRevert: d,
  onVersionSave: f,
  viewMode: h,
  onExport: m,
  canExecute: y,
  executionMessages: v = []
}) => {
  var k, g;
  const w = Sr();
  cr();
  const I = (A, b) => {
    const x = { ...e, [A]: b };
    if (r) {
      r(x);
      return;
    }
    n == null || n(x);
  }, { beforeLeave: M } = pm(!l, "Analysis", a, [
    "/workspace/analyses/:id/*",
    "/study-manager/:id/analyses/:id/*"
  ]);
  return /* @__PURE__ */ F(O, { container: !0, pb: 1, pt: 2, spacing: 1, className: "analysis-base-info", children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      c && /* @__PURE__ */ p(
        O,
        {
          item: !0,
          mr: 1.5,
          display: "flex",
          className: "analysis-base-info__icon",
          children: c
        }
      ),
      /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, children: /* @__PURE__ */ p(
        Xt,
        {
          name: "analysis-title",
          size: "medium",
          value: e == null ? void 0 : e.title,
          fullWidth: !0,
          color: w.palette.textColor.primary,
          onSubmit: function(A) {
            I("title", A);
          },
          submitOnClickOutside: !0,
          showActions: !1,
          disabled: h,
          required: !0
        }
      ) }),
      s && /* @__PURE__ */ p(O, { item: !0, ml: 1, className: "analysis-base-info__actions-additional", children: s }),
      u ? /* @__PURE__ */ p(
        Cl,
        {
          onVersionRevert: d,
          onVersionSave: f,
          viewMode: h
        }
      ) : /* @__PURE__ */ F(ze, { children: [
        !h && /* @__PURE__ */ F(ze, { children: [
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "error",
              iconName: "delete",
              onClick: t,
              tooltipText: "Delete",
              title: "Delete",
              name: "analysis-delete",
              noExpand: !0
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "primary",
              iconName: "copy",
              onClick: M(() => {
                o(e.id);
              }),
              name: "analysis-copy",
              tooltipText: "Copy",
              title: "Copy"
            }
          ) })
        ] }),
        ![pa.CUSTOM, pa.STRATEGUS].includes(
          e == null ? void 0 : e.type
        ) && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "export",
            onClick: M(m),
            tooltipText: "Export",
            title: "Export",
            name: "analysis-export"
          }
        ) }),
        !h && (e == null ? void 0 : e.type) !== pa.STRATEGUS && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "success",
            iconName: "save",
            tooltipText: "Save",
            title: "Save",
            disabled: l,
            onClick: a,
            name: "analysis-save-design"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: !u && !h && /* @__PURE__ */ p(
          yt,
          {
            text: v != null && v.length ? /* @__PURE__ */ F(le, { fontSize: 12, color: "white", children: [
              "Please fill in all required information before running the analysis:",
              v.map((A, b) => /* @__PURE__ */ p("li", { children: A }, "error" + b))
            ] }) : "Execute",
            children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
              Ee,
              {
                color: "info",
                variant: "contained",
                disabled: !y,
                onClick: M(i),
                name: "analysis-execute",
                startIcon: /* @__PURE__ */ p(he, { iconName: "submit" }),
                children: "Execute"
              }
            ) })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, container: !0, children: /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, display: "flex", children: [
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Hp[e == null ? void 0 : e.type] })
      ] }),
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(
          le,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Modified date:"
          }
        ),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.modified.timestamp) })
      ] }),
      /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ F(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: [
          (k = e == null ? void 0 : e.created) == null ? void 0 : k.user.firstName,
          " ",
          (g = e == null ? void 0 : e.created) == null ? void 0 : g.user.lastName
        ] })
      ] })
    ] }) }),
    !((h || u) && !(e != null && e.description)) && /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
      Xt,
      {
        name: "analysis-description",
        size: "small",
        value: e == null ? void 0 : e.description,
        fullWidth: !0,
        color: w.palette.textColor.secondary,
        placeholder: "Add description...",
        maxRows: 2,
        onSubmit: function(A) {
          I("description", A);
        },
        submitOnClickOutside: !0,
        showActions: !1,
        disabled: h
      }
    ) })
  ] });
}, fI = (e) => {
  const t = e.map((n) => lC.find((r) => r.id === n)).filter(Boolean);
  return (t == null ? void 0 : t.length) > 0 ? [
    {
      id: null,
      name: "Use in Analysis",
      desc: "",
      endGroup: !0
    },
    ...t
  ] : [];
}, dI = (e) => {
  const { onClickExtraActions: t, analysisTypes: n } = e, r = Ot((s) => s.user), { original: i, status: a } = NC({
    preloadAnalysisTypes: n,
    analyses: [],
    tenantId: r.data.activeTenant
  }), o = Ce(() => fI(i || []), [i]);
  return /* @__PURE__ */ p(
    Dv,
    {
      variant: "contained",
      color: "info",
      options: o,
      onClick: t,
      title: "Use in analysis",
      name: "use-in-analysis",
      closeOnSelect: !0,
      preventOverflow: !0,
      iconComponent: (s) => s.value ? /* @__PURE__ */ p(Pv, { ...s }) : /* @__PURE__ */ p(Gi, { value: wt.ANALYSIS }),
      disabled: [ve.INITIAL, ve.IN_PROGRESS].includes(a) || o.length === 0,
      startIcon: /* @__PURE__ */ p(he, { iconName: "add", sx: { "&.MuiSvgIcon-root": { fontSize: 16 } } })
    }
  );
}, uG = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onGenerate: i,
  onCopy: a,
  AdditionalActions: o,
  versionPreview: s,
  onVersionRevert: c,
  onVersionSave: l,
  onPublish: u,
  backToListPath: d,
  viewMode: f,
  disableSave: h,
  onClickExtraActions: m,
  onExport: y,
  analysisTypes: v,
  libraryMode: w,
  shareable: I,
  onShare: M,
  onArchive: k,
  nameError: g
}) => {
  const A = Sr();
  cr();
  const b = (_, R) => {
    const P = { ...e, [_]: R };
    if (r) {
      r(P);
      return;
    }
    n(P);
  };
  pm(
    !h && !f,
    "Cohort",
    () => n(e),
    ["/workspace/cohorts/:id/*", "/study-manager/:id/cohorts/:id/*"]
  );
  const x = f && !w || s;
  return /* @__PURE__ */ F(O, { container: !0, pb: 1, pt: 2, spacing: 1, className: "cohort-base-info", children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      e.terminated && /* @__PURE__ */ p(O, { item: !0, mr: 1.5, children: /* @__PURE__ */ p(we, { display: "flex", children: /* @__PURE__ */ p(
        bl,
        {
          color: "warning",
          onClick: () => {
          },
          sx: (_) => ({
            backgroundColor: Bi(0.8, _.palette.grey[500]),
            p: 0,
            my: -1,
            minWidth: 110,
            height: 26,
            fontSize: 14,
            borderRadius: 1,
            pointerEvents: "none",
            color: _.palette.grey[600],
            cursor: "default"
          }),
          children: /* @__PURE__ */ F(
            we,
            {
              className: "archived-icon",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              flexWrap: "nowrap",
              children: [
                /* @__PURE__ */ p(
                  he,
                  {
                    iconName: "terminated",
                    sx: (_) => ({
                      color: _.palette.grey[500],
                      fontSize: 18,
                      mr: 1
                    })
                  }
                ),
                /* @__PURE__ */ p("div", { children: "Archived" })
              ]
            }
          )
        }
      ) }) }),
      /* @__PURE__ */ p(O, { item: !0, mr: 1.5, display: "flex", className: "analysis-base-info__icon", children: /* @__PURE__ */ p(Gi, { value: wt.COHORT, size: 32 }) }),
      /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, children: [
        /* @__PURE__ */ p(
          Xt,
          {
            size: "medium",
            value: e.name,
            fullWidth: !0,
            color: A.palette.textColor.primary,
            onSubmit: function(_) {
              b("name", _);
            },
            submitOnClickOutside: !0,
            showActions: !1,
            disabled: x,
            name: "cohort-name",
            required: !0
          }
        ),
        g && /* @__PURE__ */ p(le, { variant: "caption", color: "error.main", children: g })
      ] }),
      o && /* @__PURE__ */ p(O, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: o }),
      s ? /* @__PURE__ */ p(
        Cl,
        {
          onVersionRevert: c,
          onVersionSave: l,
          viewMode: f
        }
      ) : f ? /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        Ue,
        {
          color: "primary",
          iconName: "export",
          onClick: y,
          tooltipText: "Export",
          title: "Export",
          name: "cohort-export"
        }
      ) }) }) : /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "success",
            iconName: "save",
            disabled: h,
            title: "Save",
            tooltipText: "Save",
            name: "cohort-save",
            onClick: () => {
              n(e);
            }
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "copy",
            onClick: () => {
              a(e.id);
            },
            tooltipText: "Copy",
            title: "Copy",
            name: "cohort-copy"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "export",
            onClick: y,
            tooltipText: "Export",
            title: "Export",
            name: "cohort-export"
          }
        ) }),
        i && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "stars",
            onClick: i,
            tooltipText: "Regenerate",
            title: "Regenerate",
            name: "cohort-regenerate"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "publish",
            onClick: u,
            tooltipText: "Publish",
            title: "Publish",
            name: "cohort-publish"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            title: "Delete",
            tooltipText: "Delete",
            name: "cohort-delete",
            noExpand: !0
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          dI,
          {
            onClickExtraActions: m,
            analysisTypes: v
          }
        ) })
      ] }),
      k && !s && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        Ue,
        {
          color: "primary",
          iconName: "terminated",
          onClick: k,
          tooltipText: "Archive",
          title: "Archive",
          name: "cohort-archive"
        }
      ) }),
      I && /* @__PURE__ */ p(O, { item: !0, m: 1, children: /* @__PURE__ */ p(
        Ee,
        {
          onClick: M,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ p(he, { iconName: "share" }),
          className: "share-cohort",
          children: "Share"
        }
      ) })
    ] }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Cohort" })
      ] }),
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !(x && !e.description) && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Xt,
      {
        value: e.description,
        onSubmit: (_) => b("description", _),
        submitOnClickOutside: !0,
        showActions: !1,
        color: A.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: f ? "..." : "Add description...",
        disabled: x,
        name: "cohort-description",
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, hI = ({ value: e, getValue: t, size: n = 24, ...r }) => {
  const i = e || (t == null ? void 0 : t()), a = Hi(), o = Ot((s) => s.images.images[i]);
  return tt(() => {
    o || a(HC(i));
  }, [i]), o != null && o.image ? /* @__PURE__ */ p(_C, { image: o.image, size: n }) : /* @__PURE__ */ p(he, { iconName: "imagePlaceholder", sx: { fontSize: n, opacity: 0.4 } });
}, fG = ({
  entity: e,
  onInvite: t,
  actions: n
}) => {
  const r = Ce(
    () => !(!(e != null && e.actions) || n != null && n[kC.UPDATE]),
    [n]
  ), i = Ot(
    (a) => {
      var o;
      return (o = a.images.images[e == null ? void 0 : e.id]) == null ? void 0 : o.image;
    }
  );
  return /* @__PURE__ */ F(O, { container: !0, py: 1.5, pb: 2, alignItems: "center", pt: 2, children: [
    i && /* @__PURE__ */ p(hI, { value: e.id, size: 45 }),
    /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, alignItems: "center", ml: i ? 3 : 0, children: [
      /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", pb: 1.5, children: [
        /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, children: /* @__PURE__ */ p(gx, { dataSource: e, isHeader: !0 }) }),
        !r && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            onClick: t,
            iconName: "add",
            color: "success",
            name: "invite-to-study",
            title: "Invite to study",
            noCollapse: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, spacing: 2, children: [
        /* @__PURE__ */ F(O, { item: !0, children: [
          /* @__PURE__ */ p(
            le,
            {
              variant: "subtitle2",
              component: "label",
              sx: { mr: 0.5 },
              children: "Created date:"
            }
          ),
          /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.created.timestamp) })
        ] }),
        /* @__PURE__ */ F(O, { item: !0, children: [
          /* @__PURE__ */ p(
            le,
            {
              variant: "subtitle2",
              component: "label",
              sx: { mr: 0.5 },
              children: "Updated date:"
            }
          ),
          /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.modified.timestamp) })
        ] })
      ] }) })
    ] })
  ] });
}, dG = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onCopy: i,
  AdditionalActions: a,
  versionPreview: o,
  onVersionRevert: s,
  onVersionSave: c,
  onPublish: l,
  backToListPath: u,
  viewMode: d,
  disableSave: f,
  onExport: h,
  onClickExtraActions: m,
  libraryMode: y,
  shareable: v,
  onShare: w,
  onGenerate: I,
  onCompare: M,
  onArchive: k,
  saveInProgress: g,
  isCompareLoading: A,
  onSuggest: b,
  suggestionStatus: x,
  nameError: _,
  saveOnlyActions: R = !1
}) => {
  const P = Sr(), { beforeLeave: E } = pm(
    !f,
    "Concept Set",
    () => n(e),
    ["/workspace/concept-sets/:id/*", "/study-manager/:id/concept-sets/:id/*"]
  ), C = (D, z) => {
    const B = { ...e, [D]: z };
    if (r) {
      r(B);
      return;
    }
    n(B);
  }, T = d && !y || o;
  return /* @__PURE__ */ F(O, { container: !0, pb: 1, pt: 2, spacing: 1, className: "concept-set-base-info", children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(O, { item: !0, mr: 1.5, display: "flex", className: "analysis-base-info__icon", children: /* @__PURE__ */ p(Gi, { value: wt.CONCEPT_SET, size: 32 }) }),
      /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, children: [
        /* @__PURE__ */ p(
          Xt,
          {
            size: "medium",
            name: "concept-set-name",
            value: e.name,
            fullWidth: !0,
            color: P.palette.textColor.primary,
            onSubmit: function(D) {
              C("name", D);
            },
            submitOnClickOutside: !0,
            showActions: !1,
            disabled: T,
            required: !0
          }
        ),
        _ && /* @__PURE__ */ p(le, { variant: "caption", color: "error.main", children: _ })
      ] }),
      a && /* @__PURE__ */ p(
        O,
        {
          item: !0,
          ml: 1,
          className: "concept-set-base-info__actions-additional",
          children: a
        }
      ),
      o ? /* @__PURE__ */ F(ze, { children: [
        " ",
        M && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "compare",
            size: "small",
            disabled: A,
            onClick: M,
            tooltipText: "Compare",
            loading: A,
            title: "Compare",
            name: "concept-set-compare"
          }
        ) }),
        /* @__PURE__ */ p(
          Cl,
          {
            onVersionRevert: s,
            onVersionSave: c,
            viewMode: d
          }
        )
      ] }) : d ? /* @__PURE__ */ F(ze, { children: [
        M && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "compare",
            disabled: A,
            onClick: M,
            tooltipText: "Compare",
            loading: A,
            title: "Compare",
            name: "concept-set-compare"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "export",
            onClick: h,
            tooltipText: "Export",
            title: "Export"
          }
        ) })
      ] }) : /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "success",
            disabled: f,
            iconName: "save",
            tooltipText: "Save",
            title: "Save",
            loading: g === ve.IN_PROGRESS,
            name: "concept-set-save",
            onClick: () => {
              n(e);
            }
          }
        ) }),
        !R && /* @__PURE__ */ F(ze, { children: [
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "primary",
              iconName: "copy",
              onClick: E(() => {
                i(e.id);
              }),
              tooltipText: "Copy",
              title: "Copy",
              name: "concept-set-copy"
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "primary",
              disabled: !f,
              iconName: "export",
              onClick: E(h),
              tooltipText: "Export",
              title: "Export",
              name: "concept-set-export"
            }
          ) }),
          (I || b) && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            SC,
            {
              color: "primary",
              title: "AI",
              iconName: "stars",
              tooltipText: "Regenerate",
              placement: "bottom-start",
              onItemClick: (D) => {
                switch (D.id) {
                  case "regenerate":
                    I == null || I();
                    break;
                  case "suggest":
                    b == null || b();
                    break;
                }
              },
              options: [
                ...I ? [
                  {
                    name: "Regenerate",
                    id: "regenerate"
                  }
                ] : [],
                ...b ? [
                  {
                    name: "Suggest",
                    id: "suggest",
                    disabled: x === C0.IN_PROGRESS,
                    message: x === C0.IN_PROGRESS ? "Suggestion in progress" : ""
                  }
                ] : []
              ]
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "primary",
              iconName: "publish",
              onClick: E(l),
              tooltipText: "Publish",
              title: "Publish",
              name: "concept-set-publish"
            }
          ) }),
          M && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "primary",
              iconName: "compare",
              disabled: A,
              onClick: M,
              tooltipText: "Compare",
              loading: A,
              title: "Compare",
              name: "concept-set-compare"
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ue,
            {
              color: "error",
              iconName: "delete",
              onClick: t,
              title: "Delete",
              tooltipText: "Delete",
              name: "concept-set-delete",
              noExpand: !0
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
            Ee,
            {
              startIcon: /* @__PURE__ */ p(he, { iconName: "add" }),
              variant: "contained",
              color: "info",
              name: "create-cohort",
              onClick: () => {
                m(e);
              },
              children: "Use in Cohort"
            }
          ) })
        ] })
      ] }),
      k && !o && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        Ue,
        {
          color: "primary",
          iconName: "terminated",
          onClick: k,
          tooltipText: "Archive",
          title: "Archive",
          name: "concept-set-archive"
        }
      ) }),
      v && !R && /* @__PURE__ */ p(O, { item: !0, m: 1, children: /* @__PURE__ */ p(
        Ee,
        {
          onClick: w,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ p(he, { iconName: "share" }),
          className: "share-cohort",
          children: "Share"
        }
      ) })
    ] }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Concept set" })
      ] }),
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !(T && !e.description) && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Xt,
      {
        name: "concept-set-description",
        value: e.description,
        onSubmit: (D) => C("description", D),
        submitOnClickOutside: !0,
        showActions: !1,
        color: P.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: d ? "..." : "Add description...",
        disabled: T,
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, hG = ({ entity: e, AdditionalActions: t, AnalysisIcon: n, submission: r }) => {
  var o, s;
  const i = Sr(), a = cr();
  return /* @__PURE__ */ F(
    O,
    {
      container: !0,
      pb: 1,
      pt: 2,
      spacing: 1,
      className: "analysis-results-base-info",
      children: [
        /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
          r && /* @__PURE__ */ p(O, { item: !0, mr: 1.5, display: "flex", children: /* @__PURE__ */ p(Qk, { status: r.status }) }),
          n && /* @__PURE__ */ p(O, { item: !0, mr: 1.5, display: "flex", children: n }),
          /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
            Xt,
            {
              size: "medium",
              value: e == null ? void 0 : e.title,
              fullWidth: !0,
              color: i.palette.textColor.primary,
              onSubmit: function() {
              },
              disabled: !0,
              required: !0
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, ml: 0.5, children: /* @__PURE__ */ F(Ee, { size: "small", color: "info", onClick: () => a(".."), children: [
            "<",
            " Back to Analysis results"
          ] }) }),
          t && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: t })
        ] }),
        /* @__PURE__ */ p(O, { item: !0, xs: 12, container: !0, justifyContent: "space-between", children: /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, display: "flex", flexWrap: "wrap", children: [
          /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: "Type:"
              }
            ),
            /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Hp[e == null ? void 0 : e.type] })
          ] }),
          /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: "ID:"
              }
            ),
            /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e == null ? void 0 : e.shortcut })
          ] }),
          /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: "Author:"
              }
            ),
            /* @__PURE__ */ F(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: [
              (o = e == null ? void 0 : e.created) == null ? void 0 : o.user.firstName,
              " ",
              (s = e == null ? void 0 : e.created) == null ? void 0 : s.user.lastName
            ] })
          ] }),
          r && /* @__PURE__ */ F(ze, { children: [
            /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
              /* @__PURE__ */ p(
                le,
                {
                  variant: "subtitle2",
                  component: "label",
                  sx: { mr: 0.5 },
                  children: "Submitted at:"
                }
              ),
              /* @__PURE__ */ p(
                le,
                {
                  variant: "subtitle2",
                  component: "span",
                  fontWeight: 700,
                  children: Vn(r.created.timestamp)
                }
              )
            ] }),
            /* @__PURE__ */ F(O, { item: !0, children: [
              /* @__PURE__ */ p(
                le,
                {
                  variant: "subtitle2",
                  component: "label",
                  sx: { mr: 0.5 },
                  children: "Data source:"
                }
              ),
              /* @__PURE__ */ p(
                le,
                {
                  variant: "subtitle2",
                  component: "span",
                  fontWeight: 700,
                  sx: {
                    div: {
                      color: "textColor.secondary"
                    }
                  },
                  children: /* @__PURE__ */ p(
                    gx,
                    {
                      isHeader: !1,
                      dataSource: r.dataSource
                    }
                  )
                }
              )
            ] })
          ] })
        ] }) }),
        (e == null ? void 0 : e.description) && /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
          Xt,
          {
            size: "small",
            value: e == null ? void 0 : e.description,
            fullWidth: !0,
            color: i.palette.textColor.secondary,
            placeholder: "Add description...",
            maxRows: 2,
            onSubmit: () => {
            },
            disabled: !0
          }
        ) })
      ]
    }
  );
}, pG = ({
  entity: e,
  onDelete: t,
  onSubmit: n,
  onChange: r,
  onCopy: i,
  AdditionalActions: a,
  versionPreview: o,
  onVersionRevert: s,
  onVersionSave: c,
  onPublish: l,
  backToListPath: u,
  viewMode: d,
  disableSave: f,
  onExport: h,
  onArchive: m
}) => {
  const y = Sr();
  cr();
  const v = (w, I) => {
    const M = { ...e, [w]: I };
    if (r) {
      r(M);
      return;
    }
    n(M);
  };
  return /* @__PURE__ */ F(O, { container: !0, pb: 1, pt: 2, spacing: 1, className: "cohort-base-info", children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(
        O,
        {
          item: !0,
          mr: 1.5,
          display: "flex",
          className: "analysis-base-info__icon",
          children: /* @__PURE__ */ p(Gi, { value: wt.ANALYSIS, size: 32 })
        }
      ),
      /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
        Xt,
        {
          size: "medium",
          value: e.name,
          fullWidth: !0,
          color: y.palette.textColor.primary,
          onSubmit: function(w) {
            v("name", w);
          },
          submitOnClickOutside: !0,
          showActions: !1,
          disabled: d || o,
          name: "cohort-name",
          required: !0
        }
      ) }),
      a && /* @__PURE__ */ p(O, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: a }),
      o ? /* @__PURE__ */ p(
        Cl,
        {
          onVersionRevert: s,
          onVersionSave: c,
          viewMode: d
        }
      ) : d ? /* @__PURE__ */ p(ze, { children: m && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        Ue,
        {
          color: "primary",
          iconName: "terminated",
          onClick: m,
          tooltipText: "Archive",
          title: "Archive",
          name: "feature-analysis-archive"
        }
      ) }) }) : /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            tooltipText: "Delete",
            title: "Delete",
            name: "cohort-delete",
            noExpand: !0
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "copy",
            onClick: () => {
              i(e.id);
            },
            tooltipText: "Copy",
            title: "Copy",
            name: "cohort-copy"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "export",
            onClick: h,
            tooltipText: "Export",
            title: "Export",
            name: "cohort-export"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "publish",
            onClick: l,
            tooltipText: "Publish",
            title: "Publish",
            name: "cohort-publish"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "success",
            iconName: "save",
            disabled: f,
            tooltipText: "Save",
            title: "Save",
            name: "cohort-save",
            onClick: () => {
              n(e);
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Feature analysis" })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(
          le,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Modified date:"
          }
        ),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(
          le,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Author:"
          }
        ),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !((d || o) && !e.description) && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Xt,
      {
        value: e.description,
        onSubmit: (w) => v("description", w),
        submitOnClickOutside: !0,
        showActions: !1,
        color: y.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: d ? "..." : "Add description...",
        disabled: d || o,
        name: "cohort-description",
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, mG = ({
  entity: e,
  onSubmit: t,
  onDelete: n,
  onPublish: r
}) => {
  var c, l, u;
  const { t: i } = Ma(), a = cr(), o = Xr(), s = (d, f) => {
    t({ ...e, [d]: f });
  };
  return /* @__PURE__ */ F(O, { container: !0, py: 1.5, pb: 2, alignItems: "center", spacing: 0.5, children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
        Xt,
        {
          size: "medium",
          value: e == null ? void 0 : e.name,
          fullWidth: !0,
          color: o.palette.textColor.primary,
          onSubmit: function(d) {
            s("name", d);
          },
          name: "database-name",
          required: !0
        }
      ) }),
      /* @__PURE__ */ F(O, { item: !0, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ F(Ee, { size: "small", color: "info", onClick: () => a(".."), children: [
          "<",
          " ",
          i("modules.administration.databases.back_database")
        ] }) }),
        /* @__PURE__ */ F(
          O,
          {
            item: !0,
            mx: 1,
            sx: {
              ".status-tag": {
                height: 24,
                lineHeight: "24px",
                mx: 0
              }
            },
            children: [
              ((c = e == null ? void 0 : e.published) == null ? void 0 : c.length) > 0 ? /* @__PURE__ */ p(
                Qp,
                {
                  text: i("statuses.published"),
                  color: "success",
                  align: "center",
                  light: !0
                }
              ) : /* @__PURE__ */ p(
                Ee,
                {
                  size: "small",
                  onClick: (d) => {
                    d.stopPropagation(), r == null || r();
                  },
                  color: "info",
                  variant: "outlined",
                  startIcon: /* @__PURE__ */ p(he, { iconName: "publish" }),
                  sx: {
                    px: 2,
                    py: 0.25,
                    borderRadius: 0.5,
                    fontSize: 12,
                    minWidth: 98
                  },
                  children: i("buttons.publish")
                }
              ),
              " "
            ]
          }
        ),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "error",
            iconName: "delete",
            onClick: n,
            tooltipText: i("tooltips.delete"),
            name: "analysis-delete",
            noExpand: !0
          }
        ) })
      ] })
    ] }),
    " ",
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      O,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        alignItems: "center",
        children: /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, display: "flex", children: [
          /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: i("forms.created_date")
              }
            ),
            /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn((l = e == null ? void 0 : e.created) == null ? void 0 : l.timestamp) })
          ] }),
          /* @__PURE__ */ F(O, { item: !0, children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle2",
                component: "label",
                sx: { mr: 0.5 },
                children: i("forms.updated_date")
              }
            ),
            /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn((u = e == null ? void 0 : e.modified) == null ? void 0 : u.timestamp) })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, mx: -1, children: /* @__PURE__ */ p(
      Xt,
      {
        size: "small",
        value: e == null ? void 0 : e.description,
        fullWidth: !0,
        color: o.palette.textColor.primary,
        onSubmit: function(d) {
          s("description", d);
        },
        name: "database-description",
        multiline: !0,
        maxRows: 3
      }
    ) })
  ] });
}, gG = ({ entity: e, updateEntity: t }) => {
  const [n, r] = Te(!1), [i, a] = Te(
    e || {
      url: "",
      token: ""
    }
  );
  return tt(() => {
    a(
      e || {
        url: "",
        token: ""
      }
    );
  }, [e]), /* @__PURE__ */ p(O, { container: !0, pt: 2.5, pb: 1.5, alignItems: "center", px: 1, children: /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "flex-start", children: [
    /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, pr: 2, children: /* @__PURE__ */ F(O, { container: !0, spacing: 0.5, children: [
      /* @__PURE__ */ F(
        O,
        {
          item: !0,
          xs: 8,
          alignItems: "center",
          display: "flex",
          minHeight: 40,
          children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle1",
                component: "label",
                sx: { mr: 1, whiteSpace: "nowrap", minWidth: 90 },
                children: "ATHENA URL"
              }
            ),
            /* @__PURE__ */ p(
              xr,
              {
                value: i.url,
                fullWidth: !0,
                onChange: (o) => {
                  a((s) => ({ ...s, url: o.target.value }));
                },
                disabled: !n,
                placeholder: "ATHENA URL...",
                sx: n ? void 0 : {
                  ".Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.87)",
                    "-webkit-text-fill-color": "rgba(0, 0, 0, 0.87)"
                  },
                  ".input-root:hover .input-notched-outline, .input-notched-outline": {
                    borderWidth: "0",
                    border: "none"
                  }
                }
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ F(
        O,
        {
          item: !0,
          xs: 8,
          alignItems: "center",
          display: "flex",
          minHeight: 40,
          children: [
            /* @__PURE__ */ p(
              le,
              {
                variant: "subtitle1",
                component: "label",
                sx: { mr: 1, whiteSpace: "nowrap", minWidth: 90 },
                children: "ATHENA token"
              }
            ),
            /* @__PURE__ */ p(
              xr,
              {
                value: i.token,
                type: "password",
                fullWidth: !0,
                onChange: (o) => {
                  a((s) => ({ ...s, token: o.target.value }));
                },
                disabled: !n,
                placeholder: "***********",
                sx: n ? void 0 : {
                  ".Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.87)",
                    "-webkit-text-fill-color": "rgba(0, 0, 0, 0.87)"
                  },
                  ".input-root:hover .input-notched-outline, .input-notched-outline": {
                    borderWidth: "0",
                    border: "none"
                  }
                }
              }
            )
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ p(O, { item: !0, display: "flex", justifyContent: "flex-end", minWidth: 64, children: n ? /* @__PURE__ */ F(ze, { children: [
      /* @__PURE__ */ p(O, { item: !0, mr: 1, children: /* @__PURE__ */ p(
        Ue,
        {
          onClick: function() {
            t(i), r(!1);
          },
          color: "success",
          iconName: "submit",
          tooltipText: "Submit",
          title: "Submit",
          name: "submit"
        }
      ) }),
      /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
        Ue,
        {
          onClick: function() {
            r(!1);
          },
          color: "error",
          iconName: "deactivate",
          tooltipText: "Cancel",
          title: "Cancel",
          name: "cancel"
        }
      ) })
    ] }) : /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
      Ue,
      {
        onClick: function() {
          r(!0);
        },
        color: "info",
        iconName: "edit",
        tooltipText: "Edit",
        title: "Edit",
        name: "edit"
      }
    ) }) })
  ] }) });
}, yG = ({
  entity: e = {},
  onDelete: t,
  onSubmit: n,
  onCopy: r,
  AdditionalActions: i,
  versionPreview: a,
  onVersionRevert: o,
  onVersionSave: s,
  onPublish: c,
  backToListPath: l,
  viewMode: u,
  disableSave: d,
  onExport: f,
  onArchive: h
}) => {
  const m = Sr();
  cr();
  const y = (v, w) => {
    n({ ...e, [v]: w });
  };
  return /* @__PURE__ */ F(O, { container: !0, pb: 1, pt: 2, spacing: 1, className: "cohort-base-info", children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ p(O, { item: !0, mr: 1.5, display: "flex", className: "analysis-base-info__icon", children: /* @__PURE__ */ p(Gi, { value: wt.CUSTOM_CODE, size: 32 }) }),
      /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, mx: -1, children: /* @__PURE__ */ p(
        Xt,
        {
          size: "medium",
          value: e == null ? void 0 : e.title,
          fullWidth: !0,
          color: m.palette.textColor.primary,
          onSubmit: function(v) {
            y("name", v);
          },
          disabled: u || a,
          name: "cohort-name",
          required: !0
        }
      ) }),
      i && /* @__PURE__ */ p(O, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: i }),
      a ? /* @__PURE__ */ p(
        Cl,
        {
          onVersionRevert: o,
          onVersionSave: s,
          viewMode: u
        }
      ) : u ? /* @__PURE__ */ p(ze, { children: h && /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
        Ue,
        {
          color: "primary",
          iconName: "terminated",
          onClick: h,
          tooltipText: "Archive",
          title: "Archive",
          name: "custom-code-archive"
        }
      ) }) }) : /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "error",
            iconName: "delete",
            onClick: t,
            tooltipText: "Delete",
            title: "Delete",
            name: "cohort-delete",
            noExpand: !0
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "copy",
            onClick: () => {
              r(e.id);
            },
            tooltipText: "Copy",
            title: "Copy",
            name: "cohort-copy"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "export",
            onClick: f,
            tooltipText: "Export",
            title: "Export",
            name: "cohort-export"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "primary",
            iconName: "publish",
            onClick: c,
            tooltipText: "Publish",
            title: "Publish",
            name: "cohort-publish"
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, ml: 1, children: /* @__PURE__ */ p(
          Ue,
          {
            color: "success",
            iconName: "save",
            disabled: d,
            tooltipText: "Save",
            title: "Save",
            name: "cohort-save",
            onClick: () => {
              n(e);
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ F(O, { item: !0, mr: 2, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Custom code" })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: Vn(e.modified.timestamp) })
      ] }),
      e.created && e.created.user && /* @__PURE__ */ F(O, { item: !0, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ p(le, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !((u || a) && !e.description) && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      Xt,
      {
        value: e.description,
        onSubmit: (v) => y("description", v),
        color: m.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: u ? "..." : "Add description...",
        disabled: u || a,
        name: "cohort-description",
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
};
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Bx;
function Se() {
  return Bx.apply(null, arguments);
}
function pI(e) {
  Bx = e;
}
function br(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function ga(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function st(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function mm(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (st(e, t))
      return !1;
  return !0;
}
function In(e) {
  return e === void 0;
}
function gi(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function El(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Fx(e, t) {
  var n = [], r, i = e.length;
  for (r = 0; r < i; ++r)
    n.push(t(e[r], r));
  return n;
}
function Ii(e, t) {
  for (var n in t)
    st(t, n) && (e[n] = t[n]);
  return st(t, "toString") && (e.toString = t.toString), st(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function Jr(e, t, n, r) {
  return cb(e, t, n, r, !0).utc();
}
function mI() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Xe(e) {
  return e._pf == null && (e._pf = mI()), e._pf;
}
var Nh;
Array.prototype.some ? Nh = Array.prototype.some : Nh = function(e) {
  var t = Object(this), n = t.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function gm(e) {
  if (e._isValid == null) {
    var t = Xe(e), n = Nh.call(t.parsedDateParts, function(i) {
      return i != null;
    }), r = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
    if (e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = r;
    else
      return r;
  }
  return e._isValid;
}
function df(e) {
  var t = Jr(NaN);
  return e != null ? Ii(Xe(t), e) : Xe(t).userInvalidated = !0, t;
}
var gy = Se.momentProperties = [], md = !1;
function ym(e, t) {
  var n, r, i, a = gy.length;
  if (In(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), In(t._i) || (e._i = t._i), In(t._f) || (e._f = t._f), In(t._l) || (e._l = t._l), In(t._strict) || (e._strict = t._strict), In(t._tzm) || (e._tzm = t._tzm), In(t._isUTC) || (e._isUTC = t._isUTC), In(t._offset) || (e._offset = t._offset), In(t._pf) || (e._pf = Xe(t)), In(t._locale) || (e._locale = t._locale), a > 0)
    for (n = 0; n < a; n++)
      r = gy[n], i = t[r], In(i) || (e[r] = i);
  return e;
}
function kl(e) {
  ym(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), md === !1 && (md = !0, Se.updateOffset(this), md = !1);
}
function wr(e) {
  return e instanceof kl || e != null && e._isAMomentObject != null;
}
function Yx(e) {
  Se.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ur(e, t) {
  var n = !0;
  return Ii(function() {
    if (Se.deprecationHandler != null && Se.deprecationHandler(null, e), n) {
      var r = [], i, a, o, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (i = "", typeof arguments[a] == "object") {
          i += `
[` + a + "] ";
          for (o in arguments[0])
            st(arguments[0], o) && (i += o + ": " + arguments[0][o] + ", ");
          i = i.slice(0, -2);
        } else
          i = arguments[a];
        r.push(i);
      }
      Yx(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var yy = {};
function jx(e, t) {
  Se.deprecationHandler != null && Se.deprecationHandler(e, t), yy[e] || (Yx(t), yy[e] = !0);
}
Se.suppressDeprecationWarnings = !1;
Se.deprecationHandler = null;
function Kr(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function gI(e) {
  var t, n;
  for (n in e)
    st(e, n) && (t = e[n], Kr(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Oh(e, t) {
  var n = Ii({}, e), r;
  for (r in t)
    st(t, r) && (ga(e[r]) && ga(t[r]) ? (n[r] = {}, Ii(n[r], e[r]), Ii(n[r], t[r])) : t[r] != null ? n[r] = t[r] : delete n[r]);
  for (r in e)
    st(e, r) && !st(t, r) && ga(e[r]) && (n[r] = Ii({}, n[r]));
  return n;
}
function Am(e) {
  e != null && this.set(e);
}
var Rh;
Object.keys ? Rh = Object.keys : Rh = function(e) {
  var t, n = [];
  for (t in e)
    st(e, t) && n.push(t);
  return n;
};
var yI = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function AI(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return Kr(r) ? r.call(t, n) : r;
}
function Hr(e, t, n) {
  var r = "" + Math.abs(e), i = t - r.length, a = e >= 0;
  return (a ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
}
var vm = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Zl = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, gd = {}, ao = {};
function Ye(e, t, n, r) {
  var i = r;
  typeof r == "string" && (i = function() {
    return this[r]();
  }), e && (ao[e] = i), t && (ao[t[0]] = function() {
    return Hr(i.apply(this, arguments), t[1], t[2]);
  }), n && (ao[n] = function() {
    return this.localeData().ordinal(
      i.apply(this, arguments),
      e
    );
  });
}
function vI(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function xI(e) {
  var t = e.match(vm), n, r;
  for (n = 0, r = t.length; n < r; n++)
    ao[t[n]] ? t[n] = ao[t[n]] : t[n] = vI(t[n]);
  return function(i) {
    var a = "", o;
    for (o = 0; o < r; o++)
      a += Kr(t[o]) ? t[o].call(i, e) : t[o];
    return a;
  };
}
function Oc(e, t) {
  return e.isValid() ? (t = $x(t, e.localeData()), gd[t] = gd[t] || xI(t), gd[t](e)) : e.localeData().invalidDate();
}
function $x(e, t) {
  var n = 5;
  function r(i) {
    return t.longDateFormat(i) || i;
  }
  for (Zl.lastIndex = 0; n >= 0 && Zl.test(e); )
    e = e.replace(
      Zl,
      r
    ), Zl.lastIndex = 0, n -= 1;
  return e;
}
var bI = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function wI(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(vm).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var _I = "Invalid date";
function SI() {
  return this._invalidDate;
}
var CI = "%d", EI = /\d{1,2}/;
function kI(e) {
  return this._ordinal.replace("%d", e);
}
var TI = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function MI(e, t, n, r) {
  var i = this._relativeTime[n];
  return Kr(i) ? i(e, t, n, r) : i.replace(/%d/i, e);
}
function II(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return Kr(n) ? n(t) : n.replace(/%s/i, t);
}
var Ms = {};
function yn(e, t) {
  var n = e.toLowerCase();
  Ms[n] = Ms[n + "s"] = Ms[t] = e;
}
function fr(e) {
  return typeof e == "string" ? Ms[e] || Ms[e.toLowerCase()] : void 0;
}
function xm(e) {
  var t = {}, n, r;
  for (r in e)
    st(e, r) && (n = fr(r), n && (t[n] = e[r]));
  return t;
}
var Wx = {};
function An(e, t) {
  Wx[e] = t;
}
function NI(e) {
  var t = [], n;
  for (n in e)
    st(e, n) && t.push({ unit: n, priority: Wx[n] });
  return t.sort(function(r, i) {
    return r.priority - i.priority;
  }), t;
}
function hf(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function nr(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function et(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = nr(t)), n;
}
function Ro(e, t) {
  return function(n) {
    return n != null ? (Ux(this, e, n), Se.updateOffset(this, t), this) : eu(this, e);
  };
}
function eu(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function Ux(e, t, n) {
  e.isValid() && !isNaN(n) && (t === "FullYear" && hf(e.year()) && e.month() === 1 && e.date() === 29 ? (n = et(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    n,
    e.month(),
    vf(n, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
}
function OI(e) {
  return e = fr(e), Kr(this[e]) ? this[e]() : this;
}
function RI(e, t) {
  if (typeof e == "object") {
    e = xm(e);
    var n = NI(e), r, i = n.length;
    for (r = 0; r < i; r++)
      this[n[r].unit](e[n[r].unit]);
  } else if (e = fr(e), Kr(this[e]))
    return this[e](t);
  return this;
}
var Hx = /\d/, qn = /\d\d/, Gx = /\d{3}/, bm = /\d{4}/, pf = /[+-]?\d{6}/, Tt = /\d\d?/, Vx = /\d\d\d\d?/, Qx = /\d\d\d\d\d\d?/, mf = /\d{1,3}/, wm = /\d{1,4}/, gf = /[+-]?\d{1,6}/, Do = /\d+/, yf = /[+-]?\d+/, DI = /Z|[+-]\d\d:?\d\d/gi, Af = /Z|[+-]\d\d(?::?\d\d)?/gi, PI = /[+-]?\d+(\.\d{1,3})?/, Tl = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, tu;
tu = {};
function Me(e, t, n) {
  tu[e] = Kr(t) ? t : function(r, i) {
    return r && n ? n : t;
  };
}
function LI(e, t) {
  return st(tu, e) ? tu[e](t._strict, t._locale) : new RegExp(zI(e));
}
function zI(e) {
  return jn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, r, i, a) {
        return n || r || i || a;
      }
    )
  );
}
function jn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Dh = {};
function vt(e, t) {
  var n, r = t, i;
  for (typeof e == "string" && (e = [e]), gi(t) && (r = function(a, o) {
    o[t] = et(a);
  }), i = e.length, n = 0; n < i; n++)
    Dh[e[n]] = r;
}
function Ml(e, t) {
  vt(e, function(n, r, i, a) {
    i._w = i._w || {}, t(n, i._w, i, a);
  });
}
function BI(e, t, n) {
  t != null && st(Dh, e) && Dh[e](t, n._a, n, e);
}
var gn = 0, ui = 1, Br = 2, Qt = 3, gr = 4, fi = 5, ma = 6, FI = 7, YI = 8;
function jI(e, t) {
  return (e % t + t) % t;
}
var Ft;
Array.prototype.indexOf ? Ft = Array.prototype.indexOf : Ft = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function vf(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = jI(t, 12);
  return e += (t - n) / 12, n === 1 ? hf(e) ? 29 : 28 : 31 - n % 7 % 2;
}
Ye("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Ye("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Ye("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
yn("month", "M");
An("month", 8);
Me("M", Tt);
Me("MM", Tt, qn);
Me("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Me("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
vt(["M", "MM"], function(e, t) {
  t[ui] = et(e) - 1;
});
vt(["MMM", "MMMM"], function(e, t, n, r) {
  var i = n._locale.monthsParse(e, r, n._strict);
  i != null ? t[ui] = i : Xe(n).invalidMonth = e;
});
var $I = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), qx = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Xx = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, WI = Tl, UI = Tl;
function HI(e, t) {
  return e ? br(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Xx).test(t) ? "format" : "standalone"][e.month()] : br(this._months) ? this._months : this._months.standalone;
}
function GI(e, t) {
  return e ? br(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Xx.test(t) ? "format" : "standalone"][e.month()] : br(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function VI(e, t, n) {
  var r, i, a, o = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      a = Jr([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (i = Ft.call(this._shortMonthsParse, o), i !== -1 ? i : null) : (i = Ft.call(this._longMonthsParse, o), i !== -1 ? i : null) : t === "MMM" ? (i = Ft.call(this._shortMonthsParse, o), i !== -1 ? i : (i = Ft.call(this._longMonthsParse, o), i !== -1 ? i : null)) : (i = Ft.call(this._longMonthsParse, o), i !== -1 ? i : (i = Ft.call(this._shortMonthsParse, o), i !== -1 ? i : null));
}
function QI(e, t, n) {
  var r, i, a;
  if (this._monthsParseExact)
    return VI.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (i = Jr([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(i, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(i, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (a = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (n && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!n && this._monthsParse[r].test(e))
      return r;
  }
}
function Jx(e, t) {
  var n;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = et(t);
    else if (t = e.localeData().monthsParse(t), !gi(t))
      return e;
  }
  return n = Math.min(e.date(), vf(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
}
function Kx(e) {
  return e != null ? (Jx(this, e), Se.updateOffset(this, !0), this) : eu(this, "Month");
}
function qI() {
  return vf(this.year(), this.month());
}
function XI(e) {
  return this._monthsParseExact ? (st(this, "_monthsRegex") || Zx.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (st(this, "_monthsShortRegex") || (this._monthsShortRegex = WI), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function JI(e) {
  return this._monthsParseExact ? (st(this, "_monthsRegex") || Zx.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (st(this, "_monthsRegex") || (this._monthsRegex = UI), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Zx() {
  function e(o, s) {
    return s.length - o.length;
  }
  var t = [], n = [], r = [], i, a;
  for (i = 0; i < 12; i++)
    a = Jr([2e3, i]), t.push(this.monthsShort(a, "")), n.push(this.months(a, "")), r.push(this.months(a, "")), r.push(this.monthsShort(a, ""));
  for (t.sort(e), n.sort(e), r.sort(e), i = 0; i < 12; i++)
    t[i] = jn(t[i]), n[i] = jn(n[i]);
  for (i = 0; i < 24; i++)
    r[i] = jn(r[i]);
  this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
Ye("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Hr(e, 4) : "+" + e;
});
Ye(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Ye(0, ["YYYY", 4], 0, "year");
Ye(0, ["YYYYY", 5], 0, "year");
Ye(0, ["YYYYYY", 6, !0], 0, "year");
yn("year", "y");
An("year", 1);
Me("Y", yf);
Me("YY", Tt, qn);
Me("YYYY", wm, bm);
Me("YYYYY", gf, pf);
Me("YYYYYY", gf, pf);
vt(["YYYYY", "YYYYYY"], gn);
vt("YYYY", function(e, t) {
  t[gn] = e.length === 2 ? Se.parseTwoDigitYear(e) : et(e);
});
vt("YY", function(e, t) {
  t[gn] = Se.parseTwoDigitYear(e);
});
vt("Y", function(e, t) {
  t[gn] = parseInt(e, 10);
});
function Is(e) {
  return hf(e) ? 366 : 365;
}
Se.parseTwoDigitYear = function(e) {
  return et(e) + (et(e) > 68 ? 1900 : 2e3);
};
var eb = Ro("FullYear", !0);
function KI() {
  return hf(this.year());
}
function ZI(e, t, n, r, i, a, o) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, r, i, a, o), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, r, i, a, o), s;
}
function Gs(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function nu(e, t, n) {
  var r = 7 + t - n, i = (7 + Gs(e, 0, r).getUTCDay() - t) % 7;
  return -i + r - 1;
}
function tb(e, t, n, r, i) {
  var a = (7 + n - r) % 7, o = nu(e, r, i), s = 1 + 7 * (t - 1) + a + o, c, l;
  return s <= 0 ? (c = e - 1, l = Is(c) + s) : s > Is(e) ? (c = e + 1, l = s - Is(e)) : (c = e, l = s), {
    year: c,
    dayOfYear: l
  };
}
function Vs(e, t, n) {
  var r = nu(e.year(), t, n), i = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, a, o;
  return i < 1 ? (o = e.year() - 1, a = i + mi(o, t, n)) : i > mi(e.year(), t, n) ? (a = i - mi(e.year(), t, n), o = e.year() + 1) : (o = e.year(), a = i), {
    week: a,
    year: o
  };
}
function mi(e, t, n) {
  var r = nu(e, t, n), i = nu(e + 1, t, n);
  return (Is(e) - r + i) / 7;
}
Ye("w", ["ww", 2], "wo", "week");
Ye("W", ["WW", 2], "Wo", "isoWeek");
yn("week", "w");
yn("isoWeek", "W");
An("week", 5);
An("isoWeek", 5);
Me("w", Tt);
Me("ww", Tt, qn);
Me("W", Tt);
Me("WW", Tt, qn);
Ml(
  ["w", "ww", "W", "WW"],
  function(e, t, n, r) {
    t[r.substr(0, 1)] = et(e);
  }
);
function eN(e) {
  return Vs(e, this._week.dow, this._week.doy).week;
}
var tN = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function nN() {
  return this._week.dow;
}
function rN() {
  return this._week.doy;
}
function iN(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function aN(e) {
  var t = Vs(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Ye("d", 0, "do", "day");
Ye("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Ye("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Ye("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Ye("e", 0, 0, "weekday");
Ye("E", 0, 0, "isoWeekday");
yn("day", "d");
yn("weekday", "e");
yn("isoWeekday", "E");
An("day", 11);
An("weekday", 11);
An("isoWeekday", 11);
Me("d", Tt);
Me("e", Tt);
Me("E", Tt);
Me("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Me("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Me("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Ml(["dd", "ddd", "dddd"], function(e, t, n, r) {
  var i = n._locale.weekdaysParse(e, r, n._strict);
  i != null ? t.d = i : Xe(n).invalidWeekday = e;
});
Ml(["d", "e", "E"], function(e, t, n, r) {
  t[r] = et(e);
});
function oN(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function sN(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function _m(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var lN = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), nb = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), cN = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), uN = Tl, fN = Tl, dN = Tl;
function hN(e, t) {
  var n = br(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? _m(n, this._week.dow) : e ? n[e.day()] : n;
}
function pN(e) {
  return e === !0 ? _m(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function mN(e) {
  return e === !0 ? _m(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function gN(e, t, n) {
  var r, i, a, o = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      a = Jr([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (i = Ft.call(this._weekdaysParse, o), i !== -1 ? i : null) : t === "ddd" ? (i = Ft.call(this._shortWeekdaysParse, o), i !== -1 ? i : null) : (i = Ft.call(this._minWeekdaysParse, o), i !== -1 ? i : null) : t === "dddd" ? (i = Ft.call(this._weekdaysParse, o), i !== -1 || (i = Ft.call(this._shortWeekdaysParse, o), i !== -1) ? i : (i = Ft.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : t === "ddd" ? (i = Ft.call(this._shortWeekdaysParse, o), i !== -1 || (i = Ft.call(this._weekdaysParse, o), i !== -1) ? i : (i = Ft.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : (i = Ft.call(this._minWeekdaysParse, o), i !== -1 || (i = Ft.call(this._weekdaysParse, o), i !== -1) ? i : (i = Ft.call(this._shortWeekdaysParse, o), i !== -1 ? i : null));
}
function yN(e, t, n) {
  var r, i, a;
  if (this._weekdaysParseExact)
    return gN.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (i = Jr([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (a = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (n && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (n && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!n && this._weekdaysParse[r].test(e))
      return r;
  }
}
function AN(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = oN(e, this.localeData()), this.add(e - t, "d")) : t;
}
function vN(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function xN(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = sN(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function bN(e) {
  return this._weekdaysParseExact ? (st(this, "_weekdaysRegex") || Sm.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (st(this, "_weekdaysRegex") || (this._weekdaysRegex = uN), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function wN(e) {
  return this._weekdaysParseExact ? (st(this, "_weekdaysRegex") || Sm.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (st(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = fN), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function _N(e) {
  return this._weekdaysParseExact ? (st(this, "_weekdaysRegex") || Sm.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (st(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = dN), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Sm() {
  function e(u, d) {
    return d.length - u.length;
  }
  var t = [], n = [], r = [], i = [], a, o, s, c, l;
  for (a = 0; a < 7; a++)
    o = Jr([2e3, 1]).day(a), s = jn(this.weekdaysMin(o, "")), c = jn(this.weekdaysShort(o, "")), l = jn(this.weekdays(o, "")), t.push(s), n.push(c), r.push(l), i.push(s), i.push(c), i.push(l);
  t.sort(e), n.sort(e), r.sort(e), i.sort(e), this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Cm() {
  return this.hours() % 12 || 12;
}
function SN() {
  return this.hours() || 24;
}
Ye("H", ["HH", 2], 0, "hour");
Ye("h", ["hh", 2], 0, Cm);
Ye("k", ["kk", 2], 0, SN);
Ye("hmm", 0, 0, function() {
  return "" + Cm.apply(this) + Hr(this.minutes(), 2);
});
Ye("hmmss", 0, 0, function() {
  return "" + Cm.apply(this) + Hr(this.minutes(), 2) + Hr(this.seconds(), 2);
});
Ye("Hmm", 0, 0, function() {
  return "" + this.hours() + Hr(this.minutes(), 2);
});
Ye("Hmmss", 0, 0, function() {
  return "" + this.hours() + Hr(this.minutes(), 2) + Hr(this.seconds(), 2);
});
function rb(e, t) {
  Ye(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
rb("a", !0);
rb("A", !1);
yn("hour", "h");
An("hour", 13);
function ib(e, t) {
  return t._meridiemParse;
}
Me("a", ib);
Me("A", ib);
Me("H", Tt);
Me("h", Tt);
Me("k", Tt);
Me("HH", Tt, qn);
Me("hh", Tt, qn);
Me("kk", Tt, qn);
Me("hmm", Vx);
Me("hmmss", Qx);
Me("Hmm", Vx);
Me("Hmmss", Qx);
vt(["H", "HH"], Qt);
vt(["k", "kk"], function(e, t, n) {
  var r = et(e);
  t[Qt] = r === 24 ? 0 : r;
});
vt(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
vt(["h", "hh"], function(e, t, n) {
  t[Qt] = et(e), Xe(n).bigHour = !0;
});
vt("hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Qt] = et(e.substr(0, r)), t[gr] = et(e.substr(r)), Xe(n).bigHour = !0;
});
vt("hmmss", function(e, t, n) {
  var r = e.length - 4, i = e.length - 2;
  t[Qt] = et(e.substr(0, r)), t[gr] = et(e.substr(r, 2)), t[fi] = et(e.substr(i)), Xe(n).bigHour = !0;
});
vt("Hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Qt] = et(e.substr(0, r)), t[gr] = et(e.substr(r));
});
vt("Hmmss", function(e, t, n) {
  var r = e.length - 4, i = e.length - 2;
  t[Qt] = et(e.substr(0, r)), t[gr] = et(e.substr(r, 2)), t[fi] = et(e.substr(i));
});
function CN(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var EN = /[ap]\.?m?\.?/i, kN = Ro("Hours", !0);
function TN(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var ab = {
  calendar: yI,
  longDateFormat: bI,
  invalidDate: _I,
  ordinal: CI,
  dayOfMonthOrdinalParse: EI,
  relativeTime: TI,
  months: $I,
  monthsShort: qx,
  week: tN,
  weekdays: lN,
  weekdaysMin: cN,
  weekdaysShort: nb,
  meridiemParse: EN
}, Nt = {}, Xo = {}, Qs;
function MN(e, t) {
  var n, r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1)
    if (e[n] !== t[n])
      return n;
  return r;
}
function Ay(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function IN(e) {
  for (var t = 0, n, r, i, a; t < e.length; ) {
    for (a = Ay(e[t]).split("-"), n = a.length, r = Ay(e[t + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (i = xf(a.slice(0, n).join("-")), i)
        return i;
      if (r && r.length >= n && MN(a, r) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return Qs;
}
function NN(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function xf(e) {
  var t = null, n;
  if (Nt[e] === void 0 && typeof module < "u" && module && module.exports && NN(e))
    try {
      t = Qs._abbr, n = require, n("./locale/" + e), Pi(t);
    } catch {
      Nt[e] = null;
    }
  return Nt[e];
}
function Pi(e, t) {
  var n;
  return e && (In(t) ? n = wi(e) : n = Em(e, t), n ? Qs = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Qs._abbr;
}
function Em(e, t) {
  if (t !== null) {
    var n, r = ab;
    if (t.abbr = e, Nt[e] != null)
      jx(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = Nt[e]._config;
    else if (t.parentLocale != null)
      if (Nt[t.parentLocale] != null)
        r = Nt[t.parentLocale]._config;
      else if (n = xf(t.parentLocale), n != null)
        r = n._config;
      else
        return Xo[t.parentLocale] || (Xo[t.parentLocale] = []), Xo[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return Nt[e] = new Am(Oh(r, t)), Xo[e] && Xo[e].forEach(function(i) {
      Em(i.name, i.config);
    }), Pi(e), Nt[e];
  } else
    return delete Nt[e], null;
}
function ON(e, t) {
  if (t != null) {
    var n, r, i = ab;
    Nt[e] != null && Nt[e].parentLocale != null ? Nt[e].set(Oh(Nt[e]._config, t)) : (r = xf(e), r != null && (i = r._config), t = Oh(i, t), r == null && (t.abbr = e), n = new Am(t), n.parentLocale = Nt[e], Nt[e] = n), Pi(e);
  } else
    Nt[e] != null && (Nt[e].parentLocale != null ? (Nt[e] = Nt[e].parentLocale, e === Pi() && Pi(e)) : Nt[e] != null && delete Nt[e]);
  return Nt[e];
}
function wi(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Qs;
  if (!br(e)) {
    if (t = xf(e), t)
      return t;
    e = [e];
  }
  return IN(e);
}
function RN() {
  return Rh(Nt);
}
function km(e) {
  var t, n = e._a;
  return n && Xe(e).overflow === -2 && (t = n[ui] < 0 || n[ui] > 11 ? ui : n[Br] < 1 || n[Br] > vf(n[gn], n[ui]) ? Br : n[Qt] < 0 || n[Qt] > 24 || n[Qt] === 24 && (n[gr] !== 0 || n[fi] !== 0 || n[ma] !== 0) ? Qt : n[gr] < 0 || n[gr] > 59 ? gr : n[fi] < 0 || n[fi] > 59 ? fi : n[ma] < 0 || n[ma] > 999 ? ma : -1, Xe(e)._overflowDayOfYear && (t < gn || t > Br) && (t = Br), Xe(e)._overflowWeeks && t === -1 && (t = FI), Xe(e)._overflowWeekday && t === -1 && (t = YI), Xe(e).overflow = t), e;
}
var DN = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, PN = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, LN = /Z|[+-]\d\d(?::?\d\d)?/, ec = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], yd = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], zN = /^\/?Date\((-?\d+)/i, BN = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, FN = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ob(e) {
  var t, n, r = e._i, i = DN.exec(r) || PN.exec(r), a, o, s, c, l = ec.length, u = yd.length;
  if (i) {
    for (Xe(e).iso = !0, t = 0, n = l; t < n; t++)
      if (ec[t][1].exec(i[1])) {
        o = ec[t][0], a = ec[t][2] !== !1;
        break;
      }
    if (o == null) {
      e._isValid = !1;
      return;
    }
    if (i[3]) {
      for (t = 0, n = u; t < n; t++)
        if (yd[t][1].exec(i[3])) {
          s = (i[2] || " ") + yd[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (i[4])
      if (LN.exec(i[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = o + (s || "") + (c || ""), Mm(e);
  } else
    e._isValid = !1;
}
function YN(e, t, n, r, i, a) {
  var o = [
    jN(e),
    qx.indexOf(t),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(i, 10)
  ];
  return a && o.push(parseInt(a, 10)), o;
}
function jN(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function $N(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function WN(e, t, n) {
  if (e) {
    var r = nb.indexOf(e), i = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== i)
      return Xe(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function UN(e, t, n) {
  if (e)
    return FN[e];
  if (t)
    return 0;
  var r = parseInt(n, 10), i = r % 100, a = (r - i) / 100;
  return a * 60 + i;
}
function sb(e) {
  var t = BN.exec($N(e._i)), n;
  if (t) {
    if (n = YN(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !WN(t[1], n, e))
      return;
    e._a = n, e._tzm = UN(t[8], t[9], t[10]), e._d = Gs.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Xe(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function HN(e) {
  var t = zN.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (ob(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (sb(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Se.createFromInputFallback(e);
}
Se.createFromInputFallback = ur(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function qa(e, t, n) {
  return e ?? t ?? n;
}
function GN(e) {
  var t = new Date(Se.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function Tm(e) {
  var t, n, r = [], i, a, o;
  if (!e._d) {
    for (i = GN(e), e._w && e._a[Br] == null && e._a[ui] == null && VN(e), e._dayOfYear != null && (o = qa(e._a[gn], i[gn]), (e._dayOfYear > Is(o) || e._dayOfYear === 0) && (Xe(e)._overflowDayOfYear = !0), n = Gs(o, 0, e._dayOfYear), e._a[ui] = n.getUTCMonth(), e._a[Br] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = i[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Qt] === 24 && e._a[gr] === 0 && e._a[fi] === 0 && e._a[ma] === 0 && (e._nextDay = !0, e._a[Qt] = 0), e._d = (e._useUTC ? Gs : ZI).apply(
      null,
      r
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Qt] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (Xe(e).weekdayMismatch = !0);
  }
}
function VN(e) {
  var t, n, r, i, a, o, s, c, l;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, o = 4, n = qa(
    t.GG,
    e._a[gn],
    Vs(kt(), 1, 4).year
  ), r = qa(t.W, 1), i = qa(t.E, 1), (i < 1 || i > 7) && (c = !0)) : (a = e._locale._week.dow, o = e._locale._week.doy, l = Vs(kt(), a, o), n = qa(t.gg, e._a[gn], l.year), r = qa(t.w, l.week), t.d != null ? (i = t.d, (i < 0 || i > 6) && (c = !0)) : t.e != null ? (i = t.e + a, (t.e < 0 || t.e > 6) && (c = !0)) : i = a), r < 1 || r > mi(n, a, o) ? Xe(e)._overflowWeeks = !0 : c != null ? Xe(e)._overflowWeekday = !0 : (s = tb(n, r, i, a, o), e._a[gn] = s.year, e._dayOfYear = s.dayOfYear);
}
Se.ISO_8601 = function() {
};
Se.RFC_2822 = function() {
};
function Mm(e) {
  if (e._f === Se.ISO_8601) {
    ob(e);
    return;
  }
  if (e._f === Se.RFC_2822) {
    sb(e);
    return;
  }
  e._a = [], Xe(e).empty = !0;
  var t = "" + e._i, n, r, i, a, o, s = t.length, c = 0, l, u;
  for (i = $x(e._f, e._locale).match(vm) || [], u = i.length, n = 0; n < u; n++)
    a = i[n], r = (t.match(LI(a, e)) || [])[0], r && (o = t.substr(0, t.indexOf(r)), o.length > 0 && Xe(e).unusedInput.push(o), t = t.slice(
      t.indexOf(r) + r.length
    ), c += r.length), ao[a] ? (r ? Xe(e).empty = !1 : Xe(e).unusedTokens.push(a), BI(a, r, e)) : e._strict && !r && Xe(e).unusedTokens.push(a);
  Xe(e).charsLeftOver = s - c, t.length > 0 && Xe(e).unusedInput.push(t), e._a[Qt] <= 12 && Xe(e).bigHour === !0 && e._a[Qt] > 0 && (Xe(e).bigHour = void 0), Xe(e).parsedDateParts = e._a.slice(0), Xe(e).meridiem = e._meridiem, e._a[Qt] = QN(
    e._locale,
    e._a[Qt],
    e._meridiem
  ), l = Xe(e).era, l !== null && (e._a[gn] = e._locale.erasConvertYear(l, e._a[gn])), Tm(e), km(e);
}
function QN(e, t, n) {
  var r;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (r = e.isPM(n), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function qN(e) {
  var t, n, r, i, a, o, s = !1, c = e._f.length;
  if (c === 0) {
    Xe(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < c; i++)
    a = 0, o = !1, t = ym({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[i], Mm(t), gm(t) && (o = !0), a += Xe(t).charsLeftOver, a += Xe(t).unusedTokens.length * 10, Xe(t).score = a, s ? a < r && (r = a, n = t) : (r == null || a < r || o) && (r = a, n = t, o && (s = !0));
  Ii(e, n || t);
}
function XN(e) {
  if (!e._d) {
    var t = xm(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = Fx(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), Tm(e);
  }
}
function JN(e) {
  var t = new kl(km(lb(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function lb(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || wi(e._l), t === null || n === void 0 && t === "" ? df({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), wr(t) ? new kl(km(t)) : (El(t) ? e._d = t : br(n) ? qN(e) : n ? Mm(e) : KN(e), gm(e) || (e._d = null), e));
}
function KN(e) {
  var t = e._i;
  In(t) ? e._d = new Date(Se.now()) : El(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? HN(e) : br(t) ? (e._a = Fx(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), Tm(e)) : ga(t) ? XN(e) : gi(t) ? e._d = new Date(t) : Se.createFromInputFallback(e);
}
function cb(e, t, n, r, i) {
  var a = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (ga(e) && mm(e) || br(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = i, a._l = n, a._i = e, a._f = t, a._strict = r, JN(a);
}
function kt(e, t, n, r) {
  return cb(e, t, n, r, !1);
}
var ZN = ur(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = kt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : df();
  }
), eO = ur(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = kt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : df();
  }
);
function ub(e, t) {
  var n, r;
  if (t.length === 1 && br(t[0]) && (t = t[0]), !t.length)
    return kt();
  for (n = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function tO() {
  var e = [].slice.call(arguments, 0);
  return ub("isBefore", e);
}
function nO() {
  var e = [].slice.call(arguments, 0);
  return ub("isAfter", e);
}
var rO = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Jo = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function iO(e) {
  var t, n = !1, r, i = Jo.length;
  for (t in e)
    if (st(e, t) && !(Ft.call(Jo, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < i; ++r)
    if (e[Jo[r]]) {
      if (n)
        return !1;
      parseFloat(e[Jo[r]]) !== et(e[Jo[r]]) && (n = !0);
    }
  return !0;
}
function aO() {
  return this._isValid;
}
function oO() {
  return Cr(NaN);
}
function bf(e) {
  var t = xm(e), n = t.year || 0, r = t.quarter || 0, i = t.month || 0, a = t.week || t.isoWeek || 0, o = t.day || 0, s = t.hour || 0, c = t.minute || 0, l = t.second || 0, u = t.millisecond || 0;
  this._isValid = iO(t), this._milliseconds = +u + l * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +o + a * 7, this._months = +i + r * 3 + n * 12, this._data = {}, this._locale = wi(), this._bubble();
}
function Rc(e) {
  return e instanceof bf;
}
function Ph(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function sO(e, t, n) {
  var r = Math.min(e.length, t.length), i = Math.abs(e.length - t.length), a = 0, o;
  for (o = 0; o < r; o++)
    et(e[o]) !== et(t[o]) && a++;
  return a + i;
}
function fb(e, t) {
  Ye(e, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + Hr(~~(n / 60), 2) + t + Hr(~~n % 60, 2);
  });
}
fb("Z", ":");
fb("ZZ", "");
Me("Z", Af);
Me("ZZ", Af);
vt(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = Im(Af, e);
});
var lO = /([\+\-]|\d\d)/gi;
function Im(e, t) {
  var n = (t || "").match(e), r, i, a;
  return n === null ? null : (r = n[n.length - 1] || [], i = (r + "").match(lO) || ["-", 0, 0], a = +(i[1] * 60) + et(i[2]), a === 0 ? 0 : i[0] === "+" ? a : -a);
}
function Nm(e, t) {
  var n, r;
  return t._isUTC ? (n = t.clone(), r = (wr(e) || El(e) ? e.valueOf() : kt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), Se.updateOffset(n, !1), n) : kt(e).local();
}
function Lh(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Se.updateOffset = function() {
};
function cO(e, t, n) {
  var r = this._offset || 0, i;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Im(Af, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (i = Lh(this)), this._offset = e, this._isUTC = !0, i != null && this.add(i, "m"), r !== e && (!t || this._changeInProgress ? pb(
      this,
      Cr(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Se.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : Lh(this);
}
function uO(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function fO(e) {
  return this.utcOffset(0, e);
}
function dO(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Lh(this), "m")), this;
}
function hO() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Im(DI, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function pO(e) {
  return this.isValid() ? (e = e ? kt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function mO() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function gO() {
  if (!In(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return ym(e, this), e = lb(e), e._a ? (t = e._isUTC ? Jr(e._a) : kt(e._a), this._isDSTShifted = this.isValid() && sO(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function yO() {
  return this.isValid() ? !this._isUTC : !1;
}
function AO() {
  return this.isValid() ? this._isUTC : !1;
}
function db() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var vO = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, xO = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Cr(e, t) {
  var n = e, r = null, i, a, o;
  return Rc(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : gi(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (r = vO.exec(e)) ? (i = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: et(r[Br]) * i,
    h: et(r[Qt]) * i,
    m: et(r[gr]) * i,
    s: et(r[fi]) * i,
    ms: et(Ph(r[ma] * 1e3)) * i
    // the millisecond decimal point is included in the match
  }) : (r = xO.exec(e)) ? (i = r[1] === "-" ? -1 : 1, n = {
    y: aa(r[2], i),
    M: aa(r[3], i),
    w: aa(r[4], i),
    d: aa(r[5], i),
    h: aa(r[6], i),
    m: aa(r[7], i),
    s: aa(r[8], i)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (o = bO(
    kt(n.from),
    kt(n.to)
  ), n = {}, n.ms = o.milliseconds, n.M = o.months), a = new bf(n), Rc(e) && st(e, "_locale") && (a._locale = e._locale), Rc(e) && st(e, "_isValid") && (a._isValid = e._isValid), a;
}
Cr.fn = bf.prototype;
Cr.invalid = oO;
function aa(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function vy(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function bO(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = Nm(t, e), e.isBefore(t) ? n = vy(e, t) : (n = vy(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function hb(e, t) {
  return function(n, r) {
    var i, a;
    return r !== null && !isNaN(+r) && (jx(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = n, n = r, r = a), i = Cr(n, r), pb(this, i, e), this;
  };
}
function pb(e, t, n, r) {
  var i = t._milliseconds, a = Ph(t._days), o = Ph(t._months);
  e.isValid() && (r = r ?? !0, o && Jx(e, eu(e, "Month") + o * n), a && Ux(e, "Date", eu(e, "Date") + a * n), i && e._d.setTime(e._d.valueOf() + i * n), r && Se.updateOffset(e, a || o));
}
var wO = hb(1, "add"), _O = hb(-1, "subtract");
function mb(e) {
  return typeof e == "string" || e instanceof String;
}
function SO(e) {
  return wr(e) || El(e) || mb(e) || gi(e) || EO(e) || CO(e) || e === null || e === void 0;
}
function CO(e) {
  var t = ga(e) && !mm(e), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, a, o = r.length;
  for (i = 0; i < o; i += 1)
    a = r[i], n = n || st(e, a);
  return t && n;
}
function EO(e) {
  var t = br(e), n = !1;
  return t && (n = e.filter(function(r) {
    return !gi(r) && mb(e);
  }).length === 0), t && n;
}
function kO(e) {
  var t = ga(e) && !mm(e), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, a;
  for (i = 0; i < r.length; i += 1)
    a = r[i], n = n || st(e, a);
  return t && n;
}
function TO(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function MO(e, t) {
  arguments.length === 1 && (arguments[0] ? SO(arguments[0]) ? (e = arguments[0], t = void 0) : kO(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || kt(), r = Nm(n, this).startOf("day"), i = Se.calendarFormat(this, r) || "sameElse", a = t && (Kr(t[i]) ? t[i].call(this, n) : t[i]);
  return this.format(
    a || this.localeData().calendar(i, this, kt(n))
  );
}
function IO() {
  return new kl(this);
}
function NO(e, t) {
  var n = wr(e) ? e : kt(e);
  return this.isValid() && n.isValid() ? (t = fr(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function OO(e, t) {
  var n = wr(e) ? e : kt(e);
  return this.isValid() && n.isValid() ? (t = fr(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function RO(e, t, n, r) {
  var i = wr(e) ? e : kt(e), a = wr(t) ? t : kt(t);
  return this.isValid() && i.isValid() && a.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(i, n) : !this.isBefore(i, n)) && (r[1] === ")" ? this.isBefore(a, n) : !this.isAfter(a, n))) : !1;
}
function DO(e, t) {
  var n = wr(e) ? e : kt(e), r;
  return this.isValid() && n.isValid() ? (t = fr(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function PO(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function LO(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function zO(e, t, n) {
  var r, i, a;
  if (!this.isValid())
    return NaN;
  if (r = Nm(e, this), !r.isValid())
    return NaN;
  switch (i = (r.utcOffset() - this.utcOffset()) * 6e4, t = fr(t), t) {
    case "year":
      a = Dc(this, r) / 12;
      break;
    case "month":
      a = Dc(this, r);
      break;
    case "quarter":
      a = Dc(this, r) / 3;
      break;
    case "second":
      a = (this - r) / 1e3;
      break;
    case "minute":
      a = (this - r) / 6e4;
      break;
    case "hour":
      a = (this - r) / 36e5;
      break;
    case "day":
      a = (this - r - i) / 864e5;
      break;
    case "week":
      a = (this - r - i) / 6048e5;
      break;
    default:
      a = this - r;
  }
  return n ? a : nr(a);
}
function Dc(e, t) {
  if (e.date() < t.date())
    return -Dc(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(n, "months"), i, a;
  return t - r < 0 ? (i = e.clone().add(n - 1, "months"), a = (t - r) / (r - i)) : (i = e.clone().add(n + 1, "months"), a = (t - r) / (i - r)), -(n + a) || 0;
}
Se.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Se.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function BO() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function FO(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Oc(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Kr(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Oc(n, "Z")) : Oc(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function YO() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, r, i, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(n + r + i + a);
}
function jO(e) {
  e || (e = this.isUtc() ? Se.defaultFormatUtc : Se.defaultFormat);
  var t = Oc(this, e);
  return this.localeData().postformat(t);
}
function $O(e, t) {
  return this.isValid() && (wr(e) && e.isValid() || kt(e).isValid()) ? Cr({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function WO(e) {
  return this.from(kt(), e);
}
function UO(e, t) {
  return this.isValid() && (wr(e) && e.isValid() || kt(e).isValid()) ? Cr({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function HO(e) {
  return this.to(kt(), e);
}
function gb(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = wi(e), t != null && (this._locale = t), this);
}
var yb = ur(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Ab() {
  return this._locale;
}
var ru = 1e3, oo = 60 * ru, iu = 60 * oo, vb = (365 * 400 + 97) * 24 * iu;
function so(e, t) {
  return (e % t + t) % t;
}
function xb(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - vb : new Date(e, t, n).valueOf();
}
function bb(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - vb : Date.UTC(e, t, n);
}
function GO(e) {
  var t, n;
  if (e = fr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? bb : xb, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= so(
        t + (this._isUTC ? 0 : this.utcOffset() * oo),
        iu
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= so(t, oo);
      break;
    case "second":
      t = this._d.valueOf(), t -= so(t, ru);
      break;
  }
  return this._d.setTime(t), Se.updateOffset(this, !0), this;
}
function VO(e) {
  var t, n;
  if (e = fr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? bb : xb, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += iu - so(
        t + (this._isUTC ? 0 : this.utcOffset() * oo),
        iu
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += oo - so(t, oo) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += ru - so(t, ru) - 1;
      break;
  }
  return this._d.setTime(t), Se.updateOffset(this, !0), this;
}
function QO() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function qO() {
  return Math.floor(this.valueOf() / 1e3);
}
function XO() {
  return new Date(this.valueOf());
}
function JO() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function KO() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function ZO() {
  return this.isValid() ? this.toISOString() : null;
}
function eR() {
  return gm(this);
}
function tR() {
  return Ii({}, Xe(this));
}
function nR() {
  return Xe(this).overflow;
}
function rR() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Ye("N", 0, 0, "eraAbbr");
Ye("NN", 0, 0, "eraAbbr");
Ye("NNN", 0, 0, "eraAbbr");
Ye("NNNN", 0, 0, "eraName");
Ye("NNNNN", 0, 0, "eraNarrow");
Ye("y", ["y", 1], "yo", "eraYear");
Ye("y", ["yy", 2], 0, "eraYear");
Ye("y", ["yyy", 3], 0, "eraYear");
Ye("y", ["yyyy", 4], 0, "eraYear");
Me("N", Om);
Me("NN", Om);
Me("NNN", Om);
Me("NNNN", pR);
Me("NNNNN", mR);
vt(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, r) {
    var i = n._locale.erasParse(e, r, n._strict);
    i ? Xe(n).era = i : Xe(n).invalidEra = e;
  }
);
Me("y", Do);
Me("yy", Do);
Me("yyy", Do);
Me("yyyy", Do);
Me("yo", gR);
vt(["y", "yy", "yyy", "yyyy"], gn);
vt(["yo"], function(e, t, n, r) {
  var i;
  n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[gn] = n._locale.eraYearOrdinalParse(e, i) : t[gn] = parseInt(e, 10);
});
function iR(e, t) {
  var n, r, i, a = this._eras || wi("en")._eras;
  for (n = 0, r = a.length; n < r; ++n) {
    switch (typeof a[n].since) {
      case "string":
        i = Se(a[n].since).startOf("day"), a[n].since = i.valueOf();
        break;
    }
    switch (typeof a[n].until) {
      case "undefined":
        a[n].until = 1 / 0;
        break;
      case "string":
        i = Se(a[n].until).startOf("day").valueOf(), a[n].until = i.valueOf();
        break;
    }
  }
  return a;
}
function aR(e, t, n) {
  var r, i, a = this.eras(), o, s, c;
  for (e = e.toUpperCase(), r = 0, i = a.length; r < i; ++r)
    if (o = a[r].name.toUpperCase(), s = a[r].abbr.toUpperCase(), c = a[r].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[r];
          break;
        case "NNNN":
          if (o === e)
            return a[r];
          break;
        case "NNNNN":
          if (c === e)
            return a[r];
          break;
      }
    else if ([o, s, c].indexOf(e) >= 0)
      return a[r];
}
function oR(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Se(e.since).year() : Se(e.since).year() + (t - e.offset) * n;
}
function sR() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].name;
  return "";
}
function lR() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].narrow;
  return "";
}
function cR() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].abbr;
  return "";
}
function uR() {
  var e, t, n, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (n = i[e].since <= i[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return (this.year() - Se(i[e].since).year()) * n + i[e].offset;
  return this.year();
}
function fR(e) {
  return st(this, "_erasNameRegex") || Rm.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function dR(e) {
  return st(this, "_erasAbbrRegex") || Rm.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function hR(e) {
  return st(this, "_erasNarrowRegex") || Rm.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Om(e, t) {
  return t.erasAbbrRegex(e);
}
function pR(e, t) {
  return t.erasNameRegex(e);
}
function mR(e, t) {
  return t.erasNarrowRegex(e);
}
function gR(e, t) {
  return t._eraYearOrdinalRegex || Do;
}
function Rm() {
  var e = [], t = [], n = [], r = [], i, a, o = this.eras();
  for (i = 0, a = o.length; i < a; ++i)
    t.push(jn(o[i].name)), e.push(jn(o[i].abbr)), n.push(jn(o[i].narrow)), r.push(jn(o[i].name)), r.push(jn(o[i].abbr)), r.push(jn(o[i].narrow));
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
Ye(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Ye(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function wf(e, t) {
  Ye(0, [e, e.length], 0, t);
}
wf("gggg", "weekYear");
wf("ggggg", "weekYear");
wf("GGGG", "isoWeekYear");
wf("GGGGG", "isoWeekYear");
yn("weekYear", "gg");
yn("isoWeekYear", "GG");
An("weekYear", 1);
An("isoWeekYear", 1);
Me("G", yf);
Me("g", yf);
Me("GG", Tt, qn);
Me("gg", Tt, qn);
Me("GGGG", wm, bm);
Me("gggg", wm, bm);
Me("GGGGG", gf, pf);
Me("ggggg", gf, pf);
Ml(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, r) {
    t[r.substr(0, 2)] = et(e);
  }
);
Ml(["gg", "GG"], function(e, t, n, r) {
  t[r] = Se.parseTwoDigitYear(e);
});
function yR(e) {
  return wb.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function AR(e) {
  return wb.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function vR() {
  return mi(this.year(), 1, 4);
}
function xR() {
  return mi(this.isoWeekYear(), 1, 4);
}
function bR() {
  var e = this.localeData()._week;
  return mi(this.year(), e.dow, e.doy);
}
function wR() {
  var e = this.localeData()._week;
  return mi(this.weekYear(), e.dow, e.doy);
}
function wb(e, t, n, r, i) {
  var a;
  return e == null ? Vs(this, r, i).year : (a = mi(e, r, i), t > a && (t = a), _R.call(this, e, t, n, r, i));
}
function _R(e, t, n, r, i) {
  var a = tb(e, t, n, r, i), o = Gs(a.year, 0, a.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
Ye("Q", 0, "Qo", "quarter");
yn("quarter", "Q");
An("quarter", 7);
Me("Q", Hx);
vt("Q", function(e, t) {
  t[ui] = (et(e) - 1) * 3;
});
function SR(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Ye("D", ["DD", 2], "Do", "date");
yn("date", "D");
An("date", 9);
Me("D", Tt);
Me("DD", Tt, qn);
Me("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
vt(["D", "DD"], Br);
vt("Do", function(e, t) {
  t[Br] = et(e.match(Tt)[0]);
});
var _b = Ro("Date", !0);
Ye("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
yn("dayOfYear", "DDD");
An("dayOfYear", 4);
Me("DDD", mf);
Me("DDDD", Gx);
vt(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = et(e);
});
function CR(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Ye("m", ["mm", 2], 0, "minute");
yn("minute", "m");
An("minute", 14);
Me("m", Tt);
Me("mm", Tt, qn);
vt(["m", "mm"], gr);
var ER = Ro("Minutes", !1);
Ye("s", ["ss", 2], 0, "second");
yn("second", "s");
An("second", 15);
Me("s", Tt);
Me("ss", Tt, qn);
vt(["s", "ss"], fi);
var kR = Ro("Seconds", !1);
Ye("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Ye(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Ye(0, ["SSS", 3], 0, "millisecond");
Ye(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Ye(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Ye(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Ye(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Ye(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Ye(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
yn("millisecond", "ms");
An("millisecond", 16);
Me("S", mf, Hx);
Me("SS", mf, qn);
Me("SSS", mf, Gx);
var Ni, Sb;
for (Ni = "SSSS"; Ni.length <= 9; Ni += "S")
  Me(Ni, Do);
function TR(e, t) {
  t[ma] = et(("0." + e) * 1e3);
}
for (Ni = "S"; Ni.length <= 9; Ni += "S")
  vt(Ni, TR);
Sb = Ro("Milliseconds", !1);
Ye("z", 0, 0, "zoneAbbr");
Ye("zz", 0, 0, "zoneName");
function MR() {
  return this._isUTC ? "UTC" : "";
}
function IR() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var pe = kl.prototype;
pe.add = wO;
pe.calendar = MO;
pe.clone = IO;
pe.diff = zO;
pe.endOf = VO;
pe.format = jO;
pe.from = $O;
pe.fromNow = WO;
pe.to = UO;
pe.toNow = HO;
pe.get = OI;
pe.invalidAt = nR;
pe.isAfter = NO;
pe.isBefore = OO;
pe.isBetween = RO;
pe.isSame = DO;
pe.isSameOrAfter = PO;
pe.isSameOrBefore = LO;
pe.isValid = eR;
pe.lang = yb;
pe.locale = gb;
pe.localeData = Ab;
pe.max = eO;
pe.min = ZN;
pe.parsingFlags = tR;
pe.set = RI;
pe.startOf = GO;
pe.subtract = _O;
pe.toArray = JO;
pe.toObject = KO;
pe.toDate = XO;
pe.toISOString = FO;
pe.inspect = YO;
typeof Symbol < "u" && Symbol.for != null && (pe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
pe.toJSON = ZO;
pe.toString = BO;
pe.unix = qO;
pe.valueOf = QO;
pe.creationData = rR;
pe.eraName = sR;
pe.eraNarrow = lR;
pe.eraAbbr = cR;
pe.eraYear = uR;
pe.year = eb;
pe.isLeapYear = KI;
pe.weekYear = yR;
pe.isoWeekYear = AR;
pe.quarter = pe.quarters = SR;
pe.month = Kx;
pe.daysInMonth = qI;
pe.week = pe.weeks = iN;
pe.isoWeek = pe.isoWeeks = aN;
pe.weeksInYear = bR;
pe.weeksInWeekYear = wR;
pe.isoWeeksInYear = vR;
pe.isoWeeksInISOWeekYear = xR;
pe.date = _b;
pe.day = pe.days = AN;
pe.weekday = vN;
pe.isoWeekday = xN;
pe.dayOfYear = CR;
pe.hour = pe.hours = kN;
pe.minute = pe.minutes = ER;
pe.second = pe.seconds = kR;
pe.millisecond = pe.milliseconds = Sb;
pe.utcOffset = cO;
pe.utc = fO;
pe.local = dO;
pe.parseZone = hO;
pe.hasAlignedHourOffset = pO;
pe.isDST = mO;
pe.isLocal = yO;
pe.isUtcOffset = AO;
pe.isUtc = db;
pe.isUTC = db;
pe.zoneAbbr = MR;
pe.zoneName = IR;
pe.dates = ur(
  "dates accessor is deprecated. Use date instead.",
  _b
);
pe.months = ur(
  "months accessor is deprecated. Use month instead",
  Kx
);
pe.years = ur(
  "years accessor is deprecated. Use year instead",
  eb
);
pe.zone = ur(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  uO
);
pe.isDSTShifted = ur(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  gO
);
function NR(e) {
  return kt(e * 1e3);
}
function OR() {
  return kt.apply(null, arguments).parseZone();
}
function Cb(e) {
  return e;
}
var lt = Am.prototype;
lt.calendar = AI;
lt.longDateFormat = wI;
lt.invalidDate = SI;
lt.ordinal = kI;
lt.preparse = Cb;
lt.postformat = Cb;
lt.relativeTime = MI;
lt.pastFuture = II;
lt.set = gI;
lt.eras = iR;
lt.erasParse = aR;
lt.erasConvertYear = oR;
lt.erasAbbrRegex = dR;
lt.erasNameRegex = fR;
lt.erasNarrowRegex = hR;
lt.months = HI;
lt.monthsShort = GI;
lt.monthsParse = QI;
lt.monthsRegex = JI;
lt.monthsShortRegex = XI;
lt.week = eN;
lt.firstDayOfYear = rN;
lt.firstDayOfWeek = nN;
lt.weekdays = hN;
lt.weekdaysMin = mN;
lt.weekdaysShort = pN;
lt.weekdaysParse = yN;
lt.weekdaysRegex = bN;
lt.weekdaysShortRegex = wN;
lt.weekdaysMinRegex = _N;
lt.isPM = CN;
lt.meridiem = TN;
function au(e, t, n, r) {
  var i = wi(), a = Jr().set(r, t);
  return i[n](a, e);
}
function Eb(e, t, n) {
  if (gi(e) && (t = e, e = void 0), e = e || "", t != null)
    return au(e, t, n, "month");
  var r, i = [];
  for (r = 0; r < 12; r++)
    i[r] = au(e, r, n, "month");
  return i;
}
function Dm(e, t, n, r) {
  typeof e == "boolean" ? (gi(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, gi(t) && (n = t, t = void 0), t = t || "");
  var i = wi(), a = e ? i._week.dow : 0, o, s = [];
  if (n != null)
    return au(t, (n + a) % 7, r, "day");
  for (o = 0; o < 7; o++)
    s[o] = au(t, (o + a) % 7, r, "day");
  return s;
}
function RR(e, t) {
  return Eb(e, t, "months");
}
function DR(e, t) {
  return Eb(e, t, "monthsShort");
}
function PR(e, t, n) {
  return Dm(e, t, n, "weekdays");
}
function LR(e, t, n) {
  return Dm(e, t, n, "weekdaysShort");
}
function zR(e, t, n) {
  return Dm(e, t, n, "weekdaysMin");
}
Pi("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = et(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
Se.lang = ur(
  "moment.lang is deprecated. Use moment.locale instead.",
  Pi
);
Se.langData = ur(
  "moment.langData is deprecated. Use moment.localeData instead.",
  wi
);
var ti = Math.abs;
function BR() {
  var e = this._data;
  return this._milliseconds = ti(this._milliseconds), this._days = ti(this._days), this._months = ti(this._months), e.milliseconds = ti(e.milliseconds), e.seconds = ti(e.seconds), e.minutes = ti(e.minutes), e.hours = ti(e.hours), e.months = ti(e.months), e.years = ti(e.years), this;
}
function kb(e, t, n, r) {
  var i = Cr(t, n);
  return e._milliseconds += r * i._milliseconds, e._days += r * i._days, e._months += r * i._months, e._bubble();
}
function FR(e, t) {
  return kb(this, e, t, 1);
}
function YR(e, t) {
  return kb(this, e, t, -1);
}
function xy(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function jR() {
  var e = this._milliseconds, t = this._days, n = this._months, r = this._data, i, a, o, s, c;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += xy(zh(n) + t) * 864e5, t = 0, n = 0), r.milliseconds = e % 1e3, i = nr(e / 1e3), r.seconds = i % 60, a = nr(i / 60), r.minutes = a % 60, o = nr(a / 60), r.hours = o % 24, t += nr(o / 24), c = nr(Tb(t)), n += c, t -= xy(zh(c)), s = nr(n / 12), n %= 12, r.days = t, r.months = n, r.years = s, this;
}
function Tb(e) {
  return e * 4800 / 146097;
}
function zh(e) {
  return e * 146097 / 4800;
}
function $R(e) {
  if (!this.isValid())
    return NaN;
  var t, n, r = this._milliseconds;
  if (e = fr(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, n = this._months + Tb(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(zh(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function WR() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + et(this._months / 12) * 31536e6 : NaN;
}
function _i(e) {
  return function() {
    return this.as(e);
  };
}
var UR = _i("ms"), HR = _i("s"), GR = _i("m"), VR = _i("h"), QR = _i("d"), qR = _i("w"), XR = _i("M"), JR = _i("Q"), KR = _i("y");
function ZR() {
  return Cr(this);
}
function eD(e) {
  return e = fr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Ia(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var tD = Ia("milliseconds"), nD = Ia("seconds"), rD = Ia("minutes"), iD = Ia("hours"), aD = Ia("days"), oD = Ia("months"), sD = Ia("years");
function lD() {
  return nr(this.days() / 7);
}
var ri = Math.round, Ja = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function cD(e, t, n, r, i) {
  return i.relativeTime(t || 1, !!n, e, r);
}
function uD(e, t, n, r) {
  var i = Cr(e).abs(), a = ri(i.as("s")), o = ri(i.as("m")), s = ri(i.as("h")), c = ri(i.as("d")), l = ri(i.as("M")), u = ri(i.as("w")), d = ri(i.as("y")), f = a <= n.ss && ["s", a] || a < n.s && ["ss", a] || o <= 1 && ["m"] || o < n.m && ["mm", o] || s <= 1 && ["h"] || s < n.h && ["hh", s] || c <= 1 && ["d"] || c < n.d && ["dd", c];
  return n.w != null && (f = f || u <= 1 && ["w"] || u < n.w && ["ww", u]), f = f || l <= 1 && ["M"] || l < n.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d], f[2] = t, f[3] = +e > 0, f[4] = r, cD.apply(null, f);
}
function fD(e) {
  return e === void 0 ? ri : typeof e == "function" ? (ri = e, !0) : !1;
}
function dD(e, t) {
  return Ja[e] === void 0 ? !1 : t === void 0 ? Ja[e] : (Ja[e] = t, e === "s" && (Ja.ss = t - 1), !0);
}
function hD(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = Ja, i, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (r = Object.assign({}, Ja, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), i = this.localeData(), a = uD(this, !n, r, i), n && (a = i.pastFuture(+this, a)), i.postformat(a);
}
var Ad = Math.abs;
function Ya(e) {
  return (e > 0) - (e < 0) || +e;
}
function _f() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Ad(this._milliseconds) / 1e3, t = Ad(this._days), n = Ad(this._months), r, i, a, o, s = this.asSeconds(), c, l, u, d;
  return s ? (r = nr(e / 60), i = nr(r / 60), e %= 60, r %= 60, a = nr(n / 12), n %= 12, o = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = s < 0 ? "-" : "", l = Ya(this._months) !== Ya(s) ? "-" : "", u = Ya(this._days) !== Ya(s) ? "-" : "", d = Ya(this._milliseconds) !== Ya(s) ? "-" : "", c + "P" + (a ? l + a + "Y" : "") + (n ? l + n + "M" : "") + (t ? u + t + "D" : "") + (i || r || e ? "T" : "") + (i ? d + i + "H" : "") + (r ? d + r + "M" : "") + (e ? d + o + "S" : "")) : "P0D";
}
var it = bf.prototype;
it.isValid = aO;
it.abs = BR;
it.add = FR;
it.subtract = YR;
it.as = $R;
it.asMilliseconds = UR;
it.asSeconds = HR;
it.asMinutes = GR;
it.asHours = VR;
it.asDays = QR;
it.asWeeks = qR;
it.asMonths = XR;
it.asQuarters = JR;
it.asYears = KR;
it.valueOf = WR;
it._bubble = jR;
it.clone = ZR;
it.get = eD;
it.milliseconds = tD;
it.seconds = nD;
it.minutes = rD;
it.hours = iD;
it.days = aD;
it.weeks = lD;
it.months = oD;
it.years = sD;
it.humanize = hD;
it.toISOString = _f;
it.toString = _f;
it.toJSON = _f;
it.locale = gb;
it.localeData = Ab;
it.toIsoString = ur(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  _f
);
it.lang = yb;
Ye("X", 0, 0, "unix");
Ye("x", 0, 0, "valueOf");
Me("x", yf);
Me("X", PI);
vt("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
vt("x", function(e, t, n) {
  n._d = new Date(et(e));
});
//! moment.js
Se.version = "2.29.4";
pI(kt);
Se.fn = pe;
Se.min = tO;
Se.max = nO;
Se.now = rO;
Se.utc = Jr;
Se.unix = NR;
Se.months = RR;
Se.isDate = El;
Se.locale = Pi;
Se.invalid = df;
Se.duration = Cr;
Se.isMoment = wr;
Se.weekdays = PR;
Se.parseZone = OR;
Se.localeData = wi;
Se.isDuration = Rc;
Se.monthsShort = DR;
Se.weekdaysMin = zR;
Se.defineLocale = Em;
Se.updateLocale = ON;
Se.locales = RN;
Se.weekdaysShort = LR;
Se.normalizeUnits = fr;
Se.relativeTimeRounding = fD;
Se.relativeTimeThreshold = dD;
Se.calendarFormat = TO;
Se.prototype = pe;
Se.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const AG = ({
  entity: e,
  studyTypes: t,
  onSubmit: n,
  actions: r
}) => {
  var u, d, f, h;
  const i = Sr(), a = !r.update || r["consent.accept"], { settings: o } = Ot(
    (m) => m.user.data
  ), s = (d = (u = o == null ? void 0 : o.features) == null ? void 0 : u.studyId) == null ? void 0 : d.enabled, c = (h = (f = o == null ? void 0 : o.features) == null ? void 0 : f.studyId) == null ? void 0 : h.fieldLabel, l = (m, y) => {
    n({ ...e, [m]: y });
  };
  return /* @__PURE__ */ F(O, { container: !0, spacing: 2, item: !0, xs: 12, children: [
    /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, spacing: 2, children: [
      /* @__PURE__ */ F(O, { item: !0, md: 6, xl: 3, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle1", component: "label", children: "Type" }),
        /* @__PURE__ */ p(
          CC,
          {
            value: e.type,
            className: "",
            id: "study-type",
            options: t,
            placeholder: "Select type...",
            isOptionEqualToValue: (m, y) => m.id == y.id,
            getOptionLabel: (m) => m.name,
            size: "small",
            onSubmit: (m) => l("type", m),
            disableClearable: !0,
            color: "textColor.secondary",
            sx: {
              ml: -1
            },
            disabled: !0
          }
        )
      ] }),
      /* @__PURE__ */ F(O, { item: !0, md: 6, xl: 3, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle1", component: "label", children: s ? c : "Study ID" }),
        /* @__PURE__ */ p(
          Xt,
          {
            color: i.palette.textColor.primary,
            disabled: s,
            onSubmit: (m) => l("studyId", m),
            value: e.studyId
          }
        )
      ] }),
      /* @__PURE__ */ F(O, { item: !0, md: 6, xl: 3, container: !0, children: [
        /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(le, { variant: "subtitle1", component: "label", children: [
          "Start ",
          "/",
          " End date"
        ] }) }),
        /* @__PURE__ */ F(
          O,
          {
            item: !0,
            xs: 12,
            container: !0,
            flexWrap: "wrap",
            ml: -1,
            justifyContent: "flex-start",
            alignItems: "center",
            children: [
              /* @__PURE__ */ p(O, { item: !0, mr: 0.5, children: /* @__PURE__ */ p(
                _0,
                {
                  name: "study-start-date",
                  value: e.startDate,
                  maxDate: e.endDate ? Se(e.endDate) : null,
                  submitErrorMessage: "Start Date cannot be later than End Date",
                  disabled: a,
                  onSubmit: (m) => l("startDate", m),
                  label: "Start Date"
                }
              ) }),
              "-",
              /* @__PURE__ */ p(O, { item: !0, ml: 0.5, children: /* @__PURE__ */ p(
                _0,
                {
                  name: "study-end-date",
                  value: e.endDate,
                  minDate: e.startDate ? Se(e.startDate) : null,
                  submitErrorMessage: "End Date cannot be earlier than Start Date",
                  disabled: a,
                  onSubmit: (m) => l("endDate", m),
                  label: "End Date"
                }
              ) })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ F(O, { item: !0, md: 6, xl: 3, children: [
        /* @__PURE__ */ p(le, { variant: "subtitle1", component: "label", children: "Author" }),
        /* @__PURE__ */ F(le, { variant: "body2", py: 0.5, children: [
          e.created.user.firstName,
          " ",
          e.created.user.lastName
        ] })
      ] })
    ] }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(xa, { flexItem: !0, orientation: "horizontal", sx: { width: "100%" } }) }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p(le, { variant: "subtitle1", component: "label", children: "Study objective" }),
      /* @__PURE__ */ p(
        Xt,
        {
          name: "study-objective",
          value: e.description,
          onSubmit: (m) => l("description", m),
          color: i.palette.textColor.secondary,
          multiline: !0,
          fullWidth: !0,
          placeholder: a ? "..." : "Add study objective...",
          disabled: a,
          sx: {
            ml: -1,
            width: "calc(100% + 16px)"
          }
        }
      )
    ] }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(xa, { flexItem: !0, orientation: "horizontal", sx: { width: "100%" } }) })
  ] });
}, Pm = ae.div`
  display: inline-block;
  width: 28px;
  min-width: 28px;
  height: 28px;
  padding: 5px;
  position: relative;
  text-align: center;
  border-radius: 50%;
  color: ${({ theme: e, color: t }) => e.palette.info.main};
  background-color: ${({ theme: e }) => Yn(0.8, e.palette.info.main)};
  transition: 300ms;
  /* margin-left: 12px; */
  box-sizing: border-box;
  /* line-height: 32px; */
  /* cursor: pointer; */
  ::after {
    content: 'i';
    display: inline-block;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    padding: 1px;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    /* bottom: 1px; */
    position: absolute;
    top: 5px;
    left: 5px;
    border: 2px solid
      ${({ theme: e }) => e.palette.info.main};
  }
  /* :hover {
    background-color: ${({ theme: e }) => Yn(0.6, e.palette.info.main)};
  } */
`, vG = () => /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(
  O,
  {
    container: !0,
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    pb: 2,
    alignItems: "center",
    children: [
      /* @__PURE__ */ p(O, { item: !0, pr: 2, children: /* @__PURE__ */ p(Pm, {}) }),
      /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(le, { variant: "body2", children: "Your personal workspace is accessible by you only. Use it as a canvas to design and experiment with various assets to be shared and used in collaborative studies." }) })
    ]
  }
) }), pD = ({
  iconName: e,
  title: t,
  onImport: n,
  onCreate: r,
  importButtonName: i,
  createButtonName: a,
  canImport: o,
  canCreate: s,
  count: c,
  customButtons: l
}) => /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
  O,
  {
    container: !0,
    mt: 2,
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    minHeight: 54,
    boxSizing: "border-box",
    children: /* @__PURE__ */ F(O, { item: !0, xs: 12, container: !0, spacing: 2, pb: 1.5, alignItems: "center", children: [
      /* @__PURE__ */ p(O, { item: !0, children: [
        "study",
        "workspace",
        "dataCatalog",
        "library",
        "admin",
        "vocabulary"
      ].includes(e) ? /* @__PURE__ */ p(
        tf,
        {
          iconName: `${e}`,
          sx: {
            width: "40px",
            height: "40px",
            color: "backgroundColor.icon"
          }
        }
      ) : /* @__PURE__ */ p(
        O,
        {
          item: !0,
          sx: (u) => ({
            backgroundColor: Bi(
              0.8,
              u.palette.info.main
            ),
            borderRadius: "50%",
            padding: 1,
            width: 40,
            height: 40,
            color: "text.secondary"
          }),
          children: /* @__PURE__ */ p(he, { iconName: "list" })
        }
      ) }),
      /* @__PURE__ */ F(O, { item: !0, flexGrow: 1, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ p(le, { variant: "h1", children: t }),
        c != null && /* @__PURE__ */ p(
          we,
          {
            sx: (u) => ({
              backgroundColor: Bi(
                0.9,
                u.palette.info.main
              ),
              borderRadius: "2px",
              color: u.palette.textColor.primary,
              fontSize: 12,
              p: "5px",
              display: "inline-flex",
              height: 23,
              boxSizing: "border-box",
              ml: 2
            }),
            children: c
          }
        )
      ] }),
      /* @__PURE__ */ F(O, { item: !0, children: [
        l,
        o && /* @__PURE__ */ p(
          Ee,
          {
            onClick: n,
            variant: "outlined",
            color: "secondary",
            startIcon: /* @__PURE__ */ p(he, { iconName: "import" }),
            className: "import-entity",
            children: i || "Import"
          }
        ),
        s && /* @__PURE__ */ p(
          Ee,
          {
            onClick: r,
            variant: "contained",
            color: "info",
            startIcon: /* @__PURE__ */ p(he, { iconName: "add" }),
            className: "create-entity",
            children: a || "Create"
          }
        )
      ] })
    ] })
  }
) }), Mb = ({
  iconName: e,
  title: t,
  titleExtra: n,
  onImport: r,
  onCreate: i,
  importButtonName: a,
  createButtonName: o,
  canImport: s,
  canCreate: c,
  customButtons: l,
  count: u,
  dense: d = !1
}) => /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
  O,
  {
    container: !0,
    mt: d ? 1 : 2,
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    minHeight: 44,
    boxSizing: "border-box",
    className: "secondary-header",
    children: /* @__PURE__ */ F(
      O,
      {
        item: !0,
        xs: 12,
        container: !0,
        spacing: 2,
        pb: d ? 1 : 1.5,
        alignItems: "center",
        children: [
          e && /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
            O,
            {
              item: !0,
              sx: (f) => ({
                backgroundColor: Bi(0.8, f.palette.info.main),
                borderRadius: "50%",
                padding: 0.5,
                width: 30,
                height: 30,
                color: "text.secondary"
              }),
              children: /* @__PURE__ */ p(he, { iconName: e, sx: { fontSize: 22 } })
            }
          ) }),
          /* @__PURE__ */ F(
            O,
            {
              item: !0,
              flexGrow: 1,
              alignContent: "center",
              display: "flex",
              alignItems: "center",
              children: [
                /* @__PURE__ */ p(
                  le,
                  {
                    variant: d ? "h3" : "h2",
                    className: "secondary-header-title",
                    children: t
                  }
                ),
                n && /* @__PURE__ */ p(we, { ml: 2, display: "flex", alignItems: "center", children: n }),
                u != null && /* @__PURE__ */ p(
                  we,
                  {
                    sx: (f) => ({
                      backgroundColor: Bi(0.9, f.palette.info.main),
                      borderRadius: "2px",
                      color: f.palette.textColor.primary,
                      fontSize: 12,
                      py: "5px",
                      px: "6px",
                      display: "inline-flex",
                      height: 23,
                      boxSizing: "border-box",
                      ml: 2
                    }),
                    children: u
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ F(O, { item: !0, className: "secondary-header-actions", children: [
            l,
            s && /* @__PURE__ */ p(
              Ee,
              {
                onClick: r,
                variant: "outlined",
                color: "secondary",
                startIcon: /* @__PURE__ */ p(he, { iconName: "import" }),
                name: "import",
                className: "import-" + e,
                children: a || "Import"
              }
            ),
            c && /* @__PURE__ */ p(
              Ee,
              {
                onClick: i,
                variant: "contained",
                color: "info",
                startIcon: /* @__PURE__ */ p(he, { iconName: "add" }),
                className: "create-" + e,
                name: "create",
                children: o || "Create"
              }
            )
          ] })
        ]
      }
    )
  }
) }), mD = ({
  iconName: e,
  title: t,
  onImport: n,
  onCreate: r,
  onGenerate: i,
  importButtonName: a,
  createButtonName: o,
  canImport: s,
  canCreate: c,
  canGenerate: l,
  customButtons: u,
  dense: d = !1
}) => /* @__PURE__ */ p(ze, { children: /* @__PURE__ */ p(
  O,
  {
    container: !0,
    mt: d ? 1 : 3,
    borderBottom: "1px solid",
    borderColor: "borderColor.main",
    minHeight: 44,
    boxSizing: "border-box",
    className: "secondary-header",
    children: /* @__PURE__ */ F(
      O,
      {
        item: !0,
        xs: 12,
        container: !0,
        spacing: 2,
        pb: d ? 1 : 1.5,
        alignItems: "center",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ F(
            O,
            {
              item: !0,
              flexGrow: 1,
              alignContent: "center",
              display: "flex",
              alignItems: "center",
              maxWidth: "70%",
              children: [
                /* @__PURE__ */ p(O, { item: !0, mr: 2, children: /* @__PURE__ */ p(Pm, {}) }),
                /* @__PURE__ */ p(le, { variant: "body2", className: "secondary-header-title", children: t })
              ]
            }
          ),
          /* @__PURE__ */ F(
            O,
            {
              item: !0,
              className: "secondary-header-actions",
              flexWrap: "nowrap",
              display: "flex",
              alignItems: "center",
              children: [
                u,
                l && c && /* @__PURE__ */ p(
                  Ee,
                  {
                    onClick: i,
                    variant: "outlined",
                    startIcon: (
                      // not ideal, need to think about it later
                      /* @__PURE__ */ p(he, { sx: { fontSize: "16px !important" }, iconName: "stars" })
                    ),
                    name: "stars",
                    sx: {
                      mr: 2,
                      whiteSpace: "nowrap"
                    },
                    className: "stars-" + e,
                    children: "Generate"
                  }
                ),
                s && /* @__PURE__ */ p(
                  Ee,
                  {
                    onClick: n,
                    variant: "outlined",
                    startIcon: /* @__PURE__ */ p(he, { iconName: "import" }),
                    name: "import",
                    sx: {
                      mr: 2,
                      whiteSpace: "nowrap"
                    },
                    className: "import-" + e,
                    children: a || "Import"
                  }
                ),
                c && /* @__PURE__ */ p(
                  Ee,
                  {
                    onClick: r,
                    variant: "contained",
                    color: "info",
                    startIcon: /* @__PURE__ */ p(he, { iconName: "add" }),
                    className: "create-" + e,
                    name: "create",
                    sx: {
                      whiteSpace: "nowrap"
                    },
                    children: o || "Create"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  }
) }), xG = (e) => {
  var Hl;
  const t = cr(), n = Hi(), r = Ot(
    (nt) => nt.user.data
  ), {
    isImport: i,
    isCreate: a = !1,
    onImport: o,
    onCreate: s,
    onGenerate: c,
    onExport: l,
    moduleConfig: u,
    listConfig: d,
    allowDelete: f,
    isEnableMetadata: h,
    tileComponent: m,
    onRowClick: y,
    disableRowClick: v = !1,
    disableRowSelect: w,
    reloadId: I,
    isSilentReload: M,
    variant: k = "secondary",
    hiddenColumns: g,
    uniqName: A,
    dense: b,
    removeId: x,
    deleteSuccessMessage: _,
    exportFilteredResultsEnabled: R = !1,
    viewMode: P = !1
  } = e, { enqueueSnackbar: E } = bi(), [C, T] = Hv(), [D, z] = qe.useState(!0), B = C.get("fullSearch");
  if (!u)
    return /* @__PURE__ */ p(cf, { children: /* @__PURE__ */ p(gt, { size: 70 }) });
  const {
    addButtonTitle: W,
    tableTitle: L,
    moduleDescription: S,
    importButtonTitle: $,
    getCols: j,
    loadingMessage: N,
    rowId: q,
    listInitialSort: G,
    createCrudMethod: X,
    createFiltersPanel: Y,
    createSortingMethod: Q,
    metadataFilter: V,
    iconName: U,
    extendedSearchParam: Z = "search-scope",
    extendedSearchEnabled: H,
    extendedSearchOptions: ee = ["basic", "meta"]
  } = d, {
    rootSettings: { rootPath: ie, rootTitle: re },
    config: K,
    path: se,
    name: xe,
    title: ke
  } = u, ue = `${(K == null ? void 0 : K.typeContainer) || ""}${(K == null ? void 0 : K.parentId) || ""}${r.activeTenant}${A || ""}${xe}`, { data: fe } = Yv(V, !1, !0), de = qe.useMemo(() => rC(fe, !0).reduce(
    (nt, Gt) => (iC(Gt.header) || (nt[Gt.id] = !1), nt),
    {}
  ), [fe]), ce = sI(ue, {
    ...g,
    ...de
  }), { entityBreadcrumbs: te, columns: oe } = oI, J = qe.useMemo(
    () => (L || "entity").toLocaleLowerCase().replace(" ", "-"),
    []
  ), ne = qe.useMemo(() => X(K == null ? void 0 : K.typeContainer, K == null ? void 0 : K.parentId), [K == null ? void 0 : K.parentId]), ye = qe.useMemo(() => Y(K == null ? void 0 : K.typeContainer, K == null ? void 0 : K.parentId), [K == null ? void 0 : K.parentId]), Ae = qe.useMemo(() => Q(K == null ? void 0 : K.typeContainer), [K == null ? void 0 : K.parentId]), {
    data: { tableData: be, filtersData: je },
    filters: Oe,
    allowedSorting: Ve,
    actions: _e,
    pageCount: Re,
    pageSize: Le,
    getEntity: Ge,
    totalElements: Ke,
    numberOfElements: Ht,
    removeEntity: kr,
    updateFilters: Mt,
    setPageSize: xn,
    status: Pt,
    error: en
  } = jv(
    {
      get: ne.fetch,
      remove: ne.remove,
      getFilters: ye.getFilters,
      getSorting: Ae
    },
    I,
    M,
    {
      ...ce.storage,
      // we can probably set this params as default in requests??
      filters: {
        ...H ? { [Z]: ee } : {},
        ...ce.storage.filters
      }
    }
  ), { otherFilters: Tr, searchFilter: at } = wv(je), Zr = (Hl = at == null ? void 0 : at.options) == null ? void 0 : Hl.map((nt) => nt.value), Zi = qe.useMemo(() => JSON.stringify(Oe), [Oe]);
  qe.useEffect(() => {
    n(
      GC(
        te({
          title: ke,
          path: se,
          rootPath: ie,
          rootTitle: re,
          parentTitle: K == null ? void 0 : K.parentTitle,
          parentId: K == null ? void 0 : K.parentId
        })
      )
    );
  }, []), qe.useEffect(() => {
    B && Mt({ "filter.search": [B || ""] }), z(!1);
  }, [B]), qe.useEffect(() => {
    Pt === ve.SUCCESS && (K != null && K.typeContainer) && [ge.STUDY, ge.WORKSPACE].some(
      (nt) => nt === K.typeContainer
    ) && n(VC(K.typeContainer, K.parentId));
  }, [Pt, K == null ? void 0 : K.typeContainer, K == null ? void 0 : K.parentId]);
  const Xn = {
    [ge.LIBRARY]: "Library",
    [ge.STUDY]: "Studies",
    [ge.WORKSPACE]: "Workspace"
  };
  qe.useEffect(() => {
    document.title = `Prometheus ${K != null && K.typeContainer ? "- " + Xn[K.typeContainer] : ""} - ${L}`;
  }, [K == null ? void 0 : K.typeContainer]);
  const za = (nt) => {
    y ? y(nt) : t(`${nt.original[q]}`);
  }, Ba = qe.useCallback(
    async (nt) => {
      const Gt = await kr(nt == null ? void 0 : nt[x || "id"]);
      Gt && _ && E({
        message: _(nt),
        variant: "success"
      }), Gt === !1 && _ && E({
        message: "Unable to delete item.",
        variant: "error"
      });
    },
    [_, E, kr, x]
  ), Pe = Object.entries(Oe).some(
    ([nt, Gt]) => nt !== "search-scope" && (Gt == null ? void 0 : Gt.length) > 0
  ), an = H ? {
    extendedSearchEnabled: H,
    extendedSearchValue: Ys(
      Oe[Z],
      Zr
    ),
    toggleExtendedSearch: (nt = !1, Gt) => {
      ei({
        [Z]: nt ? Zr : ee,
        [at == null ? void 0 : at.name]: Gt
      });
    }
  } : {}, jo = {
    header: "",
    accessorKey: "actions",
    enableSorting: !1,
    enableResizing: !1,
    enableHiding: !1,
    size: 42,
    maxSize: 42,
    meta: {
      columnType: "action"
    },
    cell: (nt) => {
      const Gt = qe.useMemo(
        () => Ec(nt.row.original.actions),
        [nt.row.original.actions]
      ), bn = !!((K == null ? void 0 : K.typeContainer) !== ge.STUDY || Gt[kc.UPDATE]);
      return /* @__PURE__ */ p(ze, { children: bn ? /* @__PURE__ */ p(
        KM,
        {
          onRemove: f ? () => Ba(nt.row.original) : null,
          withConfirmation: !0,
          entityName: nt.row.original.title || nt.row.original.name
        }
      ) : /* @__PURE__ */ p(ze, {}) });
    }
  }, Wl = qe.useMemo(
    () => [
      ...aC(
        (d == null ? void 0 : d.cols) || (j == null ? void 0 : j({ metaAttributes: fe })) || oe,
        Ve
      ),
      ...f ? [jo] : []
    ],
    [Ve, fe, Ba]
  ), ea = qe.useMemo(
    () => !P && (Ec(_e)[kc.CREATE] || a),
    [_e, P]
  ), Ci = qe.useMemo(
    () => !P && (Ec(_e)[kc.IMPORT] || !1),
    [_e, P]
  ), $o = (nt, Gt) => {
    const bn = { [nt]: Gt };
    Mt(bn), ce == null || ce.setStorage("filters", {
      ...Oe,
      ...bn
    });
  }, ei = (nt) => {
    Mt(nt), ce == null || ce.setStorage("filters", {
      ...Oe,
      ...nt
    });
  }, Ul = () => {
    l(Oe);
  };
  if (Pt === ve.ERROR)
    return /* @__PURE__ */ p(O, { container: !0, p: 6, children: /* @__PURE__ */ p(cU, { ...en.response, noAction: !0 }) });
  const Wo = /* @__PURE__ */ p(
    Ee,
    {
      onClick: Ul,
      variant: "outlined",
      color: "primary",
      size: "small",
      startIcon: /* @__PURE__ */ p(he, { iconName: "export" }),
      children: "Export"
    }
  );
  return /* @__PURE__ */ F(
    O,
    {
      container: !0,
      px: b ? 0 : 6,
      flexDirection: "column",
      sx: { backgroundColor: "common.white", flexGrow: 1 },
      minHeight: "100%",
      children: [
        k !== "no-header" && /* @__PURE__ */ F(ze, { children: [
          k === "primary" && /* @__PURE__ */ p(
            pD,
            {
              iconName: U,
              title: L,
              canImport: i && Ci,
              canCreate: s && ea,
              importButtonName: $,
              createButtonName: W,
              onCreate: s,
              onImport: o,
              count: Ke,
              customButtons: R && Wo
            }
          ),
          k === "secondary" && /* @__PURE__ */ p(
            Mb,
            {
              title: L,
              canImport: i && Ci,
              canCreate: s && ea,
              importButtonName: $,
              createButtonName: W,
              onCreate: s,
              onImport: o,
              count: Ke,
              customButtons: R && Wo
            }
          ),
          k === "description" && /* @__PURE__ */ p(
            mD,
            {
              title: S,
              canImport: i && Ci,
              canCreate: s && ea,
              canGenerate: !!c,
              importButtonName: $,
              createButtonName: W,
              onCreate: s,
              onImport: o,
              onGenerate: c,
              customButtons: R && Wo
            }
          )
        ] }),
        /* @__PURE__ */ p(O, { container: !0, className: "table-" + J, my: 2, children: /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(O, { container: !0, flexWrap: "nowrap", children: /* @__PURE__ */ p(
          O,
          {
            item: !0,
            maxWidth: "100%",
            flexGrow: 1,
            sx: { overflowX: "auto" },
            className: "table-data-" + J,
            children: !D && /* @__PURE__ */ p(
              ua,
              {
                showFilterToggle: !0,
                variant: "controlled",
                noDataText: Pe ? "The result listing is empty because of the filter you applied" : "No data currently available",
                data: be,
                columns: Wl,
                pageCount: Re,
                pageSize: Le,
                resetPaginationKey: Zi,
                persistSettings: ce == null ? void 0 : ce.setStorage,
                loading: M ? Pt === ve.IN_PROGRESS : Pt === ve.IN_PROGRESS || Pt === ve.IN_PROGRESS_RELOAD,
                isInitial: Pt === ve.INITIAL,
                loadingMessage: N,
                onRowClick: v ? void 0 : za,
                disableRowSelect: w,
                fetchData: Ge,
                totalElements: Ke,
                defaultSorting: (ce == null ? void 0 : ce.storage.sort) || G,
                columnVisibility: ce == null ? void 0 : ce.storage.columns,
                hasFilters: Pe,
                searchComponent: at && /* @__PURE__ */ p(
                  Lv,
                  {
                    ...at,
                    value: Oe == null ? void 0 : Oe[at == null ? void 0 : at.name],
                    onChange: (nt) => $o(at == null ? void 0 : at.name, nt),
                    ...an
                  }
                ),
                children: /* @__PURE__ */ p(
                  Vp,
                  {
                    showLabel: !0,
                    filters: Tr,
                    value: Oe,
                    onChange: $o,
                    isLoading: Pt === ve.IN_PROGRESS,
                    isReloading: Pt === ve.IN_PROGRESS_RELOAD
                  }
                )
              }
            )
          }
        ) }) }) })
      ]
    }
  );
}, gD = ae(zr)`
  .collapsible-content-block__title {
    line-height: 30px;
    padding: 0 10px;
    /* height: 40px; */
    .collapsible-content-block__title-text {
      font-size: 14px;
      line-height: 24px;
    }
  }
  .collapsible-block__content-container {
    padding: 10px;
  }
`, bG = (e) => {
  const {
    item: t,
    updateSection: n,
    onCancelSectionName: r,
    copySection: i,
    removeSection: a,
    exportSection: o,
    children: s,
    viewMode: c,
    index: l,
    defaultState: u = !1,
    isExport: d,
    nameError: f,
    titleMeta: h,
    hideBody: m = !1,
    bodyViewMode: y = !1,
    disableNameEdit: v = !1,
    titleAddon: w,
    onEdit: I,
    hideCopyAction: M = !1,
    hideEditAction: k = !1
  } = e, g = m || v, A = c || y, b = !!t.description || !A;
  return /* @__PURE__ */ p(
    gD,
    {
      collapsible: !m,
      defaultState: u,
      className: "section-block-" + l,
      outlined: !0,
      size: "dense",
      title: /* @__PURE__ */ F(
        O,
        {
          item: !0,
          className: "section-block-title",
          display: "flex",
          alignItems: "center",
          minHeight: "36px",
          children: [
            l + 1,
            ".",
            " ",
            /* @__PURE__ */ F(
              we,
              {
                minWidth: g ? "auto" : "50%",
                maxWidth: g ? "fit-content" : void 0,
                ml: 0.5,
                pt: f ? "5px" : 0,
                sx: {
                  ".input-root": {
                    border: "1px solid",
                    borderColor: f ? "error.main" : "transparent"
                  },
                  ".editable-component-actions": {
                    right: "-74px",
                    left: "auto",
                    top: "16px",
                    bottom: "auto",
                    transform: "translateY(-50%)"
                  }
                },
                children: [
                  g ? /* @__PURE__ */ p(
                    le,
                    {
                      component: "span",
                      sx: {
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "textColor.secondary",
                        whiteSpace: "nowrap"
                      },
                      children: t.name
                    }
                  ) : /* @__PURE__ */ p(
                    Xt,
                    {
                      value: t.name,
                      fullWidth: !0,
                      onCancel: () => {
                        r == null || r(l);
                      },
                      onSubmit: (x) => n(l, "name", x),
                      placeholder: "Enter name...",
                      disabled: c || v,
                      color: "primary",
                      submitOnClickOutside: !0,
                      activateOnClick: !0,
                      showActions: !1
                    }
                  ),
                  f && /* @__PURE__ */ p(le, { color: "error.main", variant: "caption", display: "block", children: f })
                ]
              }
            ),
            h,
            w && /* @__PURE__ */ p(
              we,
              {
                display: "inline-flex",
                alignItems: "center",
                ml: m ? "20px" : 1.5,
                children: w
              }
            )
          ]
        }
      ),
      actions: c ? /* @__PURE__ */ p(ze, {}) : /* @__PURE__ */ F(
        we,
        {
          minHeight: 30,
          py: 0.5,
          className: "section-block-actions",
          display: "flex",
          children: [
            I && !k && /* @__PURE__ */ p(we, { pr: 1, display: "inline-flex", children: /* @__PURE__ */ p(
              Ue,
              {
                onClick: (x) => {
                  x.stopPropagation(), I == null || I(t, l);
                },
                name: "editItem",
                noExpand: !0,
                iconName: "edit",
                color: "primary"
              }
            ) }),
            d && /* @__PURE__ */ p(we, { pr: 1, display: "inline-flex", children: /* @__PURE__ */ p(
              Ue,
              {
                onClick: (x) => {
                  x.stopPropagation(), o(l, t.name);
                },
                name: "exportItem",
                noExpand: !0,
                iconName: "export",
                color: "primary"
              }
            ) }),
            !M && /* @__PURE__ */ p(we, { pr: 1, display: "inline-flex", children: /* @__PURE__ */ p(
              Ue,
              {
                onClick: (x) => {
                  x.stopPropagation(), i(l);
                },
                name: "copyItem",
                noExpand: !0,
                iconName: "copy",
                color: "primary"
              }
            ) }),
            /* @__PURE__ */ p(we, { display: "inline-flex", children: /* @__PURE__ */ p(
              Ue,
              {
                onClick: (x) => {
                  x.stopPropagation(), a(l);
                },
                name: "deleteItem",
                color: "error",
                iconName: "delete",
                noExpand: !0
              }
            ) })
          ]
        }
      ),
      children: !m && /* @__PURE__ */ F(O, { container: !0, spacing: A && !t.description ? 0 : 1, children: [
        b && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: A ? /* @__PURE__ */ p(
          le,
          {
            sx: {
              color: "textColor.secondary",
              fontSize: 14,
              lineHeight: "20px",
              whiteSpace: "pre-wrap"
            },
            children: t.description
          }
        ) : /* @__PURE__ */ p(
          Xt,
          {
            type: "text",
            value: t.description,
            placeholder: "Enter description...",
            size: "small",
            name: "description",
            fullWidth: !0,
            id: t.uuid + "description",
            onCancel: () => {
            },
            onSubmit: (x) => n(l, "description", x),
            disabled: c || y,
            color: "primary",
            submitOnClickOutside: !0,
            showActions: !1
          }
        ) }),
        /* @__PURE__ */ p(O, { item: !0, xs: 12, children: s })
      ] })
    },
    t.uuid
  );
}, yD = (e) => {
  const { getCurrentVersion: t, currentViewVersion: n } = e;
  return n ? /* @__PURE__ */ p(ze, { children: "Viewing now" }) : /* @__PURE__ */ p(
    Ee,
    {
      onClick: t,
      size: "small",
      color: "primary",
      variant: "outlined",
      children: "Preview"
    }
  );
}, AD = {
  createCols: (e, t) => [
    {
      Header: "Version",
      accessor: "versionNumber",
      id: "version",
      maxWidth: 50,
      isCropped: !0
    },
    {
      Header: "Author",
      accessor: "author",
      id: "author"
    },
    {
      Header: "Created",
      accessor: "timestamp",
      id: "timestamp",
      Cell: Fi,
      isCropped: !0,
      minWidth: 140,
      maxWidth: 140
    },
    {
      Header: "Preview",
      accessor: "preview",
      width: "5%",
      minWidth: 82,
      Cell: ({ value: n }) => /* @__PURE__ */ p(ze, { children: n && /* @__PURE__ */ p(
        yD,
        {
          currentViewVersion: t === n,
          getCurrentVersion: () => e(n)
        }
      ) })
    }
  ]
}, vD = Kt((e) => {
  const { onClose: t } = e, [n, r] = Te();
  return /* @__PURE__ */ p(O, { container: !0, p: 2, children: /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ F(O, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "message", textLabel: "Comment", children: /* @__PURE__ */ p(
      xr,
      {
        type: "text",
        value: n || "",
        minRows: 2,
        maxRows: 4,
        multiline: !0,
        size: "medium",
        onChange: (a) => r(a.target.value),
        fullWidth: !0,
        name: "message"
      }
    ) }) }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, textAlign: "right", children: [
      /* @__PURE__ */ p(
        Ee,
        {
          variant: "outlined",
          onClick: t,
          startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Ee,
        {
          onClick: async () => {
          },
          variant: "contained",
          color: "success",
          name: "save",
          sx: { ml: 1 },
          startIcon: /* @__PURE__ */ p(he, { iconName: "submit" }),
          children: "Save"
        }
      )
    ] })
  ] }) }) });
}), wG = (e) => {
  const t = cr(), { openModal: n, closeModal: r } = Mo(Jp), {
    data: i,
    setPreviewEntity: a,
    path: o,
    makeCopy: s,
    apiMethods: c,
    originVersionId: l
  } = e, { createCols: u } = AD, d = i.revertVersionId || i.versionId, {
    isStartHook: f,
    versions: h,
    currentVersion: m,
    isLoading: y,
    getCurrentVersion: v,
    copyVersion: w,
    totalElements: I
  } = OC(
    i.id,
    i.versionId,
    c.getList,
    c.getCurrent,
    s,
    l
  ), M = () => {
    n(() => /* @__PURE__ */ p(vD, { onClose: r }), "Add comment", {
      closeOnClickOutside: !0,
      width: "700px",
      onClose: r
    });
  }, k = Ce(() => u(
    v,
    d,
    w,
    l,
    M
  ), [v, d, w, l]);
  return tt(() => {
    m && (a(m), t(`/${o}/${i.id}`));
  }, [m]), /* @__PURE__ */ p(zr, { outlined: !0, elevated: !0, children: /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    xl,
    {
      columns: k,
      data: h,
      isLoading: y || !f,
      loadingMessage: "",
      totalElements: I,
      enableSorting: !0,
      enablePagination: !0,
      showColumnToggle: !0
    }
  ) }) });
}, _G = (e) => {
  const { makeCopy: t } = e;
  return /* @__PURE__ */ p(Ee, { onClick: t, size: "small", color: "primary", variant: "outlined", children: "Make a copy" });
}, xD = ae(O, {
  shouldForwardProp: (e) => e !== "width"
})`
  &.visible {
    transition: 0.5s;
    bottom: 0;
  }
  transition-delay: 0.5s;
  transition: 0.5s;
  bottom: -54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  position: fixed;
  z-index: 3;
  right: 0;
  background-color: #fff;
  min-height: 54px;
  height: auto;
  /* opacity: 0.85; */
  box-shadow: ${({ theme: e }) => e.customShadows[0]};
  width: ${(e) => e.width ? e.width : "75vw"};
  ${(e) => [e.theme.breakpoints.down("md")] + ` {
    width: 100%;
  }`}
`, bD = ae.div`
  font-size: 12px;
`, wD = (e) => {
  const {
    selectedConceptsCount: t,
    buttonText: n,
    onAdd: r,
    onClear: i,
    width: a,
    className: o = "",
    disabled: s,
    startContent: c,
    buttonStartIcon: l
  } = e;
  return /* @__PURE__ */ F(
    xD,
    {
      item: !0,
      xs: 12,
      px: 2,
      py: 1,
      className: (t > 0 && "visible " || " ") + o,
      width: a || "100%",
      children: [
        /* @__PURE__ */ p(O, { item: !0, display: "flex", alignItems: "center", minWidth: 0, children: c }),
        /* @__PURE__ */ F(O, { item: !0, display: "flex", alignItems: "center", columnGap: 1.5, children: [
          /* @__PURE__ */ F(bD, { children: [
            "Selected items: ",
            t
          ] }),
          /* @__PURE__ */ p(
            Ee,
            {
              variant: "text",
              sx: {
                textDecoration: "underline",
                "&.MuiButton-root": { fontSize: 12, fontWeight: 400 }
              },
              onClick: i,
              startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
              disabled: t < 1,
              children: "Clear all selected"
            }
          ),
          /* @__PURE__ */ p(
            Ee,
            {
              onClick: r,
              disabled: t < 1 || s,
              name: "add-to-concept-set",
              variant: "contained",
              color: "success",
              startIcon: l === void 0 ? /* @__PURE__ */ p(
                he,
                {
                  iconName: "add",
                  className: "icon-button",
                  sx: { fontSize: 16 }
                }
              ) : l,
              children: /* @__PURE__ */ p("span", { children: n || "Add" })
            }
          )
        ] })
      ]
    }
  );
};
var Ib = { exports: {} }, _D = "4.13.0";
function Na(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Lm(e) {
  return e.length === 1 && (e = SD(e)), {
    left: function(t, n, r, i) {
      for (r == null && (r = 0), i == null && (i = t.length); r < i; ) {
        var a = r + i >>> 1;
        e(t[a], n) < 0 ? r = a + 1 : i = a;
      }
      return r;
    },
    right: function(t, n, r, i) {
      for (r == null && (r = 0), i == null && (i = t.length); r < i; ) {
        var a = r + i >>> 1;
        e(t[a], n) > 0 ? i = a : r = a + 1;
      }
      return r;
    }
  };
}
function SD(e) {
  return function(t, n) {
    return Na(e(t), n);
  };
}
var Nb = Lm(Na), wa = Nb.right, CD = Nb.left;
function ED(e, t) {
  t == null && (t = Ob);
  for (var n = 0, r = e.length - 1, i = e[0], a = new Array(r < 0 ? 0 : r); n < r; ) a[n] = t(i, i = e[++n]);
  return a;
}
function Ob(e, t) {
  return [e, t];
}
function kD(e, t, n) {
  var r = e.length, i = t.length, a = new Array(r * i), o, s, c, l;
  for (n == null && (n = Ob), o = c = 0; o < r; ++o)
    for (l = e[o], s = 0; s < i; ++s, ++c)
      a[c] = n(l, t[s]);
  return a;
}
function TD(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Yi(e) {
  return e === null ? NaN : +e;
}
function Rb(e, t) {
  var n = e.length, r = 0, i = -1, a = 0, o, s, c = 0;
  if (t == null)
    for (; ++i < n; )
      isNaN(o = Yi(e[i])) || (s = o - a, a += s / ++r, c += s * (o - a));
  else
    for (; ++i < n; )
      isNaN(o = Yi(t(e[i], i, e))) || (s = o - a, a += s / ++r, c += s * (o - a));
  if (r > 1) return c / (r - 1);
}
function Db(e, t) {
  var n = Rb(e, t);
  return n && Math.sqrt(n);
}
function Pb(e, t) {
  var n = e.length, r = -1, i, a, o;
  if (t == null) {
    for (; ++r < n; )
      if ((i = e[r]) != null && i >= i)
        for (a = o = i; ++r < n; )
          (i = e[r]) != null && (a > i && (a = i), o < i && (o = i));
  } else
    for (; ++r < n; )
      if ((i = t(e[r], r, e)) != null && i >= i)
        for (a = o = i; ++r < n; )
          (i = t(e[r], r, e)) != null && (a > i && (a = i), o < i && (o = i));
  return [a, o];
}
var Lb = Array.prototype, MD = Lb.slice, ID = Lb.map;
function tc(e) {
  return function() {
    return e;
  };
}
function ND(e) {
  return e;
}
function yr(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = e + r * n;
  return a;
}
var Bh = Math.sqrt(50), Fh = Math.sqrt(10), Yh = Math.sqrt(2);
function zm(e, t, n) {
  var r, i = -1, a, o, s;
  if (t = +t, e = +e, n = +n, e === t && n > 0) return [e];
  if ((r = t < e) && (a = e, e = t, t = a), (s = Ns(e, t, n)) === 0 || !isFinite(s)) return [];
  if (s > 0)
    for (e = Math.ceil(e / s), t = Math.floor(t / s), o = new Array(a = Math.ceil(t - e + 1)); ++i < a; ) o[i] = (e + i) * s;
  else
    for (e = Math.floor(e * s), t = Math.ceil(t * s), o = new Array(a = Math.ceil(e - t + 1)); ++i < a; ) o[i] = (e - i) / s;
  return r && o.reverse(), o;
}
function Ns(e, t, n) {
  var r = (t - e) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), a = r / Math.pow(10, i);
  return i >= 0 ? (a >= Bh ? 10 : a >= Fh ? 5 : a >= Yh ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= Bh ? 10 : a >= Fh ? 5 : a >= Yh ? 2 : 1);
}
function qs(e, t, n) {
  var r = Math.abs(t - e) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), a = r / i;
  return a >= Bh ? i *= 10 : a >= Fh ? i *= 5 : a >= Yh && (i *= 2), t < e ? -i : i;
}
function zb(e) {
  return Math.ceil(Math.log(e.length) / Math.LN2) + 1;
}
function OD() {
  var e = ND, t = Pb, n = zb;
  function r(i) {
    var a, o = i.length, s, c = new Array(o);
    for (a = 0; a < o; ++a)
      c[a] = e(i[a], a, i);
    var l = t(c), u = l[0], d = l[1], f = n(c, u, d);
    Array.isArray(f) || (f = qs(u, d, f), f = yr(Math.ceil(u / f) * f, Math.floor(d / f) * f, f));
    for (var h = f.length; f[0] <= u; ) f.shift(), --h;
    for (; f[h - 1] > d; ) f.pop(), --h;
    var m = new Array(h + 1), y;
    for (a = 0; a <= h; ++a)
      y = m[a] = [], y.x0 = a > 0 ? f[a - 1] : u, y.x1 = a < h ? f[a] : d;
    for (a = 0; a < o; ++a)
      s = c[a], u <= s && s <= d && m[wa(f, s, 0, h)].push(i[a]);
    return m;
  }
  return r.value = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : tc(i), r) : e;
  }, r.domain = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : tc([i[0], i[1]]), r) : t;
  }, r.thresholds = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Array.isArray(i) ? tc(MD.call(i)) : tc(i), r) : n;
  }, r;
}
function Xs(e, t, n) {
  if (n == null && (n = Yi), !!(r = e.length)) {
    if ((t = +t) <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, a = Math.floor(i), o = +n(e[a], a, e), s = +n(e[a + 1], a + 1, e);
    return o + (s - o) * (i - a);
  }
}
function RD(e, t, n) {
  return e = ID.call(e, Yi).sort(Na), Math.ceil((n - t) / (2 * (Xs(e, 0.75) - Xs(e, 0.25)) * Math.pow(e.length, -1 / 3)));
}
function DD(e, t, n) {
  return Math.ceil((n - t) / (3.5 * Db(e) * Math.pow(e.length, -1 / 3)));
}
function PD(e, t) {
  var n = e.length, r = -1, i, a;
  if (t == null) {
    for (; ++r < n; )
      if ((i = e[r]) != null && i >= i)
        for (a = i; ++r < n; )
          (i = e[r]) != null && i > a && (a = i);
  } else
    for (; ++r < n; )
      if ((i = t(e[r], r, e)) != null && i >= i)
        for (a = i; ++r < n; )
          (i = t(e[r], r, e)) != null && i > a && (a = i);
  return a;
}
function LD(e, t) {
  var n = e.length, r = n, i = -1, a, o = 0;
  if (t == null)
    for (; ++i < n; )
      isNaN(a = Yi(e[i])) ? --r : o += a;
  else
    for (; ++i < n; )
      isNaN(a = Yi(t(e[i], i, e))) ? --r : o += a;
  if (r) return o / r;
}
function zD(e, t) {
  var n = e.length, r = -1, i, a = [];
  if (t == null)
    for (; ++r < n; )
      isNaN(i = Yi(e[r])) || a.push(i);
  else
    for (; ++r < n; )
      isNaN(i = Yi(t(e[r], r, e))) || a.push(i);
  return Xs(a.sort(Na), 0.5);
}
function Bm(e) {
  for (var t = e.length, n, r = -1, i = 0, a, o; ++r < t; ) i += e[r].length;
  for (a = new Array(i); --t >= 0; )
    for (o = e[t], n = o.length; --n >= 0; )
      a[--i] = o[n];
  return a;
}
function Bb(e, t) {
  var n = e.length, r = -1, i, a;
  if (t == null) {
    for (; ++r < n; )
      if ((i = e[r]) != null && i >= i)
        for (a = i; ++r < n; )
          (i = e[r]) != null && a > i && (a = i);
  } else
    for (; ++r < n; )
      if ((i = t(e[r], r, e)) != null && i >= i)
        for (a = i; ++r < n; )
          (i = t(e[r], r, e)) != null && a > i && (a = i);
  return a;
}
function BD(e, t) {
  for (var n = t.length, r = new Array(n); n--; ) r[n] = e[t[n]];
  return r;
}
function FD(e, t) {
  if (n = e.length) {
    var n, r = 0, i = 0, a, o = e[i];
    for (t == null && (t = Na); ++r < n; )
      (t(a = e[r], o) < 0 || t(o, o) !== 0) && (o = a, i = r);
    if (t(o, o) === 0) return i;
  }
}
function YD(e, t, n) {
  for (var r = (n ?? e.length) - (t = t == null ? 0 : +t), i, a; r; )
    a = Math.random() * r-- | 0, i = e[r + t], e[r + t] = e[a + t], e[a + t] = i;
  return e;
}
function jD(e, t) {
  var n = e.length, r = -1, i, a = 0;
  if (t == null)
    for (; ++r < n; )
      (i = +e[r]) && (a += i);
  else
    for (; ++r < n; )
      (i = +t(e[r], r, e)) && (a += i);
  return a;
}
function Fb(e) {
  if (!(a = e.length)) return [];
  for (var t = -1, n = Bb(e, $D), r = new Array(n); ++t < n; )
    for (var i = -1, a, o = r[t] = new Array(a); ++i < a; )
      o[i] = e[i][t];
  return r;
}
function $D(e) {
  return e.length;
}
function WD() {
  return Fb(arguments);
}
var vd = Array.prototype.slice;
function UD(e) {
  return e;
}
var Pc = 1, Lc = 2, jh = 3, ds = 4, by = 1e-6;
function HD(e) {
  return "translate(" + (e + 0.5) + ",0)";
}
function GD(e) {
  return "translate(0," + (e + 0.5) + ")";
}
function VD(e) {
  return function(t) {
    return +e(t);
  };
}
function QD(e) {
  var t = Math.max(0, e.bandwidth() - 1) / 2;
  return e.round() && (t = Math.round(t)), function(n) {
    return +e(n) + t;
  };
}
function qD() {
  return !this.__axis;
}
function Sf(e, t) {
  var n = [], r = null, i = null, a = 6, o = 6, s = 3, c = e === Pc || e === ds ? -1 : 1, l = e === ds || e === Lc ? "x" : "y", u = e === Pc || e === jh ? HD : GD;
  function d(f) {
    var h = r ?? (t.ticks ? t.ticks.apply(t, n) : t.domain()), m = i ?? (t.tickFormat ? t.tickFormat.apply(t, n) : UD), y = Math.max(a, 0) + s, v = t.range(), w = +v[0] + 0.5, I = +v[v.length - 1] + 0.5, M = (t.bandwidth ? QD : VD)(t.copy()), k = f.selection ? f.selection() : f, g = k.selectAll(".domain").data([null]), A = k.selectAll(".tick").data(h, t).order(), b = A.exit(), x = A.enter().append("g").attr("class", "tick"), _ = A.select("line"), R = A.select("text");
    g = g.merge(g.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000")), A = A.merge(x), _ = _.merge(x.append("line").attr("stroke", "#000").attr(l + "2", c * a)), R = R.merge(x.append("text").attr("fill", "#000").attr(l, c * y).attr("dy", e === Pc ? "0em" : e === jh ? "0.71em" : "0.32em")), f !== k && (g = g.transition(f), A = A.transition(f), _ = _.transition(f), R = R.transition(f), b = b.transition(f).attr("opacity", by).attr("transform", function(P) {
      return isFinite(P = M(P)) ? u(P) : this.getAttribute("transform");
    }), x.attr("opacity", by).attr("transform", function(P) {
      var E = this.parentNode.__axis;
      return u(E && isFinite(E = E(P)) ? E : M(P));
    })), b.remove(), g.attr("d", e === ds || e == Lc ? "M" + c * o + "," + w + "H0.5V" + I + "H" + c * o : "M" + w + "," + c * o + "V0.5H" + I + "V" + c * o), A.attr("opacity", 1).attr("transform", function(P) {
      return u(M(P));
    }), _.attr(l + "2", c * a), R.attr(l, c * y).text(m), k.filter(qD).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", e === Lc ? "start" : e === ds ? "end" : "middle"), k.each(function() {
      this.__axis = M;
    });
  }
  return d.scale = function(f) {
    return arguments.length ? (t = f, d) : t;
  }, d.ticks = function() {
    return n = vd.call(arguments), d;
  }, d.tickArguments = function(f) {
    return arguments.length ? (n = f == null ? [] : vd.call(f), d) : n.slice();
  }, d.tickValues = function(f) {
    return arguments.length ? (r = f == null ? null : vd.call(f), d) : r && r.slice();
  }, d.tickFormat = function(f) {
    return arguments.length ? (i = f, d) : i;
  }, d.tickSize = function(f) {
    return arguments.length ? (a = o = +f, d) : a;
  }, d.tickSizeInner = function(f) {
    return arguments.length ? (a = +f, d) : a;
  }, d.tickSizeOuter = function(f) {
    return arguments.length ? (o = +f, d) : o;
  }, d.tickPadding = function(f) {
    return arguments.length ? (s = +f, d) : s;
  }, d;
}
function XD(e) {
  return Sf(Pc, e);
}
function JD(e) {
  return Sf(Lc, e);
}
function Yb(e) {
  return Sf(jh, e);
}
function KD(e) {
  return Sf(ds, e);
}
var ZD = { value: function() {
} };
function Vi() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new zc(n);
}
function zc(e) {
  this._ = e;
}
function eP(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
zc.prototype = Vi.prototype = {
  constructor: zc,
  on: function(e, t) {
    var n = this._, r = eP(e + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; ) if ((i = (e = r[a]).type) && (i = tP(n[i], e.name))) return i;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++a < o; )
      if (i = (e = r[a]).type) n[i] = wy(n[i], e.name, t);
      else if (t == null) for (i in n) n[i] = wy(n[i], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new zc(e);
  },
  call: function(e, t) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (a = this._[e], r = 0, i = a.length; r < i; ++r) a[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var r = this._[e], i = 0, a = r.length; i < a; ++i) r[i].value.apply(t, n);
  }
};
function tP(e, t) {
  for (var n = 0, r = e.length, i; n < r; ++n)
    if ((i = e[n]).name === t)
      return i.value;
}
function wy(e, t, n) {
  for (var r = 0, i = e.length; r < i; ++r)
    if (e[r].name === t) {
      e[r] = ZD, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var $h = "http://www.w3.org/1999/xhtml";
const Wh = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: $h,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Il(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Wh.hasOwnProperty(t) ? { space: Wh[t], local: e } : e;
}
function nP(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === $h && t.documentElement.namespaceURI === $h ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function rP(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Cf(e) {
  var t = Il(e);
  return (t.local ? rP : nP)(t);
}
function iP() {
}
function Ef(e) {
  return e == null ? iP : function() {
    return this.querySelector(e);
  };
}
function aP(e) {
  typeof e != "function" && (e = Ef(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, s = r[i] = new Array(o), c, l, u = 0; u < o; ++u)
      (c = a[u]) && (l = e.call(c, c.__data__, u, a)) && ("__data__" in c && (l.__data__ = c.__data__), s[u] = l);
  return new En(r, this._parents);
}
function oP() {
  return [];
}
function Fm(e) {
  return e == null ? oP : function() {
    return this.querySelectorAll(e);
  };
}
function sP(e) {
  typeof e != "function" && (e = Fm(e));
  for (var t = this._groups, n = t.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = t[a], s = o.length, c, l = 0; l < s; ++l)
      (c = o[l]) && (r.push(e.call(c, c.__data__, l, o)), i.push(c));
  return new En(r, i);
}
var jb = function(e) {
  return function() {
    return this.matches(e);
  };
};
if (typeof document < "u") {
  var Ko = document.documentElement;
  if (!Ko.matches) {
    var lP = Ko.webkitMatchesSelector || Ko.msMatchesSelector || Ko.mozMatchesSelector || Ko.oMatchesSelector;
    jb = function(e) {
      return function() {
        return lP.call(this, e);
      };
    };
  }
}
const Ym = jb;
function cP(e) {
  typeof e != "function" && (e = Ym(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l)
      (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
  return new En(r, this._parents);
}
function $b(e) {
  return new Array(e.length);
}
function uP() {
  return new En(this._enter || this._groups.map($b), this._parents);
}
function ou(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
ou.prototype = {
  constructor: ou,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function fP(e) {
  return function() {
    return e;
  };
}
var _y = "$";
function dP(e, t, n, r, i, a) {
  for (var o = 0, s, c = t.length, l = a.length; o < l; ++o)
    (s = t[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new ou(e, a[o]);
  for (; o < c; ++o)
    (s = t[o]) && (i[o] = s);
}
function hP(e, t, n, r, i, a, o) {
  var s, c, l = {}, u = t.length, d = a.length, f = new Array(u), h;
  for (s = 0; s < u; ++s)
    (c = t[s]) && (f[s] = h = _y + o.call(c, c.__data__, s, t), h in l ? i[s] = c : l[h] = c);
  for (s = 0; s < d; ++s)
    h = _y + o.call(e, a[s], s, a), (c = l[h]) ? (r[s] = c, c.__data__ = a[s], l[h] = null) : n[s] = new ou(e, a[s]);
  for (s = 0; s < u; ++s)
    (c = t[s]) && l[f[s]] === c && (i[s] = c);
}
function pP(e, t) {
  if (!e)
    return h = new Array(this.size()), l = -1, this.each(function(A) {
      h[++l] = A;
    }), h;
  var n = t ? hP : dP, r = this._parents, i = this._groups;
  typeof e != "function" && (e = fP(e));
  for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), l = 0; l < a; ++l) {
    var u = r[l], d = i[l], f = d.length, h = e.call(u, u && u.__data__, l, r), m = h.length, y = s[l] = new Array(m), v = o[l] = new Array(m), w = c[l] = new Array(f);
    n(u, d, y, v, w, h, t);
    for (var I = 0, M = 0, k, g; I < m; ++I)
      if (k = y[I]) {
        for (I >= M && (M = I + 1); !(g = v[M]) && ++M < m; ) ;
        k._next = g || null;
      }
  }
  return o = new En(o, r), o._enter = s, o._exit = c, o;
}
function mP() {
  return new En(this._exit || this._groups.map($b), this._parents);
}
function gP(e) {
  for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var c = t[s], l = n[s], u = c.length, d = o[s] = new Array(u), f, h = 0; h < u; ++h)
      (f = c[h] || l[h]) && (d[h] = f);
  for (; s < r; ++s)
    o[s] = t[s];
  return new En(o, this._parents);
}
function yP() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var r = e[t], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && a !== o.nextSibling && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function AP(e) {
  e || (e = vP);
  function t(d, f) {
    return d && f ? e(d.__data__, f.__data__) : !d - !f;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], s = o.length, c = i[a] = new Array(s), l, u = 0; u < s; ++u)
      (l = o[u]) && (c[u] = l);
    c.sort(t);
  }
  return new En(i, this._parents).order();
}
function vP(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function xP() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function bP() {
  var e = new Array(this.size()), t = -1;
  return this.each(function() {
    e[++t] = this;
  }), e;
}
function wP() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function _P() {
  var e = 0;
  return this.each(function() {
    ++e;
  }), e;
}
function SP() {
  return !this.node();
}
function CP(e) {
  for (var t = this._groups, n = 0, r = t.length; n < r; ++n)
    for (var i = t[n], a = 0, o = i.length, s; a < o; ++a)
      (s = i[a]) && e.call(s, s.__data__, a, i);
  return this;
}
function EP(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function kP(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function TP(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function MP(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function IP(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function NP(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function OP(e, t) {
  var n = Il(e);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((t == null ? n.local ? kP : EP : typeof t == "function" ? n.local ? NP : IP : n.local ? MP : TP)(n, t));
}
function jm(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function RP(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function DP(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function PP(e, t, n) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
  };
}
function LP(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? RP : typeof t == "function" ? PP : DP)(e, t, n ?? "")) : _a(this.node(), e);
}
function _a(e, t) {
  return e.style.getPropertyValue(t) || jm(e).getComputedStyle(e, null).getPropertyValue(t);
}
function zP(e) {
  return function() {
    delete this[e];
  };
}
function BP(e, t) {
  return function() {
    this[e] = t;
  };
}
function FP(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function YP(e, t) {
  return arguments.length > 1 ? this.each((t == null ? zP : typeof t == "function" ? FP : BP)(e, t)) : this.node()[e];
}
function Wb(e) {
  return e.trim().split(/^|\s+/);
}
function $m(e) {
  return e.classList || new Ub(e);
}
function Ub(e) {
  this._node = e, this._names = Wb(e.getAttribute("class") || "");
}
Ub.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function Hb(e, t) {
  for (var n = $m(e), r = -1, i = t.length; ++r < i; ) n.add(t[r]);
}
function Gb(e, t) {
  for (var n = $m(e), r = -1, i = t.length; ++r < i; ) n.remove(t[r]);
}
function jP(e) {
  return function() {
    Hb(this, e);
  };
}
function $P(e) {
  return function() {
    Gb(this, e);
  };
}
function WP(e, t) {
  return function() {
    (t.apply(this, arguments) ? Hb : Gb)(this, e);
  };
}
function UP(e, t) {
  var n = Wb(e + "");
  if (arguments.length < 2) {
    for (var r = $m(this.node()), i = -1, a = n.length; ++i < a; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? WP : t ? jP : $P)(n, t));
}
function HP() {
  this.textContent = "";
}
function GP(e) {
  return function() {
    this.textContent = e;
  };
}
function VP(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function QP(e) {
  return arguments.length ? this.each(e == null ? HP : (typeof e == "function" ? VP : GP)(e)) : this.node().textContent;
}
function qP() {
  this.innerHTML = "";
}
function XP(e) {
  return function() {
    this.innerHTML = e;
  };
}
function JP(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function KP(e) {
  return arguments.length ? this.each(e == null ? qP : (typeof e == "function" ? JP : XP)(e)) : this.node().innerHTML;
}
function ZP() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function eL() {
  return this.each(ZP);
}
function tL() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function nL() {
  return this.each(tL);
}
function rL(e) {
  var t = typeof e == "function" ? e : Cf(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function iL() {
  return null;
}
function aL(e, t) {
  var n = typeof e == "function" ? e : Cf(e), r = t == null ? iL : typeof t == "function" ? t : Ef(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function oL() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function sL() {
  return this.each(oL);
}
function lL() {
  return this.parentNode.insertBefore(this.cloneNode(!1), this.nextSibling);
}
function cL() {
  return this.parentNode.insertBefore(this.cloneNode(!0), this.nextSibling);
}
function uL(e) {
  return this.select(e ? cL : lL);
}
function fL(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
var Vb = {}, Ne = null;
if (typeof document < "u") {
  var dL = document.documentElement;
  "onmouseenter" in dL || (Vb = { mouseenter: "mouseover", mouseleave: "mouseout" });
}
function hL(e, t, n) {
  return e = Qb(e, t, n), function(r) {
    var i = r.relatedTarget;
    (!i || i !== this && !(i.compareDocumentPosition(this) & 8)) && e.call(this, r);
  };
}
function Qb(e, t, n) {
  return function(r) {
    var i = Ne;
    Ne = r;
    try {
      e.call(this, this.__data__, t, n);
    } finally {
      Ne = i;
    }
  };
}
function pL(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", r = t.indexOf(".");
    return r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: n };
  });
}
function mL(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, r = -1, i = t.length, a; n < i; ++n)
        a = t[n], (!e.type || a.type === e.type) && a.name === e.name ? this.removeEventListener(a.type, a.listener, a.capture) : t[++r] = a;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function gL(e, t, n) {
  var r = Vb.hasOwnProperty(e.type) ? hL : Qb;
  return function(i, a, o) {
    var s = this.__on, c, l = r(t, a, o);
    if (s) {
      for (var u = 0, d = s.length; u < d; ++u)
        if ((c = s[u]).type === e.type && c.name === e.name) {
          this.removeEventListener(c.type, c.listener, c.capture), this.addEventListener(c.type, c.listener = l, c.capture = n), c.value = t;
          return;
        }
    }
    this.addEventListener(e.type, l, n), c = { type: e.type, name: e.name, value: t, listener: l, capture: n }, s ? s.push(c) : this.__on = [c];
  };
}
function yL(e, t, n) {
  var r = pL(e + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var c = 0, l = s.length, u; c < l; ++c)
        for (i = 0, u = s[c]; i < a; ++i)
          if ((o = r[i]).type === u.type && o.name === u.name)
            return u.value;
    }
    return;
  }
  for (s = t ? gL : mL, n == null && (n = !1), i = 0; i < a; ++i) this.each(s(r[i], t, n));
  return this;
}
function Js(e, t, n, r) {
  var i = Ne;
  e.sourceEvent = Ne, Ne = e;
  try {
    return t.apply(n, r);
  } finally {
    Ne = i;
  }
}
function qb(e, t, n) {
  var r = jm(e), i = r.CustomEvent;
  typeof i == "function" ? i = new i(t, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(t, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(t, !1, !1)), e.dispatchEvent(i);
}
function AL(e, t) {
  return function() {
    return qb(this, e, t);
  };
}
function vL(e, t) {
  return function() {
    return qb(this, e, t.apply(this, arguments));
  };
}
function xL(e, t) {
  return this.each((typeof t == "function" ? vL : AL)(e, t));
}
var Wm = [null];
function En(e, t) {
  this._groups = e, this._parents = t;
}
function Oa() {
  return new En([[document.documentElement]], Wm);
}
En.prototype = Oa.prototype = {
  constructor: En,
  select: aP,
  selectAll: sP,
  filter: cP,
  data: pP,
  enter: uP,
  exit: mP,
  merge: gP,
  order: yP,
  sort: AP,
  call: xP,
  nodes: bP,
  node: wP,
  size: _P,
  empty: SP,
  each: CP,
  attr: OP,
  style: LP,
  property: YP,
  classed: UP,
  text: QP,
  html: KP,
  raise: eL,
  lower: nL,
  append: rL,
  insert: aL,
  remove: sL,
  clone: uL,
  datum: fL,
  on: yL,
  dispatch: xL
};
function Ut(e) {
  return typeof e == "string" ? new En([[document.querySelector(e)]], [document.documentElement]) : new En([[e]], Wm);
}
function bL(e) {
  return Ut(Cf(e).call(document.documentElement));
}
var wL = 0;
function Xb() {
  return new Uh();
}
function Uh() {
  this._ = "@" + (++wL).toString(36);
}
Uh.prototype = Xb.prototype = {
  constructor: Uh,
  get: function(e) {
    for (var t = this._; !(t in e); ) if (!(e = e.parentNode)) return;
    return e[t];
  },
  set: function(e, t) {
    return e[this._] = t;
  },
  remove: function(e) {
    return this._ in e && delete e[this._];
  },
  toString: function() {
    return this._;
  }
};
function Um() {
  for (var e = Ne, t; t = e.sourceEvent; ) e = t;
  return e;
}
function kf(e, t) {
  var n = e.ownerSVGElement || e;
  if (n.createSVGPoint) {
    var r = n.createSVGPoint();
    return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
  }
  var i = e.getBoundingClientRect();
  return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
}
function Oi(e) {
  var t = Um();
  return t.changedTouches && (t = t.changedTouches[0]), kf(e, t);
}
function _L(e) {
  return typeof e == "string" ? new En([document.querySelectorAll(e)], [document.documentElement]) : new En([e ?? []], Wm);
}
function su(e, t, n) {
  arguments.length < 3 && (n = t, t = Um().changedTouches);
  for (var r = 0, i = t ? t.length : 0, a; r < i; ++r)
    if ((a = t[r]).identifier === n)
      return kf(e, a);
  return null;
}
function SL(e, t) {
  t == null && (t = Um().touches);
  for (var n = 0, r = t ? t.length : 0, i = new Array(r); n < r; ++n)
    i[n] = kf(e, t[n]);
  return i;
}
function xd() {
  Ne.stopImmediatePropagation();
}
function lo() {
  Ne.preventDefault(), Ne.stopImmediatePropagation();
}
function Tf(e) {
  var t = e.document.documentElement, n = Ut(e).on("dragstart.drag", lo, !0);
  "onselectstart" in t ? n.on("selectstart.drag", lo, !0) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function Mf(e, t) {
  var n = e.document.documentElement, r = Ut(e).on("dragstart.drag", null);
  t && (r.on("click.drag", lo, !0), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
function nc(e) {
  return function() {
    return e;
  };
}
function Hh(e, t, n, r, i, a, o, s, c, l) {
  this.target = e, this.type = t, this.subject = n, this.identifier = r, this.active = i, this.x = a, this.y = o, this.dx = s, this.dy = c, this._ = l;
}
Hh.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function CL() {
  return !Ne.button;
}
function EL() {
  return this.parentNode;
}
function kL(e) {
  return e ?? { x: Ne.x, y: Ne.y };
}
function TL() {
  return "ontouchstart" in this;
}
function ML() {
  var e = CL, t = EL, n = kL, r = TL, i = {}, a = Vi("start", "drag", "end"), o = 0, s, c, l, u, d = 0;
  function f(k) {
    k.on("mousedown.drag", h).filter(r).on("touchstart.drag", v).on("touchmove.drag", w).on("touchend.drag touchcancel.drag", I).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function h() {
    if (!(u || !e.apply(this, arguments))) {
      var k = M("mouse", t.apply(this, arguments), Oi, this, arguments);
      k && (Ut(Ne.view).on("mousemove.drag", m, !0).on("mouseup.drag", y, !0), Tf(Ne.view), xd(), l = !1, s = Ne.clientX, c = Ne.clientY, k("start"));
    }
  }
  function m() {
    if (lo(), !l) {
      var k = Ne.clientX - s, g = Ne.clientY - c;
      l = k * k + g * g > d;
    }
    i.mouse("drag");
  }
  function y() {
    Ut(Ne.view).on("mousemove.drag mouseup.drag", null), Mf(Ne.view, l), lo(), i.mouse("end");
  }
  function v() {
    if (e.apply(this, arguments)) {
      var k = Ne.changedTouches, g = t.apply(this, arguments), A = k.length, b, x;
      for (b = 0; b < A; ++b)
        (x = M(k[b].identifier, g, su, this, arguments)) && (xd(), x("start"));
    }
  }
  function w() {
    var k = Ne.changedTouches, g = k.length, A, b;
    for (A = 0; A < g; ++A)
      (b = i[k[A].identifier]) && (lo(), b("drag"));
  }
  function I() {
    var k = Ne.changedTouches, g = k.length, A, b;
    for (u && clearTimeout(u), u = setTimeout(function() {
      u = null;
    }, 500), A = 0; A < g; ++A)
      (b = i[k[A].identifier]) && (xd(), b("end"));
  }
  function M(k, g, A, b, x) {
    var _ = A(g, k), R, P, E, C = a.copy();
    if (Js(new Hh(f, "beforestart", R, k, o, _[0], _[1], 0, 0, C), function() {
      return (Ne.subject = R = n.apply(b, x)) == null ? !1 : (P = R.x - _[0] || 0, E = R.y - _[1] || 0, !0);
    }))
      return function T(D) {
        var z = _, B;
        switch (D) {
          case "start":
            i[k] = T, B = o++;
            break;
          case "end":
            delete i[k], --o;
          case "drag":
            _ = A(g, k), B = o;
            break;
        }
        Js(new Hh(f, D, R, k, B, _[0] + P, _[1] + E, _[0] - z[0], _[1] - z[1], C), C.apply, C, [D, b, x]);
      };
  }
  return f.filter = function(k) {
    return arguments.length ? (e = typeof k == "function" ? k : nc(!!k), f) : e;
  }, f.container = function(k) {
    return arguments.length ? (t = typeof k == "function" ? k : nc(k), f) : t;
  }, f.subject = function(k) {
    return arguments.length ? (n = typeof k == "function" ? k : nc(k), f) : n;
  }, f.touchable = function(k) {
    return arguments.length ? (r = typeof k == "function" ? k : nc(!!k), f) : r;
  }, f.on = function() {
    var k = a.on.apply(a, arguments);
    return k === a ? f : k;
  }, f.clickDistance = function(k) {
    return arguments.length ? (d = (k = +k) * k, f) : Math.sqrt(d);
  }, f;
}
function Po(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function Nl(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Qi() {
}
var Sa = 0.7, vo = 1 / Sa, co = "\\s*([+-]?\\d+)\\s*", Ks = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", Ur = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", IL = /^#([0-9a-f]{3})$/, NL = /^#([0-9a-f]{6})$/, OL = new RegExp("^rgb\\(" + [co, co, co] + "\\)$"), RL = new RegExp("^rgb\\(" + [Ur, Ur, Ur] + "\\)$"), DL = new RegExp("^rgba\\(" + [co, co, co, Ks] + "\\)$"), PL = new RegExp("^rgba\\(" + [Ur, Ur, Ur, Ks] + "\\)$"), LL = new RegExp("^hsl\\(" + [Ks, Ur, Ur] + "\\)$"), zL = new RegExp("^hsla\\(" + [Ks, Ur, Ur, Ks] + "\\)$"), Sy = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Po(Qi, ji, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});
function ji(e) {
  var t;
  return e = (e + "").trim().toLowerCase(), (t = IL.exec(e)) ? (t = parseInt(t[1], 16), new sn(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1)) : (t = NL.exec(e)) ? Cy(parseInt(t[1], 16)) : (t = OL.exec(e)) ? new sn(t[1], t[2], t[3], 1) : (t = RL.exec(e)) ? new sn(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = DL.exec(e)) ? Ey(t[1], t[2], t[3], t[4]) : (t = PL.exec(e)) ? Ey(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = LL.exec(e)) ? ky(t[1], t[2] / 100, t[3] / 100, 1) : (t = zL.exec(e)) ? ky(t[1], t[2] / 100, t[3] / 100, t[4]) : Sy.hasOwnProperty(e) ? Cy(Sy[e]) : e === "transparent" ? new sn(NaN, NaN, NaN, 0) : null;
}
function Cy(e) {
  return new sn(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ey(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new sn(e, t, n, r);
}
function Hm(e) {
  return e instanceof Qi || (e = ji(e)), e ? (e = e.rgb(), new sn(e.r, e.g, e.b, e.opacity)) : new sn();
}
function Zs(e, t, n, r) {
  return arguments.length === 1 ? Hm(e) : new sn(e, t, n, r ?? 1);
}
function sn(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Po(sn, Zs, Nl(Qi, {
  brighter: function(e) {
    return e = e == null ? vo : Math.pow(vo, e), new sn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Sa : Math.pow(Sa, e), new sn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
  },
  toString: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function ky(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Fr(e, t, n, r);
}
function BL(e) {
  if (e instanceof Fr) return new Fr(e.h, e.s, e.l, e.opacity);
  if (e instanceof Qi || (e = ji(e)), !e) return new Fr();
  if (e instanceof Fr) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, c = (a + i) / 2;
  return s ? (t === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - t) / s + 2 : o = (t - n) / s + 4, s /= c < 0.5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Fr(o, s, c, e.opacity);
}
function lu(e, t, n, r) {
  return arguments.length === 1 ? BL(e) : new Fr(e, t, n, r ?? 1);
}
function Fr(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Po(Fr, lu, Nl(Qi, {
  brighter: function(e) {
    return e = e == null ? vo : Math.pow(vo, e), new Fr(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Sa : Math.pow(Sa, e), new Fr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new sn(
      bd(e >= 240 ? e - 240 : e + 120, i, r),
      bd(e, i, r),
      bd(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  }
}));
function bd(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
var Jb = Math.PI / 180, Kb = 180 / Math.PI, cu = 18, Zb = 0.95047, ew = 1, tw = 1.08883, nw = 4 / 29, uo = 6 / 29, rw = 3 * uo * uo, FL = uo * uo * uo;
function Gm(e) {
  if (e instanceof di) return new di(e.l, e.a, e.b, e.opacity);
  if (e instanceof Li) {
    var t = e.h * Jb;
    return new di(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
  }
  e instanceof sn || (e = Hm(e));
  var n = Cd(e.r), r = Cd(e.g), i = Cd(e.b), a = wd((0.4124564 * n + 0.3575761 * r + 0.1804375 * i) / Zb), o = wd((0.2126729 * n + 0.7151522 * r + 0.072175 * i) / ew), s = wd((0.0193339 * n + 0.119192 * r + 0.9503041 * i) / tw);
  return new di(116 * o - 16, 500 * (a - o), 200 * (o - s), e.opacity);
}
function uu(e, t, n, r) {
  return arguments.length === 1 ? Gm(e) : new di(e, t, n, r ?? 1);
}
function di(e, t, n, r) {
  this.l = +e, this.a = +t, this.b = +n, this.opacity = +r;
}
Po(di, uu, Nl(Qi, {
  brighter: function(e) {
    return new di(this.l + cu * (e ?? 1), this.a, this.b, this.opacity);
  },
  darker: function(e) {
    return new di(this.l - cu * (e ?? 1), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var e = (this.l + 16) / 116, t = isNaN(this.a) ? e : e + this.a / 500, n = isNaN(this.b) ? e : e - this.b / 200;
    return e = ew * _d(e), t = Zb * _d(t), n = tw * _d(n), new sn(
      Sd(3.2404542 * t - 1.5371385 * e - 0.4985314 * n),
      // D65 -> sRGB
      Sd(-0.969266 * t + 1.8760108 * e + 0.041556 * n),
      Sd(0.0556434 * t - 0.2040259 * e + 1.0572252 * n),
      this.opacity
    );
  }
}));
function wd(e) {
  return e > FL ? Math.pow(e, 1 / 3) : e / rw + nw;
}
function _d(e) {
  return e > uo ? e * e * e : rw * (e - nw);
}
function Sd(e) {
  return 255 * (e <= 31308e-7 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055);
}
function Cd(e) {
  return (e /= 255) <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
}
function YL(e) {
  if (e instanceof Li) return new Li(e.h, e.c, e.l, e.opacity);
  e instanceof di || (e = Gm(e));
  var t = Math.atan2(e.b, e.a) * Kb;
  return new Li(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
}
function fu(e, t, n, r) {
  return arguments.length === 1 ? YL(e) : new Li(e, t, n, r ?? 1);
}
function Li(e, t, n, r) {
  this.h = +e, this.c = +t, this.l = +n, this.opacity = +r;
}
Po(Li, fu, Nl(Qi, {
  brighter: function(e) {
    return new Li(this.h, this.c, this.l + cu * (e ?? 1), this.opacity);
  },
  darker: function(e) {
    return new Li(this.h, this.c, this.l - cu * (e ?? 1), this.opacity);
  },
  rgb: function() {
    return Gm(this).rgb();
  }
}));
var iw = -0.14861, Vm = 1.78277, Qm = -0.29227, If = -0.90649, el = 1.97294, Ty = el * If, My = el * Vm, Iy = Vm * Qm - If * iw;
function jL(e) {
  if (e instanceof ya) return new ya(e.h, e.s, e.l, e.opacity);
  e instanceof sn || (e = Hm(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = (Iy * r + Ty * t - My * n) / (Iy + Ty - My), a = r - i, o = (el * (n - i) - Qm * a) / If, s = Math.sqrt(o * o + a * a) / (el * i * (1 - i)), c = s ? Math.atan2(o, a) * Kb - 120 : NaN;
  return new ya(c < 0 ? c + 360 : c, s, i, e.opacity);
}
function _r(e, t, n, r) {
  return arguments.length === 1 ? jL(e) : new ya(e, t, n, r ?? 1);
}
function ya(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Po(ya, _r, Nl(Qi, {
  brighter: function(e) {
    return e = e == null ? vo : Math.pow(vo, e), new ya(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Sa : Math.pow(Sa, e), new ya(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * Jb, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), i = Math.sin(e);
    return new sn(
      255 * (t + n * (iw * r + Vm * i)),
      255 * (t + n * (Qm * r + If * i)),
      255 * (t + n * (el * r)),
      this.opacity
    );
  }
}));
function aw(e, t, n, r, i) {
  var a = e * e, o = a * e;
  return ((1 - 3 * e + 3 * a - o) * t + (4 - 6 * a + 3 * o) * n + (1 + 3 * e + 3 * a - 3 * o) * r + o * i) / 6;
}
function ow(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), i = e[r], a = e[r + 1], o = r > 0 ? e[r - 1] : 2 * i - a, s = r < t - 1 ? e[r + 2] : 2 * a - i;
    return aw((n - r / t) * t, o, i, a, s);
  };
}
function sw(e) {
  var t = e.length;
  return function(n) {
    var r = Math.floor(((n %= 1) < 0 ? ++n : n) * t), i = e[(r + t - 1) % t], a = e[r % t], o = e[(r + 1) % t], s = e[(r + 2) % t];
    return aw((n - r / t) * t, i, a, o, s);
  };
}
function Nf(e) {
  return function() {
    return e;
  };
}
function lw(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function $L(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function qm(e, t) {
  var n = t - e;
  return n ? lw(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Nf(isNaN(e) ? t : e);
}
function WL(e) {
  return (e = +e) == 1 ? rn : function(t, n) {
    return n - t ? $L(t, n, e) : Nf(isNaN(t) ? n : t);
  };
}
function rn(e, t) {
  var n = t - e;
  return n ? lw(e, n) : Nf(isNaN(e) ? t : e);
}
const tl = function e(t) {
  var n = WL(t);
  function r(i, a) {
    var o = n((i = Zs(i)).r, (a = Zs(a)).r), s = n(i.g, a.g), c = n(i.b, a.b), l = rn(i.opacity, a.opacity);
    return function(u) {
      return i.r = o(u), i.g = s(u), i.b = c(u), i.opacity = l(u), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function cw(e) {
  return function(t) {
    var n = t.length, r = new Array(n), i = new Array(n), a = new Array(n), o, s;
    for (o = 0; o < n; ++o)
      s = Zs(t[o]), r[o] = s.r || 0, i[o] = s.g || 0, a[o] = s.b || 0;
    return r = e(r), i = e(i), a = e(a), s.opacity = 1, function(c) {
      return s.r = r(c), s.g = i(c), s.b = a(c), s + "";
    };
  };
}
var UL = cw(ow), HL = cw(sw);
function uw(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = Ol(e[o], t[o]);
  for (; o < n; ++o) a[o] = t[o];
  return function(s) {
    for (o = 0; o < r; ++o) a[o] = i[o](s);
    return a;
  };
}
function fw(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t -= e, function(r) {
    return n.setTime(e + t * r), n;
  };
}
function $n(e, t) {
  return e = +e, t -= e, function(n) {
    return e + t * n;
  };
}
function dw(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Ol(e[i], t[i]) : r[i] = t[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var Gh = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Ed = new RegExp(Gh.source, "g");
function GL(e) {
  return function() {
    return e;
  };
}
function VL(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Xm(e, t) {
  var n = Gh.lastIndex = Ed.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (r = Gh.exec(e)) && (i = Ed.exec(t)); )
    (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({ i: o, x: $n(r, i) })), n = Ed.lastIndex;
  return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? VL(c[0].x) : GL(t) : (t = c.length, function(l) {
    for (var u = 0, d; u < t; ++u) s[(d = c[u]).i] = d.x(l);
    return s.join("");
  });
}
function Ol(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Nf(t) : (n === "number" ? $n : n === "string" ? (r = ji(t)) ? (t = r, tl) : Xm : t instanceof ji ? tl : t instanceof Date ? fw : Array.isArray(t) ? uw : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? dw : $n)(e, t);
}
function hw(e, t) {
  return e = +e, t -= e, function(n) {
    return Math.round(e + t * n);
  };
}
var Ny = 180 / Math.PI, Vh = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function pw(e, t, n, r, i, a) {
  var o, s, c;
  return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (c = e * n + t * r) && (n -= e * c, r -= t * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), e * r < t * n && (e = -e, t = -t, c = -c, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(t, e) * Ny,
    skewX: Math.atan(c) * Ny,
    scaleX: o,
    scaleY: s
  };
}
var Zo, kd, Oy, rc;
function QL(e) {
  return e === "none" ? Vh : (Zo || (Zo = document.createElement("DIV"), kd = document.documentElement, Oy = document.defaultView), Zo.style.transform = e, e = Oy.getComputedStyle(kd.appendChild(Zo), null).getPropertyValue("transform"), kd.removeChild(Zo), e = e.slice(7, -1).split(","), pw(+e[0], +e[1], +e[2], +e[3], +e[4], +e[5]));
}
function qL(e) {
  return e == null || (rc || (rc = document.createElementNS("http://www.w3.org/2000/svg", "g")), rc.setAttribute("transform", e), !(e = rc.transform.baseVal.consolidate())) ? Vh : (e = e.matrix, pw(e.a, e.b, e.c, e.d, e.e, e.f));
}
function mw(e, t, n, r) {
  function i(l) {
    return l.length ? l.pop() + " " : "";
  }
  function a(l, u, d, f, h, m) {
    if (l !== d || u !== f) {
      var y = h.push("translate(", null, t, null, n);
      m.push({ i: y - 4, x: $n(l, d) }, { i: y - 2, x: $n(u, f) });
    } else (d || f) && h.push("translate(" + d + t + f + n);
  }
  function o(l, u, d, f) {
    l !== u ? (l - u > 180 ? u += 360 : u - l > 180 && (l += 360), f.push({ i: d.push(i(d) + "rotate(", null, r) - 2, x: $n(l, u) })) : u && d.push(i(d) + "rotate(" + u + r);
  }
  function s(l, u, d, f) {
    l !== u ? f.push({ i: d.push(i(d) + "skewX(", null, r) - 2, x: $n(l, u) }) : u && d.push(i(d) + "skewX(" + u + r);
  }
  function c(l, u, d, f, h, m) {
    if (l !== d || u !== f) {
      var y = h.push(i(h) + "scale(", null, ",", null, ")");
      m.push({ i: y - 4, x: $n(l, d) }, { i: y - 2, x: $n(u, f) });
    } else (d !== 1 || f !== 1) && h.push(i(h) + "scale(" + d + "," + f + ")");
  }
  return function(l, u) {
    var d = [], f = [];
    return l = e(l), u = e(u), a(l.translateX, l.translateY, u.translateX, u.translateY, d, f), o(l.rotate, u.rotate, d, f), s(l.skewX, u.skewX, d, f), c(l.scaleX, l.scaleY, u.scaleX, u.scaleY, d, f), l = u = null, function(h) {
      for (var m = -1, y = f.length, v; ++m < y; ) d[(v = f[m]).i] = v.x(h);
      return d.join("");
    };
  };
}
var gw = mw(QL, "px, ", "px)", "deg)"), yw = mw(qL, ", ", ")", ")"), es = Math.SQRT2, Td = 2, Ry = 4, XL = 1e-12;
function Dy(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function JL(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function KL(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
function Aw(e, t) {
  var n = e[0], r = e[1], i = e[2], a = t[0], o = t[1], s = t[2], c = a - n, l = o - r, u = c * c + l * l, d, f;
  if (u < XL)
    f = Math.log(s / i) / es, d = function(I) {
      return [
        n + I * c,
        r + I * l,
        i * Math.exp(es * I * f)
      ];
    };
  else {
    var h = Math.sqrt(u), m = (s * s - i * i + Ry * u) / (2 * i * Td * h), y = (s * s - i * i - Ry * u) / (2 * s * Td * h), v = Math.log(Math.sqrt(m * m + 1) - m), w = Math.log(Math.sqrt(y * y + 1) - y);
    f = (w - v) / es, d = function(I) {
      var M = I * f, k = Dy(v), g = i / (Td * h) * (k * KL(es * M + v) - JL(v));
      return [
        n + g * c,
        r + g * l,
        i * k / Dy(es * M + v)
      ];
    };
  }
  return d.duration = f * 1e3, d;
}
function vw(e) {
  return function(t, n) {
    var r = e((t = lu(t)).h, (n = lu(n)).h), i = rn(t.s, n.s), a = rn(t.l, n.l), o = rn(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.s = i(s), t.l = a(s), t.opacity = o(s), t + "";
    };
  };
}
const ZL = vw(qm);
var e4 = vw(rn);
function t4(e, t) {
  var n = rn((e = uu(e)).l, (t = uu(t)).l), r = rn(e.a, t.a), i = rn(e.b, t.b), a = rn(e.opacity, t.opacity);
  return function(o) {
    return e.l = n(o), e.a = r(o), e.b = i(o), e.opacity = a(o), e + "";
  };
}
function xw(e) {
  return function(t, n) {
    var r = e((t = fu(t)).h, (n = fu(n)).h), i = rn(t.c, n.c), a = rn(t.l, n.l), o = rn(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.c = i(s), t.l = a(s), t.opacity = o(s), t + "";
    };
  };
}
const n4 = xw(qm);
var r4 = xw(rn);
function bw(e) {
  return function t(n) {
    n = +n;
    function r(i, a) {
      var o = e((i = _r(i)).h, (a = _r(a)).h), s = rn(i.s, a.s), c = rn(i.l, a.l), l = rn(i.opacity, a.opacity);
      return function(u) {
        return i.h = o(u), i.s = s(u), i.l = c(Math.pow(u, n)), i.opacity = l(u), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
const i4 = bw(qm);
var Of = bw(rn);
function a4(e, t) {
  for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e(r / (t - 1));
  return n;
}
var xo = 0, hs = 0, ts = 0, ww = 1e3, du, ps, hu = 0, Ca = 0, Rf = 0, nl = typeof performance == "object" && performance.now ? performance : Date, _w = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function Lo() {
  return Ca || (_w(o4), Ca = nl.now() + Rf);
}
function o4() {
  Ca = 0;
}
function rl() {
  this._call = this._time = this._next = null;
}
rl.prototype = Df.prototype = {
  constructor: rl,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? Lo() : +n) + (t == null ? 0 : +t), !this._next && ps !== this && (ps ? ps._next = this : du = this, ps = this), this._call = e, this._time = n, Qh();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Qh());
  }
};
function Df(e, t, n) {
  var r = new rl();
  return r.restart(e, t, n), r;
}
function Sw() {
  Lo(), ++xo;
  for (var e = du, t; e; )
    (t = Ca - e._time) >= 0 && e._call.call(null, t), e = e._next;
  --xo;
}
function Py() {
  Ca = (hu = nl.now()) + Rf, xo = hs = 0;
  try {
    Sw();
  } finally {
    xo = 0, l4(), Ca = 0;
  }
}
function s4() {
  var e = nl.now(), t = e - hu;
  t > ww && (Rf -= t, hu = e);
}
function l4() {
  for (var e, t = du, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : du = n);
  ps = e, Qh(r);
}
function Qh(e) {
  if (!xo) {
    hs && (hs = clearTimeout(hs));
    var t = e - Ca;
    t > 24 ? (e < 1 / 0 && (hs = setTimeout(Py, e - nl.now() - Rf)), ts && (ts = clearInterval(ts))) : (ts || (hu = nl.now(), ts = setInterval(s4, ww)), xo = 1, _w(Py));
  }
}
function qh(e, t, n) {
  var r = new rl();
  return t = t == null ? 0 : +t, r.restart(function(i) {
    r.stop(), e(i + t);
  }, t, n), r;
}
function c4(e, t, n) {
  var r = new rl(), i = t;
  return t == null ? (r.restart(e, t, n), r) : (t = +t, n = n == null ? Lo() : +n, r.restart(function a(o) {
    o += i, r.restart(a, i += t, n), e(o);
  }, t, n), r);
}
var u4 = Vi("start", "end", "interrupt"), f4 = [], Cw = 0, Xh = 1, pu = 2, Md = 3, Ly = 4, Jh = 5, Bc = 6;
function Pf(e, t, n, r, i, a) {
  var o = e.__transition;
  if (!o) e.__transition = {};
  else if (n in o) return;
  d4(e, n, {
    name: t,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: u4,
    tween: f4,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: Cw
  });
}
function Jm(e, t) {
  var n = Er(e, t);
  if (n.state > Cw) throw new Error("too late; already scheduled");
  return n;
}
function Ra(e, t) {
  var n = Er(e, t);
  if (n.state > pu) throw new Error("too late; already started");
  return n;
}
function Er(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function d4(e, t, n) {
  var r = e.__transition, i;
  r[t] = n, n.timer = Df(a, 0, n.time);
  function a(l) {
    n.state = Xh, n.timer.restart(o, n.delay, n.time), n.delay <= l && o(l - n.delay);
  }
  function o(l) {
    var u, d, f, h;
    if (n.state !== Xh) return c();
    for (u in r)
      if (h = r[u], h.name === n.name) {
        if (h.state === Md) return qh(o);
        h.state === Ly ? (h.state = Bc, h.timer.stop(), h.on.call("interrupt", e, e.__data__, h.index, h.group), delete r[u]) : +u < t && (h.state = Bc, h.timer.stop(), delete r[u]);
      }
    if (qh(function() {
      n.state === Md && (n.state = Ly, n.timer.restart(s, n.delay, n.time), s(l));
    }), n.state = pu, n.on.call("start", e, e.__data__, n.index, n.group), n.state === pu) {
      for (n.state = Md, i = new Array(f = n.tween.length), u = 0, d = -1; u < f; ++u)
        (h = n.tween[u].value.call(e, e.__data__, n.index, n.group)) && (i[++d] = h);
      i.length = d + 1;
    }
  }
  function s(l) {
    for (var u = l < n.duration ? n.ease.call(null, l / n.duration) : (n.timer.restart(c), n.state = Jh, 1), d = -1, f = i.length; ++d < f; )
      i[d].call(null, u);
    n.state === Jh && (n.on.call("end", e, e.__data__, n.index, n.group), c());
  }
  function c() {
    n.state = Bc, n.timer.stop(), delete r[t];
    for (var l in r) return;
    delete e.__transition;
  }
}
function Aa(e, t) {
  var n = e.__transition, r, i, a = !0, o;
  if (n) {
    t = t == null ? null : t + "";
    for (o in n) {
      if ((r = n[o]).name !== t) {
        a = !1;
        continue;
      }
      i = r.state > pu && r.state < Jh, r.state = Bc, r.timer.stop(), i && r.on.call("interrupt", e, e.__data__, r.index, r.group), delete n[o];
    }
    a && delete e.__transition;
  }
}
function h4(e) {
  return this.each(function() {
    Aa(this, e);
  });
}
function p4(e, t) {
  var n, r;
  return function() {
    var i = Ra(this, e), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, s = r.length; o < s; ++o)
        if (r[o].name === t) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function m4(e, t, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var a = Ra(this, e), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var s = { name: t, value: n }, c = 0, l = i.length; c < l; ++c)
        if (i[c].name === t) {
          i[c] = s;
          break;
        }
      c === l && i.push(s);
    }
    a.tween = i;
  };
}
function g4(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var r = Er(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === e)
        return o.value;
    return null;
  }
  return this.each((t == null ? p4 : m4)(n, e, t));
}
function Km(e, t, n) {
  var r = e._id;
  return e.each(function() {
    var i = Ra(this, r);
    (i.value || (i.value = {}))[t] = n.apply(this, arguments);
  }), function(i) {
    return Er(i, r).value[t];
  };
}
function Ew(e, t) {
  var n;
  return (typeof t == "number" ? $n : t instanceof ji ? tl : (n = ji(t)) ? (t = n, tl) : Xm)(e, t);
}
function y4(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function A4(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function v4(e, t, n) {
  var r, i;
  return function() {
    var a = this.getAttribute(e);
    return a === n ? null : a === r ? i : i = t(r = a, n);
  };
}
function x4(e, t, n) {
  var r, i;
  return function() {
    var a = this.getAttributeNS(e.space, e.local);
    return a === n ? null : a === r ? i : i = t(r = a, n);
  };
}
function b4(e, t, n) {
  var r, i, a;
  return function() {
    var o, s = n(this);
    return s == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), o === s ? null : o === r && s === i ? a : a = t(r = o, i = s));
  };
}
function w4(e, t, n) {
  var r, i, a;
  return function() {
    var o, s = n(this);
    return s == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), o === s ? null : o === r && s === i ? a : a = t(r = o, i = s));
  };
}
function _4(e, t) {
  var n = Il(e), r = n === "transform" ? yw : Ew;
  return this.attrTween(e, typeof t == "function" ? (n.local ? w4 : b4)(n, r, Km(this, "attr." + e, t)) : t == null ? (n.local ? A4 : y4)(n) : (n.local ? x4 : v4)(n, r, t + ""));
}
function S4(e, t) {
  function n() {
    var r = this, i = t.apply(r, arguments);
    return i && function(a) {
      r.setAttributeNS(e.space, e.local, i(a));
    };
  }
  return n._value = t, n;
}
function C4(e, t) {
  function n() {
    var r = this, i = t.apply(r, arguments);
    return i && function(a) {
      r.setAttribute(e, i(a));
    };
  }
  return n._value = t, n;
}
function E4(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var r = Il(e);
  return this.tween(n, (r.local ? S4 : C4)(r, t));
}
function k4(e, t) {
  return function() {
    Jm(this, e).delay = +t.apply(this, arguments);
  };
}
function T4(e, t) {
  return t = +t, function() {
    Jm(this, e).delay = t;
  };
}
function M4(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? k4 : T4)(t, e)) : Er(this.node(), t).delay;
}
function I4(e, t) {
  return function() {
    Ra(this, e).duration = +t.apply(this, arguments);
  };
}
function N4(e, t) {
  return t = +t, function() {
    Ra(this, e).duration = t;
  };
}
function O4(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? I4 : N4)(t, e)) : Er(this.node(), t).duration;
}
function R4(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Ra(this, e).ease = t;
  };
}
function D4(e) {
  var t = this._id;
  return arguments.length ? this.each(R4(t, e)) : Er(this.node(), t).ease;
}
function P4(e) {
  typeof e != "function" && (e = Ym(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l)
      (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
  return new Gr(r, this._parents, this._name, this._id);
}
function L4(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var c = t[s], l = n[s], u = c.length, d = o[s] = new Array(u), f, h = 0; h < u; ++h)
      (f = c[h] || l[h]) && (d[h] = f);
  for (; s < r; ++s)
    o[s] = t[s];
  return new Gr(o, this._parents, this._name, this._id);
}
function z4(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function B4(e, t, n) {
  var r, i, a = z4(t) ? Jm : Ra;
  return function() {
    var o = a(this, e), s = o.on;
    s !== r && (i = (r = s).copy()).on(t, n), o.on = i;
  };
}
function F4(e, t) {
  var n = this._id;
  return arguments.length < 2 ? Er(this.node(), n).on.on(e) : this.each(B4(n, e, t));
}
function Y4(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function j4() {
  return this.on("end.remove", Y4(this._id));
}
function $4(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Ef(e));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var s = r[o], c = s.length, l = a[o] = new Array(c), u, d, f = 0; f < c; ++f)
      (u = s[f]) && (d = e.call(u, u.__data__, f, s)) && ("__data__" in u && (d.__data__ = u.__data__), l[f] = d, Pf(l[f], t, n, f, l, Er(u, n)));
  return new Gr(a, this._parents, t, n);
}
function W4(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Fm(e));
  for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s)
    for (var c = r[s], l = c.length, u, d = 0; d < l; ++d)
      if (u = c[d]) {
        for (var f = e.call(u, u.__data__, d, c), h, m = Er(u, n), y = 0, v = f.length; y < v; ++y)
          (h = f[y]) && Pf(h, t, n, y, f, m);
        a.push(f), o.push(u);
      }
  return new Gr(a, o, t, n);
}
var U4 = Oa.prototype.constructor;
function H4() {
  return new U4(this._groups, this._parents);
}
function G4(e, t) {
  var n, r, i;
  return function() {
    var a = _a(this, e), o = (this.style.removeProperty(e), _a(this, e));
    return a === o ? null : a === n && o === r ? i : i = t(n = a, r = o);
  };
}
function V4(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Q4(e, t, n) {
  var r, i;
  return function() {
    var a = _a(this, e);
    return a === n ? null : a === r ? i : i = t(r = a, n);
  };
}
function q4(e, t, n) {
  var r, i, a;
  return function() {
    var o = _a(this, e), s = n(this);
    return s == null && (s = (this.style.removeProperty(e), _a(this, e))), o === s ? null : o === r && s === i ? a : a = t(r = o, i = s);
  };
}
function X4(e, t, n) {
  var r = (e += "") == "transform" ? gw : Ew;
  return t == null ? this.styleTween(e, G4(e, r)).on("end.style." + e, V4(e)) : this.styleTween(e, typeof t == "function" ? q4(e, r, Km(this, "style." + e, t)) : Q4(e, r, t + ""), n);
}
function J4(e, t, n) {
  function r() {
    var i = this, a = t.apply(i, arguments);
    return a && function(o) {
      i.style.setProperty(e, a(o), n);
    };
  }
  return r._value = t, r;
}
function K4(e, t, n) {
  var r = "style." + (e += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, J4(e, t, n ?? ""));
}
function Z4(e) {
  return function() {
    this.textContent = e;
  };
}
function e5(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function t5(e) {
  return this.tween("text", typeof e == "function" ? e5(Km(this, "text", e)) : Z4(e == null ? "" : e + ""));
}
function n5() {
  for (var e = this._name, t = this._id, n = Tw(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, c, l = 0; l < s; ++l)
      if (c = o[l]) {
        var u = Er(c, t);
        Pf(c, e, n, l, o, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new Gr(r, this._parents, e, n);
}
var r5 = 0;
function Gr(e, t, n, r) {
  this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function kw(e) {
  return Oa().transition(e);
}
function Tw() {
  return ++r5;
}
var ja = Oa.prototype;
Gr.prototype = kw.prototype = {
  constructor: Gr,
  select: $4,
  selectAll: W4,
  filter: P4,
  merge: L4,
  selection: H4,
  transition: n5,
  call: ja.call,
  nodes: ja.nodes,
  node: ja.node,
  size: ja.size,
  empty: ja.empty,
  each: ja.each,
  on: F4,
  attr: _4,
  attrTween: E4,
  style: X4,
  styleTween: K4,
  text: t5,
  remove: j4,
  tween: g4,
  delay: M4,
  duration: O4,
  ease: D4
};
function i5(e) {
  return +e;
}
function a5(e) {
  return e * e;
}
function o5(e) {
  return e * (2 - e);
}
function zy(e) {
  return ((e *= 2) <= 1 ? e * e : --e * (2 - e) + 1) / 2;
}
function s5(e) {
  return e * e * e;
}
function l5(e) {
  return --e * e * e + 1;
}
function Kh(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var Zm = 3, c5 = function e(t) {
  t = +t;
  function n(r) {
    return Math.pow(r, t);
  }
  return n.exponent = e, n;
}(Zm), u5 = function e(t) {
  t = +t;
  function n(r) {
    return 1 - Math.pow(1 - r, t);
  }
  return n.exponent = e, n;
}(Zm), By = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, t) : 2 - Math.pow(2 - r, t)) / 2;
  }
  return n.exponent = e, n;
}(Zm), Mw = Math.PI, Iw = Mw / 2;
function f5(e) {
  return 1 - Math.cos(e * Iw);
}
function d5(e) {
  return Math.sin(e * Iw);
}
function Fy(e) {
  return (1 - Math.cos(Mw * e)) / 2;
}
function h5(e) {
  return Math.pow(2, 10 * e - 10);
}
function p5(e) {
  return 1 - Math.pow(2, -10 * e);
}
function Yy(e) {
  return ((e *= 2) <= 1 ? Math.pow(2, 10 * e - 10) : 2 - Math.pow(2, 10 - 10 * e)) / 2;
}
function m5(e) {
  return 1 - Math.sqrt(1 - e * e);
}
function g5(e) {
  return Math.sqrt(1 - --e * e);
}
function jy(e) {
  return ((e *= 2) <= 1 ? 1 - Math.sqrt(1 - e * e) : Math.sqrt(1 - (e -= 2) * e) + 1) / 2;
}
var Zh = 4 / 11, y5 = 6 / 11, A5 = 8 / 11, v5 = 3 / 4, x5 = 9 / 11, b5 = 10 / 11, w5 = 15 / 16, _5 = 21 / 22, S5 = 63 / 64, ic = 1 / Zh / Zh;
function C5(e) {
  return 1 - il(1 - e);
}
function il(e) {
  return (e = +e) < Zh ? ic * e * e : e < A5 ? ic * (e -= y5) * e + v5 : e < b5 ? ic * (e -= x5) * e + w5 : ic * (e -= _5) * e + S5;
}
function E5(e) {
  return ((e *= 2) <= 1 ? 1 - il(1 - e) : il(e - 1) + 1) / 2;
}
var eg = 1.70158, k5 = function e(t) {
  t = +t;
  function n(r) {
    return r * r * ((t + 1) * r - t);
  }
  return n.overshoot = e, n;
}(eg), T5 = function e(t) {
  t = +t;
  function n(r) {
    return --r * r * ((t + 1) * r + t) + 1;
  }
  return n.overshoot = e, n;
}(eg), $y = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) < 1 ? r * r * ((t + 1) * r - t) : (r -= 2) * r * ((t + 1) * r + t) + 2) / 2;
  }
  return n.overshoot = e, n;
}(eg), bo = 2 * Math.PI, tg = 1, ng = 0.3, M5 = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= bo);
  function i(a) {
    return t * Math.pow(2, 10 * --a) * Math.sin((r - a) / n);
  }
  return i.amplitude = function(a) {
    return e(a, n * bo);
  }, i.period = function(a) {
    return e(t, a);
  }, i;
}(tg, ng), Wy = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= bo);
  function i(a) {
    return 1 - t * Math.pow(2, -10 * (a = +a)) * Math.sin((a + r) / n);
  }
  return i.amplitude = function(a) {
    return e(a, n * bo);
  }, i.period = function(a) {
    return e(t, a);
  }, i;
}(tg, ng), I5 = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= bo);
  function i(a) {
    return ((a = a * 2 - 1) < 0 ? t * Math.pow(2, 10 * a) * Math.sin((r - a) / n) : 2 - t * Math.pow(2, -10 * a) * Math.sin((r + a) / n)) / 2;
  }
  return i.amplitude = function(a) {
    return e(a, n * bo);
  }, i.period = function(a) {
    return e(t, a);
  }, i;
}(tg, ng), ep = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Kh
};
function N5(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      return ep.time = Lo(), ep;
  return n;
}
function O5(e) {
  var t, n;
  e instanceof Gr ? (t = e._id, e = e._name) : (t = Tw(), (n = ep).time = Lo(), e = e == null ? null : e + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, c, l = 0; l < s; ++l)
      (c = o[l]) && Pf(c, e, t, l, o, n || N5(c, t));
  return new Gr(r, this._parents, e, t);
}
Oa.prototype.interrupt = h4;
Oa.prototype.transition = O5;
var R5 = [null];
function D5(e, t) {
  var n = e.__transition, r, i;
  if (n) {
    t = t == null ? null : t + "";
    for (i in n)
      if ((r = n[i]).state > Xh && r.name === t)
        return new Gr([[e]], R5, t, +i);
  }
  return null;
}
function Uy(e) {
  return function() {
    return e;
  };
}
function P5(e, t, n) {
  this.target = e, this.type = t, this.selection = n;
}
function Hy() {
  Ne.stopImmediatePropagation();
}
function ac() {
  Ne.preventDefault(), Ne.stopImmediatePropagation();
}
var Gy = {}, Id = { name: "space" }, $a = { name: "handle" }, Wa = { name: "center" }, Fc = {
  name: "x",
  handles: ["e", "w"].map(al),
  input: function(e, t) {
    return e && [[e[0], t[0][1]], [e[1], t[1][1]]];
  },
  output: function(e) {
    return e && [e[0][0], e[1][0]];
  }
}, Yc = {
  name: "y",
  handles: ["n", "s"].map(al),
  input: function(e, t) {
    return e && [[t[0][0], e[0]], [t[1][0], e[1]]];
  },
  output: function(e) {
    return e && [e[0][1], e[1][1]];
  }
}, L5 = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(al),
  input: function(e) {
    return e;
  },
  output: function(e) {
    return e;
  }
}, ni = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, Vy = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, Qy = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, z5 = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, B5 = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function al(e) {
  return { type: e };
}
function F5() {
  return !Ne.button;
}
function Y5() {
  var e = this.ownerSVGElement || this;
  return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
}
function Nd(e) {
  for (; !e.__brush; ) if (!(e = e.parentNode)) return;
  return e.__brush;
}
function Od(e) {
  return e[0][0] === e[1][0] || e[0][1] === e[1][1];
}
function j5(e) {
  var t = e.__brush;
  return t ? t.dim.output(t.selection) : null;
}
function $5() {
  return rg(Fc);
}
function W5() {
  return rg(Yc);
}
function U5() {
  return rg(L5);
}
function rg(e) {
  var t = Y5, n = F5, r = Vi(o, "start", "brush", "end"), i = 6, a;
  function o(f) {
    var h = f.property("__brush", d).selectAll(".overlay").data([al("overlay")]);
    h.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", ni.overlay).merge(h).each(function() {
      var y = Nd(this).extent;
      Ut(this).attr("x", y[0][0]).attr("y", y[0][1]).attr("width", y[1][0] - y[0][0]).attr("height", y[1][1] - y[0][1]);
    }), f.selectAll(".selection").data([al("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", ni.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var m = f.selectAll(".handle").data(e.handles, function(y) {
      return y.type;
    });
    m.exit().remove(), m.enter().append("rect").attr("class", function(y) {
      return "handle handle--" + y.type;
    }).attr("cursor", function(y) {
      return ni[y.type];
    }), f.each(s).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", u);
  }
  o.move = function(f, h) {
    f.selection ? f.on("start.brush", function() {
      c(this, arguments).beforestart().start();
    }).on("interrupt.brush end.brush", function() {
      c(this, arguments).end();
    }).tween("brush", function() {
      var m = this, y = m.__brush, v = c(m, arguments), w = y.selection, I = e.input(typeof h == "function" ? h.apply(this, arguments) : h, y.extent), M = Ol(w, I);
      function k(g) {
        y.selection = g === 1 && Od(I) ? null : M(g), s.call(m), v.brush();
      }
      return w && I ? k : k(1);
    }) : f.each(function() {
      var m = this, y = arguments, v = m.__brush, w = e.input(typeof h == "function" ? h.apply(m, y) : h, v.extent), I = c(m, y).beforestart();
      Aa(m), v.selection = w == null || Od(w) ? null : w, s.call(m), I.start().brush().end();
    });
  };
  function s() {
    var f = Ut(this), h = Nd(this).selection;
    h ? (f.selectAll(".selection").style("display", null).attr("x", h[0][0]).attr("y", h[0][1]).attr("width", h[1][0] - h[0][0]).attr("height", h[1][1] - h[0][1]), f.selectAll(".handle").style("display", null).attr("x", function(m) {
      return m.type[m.type.length - 1] === "e" ? h[1][0] - i / 2 : h[0][0] - i / 2;
    }).attr("y", function(m) {
      return m.type[0] === "s" ? h[1][1] - i / 2 : h[0][1] - i / 2;
    }).attr("width", function(m) {
      return m.type === "n" || m.type === "s" ? h[1][0] - h[0][0] + i : i;
    }).attr("height", function(m) {
      return m.type === "e" || m.type === "w" ? h[1][1] - h[0][1] + i : i;
    })) : f.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function c(f, h) {
    return f.__brush.emitter || new l(f, h);
  }
  function l(f, h) {
    this.that = f, this.args = h, this.state = f.__brush, this.active = 0;
  }
  l.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function() {
      return this.starting && (this.starting = !1, this.emit("start")), this;
    },
    brush: function() {
      return this.emit("brush"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end")), this;
    },
    emit: function(f) {
      Js(new P5(o, f, e.output(this.state.selection)), r.apply, r, [f, this.that, this.args]);
    }
  };
  function u() {
    if (Ne.touches) {
      if (Ne.changedTouches.length < Ne.touches.length) return ac();
    } else if (a) return;
    if (!n.apply(this, arguments)) return;
    var f = this, h = Ne.target.__data__.type, m = (Ne.metaKey ? h = "overlay" : h) === "selection" ? Gy : Ne.altKey ? Wa : $a, y = e === Yc ? null : z5[h], v = e === Fc ? null : B5[h], w = Nd(f), I = w.extent, M = w.selection, k = I[0][0], g, A, b = I[0][1], x, _, R = I[1][0], P, E, C = I[1][1], T, D, z, B, W, L = y && v && Ne.shiftKey, S, $, j = Oi(f), N = j, q = c(f, arguments).beforestart();
    h === "overlay" ? w.selection = M = [
      [g = e === Yc ? k : j[0], x = e === Fc ? b : j[1]],
      [P = e === Yc ? R : g, T = e === Fc ? C : x]
    ] : (g = M[0][0], x = M[0][1], P = M[1][0], T = M[1][1]), A = g, _ = x, E = P, D = T;
    var G = Ut(f).attr("pointer-events", "none"), X = G.selectAll(".overlay").attr("cursor", ni[h]);
    if (Ne.touches)
      G.on("touchmove.brush", Q, !0).on("touchend.brush touchcancel.brush", U, !0);
    else {
      var Y = Ut(Ne.view).on("keydown.brush", Z, !0).on("keyup.brush", H, !0).on("mousemove.brush", Q, !0).on("mouseup.brush", U, !0);
      Tf(Ne.view);
    }
    Hy(), Aa(f), s.call(f), q.start();
    function Q() {
      var ee = Oi(f);
      L && !S && !$ && (Math.abs(ee[0] - N[0]) > Math.abs(ee[1] - N[1]) ? $ = !0 : S = !0), N = ee, W = !0, ac(), V();
    }
    function V() {
      var ee;
      switch (z = N[0] - j[0], B = N[1] - j[1], m) {
        case Id:
        case Gy: {
          y && (z = Math.max(k - g, Math.min(R - P, z)), A = g + z, E = P + z), v && (B = Math.max(b - x, Math.min(C - T, B)), _ = x + B, D = T + B);
          break;
        }
        case $a: {
          y < 0 ? (z = Math.max(k - g, Math.min(R - g, z)), A = g + z, E = P) : y > 0 && (z = Math.max(k - P, Math.min(R - P, z)), A = g, E = P + z), v < 0 ? (B = Math.max(b - x, Math.min(C - x, B)), _ = x + B, D = T) : v > 0 && (B = Math.max(b - T, Math.min(C - T, B)), _ = x, D = T + B);
          break;
        }
        case Wa: {
          y && (A = Math.max(k, Math.min(R, g - z * y)), E = Math.max(k, Math.min(R, P + z * y))), v && (_ = Math.max(b, Math.min(C, x - B * v)), D = Math.max(b, Math.min(C, T + B * v)));
          break;
        }
      }
      E < A && (y *= -1, ee = g, g = P, P = ee, ee = A, A = E, E = ee, h in Vy && X.attr("cursor", ni[h = Vy[h]])), D < _ && (v *= -1, ee = x, x = T, T = ee, ee = _, _ = D, D = ee, h in Qy && X.attr("cursor", ni[h = Qy[h]])), w.selection && (M = w.selection), S && (A = M[0][0], E = M[1][0]), $ && (_ = M[0][1], D = M[1][1]), (M[0][0] !== A || M[0][1] !== _ || M[1][0] !== E || M[1][1] !== D) && (w.selection = [[A, _], [E, D]], s.call(f), q.brush());
    }
    function U() {
      if (Hy(), Ne.touches) {
        if (Ne.touches.length) return;
        a && clearTimeout(a), a = setTimeout(function() {
          a = null;
        }, 500), G.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else
        Mf(Ne.view, W), Y.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      G.attr("pointer-events", "all"), X.attr("cursor", ni.overlay), w.selection && (M = w.selection), Od(M) && (w.selection = null, s.call(f)), q.end();
    }
    function Z() {
      switch (Ne.keyCode) {
        case 16: {
          L = y && v;
          break;
        }
        case 18: {
          m === $a && (y && (P = E - z * y, g = A + z * y), v && (T = D - B * v, x = _ + B * v), m = Wa, V());
          break;
        }
        case 32: {
          (m === $a || m === Wa) && (y < 0 ? P = E - z : y > 0 && (g = A - z), v < 0 ? T = D - B : v > 0 && (x = _ - B), m = Id, X.attr("cursor", ni.selection), V());
          break;
        }
        default:
          return;
      }
      ac();
    }
    function H() {
      switch (Ne.keyCode) {
        case 16: {
          L && (S = $ = L = !1, V());
          break;
        }
        case 18: {
          m === Wa && (y < 0 ? P = E : y > 0 && (g = A), v < 0 ? T = D : v > 0 && (x = _), m = $a, V());
          break;
        }
        case 32: {
          m === Id && (Ne.altKey ? (y && (P = E - z * y, g = A + z * y), v && (T = D - B * v, x = _ + B * v), m = Wa) : (y < 0 ? P = E : y > 0 && (g = A), v < 0 ? T = D : v > 0 && (x = _), m = $a), X.attr("cursor", ni[h]), V());
          break;
        }
        default:
          return;
      }
      ac();
    }
  }
  function d() {
    var f = this.__brush || { selection: null };
    return f.extent = t.apply(this, arguments), f.dim = e, f;
  }
  return o.extent = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Uy([[+f[0][0], +f[0][1]], [+f[1][0], +f[1][1]]]), o) : t;
  }, o.filter = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : Uy(!!f), o) : n;
  }, o.handleSize = function(f) {
    return arguments.length ? (i = +f, o) : i;
  }, o.on = function() {
    var f = r.on.apply(r, arguments);
    return f === r ? o : f;
  }, o;
}
var qy = Math.cos, Xy = Math.sin, Nw = Math.PI, oc = Nw / 2, Jy = Nw * 2, Ky = Math.max;
function H5(e) {
  return function(t, n) {
    return e(
      t.source.value + t.target.value,
      n.source.value + n.target.value
    );
  };
}
function G5() {
  var e = 0, t = null, n = null, r = null;
  function i(a) {
    var o = a.length, s = [], c = yr(o), l = [], u = [], d = u.groups = new Array(o), f = new Array(o * o), h, m, y, v, w, I;
    for (h = 0, w = -1; ++w < o; ) {
      for (m = 0, I = -1; ++I < o; )
        m += a[w][I];
      s.push(m), l.push(yr(o)), h += m;
    }
    for (t && c.sort(function(R, P) {
      return t(s[R], s[P]);
    }), n && l.forEach(function(R, P) {
      R.sort(function(E, C) {
        return n(a[P][E], a[P][C]);
      });
    }), h = Ky(0, Jy - e * o) / h, v = h ? e : Jy / o, m = 0, w = -1; ++w < o; ) {
      for (y = m, I = -1; ++I < o; ) {
        var M = c[w], k = l[M][I], g = a[M][k], A = m, b = m += g * h;
        f[k * o + M] = {
          index: M,
          subindex: k,
          startAngle: A,
          endAngle: b,
          value: g
        };
      }
      d[M] = {
        index: M,
        startAngle: y,
        endAngle: m,
        value: s[M]
      }, m += v;
    }
    for (w = -1; ++w < o; )
      for (I = w - 1; ++I < o; ) {
        var x = f[I * o + w], _ = f[w * o + I];
        (x.value || _.value) && u.push(x.value < _.value ? { source: _, target: x } : { source: x, target: _ });
      }
    return r ? u.sort(r) : u;
  }
  return i.padAngle = function(a) {
    return arguments.length ? (e = Ky(0, a), i) : e;
  }, i.sortGroups = function(a) {
    return arguments.length ? (t = a, i) : t;
  }, i.sortSubgroups = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.sortChords = function(a) {
    return arguments.length ? (a == null ? r = null : (r = H5(a))._ = a, i) : r && r._;
  }, i;
}
var V5 = Array.prototype.slice;
function Rd(e) {
  return function() {
    return e;
  };
}
var tp = Math.PI, np = 2 * tp, la = 1e-6, Q5 = np - la;
function rp() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function qi() {
  return new rp();
}
rp.prototype = qi.prototype = {
  constructor: rp,
  moveTo: function(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function(e, t, n, r) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(e, t, n, r, i, a) {
    this._ += "C" + +e + "," + +t + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
  },
  arcTo: function(e, t, n, r, i) {
    e = +e, t = +t, n = +n, r = +r, i = +i;
    var a = this._x1, o = this._y1, s = n - e, c = r - t, l = a - e, u = o - t, d = l * l + u * u;
    if (i < 0) throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);
    else if (d > la) if (!(Math.abs(u * s - c * l) > la) || !i)
      this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
    else {
      var f = n - a, h = r - o, m = s * s + c * c, y = f * f + h * h, v = Math.sqrt(m), w = Math.sqrt(d), I = i * Math.tan((tp - Math.acos((m + d - y) / (2 * v * w))) / 2), M = I / w, k = I / v;
      Math.abs(M - 1) > la && (this._ += "L" + (e + M * l) + "," + (t + M * u)), this._ += "A" + i + "," + i + ",0,0," + +(u * f > l * h) + "," + (this._x1 = e + k * s) + "," + (this._y1 = t + k * c);
    }
  },
  arc: function(e, t, n, r, i, a) {
    e = +e, t = +t, n = +n;
    var o = n * Math.cos(r), s = n * Math.sin(r), c = e + o, l = t + s, u = 1 ^ a, d = a ? r - i : i - r;
    if (n < 0) throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + c + "," + l : (Math.abs(this._x1 - c) > la || Math.abs(this._y1 - l) > la) && (this._ += "L" + c + "," + l), n && (d < 0 && (d = d % np + np), d > Q5 ? this._ += "A" + n + "," + n + ",0,1," + u + "," + (e - o) + "," + (t - s) + "A" + n + "," + n + ",0,1," + u + "," + (this._x1 = c) + "," + (this._y1 = l) : d > la && (this._ += "A" + n + "," + n + ",0," + +(d >= tp) + "," + u + "," + (this._x1 = e + n * Math.cos(i)) + "," + (this._y1 = t + n * Math.sin(i))));
  },
  rect: function(e, t, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function q5(e) {
  return e.source;
}
function X5(e) {
  return e.target;
}
function J5(e) {
  return e.radius;
}
function K5(e) {
  return e.startAngle;
}
function Z5(e) {
  return e.endAngle;
}
function e3() {
  var e = q5, t = X5, n = J5, r = K5, i = Z5, a = null;
  function o() {
    var s, c = V5.call(arguments), l = e.apply(this, c), u = t.apply(this, c), d = +n.apply(this, (c[0] = l, c)), f = r.apply(this, c) - oc, h = i.apply(this, c) - oc, m = d * qy(f), y = d * Xy(f), v = +n.apply(this, (c[0] = u, c)), w = r.apply(this, c) - oc, I = i.apply(this, c) - oc;
    if (a || (a = s = qi()), a.moveTo(m, y), a.arc(0, 0, d, f, h), (f !== w || h !== I) && (a.quadraticCurveTo(0, 0, v * qy(w), v * Xy(w)), a.arc(0, 0, v, w, I)), a.quadraticCurveTo(0, 0, m, y), a.closePath(), s) return a = null, s + "" || null;
  }
  return o.radius = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Rd(+s), o) : n;
  }, o.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Rd(+s), o) : r;
  }, o.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : Rd(+s), o) : i;
  }, o.source = function(s) {
    return arguments.length ? (e = s, o) : e;
  }, o.target = function(s) {
    return arguments.length ? (t = s, o) : t;
  }, o.context = function(s) {
    return arguments.length ? (a = s ?? null, o) : a;
  }, o;
}
var er = "$";
function mu() {
}
mu.prototype = Vr.prototype = {
  constructor: mu,
  has: function(e) {
    return er + e in this;
  },
  get: function(e) {
    return this[er + e];
  },
  set: function(e, t) {
    return this[er + e] = t, this;
  },
  remove: function(e) {
    var t = er + e;
    return t in this && delete this[t];
  },
  clear: function() {
    for (var e in this) e[0] === er && delete this[e];
  },
  keys: function() {
    var e = [];
    for (var t in this) t[0] === er && e.push(t.slice(1));
    return e;
  },
  values: function() {
    var e = [];
    for (var t in this) t[0] === er && e.push(this[t]);
    return e;
  },
  entries: function() {
    var e = [];
    for (var t in this) t[0] === er && e.push({ key: t.slice(1), value: this[t] });
    return e;
  },
  size: function() {
    var e = 0;
    for (var t in this) t[0] === er && ++e;
    return e;
  },
  empty: function() {
    for (var e in this) if (e[0] === er) return !1;
    return !0;
  },
  each: function(e) {
    for (var t in this) t[0] === er && e(this[t], t.slice(1), this);
  }
};
function Vr(e, t) {
  var n = new mu();
  if (e instanceof mu) e.each(function(s, c) {
    n.set(c, s);
  });
  else if (Array.isArray(e)) {
    var r = -1, i = e.length, a;
    if (t == null) for (; ++r < i; ) n.set(r, e[r]);
    else for (; ++r < i; ) n.set(t(a = e[r], r, e), a);
  } else if (e) for (var o in e) n.set(o, e[o]);
  return n;
}
function t3() {
  var e = [], t = [], n, r, i;
  function a(s, c, l, u) {
    if (c >= e.length)
      return n != null && s.sort(n), r != null ? r(s) : s;
    for (var d = -1, f = s.length, h = e[c++], m, y, v = Vr(), w, I = l(); ++d < f; )
      (w = v.get(m = h(y = s[d]) + "")) ? w.push(y) : v.set(m, [y]);
    return v.each(function(M, k) {
      u(I, k, a(M, c, l, u));
    }), I;
  }
  function o(s, c) {
    if (++c > e.length) return s;
    var l, u = t[c - 1];
    return r != null && c >= e.length ? l = s.entries() : (l = [], s.each(function(d, f) {
      l.push({ key: f, values: o(d, c) });
    })), u != null ? l.sort(function(d, f) {
      return u(d.key, f.key);
    }) : l;
  }
  return i = {
    object: function(s) {
      return a(s, 0, n3, r3);
    },
    map: function(s) {
      return a(s, 0, Zy, e1);
    },
    entries: function(s) {
      return o(a(s, 0, Zy, e1), 0);
    },
    key: function(s) {
      return e.push(s), i;
    },
    sortKeys: function(s) {
      return t[e.length - 1] = s, i;
    },
    sortValues: function(s) {
      return n = s, i;
    },
    rollup: function(s) {
      return r = s, i;
    }
  };
}
function n3() {
  return {};
}
function r3(e, t, n) {
  e[t] = n;
}
function Zy() {
  return Vr();
}
function e1(e, t, n) {
  e.set(t, n);
}
function gu() {
}
var oa = Vr.prototype;
gu.prototype = Ow.prototype = {
  constructor: gu,
  has: oa.has,
  add: function(e) {
    return e += "", this[er + e] = e, this;
  },
  remove: oa.remove,
  clear: oa.clear,
  values: oa.keys,
  size: oa.size,
  empty: oa.empty,
  each: oa.each
};
function Ow(e, t) {
  var n = new gu();
  if (e instanceof gu) e.each(function(a) {
    n.add(a);
  });
  else if (e) {
    var r = -1, i = e.length;
    if (t == null) for (; ++r < i; ) n.add(e[r]);
    else for (; ++r < i; ) n.add(t(e[r], r, e));
  }
  return n;
}
function i3(e) {
  var t = [];
  for (var n in e) t.push(n);
  return t;
}
function a3(e) {
  var t = [];
  for (var n in e) t.push(e[n]);
  return t;
}
function o3(e) {
  var t = [];
  for (var n in e) t.push({ key: n, value: e[n] });
  return t;
}
var t1 = {}, Dd = {}, Pd = 34, ns = 10, Ld = 13;
function Rw(e) {
  return new Function("d", "return {" + e.map(function(t, n) {
    return JSON.stringify(t) + ": d[" + n + "]";
  }).join(",") + "}");
}
function s3(e, t) {
  var n = Rw(e);
  return function(r, i) {
    return t(n(r), i, e);
  };
}
function l3(e) {
  var t = /* @__PURE__ */ Object.create(null), n = [];
  return e.forEach(function(r) {
    for (var i in r)
      i in t || n.push(t[i] = i);
  }), n;
}
function ig(e) {
  var t = new RegExp('["' + e + `
\r]`), n = e.charCodeAt(0);
  function r(l, u) {
    var d, f, h = i(l, function(m, y) {
      if (d) return d(m, y - 1);
      f = m, d = u ? s3(m, u) : Rw(m);
    });
    return h.columns = f || [], h;
  }
  function i(l, u) {
    var d = [], f = l.length, h = 0, m = 0, y, v = f <= 0, w = !1;
    l.charCodeAt(f - 1) === ns && --f, l.charCodeAt(f - 1) === Ld && --f;
    function I() {
      if (v) return Dd;
      if (w) return w = !1, t1;
      var k, g = h, A;
      if (l.charCodeAt(g) === Pd) {
        for (; h++ < f && l.charCodeAt(h) !== Pd || l.charCodeAt(++h) === Pd; ) ;
        return (k = h) >= f ? v = !0 : (A = l.charCodeAt(h++)) === ns ? w = !0 : A === Ld && (w = !0, l.charCodeAt(h) === ns && ++h), l.slice(g + 1, k - 1).replace(/""/g, '"');
      }
      for (; h < f; ) {
        if ((A = l.charCodeAt(k = h++)) === ns) w = !0;
        else if (A === Ld)
          w = !0, l.charCodeAt(h) === ns && ++h;
        else if (A !== n) continue;
        return l.slice(g, k);
      }
      return v = !0, l.slice(g, f);
    }
    for (; (y = I()) !== Dd; ) {
      for (var M = []; y !== t1 && y !== Dd; ) M.push(y), y = I();
      u && (M = u(M, m++)) == null || d.push(M);
    }
    return d;
  }
  function a(l, u) {
    return u == null && (u = l3(l)), [u.map(c).join(e)].concat(l.map(function(d) {
      return u.map(function(f) {
        return c(d[f]);
      }).join(e);
    })).join(`
`);
  }
  function o(l) {
    return l.map(s).join(`
`);
  }
  function s(l) {
    return l.map(c).join(e);
  }
  function c(l) {
    return l == null ? "" : t.test(l += "") ? '"' + l.replace(/"/g, '""') + '"' : l;
  }
  return {
    parse: r,
    parseRows: i,
    format: a,
    formatRows: o
  };
}
var Lf = ig(","), Dw = Lf.parse, c3 = Lf.parseRows, u3 = Lf.format, f3 = Lf.formatRows, zf = ig("	"), Pw = zf.parse, d3 = zf.parseRows, h3 = zf.format, p3 = zf.formatRows;
function m3(e, t) {
  var n;
  e == null && (e = 0), t == null && (t = 0);
  function r() {
    var i, a = n.length, o, s = 0, c = 0;
    for (i = 0; i < a; ++i)
      o = n[i], s += o.x, c += o.y;
    for (s = s / a - e, c = c / a - t, i = 0; i < a; ++i)
      o = n[i], o.x -= s, o.y -= c;
  }
  return r.initialize = function(i) {
    n = i;
  }, r.x = function(i) {
    return arguments.length ? (e = +i, r) : e;
  }, r.y = function(i) {
    return arguments.length ? (t = +i, r) : t;
  }, r;
}
function qt(e) {
  return function() {
    return e;
  };
}
function Ri() {
  return (Math.random() - 0.5) * 1e-6;
}
function g3(e) {
  var t = +this._x.call(null, e), n = +this._y.call(null, e);
  return Lw(this.cover(t, n), t, n, e);
}
function Lw(e, t, n, r) {
  if (isNaN(t) || isNaN(n)) return e;
  var i, a = e._root, o = { data: r }, s = e._x0, c = e._y0, l = e._x1, u = e._y1, d, f, h, m, y, v, w, I;
  if (!a) return e._root = o, e;
  for (; a.length; )
    if ((y = t >= (d = (s + l) / 2)) ? s = d : l = d, (v = n >= (f = (c + u) / 2)) ? c = f : u = f, i = a, !(a = a[w = v << 1 | y])) return i[w] = o, e;
  if (h = +e._x.call(null, a.data), m = +e._y.call(null, a.data), t === h && n === m) return o.next = a, i ? i[w] = o : e._root = o, e;
  do
    i = i ? i[w] = new Array(4) : e._root = new Array(4), (y = t >= (d = (s + l) / 2)) ? s = d : l = d, (v = n >= (f = (c + u) / 2)) ? c = f : u = f;
  while ((w = v << 1 | y) === (I = (m >= f) << 1 | h >= d));
  return i[I] = a, i[w] = o, e;
}
function y3(e) {
  var t, n, r = e.length, i, a, o = new Array(r), s = new Array(r), c = 1 / 0, l = 1 / 0, u = -1 / 0, d = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, t = e[n])) || isNaN(a = +this._y.call(null, t)) || (o[n] = i, s[n] = a, i < c && (c = i), i > u && (u = i), a < l && (l = a), a > d && (d = a));
  for (u < c && (c = this._x0, u = this._x1), d < l && (l = this._y0, d = this._y1), this.cover(c, l).cover(u, d), n = 0; n < r; ++n)
    Lw(this, o[n], s[n], e[n]);
  return this;
}
function A3(e, t) {
  if (isNaN(e = +e) || isNaN(t = +t)) return this;
  var n = this._x0, r = this._y0, i = this._x1, a = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(e)) + 1, a = (r = Math.floor(t)) + 1;
  else if (n > e || e > i || r > t || t > a) {
    var o = i - n, s = this._root, c, l;
    switch (l = (t < (r + a) / 2) << 1 | e < (n + i) / 2) {
      case 0: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, i = n + o, a = r + o, e > i || t > a);
        break;
      }
      case 1: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, n = i - o, a = r + o, n > e || t > a);
        break;
      }
      case 2: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, i = n + o, r = a - o, e > i || r > t);
        break;
      }
      case 3: {
        do
          c = new Array(4), c[l] = s, s = c;
        while (o *= 2, n = i - o, r = a - o, n > e || r > t);
        break;
      }
    }
    this._root && this._root.length && (this._root = s);
  } else return this;
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this;
}
function v3() {
  var e = [];
  return this.visit(function(t) {
    if (!t.length) do
      e.push(t.data);
    while (t = t.next);
  }), e;
}
function x3(e) {
  return arguments.length ? this.cover(+e[0][0], +e[0][1]).cover(+e[1][0], +e[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Cn(e, t, n, r, i) {
  this.node = e, this.x0 = t, this.y0 = n, this.x1 = r, this.y1 = i;
}
function b3(e, t, n) {
  var r, i = this._x0, a = this._y0, o, s, c, l, u = this._x1, d = this._y1, f = [], h = this._root, m, y;
  for (h && f.push(new Cn(h, i, a, u, d)), n == null ? n = 1 / 0 : (i = e - n, a = t - n, u = e + n, d = t + n, n *= n); m = f.pop(); )
    if (!(!(h = m.node) || (o = m.x0) > u || (s = m.y0) > d || (c = m.x1) < i || (l = m.y1) < a))
      if (h.length) {
        var v = (o + c) / 2, w = (s + l) / 2;
        f.push(
          new Cn(h[3], v, w, c, l),
          new Cn(h[2], o, w, v, l),
          new Cn(h[1], v, s, c, w),
          new Cn(h[0], o, s, v, w)
        ), (y = (t >= w) << 1 | e >= v) && (m = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - y], f[f.length - 1 - y] = m);
      } else {
        var I = e - +this._x.call(null, h.data), M = t - +this._y.call(null, h.data), k = I * I + M * M;
        if (k < n) {
          var g = Math.sqrt(n = k);
          i = e - g, a = t - g, u = e + g, d = t + g, r = h.data;
        }
      }
  return r;
}
function w3(e) {
  if (isNaN(u = +this._x.call(null, e)) || isNaN(d = +this._y.call(null, e))) return this;
  var t, n = this._root, r, i, a, o = this._x0, s = this._y0, c = this._x1, l = this._y1, u, d, f, h, m, y, v, w;
  if (!n) return this;
  if (n.length) for (; ; ) {
    if ((m = u >= (f = (o + c) / 2)) ? o = f : c = f, (y = d >= (h = (s + l) / 2)) ? s = h : l = h, t = n, !(n = n[v = y << 1 | m])) return this;
    if (!n.length) break;
    (t[v + 1 & 3] || t[v + 2 & 3] || t[v + 3 & 3]) && (r = t, w = v);
  }
  for (; n.data !== e; ) if (i = n, !(n = n.next)) return this;
  return (a = n.next) && delete n.next, i ? (a ? i.next = a : delete i.next, this) : t ? (a ? t[v] = a : delete t[v], (n = t[0] || t[1] || t[2] || t[3]) && n === (t[3] || t[2] || t[1] || t[0]) && !n.length && (r ? r[w] = n : this._root = n), this) : (this._root = a, this);
}
function _3(e) {
  for (var t = 0, n = e.length; t < n; ++t) this.remove(e[t]);
  return this;
}
function S3() {
  return this._root;
}
function C3() {
  var e = 0;
  return this.visit(function(t) {
    if (!t.length) do
      ++e;
    while (t = t.next);
  }), e;
}
function E3(e) {
  var t = [], n, r = this._root, i, a, o, s, c;
  for (r && t.push(new Cn(r, this._x0, this._y0, this._x1, this._y1)); n = t.pop(); )
    if (!e(r = n.node, a = n.x0, o = n.y0, s = n.x1, c = n.y1) && r.length) {
      var l = (a + s) / 2, u = (o + c) / 2;
      (i = r[3]) && t.push(new Cn(i, l, u, s, c)), (i = r[2]) && t.push(new Cn(i, a, u, l, c)), (i = r[1]) && t.push(new Cn(i, l, o, s, u)), (i = r[0]) && t.push(new Cn(i, a, o, l, u));
    }
  return this;
}
function k3(e) {
  var t = [], n = [], r;
  for (this._root && t.push(new Cn(this._root, this._x0, this._y0, this._x1, this._y1)); r = t.pop(); ) {
    var i = r.node;
    if (i.length) {
      var a, o = r.x0, s = r.y0, c = r.x1, l = r.y1, u = (o + c) / 2, d = (s + l) / 2;
      (a = i[0]) && t.push(new Cn(a, o, s, u, d)), (a = i[1]) && t.push(new Cn(a, u, s, c, d)), (a = i[2]) && t.push(new Cn(a, o, d, u, l)), (a = i[3]) && t.push(new Cn(a, u, d, c, l));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    e(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function T3(e) {
  return e[0];
}
function M3(e) {
  return arguments.length ? (this._x = e, this) : this._x;
}
function I3(e) {
  return e[1];
}
function N3(e) {
  return arguments.length ? (this._y = e, this) : this._y;
}
function Bf(e, t, n) {
  var r = new ag(t ?? T3, n ?? I3, NaN, NaN, NaN, NaN);
  return e == null ? r : r.addAll(e);
}
function ag(e, t, n, r, i, a) {
  this._x = e, this._y = t, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this._root = void 0;
}
function n1(e) {
  for (var t = { data: e.data }, n = t; e = e.next; ) n = n.next = { data: e.data };
  return t;
}
var Tn = Bf.prototype = ag.prototype;
Tn.copy = function() {
  var e = new ag(this._x, this._y, this._x0, this._y0, this._x1, this._y1), t = this._root, n, r;
  if (!t) return e;
  if (!t.length) return e._root = n1(t), e;
  for (n = [{ source: t, target: e._root = new Array(4) }]; t = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = t.source[i]) && (r.length ? n.push({ source: r, target: t.target[i] = new Array(4) }) : t.target[i] = n1(r));
  return e;
};
Tn.add = g3;
Tn.addAll = y3;
Tn.cover = A3;
Tn.data = v3;
Tn.extent = x3;
Tn.find = b3;
Tn.remove = w3;
Tn.removeAll = _3;
Tn.root = S3;
Tn.size = C3;
Tn.visit = E3;
Tn.visitAfter = k3;
Tn.x = M3;
Tn.y = N3;
function O3(e) {
  return e.x + e.vx;
}
function R3(e) {
  return e.y + e.vy;
}
function D3(e) {
  var t, n, r = 1, i = 1;
  typeof e != "function" && (e = qt(e == null ? 1 : +e));
  function a() {
    for (var c, l = t.length, u, d, f, h, m, y, v = 0; v < i; ++v)
      for (u = Bf(t, O3, R3).visitAfter(o), c = 0; c < l; ++c)
        d = t[c], m = n[d.index], y = m * m, f = d.x + d.vx, h = d.y + d.vy, u.visit(w);
    function w(I, M, k, g, A) {
      var b = I.data, x = I.r, _ = m + x;
      if (b) {
        if (b.index > d.index) {
          var R = f - b.x - b.vx, P = h - b.y - b.vy, E = R * R + P * P;
          E < _ * _ && (R === 0 && (R = Ri(), E += R * R), P === 0 && (P = Ri(), E += P * P), E = (_ - (E = Math.sqrt(E))) / E * r, d.vx += (R *= E) * (_ = (x *= x) / (y + x)), d.vy += (P *= E) * _, b.vx -= R * (_ = 1 - _), b.vy -= P * _);
        }
        return;
      }
      return M > f + _ || g < f - _ || k > h + _ || A < h - _;
    }
  }
  function o(c) {
    if (c.data) return c.r = n[c.data.index];
    for (var l = c.r = 0; l < 4; ++l)
      c[l] && c[l].r > c.r && (c.r = c[l].r);
  }
  function s() {
    if (t) {
      var c, l = t.length, u;
      for (n = new Array(l), c = 0; c < l; ++c) u = t[c], n[u.index] = +e(u, c, t);
    }
  }
  return a.initialize = function(c) {
    t = c, s();
  }, a.iterations = function(c) {
    return arguments.length ? (i = +c, a) : i;
  }, a.strength = function(c) {
    return arguments.length ? (r = +c, a) : r;
  }, a.radius = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : qt(+c), s(), a) : e;
  }, a;
}
function P3(e) {
  return e.index;
}
function r1(e, t) {
  var n = e.get(t);
  if (!n) throw new Error("missing: " + t);
  return n;
}
function L3(e) {
  var t = P3, n = u, r, i = qt(30), a, o, s, c, l = 1;
  e == null && (e = []);
  function u(y) {
    return 1 / Math.min(s[y.source.index], s[y.target.index]);
  }
  function d(y) {
    for (var v = 0, w = e.length; v < l; ++v)
      for (var I = 0, M, k, g, A, b, x, _; I < w; ++I)
        M = e[I], k = M.source, g = M.target, A = g.x + g.vx - k.x - k.vx || Ri(), b = g.y + g.vy - k.y - k.vy || Ri(), x = Math.sqrt(A * A + b * b), x = (x - a[I]) / x * y * r[I], A *= x, b *= x, g.vx -= A * (_ = c[I]), g.vy -= b * _, k.vx += A * (_ = 1 - _), k.vy += b * _;
  }
  function f() {
    if (o) {
      var y, v = o.length, w = e.length, I = Vr(o, t), M;
      for (y = 0, s = new Array(v); y < w; ++y)
        M = e[y], M.index = y, typeof M.source != "object" && (M.source = r1(I, M.source)), typeof M.target != "object" && (M.target = r1(I, M.target)), s[M.source.index] = (s[M.source.index] || 0) + 1, s[M.target.index] = (s[M.target.index] || 0) + 1;
      for (y = 0, c = new Array(w); y < w; ++y)
        M = e[y], c[y] = s[M.source.index] / (s[M.source.index] + s[M.target.index]);
      r = new Array(w), h(), a = new Array(w), m();
    }
  }
  function h() {
    if (o)
      for (var y = 0, v = e.length; y < v; ++y)
        r[y] = +n(e[y], y, e);
  }
  function m() {
    if (o)
      for (var y = 0, v = e.length; y < v; ++y)
        a[y] = +i(e[y], y, e);
  }
  return d.initialize = function(y) {
    o = y, f();
  }, d.links = function(y) {
    return arguments.length ? (e = y, f(), d) : e;
  }, d.id = function(y) {
    return arguments.length ? (t = y, d) : t;
  }, d.iterations = function(y) {
    return arguments.length ? (l = +y, d) : l;
  }, d.strength = function(y) {
    return arguments.length ? (n = typeof y == "function" ? y : qt(+y), h(), d) : n;
  }, d.distance = function(y) {
    return arguments.length ? (i = typeof y == "function" ? y : qt(+y), m(), d) : i;
  }, d;
}
function z3(e) {
  return e.x;
}
function B3(e) {
  return e.y;
}
var F3 = 10, Y3 = Math.PI * (3 - Math.sqrt(5));
function j3(e) {
  var t, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), a = 0, o = 0.6, s = Vr(), c = Df(u), l = Vi("tick", "end");
  e == null && (e = []);
  function u() {
    d(), l.call("tick", t), n < r && (c.stop(), l.call("end", t));
  }
  function d() {
    var m, y = e.length, v;
    for (n += (a - n) * i, s.each(function(w) {
      w(n);
    }), m = 0; m < y; ++m)
      v = e[m], v.fx == null ? v.x += v.vx *= o : (v.x = v.fx, v.vx = 0), v.fy == null ? v.y += v.vy *= o : (v.y = v.fy, v.vy = 0);
  }
  function f() {
    for (var m = 0, y = e.length, v; m < y; ++m) {
      if (v = e[m], v.index = m, isNaN(v.x) || isNaN(v.y)) {
        var w = F3 * Math.sqrt(m), I = m * Y3;
        v.x = w * Math.cos(I), v.y = w * Math.sin(I);
      }
      (isNaN(v.vx) || isNaN(v.vy)) && (v.vx = v.vy = 0);
    }
  }
  function h(m) {
    return m.initialize && m.initialize(e), m;
  }
  return f(), t = {
    tick: d,
    restart: function() {
      return c.restart(u), t;
    },
    stop: function() {
      return c.stop(), t;
    },
    nodes: function(m) {
      return arguments.length ? (e = m, f(), s.each(h), t) : e;
    },
    alpha: function(m) {
      return arguments.length ? (n = +m, t) : n;
    },
    alphaMin: function(m) {
      return arguments.length ? (r = +m, t) : r;
    },
    alphaDecay: function(m) {
      return arguments.length ? (i = +m, t) : +i;
    },
    alphaTarget: function(m) {
      return arguments.length ? (a = +m, t) : a;
    },
    velocityDecay: function(m) {
      return arguments.length ? (o = 1 - m, t) : 1 - o;
    },
    force: function(m, y) {
      return arguments.length > 1 ? (y == null ? s.remove(m) : s.set(m, h(y)), t) : s.get(m);
    },
    find: function(m, y, v) {
      var w = 0, I = e.length, M, k, g, A, b;
      for (v == null ? v = 1 / 0 : v *= v, w = 0; w < I; ++w)
        A = e[w], M = m - A.x, k = y - A.y, g = M * M + k * k, g < v && (b = A, v = g);
      return b;
    },
    on: function(m, y) {
      return arguments.length > 1 ? (l.on(m, y), t) : l.on(m);
    }
  };
}
function $3() {
  var e, t, n, r = qt(-30), i, a = 1, o = 1 / 0, s = 0.81;
  function c(f) {
    var h, m = e.length, y = Bf(e, z3, B3).visitAfter(u);
    for (n = f, h = 0; h < m; ++h) t = e[h], y.visit(d);
  }
  function l() {
    if (e) {
      var f, h = e.length, m;
      for (i = new Array(h), f = 0; f < h; ++f) m = e[f], i[m.index] = +r(m, f, e);
    }
  }
  function u(f) {
    var h = 0, m, y, v = 0, w, I, M;
    if (f.length) {
      for (w = I = M = 0; M < 4; ++M)
        (m = f[M]) && (y = Math.abs(m.value)) && (h += m.value, v += y, w += y * m.x, I += y * m.y);
      f.x = w / v, f.y = I / v;
    } else {
      m = f, m.x = m.data.x, m.y = m.data.y;
      do
        h += i[m.data.index];
      while (m = m.next);
    }
    f.value = h;
  }
  function d(f, h, m, y) {
    if (!f.value) return !0;
    var v = f.x - t.x, w = f.y - t.y, I = y - h, M = v * v + w * w;
    if (I * I / s < M)
      return M < o && (v === 0 && (v = Ri(), M += v * v), w === 0 && (w = Ri(), M += w * w), M < a && (M = Math.sqrt(a * M)), t.vx += v * f.value * n / M, t.vy += w * f.value * n / M), !0;
    if (f.length || M >= o) return;
    (f.data !== t || f.next) && (v === 0 && (v = Ri(), M += v * v), w === 0 && (w = Ri(), M += w * w), M < a && (M = Math.sqrt(a * M)));
    do
      f.data !== t && (I = i[f.data.index] * n / M, t.vx += v * I, t.vy += w * I);
    while (f = f.next);
  }
  return c.initialize = function(f) {
    e = f, l();
  }, c.strength = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : qt(+f), l(), c) : r;
  }, c.distanceMin = function(f) {
    return arguments.length ? (a = f * f, c) : Math.sqrt(a);
  }, c.distanceMax = function(f) {
    return arguments.length ? (o = f * f, c) : Math.sqrt(o);
  }, c.theta = function(f) {
    return arguments.length ? (s = f * f, c) : Math.sqrt(s);
  }, c;
}
function W3(e, t, n) {
  var r, i = qt(0.1), a, o;
  typeof e != "function" && (e = qt(+e)), t == null && (t = 0), n == null && (n = 0);
  function s(l) {
    for (var u = 0, d = r.length; u < d; ++u) {
      var f = r[u], h = f.x - t || 1e-6, m = f.y - n || 1e-6, y = Math.sqrt(h * h + m * m), v = (o[u] - y) * a[u] * l / y;
      f.vx += h * v, f.vy += m * v;
    }
  }
  function c() {
    if (r) {
      var l, u = r.length;
      for (a = new Array(u), o = new Array(u), l = 0; l < u; ++l)
        o[l] = +e(r[l], l, r), a[l] = isNaN(o[l]) ? 0 : +i(r[l], l, r);
    }
  }
  return s.initialize = function(l) {
    r = l, c();
  }, s.strength = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : qt(+l), c(), s) : i;
  }, s.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : qt(+l), c(), s) : e;
  }, s.x = function(l) {
    return arguments.length ? (t = +l, s) : t;
  }, s.y = function(l) {
    return arguments.length ? (n = +l, s) : n;
  }, s;
}
function U3(e) {
  var t = qt(0.1), n, r, i;
  typeof e != "function" && (e = qt(e == null ? 0 : +e));
  function a(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vx += (i[c] - u.x) * r[c] * s;
  }
  function o() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return a.initialize = function(s) {
    n = s, o();
  }, a.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : qt(+s), o(), a) : t;
  }, a.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : qt(+s), o(), a) : e;
  }, a;
}
function H3(e) {
  var t = qt(0.1), n, r, i;
  typeof e != "function" && (e = qt(e == null ? 0 : +e));
  function a(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vy += (i[c] - u.y) * r[c] * s;
  }
  function o() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return a.initialize = function(s) {
    n = s, o();
  }, a.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : qt(+s), o(), a) : t;
  }, a.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : qt(+s), o(), a) : e;
  }, a;
}
function yu(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function wo(e) {
  return e = yu(Math.abs(e)), e ? e[1] : NaN;
}
function G3(e, t) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function V3(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
function Q3(e, t) {
  e = e.toPrecision(t);
  e: for (var n = e.length, r = 1, i = -1, a; r < n; ++r)
    switch (e[r]) {
      case ".":
        i = a = r;
        break;
      case "0":
        i === 0 && (i = r), a = r;
        break;
      case "e":
        break e;
      default:
        i > 0 && (i = 0);
        break;
    }
  return i > 0 ? e.slice(0, i) + e.slice(a + 1) : e;
}
var zw;
function q3(e, t) {
  var n = yu(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], a = i - (zw = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + yu(e, Math.max(0, t + a - 1))[0];
}
function i1(e, t) {
  var n = yu(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Bw = {
  "": Q3,
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: function(e) {
    return Math.round(e).toString(10);
  },
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return i1(e * 100, t);
  },
  r: i1,
  s: q3,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
var X3 = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
function ol(e) {
  return new og(e);
}
ol.prototype = og.prototype;
function og(e) {
  if (!(t = X3.exec(e))) throw new Error("invalid format: " + e);
  var t, n = t[1] || " ", r = t[2] || ">", i = t[3] || "-", a = t[4] || "", o = !!t[5], s = t[6] && +t[6], c = !!t[7], l = t[8] && +t[8].slice(1), u = t[9] || "";
  u === "n" ? (c = !0, u = "g") : Bw[u] || (u = ""), (o || n === "0" && r === "=") && (o = !0, n = "0", r = "="), this.fill = n, this.align = r, this.sign = i, this.symbol = a, this.zero = o, this.width = s, this.comma = c, this.precision = l, this.type = u;
}
og.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + this.type;
};
function a1(e) {
  return e;
}
var o1 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Fw(e) {
  var t = e.grouping && e.thousands ? G3(e.grouping, e.thousands) : a1, n = e.currency, r = e.decimal, i = e.numerals ? V3(e.numerals) : a1, a = e.percent || "%";
  function o(c) {
    c = ol(c);
    var l = c.fill, u = c.align, d = c.sign, f = c.symbol, h = c.zero, m = c.width, y = c.comma, v = c.precision, w = c.type, I = f === "$" ? n[0] : f === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", M = f === "$" ? n[1] : /[%p]/.test(w) ? a : "", k = Bw[w], g = !w || /[defgprs%]/.test(w);
    v = v == null ? w ? 6 : 12 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function A(b) {
      var x = I, _ = M, R, P, E;
      if (w === "c")
        _ = k(b) + _, b = "";
      else {
        b = +b;
        var C = b < 0;
        if (b = k(Math.abs(b), v), C && +b == 0 && (C = !1), x = (C ? d === "(" ? d : "-" : d === "-" || d === "(" ? "" : d) + x, _ = (w === "s" ? o1[8 + zw / 3] : "") + _ + (C && d === "(" ? ")" : ""), g) {
          for (R = -1, P = b.length; ++R < P; )
            if (E = b.charCodeAt(R), 48 > E || E > 57) {
              _ = (E === 46 ? r + b.slice(R + 1) : b.slice(R)) + _, b = b.slice(0, R);
              break;
            }
        }
      }
      y && !h && (b = t(b, 1 / 0));
      var T = x.length + b.length + _.length, D = T < m ? new Array(m - T + 1).join(l) : "";
      switch (y && h && (b = t(D + b, D.length ? m - _.length : 1 / 0), D = ""), u) {
        case "<":
          b = x + b + _ + D;
          break;
        case "=":
          b = x + D + b + _;
          break;
        case "^":
          b = D.slice(0, T = D.length >> 1) + x + b + _ + D.slice(T);
          break;
        default:
          b = D + x + b + _;
          break;
      }
      return i(b);
    }
    return A.toString = function() {
      return c + "";
    }, A;
  }
  function s(c, l) {
    var u = o((c = ol(c), c.type = "f", c)), d = Math.max(-8, Math.min(8, Math.floor(wo(l) / 3))) * 3, f = Math.pow(10, -d), h = o1[8 + d / 3];
    return function(m) {
      return u(f * m) + h;
    };
  }
  return {
    format: o,
    formatPrefix: s
  };
}
var sc, Ff, sg;
Yw({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Yw(e) {
  return sc = Fw(e), Ff = sc.format, sg = sc.formatPrefix, sc;
}
function jw(e) {
  return Math.max(0, -wo(Math.abs(e)));
}
function $w(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(wo(t) / 3))) * 3 - wo(Math.abs(e)));
}
function Ww(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, wo(t) - wo(e)) + 1;
}
function Xi() {
  return new Au();
}
function Au() {
  this.reset();
}
Au.prototype = {
  constructor: Au,
  reset: function() {
    this.s = // rounded value
    this.t = 0;
  },
  add: function(e) {
    s1(lc, e, this.t), s1(this, lc.s, this.s), this.s ? this.t += lc.t : this.s = lc.t;
  },
  valueOf: function() {
    return this.s;
  }
};
var lc = new Au();
function s1(e, t, n) {
  var r = e.s = t + n, i = r - t, a = r - i;
  e.t = t - a + (n - i);
}
var Fe = 1e-6, l1 = 1e-12, rt = Math.PI, Wt = rt / 2, vu = rt / 4, Dn = rt * 2, Et = 180 / rt, $e = rt / 180, dt = Math.abs, zo = Math.atan, kn = Math.atan2, Be = Math.cos, cc = Math.ceil, Uw = Math.exp, xu = Math.log, zd = Math.pow, De = Math.sin, sl = Math.sign || function(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0;
}, Jt = Math.sqrt, lg = Math.tan;
function Hw(e) {
  return e > 1 ? 0 : e < -1 ? rt : Math.acos(e);
}
function Qn(e) {
  return e > 1 ? Wt : e < -1 ? -Wt : Math.asin(e);
}
function c1(e) {
  return (e = De(e / 2)) * e;
}
function Dt() {
}
function bu(e, t) {
  e && f1.hasOwnProperty(e.type) && f1[e.type](e, t);
}
var u1 = {
  Feature: function(e, t) {
    bu(e.geometry, t);
  },
  FeatureCollection: function(e, t) {
    for (var n = e.features, r = -1, i = n.length; ++r < i; ) bu(n[r].geometry, t);
  }
}, f1 = {
  Sphere: function(e, t) {
    t.sphere();
  },
  Point: function(e, t) {
    e = e.coordinates, t.point(e[0], e[1], e[2]);
  },
  MultiPoint: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) e = n[r], t.point(e[0], e[1], e[2]);
  },
  LineString: function(e, t) {
    ip(e.coordinates, t, 0);
  },
  MultiLineString: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) ip(n[r], t, 0);
  },
  Polygon: function(e, t) {
    d1(e.coordinates, t);
  },
  MultiPolygon: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) d1(n[r], t);
  },
  GeometryCollection: function(e, t) {
    for (var n = e.geometries, r = -1, i = n.length; ++r < i; ) bu(n[r], t);
  }
};
function ip(e, t, n) {
  var r = -1, i = e.length - n, a;
  for (t.lineStart(); ++r < i; ) a = e[r], t.point(a[0], a[1], a[2]);
  t.lineEnd();
}
function d1(e, t) {
  var n = -1, r = e.length;
  for (t.polygonStart(); ++n < r; ) ip(e[n], t, 1);
  t.polygonEnd();
}
function pr(e, t) {
  e && u1.hasOwnProperty(e.type) ? u1[e.type](e, t) : bu(e, t);
}
var wu = Xi(), _u = Xi(), Gw, Vw, ap, op, sp, Qr = {
  point: Dt,
  lineStart: Dt,
  lineEnd: Dt,
  polygonStart: function() {
    wu.reset(), Qr.lineStart = J3, Qr.lineEnd = K3;
  },
  polygonEnd: function() {
    var e = +wu;
    _u.add(e < 0 ? Dn + e : e), this.lineStart = this.lineEnd = this.point = Dt;
  },
  sphere: function() {
    _u.add(Dn);
  }
};
function J3() {
  Qr.point = Z3;
}
function K3() {
  Qw(Gw, Vw);
}
function Z3(e, t) {
  Qr.point = Qw, Gw = e, Vw = t, e *= $e, t *= $e, ap = e, op = Be(t = t / 2 + vu), sp = De(t);
}
function Qw(e, t) {
  e *= $e, t *= $e, t = t / 2 + vu;
  var n = e - ap, r = n >= 0 ? 1 : -1, i = r * n, a = Be(t), o = De(t), s = sp * o, c = op * a + s * Be(i), l = s * r * De(i);
  wu.add(kn(l, c)), ap = e, op = a, sp = o;
}
function ez(e) {
  return _u.reset(), pr(e, Qr), _u * 2;
}
function Su(e) {
  return [kn(e[1], e[0]), Qn(e[2])];
}
function Ea(e) {
  var t = e[0], n = e[1], r = Be(n);
  return [r * Be(t), r * De(t), De(n)];
}
function uc(e, t) {
  return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function _o(e, t) {
  return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
}
function Bd(e, t) {
  e[0] += t[0], e[1] += t[1], e[2] += t[2];
}
function fc(e, t) {
  return [e[0] * t, e[1] * t, e[2] * t];
}
function Cu(e) {
  var t = Jt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
  e[0] /= t, e[1] /= t, e[2] /= t;
}
var zt, Wn, Yt, rr, ca, qw, Xw, fo, Os = Xi(), Ti, yi, ai = {
  point: lp,
  lineStart: h1,
  lineEnd: p1,
  polygonStart: function() {
    ai.point = Kw, ai.lineStart = tz, ai.lineEnd = nz, Os.reset(), Qr.polygonStart();
  },
  polygonEnd: function() {
    Qr.polygonEnd(), ai.point = lp, ai.lineStart = h1, ai.lineEnd = p1, wu < 0 ? (zt = -(Yt = 180), Wn = -(rr = 90)) : Os > Fe ? rr = 90 : Os < -Fe && (Wn = -90), yi[0] = zt, yi[1] = Yt;
  }
};
function lp(e, t) {
  Ti.push(yi = [zt = e, Yt = e]), t < Wn && (Wn = t), t > rr && (rr = t);
}
function Jw(e, t) {
  var n = Ea([e * $e, t * $e]);
  if (fo) {
    var r = _o(fo, n), i = [r[1], -r[0], 0], a = _o(i, r);
    Cu(a), a = Su(a);
    var o = e - ca, s = o > 0 ? 1 : -1, c = a[0] * Et * s, l, u = dt(o) > 180;
    u ^ (s * ca < c && c < s * e) ? (l = a[1] * Et, l > rr && (rr = l)) : (c = (c + 360) % 360 - 180, u ^ (s * ca < c && c < s * e) ? (l = -a[1] * Et, l < Wn && (Wn = l)) : (t < Wn && (Wn = t), t > rr && (rr = t))), u ? e < ca ? Fn(zt, e) > Fn(zt, Yt) && (Yt = e) : Fn(e, Yt) > Fn(zt, Yt) && (zt = e) : Yt >= zt ? (e < zt && (zt = e), e > Yt && (Yt = e)) : e > ca ? Fn(zt, e) > Fn(zt, Yt) && (Yt = e) : Fn(e, Yt) > Fn(zt, Yt) && (zt = e);
  } else
    Ti.push(yi = [zt = e, Yt = e]);
  t < Wn && (Wn = t), t > rr && (rr = t), fo = n, ca = e;
}
function h1() {
  ai.point = Jw;
}
function p1() {
  yi[0] = zt, yi[1] = Yt, ai.point = lp, fo = null;
}
function Kw(e, t) {
  if (fo) {
    var n = e - ca;
    Os.add(dt(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
  } else
    qw = e, Xw = t;
  Qr.point(e, t), Jw(e, t);
}
function tz() {
  Qr.lineStart();
}
function nz() {
  Kw(qw, Xw), Qr.lineEnd(), dt(Os) > Fe && (zt = -(Yt = 180)), yi[0] = zt, yi[1] = Yt, fo = null;
}
function Fn(e, t) {
  return (t -= e) < 0 ? t + 360 : t;
}
function rz(e, t) {
  return e[0] - t[0];
}
function m1(e, t) {
  return e[0] <= e[1] ? e[0] <= t && t <= e[1] : t < e[0] || e[1] < t;
}
function iz(e) {
  var t, n, r, i, a, o, s;
  if (rr = Yt = -(zt = Wn = 1 / 0), Ti = [], pr(e, ai), n = Ti.length) {
    for (Ti.sort(rz), t = 1, r = Ti[0], a = [r]; t < n; ++t)
      i = Ti[t], m1(r, i[0]) || m1(r, i[1]) ? (Fn(r[0], i[1]) > Fn(r[0], r[1]) && (r[1] = i[1]), Fn(i[0], r[1]) > Fn(r[0], r[1]) && (r[0] = i[0])) : a.push(r = i);
    for (o = -1 / 0, n = a.length - 1, t = 0, r = a[n]; t <= n; r = i, ++t)
      i = a[t], (s = Fn(r[1], i[0])) > o && (o = s, zt = i[0], Yt = r[1]);
  }
  return Ti = yi = null, zt === 1 / 0 || Wn === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[zt, Wn], [Yt, rr]];
}
var ms, Eu, ku, Tu, Mu, Iu, Nu, Ou, cp, up, fp, Zw, e_, wn, _n, Sn, Ar = {
  sphere: Dt,
  point: cg,
  lineStart: g1,
  lineEnd: y1,
  polygonStart: function() {
    Ar.lineStart = sz, Ar.lineEnd = lz;
  },
  polygonEnd: function() {
    Ar.lineStart = g1, Ar.lineEnd = y1;
  }
};
function cg(e, t) {
  e *= $e, t *= $e;
  var n = Be(t);
  Rl(n * Be(e), n * De(e), De(t));
}
function Rl(e, t, n) {
  ++ms, ku += (e - ku) / ms, Tu += (t - Tu) / ms, Mu += (n - Mu) / ms;
}
function g1() {
  Ar.point = az;
}
function az(e, t) {
  e *= $e, t *= $e;
  var n = Be(t);
  wn = n * Be(e), _n = n * De(e), Sn = De(t), Ar.point = oz, Rl(wn, _n, Sn);
}
function oz(e, t) {
  e *= $e, t *= $e;
  var n = Be(t), r = n * Be(e), i = n * De(e), a = De(t), o = kn(Jt((o = _n * a - Sn * i) * o + (o = Sn * r - wn * a) * o + (o = wn * i - _n * r) * o), wn * r + _n * i + Sn * a);
  Eu += o, Iu += o * (wn + (wn = r)), Nu += o * (_n + (_n = i)), Ou += o * (Sn + (Sn = a)), Rl(wn, _n, Sn);
}
function y1() {
  Ar.point = cg;
}
function sz() {
  Ar.point = cz;
}
function lz() {
  t_(Zw, e_), Ar.point = cg;
}
function cz(e, t) {
  Zw = e, e_ = t, e *= $e, t *= $e, Ar.point = t_;
  var n = Be(t);
  wn = n * Be(e), _n = n * De(e), Sn = De(t), Rl(wn, _n, Sn);
}
function t_(e, t) {
  e *= $e, t *= $e;
  var n = Be(t), r = n * Be(e), i = n * De(e), a = De(t), o = _n * a - Sn * i, s = Sn * r - wn * a, c = wn * i - _n * r, l = Jt(o * o + s * s + c * c), u = Qn(l), d = l && -u / l;
  cp += d * o, up += d * s, fp += d * c, Eu += u, Iu += u * (wn + (wn = r)), Nu += u * (_n + (_n = i)), Ou += u * (Sn + (Sn = a)), Rl(wn, _n, Sn);
}
function uz(e) {
  ms = Eu = ku = Tu = Mu = Iu = Nu = Ou = cp = up = fp = 0, pr(e, Ar);
  var t = cp, n = up, r = fp, i = t * t + n * n + r * r;
  return i < l1 && (t = Iu, n = Nu, r = Ou, Eu < Fe && (t = ku, n = Tu, r = Mu), i = t * t + n * n + r * r, i < l1) ? [NaN, NaN] : [kn(n, t) * Et, Qn(r / Jt(i)) * Et];
}
function Ua(e) {
  return function() {
    return e;
  };
}
function n_(e, t) {
  function n(r, i) {
    return r = e(r, i), t(r[0], r[1]);
  }
  return e.invert && t.invert && (n.invert = function(r, i) {
    return r = t.invert(r, i), r && e.invert(r[0], r[1]);
  }), n;
}
function dp(e, t) {
  return [e > rt ? e - Dn : e < -rt ? e + Dn : e, t];
}
dp.invert = dp;
function ug(e, t, n) {
  return (e %= Dn) ? t || n ? n_(v1(e), x1(t, n)) : v1(e) : t || n ? x1(t, n) : dp;
}
function A1(e) {
  return function(t, n) {
    return t += e, [t > rt ? t - Dn : t < -rt ? t + Dn : t, n];
  };
}
function v1(e) {
  var t = A1(e);
  return t.invert = A1(-e), t;
}
function x1(e, t) {
  var n = Be(e), r = De(e), i = Be(t), a = De(t);
  function o(s, c) {
    var l = Be(c), u = Be(s) * l, d = De(s) * l, f = De(c), h = f * n + u * r;
    return [
      kn(d * i - h * a, u * n - f * r),
      Qn(h * i + d * a)
    ];
  }
  return o.invert = function(s, c) {
    var l = Be(c), u = Be(s) * l, d = De(s) * l, f = De(c), h = f * i - d * a;
    return [
      kn(d * i + f * a, u * n + h * r),
      Qn(h * n - u * r)
    ];
  }, o;
}
function r_(e) {
  e = ug(e[0] * $e, e[1] * $e, e.length > 2 ? e[2] * $e : 0);
  function t(n) {
    return n = e(n[0] * $e, n[1] * $e), n[0] *= Et, n[1] *= Et, n;
  }
  return t.invert = function(n) {
    return n = e.invert(n[0] * $e, n[1] * $e), n[0] *= Et, n[1] *= Et, n;
  }, t;
}
function i_(e, t, n, r, i, a) {
  if (n) {
    var o = Be(t), s = De(t), c = r * n;
    i == null ? (i = t + r * Dn, a = t - c / 2) : (i = b1(o, i), a = b1(o, a), (r > 0 ? i < a : i > a) && (i += r * Dn));
    for (var l, u = i; r > 0 ? u > a : u < a; u -= c)
      l = Su([o, -s * Be(u), -s * De(u)]), e.point(l[0], l[1]);
  }
}
function b1(e, t) {
  t = Ea(t), t[0] -= e, Cu(t);
  var n = Hw(-t[1]);
  return ((-t[2] < 0 ? -n : n) + Dn - Fe) % Dn;
}
function fz() {
  var e = Ua([0, 0]), t = Ua(90), n = Ua(6), r, i, a = { point: o };
  function o(c, l) {
    r.push(c = i(c, l)), c[0] *= Et, c[1] *= Et;
  }
  function s() {
    var c = e.apply(this, arguments), l = t.apply(this, arguments) * $e, u = n.apply(this, arguments) * $e;
    return r = [], i = ug(-c[0] * $e, -c[1] * $e, 0).invert, i_(a, l, u, 1), c = { type: "Polygon", coordinates: [r] }, r = i = null, c;
  }
  return s.center = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Ua([+c[0], +c[1]]), s) : e;
  }, s.radius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Ua(+c), s) : t;
  }, s.precision = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Ua(+c), s) : n;
  }, s;
}
function a_() {
  var e = [], t;
  return {
    point: function(n, r) {
      t.push([n, r]);
    },
    lineStart: function() {
      e.push(t = []);
    },
    lineEnd: Dt,
    rejoin: function() {
      e.length > 1 && e.push(e.pop().concat(e.shift()));
    },
    result: function() {
      var n = e;
      return e = [], t = null, n;
    }
  };
}
function jc(e, t) {
  return dt(e[0] - t[0]) < Fe && dt(e[1] - t[1]) < Fe;
}
function dc(e, t, n, r) {
  this.x = e, this.z = t, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function o_(e, t, n, r, i) {
  var a = [], o = [], s, c;
  if (e.forEach(function(m) {
    if (!((y = m.length - 1) <= 0)) {
      var y, v = m[0], w = m[y], I;
      if (jc(v, w)) {
        for (i.lineStart(), s = 0; s < y; ++s) i.point((v = m[s])[0], v[1]);
        i.lineEnd();
        return;
      }
      a.push(I = new dc(v, m, null, !0)), o.push(I.o = new dc(v, null, I, !1)), a.push(I = new dc(w, m, null, !1)), o.push(I.o = new dc(w, null, I, !0));
    }
  }), !!a.length) {
    for (o.sort(t), w1(a), w1(o), s = 0, c = o.length; s < c; ++s)
      o[s].e = n = !n;
    for (var l = a[0], u, d; ; ) {
      for (var f = l, h = !0; f.v; ) if ((f = f.n) === l) return;
      u = f.z, i.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (h)
            for (s = 0, c = u.length; s < c; ++s) i.point((d = u[s])[0], d[1]);
          else
            r(f.x, f.n.x, 1, i);
          f = f.n;
        } else {
          if (h)
            for (u = f.p.z, s = u.length - 1; s >= 0; --s) i.point((d = u[s])[0], d[1]);
          else
            r(f.x, f.p.x, -1, i);
          f = f.p;
        }
        f = f.o, u = f.z, h = !h;
      } while (!f.v);
      i.lineEnd();
    }
  }
}
function w1(e) {
  if (t = e.length) {
    for (var t, n = 0, r = e[0], i; ++n < t; )
      r.n = i = e[n], i.p = r, r = i;
    r.n = i = e[0], i.p = r;
  }
}
var Fd = Xi();
function s_(e, t) {
  var n = t[0], r = t[1], i = [De(n), -Be(n), 0], a = 0, o = 0;
  Fd.reset();
  for (var s = 0, c = e.length; s < c; ++s)
    if (u = (l = e[s]).length)
      for (var l, u, d = l[u - 1], f = d[0], h = d[1] / 2 + vu, m = De(h), y = Be(h), v = 0; v < u; ++v, f = I, m = k, y = g, d = w) {
        var w = l[v], I = w[0], M = w[1] / 2 + vu, k = De(M), g = Be(M), A = I - f, b = A >= 0 ? 1 : -1, x = b * A, _ = x > rt, R = m * k;
        if (Fd.add(kn(R * b * De(x), y * g + R * Be(x))), a += _ ? A + b * Dn : A, _ ^ f >= n ^ I >= n) {
          var P = _o(Ea(d), Ea(w));
          Cu(P);
          var E = _o(i, P);
          Cu(E);
          var C = (_ ^ A >= 0 ? -1 : 1) * Qn(E[2]);
          (r > C || r === C && (P[0] || P[1])) && (o += _ ^ A >= 0 ? 1 : -1);
        }
      }
  return (a < -Fe || a < Fe && Fd < -Fe) ^ o & 1;
}
function l_(e, t, n, r) {
  return function(i) {
    var a = t(i), o = a_(), s = t(o), c = !1, l, u, d, f = {
      point: h,
      lineStart: y,
      lineEnd: v,
      polygonStart: function() {
        f.point = w, f.lineStart = I, f.lineEnd = M, u = [], l = [];
      },
      polygonEnd: function() {
        f.point = h, f.lineStart = y, f.lineEnd = v, u = Bm(u);
        var k = s_(l, r);
        u.length ? (c || (i.polygonStart(), c = !0), o_(u, hz, k, n, i)) : k && (c || (i.polygonStart(), c = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), c && (i.polygonEnd(), c = !1), u = l = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function h(k, g) {
      e(k, g) && i.point(k, g);
    }
    function m(k, g) {
      a.point(k, g);
    }
    function y() {
      f.point = m, a.lineStart();
    }
    function v() {
      f.point = h, a.lineEnd();
    }
    function w(k, g) {
      d.push([k, g]), s.point(k, g);
    }
    function I() {
      s.lineStart(), d = [];
    }
    function M() {
      w(d[0][0], d[0][1]), s.lineEnd();
      var k = s.clean(), g = o.result(), A, b = g.length, x, _, R;
      if (d.pop(), l.push(d), d = null, !!b) {
        if (k & 1) {
          if (_ = g[0], (x = _.length - 1) > 0) {
            for (c || (i.polygonStart(), c = !0), i.lineStart(), A = 0; A < x; ++A) i.point((R = _[A])[0], R[1]);
            i.lineEnd();
          }
          return;
        }
        b > 1 && k & 2 && g.push(g.pop().concat(g.shift())), u.push(g.filter(dz));
      }
    }
    return f;
  };
}
function dz(e) {
  return e.length > 1;
}
function hz(e, t) {
  return ((e = e.x)[0] < 0 ? e[1] - Wt - Fe : Wt - e[1]) - ((t = t.x)[0] < 0 ? t[1] - Wt - Fe : Wt - t[1]);
}
const hp = l_(
  function() {
    return !0;
  },
  pz,
  gz,
  [-rt, -Wt]
);
function pz(e) {
  var t = NaN, n = NaN, r = NaN, i;
  return {
    lineStart: function() {
      e.lineStart(), i = 1;
    },
    point: function(a, o) {
      var s = a > 0 ? rt : -rt, c = dt(a - t);
      dt(c - rt) < Fe ? (e.point(t, n = (n + o) / 2 > 0 ? Wt : -Wt), e.point(r, n), e.lineEnd(), e.lineStart(), e.point(s, n), e.point(a, n), i = 0) : r !== s && c >= rt && (dt(t - r) < Fe && (t -= r * Fe), dt(a - s) < Fe && (a -= s * Fe), n = mz(t, n, a, o), e.point(r, n), e.lineEnd(), e.lineStart(), e.point(s, n), i = 0), e.point(t = a, n = o), r = s;
    },
    lineEnd: function() {
      e.lineEnd(), t = n = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function mz(e, t, n, r) {
  var i, a, o = De(e - n);
  return dt(o) > Fe ? zo((De(t) * (a = Be(r)) * De(n) - De(r) * (i = Be(t)) * De(e)) / (i * a * o)) : (t + r) / 2;
}
function gz(e, t, n, r) {
  var i;
  if (e == null)
    i = n * Wt, r.point(-rt, i), r.point(0, i), r.point(rt, i), r.point(rt, 0), r.point(rt, -i), r.point(0, -i), r.point(-rt, -i), r.point(-rt, 0), r.point(-rt, i);
  else if (dt(e[0] - t[0]) > Fe) {
    var a = e[0] < t[0] ? rt : -rt;
    i = n * a / 2, r.point(-a, i), r.point(0, i), r.point(a, i);
  } else
    r.point(t[0], t[1]);
}
function c_(e) {
  var t = Be(e), n = 6 * $e, r = t > 0, i = dt(t) > Fe;
  function a(u, d, f, h) {
    i_(h, e, n, f, u, d);
  }
  function o(u, d) {
    return Be(u) * Be(d) > t;
  }
  function s(u) {
    var d, f, h, m, y;
    return {
      lineStart: function() {
        m = h = !1, y = 1;
      },
      point: function(v, w) {
        var I = [v, w], M, k = o(v, w), g = r ? k ? 0 : l(v, w) : k ? l(v + (v < 0 ? rt : -rt), w) : 0;
        if (!d && (m = h = k) && u.lineStart(), k !== h && (M = c(d, I), (!M || jc(d, M) || jc(I, M)) && (I[0] += Fe, I[1] += Fe, k = o(I[0], I[1]))), k !== h)
          y = 0, k ? (u.lineStart(), M = c(I, d), u.point(M[0], M[1])) : (M = c(d, I), u.point(M[0], M[1]), u.lineEnd()), d = M;
        else if (i && d && r ^ k) {
          var A;
          !(g & f) && (A = c(I, d, !0)) && (y = 0, r ? (u.lineStart(), u.point(A[0][0], A[0][1]), u.point(A[1][0], A[1][1]), u.lineEnd()) : (u.point(A[1][0], A[1][1]), u.lineEnd(), u.lineStart(), u.point(A[0][0], A[0][1])));
        }
        k && (!d || !jc(d, I)) && u.point(I[0], I[1]), d = I, h = k, f = g;
      },
      lineEnd: function() {
        h && u.lineEnd(), d = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return y | (m && h) << 1;
      }
    };
  }
  function c(u, d, f) {
    var h = Ea(u), m = Ea(d), y = [1, 0, 0], v = _o(h, m), w = uc(v, v), I = v[0], M = w - I * I;
    if (!M) return !f && u;
    var k = t * w / M, g = -t * I / M, A = _o(y, v), b = fc(y, k), x = fc(v, g);
    Bd(b, x);
    var _ = A, R = uc(b, _), P = uc(_, _), E = R * R - P * (uc(b, b) - 1);
    if (!(E < 0)) {
      var C = Jt(E), T = fc(_, (-R - C) / P);
      if (Bd(T, b), T = Su(T), !f) return T;
      var D = u[0], z = d[0], B = u[1], W = d[1], L;
      z < D && (L = D, D = z, z = L);
      var S = z - D, $ = dt(S - rt) < Fe, j = $ || S < Fe;
      if (!$ && W < B && (L = B, B = W, W = L), j ? $ ? B + W > 0 ^ T[1] < (dt(T[0] - D) < Fe ? B : W) : B <= T[1] && T[1] <= W : S > rt ^ (D <= T[0] && T[0] <= z)) {
        var N = fc(_, (-R + C) / P);
        return Bd(N, b), [T, Su(N)];
      }
    }
  }
  function l(u, d) {
    var f = r ? e : rt - e, h = 0;
    return u < -f ? h |= 1 : u > f && (h |= 2), d < -f ? h |= 4 : d > f && (h |= 8), h;
  }
  return l_(o, s, a, r ? [0, -e] : [-rt, e - rt]);
}
function yz(e, t, n, r, i, a) {
  var o = e[0], s = e[1], c = t[0], l = t[1], u = 0, d = 1, f = c - o, h = l - s, m;
  if (m = n - o, !(!f && m > 0)) {
    if (m /= f, f < 0) {
      if (m < u) return;
      m < d && (d = m);
    } else if (f > 0) {
      if (m > d) return;
      m > u && (u = m);
    }
    if (m = i - o, !(!f && m < 0)) {
      if (m /= f, f < 0) {
        if (m > d) return;
        m > u && (u = m);
      } else if (f > 0) {
        if (m < u) return;
        m < d && (d = m);
      }
      if (m = r - s, !(!h && m > 0)) {
        if (m /= h, h < 0) {
          if (m < u) return;
          m < d && (d = m);
        } else if (h > 0) {
          if (m > d) return;
          m > u && (u = m);
        }
        if (m = a - s, !(!h && m < 0)) {
          if (m /= h, h < 0) {
            if (m > d) return;
            m > u && (u = m);
          } else if (h > 0) {
            if (m < u) return;
            m < d && (d = m);
          }
          return u > 0 && (e[0] = o + u * f, e[1] = s + u * h), d < 1 && (t[0] = o + d * f, t[1] = s + d * h), !0;
        }
      }
    }
  }
}
var gs = 1e9, hc = -gs;
function Yf(e, t, n, r) {
  function i(l, u) {
    return e <= l && l <= n && t <= u && u <= r;
  }
  function a(l, u, d, f) {
    var h = 0, m = 0;
    if (l == null || (h = o(l, d)) !== (m = o(u, d)) || c(l, u) < 0 ^ d > 0)
      do
        f.point(h === 0 || h === 3 ? e : n, h > 1 ? r : t);
      while ((h = (h + d + 4) % 4) !== m);
    else
      f.point(u[0], u[1]);
  }
  function o(l, u) {
    return dt(l[0] - e) < Fe ? u > 0 ? 0 : 3 : dt(l[0] - n) < Fe ? u > 0 ? 2 : 1 : dt(l[1] - t) < Fe ? u > 0 ? 1 : 0 : u > 0 ? 3 : 2;
  }
  function s(l, u) {
    return c(l.x, u.x);
  }
  function c(l, u) {
    var d = o(l, 1), f = o(u, 1);
    return d !== f ? d - f : d === 0 ? u[1] - l[1] : d === 1 ? l[0] - u[0] : d === 2 ? l[1] - u[1] : u[0] - l[0];
  }
  return function(l) {
    var u = l, d = a_(), f, h, m, y, v, w, I, M, k, g, A, b = {
      point: x,
      lineStart: E,
      lineEnd: C,
      polygonStart: R,
      polygonEnd: P
    };
    function x(D, z) {
      i(D, z) && u.point(D, z);
    }
    function _() {
      for (var D = 0, z = 0, B = h.length; z < B; ++z)
        for (var W = h[z], L = 1, S = W.length, $ = W[0], j, N, q = $[0], G = $[1]; L < S; ++L)
          j = q, N = G, $ = W[L], q = $[0], G = $[1], N <= r ? G > r && (q - j) * (r - N) > (G - N) * (e - j) && ++D : G <= r && (q - j) * (r - N) < (G - N) * (e - j) && --D;
      return D;
    }
    function R() {
      u = d, f = [], h = [], A = !0;
    }
    function P() {
      var D = _(), z = A && D, B = (f = Bm(f)).length;
      (z || B) && (l.polygonStart(), z && (l.lineStart(), a(null, null, 1, l), l.lineEnd()), B && o_(f, s, D, a, l), l.polygonEnd()), u = l, f = h = m = null;
    }
    function E() {
      b.point = T, h && h.push(m = []), g = !0, k = !1, I = M = NaN;
    }
    function C() {
      f && (T(y, v), w && k && d.rejoin(), f.push(d.result())), b.point = x, k && u.lineEnd();
    }
    function T(D, z) {
      var B = i(D, z);
      if (h && m.push([D, z]), g)
        y = D, v = z, w = B, g = !1, B && (u.lineStart(), u.point(D, z));
      else if (B && k) u.point(D, z);
      else {
        var W = [I = Math.max(hc, Math.min(gs, I)), M = Math.max(hc, Math.min(gs, M))], L = [D = Math.max(hc, Math.min(gs, D)), z = Math.max(hc, Math.min(gs, z))];
        yz(W, L, e, t, n, r) ? (k || (u.lineStart(), u.point(W[0], W[1])), u.point(L[0], L[1]), B || u.lineEnd(), A = !1) : B && (u.lineStart(), u.point(D, z), A = !1);
      }
      I = D, M = z, k = B;
    }
    return b;
  };
}
function Az() {
  var e = 0, t = 0, n = 960, r = 500, i, a, o;
  return o = {
    stream: function(s) {
      return i && a === s ? i : i = Yf(e, t, n, r)(a = s);
    },
    extent: function(s) {
      return arguments.length ? (e = +s[0][0], t = +s[0][1], n = +s[1][0], r = +s[1][1], i = a = null, o) : [[e, t], [n, r]];
    }
  };
}
var pp = Xi(), mp, $c, Wc, So = {
  sphere: Dt,
  point: Dt,
  lineStart: vz,
  lineEnd: Dt,
  polygonStart: Dt,
  polygonEnd: Dt
};
function vz() {
  So.point = bz, So.lineEnd = xz;
}
function xz() {
  So.point = So.lineEnd = Dt;
}
function bz(e, t) {
  e *= $e, t *= $e, mp = e, $c = De(t), Wc = Be(t), So.point = wz;
}
function wz(e, t) {
  e *= $e, t *= $e;
  var n = De(t), r = Be(t), i = dt(e - mp), a = Be(i), o = De(i), s = r * o, c = Wc * n - $c * r * a, l = $c * n + Wc * r * a;
  pp.add(kn(Jt(s * s + c * c), l)), mp = e, $c = n, Wc = r;
}
function u_(e) {
  return pp.reset(), pr(e, So), +pp;
}
var gp = [null, null], _z = { type: "LineString", coordinates: gp };
function Rs(e, t) {
  return gp[0] = e, gp[1] = t, u_(_z);
}
var _1 = {
  Feature: function(e, t) {
    return Ru(e.geometry, t);
  },
  FeatureCollection: function(e, t) {
    for (var n = e.features, r = -1, i = n.length; ++r < i; ) if (Ru(n[r].geometry, t)) return !0;
    return !1;
  }
}, S1 = {
  Sphere: function() {
    return !0;
  },
  Point: function(e, t) {
    return C1(e.coordinates, t);
  },
  MultiPoint: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) if (C1(n[r], t)) return !0;
    return !1;
  },
  LineString: function(e, t) {
    return E1(e.coordinates, t);
  },
  MultiLineString: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) if (E1(n[r], t)) return !0;
    return !1;
  },
  Polygon: function(e, t) {
    return k1(e.coordinates, t);
  },
  MultiPolygon: function(e, t) {
    for (var n = e.coordinates, r = -1, i = n.length; ++r < i; ) if (k1(n[r], t)) return !0;
    return !1;
  },
  GeometryCollection: function(e, t) {
    for (var n = e.geometries, r = -1, i = n.length; ++r < i; ) if (Ru(n[r], t)) return !0;
    return !1;
  }
};
function Ru(e, t) {
  return e && S1.hasOwnProperty(e.type) ? S1[e.type](e, t) : !1;
}
function C1(e, t) {
  return Rs(e, t) === 0;
}
function E1(e, t) {
  var n = Rs(e[0], e[1]), r = Rs(e[0], t), i = Rs(t, e[1]);
  return r + i <= n + Fe;
}
function k1(e, t) {
  return !!s_(e.map(Sz), f_(t));
}
function Sz(e) {
  return e = e.map(f_), e.pop(), e;
}
function f_(e) {
  return [e[0] * $e, e[1] * $e];
}
function Cz(e, t) {
  return (e && _1.hasOwnProperty(e.type) ? _1[e.type] : Ru)(e, t);
}
function T1(e, t, n) {
  var r = yr(e, t - Fe, n).concat(t);
  return function(i) {
    return r.map(function(a) {
      return [i, a];
    });
  };
}
function M1(e, t, n) {
  var r = yr(e, t - Fe, n).concat(t);
  return function(i) {
    return r.map(function(a) {
      return [a, i];
    });
  };
}
function d_() {
  var e, t, n, r, i, a, o, s, c = 10, l = c, u = 90, d = 360, f, h, m, y, v = 2.5;
  function w() {
    return { type: "MultiLineString", coordinates: I() };
  }
  function I() {
    return yr(cc(r / u) * u, n, u).map(m).concat(yr(cc(s / d) * d, o, d).map(y)).concat(yr(cc(t / c) * c, e, c).filter(function(M) {
      return dt(M % u) > Fe;
    }).map(f)).concat(yr(cc(a / l) * l, i, l).filter(function(M) {
      return dt(M % d) > Fe;
    }).map(h));
  }
  return w.lines = function() {
    return I().map(function(M) {
      return { type: "LineString", coordinates: M };
    });
  }, w.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        m(r).concat(
          y(o).slice(1),
          m(n).reverse().slice(1),
          y(s).reverse().slice(1)
        )
      ]
    };
  }, w.extent = function(M) {
    return arguments.length ? w.extentMajor(M).extentMinor(M) : w.extentMinor();
  }, w.extentMajor = function(M) {
    return arguments.length ? (r = +M[0][0], n = +M[1][0], s = +M[0][1], o = +M[1][1], r > n && (M = r, r = n, n = M), s > o && (M = s, s = o, o = M), w.precision(v)) : [[r, s], [n, o]];
  }, w.extentMinor = function(M) {
    return arguments.length ? (t = +M[0][0], e = +M[1][0], a = +M[0][1], i = +M[1][1], t > e && (M = t, t = e, e = M), a > i && (M = a, a = i, i = M), w.precision(v)) : [[t, a], [e, i]];
  }, w.step = function(M) {
    return arguments.length ? w.stepMajor(M).stepMinor(M) : w.stepMinor();
  }, w.stepMajor = function(M) {
    return arguments.length ? (u = +M[0], d = +M[1], w) : [u, d];
  }, w.stepMinor = function(M) {
    return arguments.length ? (c = +M[0], l = +M[1], w) : [c, l];
  }, w.precision = function(M) {
    return arguments.length ? (v = +M, f = T1(a, i, 90), h = M1(t, e, v), m = T1(s, o, 90), y = M1(r, n, v), w) : v;
  }, w.extentMajor([[-180, -90 + Fe], [180, 90 - Fe]]).extentMinor([[-180, -80 - Fe], [180, 80 + Fe]]);
}
function Ez() {
  return d_()();
}
function kz(e, t) {
  var n = e[0] * $e, r = e[1] * $e, i = t[0] * $e, a = t[1] * $e, o = Be(r), s = De(r), c = Be(a), l = De(a), u = o * Be(n), d = o * De(n), f = c * Be(i), h = c * De(i), m = 2 * Qn(Jt(c1(a - r) + o * c * c1(i - n))), y = De(m), v = m ? function(w) {
    var I = De(w *= m) / y, M = De(m - w) / y, k = M * u + I * f, g = M * d + I * h, A = M * s + I * l;
    return [
      kn(g, k) * Et,
      kn(A, Jt(k * k + g * g)) * Et
    ];
  } : function() {
    return [n * Et, r * Et];
  };
  return v.distance = m, v;
}
function va(e) {
  return e;
}
var Yd = Xi(), yp = Xi(), h_, p_, Ap, vp, li = {
  point: Dt,
  lineStart: Dt,
  lineEnd: Dt,
  polygonStart: function() {
    li.lineStart = Tz, li.lineEnd = Iz;
  },
  polygonEnd: function() {
    li.lineStart = li.lineEnd = li.point = Dt, Yd.add(dt(yp)), yp.reset();
  },
  result: function() {
    var e = Yd / 2;
    return Yd.reset(), e;
  }
};
function Tz() {
  li.point = Mz;
}
function Mz(e, t) {
  li.point = m_, h_ = Ap = e, p_ = vp = t;
}
function m_(e, t) {
  yp.add(vp * e - Ap * t), Ap = e, vp = t;
}
function Iz() {
  m_(h_, p_);
}
var Co = 1 / 0, Du = Co, ll = -Co, Pu = ll, Lu = {
  point: Nz,
  lineStart: Dt,
  lineEnd: Dt,
  polygonStart: Dt,
  polygonEnd: Dt,
  result: function() {
    var e = [[Co, Du], [ll, Pu]];
    return ll = Pu = -(Du = Co = 1 / 0), e;
  }
};
function Nz(e, t) {
  e < Co && (Co = e), e > ll && (ll = e), t < Du && (Du = t), t > Pu && (Pu = t);
}
var xp = 0, bp = 0, ys = 0, zu = 0, Bu = 0, Ka = 0, wp = 0, _p = 0, As = 0, g_, y_, Yr, jr, or = {
  point: ka,
  lineStart: I1,
  lineEnd: N1,
  polygonStart: function() {
    or.lineStart = Dz, or.lineEnd = Pz;
  },
  polygonEnd: function() {
    or.point = ka, or.lineStart = I1, or.lineEnd = N1;
  },
  result: function() {
    var e = As ? [wp / As, _p / As] : Ka ? [zu / Ka, Bu / Ka] : ys ? [xp / ys, bp / ys] : [NaN, NaN];
    return xp = bp = ys = zu = Bu = Ka = wp = _p = As = 0, e;
  }
};
function ka(e, t) {
  xp += e, bp += t, ++ys;
}
function I1() {
  or.point = Oz;
}
function Oz(e, t) {
  or.point = Rz, ka(Yr = e, jr = t);
}
function Rz(e, t) {
  var n = e - Yr, r = t - jr, i = Jt(n * n + r * r);
  zu += i * (Yr + e) / 2, Bu += i * (jr + t) / 2, Ka += i, ka(Yr = e, jr = t);
}
function N1() {
  or.point = ka;
}
function Dz() {
  or.point = Lz;
}
function Pz() {
  A_(g_, y_);
}
function Lz(e, t) {
  or.point = A_, ka(g_ = Yr = e, y_ = jr = t);
}
function A_(e, t) {
  var n = e - Yr, r = t - jr, i = Jt(n * n + r * r);
  zu += i * (Yr + e) / 2, Bu += i * (jr + t) / 2, Ka += i, i = jr * e - Yr * t, wp += i * (Yr + e), _p += i * (jr + t), As += i * 3, ka(Yr = e, jr = t);
}
function v_(e) {
  this._context = e;
}
v_.prototype = {
  _radius: 4.5,
  pointRadius: function(e) {
    return this._radius = e, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(e, t) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(e, t), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(e, t);
        break;
      }
      default: {
        this._context.moveTo(e + this._radius, t), this._context.arc(e, t, this._radius, 0, Dn);
        break;
      }
    }
  },
  result: Dt
};
var Sp = Xi(), jd, x_, b_, vs, xs, cl = {
  point: Dt,
  lineStart: function() {
    cl.point = zz;
  },
  lineEnd: function() {
    jd && w_(x_, b_), cl.point = Dt;
  },
  polygonStart: function() {
    jd = !0;
  },
  polygonEnd: function() {
    jd = null;
  },
  result: function() {
    var e = +Sp;
    return Sp.reset(), e;
  }
};
function zz(e, t) {
  cl.point = w_, x_ = vs = e, b_ = xs = t;
}
function w_(e, t) {
  vs -= e, xs -= t, Sp.add(Jt(vs * vs + xs * xs)), vs = e, xs = t;
}
function __() {
  this._string = [];
}
__.prototype = {
  _radius: 4.5,
  _circle: O1(4.5),
  pointRadius: function(e) {
    return (e = +e) !== this._radius && (this._radius = e, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(e, t) {
    switch (this._point) {
      case 0: {
        this._string.push("M", e, ",", t), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", e, ",", t);
        break;
      }
      default: {
        this._circle == null && (this._circle = O1(this._radius)), this._string.push("M", e, ",", t, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var e = this._string.join("");
      return this._string = [], e;
    } else
      return null;
  }
};
function O1(e) {
  return "m0," + e + "a" + e + "," + e + " 0 1,1 0," + -2 * e + "a" + e + "," + e + " 0 1,1 0," + 2 * e + "z";
}
function Bz(e, t) {
  var n = 4.5, r, i;
  function a(o) {
    return o && (typeof n == "function" && i.pointRadius(+n.apply(this, arguments)), pr(o, r(i))), i.result();
  }
  return a.area = function(o) {
    return pr(o, r(li)), li.result();
  }, a.measure = function(o) {
    return pr(o, r(cl)), cl.result();
  }, a.bounds = function(o) {
    return pr(o, r(Lu)), Lu.result();
  }, a.centroid = function(o) {
    return pr(o, r(or)), or.result();
  }, a.projection = function(o) {
    return arguments.length ? (r = o == null ? (e = null, va) : (e = o).stream, a) : e;
  }, a.context = function(o) {
    return arguments.length ? (i = o == null ? (t = null, new __()) : new v_(t = o), typeof n != "function" && i.pointRadius(n), a) : t;
  }, a.pointRadius = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : (i.pointRadius(+o), +o), a) : n;
  }, a.projection(e).context(t);
}
function Fz(e) {
  return {
    stream: Dl(e)
  };
}
function Dl(e) {
  return function(t) {
    var n = new Cp();
    for (var r in e) n[r] = e[r];
    return n.stream = t, n;
  };
}
function Cp() {
}
Cp.prototype = {
  constructor: Cp,
  point: function(e, t) {
    this.stream.point(e, t);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function fg(e, t, n) {
  var r = e.clipExtent && e.clipExtent();
  return e.scale(150).translate([0, 0]), r != null && e.clipExtent(null), pr(n, e.stream(Lu)), t(Lu.result()), r != null && e.clipExtent(r), e;
}
function jf(e, t, n) {
  return fg(e, function(r) {
    var i = t[1][0] - t[0][0], a = t[1][1] - t[0][1], o = Math.min(i / (r[1][0] - r[0][0]), a / (r[1][1] - r[0][1])), s = +t[0][0] + (i - o * (r[1][0] + r[0][0])) / 2, c = +t[0][1] + (a - o * (r[1][1] + r[0][1])) / 2;
    e.scale(150 * o).translate([s, c]);
  }, n);
}
function dg(e, t, n) {
  return jf(e, [[0, 0], t], n);
}
function hg(e, t, n) {
  return fg(e, function(r) {
    var i = +t, a = i / (r[1][0] - r[0][0]), o = (i - a * (r[1][0] + r[0][0])) / 2, s = -a * r[0][1];
    e.scale(150 * a).translate([o, s]);
  }, n);
}
function pg(e, t, n) {
  return fg(e, function(r) {
    var i = +t, a = i / (r[1][1] - r[0][1]), o = -a * r[0][0], s = (i - a * (r[1][1] + r[0][1])) / 2;
    e.scale(150 * a).translate([o, s]);
  }, n);
}
var R1 = 16, Yz = Be(30 * $e);
function D1(e, t) {
  return +t ? $z(e, t) : jz(e);
}
function jz(e) {
  return Dl({
    point: function(t, n) {
      t = e(t, n), this.stream.point(t[0], t[1]);
    }
  });
}
function $z(e, t) {
  function n(r, i, a, o, s, c, l, u, d, f, h, m, y, v) {
    var w = l - r, I = u - i, M = w * w + I * I;
    if (M > 4 * t && y--) {
      var k = o + f, g = s + h, A = c + m, b = Jt(k * k + g * g + A * A), x = Qn(A /= b), _ = dt(dt(A) - 1) < Fe || dt(a - d) < Fe ? (a + d) / 2 : kn(g, k), R = e(_, x), P = R[0], E = R[1], C = P - r, T = E - i, D = I * C - w * T;
      (D * D / M > t || dt((w * C + I * T) / M - 0.5) > 0.3 || o * f + s * h + c * m < Yz) && (n(r, i, a, o, s, c, P, E, _, k /= b, g /= b, A, y, v), v.point(P, E), n(P, E, _, k, g, A, l, u, d, f, h, m, y, v));
    }
  }
  return function(r) {
    var i, a, o, s, c, l, u, d, f, h, m, y, v = {
      point: w,
      lineStart: I,
      lineEnd: k,
      polygonStart: function() {
        r.polygonStart(), v.lineStart = g;
      },
      polygonEnd: function() {
        r.polygonEnd(), v.lineStart = I;
      }
    };
    function w(x, _) {
      x = e(x, _), r.point(x[0], x[1]);
    }
    function I() {
      d = NaN, v.point = M, r.lineStart();
    }
    function M(x, _) {
      var R = Ea([x, _]), P = e(x, _);
      n(d, f, u, h, m, y, d = P[0], f = P[1], u = x, h = R[0], m = R[1], y = R[2], R1, r), r.point(d, f);
    }
    function k() {
      v.point = w, r.lineEnd();
    }
    function g() {
      I(), v.point = A, v.lineEnd = b;
    }
    function A(x, _) {
      M(i = x, _), a = d, o = f, s = h, c = m, l = y, v.point = M;
    }
    function b() {
      n(d, f, u, h, m, y, a, o, i, s, c, l, R1, r), v.lineEnd = k, k();
    }
    return v;
  };
}
var Wz = Dl({
  point: function(e, t) {
    this.stream.point(e * $e, t * $e);
  }
});
function Uz(e) {
  return Dl({
    point: function(t, n) {
      var r = e(t, n);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function Si(e) {
  return mg(function() {
    return e;
  })();
}
function mg(e) {
  var t, n = 150, r = 480, i = 250, a, o, s = 0, c = 0, l = 0, u = 0, d = 0, f, h, m = null, y = hp, v = null, w, I, M, k = va, g = 0.5, A = D1(P, g), b, x;
  function _(T) {
    return T = h(T[0] * $e, T[1] * $e), [T[0] * n + a, o - T[1] * n];
  }
  function R(T) {
    return T = h.invert((T[0] - a) / n, (o - T[1]) / n), T && [T[0] * Et, T[1] * Et];
  }
  function P(T, D) {
    return T = t(T, D), [T[0] * n + a, o - T[1] * n];
  }
  _.stream = function(T) {
    return b && x === T ? b : b = Wz(Uz(f)(y(A(k(x = T)))));
  }, _.preclip = function(T) {
    return arguments.length ? (y = T, m = void 0, C()) : y;
  }, _.postclip = function(T) {
    return arguments.length ? (k = T, v = w = I = M = null, C()) : k;
  }, _.clipAngle = function(T) {
    return arguments.length ? (y = +T ? c_(m = T * $e) : (m = null, hp), C()) : m * Et;
  }, _.clipExtent = function(T) {
    return arguments.length ? (k = T == null ? (v = w = I = M = null, va) : Yf(v = +T[0][0], w = +T[0][1], I = +T[1][0], M = +T[1][1]), C()) : v == null ? null : [[v, w], [I, M]];
  }, _.scale = function(T) {
    return arguments.length ? (n = +T, E()) : n;
  }, _.translate = function(T) {
    return arguments.length ? (r = +T[0], i = +T[1], E()) : [r, i];
  }, _.center = function(T) {
    return arguments.length ? (s = T[0] % 360 * $e, c = T[1] % 360 * $e, E()) : [s * Et, c * Et];
  }, _.rotate = function(T) {
    return arguments.length ? (l = T[0] % 360 * $e, u = T[1] % 360 * $e, d = T.length > 2 ? T[2] % 360 * $e : 0, E()) : [l * Et, u * Et, d * Et];
  }, _.precision = function(T) {
    return arguments.length ? (A = D1(P, g = T * T), C()) : Jt(g);
  }, _.fitExtent = function(T, D) {
    return jf(_, T, D);
  }, _.fitSize = function(T, D) {
    return dg(_, T, D);
  }, _.fitWidth = function(T, D) {
    return hg(_, T, D);
  }, _.fitHeight = function(T, D) {
    return pg(_, T, D);
  };
  function E() {
    h = n_(f = ug(l, u, d), t);
    var T = t(s, c);
    return a = r - T[0] * n, o = i + T[1] * n, C();
  }
  function C() {
    return b = x = null, _;
  }
  return function() {
    return t = e.apply(this, arguments), _.invert = t.invert && R, E();
  };
}
function gg(e) {
  var t = 0, n = rt / 3, r = mg(e), i = r(t, n);
  return i.parallels = function(a) {
    return arguments.length ? r(t = a[0] * $e, n = a[1] * $e) : [t * Et, n * Et];
  }, i;
}
function Hz(e) {
  var t = Be(e);
  function n(r, i) {
    return [r * t, De(i) / t];
  }
  return n.invert = function(r, i) {
    return [r / t, Qn(i * t)];
  }, n;
}
function S_(e, t) {
  var n = De(e), r = (n + De(t)) / 2;
  if (dt(r) < Fe) return Hz(e);
  var i = 1 + n * (2 * r - n), a = Jt(i) / r;
  function o(s, c) {
    var l = Jt(i - 2 * r * De(c)) / r;
    return [l * De(s *= r), a - l * Be(s)];
  }
  return o.invert = function(s, c) {
    var l = a - c;
    return [kn(s, dt(l)) / r * sl(l), Qn((i - (s * s + l * l) * r * r) / (2 * r))];
  }, o;
}
function Fu() {
  return gg(S_).scale(155.424).center([0, 33.6442]);
}
function C_() {
  return Fu().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function Gz(e) {
  var t = e.length;
  return {
    point: function(n, r) {
      for (var i = -1; ++i < t; ) e[i].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < t; ) e[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < t; ) e[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < t; ) e[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < t; ) e[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < t; ) e[n].polygonEnd();
    }
  };
}
function Vz() {
  var e, t, n = C_(), r, i = Fu().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), a, o = Fu().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), s, c, l = { point: function(f, h) {
    c = [f, h];
  } };
  function u(f) {
    var h = f[0], m = f[1];
    return c = null, r.point(h, m), c || (a.point(h, m), c) || (s.point(h, m), c);
  }
  u.invert = function(f) {
    var h = n.scale(), m = n.translate(), y = (f[0] - m[0]) / h, v = (f[1] - m[1]) / h;
    return (v >= 0.12 && v < 0.234 && y >= -0.425 && y < -0.214 ? i : v >= 0.166 && v < 0.234 && y >= -0.214 && y < -0.115 ? o : n).invert(f);
  }, u.stream = function(f) {
    return e && t === f ? e : e = Gz([n.stream(t = f), i.stream(f), o.stream(f)]);
  }, u.precision = function(f) {
    return arguments.length ? (n.precision(f), i.precision(f), o.precision(f), d()) : n.precision();
  }, u.scale = function(f) {
    return arguments.length ? (n.scale(f), i.scale(f * 0.35), o.scale(f), u.translate(n.translate())) : n.scale();
  }, u.translate = function(f) {
    if (!arguments.length) return n.translate();
    var h = n.scale(), m = +f[0], y = +f[1];
    return r = n.translate(f).clipExtent([[m - 0.455 * h, y - 0.238 * h], [m + 0.455 * h, y + 0.238 * h]]).stream(l), a = i.translate([m - 0.307 * h, y + 0.201 * h]).clipExtent([[m - 0.425 * h + Fe, y + 0.12 * h + Fe], [m - 0.214 * h - Fe, y + 0.234 * h - Fe]]).stream(l), s = o.translate([m - 0.205 * h, y + 0.212 * h]).clipExtent([[m - 0.214 * h + Fe, y + 0.166 * h + Fe], [m - 0.115 * h - Fe, y + 0.234 * h - Fe]]).stream(l), d();
  }, u.fitExtent = function(f, h) {
    return jf(u, f, h);
  }, u.fitSize = function(f, h) {
    return dg(u, f, h);
  }, u.fitWidth = function(f, h) {
    return hg(u, f, h);
  }, u.fitHeight = function(f, h) {
    return pg(u, f, h);
  };
  function d() {
    return e = t = null, u;
  }
  return u.scale(1070);
}
function E_(e) {
  return function(t, n) {
    var r = Be(t), i = Be(n), a = e(r * i);
    return [
      a * i * De(t),
      a * De(n)
    ];
  };
}
function Pl(e) {
  return function(t, n) {
    var r = Jt(t * t + n * n), i = e(r), a = De(i), o = Be(i);
    return [
      kn(t * a, r * o),
      Qn(r && n * a / r)
    ];
  };
}
var yg = E_(function(e) {
  return Jt(2 / (1 + e));
});
yg.invert = Pl(function(e) {
  return 2 * Qn(e / 2);
});
function Qz() {
  return Si(yg).scale(124.75).clipAngle(180 - 1e-3);
}
var Ag = E_(function(e) {
  return (e = Hw(e)) && e / De(e);
});
Ag.invert = Pl(function(e) {
  return e;
});
function qz() {
  return Si(Ag).scale(79.4188).clipAngle(180 - 1e-3);
}
function Ll(e, t) {
  return [e, xu(lg((Wt + t) / 2))];
}
Ll.invert = function(e, t) {
  return [e, 2 * zo(Uw(t)) - Wt];
};
function Xz() {
  return k_(Ll).scale(961 / Dn);
}
function k_(e) {
  var t = Si(e), n = t.center, r = t.scale, i = t.translate, a = t.clipExtent, o = null, s, c, l;
  t.scale = function(d) {
    return arguments.length ? (r(d), u()) : r();
  }, t.translate = function(d) {
    return arguments.length ? (i(d), u()) : i();
  }, t.center = function(d) {
    return arguments.length ? (n(d), u()) : n();
  }, t.clipExtent = function(d) {
    return arguments.length ? (d == null ? o = s = c = l = null : (o = +d[0][0], s = +d[0][1], c = +d[1][0], l = +d[1][1]), u()) : o == null ? null : [[o, s], [c, l]];
  };
  function u() {
    var d = rt * r(), f = t(r_(t.rotate()).invert([0, 0]));
    return a(o == null ? [[f[0] - d, f[1] - d], [f[0] + d, f[1] + d]] : e === Ll ? [[Math.max(f[0] - d, o), s], [Math.min(f[0] + d, c), l]] : [[o, Math.max(f[1] - d, s)], [c, Math.min(f[1] + d, l)]]);
  }
  return u();
}
function pc(e) {
  return lg((Wt + e) / 2);
}
function T_(e, t) {
  var n = Be(e), r = e === t ? De(e) : xu(n / Be(t)) / xu(pc(t) / pc(e)), i = n * zd(pc(e), r) / r;
  if (!r) return Ll;
  function a(o, s) {
    i > 0 ? s < -Wt + Fe && (s = -Wt + Fe) : s > Wt - Fe && (s = Wt - Fe);
    var c = i / zd(pc(s), r);
    return [c * De(r * o), i - c * Be(r * o)];
  }
  return a.invert = function(o, s) {
    var c = i - s, l = sl(r) * Jt(o * o + c * c);
    return [kn(o, dt(c)) / r * sl(c), 2 * zo(zd(i / l, 1 / r)) - Wt];
  }, a;
}
function Jz() {
  return gg(T_).scale(109.5).parallels([30, 30]);
}
function ul(e, t) {
  return [e, t];
}
ul.invert = ul;
function Kz() {
  return Si(ul).scale(152.63);
}
function M_(e, t) {
  var n = Be(e), r = e === t ? De(e) : (n - Be(t)) / (t - e), i = n / r + e;
  if (dt(r) < Fe) return ul;
  function a(o, s) {
    var c = i - s, l = r * o;
    return [c * De(l), i - c * Be(l)];
  }
  return a.invert = function(o, s) {
    var c = i - s;
    return [kn(o, dt(c)) / r * sl(c), i - sl(r) * Jt(o * o + c * c)];
  }, a;
}
function Zz() {
  return gg(M_).scale(131.154).center([0, 13.9389]);
}
function vg(e, t) {
  var n = Be(t), r = Be(e) * n;
  return [n * De(e) / r, De(t) / r];
}
vg.invert = Pl(zo);
function e6() {
  return Si(vg).scale(144.049).clipAngle(60);
}
function mc(e, t, n, r) {
  return e === 1 && t === 1 && n === 0 && r === 0 ? va : Dl({
    point: function(i, a) {
      this.stream.point(i * e + n, a * t + r);
    }
  });
}
function t6() {
  var e = 1, t = 0, n = 0, r = 1, i = 1, a = va, o = null, s, c, l, u = va, d, f, h;
  function m() {
    return d = f = null, h;
  }
  return h = {
    stream: function(y) {
      return d && f === y ? d : d = a(u(f = y));
    },
    postclip: function(y) {
      return arguments.length ? (u = y, o = s = c = l = null, m()) : u;
    },
    clipExtent: function(y) {
      return arguments.length ? (u = y == null ? (o = s = c = l = null, va) : Yf(o = +y[0][0], s = +y[0][1], c = +y[1][0], l = +y[1][1]), m()) : o == null ? null : [[o, s], [c, l]];
    },
    scale: function(y) {
      return arguments.length ? (a = mc((e = +y) * r, e * i, t, n), m()) : e;
    },
    translate: function(y) {
      return arguments.length ? (a = mc(e * r, e * i, t = +y[0], n = +y[1]), m()) : [t, n];
    },
    reflectX: function(y) {
      return arguments.length ? (a = mc(e * (r = y ? -1 : 1), e * i, t, n), m()) : r < 0;
    },
    reflectY: function(y) {
      return arguments.length ? (a = mc(e * r, e * (i = y ? -1 : 1), t, n), m()) : i < 0;
    },
    fitExtent: function(y, v) {
      return jf(h, y, v);
    },
    fitSize: function(y, v) {
      return dg(h, y, v);
    },
    fitWidth: function(y, v) {
      return hg(h, y, v);
    },
    fitHeight: function(y, v) {
      return pg(h, y, v);
    }
  };
}
function xg(e, t) {
  var n = t * t, r = n * n;
  return [
    e * (0.8707 - 0.131979 * n + r * (-0.013791 + r * (3971e-6 * n - 1529e-6 * r))),
    t * (1.007226 + n * (0.015085 + r * (-0.044475 + 0.028874 * n - 5916e-6 * r)))
  ];
}
xg.invert = function(e, t) {
  var n = t, r = 25, i;
  do {
    var a = n * n, o = a * a;
    n -= i = (n * (1.007226 + a * (0.015085 + o * (-0.044475 + 0.028874 * a - 5916e-6 * o))) - t) / (1.007226 + a * (0.015085 * 3 + o * (-0.044475 * 7 + 0.028874 * 9 * a - 5916e-6 * 11 * o)));
  } while (dt(i) > Fe && --r > 0);
  return [
    e / (0.8707 + (a = n * n) * (-0.131979 + a * (-0.013791 + a * a * a * (3971e-6 - 1529e-6 * a)))),
    n
  ];
};
function n6() {
  return Si(xg).scale(175.295);
}
function bg(e, t) {
  return [Be(t) * De(e), De(t)];
}
bg.invert = Pl(Qn);
function r6() {
  return Si(bg).scale(249.5).clipAngle(90 + Fe);
}
function wg(e, t) {
  var n = Be(t), r = 1 + Be(e) * n;
  return [n * De(e) / r, De(t) / r];
}
wg.invert = Pl(function(e) {
  return 2 * zo(e);
});
function i6() {
  return Si(wg).scale(250).clipAngle(142);
}
function _g(e, t) {
  return [xu(lg((Wt + t) / 2)), -e];
}
_g.invert = function(e, t) {
  return [-t, 2 * zo(Uw(e)) - Wt];
};
function a6() {
  var e = k_(_g), t = e.center, n = e.rotate;
  return e.center = function(r) {
    return arguments.length ? t([-r[1], r[0]]) : (r = t(), [r[1], -r[0]]);
  }, e.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
function o6(e, t) {
  return e.parent === t.parent ? 1 : 2;
}
function s6(e) {
  return e.reduce(l6, 0) / e.length;
}
function l6(e, t) {
  return e + t.x;
}
function c6(e) {
  return 1 + e.reduce(u6, 0);
}
function u6(e, t) {
  return Math.max(e, t.y);
}
function f6(e) {
  for (var t; t = e.children; ) e = t[0];
  return e;
}
function d6(e) {
  for (var t; t = e.children; ) e = t[t.length - 1];
  return e;
}
function h6() {
  var e = o6, t = 1, n = 1, r = !1;
  function i(a) {
    var o, s = 0;
    a.eachAfter(function(f) {
      var h = f.children;
      h ? (f.x = s6(h), f.y = c6(h)) : (f.x = o ? s += e(f, o) : 0, f.y = 0, o = f);
    });
    var c = f6(a), l = d6(a), u = c.x - e(c, l) / 2, d = l.x + e(l, c) / 2;
    return a.eachAfter(r ? function(f) {
      f.x = (f.x - a.x) * t, f.y = (a.y - f.y) * n;
    } : function(f) {
      f.x = (f.x - u) / (d - u) * t, f.y = (1 - (a.y ? f.y / a.y : 1)) * n;
    });
  }
  return i.separation = function(a) {
    return arguments.length ? (e = a, i) : e;
  }, i.size = function(a) {
    return arguments.length ? (r = !1, t = +a[0], n = +a[1], i) : r ? null : [t, n];
  }, i.nodeSize = function(a) {
    return arguments.length ? (r = !0, t = +a[0], n = +a[1], i) : r ? [t, n] : null;
  }, i;
}
function p6(e) {
  var t = 0, n = e.children, r = n && n.length;
  if (!r) t = 1;
  else for (; --r >= 0; ) t += n[r].value;
  e.value = t;
}
function m6() {
  return this.eachAfter(p6);
}
function g6(e) {
  var t = this, n, r = [t], i, a, o;
  do
    for (n = r.reverse(), r = []; t = n.pop(); )
      if (e(t), i = t.children, i) for (a = 0, o = i.length; a < o; ++a)
        r.push(i[a]);
  while (r.length);
  return this;
}
function y6(e) {
  for (var t = this, n = [t], r, i; t = n.pop(); )
    if (e(t), r = t.children, r) for (i = r.length - 1; i >= 0; --i)
      n.push(r[i]);
  return this;
}
function A6(e) {
  for (var t = this, n = [t], r = [], i, a, o; t = n.pop(); )
    if (r.push(t), i = t.children, i) for (a = 0, o = i.length; a < o; ++a)
      n.push(i[a]);
  for (; t = r.pop(); )
    e(t);
  return this;
}
function v6(e) {
  return this.eachAfter(function(t) {
    for (var n = +e(t.data) || 0, r = t.children, i = r && r.length; --i >= 0; ) n += r[i].value;
    t.value = n;
  });
}
function x6(e) {
  return this.eachBefore(function(t) {
    t.children && t.children.sort(e);
  });
}
function b6(e) {
  for (var t = this, n = w6(t, e), r = [t]; t !== n; )
    t = t.parent, r.push(t);
  for (var i = r.length; e !== n; )
    r.splice(i, 0, e), e = e.parent;
  return r;
}
function w6(e, t) {
  if (e === t) return e;
  var n = e.ancestors(), r = t.ancestors(), i = null;
  for (e = n.pop(), t = r.pop(); e === t; )
    i = e, e = n.pop(), t = r.pop();
  return i;
}
function _6() {
  for (var e = this, t = [e]; e = e.parent; )
    t.push(e);
  return t;
}
function S6() {
  var e = [];
  return this.each(function(t) {
    e.push(t);
  }), e;
}
function C6() {
  var e = [];
  return this.eachBefore(function(t) {
    t.children || e.push(t);
  }), e;
}
function E6() {
  var e = this, t = [];
  return e.each(function(n) {
    n !== e && t.push({ source: n.parent, target: n });
  }), t;
}
function $f(e, t) {
  var n = new Eo(e), r = +e.value && (n.value = e.value), i, a = [n], o, s, c, l;
  for (t == null && (t = T6); i = a.pop(); )
    if (r && (i.value = +i.data.value), (s = t(i.data)) && (l = s.length))
      for (i.children = new Array(l), c = l - 1; c >= 0; --c)
        a.push(o = i.children[c] = new Eo(s[c])), o.parent = i, o.depth = i.depth + 1;
  return n.eachBefore(I_);
}
function k6() {
  return $f(this).eachBefore(M6);
}
function T6(e) {
  return e.children;
}
function M6(e) {
  e.data = e.data.data;
}
function I_(e) {
  var t = 0;
  do
    e.height = t;
  while ((e = e.parent) && e.height < ++t);
}
function Eo(e) {
  this.data = e, this.depth = this.height = 0, this.parent = null;
}
Eo.prototype = $f.prototype = {
  constructor: Eo,
  count: m6,
  each: g6,
  eachAfter: A6,
  eachBefore: y6,
  sum: v6,
  sort: x6,
  path: b6,
  ancestors: _6,
  descendants: S6,
  leaves: C6,
  links: E6,
  copy: k6
};
var I6 = Array.prototype.slice;
function N6(e) {
  for (var t = e.length, n, r; t; )
    r = Math.random() * t-- | 0, n = e[t], e[t] = e[r], e[r] = n;
  return e;
}
function N_(e) {
  for (var t = 0, n = (e = N6(I6.call(e))).length, r = [], i, a; t < n; )
    i = e[t], a && O_(a, i) ? ++t : (a = R6(r = O6(r, i)), t = 0);
  return a;
}
function O6(e, t) {
  var n, r;
  if ($d(t, e)) return [t];
  for (n = 0; n < e.length; ++n)
    if (gc(t, e[n]) && $d(bs(e[n], t), e))
      return [e[n], t];
  for (n = 0; n < e.length - 1; ++n)
    for (r = n + 1; r < e.length; ++r)
      if (gc(bs(e[n], e[r]), t) && gc(bs(e[n], t), e[r]) && gc(bs(e[r], t), e[n]) && $d(R_(e[n], e[r], t), e))
        return [e[n], e[r], t];
  throw new Error();
}
function gc(e, t) {
  var n = e.r - t.r, r = t.x - e.x, i = t.y - e.y;
  return n < 0 || n * n < r * r + i * i;
}
function O_(e, t) {
  var n = e.r - t.r + 1e-6, r = t.x - e.x, i = t.y - e.y;
  return n > 0 && n * n > r * r + i * i;
}
function $d(e, t) {
  for (var n = 0; n < t.length; ++n)
    if (!O_(e, t[n]))
      return !1;
  return !0;
}
function R6(e) {
  switch (e.length) {
    case 1:
      return D6(e[0]);
    case 2:
      return bs(e[0], e[1]);
    case 3:
      return R_(e[0], e[1], e[2]);
  }
}
function D6(e) {
  return {
    x: e.x,
    y: e.y,
    r: e.r
  };
}
function bs(e, t) {
  var n = e.x, r = e.y, i = e.r, a = t.x, o = t.y, s = t.r, c = a - n, l = o - r, u = s - i, d = Math.sqrt(c * c + l * l);
  return {
    x: (n + a + c / d * u) / 2,
    y: (r + o + l / d * u) / 2,
    r: (d + i + s) / 2
  };
}
function R_(e, t, n) {
  var r = e.x, i = e.y, a = e.r, o = t.x, s = t.y, c = t.r, l = n.x, u = n.y, d = n.r, f = r - o, h = r - l, m = i - s, y = i - u, v = c - a, w = d - a, I = r * r + i * i - a * a, M = I - o * o - s * s + c * c, k = I - l * l - u * u + d * d, g = h * m - f * y, A = (m * k - y * M) / (g * 2) - r, b = (y * v - m * w) / g, x = (h * M - f * k) / (g * 2) - i, _ = (f * w - h * v) / g, R = b * b + _ * _ - 1, P = 2 * (a + A * b + x * _), E = A * A + x * x - a * a, C = -(R ? (P + Math.sqrt(P * P - 4 * R * E)) / (2 * R) : E / P);
  return {
    x: r + A + b * C,
    y: i + x + _ * C,
    r: C
  };
}
function P1(e, t, n) {
  var r = e.x, i = e.y, a = t.r + n.r, o = e.r + n.r, s = t.x - r, c = t.y - i, l = s * s + c * c;
  if (l) {
    var u = 0.5 + ((o *= o) - (a *= a)) / (2 * l), d = Math.sqrt(Math.max(0, 2 * a * (o + l) - (o -= l) * o - a * a)) / (2 * l);
    n.x = r + u * s + d * c, n.y = i + u * c - d * s;
  } else
    n.x = r + o, n.y = i;
}
function L1(e, t) {
  var n = t.x - e.x, r = t.y - e.y, i = e.r + t.r;
  return i * i - 1e-6 > n * n + r * r;
}
function z1(e) {
  var t = e._, n = e.next._, r = t.r + n.r, i = (t.x * n.r + n.x * t.r) / r, a = (t.y * n.r + n.y * t.r) / r;
  return i * i + a * a;
}
function yc(e) {
  this._ = e, this.next = null, this.previous = null;
}
function D_(e) {
  if (!(i = e.length)) return 0;
  var t, n, r, i, a, o, s, c, l, u, d;
  if (t = e[0], t.x = 0, t.y = 0, !(i > 1)) return t.r;
  if (n = e[1], t.x = -n.r, n.x = t.r, n.y = 0, !(i > 2)) return t.r + n.r;
  P1(n, t, r = e[2]), t = new yc(t), n = new yc(n), r = new yc(r), t.next = r.previous = n, n.next = t.previous = r, r.next = n.previous = t;
  e: for (s = 3; s < i; ++s) {
    P1(t._, n._, r = e[s]), r = new yc(r), c = n.next, l = t.previous, u = n._.r, d = t._.r;
    do
      if (u <= d) {
        if (L1(c._, r._)) {
          n = c, t.next = n, n.previous = t, --s;
          continue e;
        }
        u += c._.r, c = c.next;
      } else {
        if (L1(l._, r._)) {
          t = l, t.next = n, n.previous = t, --s;
          continue e;
        }
        d += l._.r, l = l.previous;
      }
    while (c !== l.next);
    for (r.previous = t, r.next = n, t.next = n.previous = n = r, a = z1(t); (r = r.next) !== n; )
      (o = z1(r)) < a && (t = r, a = o);
    n = t.next;
  }
  for (t = [n._], r = n; (r = r.next) !== n; ) t.push(r._);
  for (r = N_(t), s = 0; s < i; ++s) t = e[s], t.x -= r.x, t.y -= r.y;
  return r.r;
}
function P6(e) {
  return D_(e), e;
}
function L6(e) {
  return e == null ? null : Yu(e);
}
function Yu(e) {
  if (typeof e != "function") throw new Error();
  return e;
}
function da() {
  return 0;
}
function Xa(e) {
  return function() {
    return e;
  };
}
function z6(e) {
  return Math.sqrt(e.value);
}
function B6() {
  var e = null, t = 1, n = 1, r = da;
  function i(a) {
    return a.x = t / 2, a.y = n / 2, e ? a.eachBefore(B1(e)).eachAfter(Wd(r, 0.5)).eachBefore(F1(1)) : a.eachBefore(B1(z6)).eachAfter(Wd(da, 1)).eachAfter(Wd(r, a.r / Math.min(t, n))).eachBefore(F1(Math.min(t, n) / (2 * a.r))), a;
  }
  return i.radius = function(a) {
    return arguments.length ? (e = L6(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = +a[0], n = +a[1], i) : [t, n];
  }, i.padding = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Xa(+a), i) : r;
  }, i;
}
function B1(e) {
  return function(t) {
    t.children || (t.r = Math.max(0, +e(t) || 0));
  };
}
function Wd(e, t) {
  return function(n) {
    if (r = n.children) {
      var r, i, a = r.length, o = e(n) * t || 0, s;
      if (o) for (i = 0; i < a; ++i) r[i].r += o;
      if (s = D_(r), o) for (i = 0; i < a; ++i) r[i].r -= o;
      n.r = s + o;
    }
  };
}
function F1(e) {
  return function(t) {
    var n = t.parent;
    t.r *= e, n && (t.x = n.x + e * t.x, t.y = n.y + e * t.y);
  };
}
function P_(e) {
  e.x0 = Math.round(e.x0), e.y0 = Math.round(e.y0), e.x1 = Math.round(e.x1), e.y1 = Math.round(e.y1);
}
function zl(e, t, n, r, i) {
  for (var a = e.children, o, s = -1, c = a.length, l = e.value && (r - t) / e.value; ++s < c; )
    o = a[s], o.y0 = n, o.y1 = i, o.x0 = t, o.x1 = t += o.value * l;
}
function F6() {
  var e = 1, t = 1, n = 0, r = !1;
  function i(o) {
    var s = o.height + 1;
    return o.x0 = o.y0 = n, o.x1 = e, o.y1 = t / s, o.eachBefore(a(t, s)), r && o.eachBefore(P_), o;
  }
  function a(o, s) {
    return function(c) {
      c.children && zl(c, c.x0, o * (c.depth + 1) / s, c.x1, o * (c.depth + 2) / s);
      var l = c.x0, u = c.y0, d = c.x1 - n, f = c.y1 - n;
      d < l && (l = d = (l + d) / 2), f < u && (u = f = (u + f) / 2), c.x0 = l, c.y0 = u, c.x1 = d, c.y1 = f;
    };
  }
  return i.round = function(o) {
    return arguments.length ? (r = !!o, i) : r;
  }, i.size = function(o) {
    return arguments.length ? (e = +o[0], t = +o[1], i) : [e, t];
  }, i.padding = function(o) {
    return arguments.length ? (n = +o, i) : n;
  }, i;
}
var Y1 = "$", Y6 = { depth: -1 }, j1 = {};
function j6(e) {
  return e.id;
}
function $6(e) {
  return e.parentId;
}
function W6() {
  var e = j6, t = $6;
  function n(r) {
    var i, a, o = r.length, s, c, l, u = new Array(o), d, f, h = {};
    for (a = 0; a < o; ++a)
      i = r[a], l = u[a] = new Eo(i), (d = e(i, a, r)) != null && (d += "") && (f = Y1 + (l.id = d), h[f] = f in h ? j1 : l);
    for (a = 0; a < o; ++a)
      if (l = u[a], d = t(r[a], a, r), d == null || !(d += "")) {
        if (s) throw new Error("multiple roots");
        s = l;
      } else {
        if (c = h[Y1 + d], !c) throw new Error("missing: " + d);
        if (c === j1) throw new Error("ambiguous: " + d);
        c.children ? c.children.push(l) : c.children = [l], l.parent = c;
      }
    if (!s) throw new Error("no root");
    if (s.parent = Y6, s.eachBefore(function(m) {
      m.depth = m.parent.depth + 1, --o;
    }).eachBefore(I_), s.parent = null, o > 0) throw new Error("cycle");
    return s;
  }
  return n.id = function(r) {
    return arguments.length ? (e = Yu(r), n) : e;
  }, n.parentId = function(r) {
    return arguments.length ? (t = Yu(r), n) : t;
  }, n;
}
function U6(e, t) {
  return e.parent === t.parent ? 1 : 2;
}
function Ud(e) {
  var t = e.children;
  return t ? t[0] : e.t;
}
function Hd(e) {
  var t = e.children;
  return t ? t[t.length - 1] : e.t;
}
function H6(e, t, n) {
  var r = n / (t.i - e.i);
  t.c -= r, t.s += n, e.c += r, t.z += n, t.m += n;
}
function G6(e) {
  for (var t = 0, n = 0, r = e.children, i = r.length, a; --i >= 0; )
    a = r[i], a.z += t, a.m += t, t += a.s + (n += a.c);
}
function V6(e, t, n) {
  return e.a.parent === t.parent ? e.a : n;
}
function Uc(e, t) {
  this._ = e, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = t;
}
Uc.prototype = Object.create(Eo.prototype);
function Q6(e) {
  for (var t = new Uc(e, 0), n, r = [t], i, a, o, s; n = r.pop(); )
    if (a = n._.children)
      for (n.children = new Array(s = a.length), o = s - 1; o >= 0; --o)
        r.push(i = n.children[o] = new Uc(a[o], o)), i.parent = n;
  return (t.parent = new Uc(null, 0)).children = [t], t;
}
function q6() {
  var e = U6, t = 1, n = 1, r = null;
  function i(l) {
    var u = Q6(l);
    if (u.eachAfter(a), u.parent.m = -u.z, u.eachBefore(o), r) l.eachBefore(c);
    else {
      var d = l, f = l, h = l;
      l.eachBefore(function(I) {
        I.x < d.x && (d = I), I.x > f.x && (f = I), I.depth > h.depth && (h = I);
      });
      var m = d === f ? 1 : e(d, f) / 2, y = m - d.x, v = t / (f.x + m + y), w = n / (h.depth || 1);
      l.eachBefore(function(I) {
        I.x = (I.x + y) * v, I.y = I.depth * w;
      });
    }
    return l;
  }
  function a(l) {
    var u = l.children, d = l.parent.children, f = l.i ? d[l.i - 1] : null;
    if (u) {
      G6(l);
      var h = (u[0].z + u[u.length - 1].z) / 2;
      f ? (l.z = f.z + e(l._, f._), l.m = l.z - h) : l.z = h;
    } else f && (l.z = f.z + e(l._, f._));
    l.parent.A = s(l, f, l.parent.A || d[0]);
  }
  function o(l) {
    l._.x = l.z + l.parent.m, l.m += l.parent.m;
  }
  function s(l, u, d) {
    if (u) {
      for (var f = l, h = l, m = u, y = f.parent.children[0], v = f.m, w = h.m, I = m.m, M = y.m, k; m = Hd(m), f = Ud(f), m && f; )
        y = Ud(y), h = Hd(h), h.a = l, k = m.z + I - f.z - v + e(m._, f._), k > 0 && (H6(V6(m, l, d), l, k), v += k, w += k), I += m.m, v += f.m, M += y.m, w += h.m;
      m && !Hd(h) && (h.t = m, h.m += I - w), f && !Ud(y) && (y.t = f, y.m += v - M, d = l);
    }
    return d;
  }
  function c(l) {
    l.x *= t, l.y = l.depth * n;
  }
  return i.separation = function(l) {
    return arguments.length ? (e = l, i) : e;
  }, i.size = function(l) {
    return arguments.length ? (r = !1, t = +l[0], n = +l[1], i) : r ? null : [t, n];
  }, i.nodeSize = function(l) {
    return arguments.length ? (r = !0, t = +l[0], n = +l[1], i) : r ? [t, n] : null;
  }, i;
}
function Wf(e, t, n, r, i) {
  for (var a = e.children, o, s = -1, c = a.length, l = e.value && (i - n) / e.value; ++s < c; )
    o = a[s], o.x0 = t, o.x1 = r, o.y0 = n, o.y1 = n += o.value * l;
}
var L_ = (1 + Math.sqrt(5)) / 2;
function z_(e, t, n, r, i, a) {
  for (var o = [], s = t.children, c, l, u = 0, d = 0, f = s.length, h, m, y = t.value, v, w, I, M, k, g, A; u < f; ) {
    h = i - n, m = a - r;
    do
      v = s[d++].value;
    while (!v && d < f);
    for (w = I = v, g = Math.max(m / h, h / m) / (y * e), A = v * v * g, k = Math.max(I / A, A / w); d < f; ++d) {
      if (v += l = s[d].value, l < w && (w = l), l > I && (I = l), A = v * v * g, M = Math.max(I / A, A / w), M > k) {
        v -= l;
        break;
      }
      k = M;
    }
    o.push(c = { value: v, dice: h < m, children: s.slice(u, d) }), c.dice ? zl(c, n, r, i, y ? r += m * v / y : a) : Wf(c, n, r, y ? n += h * v / y : i, a), y -= v, u = d;
  }
  return o;
}
const B_ = function e(t) {
  function n(r, i, a, o, s) {
    z_(t, r, i, a, o, s);
  }
  return n.ratio = function(r) {
    return e((r = +r) > 1 ? r : 1);
  }, n;
}(L_);
function F_() {
  var e = B_, t = !1, n = 1, r = 1, i = [0], a = da, o = da, s = da, c = da, l = da;
  function u(f) {
    return f.x0 = f.y0 = 0, f.x1 = n, f.y1 = r, f.eachBefore(d), i = [0], t && f.eachBefore(P_), f;
  }
  function d(f) {
    var h = i[f.depth], m = f.x0 + h, y = f.y0 + h, v = f.x1 - h, w = f.y1 - h;
    v < m && (m = v = (m + v) / 2), w < y && (y = w = (y + w) / 2), f.x0 = m, f.y0 = y, f.x1 = v, f.y1 = w, f.children && (h = i[f.depth + 1] = a(f) / 2, m += l(f) - h, y += o(f) - h, v -= s(f) - h, w -= c(f) - h, v < m && (m = v = (m + v) / 2), w < y && (y = w = (y + w) / 2), e(f, m, y, v, w));
  }
  return u.round = function(f) {
    return arguments.length ? (t = !!f, u) : t;
  }, u.size = function(f) {
    return arguments.length ? (n = +f[0], r = +f[1], u) : [n, r];
  }, u.tile = function(f) {
    return arguments.length ? (e = Yu(f), u) : e;
  }, u.padding = function(f) {
    return arguments.length ? u.paddingInner(f).paddingOuter(f) : u.paddingInner();
  }, u.paddingInner = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : Xa(+f), u) : a;
  }, u.paddingOuter = function(f) {
    return arguments.length ? u.paddingTop(f).paddingRight(f).paddingBottom(f).paddingLeft(f) : u.paddingTop();
  }, u.paddingTop = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : Xa(+f), u) : o;
  }, u.paddingRight = function(f) {
    return arguments.length ? (s = typeof f == "function" ? f : Xa(+f), u) : s;
  }, u.paddingBottom = function(f) {
    return arguments.length ? (c = typeof f == "function" ? f : Xa(+f), u) : c;
  }, u.paddingLeft = function(f) {
    return arguments.length ? (l = typeof f == "function" ? f : Xa(+f), u) : l;
  }, u;
}
function X6(e, t, n, r, i) {
  var a = e.children, o, s = a.length, c, l = new Array(s + 1);
  for (l[0] = c = o = 0; o < s; ++o)
    l[o + 1] = c += a[o].value;
  u(0, s, e.value, t, n, r, i);
  function u(d, f, h, m, y, v, w) {
    if (d >= f - 1) {
      var I = a[d];
      I.x0 = m, I.y0 = y, I.x1 = v, I.y1 = w;
      return;
    }
    for (var M = l[d], k = h / 2 + M, g = d + 1, A = f - 1; g < A; ) {
      var b = g + A >>> 1;
      l[b] < k ? g = b + 1 : A = b;
    }
    k - l[g - 1] < l[g] - k && d + 1 < g && --g;
    var x = l[g] - M, _ = h - x;
    if (v - m > w - y) {
      var R = (m * _ + v * x) / h;
      u(d, g, x, m, y, R, w), u(g, f, _, R, y, v, w);
    } else {
      var P = (y * _ + w * x) / h;
      u(d, g, x, m, y, v, P), u(g, f, _, m, P, v, w);
    }
  }
}
function J6(e, t, n, r, i) {
  (e.depth & 1 ? Wf : zl)(e, t, n, r, i);
}
const K6 = function e(t) {
  function n(r, i, a, o, s) {
    if ((c = r._squarify) && c.ratio === t)
      for (var c, l, u, d, f = -1, h, m = c.length, y = r.value; ++f < m; ) {
        for (l = c[f], u = l.children, d = l.value = 0, h = u.length; d < h; ++d) l.value += u[d].value;
        l.dice ? zl(l, i, a, o, a += (s - a) * l.value / y) : Wf(l, i, a, i += (o - i) * l.value / y, s), y -= l.value;
      }
    else
      r._squarify = c = z_(t, r, i, a, o, s), c.ratio = t;
  }
  return n.ratio = function(r) {
    return e((r = +r) > 1 ? r : 1);
  }, n;
}(L_);
function Z6(e) {
  for (var t = -1, n = e.length, r, i = e[n - 1], a = 0; ++t < n; )
    r = i, i = e[t], a += r[1] * i[0] - r[0] * i[1];
  return a / 2;
}
function eB(e) {
  for (var t = -1, n = e.length, r = 0, i = 0, a, o = e[n - 1], s, c = 0; ++t < n; )
    a = o, o = e[t], c += s = a[0] * o[1] - o[0] * a[1], r += (a[0] + o[0]) * s, i += (a[1] + o[1]) * s;
  return c *= 3, [r / c, i / c];
}
function tB(e, t, n) {
  return (t[0] - e[0]) * (n[1] - e[1]) - (t[1] - e[1]) * (n[0] - e[0]);
}
function nB(e, t) {
  return e[0] - t[0] || e[1] - t[1];
}
function $1(e) {
  for (var t = e.length, n = [0, 1], r = 2, i = 2; i < t; ++i) {
    for (; r > 1 && tB(e[n[r - 2]], e[n[r - 1]], e[i]) <= 0; ) --r;
    n[r++] = i;
  }
  return n.slice(0, r);
}
function rB(e) {
  if ((n = e.length) < 3) return null;
  var t, n, r = new Array(n), i = new Array(n);
  for (t = 0; t < n; ++t) r[t] = [+e[t][0], +e[t][1], t];
  for (r.sort(nB), t = 0; t < n; ++t) i[t] = [r[t][0], -r[t][1]];
  var a = $1(r), o = $1(i), s = o[0] === a[0], c = o[o.length - 1] === a[a.length - 1], l = [];
  for (t = a.length - 1; t >= 0; --t) l.push(e[r[a[t]][2]]);
  for (t = +s; t < o.length - c; ++t) l.push(e[r[o[t]][2]]);
  return l;
}
function iB(e, t) {
  for (var n = e.length, r = e[n - 1], i = t[0], a = t[1], o = r[0], s = r[1], c, l, u = !1, d = 0; d < n; ++d)
    r = e[d], c = r[0], l = r[1], l > a != s > a && i < (o - c) * (a - l) / (s - l) + c && (u = !u), o = c, s = l;
  return u;
}
function aB(e) {
  for (var t = -1, n = e.length, r = e[n - 1], i, a, o = r[0], s = r[1], c = 0; ++t < n; )
    i = o, a = s, r = e[t], o = r[0], s = r[1], i -= o, a -= s, c += Math.sqrt(i * i + a * a);
  return c;
}
var oB = [].slice, sB = {};
function Ep(e) {
  this._size = e, this._call = this._error = null, this._tasks = [], this._data = [], this._waiting = this._active = this._ended = this._start = 0;
}
Ep.prototype = j_.prototype = {
  constructor: Ep,
  defer: function(e) {
    if (typeof e != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = oB.call(arguments, 1);
    return t.push(e), ++this._waiting, this._tasks.push(t), Y_(this), this;
  },
  abort: function() {
    return this._error == null && Sg(this, new Error("abort")), this;
  },
  await: function(e) {
    if (typeof e != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = function(t, n) {
      e.apply(null, [t].concat(n));
    }, ju(this), this;
  },
  awaitAll: function(e) {
    if (typeof e != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = e, ju(this), this;
  }
};
function Y_(e) {
  if (!e._start)
    try {
      lB(e);
    } catch (t) {
      if (e._tasks[e._ended + e._active - 1]) Sg(e, t);
      else if (!e._data) throw t;
    }
}
function lB(e) {
  for (; e._start = e._waiting && e._active < e._size; ) {
    var t = e._ended + e._active, n = e._tasks[t], r = n.length - 1, i = n[r];
    n[r] = cB(e, t), --e._waiting, ++e._active, n = i.apply(null, n), e._tasks[t] && (e._tasks[t] = n || sB);
  }
}
function cB(e, t) {
  return function(n, r) {
    e._tasks[t] && (--e._active, ++e._ended, e._tasks[t] = null, e._error == null && (n != null ? Sg(e, n) : (e._data[t] = r, e._waiting ? Y_(e) : ju(e))));
  };
}
function Sg(e, t) {
  var n = e._tasks.length, r;
  for (e._error = t, e._data = void 0, e._waiting = NaN; --n >= 0; )
    if ((r = e._tasks[n]) && (e._tasks[n] = null, r.abort))
      try {
        r.abort();
      } catch {
      }
  e._active = NaN, ju(e);
}
function ju(e) {
  if (!e._active && e._call) {
    var t = e._data;
    e._data = void 0, e._call(e._error, t);
  }
}
function j_(e) {
  if (e == null) e = 1 / 0;
  else if (!((e = +e) >= 1)) throw new Error("invalid concurrency");
  return new Ep(e);
}
function Bo() {
  return Math.random();
}
const uB = function e(t) {
  function n(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, arguments.length === 1 ? (i = r, r = 0) : i -= r, function() {
      return t() * i + r;
    };
  }
  return n.source = e, n;
}(Bo), $_ = function e(t) {
  function n(r, i) {
    var a, o;
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var s;
      if (a != null) s = a, a = null;
      else do
        a = t() * 2 - 1, s = t() * 2 - 1, o = a * a + s * s;
      while (!o || o > 1);
      return r + i * s * Math.sqrt(-2 * Math.log(o) / o);
    };
  }
  return n.source = e, n;
}(Bo), fB = function e(t) {
  function n() {
    var r = $_.source(t).apply(this, arguments);
    return function() {
      return Math.exp(r());
    };
  }
  return n.source = e, n;
}(Bo), W_ = function e(t) {
  function n(r) {
    return function() {
      for (var i = 0, a = 0; a < r; ++a) i += t();
      return i;
    };
  }
  return n.source = e, n;
}(Bo), dB = function e(t) {
  function n(r) {
    var i = W_.source(t)(r);
    return function() {
      return i() / r;
    };
  }
  return n.source = e, n;
}(Bo), hB = function e(t) {
  function n(r) {
    return function() {
      return -Math.log(1 - t()) / r;
    };
  }
  return n.source = e, n;
}(Bo);
function Cg(e, t) {
  var n, r = Vi("beforesend", "progress", "load", "error"), i, a = Vr(), o = new XMLHttpRequest(), s = null, c = null, l, u, d = 0;
  typeof XDomainRequest < "u" && !("withCredentials" in o) && /^(http(s)?:)?\/\//.test(e) && (o = new XDomainRequest()), "onload" in o ? o.onload = o.onerror = o.ontimeout = f : o.onreadystatechange = function(h) {
    o.readyState > 3 && f(h);
  };
  function f(h) {
    var m = o.status, y;
    if (!m && mB(o) || m >= 200 && m < 300 || m === 304) {
      if (l)
        try {
          y = l.call(n, o);
        } catch (v) {
          r.call("error", n, v);
          return;
        }
      else
        y = o;
      r.call("load", n, y);
    } else
      r.call("error", n, h);
  }
  if (o.onprogress = function(h) {
    r.call("progress", n, h);
  }, n = {
    header: function(h, m) {
      return h = (h + "").toLowerCase(), arguments.length < 2 ? a.get(h) : (m == null ? a.remove(h) : a.set(h, m + ""), n);
    },
    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(h) {
      return arguments.length ? (i = h == null ? null : h + "", n) : i;
    },
    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(h) {
      return arguments.length ? (u = h, n) : u;
    },
    timeout: function(h) {
      return arguments.length ? (d = +h, n) : d;
    },
    user: function(h) {
      return arguments.length < 1 ? s : (s = h == null ? null : h + "", n);
    },
    password: function(h) {
      return arguments.length < 1 ? c : (c = h == null ? null : h + "", n);
    },
    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(h) {
      return l = h, n;
    },
    // Alias for send("GET", …).
    get: function(h, m) {
      return n.send("GET", h, m);
    },
    // Alias for send("POST", …).
    post: function(h, m) {
      return n.send("POST", h, m);
    },
    // If callback is non-null, it will be used for error and load events.
    send: function(h, m, y) {
      return o.open(h, e, !0, s, c), i != null && !a.has("accept") && a.set("accept", i + ",*/*"), o.setRequestHeader && a.each(function(v, w) {
        o.setRequestHeader(w, v);
      }), i != null && o.overrideMimeType && o.overrideMimeType(i), u != null && (o.responseType = u), d > 0 && (o.timeout = d), y == null && typeof m == "function" && (y = m, m = null), y != null && y.length === 1 && (y = pB(y)), y != null && n.on("error", y).on("load", function(v) {
        y(null, v);
      }), r.call("beforesend", n, o), o.send(m ?? null), n;
    },
    abort: function() {
      return o.abort(), n;
    },
    on: function() {
      var h = r.on.apply(r, arguments);
      return h === r ? n : h;
    }
  }, t != null) {
    if (typeof t != "function") throw new Error("invalid callback: " + t);
    return n.get(t);
  }
  return n;
}
function pB(e) {
  return function(t, n) {
    e(t == null ? n : null);
  };
}
function mB(e) {
  var t = e.responseType;
  return t && t !== "text" ? e.response : e.responseText;
}
function Uf(e, t) {
  return function(n, r) {
    var i = Cg(n).mimeType(e).response(t);
    if (r != null) {
      if (typeof r != "function") throw new Error("invalid callback: " + r);
      return i.get(r);
    }
    return i;
  };
}
const gB = Uf("text/html", function(e) {
  return document.createRange().createContextualFragment(e.responseText);
}), yB = Uf("application/json", function(e) {
  return JSON.parse(e.responseText);
}), AB = Uf("text/plain", function(e) {
  return e.responseText;
}), vB = Uf("application/xml", function(e) {
  var t = e.responseXML;
  if (!t) throw new Error("parse error");
  return t;
});
function U_(e, t) {
  return function(n, r, i) {
    arguments.length < 3 && (i = r, r = null);
    var a = Cg(n).mimeType(e);
    return a.row = function(o) {
      return arguments.length ? a.response(xB(t, r = o)) : r;
    }, a.row(r), i ? a.get(i) : a;
  };
}
function xB(e, t) {
  return function(n) {
    return e(n.responseText, t);
  };
}
const bB = U_("text/csv", Dw), wB = U_("text/tab-separated-values", Pw);
var H_ = Array.prototype, Eg = H_.map, $i = H_.slice, kp = { name: "implicit" };
function kg(e) {
  var t = Vr(), n = [], r = kp;
  e = e == null ? [] : $i.call(e);
  function i(a) {
    var o = a + "", s = t.get(o);
    if (!s) {
      if (r !== kp) return r;
      t.set(o, s = n.push(a));
    }
    return e[(s - 1) % e.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return n.slice();
    n = [], t = Vr();
    for (var o = -1, s = a.length, c, l; ++o < s; ) t.has(l = (c = a[o]) + "") || t.set(l, n.push(c));
    return i;
  }, i.range = function(a) {
    return arguments.length ? (e = $i.call(a), i) : e.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return kg().domain(n).range(e).unknown(r);
  }, i;
}
function Tg() {
  var e = kg().unknown(void 0), t = e.domain, n = e.range, r = [0, 1], i, a, o = !1, s = 0, c = 0, l = 0.5;
  delete e.unknown;
  function u() {
    var d = t().length, f = r[1] < r[0], h = r[f - 0], m = r[1 - f];
    i = (m - h) / Math.max(1, d - s + c * 2), o && (i = Math.floor(i)), h += (m - h - i * (d - s)) * l, a = i * (1 - s), o && (h = Math.round(h), a = Math.round(a));
    var y = yr(d).map(function(v) {
      return h + i * v;
    });
    return n(f ? y.reverse() : y);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), u()) : t();
  }, e.range = function(d) {
    return arguments.length ? (r = [+d[0], +d[1]], u()) : r.slice();
  }, e.rangeRound = function(d) {
    return r = [+d[0], +d[1]], o = !0, u();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return i;
  }, e.round = function(d) {
    return arguments.length ? (o = !!d, u()) : o;
  }, e.padding = function(d) {
    return arguments.length ? (s = c = Math.max(0, Math.min(1, d)), u()) : s;
  }, e.paddingInner = function(d) {
    return arguments.length ? (s = Math.max(0, Math.min(1, d)), u()) : s;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = Math.max(0, Math.min(1, d)), u()) : c;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), u()) : l;
  }, e.copy = function() {
    return Tg().domain(t()).range(r).round(o).paddingInner(s).paddingOuter(c).align(l);
  }, u();
}
function G_(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return G_(t());
  }, e;
}
function _B() {
  return G_(Tg().paddingInner(1));
}
function Mg(e) {
  return function() {
    return e;
  };
}
function V_(e) {
  return +e;
}
var W1 = [0, 1];
function Ig(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Mg(t);
}
function SB(e) {
  return function(t, n) {
    var r = e(t = +t, n = +n);
    return function(i) {
      return i <= t ? 0 : i >= n ? 1 : r(i);
    };
  };
}
function CB(e) {
  return function(t, n) {
    var r = e(t = +t, n = +n);
    return function(i) {
      return i <= 0 ? t : i >= 1 ? n : r(i);
    };
  };
}
function EB(e, t, n, r) {
  var i = e[0], a = e[1], o = t[0], s = t[1];
  return a < i ? (i = n(a, i), o = r(s, o)) : (i = n(i, a), o = r(o, s)), function(c) {
    return o(i(c));
  };
}
function kB(e, t, n, r) {
  var i = Math.min(e.length, t.length) - 1, a = new Array(i), o = new Array(i), s = -1;
  for (e[i] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++s < i; )
    a[s] = n(e[s], e[s + 1]), o[s] = r(t[s], t[s + 1]);
  return function(c) {
    var l = wa(e, c, 1, i) - 1;
    return o[l](a[l](c));
  };
}
function Hf(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp());
}
function Gf(e, t) {
  var n = W1, r = W1, i = Ol, a = !1, o, s, c;
  function l() {
    return o = Math.min(n.length, r.length) > 2 ? kB : EB, s = c = null, u;
  }
  function u(d) {
    return (s || (s = o(n, r, a ? SB(e) : e, i)))(+d);
  }
  return u.invert = function(d) {
    return (c || (c = o(r, n, Ig, a ? CB(t) : t)))(+d);
  }, u.domain = function(d) {
    return arguments.length ? (n = Eg.call(d, V_), l()) : n.slice();
  }, u.range = function(d) {
    return arguments.length ? (r = $i.call(d), l()) : r.slice();
  }, u.rangeRound = function(d) {
    return r = $i.call(d), i = hw, l();
  }, u.clamp = function(d) {
    return arguments.length ? (a = !!d, l()) : a;
  }, u.interpolate = function(d) {
    return arguments.length ? (i = d, l()) : i;
  }, l();
}
function TB(e, t, n) {
  var r = e[0], i = e[e.length - 1], a = qs(r, i, t ?? 10), o;
  switch (n = ol(n ?? ",f"), n.type) {
    case "s": {
      var s = Math.max(Math.abs(r), Math.abs(i));
      return n.precision == null && !isNaN(o = $w(a, s)) && (n.precision = o), sg(n, s);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(o = Ww(a, Math.max(Math.abs(r), Math.abs(i)))) && (n.precision = o - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(o = jw(a)) && (n.precision = o - (n.type === "%") * 2);
      break;
    }
  }
  return Ff(n);
}
function Bl(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return zm(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    return TB(t(), n, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, a = r.length - 1, o = r[i], s = r[a], c;
    return s < o && (c = o, o = s, s = c, c = i, i = a, a = c), c = Ns(o, s, n), c > 0 ? (o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c, c = Ns(o, s, n)) : c < 0 && (o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c, c = Ns(o, s, n)), c > 0 ? (r[i] = Math.floor(o / c) * c, r[a] = Math.ceil(s / c) * c, t(r)) : c < 0 && (r[i] = Math.ceil(o * c) / c, r[a] = Math.floor(s * c) / c, t(r)), e;
  }, e;
}
function fl() {
  var e = Gf(Ig, $n);
  return e.copy = function() {
    return Hf(e, fl());
  }, Bl(e);
}
function Q_() {
  var e = [0, 1];
  function t(n) {
    return +n;
  }
  return t.invert = t, t.domain = t.range = function(n) {
    return arguments.length ? (e = Eg.call(n, V_), t) : e.slice();
  }, t.copy = function() {
    return Q_().domain(e);
  }, Bl(t);
}
function q_(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], a = e[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), e[n] = t.floor(i), e[r] = t.ceil(a), e;
}
function MB(e, t) {
  return (t = Math.log(t / e)) ? function(n) {
    return Math.log(n / e) / t;
  } : Mg(t);
}
function IB(e, t) {
  return e < 0 ? function(n) {
    return -Math.pow(-t, n) * Math.pow(-e, 1 - n);
  } : function(n) {
    return Math.pow(t, n) * Math.pow(e, 1 - n);
  };
}
function NB(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function U1(e) {
  return e === 10 ? NB : e === Math.E ? Math.exp : function(t) {
    return Math.pow(e, t);
  };
}
function H1(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), function(t) {
    return Math.log(t) / e;
  });
}
function G1(e) {
  return function(t) {
    return -e(-t);
  };
}
function X_() {
  var e = Gf(MB, IB).domain([1, 10]), t = e.domain, n = 10, r = H1(10), i = U1(10);
  function a() {
    return r = H1(n), i = U1(n), t()[0] < 0 && (r = G1(r), i = G1(i)), e;
  }
  return e.base = function(o) {
    return arguments.length ? (n = +o, a()) : n;
  }, e.domain = function(o) {
    return arguments.length ? (t(o), a()) : t();
  }, e.ticks = function(o) {
    var s = t(), c = s[0], l = s[s.length - 1], u;
    (u = l < c) && (d = c, c = l, l = d);
    var d = r(c), f = r(l), h, m, y, v = o == null ? 10 : +o, w = [];
    if (!(n % 1) && f - d < v) {
      if (d = Math.round(d) - 1, f = Math.round(f) + 1, c > 0) {
        for (; d < f; ++d)
          for (m = 1, h = i(d); m < n; ++m)
            if (y = h * m, !(y < c)) {
              if (y > l) break;
              w.push(y);
            }
      } else for (; d < f; ++d)
        for (m = n - 1, h = i(d); m >= 1; --m)
          if (y = h * m, !(y < c)) {
            if (y > l) break;
            w.push(y);
          }
    } else
      w = zm(d, f, Math.min(f - d, v)).map(i);
    return u ? w.reverse() : w;
  }, e.tickFormat = function(o, s) {
    if (s == null && (s = n === 10 ? ".0e" : ","), typeof s != "function" && (s = Ff(s)), o === 1 / 0) return s;
    o == null && (o = 10);
    var c = Math.max(1, n * o / e.ticks().length);
    return function(l) {
      var u = l / i(Math.round(r(l)));
      return u * n < n - 0.5 && (u *= n), u <= c ? s(l) : "";
    };
  }, e.nice = function() {
    return t(q_(t(), {
      floor: function(o) {
        return i(Math.floor(r(o)));
      },
      ceil: function(o) {
        return i(Math.ceil(r(o)));
      }
    }));
  }, e.copy = function() {
    return Hf(e, X_().base(n));
  }, e;
}
function Ha(e, t) {
  return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
}
function Ng() {
  var e = 1, t = Gf(r, i), n = t.domain;
  function r(a, o) {
    return (o = Ha(o, e) - (a = Ha(a, e))) ? function(s) {
      return (Ha(s, e) - a) / o;
    } : Mg(o);
  }
  function i(a, o) {
    return o = Ha(o, e) - (a = Ha(a, e)), function(s) {
      return Ha(a + o * s, 1 / e);
    };
  }
  return t.exponent = function(a) {
    return arguments.length ? (e = +a, n(n())) : e;
  }, t.copy = function() {
    return Hf(t, Ng().exponent(e));
  }, Bl(t);
}
function OB() {
  return Ng().exponent(0.5);
}
function J_() {
  var e = [], t = [], n = [];
  function r() {
    var a = 0, o = Math.max(1, t.length);
    for (n = new Array(o - 1); ++a < o; ) n[a - 1] = Xs(e, a / o);
    return i;
  }
  function i(a) {
    if (!isNaN(a = +a)) return t[wa(n, a)];
  }
  return i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return o < 0 ? [NaN, NaN] : [
      o > 0 ? n[o - 1] : e[0],
      o < n.length ? n[o] : e[e.length - 1]
    ];
  }, i.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (var o = 0, s = a.length, c; o < s; ++o) c = a[o], c != null && !isNaN(c = +c) && e.push(c);
    return e.sort(Na), r();
  }, i.range = function(a) {
    return arguments.length ? (t = $i.call(a), r()) : t.slice();
  }, i.quantiles = function() {
    return n.slice();
  }, i.copy = function() {
    return J_().domain(e).range(t);
  }, i;
}
function K_() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1];
  function a(s) {
    if (s <= s) return i[wa(r, s, 0, n)];
  }
  function o() {
    var s = -1;
    for (r = new Array(n); ++s < n; ) r[s] = ((s + 1) * t - (s - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(s) {
    return arguments.length ? (e = +s[0], t = +s[1], o()) : [e, t];
  }, a.range = function(s) {
    return arguments.length ? (n = (i = $i.call(s)).length - 1, o()) : i.slice();
  }, a.invertExtent = function(s) {
    var c = i.indexOf(s);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, r[0]] : c >= n ? [r[n - 1], t] : [r[c - 1], r[c]];
  }, a.copy = function() {
    return K_().domain([e, t]).range(i);
  }, Bl(a);
}
function Z_() {
  var e = [0.5], t = [0, 1], n = 1;
  function r(i) {
    if (i <= i) return t[wa(e, i, 0, n)];
  }
  return r.domain = function(i) {
    return arguments.length ? (e = $i.call(i), n = Math.min(e.length, t.length - 1), r) : e.slice();
  }, r.range = function(i) {
    return arguments.length ? (t = $i.call(i), n = Math.min(e.length, t.length - 1), r) : t.slice();
  }, r.invertExtent = function(i) {
    var a = t.indexOf(i);
    return [e[a - 1], e[a]];
  }, r.copy = function() {
    return Z_().domain(e).range(t);
  }, r;
}
var Gd = /* @__PURE__ */ new Date(), Vd = /* @__PURE__ */ new Date();
function Zt(e, t, n, r) {
  function i(a) {
    return e(a = /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = i, i.ceil = function(a) {
    return e(a = new Date(a - 1)), t(a, 1), e(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var c = [], l;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return c;
    do
      c.push(l = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (l < a && a < o);
    return c;
  }, i.filter = function(a) {
    return Zt(function(o) {
      if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0) for (; ++s <= 0; )
          for (; t(o, -1), !a(o); )
            ;
        else for (; --s >= 0; )
          for (; t(o, 1), !a(o); )
            ;
    });
  }, n && (i.count = function(a, o) {
    return Gd.setTime(+a), Vd.setTime(+o), e(Gd), e(Vd), Math.floor(n(Gd, Vd));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
var Ta = Zt(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
Ta.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Zt(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : Ta;
};
var V1 = Ta.range, Ac = 1e3, hi = 6e4, Mi = 36e5, eS = 864e5, tS = 6048e5, dl = Zt(function(e) {
  e.setTime(Math.floor(e / Ac) * Ac);
}, function(e, t) {
  e.setTime(+e + t * Ac);
}, function(e, t) {
  return (t - e) / Ac;
}, function(e) {
  return e.getUTCSeconds();
}), Q1 = dl.range, Og = Zt(function(e) {
  e.setTime(Math.floor(e / hi) * hi);
}, function(e, t) {
  e.setTime(+e + t * hi);
}, function(e, t) {
  return (t - e) / hi;
}, function(e) {
  return e.getMinutes();
}), RB = Og.range, Rg = Zt(function(e) {
  var t = e.getTimezoneOffset() * hi % Mi;
  t < 0 && (t += Mi), e.setTime(Math.floor((+e - t) / Mi) * Mi + t);
}, function(e, t) {
  e.setTime(+e + t * Mi);
}, function(e, t) {
  return (t - e) / Mi;
}, function(e) {
  return e.getHours();
}), DB = Rg.range, Fl = Zt(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * hi) / eS;
}, function(e) {
  return e.getDate() - 1;
}), PB = Fl.range;
function Da(e) {
  return Zt(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * hi) / tS;
  });
}
var hl = Da(0), pl = Da(1), nS = Da(2), rS = Da(3), Ds = Da(4), iS = Da(5), aS = Da(6), q1 = hl.range, LB = pl.range, zB = nS.range, BB = rS.range, FB = Ds.range, YB = iS.range, jB = aS.range, Dg = Zt(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
}), $B = Dg.range, Ai = Zt(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
Ai.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Zt(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
var WB = Ai.range, Pg = Zt(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * hi);
}, function(e, t) {
  return (t - e) / hi;
}, function(e) {
  return e.getUTCMinutes();
}), UB = Pg.range, Lg = Zt(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * Mi);
}, function(e, t) {
  return (t - e) / Mi;
}, function(e) {
  return e.getUTCHours();
}), HB = Lg.range, Yl = Zt(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / eS;
}, function(e) {
  return e.getUTCDate() - 1;
}), GB = Yl.range;
function Pa(e) {
  return Zt(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / tS;
  });
}
var ml = Pa(0), gl = Pa(1), oS = Pa(2), sS = Pa(3), Ps = Pa(4), lS = Pa(5), cS = Pa(6), X1 = ml.range, VB = gl.range, QB = oS.range, qB = sS.range, XB = Ps.range, JB = lS.range, KB = cS.range, zg = Zt(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
}), ZB = zg.range, vi = Zt(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
vi.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Zt(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
var eF = vi.range;
function tF(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function vc(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function rs(e) {
  return { y: e, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0 };
}
function uS(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, l = is(i), u = as(i), d = is(a), f = as(a), h = is(o), m = as(o), y = is(s), v = as(s), w = is(c), I = as(c), M = {
    a: B,
    A: W,
    b: L,
    B: S,
    c: null,
    d: eA,
    e: eA,
    f: CF,
    H: wF,
    I: _F,
    j: SF,
    L: fS,
    m: EF,
    M: kF,
    p: $,
    Q: rA,
    s: iA,
    S: TF,
    u: MF,
    U: IF,
    V: NF,
    w: OF,
    W: RF,
    x: null,
    X: null,
    y: DF,
    Y: PF,
    Z: LF,
    "%": nA
  }, k = {
    a: j,
    A: N,
    b: q,
    B: G,
    c: null,
    d: tA,
    e: tA,
    f: YF,
    H: zF,
    I: BF,
    j: FF,
    L: dS,
    m: jF,
    M: $F,
    p: X,
    Q: rA,
    s: iA,
    S: WF,
    u: UF,
    U: HF,
    V: GF,
    w: VF,
    W: QF,
    x: null,
    X: null,
    y: qF,
    Y: XF,
    Z: JF,
    "%": nA
  }, g = {
    a: R,
    A: P,
    b: E,
    B: C,
    c: T,
    d: K1,
    e: K1,
    f: AF,
    H: Z1,
    I: Z1,
    j: pF,
    L: yF,
    m: hF,
    M: mF,
    p: _,
    Q: xF,
    s: bF,
    S: gF,
    u: oF,
    U: sF,
    V: lF,
    w: aF,
    W: cF,
    x: D,
    X: z,
    y: fF,
    Y: uF,
    Z: dF,
    "%": vF
  };
  M.x = A(n, M), M.X = A(r, M), M.c = A(t, M), k.x = A(n, k), k.X = A(r, k), k.c = A(t, k);
  function A(Y, Q) {
    return function(V) {
      var U = [], Z = -1, H = 0, ee = Y.length, ie, re, K;
      for (V instanceof Date || (V = /* @__PURE__ */ new Date(+V)); ++Z < ee; )
        Y.charCodeAt(Z) === 37 && (U.push(Y.slice(H, Z)), (re = J1[ie = Y.charAt(++Z)]) != null ? ie = Y.charAt(++Z) : re = ie === "e" ? " " : "0", (K = Q[ie]) && (ie = K(V, re)), U.push(ie), H = Z + 1);
      return U.push(Y.slice(H, Z)), U.join("");
    };
  }
  function b(Y, Q) {
    return function(V) {
      var U = rs(1900), Z = x(U, Y, V += "", 0), H, ee;
      if (Z != V.length) return null;
      if ("Q" in U) return new Date(U.Q);
      if ("p" in U && (U.H = U.H % 12 + U.p * 12), "V" in U) {
        if (U.V < 1 || U.V > 53) return null;
        "w" in U || (U.w = 1), "Z" in U ? (H = vc(rs(U.y)), ee = H.getUTCDay(), H = ee > 4 || ee === 0 ? gl.ceil(H) : gl(H), H = Yl.offset(H, (U.V - 1) * 7), U.y = H.getUTCFullYear(), U.m = H.getUTCMonth(), U.d = H.getUTCDate() + (U.w + 6) % 7) : (H = Q(rs(U.y)), ee = H.getDay(), H = ee > 4 || ee === 0 ? pl.ceil(H) : pl(H), H = Fl.offset(H, (U.V - 1) * 7), U.y = H.getFullYear(), U.m = H.getMonth(), U.d = H.getDate() + (U.w + 6) % 7);
      } else ("W" in U || "U" in U) && ("w" in U || (U.w = "u" in U ? U.u % 7 : "W" in U ? 1 : 0), ee = "Z" in U ? vc(rs(U.y)).getUTCDay() : Q(rs(U.y)).getDay(), U.m = 0, U.d = "W" in U ? (U.w + 6) % 7 + U.W * 7 - (ee + 5) % 7 : U.w + U.U * 7 - (ee + 6) % 7);
      return "Z" in U ? (U.H += U.Z / 100 | 0, U.M += U.Z % 100, vc(U)) : Q(U);
    };
  }
  function x(Y, Q, V, U) {
    for (var Z = 0, H = Q.length, ee = V.length, ie, re; Z < H; ) {
      if (U >= ee) return -1;
      if (ie = Q.charCodeAt(Z++), ie === 37) {
        if (ie = Q.charAt(Z++), re = g[ie in J1 ? Q.charAt(Z++) : ie], !re || (U = re(Y, V, U)) < 0) return -1;
      } else if (ie != V.charCodeAt(U++))
        return -1;
    }
    return U;
  }
  function _(Y, Q, V) {
    var U = l.exec(Q.slice(V));
    return U ? (Y.p = u[U[0].toLowerCase()], V + U[0].length) : -1;
  }
  function R(Y, Q, V) {
    var U = h.exec(Q.slice(V));
    return U ? (Y.w = m[U[0].toLowerCase()], V + U[0].length) : -1;
  }
  function P(Y, Q, V) {
    var U = d.exec(Q.slice(V));
    return U ? (Y.w = f[U[0].toLowerCase()], V + U[0].length) : -1;
  }
  function E(Y, Q, V) {
    var U = w.exec(Q.slice(V));
    return U ? (Y.m = I[U[0].toLowerCase()], V + U[0].length) : -1;
  }
  function C(Y, Q, V) {
    var U = y.exec(Q.slice(V));
    return U ? (Y.m = v[U[0].toLowerCase()], V + U[0].length) : -1;
  }
  function T(Y, Q, V) {
    return x(Y, t, Q, V);
  }
  function D(Y, Q, V) {
    return x(Y, n, Q, V);
  }
  function z(Y, Q, V) {
    return x(Y, r, Q, V);
  }
  function B(Y) {
    return o[Y.getDay()];
  }
  function W(Y) {
    return a[Y.getDay()];
  }
  function L(Y) {
    return c[Y.getMonth()];
  }
  function S(Y) {
    return s[Y.getMonth()];
  }
  function $(Y) {
    return i[+(Y.getHours() >= 12)];
  }
  function j(Y) {
    return o[Y.getUTCDay()];
  }
  function N(Y) {
    return a[Y.getUTCDay()];
  }
  function q(Y) {
    return c[Y.getUTCMonth()];
  }
  function G(Y) {
    return s[Y.getUTCMonth()];
  }
  function X(Y) {
    return i[+(Y.getUTCHours() >= 12)];
  }
  return {
    format: function(Y) {
      var Q = A(Y += "", M);
      return Q.toString = function() {
        return Y;
      }, Q;
    },
    parse: function(Y) {
      var Q = b(Y += "", tF);
      return Q.toString = function() {
        return Y;
      }, Q;
    },
    utcFormat: function(Y) {
      var Q = A(Y += "", k);
      return Q.toString = function() {
        return Y;
      }, Q;
    },
    utcParse: function(Y) {
      var Q = b(Y, vc);
      return Q.toString = function() {
        return Y;
      }, Q;
    }
  };
}
var J1 = { "-": "", _: " ", 0: "0" }, ln = /^\s*\d+/, nF = /^%/, rF = /[\\^$*+?|[\]().{}]/g;
function At(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(t) + i : i);
}
function iF(e) {
  return e.replace(rF, "\\$&");
}
function is(e) {
  return new RegExp("^(?:" + e.map(iF).join("|") + ")", "i");
}
function as(e) {
  for (var t = {}, n = -1, r = e.length; ++n < r; ) t[e[n].toLowerCase()] = n;
  return t;
}
function aF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function oF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function sF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function lF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function cF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function uF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function fF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function dF(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function hF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function K1(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function pF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function Z1(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function mF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function gF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function yF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function AF(e, t, n) {
  var r = ln.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function vF(e, t, n) {
  var r = nF.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function xF(e, t, n) {
  var r = ln.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function bF(e, t, n) {
  var r = ln.exec(t.slice(n));
  return r ? (e.Q = +r[0] * 1e3, n + r[0].length) : -1;
}
function eA(e, t) {
  return At(e.getDate(), t, 2);
}
function wF(e, t) {
  return At(e.getHours(), t, 2);
}
function _F(e, t) {
  return At(e.getHours() % 12 || 12, t, 2);
}
function SF(e, t) {
  return At(1 + Fl.count(Ai(e), e), t, 3);
}
function fS(e, t) {
  return At(e.getMilliseconds(), t, 3);
}
function CF(e, t) {
  return fS(e, t) + "000";
}
function EF(e, t) {
  return At(e.getMonth() + 1, t, 2);
}
function kF(e, t) {
  return At(e.getMinutes(), t, 2);
}
function TF(e, t) {
  return At(e.getSeconds(), t, 2);
}
function MF(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function IF(e, t) {
  return At(hl.count(Ai(e), e), t, 2);
}
function NF(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Ds(e) : Ds.ceil(e), At(Ds.count(Ai(e), e) + (Ai(e).getDay() === 4), t, 2);
}
function OF(e) {
  return e.getDay();
}
function RF(e, t) {
  return At(pl.count(Ai(e), e), t, 2);
}
function DF(e, t) {
  return At(e.getFullYear() % 100, t, 2);
}
function PF(e, t) {
  return At(e.getFullYear() % 1e4, t, 4);
}
function LF(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + At(t / 60 | 0, "0", 2) + At(t % 60, "0", 2);
}
function tA(e, t) {
  return At(e.getUTCDate(), t, 2);
}
function zF(e, t) {
  return At(e.getUTCHours(), t, 2);
}
function BF(e, t) {
  return At(e.getUTCHours() % 12 || 12, t, 2);
}
function FF(e, t) {
  return At(1 + Yl.count(vi(e), e), t, 3);
}
function dS(e, t) {
  return At(e.getUTCMilliseconds(), t, 3);
}
function YF(e, t) {
  return dS(e, t) + "000";
}
function jF(e, t) {
  return At(e.getUTCMonth() + 1, t, 2);
}
function $F(e, t) {
  return At(e.getUTCMinutes(), t, 2);
}
function WF(e, t) {
  return At(e.getUTCSeconds(), t, 2);
}
function UF(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function HF(e, t) {
  return At(ml.count(vi(e), e), t, 2);
}
function GF(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Ps(e) : Ps.ceil(e), At(Ps.count(vi(e), e) + (vi(e).getUTCDay() === 4), t, 2);
}
function VF(e) {
  return e.getUTCDay();
}
function QF(e, t) {
  return At(gl.count(vi(e), e), t, 2);
}
function qF(e, t) {
  return At(e.getUTCFullYear() % 100, t, 2);
}
function XF(e, t) {
  return At(e.getUTCFullYear() % 1e4, t, 4);
}
function JF() {
  return "+0000";
}
function nA() {
  return "%";
}
function rA(e) {
  return +e;
}
function iA(e) {
  return Math.floor(+e / 1e3);
}
var Ga, Bg, hS, Vf, Fg;
pS({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function pS(e) {
  return Ga = uS(e), Bg = Ga.format, hS = Ga.parse, Vf = Ga.utcFormat, Fg = Ga.utcParse, Ga;
}
var mS = "%Y-%m-%dT%H:%M:%S.%LZ";
function KF(e) {
  return e.toISOString();
}
var ZF = Date.prototype.toISOString ? KF : Vf(mS);
function e8(e) {
  var t = new Date(e);
  return isNaN(t) ? null : t;
}
var t8 = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? e8 : Fg(mS), ws = 1e3, _s = ws * 60, Ss = _s * 60, yl = Ss * 24, n8 = yl * 7, aA = yl * 30, Qd = yl * 365;
function r8(e) {
  return new Date(e);
}
function i8(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Yg(e, t, n, r, i, a, o, s, c) {
  var l = Gf(Ig, $n), u = l.invert, d = l.domain, f = c(".%L"), h = c(":%S"), m = c("%I:%M"), y = c("%I %p"), v = c("%a %d"), w = c("%b %d"), I = c("%B"), M = c("%Y"), k = [
    [o, 1, ws],
    [o, 5, 5 * ws],
    [o, 15, 15 * ws],
    [o, 30, 30 * ws],
    [a, 1, _s],
    [a, 5, 5 * _s],
    [a, 15, 15 * _s],
    [a, 30, 30 * _s],
    [i, 1, Ss],
    [i, 3, 3 * Ss],
    [i, 6, 6 * Ss],
    [i, 12, 12 * Ss],
    [r, 1, yl],
    [r, 2, 2 * yl],
    [n, 1, n8],
    [t, 1, aA],
    [t, 3, 3 * aA],
    [e, 1, Qd]
  ];
  function g(b) {
    return (o(b) < b ? f : a(b) < b ? h : i(b) < b ? m : r(b) < b ? y : t(b) < b ? n(b) < b ? v : w : e(b) < b ? I : M)(b);
  }
  function A(b, x, _, R) {
    if (b == null && (b = 10), typeof b == "number") {
      var P = Math.abs(_ - x) / b, E = Lm(function(C) {
        return C[2];
      }).right(k, P);
      E === k.length ? (R = qs(x / Qd, _ / Qd, b), b = e) : E ? (E = k[P / k[E - 1][2] < k[E][2] / P ? E - 1 : E], R = E[1], b = E[0]) : (R = Math.max(qs(x, _, b), 1), b = s);
    }
    return R == null ? b : b.every(R);
  }
  return l.invert = function(b) {
    return new Date(u(b));
  }, l.domain = function(b) {
    return arguments.length ? d(Eg.call(b, i8)) : d().map(r8);
  }, l.ticks = function(b, x) {
    var _ = d(), R = _[0], P = _[_.length - 1], E = P < R, C;
    return E && (C = R, R = P, P = C), C = A(b, R, P, x), C = C ? C.range(R, P + 1) : [], E ? C.reverse() : C;
  }, l.tickFormat = function(b, x) {
    return x == null ? g : c(x);
  }, l.nice = function(b, x) {
    var _ = d();
    return (b = A(b, _[0], _[_.length - 1], x)) ? d(q_(_, b)) : l;
  }, l.copy = function() {
    return Hf(l, Yg(e, t, n, r, i, a, o, s, c));
  }, l;
}
function a8() {
  return Yg(Ai, Dg, hl, Fl, Rg, Og, dl, Ta, Bg).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
}
function o8() {
  return Yg(vi, zg, ml, Yl, Lg, Pg, dl, Ta, Vf).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
}
function Ji(e) {
  return e.match(/.{6}/g).map(function(t) {
    return "#" + t;
  });
}
const s8 = Ji("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), l8 = Ji("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"), c8 = Ji("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"), u8 = Ji("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"), f8 = Of(_r(300, 0.5, 0), _r(-240, 0.5, 1));
var d8 = Of(_r(-100, 0.75, 0.35), _r(80, 1.5, 0.8)), h8 = Of(_r(260, 0.75, 0.35), _r(80, 1.5, 0.8)), xc = _r();
function p8(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return xc.h = 360 * e - 100, xc.s = 1.5 - 1.5 * t, xc.l = 0.8 - 0.9 * t, xc + "";
}
function Qf(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
const m8 = Qf(Ji("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var g8 = Qf(Ji("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), y8 = Qf(Ji("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), A8 = Qf(Ji("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function gS(e) {
  var t = 0, n = 1, r = !1;
  function i(a) {
    var o = (a - t) / (n - t);
    return e(r ? Math.max(0, Math.min(1, o)) : o);
  }
  return i.domain = function(a) {
    return arguments.length ? (t = +a[0], n = +a[1], i) : [t, n];
  }, i.clamp = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.interpolator = function(a) {
    return arguments.length ? (e = a, i) : e;
  }, i.copy = function() {
    return gS(e).domain([t, n]).clamp(r);
  }, Bl(i);
}
function Ze(e) {
  return function() {
    return e;
  };
}
var oA = Math.abs, fn = Math.atan2, sa = Math.cos, v8 = Math.max, qd = Math.min, Or = Math.sin, Za = Math.sqrt, hn = 1e-12, Wi = Math.PI, $u = Wi / 2, zi = 2 * Wi;
function x8(e) {
  return e > 1 ? 0 : e < -1 ? Wi : Math.acos(e);
}
function sA(e) {
  return e >= 1 ? $u : e <= -1 ? -$u : Math.asin(e);
}
function b8(e) {
  return e.innerRadius;
}
function w8(e) {
  return e.outerRadius;
}
function _8(e) {
  return e.startAngle;
}
function S8(e) {
  return e.endAngle;
}
function C8(e) {
  return e && e.padAngle;
}
function E8(e, t, n, r, i, a, o, s) {
  var c = n - e, l = r - t, u = o - i, d = s - a, f = (u * (t - a) - d * (e - i)) / (d * c - u * l);
  return [e + f * c, t + f * l];
}
function bc(e, t, n, r, i, a, o) {
  var s = e - n, c = t - r, l = (o ? a : -a) / Za(s * s + c * c), u = l * c, d = -l * s, f = e + u, h = t + d, m = n + u, y = r + d, v = (f + m) / 2, w = (h + y) / 2, I = m - f, M = y - h, k = I * I + M * M, g = i - a, A = f * y - m * h, b = (M < 0 ? -1 : 1) * Za(v8(0, g * g * k - A * A)), x = (A * M - I * b) / k, _ = (-A * I - M * b) / k, R = (A * M + I * b) / k, P = (-A * I + M * b) / k, E = x - v, C = _ - w, T = R - v, D = P - w;
  return E * E + C * C > T * T + D * D && (x = R, _ = P), {
    cx: x,
    cy: _,
    x01: -u,
    y01: -d,
    x11: x * (i / g - 1),
    y11: _ * (i / g - 1)
  };
}
function k8() {
  var e = b8, t = w8, n = Ze(0), r = null, i = _8, a = S8, o = C8, s = null;
  function c() {
    var l, u, d = +e.apply(this, arguments), f = +t.apply(this, arguments), h = i.apply(this, arguments) - $u, m = a.apply(this, arguments) - $u, y = oA(m - h), v = m > h;
    if (s || (s = l = qi()), f < d && (u = f, f = d, d = u), !(f > hn)) s.moveTo(0, 0);
    else if (y > zi - hn)
      s.moveTo(f * sa(h), f * Or(h)), s.arc(0, 0, f, h, m, !v), d > hn && (s.moveTo(d * sa(m), d * Or(m)), s.arc(0, 0, d, m, h, v));
    else {
      var w = h, I = m, M = h, k = m, g = y, A = y, b = o.apply(this, arguments) / 2, x = b > hn && (r ? +r.apply(this, arguments) : Za(d * d + f * f)), _ = qd(oA(f - d) / 2, +n.apply(this, arguments)), R = _, P = _, E, C;
      if (x > hn) {
        var T = sA(x / d * Or(b)), D = sA(x / f * Or(b));
        (g -= T * 2) > hn ? (T *= v ? 1 : -1, M += T, k -= T) : (g = 0, M = k = (h + m) / 2), (A -= D * 2) > hn ? (D *= v ? 1 : -1, w += D, I -= D) : (A = 0, w = I = (h + m) / 2);
      }
      var z = f * sa(w), B = f * Or(w), W = d * sa(k), L = d * Or(k);
      if (_ > hn) {
        var S = f * sa(I), $ = f * Or(I), j = d * sa(M), N = d * Or(M);
        if (y < Wi) {
          var q = g > hn ? E8(z, B, j, N, S, $, W, L) : [W, L], G = z - q[0], X = B - q[1], Y = S - q[0], Q = $ - q[1], V = 1 / Or(x8((G * Y + X * Q) / (Za(G * G + X * X) * Za(Y * Y + Q * Q))) / 2), U = Za(q[0] * q[0] + q[1] * q[1]);
          R = qd(_, (d - U) / (V - 1)), P = qd(_, (f - U) / (V + 1));
        }
      }
      A > hn ? P > hn ? (E = bc(j, N, z, B, f, P, v), C = bc(S, $, W, L, f, P, v), s.moveTo(E.cx + E.x01, E.cy + E.y01), P < _ ? s.arc(E.cx, E.cy, P, fn(E.y01, E.x01), fn(C.y01, C.x01), !v) : (s.arc(E.cx, E.cy, P, fn(E.y01, E.x01), fn(E.y11, E.x11), !v), s.arc(0, 0, f, fn(E.cy + E.y11, E.cx + E.x11), fn(C.cy + C.y11, C.cx + C.x11), !v), s.arc(C.cx, C.cy, P, fn(C.y11, C.x11), fn(C.y01, C.x01), !v))) : (s.moveTo(z, B), s.arc(0, 0, f, w, I, !v)) : s.moveTo(z, B), !(d > hn) || !(g > hn) ? s.lineTo(W, L) : R > hn ? (E = bc(W, L, S, $, d, -R, v), C = bc(z, B, j, N, d, -R, v), s.lineTo(E.cx + E.x01, E.cy + E.y01), R < _ ? s.arc(E.cx, E.cy, R, fn(E.y01, E.x01), fn(C.y01, C.x01), !v) : (s.arc(E.cx, E.cy, R, fn(E.y01, E.x01), fn(E.y11, E.x11), !v), s.arc(0, 0, d, fn(E.cy + E.y11, E.cx + E.x11), fn(C.cy + C.y11, C.cx + C.x11), v), s.arc(C.cx, C.cy, R, fn(C.y11, C.x11), fn(C.y01, C.x01), !v))) : s.arc(0, 0, d, k, M, v);
    }
    if (s.closePath(), l) return s = null, l + "" || null;
  }
  return c.centroid = function() {
    var l = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, u = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - Wi / 2;
    return [sa(u) * l, Or(u) * l];
  }, c.innerRadius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Ze(+l), c) : e;
  }, c.outerRadius = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Ze(+l), c) : t;
  }, c.cornerRadius = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Ze(+l), c) : n;
  }, c.padRadius = function(l) {
    return arguments.length ? (r = l == null ? null : typeof l == "function" ? l : Ze(+l), c) : r;
  }, c.startAngle = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : Ze(+l), c) : i;
  }, c.endAngle = function(l) {
    return arguments.length ? (a = typeof l == "function" ? l : Ze(+l), c) : a;
  }, c.padAngle = function(l) {
    return arguments.length ? (o = typeof l == "function" ? l : Ze(+l), c) : o;
  }, c.context = function(l) {
    return arguments.length ? (s = l ?? null, c) : s;
  }, c;
}
function yS(e) {
  this._context = e;
}
yS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function qf(e) {
  return new yS(e);
}
function jg(e) {
  return e[0];
}
function $g(e) {
  return e[1];
}
function Wg() {
  var e = jg, t = $g, n = Ze(!0), r = null, i = qf, a = null;
  function o(s) {
    var c, l = s.length, u, d = !1, f;
    for (r == null && (a = i(f = qi())), c = 0; c <= l; ++c)
      !(c < l && n(u = s[c], c, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(u, c, s), +t(u, c, s));
    if (f) return a = null, f + "" || null;
  }
  return o.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Ze(+s), o) : e;
  }, o.y = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Ze(+s), o) : t;
  }, o.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Ze(!!s), o) : n;
  }, o.curve = function(s) {
    return arguments.length ? (i = s, r != null && (a = i(r)), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = i(r = s), o) : r;
  }, o;
}
function AS() {
  var e = jg, t = null, n = Ze(0), r = $g, i = Ze(!0), a = null, o = qf, s = null;
  function c(u) {
    var d, f, h, m = u.length, y, v = !1, w, I = new Array(m), M = new Array(m);
    for (a == null && (s = o(w = qi())), d = 0; d <= m; ++d) {
      if (!(d < m && i(y = u[d], d, u)) === v)
        if (v = !v)
          f = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), h = d - 1; h >= f; --h)
            s.point(I[h], M[h]);
          s.lineEnd(), s.areaEnd();
        }
      v && (I[d] = +e(y, d, u), M[d] = +n(y, d, u), s.point(t ? +t(y, d, u) : I[d], r ? +r(y, d, u) : M[d]));
    }
    if (w) return s = null, w + "" || null;
  }
  function l() {
    return Wg().defined(i).curve(o).context(a);
  }
  return c.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Ze(+u), t = null, c) : e;
  }, c.x0 = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Ze(+u), c) : e;
  }, c.x1 = function(u) {
    return arguments.length ? (t = u == null ? null : typeof u == "function" ? u : Ze(+u), c) : t;
  }, c.y = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : Ze(+u), r = null, c) : n;
  }, c.y0 = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : Ze(+u), c) : n;
  }, c.y1 = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : Ze(+u), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(e).y(n);
  }, c.lineY1 = function() {
    return l().x(e).y(r);
  }, c.lineX1 = function() {
    return l().x(t).y(n);
  }, c.defined = function(u) {
    return arguments.length ? (i = typeof u == "function" ? u : Ze(!!u), c) : i;
  }, c.curve = function(u) {
    return arguments.length ? (o = u, a != null && (s = o(a)), c) : o;
  }, c.context = function(u) {
    return arguments.length ? (u == null ? a = s = null : s = o(a = u), c) : a;
  }, c;
}
function T8(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function M8(e) {
  return e;
}
function I8() {
  var e = M8, t = T8, n = null, r = Ze(0), i = Ze(zi), a = Ze(0);
  function o(s) {
    var c, l = s.length, u, d, f = 0, h = new Array(l), m = new Array(l), y = +r.apply(this, arguments), v = Math.min(zi, Math.max(-zi, i.apply(this, arguments) - y)), w, I = Math.min(Math.abs(v) / l, a.apply(this, arguments)), M = I * (v < 0 ? -1 : 1), k;
    for (c = 0; c < l; ++c)
      (k = m[h[c] = c] = +e(s[c], c, s)) > 0 && (f += k);
    for (t != null ? h.sort(function(g, A) {
      return t(m[g], m[A]);
    }) : n != null && h.sort(function(g, A) {
      return n(s[g], s[A]);
    }), c = 0, d = f ? (v - l * M) / f : 0; c < l; ++c, y = w)
      u = h[c], k = m[u], w = y + (k > 0 ? k * d : 0) + M, m[u] = {
        data: s[u],
        index: c,
        value: k,
        startAngle: y,
        endAngle: w,
        padAngle: I
      };
    return m;
  }
  return o.value = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Ze(+s), o) : e;
  }, o.sortValues = function(s) {
    return arguments.length ? (t = s, n = null, o) : t;
  }, o.sort = function(s) {
    return arguments.length ? (n = s, t = null, o) : n;
  }, o.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Ze(+s), o) : r;
  }, o.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : Ze(+s), o) : i;
  }, o.padAngle = function(s) {
    return arguments.length ? (a = typeof s == "function" ? s : Ze(+s), o) : a;
  }, o;
}
var vS = Ug(qf);
function xS(e) {
  this._curve = e;
}
xS.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(e, t) {
    this._curve.point(t * Math.sin(e), t * -Math.cos(e));
  }
};
function Ug(e) {
  function t(n) {
    return new xS(e(n));
  }
  return t._curve = e, t;
}
function Cs(e) {
  var t = e.curve;
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e.curve = function(n) {
    return arguments.length ? t(Ug(n)) : t()._curve;
  }, e;
}
function lA() {
  return Cs(Wg().curve(vS));
}
function cA() {
  var e = AS().curve(vS), t = e.curve, n = e.lineX0, r = e.lineX1, i = e.lineY0, a = e.lineY1;
  return e.angle = e.x, delete e.x, e.startAngle = e.x0, delete e.x0, e.endAngle = e.x1, delete e.x1, e.radius = e.y, delete e.y, e.innerRadius = e.y0, delete e.y0, e.outerRadius = e.y1, delete e.y1, e.lineStartAngle = function() {
    return Cs(n());
  }, delete e.lineX0, e.lineEndAngle = function() {
    return Cs(r());
  }, delete e.lineX1, e.lineInnerRadius = function() {
    return Cs(i());
  }, delete e.lineY0, e.lineOuterRadius = function() {
    return Cs(a());
  }, delete e.lineY1, e.curve = function(o) {
    return arguments.length ? t(Ug(o)) : t()._curve;
  }, e;
}
function Es(e, t) {
  return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
}
var Tp = Array.prototype.slice;
function N8(e) {
  return e.source;
}
function O8(e) {
  return e.target;
}
function Hg(e) {
  var t = N8, n = O8, r = jg, i = $g, a = null;
  function o() {
    var s, c = Tp.call(arguments), l = t.apply(this, c), u = n.apply(this, c);
    if (a || (a = s = qi()), e(a, +r.apply(this, (c[0] = l, c)), +i.apply(this, c), +r.apply(this, (c[0] = u, c)), +i.apply(this, c)), s) return a = null, s + "" || null;
  }
  return o.source = function(s) {
    return arguments.length ? (t = s, o) : t;
  }, o.target = function(s) {
    return arguments.length ? (n = s, o) : n;
  }, o.x = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Ze(+s), o) : r;
  }, o.y = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : Ze(+s), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (a = s ?? null, o) : a;
  }, o;
}
function R8(e, t, n, r, i) {
  e.moveTo(t, n), e.bezierCurveTo(t = (t + r) / 2, n, t, i, r, i);
}
function D8(e, t, n, r, i) {
  e.moveTo(t, n), e.bezierCurveTo(t, n = (n + i) / 2, r, n, r, i);
}
function P8(e, t, n, r, i) {
  var a = Es(t, n), o = Es(t, n = (n + i) / 2), s = Es(r, n), c = Es(r, i);
  e.moveTo(a[0], a[1]), e.bezierCurveTo(o[0], o[1], s[0], s[1], c[0], c[1]);
}
function L8() {
  return Hg(R8);
}
function z8() {
  return Hg(D8);
}
function B8() {
  var e = Hg(P8);
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e;
}
const Gg = {
  draw: function(e, t) {
    var n = Math.sqrt(t / Wi);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, zi);
  }
}, bS = {
  draw: function(e, t) {
    var n = Math.sqrt(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
};
var wS = Math.sqrt(1 / 3), F8 = wS * 2;
const _S = {
  draw: function(e, t) {
    var n = Math.sqrt(t / F8), r = n * wS;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
};
var Y8 = 0.8908130915292852, SS = Math.sin(Wi / 10) / Math.sin(7 * Wi / 10), j8 = Math.sin(zi / 10) * SS, $8 = -Math.cos(zi / 10) * SS;
const CS = {
  draw: function(e, t) {
    var n = Math.sqrt(t * Y8), r = j8 * n, i = $8 * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (var a = 1; a < 5; ++a) {
      var o = zi * a / 5, s = Math.cos(o), c = Math.sin(o);
      e.lineTo(c * n, -s * n), e.lineTo(s * r - c * i, c * r + s * i);
    }
    e.closePath();
  }
}, ES = {
  draw: function(e, t) {
    var n = Math.sqrt(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
};
var Xd = Math.sqrt(3);
const kS = {
  draw: function(e, t) {
    var n = -Math.sqrt(t / (Xd * 3));
    e.moveTo(0, n * 2), e.lineTo(-Xd * n, -n), e.lineTo(Xd * n, -n), e.closePath();
  }
};
var Jn = -0.5, Kn = Math.sqrt(3) / 2, Mp = 1 / Math.sqrt(12), W8 = (Mp / 2 + 1) * 3;
const TS = {
  draw: function(e, t) {
    var n = Math.sqrt(t / W8), r = n / 2, i = n * Mp, a = r, o = n * Mp + n, s = -a, c = o;
    e.moveTo(r, i), e.lineTo(a, o), e.lineTo(s, c), e.lineTo(Jn * r - Kn * i, Kn * r + Jn * i), e.lineTo(Jn * a - Kn * o, Kn * a + Jn * o), e.lineTo(Jn * s - Kn * c, Kn * s + Jn * c), e.lineTo(Jn * r + Kn * i, Jn * i - Kn * r), e.lineTo(Jn * a + Kn * o, Jn * o - Kn * a), e.lineTo(Jn * s + Kn * c, Jn * c - Kn * s), e.closePath();
  }
};
var U8 = [
  Gg,
  bS,
  _S,
  ES,
  CS,
  kS,
  TS
];
function H8() {
  var e = Ze(Gg), t = Ze(64), n = null;
  function r() {
    var i;
    if (n || (n = i = qi()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), i) return n = null, i + "" || null;
  }
  return r.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Ze(i), r) : e;
  }, r.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Ze(+i), r) : t;
  }, r.context = function(i) {
    return arguments.length ? (n = i ?? null, r) : n;
  }, r;
}
function Ui() {
}
function Wu(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function Xf(e) {
  this._context = e;
}
Xf.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Wu(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Wu(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function G8(e) {
  return new Xf(e);
}
function MS(e) {
  this._context = e;
}
MS.prototype = {
  areaStart: Ui,
  areaEnd: Ui,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Wu(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function V8(e) {
  return new MS(e);
}
function IS(e) {
  this._context = e;
}
IS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        Wu(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Q8(e) {
  return new IS(e);
}
function NS(e, t) {
  this._basis = new Xf(e), this._beta = t;
}
NS.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], i = t[0], a = e[n] - r, o = t[n] - i, s = -1, c; ++s <= n; )
        c = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + c * a),
          this._beta * t[s] + (1 - this._beta) * (i + c * o)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const q8 = function e(t) {
  function n(r) {
    return t === 1 ? new Xf(r) : new NS(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function Uu(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function Vg(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
Vg.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        Uu(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        Uu(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const X8 = function e(t) {
  function n(r) {
    return new Vg(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function Qg(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
Qg.prototype = {
  areaStart: Ui,
  areaEnd: Ui,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        Uu(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const J8 = function e(t) {
  function n(r) {
    return new Qg(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function qg(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
qg.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        Uu(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const K8 = function e(t) {
  function n(r) {
    return new qg(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function Xg(e, t, n) {
  var r = e._x1, i = e._y1, a = e._x2, o = e._y2;
  if (e._l01_a > hn) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, c = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / c, i = (i * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / c;
  }
  if (e._l23_a > hn) {
    var l = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, u = 3 * e._l23_a * (e._l23_a + e._l12_a);
    a = (a * l + e._x1 * e._l23_2a - t * e._l12_2a) / u, o = (o * l + e._y1 * e._l23_2a - n * e._l12_2a) / u;
  }
  e._context.bezierCurveTo(r, i, a, o, e._x2, e._y2);
}
function OS(e, t) {
  this._context = e, this._alpha = t;
}
OS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        Xg(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Z8 = function e(t) {
  function n(r) {
    return t ? new OS(r, t) : new Vg(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function RS(e, t) {
  this._context = e, this._alpha = t;
}
RS.prototype = {
  areaStart: Ui,
  areaEnd: Ui,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        Xg(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const eY = function e(t) {
  function n(r) {
    return t ? new RS(r, t) : new Qg(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function DS(e, t) {
  this._context = e, this._alpha = t;
}
DS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        Xg(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const tY = function e(t) {
  function n(r) {
    return t ? new DS(r, t) : new qg(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function PS(e) {
  this._context = e;
}
PS.prototype = {
  areaStart: Ui,
  areaEnd: Ui,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function nY(e) {
  return new PS(e);
}
function uA(e) {
  return e < 0 ? -1 : 1;
}
function fA(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (r || i < 0 && -0), o = (n - e._y1) / (i || r < 0 && -0), s = (a * i + o * r) / (r + i);
  return (uA(a) + uA(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function dA(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Jd(e, t, n) {
  var r = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, a - s, o - s * n, a, o);
}
function Hu(e) {
  this._context = e;
}
Hu.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Jd(this, this._t0, dA(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Jd(this, dA(this, n = fA(this, e, t)), n);
          break;
        default:
          Jd(this, this._t0, n = fA(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function LS(e) {
  this._context = new zS(e);
}
(LS.prototype = Object.create(Hu.prototype)).point = function(e, t) {
  Hu.prototype.point.call(this, t, e);
};
function zS(e) {
  this._context = e;
}
zS.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, a) {
    this._context.bezierCurveTo(t, e, r, n, a, i);
  }
};
function rY(e) {
  return new Hu(e);
}
function iY(e) {
  return new LS(e);
}
function BS(e) {
  this._context = e;
}
BS.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = hA(e), i = hA(t), a = 0, o = 1; o < n; ++a, ++o)
          this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function hA(e) {
  var t, n = e.length - 1, r, i = new Array(n), a = new Array(n), o = new Array(n);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, a[n - 1] = 7, o[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / a[t - 1], a[t] -= r, o[t] -= r * o[t - 1];
  for (i[n - 1] = o[n - 1] / a[n - 1], t = n - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function aY(e) {
  return new BS(e);
}
function Jf(e, t) {
  this._context = e, this._t = t;
}
Jf.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function oY(e) {
  return new Jf(e, 0.5);
}
function sY(e) {
  return new Jf(e, 0);
}
function lY(e) {
  return new Jf(e, 1);
}
function ko(e, t) {
  if ((o = e.length) > 1)
    for (var n = 1, r, i, a = e[t[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = e[t[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function To(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function cY(e, t) {
  return e[t];
}
function uY() {
  var e = Ze([]), t = To, n = ko, r = cY;
  function i(a) {
    var o = e.apply(this, arguments), s, c = a.length, l = o.length, u = new Array(l), d;
    for (s = 0; s < l; ++s) {
      for (var f = o[s], h = u[s] = new Array(c), m = 0, y; m < c; ++m)
        h[m] = y = [0, +r(a[m], f, m, a)], y.data = a[m];
      h.key = f;
    }
    for (s = 0, d = t(u); s < l; ++s)
      u[d[s]].index = s;
    return n(u, d), u;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Ze(Tp.call(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Ze(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? To : typeof a == "function" ? a : Ze(Tp.call(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (n = a ?? ko, i) : n;
  }, i;
}
function fY(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = n = 0; n < r; ++n) o += e[n][i][1] || 0;
      if (o) for (n = 0; n < r; ++n) e[n][i][1] /= o;
    }
    ko(e, t);
  }
}
function dY(e, t) {
  if ((c = e.length) > 1)
    for (var n, r = 0, i, a, o, s, c, l = e[t[0]].length; r < l; ++r)
      for (o = s = 0, n = 0; n < c; ++n)
        (a = (i = e[t[n]][r])[1] - i[0]) >= 0 ? (i[0] = o, i[1] = o += a) : a < 0 ? (i[1] = s, i[0] = s += a) : i[0] = o;
}
function hY(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, a = r.length; n < a; ++n) {
      for (var o = 0, s = 0; o < i; ++o) s += e[o][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    ko(e, t);
  }
}
function pY(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, a, o; r < a; ++r) {
      for (var s = 0, c = 0, l = 0; s < o; ++s) {
        for (var u = e[t[s]], d = u[r][1] || 0, f = u[r - 1][1] || 0, h = (d - f) / 2, m = 0; m < s; ++m) {
          var y = e[t[m]], v = y[r][1] || 0, w = y[r - 1][1] || 0;
          h += v - w;
        }
        c += d, l += h * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
    }
    i[r - 1][1] += i[r - 1][0] = n, ko(e, t);
  }
}
function FS(e) {
  var t = e.map(YS);
  return To(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function YS(e) {
  for (var t = 0, n = -1, r = e.length, i; ++n < r; ) (i = +e[n][1]) && (t += i);
  return t;
}
function mY(e) {
  return FS(e).reverse();
}
function gY(e) {
  var t = e.length, n, r, i = e.map(YS), a = To(e).sort(function(u, d) {
    return i[d] - i[u];
  }), o = 0, s = 0, c = [], l = [];
  for (n = 0; n < t; ++n)
    r = a[n], o < s ? (o += i[r], c.push(r)) : (s += i[r], l.push(r));
  return l.reverse().concat(c);
}
function yY(e) {
  return To(e).reverse();
}
function pA(e) {
  return function() {
    return e;
  };
}
function AY(e) {
  return e[0];
}
function vY(e) {
  return e[1];
}
function Gu() {
  this._ = null;
}
function Kf(e) {
  e.U = // parent node
  e.C = // color - true for red, false for black
  e.L = // left node
  e.R = // right node
  e.P = // previous node
  e.N = null;
}
Gu.prototype = {
  constructor: Gu,
  insert: function(e, t) {
    var n, r, i;
    if (e) {
      if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
        for (e = e.R; e.L; ) e = e.L;
        e.L = t;
      } else
        e.R = t;
      n = e;
    } else this._ ? (e = mA(this._), t.P = null, t.N = e, e.P = e.L = t, n = e) : (t.P = t.N = null, this._ = t, n = null);
    for (t.L = t.R = null, t.U = n, t.C = !0, e = t; n && n.C; )
      r = n.U, n === r.L ? (i = r.R, i && i.C ? (n.C = i.C = !1, r.C = !0, e = r) : (e === n.R && (os(this, n), e = n, n = e.U), n.C = !1, r.C = !0, ss(this, r))) : (i = r.L, i && i.C ? (n.C = i.C = !1, r.C = !0, e = r) : (e === n.L && (ss(this, n), e = n, n = e.U), n.C = !1, r.C = !0, os(this, r))), n = e.U;
    this._.C = !1;
  },
  remove: function(e) {
    e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
    var t = e.U, n, r = e.L, i = e.R, a, o;
    if (r ? i ? a = mA(i) : a = r : a = i, t ? t.L === e ? t.L = a : t.R = a : this._ = a, r && i ? (o = a.C, a.C = e.C, a.L = r, r.U = a, a !== i ? (t = a.U, a.U = e.U, e = a.R, t.L = e, a.R = i, i.U = a) : (a.U = t, t = a, e = a.R)) : (o = e.C, e = a), e && (e.U = t), !o) {
      if (e && e.C) {
        e.C = !1;
        return;
      }
      do {
        if (e === this._) break;
        if (e === t.L) {
          if (n = t.R, n.C && (n.C = !1, t.C = !0, os(this, t), n = t.R), n.L && n.L.C || n.R && n.R.C) {
            (!n.R || !n.R.C) && (n.L.C = !1, n.C = !0, ss(this, n), n = t.R), n.C = t.C, t.C = n.R.C = !1, os(this, t), e = this._;
            break;
          }
        } else if (n = t.L, n.C && (n.C = !1, t.C = !0, ss(this, t), n = t.L), n.L && n.L.C || n.R && n.R.C) {
          (!n.L || !n.L.C) && (n.R.C = !1, n.C = !0, os(this, n), n = t.L), n.C = t.C, t.C = n.L.C = !1, ss(this, t), e = this._;
          break;
        }
        n.C = !0, e = t, t = t.U;
      } while (!e.C);
      e && (e.C = !1);
    }
  }
};
function os(e, t) {
  var n = t, r = t.R, i = n.U;
  i ? i.L === n ? i.L = r : i.R = r : e._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
}
function ss(e, t) {
  var n = t, r = t.L, i = n.U;
  i ? i.L === n ? i.L = r : i.R = r : e._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
}
function mA(e) {
  for (; e.L; ) e = e.L;
  return e;
}
function ks(e, t, n, r) {
  var i = [null, null], a = pn.push(i) - 1;
  return i.left = e, i.right = t, n && Vu(i, e, t, n), r && Vu(i, t, e, r), Un[e.index].halfedges.push(a), Un[t.index].halfedges.push(a), i;
}
function ls(e, t, n) {
  var r = [t, n];
  return r.left = e, r;
}
function Vu(e, t, n, r) {
  !e[0] && !e[1] ? (e[0] = r, e.left = t, e.right = n) : e.left === n ? e[1] = r : e[0] = r;
}
function xY(e, t, n, r, i) {
  var a = e[0], o = e[1], s = a[0], c = a[1], l = o[0], u = o[1], d = 0, f = 1, h = l - s, m = u - c, y;
  if (y = t - s, !(!h && y > 0)) {
    if (y /= h, h < 0) {
      if (y < d) return;
      y < f && (f = y);
    } else if (h > 0) {
      if (y > f) return;
      y > d && (d = y);
    }
    if (y = r - s, !(!h && y < 0)) {
      if (y /= h, h < 0) {
        if (y > f) return;
        y > d && (d = y);
      } else if (h > 0) {
        if (y < d) return;
        y < f && (f = y);
      }
      if (y = n - c, !(!m && y > 0)) {
        if (y /= m, m < 0) {
          if (y < d) return;
          y < f && (f = y);
        } else if (m > 0) {
          if (y > f) return;
          y > d && (d = y);
        }
        if (y = i - c, !(!m && y < 0)) {
          if (y /= m, m < 0) {
            if (y > f) return;
            y > d && (d = y);
          } else if (m > 0) {
            if (y < d) return;
            y < f && (f = y);
          }
          return !(d > 0) && !(f < 1) || (d > 0 && (e[0] = [s + d * h, c + d * m]), f < 1 && (e[1] = [s + f * h, c + f * m])), !0;
        }
      }
    }
  }
}
function bY(e, t, n, r, i) {
  var a = e[1];
  if (a) return !0;
  var o = e[0], s = e.left, c = e.right, l = s[0], u = s[1], d = c[0], f = c[1], h = (l + d) / 2, m = (u + f) / 2, y, v;
  if (f === u) {
    if (h < t || h >= r) return;
    if (l > d) {
      if (!o) o = [h, n];
      else if (o[1] >= i) return;
      a = [h, i];
    } else {
      if (!o) o = [h, i];
      else if (o[1] < n) return;
      a = [h, n];
    }
  } else if (y = (l - d) / (f - u), v = m - y * h, y < -1 || y > 1)
    if (l > d) {
      if (!o) o = [(n - v) / y, n];
      else if (o[1] >= i) return;
      a = [(i - v) / y, i];
    } else {
      if (!o) o = [(i - v) / y, i];
      else if (o[1] < n) return;
      a = [(n - v) / y, n];
    }
  else if (u < f) {
    if (!o) o = [t, y * t + v];
    else if (o[0] >= r) return;
    a = [r, y * r + v];
  } else {
    if (!o) o = [r, y * r + v];
    else if (o[0] < t) return;
    a = [t, y * t + v];
  }
  return e[0] = o, e[1] = a, !0;
}
function wY(e, t, n, r) {
  for (var i = pn.length, a; i--; )
    (!bY(a = pn[i], e, t, n, r) || !xY(a, e, t, n, r) || !(Math.abs(a[0][0] - a[1][0]) > mt || Math.abs(a[0][1] - a[1][1]) > mt)) && delete pn[i];
}
function _Y(e) {
  return Un[e.index] = {
    site: e,
    halfedges: []
  };
}
function SY(e, t) {
  var n = e.site, r = t.left, i = t.right;
  return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = t[1], i = t[0]) : (r = t[0], i = t[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
}
function jS(e, t) {
  return t[+(t.left !== e.site)];
}
function CY(e, t) {
  return t[+(t.left === e.site)];
}
function EY() {
  for (var e = 0, t = Un.length, n, r, i, a; e < t; ++e)
    if ((n = Un[e]) && (a = (r = n.halfedges).length)) {
      var o = new Array(a), s = new Array(a);
      for (i = 0; i < a; ++i) o[i] = i, s[i] = SY(n, pn[r[i]]);
      for (o.sort(function(c, l) {
        return s[l] - s[c];
      }), i = 0; i < a; ++i) s[i] = r[o[i]];
      for (i = 0; i < a; ++i) r[i] = s[i];
    }
}
function kY(e, t, n, r) {
  var i = Un.length, a, o, s, c, l, u, d, f, h, m, y, v, w = !0;
  for (a = 0; a < i; ++a)
    if (o = Un[a]) {
      for (s = o.site, l = o.halfedges, c = l.length; c--; )
        pn[l[c]] || l.splice(c, 1);
      for (c = 0, u = l.length; c < u; )
        m = CY(o, pn[l[c]]), y = m[0], v = m[1], d = jS(o, pn[l[++c % u]]), f = d[0], h = d[1], (Math.abs(y - f) > mt || Math.abs(v - h) > mt) && (l.splice(c, 0, pn.push(ls(
          s,
          m,
          Math.abs(y - e) < mt && r - v > mt ? [e, Math.abs(f - e) < mt ? h : r] : Math.abs(v - r) < mt && n - y > mt ? [Math.abs(h - r) < mt ? f : n, r] : Math.abs(y - n) < mt && v - t > mt ? [n, Math.abs(f - n) < mt ? h : t] : Math.abs(v - t) < mt && y - e > mt ? [Math.abs(h - t) < mt ? f : e, t] : null
        )) - 1), ++u);
      u && (w = !1);
    }
  if (w) {
    var I, M, k, g = 1 / 0;
    for (a = 0, w = null; a < i; ++a)
      (o = Un[a]) && (s = o.site, I = s[0] - e, M = s[1] - t, k = I * I + M * M, k < g && (g = k, w = o));
    if (w) {
      var A = [e, t], b = [e, r], x = [n, r], _ = [n, t];
      w.halfedges.push(
        pn.push(ls(s = w.site, A, b)) - 1,
        pn.push(ls(s, b, x)) - 1,
        pn.push(ls(s, x, _)) - 1,
        pn.push(ls(s, _, A)) - 1
      );
    }
  }
  for (a = 0; a < i; ++a)
    (o = Un[a]) && (o.halfedges.length || delete Un[a]);
}
var $S = [], Jg;
function TY() {
  Kf(this), this.x = this.y = this.arc = this.site = this.cy = null;
}
function eo(e) {
  var t = e.P, n = e.N;
  if (!(!t || !n)) {
    var r = t.site, i = e.site, a = n.site;
    if (r !== a) {
      var o = i[0], s = i[1], c = r[0] - o, l = r[1] - s, u = a[0] - o, d = a[1] - s, f = 2 * (c * d - l * u);
      if (!(f >= -1e-12)) {
        var h = c * c + l * l, m = u * u + d * d, y = (d * h - l * m) / f, v = (c * m - u * h) / f, w = $S.pop() || new TY();
        w.arc = e, w.site = i, w.x = y + o, w.y = (w.cy = v + s) + Math.sqrt(y * y + v * v), e.circle = w;
        for (var I = null, M = Al._; M; )
          if (w.y < M.y || w.y === M.y && w.x <= M.x)
            if (M.L) M = M.L;
            else {
              I = M.P;
              break;
            }
          else if (M.R) M = M.R;
          else {
            I = M;
            break;
          }
        Al.insert(I, w), I || (Jg = w);
      }
    }
  }
}
function ho(e) {
  var t = e.circle;
  t && (t.P || (Jg = t.N), Al.remove(t), $S.push(t), Kf(t), e.circle = null);
}
var WS = [];
function MY() {
  Kf(this), this.edge = this.site = this.circle = null;
}
function gA(e) {
  var t = WS.pop() || new MY();
  return t.site = e, t;
}
function Kd(e) {
  ho(e), po.remove(e), WS.push(e), Kf(e);
}
function IY(e) {
  var t = e.circle, n = t.x, r = t.cy, i = [n, r], a = e.P, o = e.N, s = [e];
  Kd(e);
  for (var c = a; c.circle && Math.abs(n - c.circle.x) < mt && Math.abs(r - c.circle.cy) < mt; )
    a = c.P, s.unshift(c), Kd(c), c = a;
  s.unshift(c), ho(c);
  for (var l = o; l.circle && Math.abs(n - l.circle.x) < mt && Math.abs(r - l.circle.cy) < mt; )
    o = l.N, s.push(l), Kd(l), l = o;
  s.push(l), ho(l);
  var u = s.length, d;
  for (d = 1; d < u; ++d)
    l = s[d], c = s[d - 1], Vu(l.edge, c.site, l.site, i);
  c = s[0], l = s[u - 1], l.edge = ks(c.site, l.site, null, i), eo(c), eo(l);
}
function NY(e) {
  for (var t = e[0], n = e[1], r, i, a, o, s = po._; s; )
    if (a = US(s, n) - t, a > mt) s = s.L;
    else if (o = t - OY(s, n), o > mt) {
      if (!s.R) {
        r = s;
        break;
      }
      s = s.R;
    } else {
      a > -mt ? (r = s.P, i = s) : o > -mt ? (r = s, i = s.N) : r = i = s;
      break;
    }
  _Y(e);
  var c = gA(e);
  if (po.insert(r, c), !(!r && !i)) {
    if (r === i) {
      ho(r), i = gA(r.site), po.insert(c, i), c.edge = i.edge = ks(r.site, c.site), eo(r), eo(i);
      return;
    }
    if (!i) {
      c.edge = ks(r.site, c.site);
      return;
    }
    ho(r), ho(i);
    var l = r.site, u = l[0], d = l[1], f = e[0] - u, h = e[1] - d, m = i.site, y = m[0] - u, v = m[1] - d, w = 2 * (f * v - h * y), I = f * f + h * h, M = y * y + v * v, k = [(v * I - h * M) / w + u, (f * M - y * I) / w + d];
    Vu(i.edge, l, m, k), c.edge = ks(l, e, null, k), i.edge = ks(e, m, null, k), eo(r), eo(i);
  }
}
function US(e, t) {
  var n = e.site, r = n[0], i = n[1], a = i - t;
  if (!a) return r;
  var o = e.P;
  if (!o) return -1 / 0;
  n = o.site;
  var s = n[0], c = n[1], l = c - t;
  if (!l) return s;
  var u = s - r, d = 1 / a - 1 / l, f = u / l;
  return d ? (-f + Math.sqrt(f * f - 2 * d * (u * u / (-2 * l) - c + l / 2 + i - a / 2))) / d + r : (r + s) / 2;
}
function OY(e, t) {
  var n = e.N;
  if (n) return US(n, t);
  var r = e.site;
  return r[1] === t ? r[0] : 1 / 0;
}
var mt = 1e-6, po, Un, Al, pn;
function RY(e, t, n) {
  return (e[0] - n[0]) * (t[1] - e[1]) - (e[0] - t[0]) * (n[1] - e[1]);
}
function DY(e, t) {
  return t[1] - e[1] || t[0] - e[0];
}
function Ip(e, t) {
  var n = e.sort(DY).pop(), r, i, a;
  for (pn = [], Un = new Array(e.length), po = new Gu(), Al = new Gu(); ; )
    if (a = Jg, n && (!a || n[1] < a.y || n[1] === a.y && n[0] < a.x))
      (n[0] !== r || n[1] !== i) && (NY(n), r = n[0], i = n[1]), n = e.pop();
    else if (a)
      IY(a.arc);
    else
      break;
  if (EY(), t) {
    var o = +t[0][0], s = +t[0][1], c = +t[1][0], l = +t[1][1];
    wY(o, s, c, l), kY(o, s, c, l);
  }
  this.edges = pn, this.cells = Un, po = Al = pn = Un = null;
}
Ip.prototype = {
  constructor: Ip,
  polygons: function() {
    var e = this.edges;
    return this.cells.map(function(t) {
      var n = t.halfedges.map(function(r) {
        return jS(t, e[r]);
      });
      return n.data = t.site.data, n;
    });
  },
  triangles: function() {
    var e = [], t = this.edges;
    return this.cells.forEach(function(n, r) {
      if (s = (a = n.halfedges).length)
        for (var i = n.site, a, o = -1, s, c, l = t[a[s - 1]], u = l.left === i ? l.right : l.left; ++o < s; )
          c = u, l = t[a[o]], u = l.left === i ? l.right : l.left, c && u && r < c.index && r < u.index && RY(i, c, u) < 0 && e.push([i.data, c.data, u.data]);
    }), e;
  },
  links: function() {
    return this.edges.filter(function(e) {
      return e.right;
    }).map(function(e) {
      return {
        source: e.left.data,
        target: e.right.data
      };
    });
  },
  find: function(e, t, n) {
    for (var r = this, i, a = r._found || 0, o = r.cells.length, s; !(s = r.cells[a]); ) if (++a >= o) return null;
    var c = e - s.site[0], l = t - s.site[1], u = c * c + l * l;
    do
      s = r.cells[i = a], a = null, s.halfedges.forEach(function(d) {
        var f = r.edges[d], h = f.left;
        if (!((h === s.site || !h) && !(h = f.right))) {
          var m = e - h[0], y = t - h[1], v = m * m + y * y;
          v < u && (u = v, a = h.index);
        }
      });
    while (a !== null);
    return r._found = i, n == null || u <= n * n ? s.site : null;
  }
};
function PY() {
  var e = AY, t = vY, n = null;
  function r(i) {
    return new Ip(i.map(function(a, o) {
      var s = [Math.round(e(a, o, i) / mt) * mt, Math.round(t(a, o, i) / mt) * mt];
      return s.index = o, s.data = a, s;
    }), n);
  }
  return r.polygons = function(i) {
    return r(i).polygons();
  }, r.links = function(i) {
    return r(i).links();
  }, r.triangles = function(i) {
    return r(i).triangles();
  }, r.x = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : pA(+i), r) : e;
  }, r.y = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : pA(+i), r) : t;
  }, r.extent = function(i) {
    return arguments.length ? (n = i == null ? null : [[+i[0][0], +i[0][1]], [+i[1][0], +i[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
  }, r.size = function(i) {
    return arguments.length ? (n = i == null ? null : [[0, 0], [+i[0], +i[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
  }, r;
}
function wc(e) {
  return function() {
    return e;
  };
}
function LY(e, t, n) {
  this.target = e, this.type = t, this.transform = n;
}
function pi(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
pi.prototype = {
  constructor: pi,
  scale: function(e) {
    return e === 1 ? this : new pi(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new pi(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Zf = new pi(1, 0, 0);
HS.prototype = pi.prototype;
function HS(e) {
  return e.__zoom || Zf;
}
function Zd() {
  Ne.stopImmediatePropagation();
}
function cs() {
  Ne.preventDefault(), Ne.stopImmediatePropagation();
}
function zY() {
  return !Ne.button;
}
function BY() {
  var e = this, t, n;
  return e instanceof SVGElement ? (e = e.ownerSVGElement || e, t = e.width.baseVal.value, n = e.height.baseVal.value) : (t = e.clientWidth, n = e.clientHeight), [[0, 0], [t, n]];
}
function yA() {
  return this.__zoom || Zf;
}
function FY() {
  return -Ne.deltaY * (Ne.deltaMode ? 120 : 1) / 500;
}
function YY() {
  return "ontouchstart" in this;
}
function jY(e, t, n) {
  var r = e.invertX(t[0][0]) - n[0][0], i = e.invertX(t[1][0]) - n[1][0], a = e.invertY(t[0][1]) - n[0][1], o = e.invertY(t[1][1]) - n[1][1];
  return e.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function $Y() {
  var e = zY, t = BY, n = jY, r = FY, i = YY, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, c = Aw, l = [], u = Vi("start", "zoom", "end"), d, f, h = 500, m = 150, y = 0;
  function v(C) {
    C.property("__zoom", yA).on("wheel.zoom", b).on("mousedown.zoom", x).on("dblclick.zoom", _).filter(i).on("touchstart.zoom", R).on("touchmove.zoom", P).on("touchend.zoom touchcancel.zoom", E).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  v.transform = function(C, T) {
    var D = C.selection ? C.selection() : C;
    D.property("__zoom", yA), C !== D ? k(C, T) : D.interrupt().each(function() {
      g(this, arguments).start().zoom(null, typeof T == "function" ? T.apply(this, arguments) : T).end();
    });
  }, v.scaleBy = function(C, T) {
    v.scaleTo(C, function() {
      var D = this.__zoom.k, z = typeof T == "function" ? T.apply(this, arguments) : T;
      return D * z;
    });
  }, v.scaleTo = function(C, T) {
    v.transform(C, function() {
      var D = t.apply(this, arguments), z = this.__zoom, B = M(D), W = z.invert(B), L = typeof T == "function" ? T.apply(this, arguments) : T;
      return n(I(w(z, L), B, W), D, o);
    });
  }, v.translateBy = function(C, T, D) {
    v.transform(C, function() {
      return n(this.__zoom.translate(
        typeof T == "function" ? T.apply(this, arguments) : T,
        typeof D == "function" ? D.apply(this, arguments) : D
      ), t.apply(this, arguments), o);
    });
  }, v.translateTo = function(C, T, D) {
    v.transform(C, function() {
      var z = t.apply(this, arguments), B = this.__zoom, W = M(z);
      return n(Zf.translate(W[0], W[1]).scale(B.k).translate(
        typeof T == "function" ? -T.apply(this, arguments) : -T,
        typeof D == "function" ? -D.apply(this, arguments) : -D
      ), z, o);
    });
  };
  function w(C, T) {
    return T = Math.max(a[0], Math.min(a[1], T)), T === C.k ? C : new pi(T, C.x, C.y);
  }
  function I(C, T, D) {
    var z = T[0] - D[0] * C.k, B = T[1] - D[1] * C.k;
    return z === C.x && B === C.y ? C : new pi(C.k, z, B);
  }
  function M(C) {
    return [(+C[0][0] + +C[1][0]) / 2, (+C[0][1] + +C[1][1]) / 2];
  }
  function k(C, T, D) {
    C.on("start.zoom", function() {
      g(this, arguments).start();
    }).on("interrupt.zoom end.zoom", function() {
      g(this, arguments).end();
    }).tween("zoom", function() {
      var z = this, B = arguments, W = g(z, B), L = t.apply(z, B), S = D || M(L), $ = Math.max(L[1][0] - L[0][0], L[1][1] - L[0][1]), j = z.__zoom, N = typeof T == "function" ? T.apply(z, B) : T, q = c(j.invert(S).concat($ / j.k), N.invert(S).concat($ / N.k));
      return function(G) {
        if (G === 1) G = N;
        else {
          var X = q(G), Y = $ / X[2];
          G = new pi(Y, S[0] - X[0] * Y, S[1] - X[1] * Y);
        }
        W.zoom(null, G);
      };
    });
  }
  function g(C, T) {
    for (var D = 0, z = l.length, B; D < z; ++D)
      if ((B = l[D]).that === C)
        return B;
    return new A(C, T);
  }
  function A(C, T) {
    this.that = C, this.args = T, this.index = -1, this.active = 0, this.extent = t.apply(C, T);
  }
  A.prototype = {
    start: function() {
      return ++this.active === 1 && (this.index = l.push(this) - 1, this.emit("start")), this;
    },
    zoom: function(C, T) {
      return this.mouse && C !== "mouse" && (this.mouse[1] = T.invert(this.mouse[0])), this.touch0 && C !== "touch" && (this.touch0[1] = T.invert(this.touch0[0])), this.touch1 && C !== "touch" && (this.touch1[1] = T.invert(this.touch1[0])), this.that.__zoom = T, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (l.splice(this.index, 1), this.index = -1, this.emit("end")), this;
    },
    emit: function(C) {
      Js(new LY(v, C, this.that.__zoom), u.apply, u, [C, this.that, this.args]);
    }
  };
  function b() {
    if (!e.apply(this, arguments)) return;
    var C = g(this, arguments), T = this.__zoom, D = Math.max(a[0], Math.min(a[1], T.k * Math.pow(2, r.apply(this, arguments)))), z = Oi(this);
    if (C.wheel)
      (C.mouse[0][0] !== z[0] || C.mouse[0][1] !== z[1]) && (C.mouse[1] = T.invert(C.mouse[0] = z)), clearTimeout(C.wheel);
    else {
      if (T.k === D) return;
      C.mouse = [z, T.invert(z)], Aa(this), C.start();
    }
    cs(), C.wheel = setTimeout(B, m), C.zoom("mouse", n(I(w(T, D), C.mouse[0], C.mouse[1]), C.extent, o));
    function B() {
      C.wheel = null, C.end();
    }
  }
  function x() {
    if (f || !e.apply(this, arguments)) return;
    var C = g(this, arguments), T = Ut(Ne.view).on("mousemove.zoom", W, !0).on("mouseup.zoom", L, !0), D = Oi(this), z = Ne.clientX, B = Ne.clientY;
    Tf(Ne.view), Zd(), C.mouse = [D, this.__zoom.invert(D)], Aa(this), C.start();
    function W() {
      if (cs(), !C.moved) {
        var S = Ne.clientX - z, $ = Ne.clientY - B;
        C.moved = S * S + $ * $ > y;
      }
      C.zoom("mouse", n(I(C.that.__zoom, C.mouse[0] = Oi(C.that), C.mouse[1]), C.extent, o));
    }
    function L() {
      T.on("mousemove.zoom mouseup.zoom", null), Mf(Ne.view, C.moved), cs(), C.end();
    }
  }
  function _() {
    if (e.apply(this, arguments)) {
      var C = this.__zoom, T = Oi(this), D = C.invert(T), z = C.k * (Ne.shiftKey ? 0.5 : 2), B = n(I(w(C, z), T, D), t.apply(this, arguments), o);
      cs(), s > 0 ? Ut(this).transition().duration(s).call(k, B, T) : Ut(this).call(v.transform, B);
    }
  }
  function R() {
    if (e.apply(this, arguments)) {
      var C = g(this, arguments), T = Ne.changedTouches, D, z = T.length, B, W, L;
      for (Zd(), B = 0; B < z; ++B)
        W = T[B], L = su(this, T, W.identifier), L = [L, this.__zoom.invert(L), W.identifier], C.touch0 ? C.touch1 || (C.touch1 = L) : (C.touch0 = L, D = !0);
      if (d && (d = clearTimeout(d), !C.touch1)) {
        C.end(), L = Ut(this).on("dblclick.zoom"), L && L.apply(this, arguments);
        return;
      }
      D && (d = setTimeout(function() {
        d = null;
      }, h), Aa(this), C.start());
    }
  }
  function P() {
    var C = g(this, arguments), T = Ne.changedTouches, D = T.length, z, B, W, L;
    for (cs(), d && (d = clearTimeout(d)), z = 0; z < D; ++z)
      B = T[z], W = su(this, T, B.identifier), C.touch0 && C.touch0[2] === B.identifier ? C.touch0[0] = W : C.touch1 && C.touch1[2] === B.identifier && (C.touch1[0] = W);
    if (B = C.that.__zoom, C.touch1) {
      var S = C.touch0[0], $ = C.touch0[1], j = C.touch1[0], N = C.touch1[1], q = (q = j[0] - S[0]) * q + (q = j[1] - S[1]) * q, G = (G = N[0] - $[0]) * G + (G = N[1] - $[1]) * G;
      B = w(B, Math.sqrt(q / G)), W = [(S[0] + j[0]) / 2, (S[1] + j[1]) / 2], L = [($[0] + N[0]) / 2, ($[1] + N[1]) / 2];
    } else if (C.touch0) W = C.touch0[0], L = C.touch0[1];
    else return;
    C.zoom("touch", n(I(B, W, L), C.extent, o));
  }
  function E() {
    var C = g(this, arguments), T = Ne.changedTouches, D = T.length, z, B;
    for (Zd(), f && clearTimeout(f), f = setTimeout(function() {
      f = null;
    }, h), z = 0; z < D; ++z)
      B = T[z], C.touch0 && C.touch0[2] === B.identifier ? delete C.touch0 : C.touch1 && C.touch1[2] === B.identifier && delete C.touch1;
    C.touch1 && !C.touch0 && (C.touch0 = C.touch1, delete C.touch1), C.touch0 ? C.touch0[1] = this.__zoom.invert(C.touch0[0]) : C.end();
  }
  return v.wheelDelta = function(C) {
    return arguments.length ? (r = typeof C == "function" ? C : wc(+C), v) : r;
  }, v.filter = function(C) {
    return arguments.length ? (e = typeof C == "function" ? C : wc(!!C), v) : e;
  }, v.touchable = function(C) {
    return arguments.length ? (i = typeof C == "function" ? C : wc(!!C), v) : i;
  }, v.extent = function(C) {
    return arguments.length ? (t = typeof C == "function" ? C : wc([[+C[0][0], +C[0][1]], [+C[1][0], +C[1][1]]]), v) : t;
  }, v.scaleExtent = function(C) {
    return arguments.length ? (a[0] = +C[0], a[1] = +C[1], v) : [a[0], a[1]];
  }, v.translateExtent = function(C) {
    return arguments.length ? (o[0][0] = +C[0][0], o[1][0] = +C[1][0], o[0][1] = +C[0][1], o[1][1] = +C[1][1], v) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, v.constrain = function(C) {
    return arguments.length ? (n = C, v) : n;
  }, v.duration = function(C) {
    return arguments.length ? (s = +C, v) : s;
  }, v.interpolate = function(C) {
    return arguments.length ? (c = C, v) : c;
  }, v.on = function() {
    var C = u.on.apply(u, arguments);
    return C === u ? v : C;
  }, v.clickDistance = function(C) {
    return arguments.length ? (y = (C = +C) * C, v) : Math.sqrt(y);
  }, v;
}
const WY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  active: D5,
  arc: k8,
  area: AS,
  areaRadial: cA,
  ascending: Na,
  axisBottom: Yb,
  axisLeft: KD,
  axisRight: JD,
  axisTop: XD,
  bisect: wa,
  bisectLeft: CD,
  bisectRight: wa,
  bisector: Lm,
  brush: U5,
  brushSelection: j5,
  brushX: $5,
  brushY: W5,
  chord: G5,
  clientPoint: kf,
  cluster: h6,
  color: ji,
  create: bL,
  creator: Cf,
  cross: kD,
  csv: bB,
  csvFormat: u3,
  csvFormatRows: f3,
  csvParse: Dw,
  csvParseRows: c3,
  cubehelix: _r,
  curveBasis: G8,
  curveBasisClosed: V8,
  curveBasisOpen: Q8,
  curveBundle: q8,
  curveCardinal: X8,
  curveCardinalClosed: J8,
  curveCardinalOpen: K8,
  curveCatmullRom: Z8,
  curveCatmullRomClosed: eY,
  curveCatmullRomOpen: tY,
  curveLinear: qf,
  curveLinearClosed: nY,
  curveMonotoneX: rY,
  curveMonotoneY: iY,
  curveNatural: aY,
  curveStep: oY,
  curveStepAfter: lY,
  curveStepBefore: sY,
  customEvent: Js,
  descending: TD,
  deviation: Db,
  dispatch: Vi,
  drag: ML,
  dragDisable: Tf,
  dragEnable: Mf,
  dsvFormat: ig,
  easeBack: $y,
  easeBackIn: k5,
  easeBackInOut: $y,
  easeBackOut: T5,
  easeBounce: il,
  easeBounceIn: C5,
  easeBounceInOut: E5,
  easeBounceOut: il,
  easeCircle: jy,
  easeCircleIn: m5,
  easeCircleInOut: jy,
  easeCircleOut: g5,
  easeCubic: Kh,
  easeCubicIn: s5,
  easeCubicInOut: Kh,
  easeCubicOut: l5,
  easeElastic: Wy,
  easeElasticIn: M5,
  easeElasticInOut: I5,
  easeElasticOut: Wy,
  easeExp: Yy,
  easeExpIn: h5,
  easeExpInOut: Yy,
  easeExpOut: p5,
  easeLinear: i5,
  easePoly: By,
  easePolyIn: c5,
  easePolyInOut: By,
  easePolyOut: u5,
  easeQuad: zy,
  easeQuadIn: a5,
  easeQuadInOut: zy,
  easeQuadOut: o5,
  easeSin: Fy,
  easeSinIn: f5,
  easeSinInOut: Fy,
  easeSinOut: d5,
  entries: o3,
  get event() {
    return Ne;
  },
  extent: Pb,
  forceCenter: m3,
  forceCollide: D3,
  forceLink: L3,
  forceManyBody: $3,
  forceRadial: W3,
  forceSimulation: j3,
  forceX: U3,
  forceY: H3,
  get format() {
    return Ff;
  },
  formatDefaultLocale: Yw,
  formatLocale: Fw,
  get formatPrefix() {
    return sg;
  },
  formatSpecifier: ol,
  geoAlbers: C_,
  geoAlbersUsa: Vz,
  geoArea: ez,
  geoAzimuthalEqualArea: Qz,
  geoAzimuthalEqualAreaRaw: yg,
  geoAzimuthalEquidistant: qz,
  geoAzimuthalEquidistantRaw: Ag,
  geoBounds: iz,
  geoCentroid: uz,
  geoCircle: fz,
  geoClipAntimeridian: hp,
  geoClipCircle: c_,
  geoClipExtent: Az,
  geoClipRectangle: Yf,
  geoConicConformal: Jz,
  geoConicConformalRaw: T_,
  geoConicEqualArea: Fu,
  geoConicEqualAreaRaw: S_,
  geoConicEquidistant: Zz,
  geoConicEquidistantRaw: M_,
  geoContains: Cz,
  geoDistance: Rs,
  geoEquirectangular: Kz,
  geoEquirectangularRaw: ul,
  geoGnomonic: e6,
  geoGnomonicRaw: vg,
  geoGraticule: d_,
  geoGraticule10: Ez,
  geoIdentity: t6,
  geoInterpolate: kz,
  geoLength: u_,
  geoMercator: Xz,
  geoMercatorRaw: Ll,
  geoNaturalEarth1: n6,
  geoNaturalEarth1Raw: xg,
  geoOrthographic: r6,
  geoOrthographicRaw: bg,
  geoPath: Bz,
  geoProjection: Si,
  geoProjectionMutator: mg,
  geoRotation: r_,
  geoStereographic: i6,
  geoStereographicRaw: wg,
  geoStream: pr,
  geoTransform: Fz,
  geoTransverseMercator: a6,
  geoTransverseMercatorRaw: _g,
  hcl: fu,
  hierarchy: $f,
  histogram: OD,
  hsl: lu,
  html: gB,
  interpolate: Ol,
  interpolateArray: uw,
  interpolateBasis: ow,
  interpolateBasisClosed: sw,
  interpolateCool: h8,
  interpolateCubehelix: i4,
  interpolateCubehelixDefault: f8,
  interpolateCubehelixLong: Of,
  interpolateDate: fw,
  interpolateHcl: n4,
  interpolateHclLong: r4,
  interpolateHsl: ZL,
  interpolateHslLong: e4,
  interpolateInferno: y8,
  interpolateLab: t4,
  interpolateMagma: g8,
  interpolateNumber: $n,
  interpolateObject: dw,
  interpolatePlasma: A8,
  interpolateRainbow: p8,
  interpolateRgb: tl,
  interpolateRgbBasis: UL,
  interpolateRgbBasisClosed: HL,
  interpolateRound: hw,
  interpolateString: Xm,
  interpolateTransformCss: gw,
  interpolateTransformSvg: yw,
  interpolateViridis: m8,
  interpolateWarm: d8,
  interpolateZoom: Aw,
  interrupt: Aa,
  interval: c4,
  isoFormat: ZF,
  isoParse: t8,
  json: yB,
  keys: i3,
  lab: uu,
  line: Wg,
  lineRadial: lA,
  linkHorizontal: L8,
  linkRadial: B8,
  linkVertical: z8,
  local: Xb,
  map: Vr,
  matcher: Ym,
  max: PD,
  mean: LD,
  median: zD,
  merge: Bm,
  min: Bb,
  mouse: Oi,
  namespace: Il,
  namespaces: Wh,
  nest: t3,
  now: Lo,
  pack: B6,
  packEnclose: N_,
  packSiblings: P6,
  pairs: ED,
  partition: F6,
  path: qi,
  permute: BD,
  pie: I8,
  pointRadial: Es,
  polygonArea: Z6,
  polygonCentroid: eB,
  polygonContains: iB,
  polygonHull: rB,
  polygonLength: aB,
  precisionFixed: jw,
  precisionPrefix: $w,
  precisionRound: Ww,
  quadtree: Bf,
  quantile: Xs,
  quantize: a4,
  queue: j_,
  radialArea: cA,
  radialLine: lA,
  randomBates: dB,
  randomExponential: hB,
  randomIrwinHall: W_,
  randomLogNormal: fB,
  randomNormal: $_,
  randomUniform: uB,
  range: yr,
  request: Cg,
  rgb: Zs,
  ribbon: e3,
  scaleBand: Tg,
  scaleIdentity: Q_,
  scaleImplicit: kp,
  scaleLinear: fl,
  scaleLog: X_,
  scaleOrdinal: kg,
  scalePoint: _B,
  scalePow: Ng,
  scaleQuantile: J_,
  scaleQuantize: K_,
  scaleSequential: gS,
  scaleSqrt: OB,
  scaleThreshold: Z_,
  scaleTime: a8,
  scaleUtc: o8,
  scan: FD,
  schemeCategory10: s8,
  schemeCategory20: u8,
  schemeCategory20b: l8,
  schemeCategory20c: c8,
  select: Ut,
  selectAll: _L,
  selection: Oa,
  selector: Ef,
  selectorAll: Fm,
  set: Ow,
  shuffle: YD,
  stack: uY,
  stackOffsetDiverging: dY,
  stackOffsetExpand: fY,
  stackOffsetNone: ko,
  stackOffsetSilhouette: hY,
  stackOffsetWiggle: pY,
  stackOrderAscending: FS,
  stackOrderDescending: mY,
  stackOrderInsideOut: gY,
  stackOrderNone: To,
  stackOrderReverse: yY,
  stratify: W6,
  style: _a,
  sum: jD,
  symbol: H8,
  symbolCircle: Gg,
  symbolCross: bS,
  symbolDiamond: _S,
  symbolSquare: ES,
  symbolStar: CS,
  symbolTriangle: kS,
  symbolWye: TS,
  symbols: U8,
  text: AB,
  thresholdFreedmanDiaconis: RD,
  thresholdScott: DD,
  thresholdSturges: zb,
  tickIncrement: Ns,
  tickStep: qs,
  ticks: zm,
  timeDay: Fl,
  timeDays: PB,
  get timeFormat() {
    return Bg;
  },
  timeFormatDefaultLocale: pS,
  timeFormatLocale: uS,
  timeFriday: iS,
  timeFridays: YB,
  timeHour: Rg,
  timeHours: DB,
  timeInterval: Zt,
  timeMillisecond: Ta,
  timeMilliseconds: V1,
  timeMinute: Og,
  timeMinutes: RB,
  timeMonday: pl,
  timeMondays: LB,
  timeMonth: Dg,
  timeMonths: $B,
  get timeParse() {
    return hS;
  },
  timeSaturday: aS,
  timeSaturdays: jB,
  timeSecond: dl,
  timeSeconds: Q1,
  timeSunday: hl,
  timeSundays: q1,
  timeThursday: Ds,
  timeThursdays: FB,
  timeTuesday: nS,
  timeTuesdays: zB,
  timeWednesday: rS,
  timeWednesdays: BB,
  timeWeek: hl,
  timeWeeks: q1,
  timeYear: Ai,
  timeYears: WB,
  timeout: qh,
  timer: Df,
  timerFlush: Sw,
  touch: su,
  touches: SL,
  transition: kw,
  transpose: Fb,
  tree: q6,
  treemap: F_,
  treemapBinary: X6,
  treemapDice: zl,
  treemapResquarify: K6,
  treemapSlice: Wf,
  treemapSliceDice: J6,
  treemapSquarify: B_,
  tsv: wB,
  tsvFormat: h3,
  tsvFormatRows: p3,
  tsvParse: Pw,
  tsvParseRows: d3,
  utcDay: Yl,
  utcDays: GB,
  get utcFormat() {
    return Vf;
  },
  utcFriday: lS,
  utcFridays: JB,
  utcHour: Lg,
  utcHours: HB,
  utcMillisecond: Ta,
  utcMilliseconds: V1,
  utcMinute: Pg,
  utcMinutes: UB,
  utcMonday: gl,
  utcMondays: VB,
  utcMonth: zg,
  utcMonths: ZB,
  get utcParse() {
    return Fg;
  },
  utcSaturday: cS,
  utcSaturdays: KB,
  utcSecond: dl,
  utcSeconds: Q1,
  utcSunday: ml,
  utcSundays: X1,
  utcThursday: Ps,
  utcThursdays: XB,
  utcTuesday: oS,
  utcTuesdays: QB,
  utcWednesday: sS,
  utcWednesdays: qB,
  utcWeek: ml,
  utcWeeks: X1,
  utcYear: vi,
  utcYears: eF,
  values: a3,
  variance: Rb,
  version: _D,
  voronoi: PY,
  window: jm,
  xml: vB,
  zip: WD,
  zoom: $Y,
  zoomIdentity: Zf,
  zoomTransform: HS
}, Symbol.toStringTag, { value: "Module" })), UY = /* @__PURE__ */ sE(WY);
var eh = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
var AA;
function HY() {
  return AA || (AA = 1, function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.numeral = n();
    })(ba, function() {
      var t, n, r = "2.0.6", i = {}, a = {}, o = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: !0
      }, s = {
        currentLocale: o.currentLocale,
        zeroFormat: o.zeroFormat,
        nullFormat: o.nullFormat,
        defaultFormat: o.defaultFormat,
        scalePercentBy100: o.scalePercentBy100
      };
      function c(l, u) {
        this._input = l, this._value = u;
      }
      return t = function(l) {
        var u, d, f, h;
        if (t.isNumeral(l))
          u = l.value();
        else if (l === 0 || typeof l > "u")
          u = 0;
        else if (l === null || n.isNaN(l))
          u = null;
        else if (typeof l == "string")
          if (s.zeroFormat && l === s.zeroFormat)
            u = 0;
          else if (s.nullFormat && l === s.nullFormat || !l.replace(/[^0-9]+/g, "").length)
            u = null;
          else {
            for (d in i)
              if (h = typeof i[d].regexps.unformat == "function" ? i[d].regexps.unformat() : i[d].regexps.unformat, h && l.match(h)) {
                f = i[d].unformat;
                break;
              }
            f = f || t._.stringToNumber, u = f(l);
          }
        else
          u = Number(l) || null;
        return new c(l, u);
      }, t.version = r, t.isNumeral = function(l) {
        return l instanceof c;
      }, t._ = n = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(l, u, d) {
          var f = a[t.options.currentLocale], h = !1, m = !1, y = 0, v = "", w = 1e12, I = 1e9, M = 1e6, k = 1e3, g = "", A = !1, b, x, _, R, P, E, C;
          if (l = l || 0, x = Math.abs(l), t._.includes(u, "(") ? (h = !0, u = u.replace(/[\(|\)]/g, "")) : (t._.includes(u, "+") || t._.includes(u, "-")) && (P = t._.includes(u, "+") ? u.indexOf("+") : l < 0 ? u.indexOf("-") : -1, u = u.replace(/[\+|\-]/g, "")), t._.includes(u, "a") && (b = u.match(/a(k|m|b|t)?/), b = b ? b[1] : !1, t._.includes(u, " a") && (v = " "), u = u.replace(new RegExp(v + "a[kmbt]?"), ""), x >= w && !b || b === "t" ? (v += f.abbreviations.trillion, l = l / w) : x < w && x >= I && !b || b === "b" ? (v += f.abbreviations.billion, l = l / I) : x < I && x >= M && !b || b === "m" ? (v += f.abbreviations.million, l = l / M) : (x < M && x >= k && !b || b === "k") && (v += f.abbreviations.thousand, l = l / k)), t._.includes(u, "[.]") && (m = !0, u = u.replace("[.]", ".")), _ = l.toString().split(".")[0], R = u.split(".")[1], E = u.indexOf(","), y = (u.split(".")[0].split(",")[0].match(/0/g) || []).length, R ? (t._.includes(R, "[") ? (R = R.replace("]", ""), R = R.split("["), g = t._.toFixed(l, R[0].length + R[1].length, d, R[1].length)) : g = t._.toFixed(l, R.length, d), _ = g.split(".")[0], t._.includes(g, ".") ? g = f.delimiters.decimal + g.split(".")[1] : g = "", m && Number(g.slice(1)) === 0 && (g = "")) : _ = t._.toFixed(l, 0, d), v && !b && Number(_) >= 1e3 && v !== f.abbreviations.trillion)
            switch (_ = String(Number(_) / 1e3), v) {
              case f.abbreviations.thousand:
                v = f.abbreviations.million;
                break;
              case f.abbreviations.million:
                v = f.abbreviations.billion;
                break;
              case f.abbreviations.billion:
                v = f.abbreviations.trillion;
                break;
            }
          if (t._.includes(_, "-") && (_ = _.slice(1), A = !0), _.length < y)
            for (var T = y - _.length; T > 0; T--)
              _ = "0" + _;
          return E > -1 && (_ = _.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + f.delimiters.thousands)), u.indexOf(".") === 0 && (_ = ""), C = _ + g + (v || ""), h ? C = (h && A ? "(" : "") + C + (h && A ? ")" : "") : P >= 0 ? C = P === 0 ? (A ? "-" : "+") + C : C + (A ? "-" : "+") : A && (C = "-" + C), C;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(l) {
          var u = a[s.currentLocale], d = l, f = {
            thousand: 3,
            million: 6,
            billion: 9,
            trillion: 12
          }, h, m, y;
          if (s.zeroFormat && l === s.zeroFormat)
            m = 0;
          else if (s.nullFormat && l === s.nullFormat || !l.replace(/[^0-9]+/g, "").length)
            m = null;
          else {
            m = 1, u.delimiters.decimal !== "." && (l = l.replace(/\./g, "").replace(u.delimiters.decimal, "."));
            for (h in f)
              if (y = new RegExp("[^a-zA-Z]" + u.abbreviations[h] + "(?:\\)|(\\" + u.currency.symbol + ")?(?:\\))?)?$"), d.match(y)) {
                m *= Math.pow(10, f[h]);
                break;
              }
            m *= (l.split("-").length + Math.min(l.split("(").length - 1, l.split(")").length - 1)) % 2 ? 1 : -1, l = l.replace(/[^0-9\.]+/g, ""), m *= Number(l);
          }
          return m;
        },
        isNaN: function(l) {
          return typeof l == "number" && isNaN(l);
        },
        includes: function(l, u) {
          return l.indexOf(u) !== -1;
        },
        insert: function(l, u, d) {
          return l.slice(0, d) + u + l.slice(d);
        },
        reduce: function(l, u) {
          if (this === null)
            throw new TypeError("Array.prototype.reduce called on null or undefined");
          if (typeof u != "function")
            throw new TypeError(u + " is not a function");
          var d = Object(l), f = d.length >>> 0, h = 0, m;
          if (arguments.length === 3)
            m = arguments[2];
          else {
            for (; h < f && !(h in d); )
              h++;
            if (h >= f)
              throw new TypeError("Reduce of empty array with no initial value");
            m = d[h++];
          }
          for (; h < f; h++)
            h in d && (m = u(m, d[h], h, d));
          return m;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function(l) {
          var u = l.toString().split(".");
          return u.length < 2 ? 1 : Math.pow(10, u[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function() {
          var l = Array.prototype.slice.call(arguments);
          return l.reduce(function(u, d) {
            var f = n.multiplier(d);
            return u > f ? u : f;
          }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(l, u, d, f) {
          var h = l.toString().split("."), m = u - (f || 0), y, v, w, I;
          return h.length === 2 ? y = Math.min(Math.max(h[1].length, m), u) : y = m, w = Math.pow(10, y), I = (d(l + "e+" + y) / w).toFixed(y), f > u - y && (v = new RegExp("\\.?0{1," + (f - (u - y)) + "}$"), I = I.replace(v, "")), I;
        }
      }, t.options = s, t.formats = i, t.locales = a, t.locale = function(l) {
        return l && (s.currentLocale = l.toLowerCase()), s.currentLocale;
      }, t.localeData = function(l) {
        if (!l)
          return a[s.currentLocale];
        if (l = l.toLowerCase(), !a[l])
          throw new Error("Unknown locale : " + l);
        return a[l];
      }, t.reset = function() {
        for (var l in o)
          s[l] = o[l];
      }, t.zeroFormat = function(l) {
        s.zeroFormat = typeof l == "string" ? l : null;
      }, t.nullFormat = function(l) {
        s.nullFormat = typeof l == "string" ? l : null;
      }, t.defaultFormat = function(l) {
        s.defaultFormat = typeof l == "string" ? l : "0.0";
      }, t.register = function(l, u, d) {
        if (u = u.toLowerCase(), this[l + "s"][u])
          throw new TypeError(u + " " + l + " already registered.");
        return this[l + "s"][u] = d, d;
      }, t.validate = function(l, u) {
        var d, f, h, m, y, v, w, I;
        if (typeof l != "string" && (l += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", l)), l = l.trim(), l.match(/^\d+$/))
          return !0;
        if (l === "")
          return !1;
        try {
          w = t.localeData(u);
        } catch {
          w = t.localeData(t.locale());
        }
        return h = w.currency.symbol, y = w.abbreviations, d = w.delimiters.decimal, w.delimiters.thousands === "." ? f = "\\." : f = w.delimiters.thousands, I = l.match(/^[^\d]+/), I !== null && (l = l.substr(1), I[0] !== h) || (I = l.match(/[^\d]+$/), I !== null && (l = l.slice(0, -1), I[0] !== y.thousand && I[0] !== y.million && I[0] !== y.billion && I[0] !== y.trillion)) ? !1 : (v = new RegExp(f + "{2}"), l.match(/[^\d.,]/g) ? !1 : (m = l.split(d), m.length > 2 ? !1 : m.length < 2 ? !!m[0].match(/^\d+.*\d$/) && !m[0].match(v) : m[0].length === 1 ? !!m[0].match(/^\d+$/) && !m[0].match(v) && !!m[1].match(/^\d+$/) : !!m[0].match(/^\d+.*\d$/) && !m[0].match(v) && !!m[1].match(/^\d+$/)));
      }, t.fn = c.prototype = {
        clone: function() {
          return t(this);
        },
        format: function(l, u) {
          var d = this._value, f = l || s.defaultFormat, h, m, y;
          if (u = u || Math.round, d === 0 && s.zeroFormat !== null)
            m = s.zeroFormat;
          else if (d === null && s.nullFormat !== null)
            m = s.nullFormat;
          else {
            for (h in i)
              if (f.match(i[h].regexps.format)) {
                y = i[h].format;
                break;
              }
            y = y || t._.numberToFormat, m = y(d, f, u);
          }
          return m;
        },
        value: function() {
          return this._value;
        },
        input: function() {
          return this._input;
        },
        set: function(l) {
          return this._value = Number(l), this;
        },
        add: function(l) {
          var u = n.correctionFactor.call(null, this._value, l);
          function d(f, h, m, y) {
            return f + Math.round(u * h);
          }
          return this._value = n.reduce([this._value, l], d, 0) / u, this;
        },
        subtract: function(l) {
          var u = n.correctionFactor.call(null, this._value, l);
          function d(f, h, m, y) {
            return f - Math.round(u * h);
          }
          return this._value = n.reduce([l], d, Math.round(this._value * u)) / u, this;
        },
        multiply: function(l) {
          function u(d, f, h, m) {
            var y = n.correctionFactor(d, f);
            return Math.round(d * y) * Math.round(f * y) / Math.round(y * y);
          }
          return this._value = n.reduce([this._value, l], u, 1), this;
        },
        divide: function(l) {
          function u(d, f, h, m) {
            var y = n.correctionFactor(d, f);
            return Math.round(d * y) / Math.round(f * y);
          }
          return this._value = n.reduce([this._value, l], u), this;
        },
        difference: function(l) {
          return Math.abs(t(this._value).subtract(l).value());
        }
      }, t.register("locale", "en", {
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        ordinal: function(l) {
          var u = l % 10;
          return ~~(l % 100 / 10) === 1 ? "th" : u === 1 ? "st" : u === 2 ? "nd" : u === 3 ? "rd" : "th";
        },
        currency: {
          symbol: "$"
        }
      }), function() {
        t.register("format", "bps", {
          regexps: {
            format: /(BPS)/,
            unformat: /(BPS)/
          },
          format: function(l, u, d) {
            var f = t._.includes(u, " BPS") ? " " : "", h;
            return l = l * 1e4, u = u.replace(/\s?BPS/, ""), h = t._.numberToFormat(l, u, d), t._.includes(h, ")") ? (h = h.split(""), h.splice(-1, 0, f + "BPS"), h = h.join("")) : h = h + f + "BPS", h;
          },
          unformat: function(l) {
            return +(t._.stringToNumber(l) * 1e-4).toFixed(15);
          }
        });
      }(), function() {
        var l = {
          base: 1e3,
          suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        }, u = {
          base: 1024,
          suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
        }, d = l.suffixes.concat(u.suffixes.filter(function(h) {
          return l.suffixes.indexOf(h) < 0;
        })), f = d.join("|");
        f = "(" + f.replace("B", "B(?!PS)") + ")", t.register("format", "bytes", {
          regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(f)
          },
          format: function(h, m, y) {
            var v, w = t._.includes(m, "ib") ? u : l, I = t._.includes(m, " b") || t._.includes(m, " ib") ? " " : "", M, k, g;
            for (m = m.replace(/\s?i?b/, ""), M = 0; M <= w.suffixes.length; M++)
              if (k = Math.pow(w.base, M), g = Math.pow(w.base, M + 1), h === null || h === 0 || h >= k && h < g) {
                I += w.suffixes[M], k > 0 && (h = h / k);
                break;
              }
            return v = t._.numberToFormat(h, m, y), v + I;
          },
          unformat: function(h) {
            var m = t._.stringToNumber(h), y, v;
            if (m) {
              for (y = l.suffixes.length - 1; y >= 0; y--) {
                if (t._.includes(h, l.suffixes[y])) {
                  v = Math.pow(l.base, y);
                  break;
                }
                if (t._.includes(h, u.suffixes[y])) {
                  v = Math.pow(u.base, y);
                  break;
                }
              }
              m *= v || 1;
            }
            return m;
          }
        });
      }(), function() {
        t.register("format", "currency", {
          regexps: {
            format: /(\$)/
          },
          format: function(l, u, d) {
            var f = t.locales[t.options.currentLocale], h = {
              before: u.match(/^([\+|\-|\(|\s|\$]*)/)[0],
              after: u.match(/([\+|\-|\)|\s|\$]*)$/)[0]
            }, m, y, v;
            for (u = u.replace(/\s?\$\s?/, ""), m = t._.numberToFormat(l, u, d), l >= 0 ? (h.before = h.before.replace(/[\-\(]/, ""), h.after = h.after.replace(/[\-\)]/, "")) : l < 0 && !t._.includes(h.before, "-") && !t._.includes(h.before, "(") && (h.before = "-" + h.before), v = 0; v < h.before.length; v++)
              switch (y = h.before[v], y) {
                case "$":
                  m = t._.insert(m, f.currency.symbol, v);
                  break;
                case " ":
                  m = t._.insert(m, " ", v + f.currency.symbol.length - 1);
                  break;
              }
            for (v = h.after.length - 1; v >= 0; v--)
              switch (y = h.after[v], y) {
                case "$":
                  m = v === h.after.length - 1 ? m + f.currency.symbol : t._.insert(m, f.currency.symbol, -(h.after.length - (1 + v)));
                  break;
                case " ":
                  m = v === h.after.length - 1 ? m + " " : t._.insert(m, " ", -(h.after.length - (1 + v) + f.currency.symbol.length - 1));
                  break;
              }
            return m;
          }
        });
      }(), function() {
        t.register("format", "exponential", {
          regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
          },
          format: function(l, u, d) {
            var f, h = typeof l == "number" && !t._.isNaN(l) ? l.toExponential() : "0e+0", m = h.split("e");
            return u = u.replace(/e[\+|\-]{1}0/, ""), f = t._.numberToFormat(Number(m[0]), u, d), f + "e" + m[1];
          },
          unformat: function(l) {
            var u = t._.includes(l, "e+") ? l.split("e+") : l.split("e-"), d = Number(u[0]), f = Number(u[1]);
            f = t._.includes(l, "e-") ? f *= -1 : f;
            function h(m, y, v, w) {
              var I = t._.correctionFactor(m, y), M = m * I * (y * I) / (I * I);
              return M;
            }
            return t._.reduce([d, Math.pow(10, f)], h, 1);
          }
        });
      }(), function() {
        t.register("format", "ordinal", {
          regexps: {
            format: /(o)/
          },
          format: function(l, u, d) {
            var f = t.locales[t.options.currentLocale], h, m = t._.includes(u, " o") ? " " : "";
            return u = u.replace(/\s?o/, ""), m += f.ordinal(l), h = t._.numberToFormat(l, u, d), h + m;
          }
        });
      }(), function() {
        t.register("format", "percentage", {
          regexps: {
            format: /(%)/,
            unformat: /(%)/
          },
          format: function(l, u, d) {
            var f = t._.includes(u, " %") ? " " : "", h;
            return t.options.scalePercentBy100 && (l = l * 100), u = u.replace(/\s?\%/, ""), h = t._.numberToFormat(l, u, d), t._.includes(h, ")") ? (h = h.split(""), h.splice(-1, 0, f + "%"), h = h.join("")) : h = h + f + "%", h;
          },
          unformat: function(l) {
            var u = t._.stringToNumber(l);
            return t.options.scalePercentBy100 ? u * 0.01 : u;
          }
        });
      }(), function() {
        t.register("format", "time", {
          regexps: {
            format: /(:)/,
            unformat: /(:)/
          },
          format: function(l, u, d) {
            var f = Math.floor(l / 60 / 60), h = Math.floor((l - f * 60 * 60) / 60), m = Math.round(l - f * 60 * 60 - h * 60);
            return f + ":" + (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m);
          },
          unformat: function(l) {
            var u = l.split(":"), d = 0;
            return u.length === 3 ? (d = d + Number(u[0]) * 60 * 60, d = d + Number(u[1]) * 60, d = d + Number(u[2])) : u.length === 2 && (d = d + Number(u[0]) * 60, d = d + Number(u[1])), Number(d);
          }
        });
      }(), t;
    });
  }(eh)), eh.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(UY, qC, HY());
  })(self, function(n, r, i) {
    return (() => {
      var a = { 605: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "render", value: function(C, T, D, z, B) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var W = { margin: { top: 20, right: 30, bottom: 20, left: 40 }, yTicks: 4, xFormat: g.format(",.0f"), yFormat: g.format("s") }, L = D - (B = Object.assign({}, W, B)).margin.left - B.margin.right, S = z - B.margin.top - B.margin.bottom, $ = g.scaleLinear().domain(g.extent(C, function(Y) {
                return Y.x;
              })).range([0, L]), j = g.scaleLinear().domain([0, g.max(C, function(Y) {
                return Y.y;
              })]).range([S, 0]), N = g.axisBottom().scale($).tickFormat(B.xFormat).ticks(10), q = g.axisLeft().scale(j).tickFormat(B.yFormat).ticks(B.yTicks), G = g.area().x(function(Y) {
                return $(Y.x);
              }).y0(S).y1(function(Y) {
                return j(Y.y);
              }), X = this.createSvg(T, D, z).append("g").attr("transform", "translate(" + B.margin.left + "," + B.margin.top + ")");
              X.append("path").data([C]).attr("class", "area").attr("d", G), X.append("g").attr("class", "x axis").attr("transform", "translate(0," + S + ")").call(N), X.append("g").attr("class", "y axis").call(q);
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 648: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "render", value: function(C, T, D, z, B) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var W = this.getOptions({ maxPercent: 100 }, B), L = this.createSvg(T, D, z), S = L.append("g").attr("transform", "translate(".concat(D / 2, ", ").concat(z / 2, ")")), $ = Math.min(D - 10, z - 10) / 2, j = 0.3 * $, N = g.scaleLinear().domain([0, W.maxPercent]).range([j, $]), q = g.arc().innerRadius(j).outerRadius(function(Z) {
                return N(Z.data.percent);
              }), G = g.arc().innerRadius(j).outerRadius($), X = [0, 2 * Math.PI], Y = g.pie().sort(null).startAngle(X[0]).endAngle(X[1]).value(function(Z) {
                return Z.weight;
              });
              C.length > 1 && Y.padAngle(0.01), S.selectAll(".solidArc").data(Y(C)).enter().append("path").attr("fill", function(Z) {
                return W.colors(Z.data.id);
              }).attr("class", "solidArc").attr("d", q), S.selectAll(".outlineArc").data(Y(C)).enter().append("path").attr("fill", "none").attr("stroke", function(Z) {
                return W.colors(Z.data.id);
              }).attr("class", "outlineArc").attr("d", G), W.asterLabel && L.append("svg:text").attr("class", "aster-label").attr("dy", ".35em").attr("text-anchor", "middle").text(asterLabel());
              for (var Q = S.append("g").attr("class", "axisWrapper"), V = Math.ceil(W.maxPercent / 25), U = 1; U < V; U++) Q.append("circle").attr("class", "gridCircle").attr("r", N(25 * U)).style("fill", "none").style("stroke", "#c5c5c5").style("stroke-width", 0.6), U % 2 == 1 && (Q.append("rect").attr("x", -8).attr("y", -N(25 * U) - 5).attr("width", 20).style("height", 10).attr("fill", "#fff"), Q.append("text").attr("class", "axisLabel").attr("x", -6).attr("y", -N(25 * U)).attr("dy", ".4em").style("font-size", "8px").attr("fill", "#737373").text(function(Z, H) {
                return "".concat(25 * U, "%");
              }));
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 131: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "render", value: function(C, T, D, z, B) {
              var W = this;
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var L = this.getOptions({ label: "label", value: "value", rotate: 0, textAnchor: "middle", showLabels: !1 }, B), S = this.createSvg(T, D, z);
              this.useTip(function(re) {
                re.attr("class", "d3-tip").offset([-10, 0]).html(function(K) {
                  return K.value;
                });
              });
              var $ = L.label, j = L.value, N = 0;
              C.forEach(function(re) {
                N += re[j];
              });
              var q = D - L.margins.left - L.margins.right, G = z - L.margins.top - L.margins.bottom, X = g.scaleBand().range([0, q]).padding(0.1).round(1 / C.length), Y = g.scaleLinear().range([G, 0]), Q = g.axisBottom().scale(X).tickSize(2, 0), V = g.axisLeft().scale(Y).tickFormat(L.yFormat).ticks(5);
              X.domain(C.map(function(re) {
                return re[$];
              })), Y.domain([0, L.yMax || g.max(C, function(re) {
                return re[j];
              })]);
              var U = S.append("g").attr("class", "axis");
              U.call(Q);
              var Z = Math.round(U.node().getBBox().height), H = Math.round(U.node().getBBox().width);
              G -= Z, q -= Math.max(0, H - q), U.remove();
              var ee = S.append("g").attr("class", "axis");
              ee.call(V);
              var ie = Math.round(ee.node().getBBox().width);
              q -= ie, ee.remove(), X.range([0, q]), Y.range([G, 0]), (S = S.append("g").attr("transform", `translate(
	          `.concat(L.margins.left + ie, `,
	          `).concat(L.margins.top, `
	        )`))).append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(G, ")")).call(Q).selectAll(".tick text").style("text-anchor", L.textAnchor).attr("transform", function(re) {
                return "rotate(".concat(L.rotate, ")");
              }), L.wrap && S.selectAll(".tick text").call(this.wrap, X.bandwidth()), S.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(V), S.selectAll(".bar").data(C).enter().append("rect").attr("class", "bar").attr("x", function(re) {
                return X(re[$]);
              }).attr("width", X.bandwidth()).attr("y", function(re) {
                return Y(re[j]);
              }).attr("height", function(re) {
                return G - Y(re[j]);
              }).attr("title", function(re) {
                var K = "".concat(re[$], ": ").concat(W.formatters.commaseparated(re[j], ","));
                return K += " (".concat(N > 0 ? W.formatters.formatpercent(re[j] / N) : W.formatters.formatpercent(0), ")");
              }).style("fill", function(re) {
                return L.colors(re[$]);
              }).on("mouseover", function(re) {
                return W.tip.show(re, event.target);
              }).on("mouseout", function(re) {
                return W.tip.hide(re, event.target);
              }).exit().remove(), L.showLabels && S.selectAll(".barlabel").data(C).enter().append("text").attr("class", "barlabel").text(function(re) {
                return W.formatters.formatpercent(re[j] / N);
              }).attr("x", function(re) {
                return X(re[$]) + X.bandwidth() / 2;
              }).attr("y", function(re) {
                return Y(re[j]) - 3;
              }).attr("text-anchor", "middle");
            } }, { key: "formatters", get: function() {
              return { commaseparated: g.format(","), formatpercent: g.format(".1%") };
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 316: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "defaultTip", value: function(C, T) {
              C.attr("class", "d3-tip").offset(function(D) {
                return D.tipOffset || [-10, 0];
              }).direction(function(D) {
                return D.tipDirection || "n";
              }).html(function(D) {
                return `<table class='boxplotValues'>
					<tr>
						<td>Max:</td>
						<td>`.concat(T.valueFormatter(D.max), `</td>
					</tr>
					<tr>
						<td>P90:</td>
						<td>`).concat(T.valueFormatter(D.UIF), `</td>
					</tr>
					<tr>
						<td>P75:</td>
						<td>`).concat(T.valueFormatter(D.q3), `</td>
					</tr>
					<tr>
						<td>Median:</td>
						<td>`).concat(T.valueFormatter(D.median), `</td>
					</tr>
					<tr>
						<td>P25:</td>
						<td>`).concat(T.valueFormatter(D.q1), `</td>
					</tr>
					<tr>
						<td>P10:</td>
						<td>`).concat(T.valueFormatter(D.LIF), `</td>
					</tr>
					<tr>
						<td>Min:</td>
						<td>`).concat(T.valueFormatter(D.min), `</td>
					</tr>
				</table>`);
              });
            } }, { key: "render", value: function(C, T, D, z, B) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var W = { valueFormatter: this.formatters.formatSI(3) }, L = this.getOptions(W, B), S = this.createSvg(T, D, z);
              L.valueFormatter, this.useTip(this.defaultTip, L);
              var $ = 0, j = 0;
              if (L.xLabel) {
                var N = S.append("g").attr("transform", "translate(".concat(D / 2, ", ").concat(z - L.margins.bottom, ")"));
                N.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(L.xLabel), $ = N.node().getBBox().height;
              }
              if (L.yLabel) {
                var q = S.append("g").attr("transform", `translate(
	            `.concat(L.margins.left, `,
	            `).concat((z - L.margins.bottom - L.margins.top) / 2 + L.margins.top, `
	          )`));
                q.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(L.yLabel), j = q.node().getBBox().width;
              }
              var G = D - L.margins.left - j - L.margins.right, X = z - L.margins.top - $ - L.margins.bottom, Y = g.scaleBand().range([0, G]).round(1 / C.length).domain(C.map(function(fe) {
                return fe.Category;
              })), Q = g.scaleLinear().range([X, 0]).domain([L.yMin || 0, L.yMax || g.max(C, function(fe) {
                return fe.max;
              })]), V = g.axisBottom().scale(Y), U = g.axisLeft().scale(Q).tickFormat(L.yFormat).ticks(5), Z = S.append("g").attr("class", "axis");
              Z.call(V);
              var H = Math.round(Z.node().getBBox().height), ee = Math.round(Z.node().getBBox().width);
              X -= H, G -= Math.max(0, ee - G), Z.remove();
              var ie = S.append("g").attr("class", "axis");
              ie.call(U);
              var re = Math.round(ie.node().getBBox().width);
              G -= re, ie.remove(), Y.range([0, G]), Q.range([X, 0]);
              var K = Y.bandwidth() / 2 - 5, se = Y.bandwidth() / 2 - 2.5, xe = S.append("g").attr("transform", `translate(
	          `.concat(L.margins.left + j + re, `,
	          `).concat(L.margins.top, `
	        )`)), ke = xe.selectAll(".boxplot").data(C).enter().append("g").attr("class", "boxplot").attr("transform", function(fe) {
                return "translate(".concat(Y(fe.Category), ", 0)");
              }), ue = this;
              ke.each(function(fe) {
                var de = g.select(this);
                fe.LIF != fe.q1 && (de.append("line").attr("class", "bar").attr("x1", se).attr("y1", Q(fe.LIF)).attr("x2", se + 5).attr("y2", Q(fe.LIF)), de.append("line").attr("class", "whisker").attr("x1", Y.bandwidth() / 2).attr("y1", Q(fe.LIF)).attr("x2", Y.bandwidth() / 2).attr("y2", Q(fe.q1))), de.append("rect").attr("class", "box").attr("x", K).attr("y", Q(fe.q3)).attr("width", 10).attr("height", Math.max(1, Q(fe.q1) - Q(fe.q3))).on("mouseover", function(ce) {
                  return ue.tip.show(ce, event.target);
                }).on("mouseout", function(ce) {
                  return ue.tip.hide(ce, event.target);
                }), de.append("line").attr("class", "median").attr("x1", K).attr("y1", Q(fe.median)).attr("x2", K + 10).attr("y2", Q(fe.median)), fe.UIF != fe.q3 && (de.append("line").attr("class", "bar").attr("x1", se).attr("y1", Q(fe.UIF)).attr("x2", Y.bandwidth() - se).attr("y2", Q(fe.UIF)), de.append("line").attr("class", "whisker").attr("x1", Y.bandwidth() / 2).attr("y1", Q(fe.UIF)).attr("x2", Y.bandwidth() / 2).attr("y2", Q(fe.q3)));
              }), xe.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(X, ")")).call(V), xe.selectAll(".tick text").call(this.wrap, Y.bandwidth() || Y.range()), xe.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(U);
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 842: (c, l, u) => {
        var d, f;
        function h(m, y) {
          for (var v = 0; v < y.length; v++) {
            var w = y[v];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(m, w.key, w);
          }
        }
        d = [u(680), u(92), u(383)], f = (function(m, y, v) {
          var w = function() {
            function I() {
              (function(A, b) {
                if (!(A instanceof b)) throw new TypeError("Cannot call a class as a function");
              })(this, I);
            }
            var M, k, g;
            return M = I, k = [{ key: "render", value: function(A, b, x, _, R) {
              var P = this;
              typeof b == "string" && (b = document.querySelector(b)), this.cachedData = A, this.doResize || (this.doResize = y.debounce(function() {
                P.render(P.cachedData, b, b.clientWidth, b.clientHeight, R);
              }, 250), window.addEventListener("resize", this.doResize));
            } }, { key: "getOptions", value: function(A, b) {
              return Object.assign({}, { margins: { top: 10, right: 10, bottom: 10, left: 10 }, xFormat: m.format(",.0f"), yFormat: m.format("s"), colors: m.scaleOrdinal(m.schemeCategory20.concat(m.schemeCategory20c)) }, Object.assign({}, A), Object.assign({}, b));
            } }, { key: "createSvg", value: function(A, b, x) {
              this.destroyTipIfExists();
              var _ = m.select(A);
              _.select("svg").remove();
              var R = _.append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", `
	        0
	        0
	        `.concat(b, `
	        `).concat(x)).append("g").attr("class", "chart");
              return this.chart = R, R;
            } }, { key: "useTip", value: function() {
              var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
              }, b = arguments.length > 1 ? arguments[1] : void 0;
              return this.destroyTipIfExists(), this.tip = v().attr("class", "d3-tip"), A(this.tip, b), this.chart && this.chart.call(this.tip), this.tip;
            } }, { key: "destroyTipIfExists", value: function() {
              this.tip && this.tip.destroy();
            } }, { key: "truncate", value: function(A, b) {
              A.each(function() {
                for (var x = m.select(this), _ = x.text(), R = x.node().getComputedTextLength(), P = x.text(); R > b && P.length > 0; ) P = P.slice(0, -1), x.text("".concat(P, "...")), R = x.node().getComputedTextLength();
                x.append("title").text(_);
              });
            } }, { key: "wrap", value: function(A, b, x) {
              A.each(function() {
                for (var _, R = m.select(this), P = R.text(), E = R.text().split(/\s+/).reverse(), C = [], T = 0, D = 0, z = R.attr("y"), B = parseFloat(R.attr("dy")), W = R.text(null).append("tspan").attr("x", 0).attr("y", z).attr("dy", "".concat(B, "em")); _ = E.pop(); ) if (C.push(_), W.text(C.join(" ")), W.node().getComputedTextLength() > b) {
                  if (C.length > 1) {
                    C.pop(), E.push(_);
                    var L = x && ++D === x ? "".concat(C.splice(0, C.length - 1).join(" "), "...") : C.join(" ");
                    W.text(L);
                  }
                  if (C = [], W = R.append("tspan").attr("x", 0).attr("y", z).attr("dy", "".concat(1.1 * ++T + B, "em")), x && x === D) {
                    W.remove();
                    break;
                  }
                }
                R.append("title").text(P);
              });
            } }, { key: "tooltipFactory", value: function(A) {
              return function(b) {
                var x = "";
                if (A !== void 0) for (var _ = 0; _ < A.length; _ += 1) {
                  var R = A[_].accessor(b);
                  A[_].format !== void 0 && (R = A[_].format(R)), x += "".concat(A[_].label, ": ").concat(R, "</br>");
                }
                return x;
              };
            } }, { key: "lineDefaultTooltip", value: function(A, b, x, _, R, P, E) {
              return function(C) {
                var T = "";
                return E(C) && (T = "Series: ".concat(E(C), "</br>")), T += "".concat(A, ": ").concat(b(x(C)), "</br>"), T += "".concat(_, ": ").concat(R(P(C)));
              };
            } }, { key: "donutDefaultTooltip", value: function(A, b, x) {
              return function(_) {
                return "".concat(A(_), ": ").concat(b(_), " (").concat(x(_), ")");
              };
            } }, { key: "dispose", value: function() {
              this.destroyTipIfExists(), this.doResize && window.removeEventListener("resize", this.doResize);
            } }, { key: "formatters", get: function() {
              return { formatSI: function(A) {
                A = A || 0;
                var b = m.format(",.".concat(A, "s"));
                return function(x) {
                  return x < 1 ? x.toFixed(A).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "") : b(x).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "");
                };
              } };
            } }], g = [{ key: "normalizeDataframe", value: function(A) {
              var b = m.keys(A), x = Object.assign({}, A);
              return b.forEach(function(_) {
                A[_] instanceof Array || (x[_] = [A[_]]);
              }), x;
            } }, { key: "dataframeToArray", value: function(A) {
              var b = m.keys(A);
              return A[b[0]] instanceof Array ? A[b[0]].map(function(x, _) {
                var R = {};
                return b.forEach(function(P) {
                  R[P] = A[P][_];
                }), R;
              }) : [A];
            } }, { key: "mapMonthYearDataToSeries", value: function(A, b) {
              var x = Object.assign({}, { dateField: "x", yValue: "y", yPercent: "p" }, b), _ = { name: "All Time", values: [] };
              return A[x.dateField].map(function(R, P) {
                _.values.push({ xValue: new Date(Math.floor(A[x.dateField][P] / 100), A[x.dateField][P] % 100 - 1, 1), yValue: A[x.yValue][P], yPercent: A[x.yPercent][P] });
              }), _.values.sort(function(R, P) {
                return R.xValue - P.xValue;
              }), [_];
            } }, { key: "prepareData", value: function(A, b) {
              if (b === this.chartTypes.BOXPLOT) {
                if (!A.CATEGORY.length) return null;
                var x = A.CATEGORY.map(function(_, R) {
                  return { Category: A.CATEGORY[R], min: A.MIN_VALUE[R], max: A.MAX_VALUE[R], median: A.MEDIAN_VALUE[R], LIF: A.P10_VALUE[R], q1: A.P25_VALUE[R], q3: A.P75_VALUE[R], UIF: A.P90_VALUE[R] };
                }, A);
                return Object.values(x).reduce(function(_, R) {
                  return _.concat(R);
                }, []).length ? x : null;
              }
            } }, { key: "chartTypes", get: function() {
              return { AREA: "AREA", BOXPLOT: "BOXPLOT", DONUT: "DONUT", HISTOGRAM: "HISTOGRAM", LINE: "LINE", TRELLISLINE: "TRELLISLINE" };
            } }], k && h(M.prototype, k), g && h(M, g), I;
          }();
          return w;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 535: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(756), u(842)], f = (function(g, A, b) {
          var x = function(_) {
            (function(T, D) {
              if (typeof D != "function" && D !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(D && D.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), D && w(T, D);
            })(C, _);
            var R, P, E = I(C);
            function C() {
              return m(this, C), E.apply(this, arguments);
            }
            return R = C, (P = [{ key: "render", value: function(T, D, z, B, W) {
              var L = this;
              v(k(C.prototype), "render", this).call(this, T, D, z, B, W);
              var S = this.getOptions(W), $ = this.createSvg(D, z, B), j = 0;
              T.forEach(function(ee) {
                j += +ee.value;
              });
              var N = this.donutDefaultTooltip(function(ee) {
                return ee.label;
              }, function(ee) {
                return A(ee.value).format("0,0");
              }, function(ee) {
                return L.formatters.formatpercent(j != 0 ? ee.value / j : 0);
              });
              if (this.useTip(function(ee) {
                return ee.attr("class", "d3-tip").direction("s").offset([3, 0]).html(N);
              }), T.length > 0) {
                var q = $.append("g").attr("id", "chart"), G = g.drag().on("drag", function() {
                  var ee = g.select(this), ie = event.y - parseFloat(ee.attr("initialY"));
                  if (isNaN(ie)) return !1;
                  ee.attr("transform", `translate(
	        `.concat(parseFloat(ee.attr("initialPositionX")), `,
	        `).concat(parseFloat(ee.attr("initialPositionY")) + ie, `
	      )`));
                }).on("start", function() {
                  var ee = g.select(this);
                  ee.attr("initialX", event.x), ee.attr("initialY", event.y);
                }).on("end", function() {
                  var ee = g.select(this);
                  ee.transition().duration(300).attr("transform", `translate(
	          `.concat(ee.attr("initialPositionX"), `,
	          `).concat(ee.attr("initialPositionY"), `
	        )`));
                }), X = $.append("g").attr("class", "legend").call(G);
                X.selectAll("rect").data(T).enter().append("rect").attr("x", 0).attr("y", function(ee, ie) {
                  return 15 * ie;
                }).attr("width", 10).attr("height", 10).style("fill", function(ee) {
                  return S.colors(ee.id);
                });
                var Y = 0, Q = X.selectAll("g.legend-item").data(T).enter().append("g").attr("class", "legend-item");
                Q.append("text").attr("x", 12).attr("y", function(ee, ie) {
                  return 15 * ie + 9;
                }).text(function(ee) {
                  return ee.label;
                }), Q.append("title").attr("x", 12).attr("y", function(ee, ie) {
                  return 15 * ie + 9;
                }).text(function(ee) {
                  return ee.label;
                }), Q.each(function() {
                  var ee = this.getBBox().width;
                  ee > Y && Y + ee < 0.75 * z && (Y = ee);
                }), Y += 12, X.attr("transform", `translate(
	            `.concat(z - Y - S.margins.right, `,
	            `).concat(S.margins.top, `
	          )`)).attr("initialPositionX", z - Y - S.margins.right).attr("initialPositionY", S.margins.top), q.attr("transform", "translate(".concat((z - Y) / 2, ", ").concat(B / 2, ")"));
                var V = Math.min(B, z - Y) / 2 - S.margins.top, U = Math.min(B, z - Y) / 6 - S.margins.top, Z = g.arc().innerRadius(U).outerRadius(V), H = g.pie().value(function(ee) {
                  return ee.value > 0 ? Math.max(ee.value, 0.015 * j) : 0;
                });
                q.selectAll("g.slice").data(H(T)).enter().append("g").attr("class", "slice").append("path").attr("fill", function(ee) {
                  return S.colors(ee.data.id);
                }).attr("stroke", "#fff").attr("stroke-width", 5).attr("title", function(ee) {
                  return ee.label;
                }).on("mouseover", function(ee) {
                  return L.tip.show(ee.data, event.target);
                }).on("mouseout", function(ee) {
                  return L.tip.hide(ee.data, event.target);
                }).attr("d", Z);
              } else $.append("text").attr("transform", "translate(".concat(z / 2, ", ").concat(B / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "formatters", get: function() {
              return { formatpercent: g.format(".1%") };
            } }]) && y(R.prototype, P), C;
          }(b);
          return x;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 502: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(756), u(842)], f = (function(g, A, b) {
          var x = function(_) {
            (function(D, z) {
              if (typeof z != "function" && z !== null) throw new TypeError("Super expression must either be null or a function");
              D.prototype = Object.create(z && z.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), z && w(D, z);
            })(T, _);
            var R, P, E, C = I(T);
            function T() {
              return m(this, T), C.apply(this, arguments);
            }
            return R = T, E = [{ key: "mapHistogram", value: function(D) {
              for (var z = [], B = D.OFFSET || 0, W = D.INTERVAL_SIZE, L = this.normalizeDataframe(D.DATA), S = 0; S < D.INTERVALS; S += 1) {
                var $ = {};
                $.x = B + 1 * L.INTERVAL_INDEX[S] * W, $.dx = W, $.y = L.COUNT_VALUE[S] || 0, z.push($);
              }
              return z;
            } }], (P = [{ key: "drawBoxplot", value: function(D, z, B, W) {
              var L = D, S = this.xScale, $ = W / 2;
              z.LIF !== z.q1 && (L.append("line").attr("class", "bar").attr("x1", S(z.LIF)).attr("y1", W / 2 - $ / 2).attr("x2", S(z.LIF)).attr("y2", W / 2 + $ / 2), L.append("line").attr("class", "whisker").attr("x1", S(z.LIF)).attr("y1", W / 2).attr("x2", S(z.q1)).attr("y2", W / 2)), L.append("rect").attr("class", "box").attr("x", S(z.q1)).attr("width", S(z.q3) - S(z.q1)).attr("height", W), L.append("line").attr("class", "median").attr("x1", S(z.median)).attr("y1", 0).attr("x2", S(z.median)).attr("y2", W), z.UIF !== z.q3 && (L.append("line").attr("class", "bar").attr("x1", S(z.UIF)).attr("y1", W / 2 - $ / 2).attr("x2", S(z.UIF)).attr("y2", W / 2 + $ / 2), L.append("line").attr("class", "whisker").attr("x1", S(z.q3)).attr("y1", W / 2).attr("x2", S(z.UIF)).attr("y2", W / 2));
            } }, { key: "render", value: function(D, z, B, W, L) {
              var S = this;
              v(k(T.prototype), "render", this).call(this, D, z, B, W, L);
              var $ = { ticks: 10, yTicks: 4, yScale: g.scaleLinear(), boxplotHeight: 10, getTooltipBuilder: null }, j = this.getOptions($, L), N = this.createSvg(z, B, W);
              this.xScale = {};
              var q = D || [], G = typeof j.getTooltipBuilder == "function" ? j.getTooltipBuilder(j) : function(ce) {
                return A(ce.y).format("0,0");
              };
              this.useTip(function(ce) {
                ce.attr("class", "d3-tip").offset([-10, 0]).html(G);
              });
              var X = 0, Y = 0;
              if (j.xLabel) {
                var Q = N.append("g").attr("transform", "translate(".concat(B / 2, ", ").concat(W - j.margins.bottom, ")"));
                Q.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(j.xLabel), X = Q.node().getBBox().height;
              }
              if (j.yLabel) {
                var V = N.append("g").attr("transform", `translate(
	            `.concat(j.margins.left, `,
	            `).concat((W - j.margins.bottom - j.margins.top) / 2 + j.margins.top, `
	          )`));
                V.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(j.yLabel), Y = 1.5 * V.node().getBBox().width;
              }
              var U = B - j.margins.left - j.margins.right - Y, Z = W - j.margins.top - j.margins.bottom - X, H = this.xScale = g.scaleLinear().domain(j.xDomain || [g.min(q, function(ce) {
                return ce.x;
              }), g.max(q, function(ce) {
                return ce.x + ce.dx;
              })]).range([0, U]), ee = g.axisBottom().scale(H).ticks(j.ticks).tickFormat(j.xFormat), ie = j.yScale.domain([0, j.yMax || g.max(q, function(ce) {
                return ce.y;
              })]).range([Z, 0]), re = g.axisLeft().scale(ie).ticks(j.yTicks).tickFormat(j.yFormat), K = N.append("g").attr("class", "axis");
              K.call(ee);
              var se = Math.round(K.node().getBBox().height), xe = Math.round(K.node().getBBox().width);
              Z -= se, U -= Math.max(0, xe - U), K.remove();
              var ke = N.append("g").attr("class", "axis");
              ke.call(re);
              var ue = Math.round(ke.node().getBBox().width);
              if (U -= ue, ke.remove(), j.boxplot) {
                Z -= 12;
                var fe = N.append("g").attr("class", "boxplot").attr("transform", "translate(".concat(j.margins.left + Y + ue, `,
	          `).concat(j.margins.top + Z + se, ")"));
                this.drawBoxplot(fe, j.boxplot, U, 8);
              }
              H.range([0, U]), ie.range([Z, 0]);
              var de = N.append("g").attr("transform", `translate(
	        `.concat(j.margins.left + Y + ue, `,
	        `).concat(j.margins.top, ")"));
              de.selectAll(".bar").data(q).enter().append("g").attr("class", "bar").attr("transform", function(ce) {
                return "translate(".concat(H(ce.x), ", ").concat(ie(ce.y), ")");
              }).on("mouseover", function(ce) {
                return S.tip.show(ce, event.target);
              }).on("mouseout", function(ce) {
                return S.tip.hide(ce, event.target);
              }).append("rect").attr("x", 1).attr("width", function(ce) {
                return Math.max(H(ce.x + ce.dx) - H(ce.x) - 1, 0.5);
              }).attr("height", function(ce) {
                return Z - ie(ce.y);
              }), de.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Z, ")")).call(ee), de.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(re);
            } }]) && y(R.prototype, P), E && y(R, E), T;
          }(b);
          return x;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 487: (c, l, u) => {
        var d, f;
        function h(k) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
            return typeof g;
          } : function(g) {
            return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
          }, h(k);
        }
        function m(k, g) {
          if (!(k instanceof g)) throw new TypeError("Cannot call a class as a function");
        }
        function y(k, g) {
          for (var A = 0; A < g.length; A++) {
            var b = g[A];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(k, b.key, b);
          }
        }
        function v(k, g) {
          return v = Object.setPrototypeOf || function(A, b) {
            return A.__proto__ = b, A;
          }, v(k, g);
        }
        function w(k) {
          var g = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var A, b = M(k);
            if (g) {
              var x = M(this).constructor;
              A = Reflect.construct(b, arguments, x);
            } else A = b.apply(this, arguments);
            return I(this, A);
          };
        }
        function I(k, g) {
          return !g || h(g) !== "object" && typeof g != "function" ? function(A) {
            if (A === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return A;
          }(k) : g;
        }
        function M(k) {
          return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(g) {
            return g.__proto__ || Object.getPrototypeOf(g);
          }, M(k);
        }
        d = [u(680), u(316)], f = (function(k, g) {
          var A = function(b) {
            (function(E, C) {
              if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function");
              E.prototype = Object.create(C && C.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), C && v(E, C);
            })(P, b);
            var x, _, R = w(P);
            function P() {
              return m(this, P), R.apply(this, arguments);
            }
            return x = P, (_ = [{ key: "render", value: function(E, C, T, D, z) {
              var B = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 4 } }, W = this.getOptions(B, z), L = D < E.length * W.boxHeight ? E.length * W.boxHeight : D, S = this.createSvg(C, T, L), $ = W.valueFormatter;
              this.useTip(this.defaultTip, W), E.forEach(function(fe) {
                return fe.Category = fe.Category || "Default";
              });
              var j = T - W.margins.left - W.margins.right;
              L = L - W.margins.top - W.margins.bottom;
              var N = k.scaleLinear().range([0, j]).domain([W.xMin || k.min(E, function(fe) {
                return fe.min;
              }), W.xMax || k.max(E, function(fe) {
                return fe.max;
              })]).nice(), q = k.scaleBand().range([0, L]).round(1 / E.length).domain(E.map(function(fe) {
                return fe.Category;
              })), G = k.axisBottom().scale(N).tickFormat($), X = k.axisLeft().scale(q), Y = k.scaleOrdinal().domain(E.map(function(fe) {
                return fe.Category;
              })).range(["#ff9315", "#0d61ff", "gold", "blue", "green", "red", "black", "orange", "brown", "grey", "slateblue", "grey1", "darkgreen"]), Q = 0, V = Q;
              if (W.showXAxis) {
                var U = S.append("g").attr("class", "axis");
                U.call(G), Q = Math.round(U.node().getBBox().height) + 2, V = Math.round(U.node().getBBox().width) + 4, L -= Q, j -= Math.max(0, V - j), U.remove();
              }
              var Z = 0;
              if (W.showYAxis) {
                var H = S.append("g").attr("class", "axis");
                H.call(X), j -= Z = Math.round(H.node().getBBox().width), H.remove();
              }
              var ee = W.boxHeight, ie = q.bandwidth() / 2 - ee / 2, re = ee / 2, K = re / 10;
              W.showMinMarkers && (j -= K > Z ? 2 * K - Z : K), N.range([0, j]), q.range([L, 0]);
              var se = S.append("g").attr("transform", `translate(
	          `.concat(W.margins.left + Math.max(Z, K), `,
	          `).concat(W.margins.top, `
	        )`)), xe = se.selectAll(".boxplot").data(E).enter().append("g").attr("class", "boxplot").attr("transform", function(fe) {
                return "translate(0, ".concat(q(fe.Category), ")");
              }), ke = this, ue = k.scaleLinear().range([ee / 2, 0]).domain([0, ee]);
              xe.each(function(fe) {
                var de = fe, ce = k.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(ie, ")");
                }).append("g").datum(fe);
                de.LIF != de.q1 && (ce.append("line").attr("class", "bar").attr("x1", N(de.LIF)).attr("y1", ue(1.5 * re)).attr("x2", N(de.LIF)).attr("y2", ue(0.5 * re)).style("stroke", Y(de.Category)), ce.append("line").attr("class", "whisker").attr("x1", N(de.LIF)).attr("y1", ue(re)).attr("x2", N(de.q1)).attr("y2", ue(re)).style("stroke", Y(de.Category))), ce.append("rect").attr("class", "box").attr("x", N(de.q1)).attr("y", Math.min(ue(0), ue(ee))).attr("width", Math.max(1, N(de.q3) - N(de.q1))).attr("height", Math.abs(ue(0) - ue(ee))).style("fill", Y(de.Category)).style("stroke", Y(de.Category)).style("fill-opacity", 0.4).on("mouseover", function(te) {
                  return ke.tip.show(te, event.target);
                }).on("mouseout", function(te) {
                  return ke.tip.hide(te, event.target);
                }), ce.append("line").attr("class", "median").attr("x1", N(de.median)).attr("y1", ue(0)).attr("x2", N(de.median)).attr("y2", ue(ee)).style("stroke", Y(de.Category)), de.UIF != de.q3 && (ce.append("line").attr("class", "bar").attr("x1", N(de.UIF)).attr("y1", ue(1.5 * re)).attr("x2", N(de.UIF)).attr("y2", ue(0.5 * re)).style("stroke", Y(de.Category)), ce.append("line").attr("class", "whisker").attr("x1", N(de.q3)).attr("y1", ue(re)).attr("x2", N(de.UIF)).attr("y2", ue(re)).style("stroke", Y(de.Category))), W.showMinMarkers && ce.append("circle").attr("cx", N(de.min)).attr("cy", ue(re)).attr("r", K).style("fill", Y(de.Category)).style("stroke", Y(de.Category)).style("fill-opacity", 0.4), W.showMaxMarkers && ce.append("circle").attr("cx", N(de.max)).attr("cy", ue(re)).attr("r", K).style("fill", Y(de.Category)).style("stroke", Y(de.Category)).style("fill-opacity", 0.4);
              }), W.showXAxis && se.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(L, ")")).call(G), W.showYAxis && se.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(X).selectAll(".tick text").call(this.wrap, q.bandwidth() || q.range()).selectAll(".tick text tspan").attr("x", -9);
            } }]) && y(x.prototype, _), P;
          }(g);
          return A;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 557: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(T, D) {
              if (typeof D != "function" && D !== null) throw new TypeError("Super expression must either be null or a function");
              T.prototype = Object.create(D && D.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), D && w(T, D);
            })(C, x);
            var _, R, P, E = I(C);
            function C() {
              return m(this, C), E.apply(this, arguments);
            }
            return _ = C, P = [{ key: "convertData", value: function(T) {
              return T[0].hasOwnProperty("values") || (T = [{ name: "", values: T }]), T;
            } }, { key: "getMinValue", value: function(T, D) {
              return g.min(T, function(z) {
                return g.min(z.values, function(B) {
                  return B[D];
                });
              });
            } }, { key: "getMaxValue", value: function(T, D) {
              return g.max(T, function(z) {
                return g.max(z.values, function(B) {
                  return B[D];
                });
              });
            } }, { key: "getZeroBasedY", value: function(T) {
              var D = T.data, z = T.yValue, B = T.height, W = C.getMaxValue(D, z);
              return g.scaleLinear().domain([0, W]).range([B, 0]);
            } }, { key: "getRelativeY", value: function(T) {
              var D = T.data, z = T.yValue, B = z === void 0 ? "yValue" : z, W = T.height, L = T.yRangePadding, S = L === void 0 ? 0.1 : L, $ = T.defaultYRangePadding, j = $ === void 0 ? 10 : $;
              D = C.convertData(D);
              var N = C.getMinValue(D, B), q = C.getMaxValue(D, B), G = (q - N) * S || j;
              return g.scaleLinear().domain([N - G, q + G]).range([W, 0]);
            } }], (R = [{ key: "render", value: function(T, D, z, B, W) {
              v(k(C.prototype), "render", this).call(this, T, D, z, B, W), typeof D == "string" && (D = document.querySelector(D));
              var L = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: this.interpolation.linear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, getTooltipBuilder: null }, S = this.getOptions(L, W), $ = this.createSvg(D, z, B), j = typeof S.getTooltipBuilder == "function" ? S.getTooltipBuilder(S) : this.lineDefaultTooltip(S.xLabel || "x", S.xFormat, function(J) {
                return J[S.xValue];
              }, S.yLabel || "y", S.yFormat, function(J) {
                return J[S.yValue];
              }, function(J) {
                return J[S.seriesName];
              });
              if (T.length > 0) {
                T = C.convertData(T), this.useTip(function(J) {
                  J.attr("class", "d3-tip").offset([-10, 0]).html(j);
                });
                var N = 0, q = 0;
                if (S.xLabel) {
                  var G = $.append("g").attr("transform", "translate(".concat(z / 2, ", ").concat(B - S.margins.bottom, ")"));
                  G.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(S.xLabel), N += G.node().getBBox().height;
                }
                if (S.yLabel) {
                  var X = $.append("g").attr("transform", `translate(
	              `.concat(S.margins.left, `,
	              `).concat((B - S.margins.bottom - S.margins.top) / 2 + S.margins.top, `
	            )`));
                  X.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(S.yLabel), q = 1.2 * X.node().getBBox().width;
                }
                var Y = 0;
                if (S.showLegend) {
                  var Q = $.append("g").attr("class", "legend"), V = 0;
                  T.forEach(function(J, ne) {
                    Q.append("rect").attr("x", 0).attr("y", 15 * ne).attr("width", 10).attr("height", 10).style("fill", S.colors(J.name));
                    var ye = Q.append("text").attr("x", 12).attr("y", 15 * ne + 9).text(J.name);
                    V = Math.max(ye.node().getBBox().width + 12, V);
                  }), Q.attr("transform", `translate(
	          `.concat(z - S.margins.right - V, `,
	          `).concat(S.margins.top, `
	        )`)), (Y += V + 5) > z / 3 && Q.style("display", "none");
                }
                var U = z - S.margins.left - S.margins.right - q - (Y > z / 5 ? 0 : Y), Z = B - S.margins.top - S.margins.bottom - N, H = S.xScale || g.scaleLinear().domain([g.min(T, function(J) {
                  return g.min(J.values, function(ne) {
                    return ne[S.xValue];
                  });
                }), g.max(T, function(J) {
                  return g.max(J.values, function(ne) {
                    return ne[S.xValue];
                  });
                })]), ee = g.axisBottom().scale(H).ticks(S.ticks);
                S.tickFormat ? ee.tickFormat(S.tickFormat) : ee.tickFormat(S.xFormat), typeof H.rangePoints == "function" ? H.rangePoints([0, U]) : H.range([0, U]);
                var ie = S.yScale || C.getZeroBasedY({ data: T, height: Z, yValue: S.yValue }), re = g.axisLeft().scale(ie).tickFormat(S.yFormat).ticks(S.yTicks), K = $.append("g").attr("class", "axis");
                K.call(ee);
                var se = Math.round(K.node().getBBox().height), xe = Math.round(K.node().getBBox().width);
                Z -= se, U -= Math.max(0, xe - U), K.remove();
                var ke = S.yAxisWidth;
                if (S.yAxisWidth == null) {
                  var ue = $.append("g").attr("class", "axis");
                  ue.call(re), ke = Math.round(ue.node().getBBox().width), ue.remove();
                }
                U -= ke, typeof H.rangePoints == "function" ? H.rangePoints([0, U]) : H.range([0, U]), ie.range([Z, 0]);
                var fe = g.line().x(function(J) {
                  return H(J[S.xValue]);
                }).y(function(J) {
                  return ie(J[S.yValue]);
                }).curve(S.interpolate), de = $.append("g").attr("class", S.cssClass).attr("transform", `translate(
	            `.concat(S.margins.left + q + ke, `,
	            `).concat(S.margins.top, `
	          )`)), ce = de.selectAll(".series").data(T).enter().append("g"), te = ce.append("path").attr("class", "line").attr("d", function(J) {
                  return fe(J.values.sort(function(ne, ye) {
                    return g.ascending(ne[S.xValue], ye[S.xValue]);
                  }));
                });
                S.colors && te.style("stroke", function(J, ne) {
                  return S.colors(J.name);
                }), S.showSeriesLabel && ce.append("text").datum(function(J) {
                  return { name: J.name, value: J.values[J.values.length - 1] };
                }).attr("transform", function(J) {
                  return "translate(".concat(H(J.value[S.xValue]), ", ").concat(ie(J.value[S.yValue]), ")");
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(J) {
                  return J.name;
                });
                var oe = { x: 0, y: 0 };
                de.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Z, ")")).call(ee), de.append("g").attr("class", "y axis").call(re), S.labelIndexDate && de.append("rect").attr("transform", "translate(".concat(oe.x - 0.5, ", ").concat(oe.y, ")")).attr("width", 1).attr("height", Z), this.appendTracker({ vis: de, data: T, width: U, height: Z, x: H, y: ie, options: S });
              } else $.append("text").attr("transform", "translate(".concat(z / 2, ", ").concat(B / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "appendTracker", value: function(T) {
              var D = this, z = T.vis, B = T.data, W = T.width, L = T.height, S = T.x, $ = T.y, j = T.options, N = z.append("g").attr("class", "current-focus").style("display", "none"), q = N.append("line").attr("class", "x-hover-line").style("stroke-width", "2px").style("stroke-dasharray", "3,3").attr("y1", 0), G = N.append("circle").attr("r", 2), X = z.append("rect").style("opacity", 0), Y = g.quadtree().x(function(V) {
                return S(V[j.xValue]);
              }).y(function(V) {
                return $(V[j.yValue]);
              }), Q = B.reduce(function(V, U) {
                return V.concat(U.values.map(function(Z) {
                  return Z.name = U.name, Z;
                }));
              }, []);
              Y.addAll(Q), X.attr("class", "overlay").attr("width", W).attr("height", L).attr("pointer-events", "all").on("mouseover", function() {
                return N.style("display", null);
              }).on("mouseout", function() {
                N.style("display", "none"), D.tip.hide({}, N.node());
              }), X.on("mousemove", function() {
                var V = g.event, U = g.mouse(V.target), Z = Y.find(U[0], U[1]);
                G.style("fill", j.colors(Z.name)), q.style("stroke", j.colors(Z.name)), q.attr("y2", L - $(Z[j.yValue])), N.attr("transform", "translate(" + S(Z[j.xValue]) + "," + $(Z[j.yValue]) + ")"), D.tip.show(Z, N.node());
              });
            } }, { key: "interpolation", get: function() {
              return { linear: g.curveLinear, curveStep: g.curveStep, curveStepBefore: g.curveStepBefore, curveStepAfter: g.curveStepAfter, curveBasis: g.curveBasis, curveCardinal: g.curveCardinal, curveMonotoneX: g.curveMonotoneX, curveCatmullRom: g.curveCatmullRom };
            } }]) && y(_.prototype, R), P && y(_, P), C;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 76: (c, l, u) => {
        var d;
        c = u.nmd(c), d = (function(f) {
          var h = { version: "0.0.1" }, m = u(842), y = u(648), v = u(605), w = u(131), I = u(316), M = u(535), k = u(502), g = u(487), A = u(557), b = u(775), x = u(312), _ = u(345), R = u(255), P = u(587), E = u(132);
          return h.chart = m, h.aster = y, h.areachart = v, h.barchart = w, h.boxplot = I, h.donut = M, h.histogram = k, h.horizontalBoxplot = g, h.line = A, h.trellisline = b, h.treemap = x, h.scatterplot = _, h.splitBoxplot = R, h.sunburst = P, h.util = E, h;
        }).call(l, u, l, c), d === void 0 || (c.exports = d);
      }, 345: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "render", value: function(C, T, D, z, B) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var W = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: g.curveLinear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, truncateLabelAtLine: 2, showXAxis: !0, tooltip: function(te) {
                return "<div>Series: ".concat(te.seriesName, `</div>
					<div>X: `).concat(te[L.xValue], `</div>
					<div>Y: `).concat(te[L.yValue], `</div>
					`);
              }, circleRadius: 1, addDiagonal: !1, diagonalColor: "#ccc" }, L = this.getOptions(W, B);
              B.colors ? L.colors = g.scaleOrdinal(Object.values(B.colors)).domain(Object.keys(B.colors)) : L.colors = g.scaleOrdinal(g.schemeCategory20).domain(C.map(function(te) {
                return te.name;
              }));
              var S = this.createSvg(T, D, z);
              if (C.length > 0) {
                C[0].hasOwnProperty("values") || (C = [{ name: "", values: C }]), this.useTip(function(te) {
                  te.attr("class", "d3-tip").offset([-10, 0]).html(L.tooltip);
                });
                var $, j, N = 0, q = 0;
                L.xLabel && (($ = S.append("g")).append("text").attr("class", "axislabel").attr("dy", 0).attr("y", 0).style("text-anchor", "middle").text(L.xLabel), N += $.node().getBBox().height), L.yLabel && ((j = S.append("g")).append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(L.yLabel), q = 1.5 * j.node().getBBox().width);
                var G = 0;
                if (L.showLegend) {
                  var X = S.append("g").attr("class", "legend"), Y = 0;
                  C.forEach(function(te, oe) {
                    X.append("rect").attr("x", 0).attr("y", 15 * oe).attr("width", 10).attr("height", 10).style("fill", L.colors(te.name));
                    var J = X.append("text").attr("x", 12).attr("y", 15 * oe + 9).text(te.name);
                    Y = Math.max(J.node().getBBox().width + 12, Y);
                  }), X.attr("transform", "translate(" + (D - L.margins.right - Y) + ",0)"), G += Y + 5;
                }
                var Q = D - L.margins.left - L.margins.right - q - G, V = z - L.margins.top - L.margins.bottom - N, U = L.xScale || g.scaleLinear().domain([g.min(C, function(te) {
                  return g.min(te.values, function(oe) {
                    return oe[L.xValue];
                  });
                }), g.max(C, function(te) {
                  return g.max(te.values, function(oe) {
                    return oe[L.xValue];
                  });
                })]), Z = g.axisBottom().scale(U).ticks(L.ticks);
                L.tickFormat ? Z.tickFormat(L.tickFormat) : Z.tickFormat(L.xFormat), typeof U.rangePoints == "function" ? U.rangePoints([0, Q]) : U.range([0, Q]);
                var H = L.yScale || g.scaleLinear().domain([0, g.max(C, function(te) {
                  return g.max(te.values, function(oe) {
                    return oe[L.yValue];
                  });
                })]).range([V, 0]), ee = g.axisLeft().scale(H).tickFormat(L.yFormat).ticks(L.yTicks), ie = S.append("g").attr("class", "axis");
                ie.call(Z);
                var re = Math.round(ie.node().getBBox().height), K = Math.round(ie.node().getBBox().width);
                V -= re, Q -= Math.max(0, K - Q), ie.remove();
                var se = S.append("g").attr("class", "axis");
                se.call(ee);
                var xe = Math.round(se.node().getBBox().width);
                if (Q -= xe, se.remove(), L.xLabel && $) {
                  $.selectAll("text").call(this.wrap, Q, L.truncateLabelAtLine);
                  var ke = $.node().getBBox().height;
                  V -= ke, $.attr("transform", `translate(
								`.concat(q + xe + L.margins.left + Q / 2, `,
								`).concat(z - L.margins.bottom - ke, `
							)`));
                }
                L.yLabel && j && (j.attr("transform", `translate(
							`.concat(L.margins.left, `,
							`).concat(L.margins.bottom + V / 2, `
						)`)).selectAll("text").call(this.wrap, V, L.truncateLabelAtLine), q = j.node().getBBox().width), typeof U.rangePoints == "function" ? U.rangePoints([0, Q]) : U.range([0, Q]), H.range([V, 0]);
                var ue = S.append("g").attr("class", L.cssClass).attr("transform", "translate(" + (L.margins.left + q + xe) + "," + L.margins.top + ")"), fe = ue.selectAll(".series").data(C).enter().append("g");
                fe.selectAll(".dot").data(function(te) {
                  return te.values.map(function(oe) {
                    return Object.assign({}, oe, { seriesName: te.name });
                  });
                }).enter().append("circle").attr("class", "dot").attr("r", L.circleRadius).style("fill", function(te, oe) {
                  return L.colors(te.seriesName);
                }).attr("transform", function(te) {
                  return "translate(" + U(te[L.xValue]) + "," + H(te[L.yValue]) + ")";
                }), L.addDiagonal && fe.append("line").attr("x1", 0).attr("y1", V).attr("x2", Q).attr("y2", 0).attr("stroke-width", 1).attr("stroke", L.diagonalColor).attr("stroke-dasharray", "5,5"), L.showSeriesLabel && fe.append("text").datum(function(te) {
                  return { name: te.name, value: te.values[te.values.length - 1] };
                }).attr("transform", function(te) {
                  return "translate(" + U(te.value[L.xValue]) + "," + H(te.value[L.yValue]) + ")";
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(te) {
                  return te.name;
                });
                var de = { x: 0, y: 0 }, ce = this;
                fe.selectAll(".focus").data(function(te) {
                  return te.values.map(function(oe) {
                    return Object.assign({}, oe, { seriesName: te.name });
                  });
                }).enter().append("circle").attr("class", "focus").attr("r", L.circleRadius).attr("transform", function(te) {
                  var oe = U(te[L.xValue]), J = H(te[L.yValue]);
                  return te[L.xValue] === 0 && de.y === 0 && (de.x = oe, de.y = J), "translate(" + oe + "," + J + ")";
                }).on("mouseover", function(te) {
                  g.select(this).style("opacity", "1").style("stroke", L.colors(te.seriesName)).style("stroke-width", L.circleRadius / 2), ce.tip.show(te, event.target);
                }).on("mouseout", function(te) {
                  g.select(this).style("opacity", "0"), ce.tip.hide(te, event.target);
                }), L.showXAxis && ue.append("g").attr("class", "x axis").attr("transform", "translate(0," + V + ")").call(Z), ue.append("g").attr("class", "y axis").call(ee), L.labelIndexDate && ue.append("rect").attr("transform", function() {
                  return "translate(" + (de.x - 0.5) + "," + de.y + ")";
                }).attr("width", 1).attr("height", V);
              } else S.append("text").attr("transform", "translate(" + D / 2 + "," + z / 2 + ")").style("text-anchor", "middle").text("No Data");
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 255: (c, l, u) => {
        var d, f;
        function h(k) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
            return typeof g;
          } : function(g) {
            return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
          }, h(k);
        }
        function m(k, g) {
          if (!(k instanceof g)) throw new TypeError("Cannot call a class as a function");
        }
        function y(k, g) {
          for (var A = 0; A < g.length; A++) {
            var b = g[A];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(k, b.key, b);
          }
        }
        function v(k, g) {
          return v = Object.setPrototypeOf || function(A, b) {
            return A.__proto__ = b, A;
          }, v(k, g);
        }
        function w(k) {
          var g = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var A, b = M(k);
            if (g) {
              var x = M(this).constructor;
              A = Reflect.construct(b, arguments, x);
            } else A = b.apply(this, arguments);
            return I(this, A);
          };
        }
        function I(k, g) {
          return !g || h(g) !== "object" && typeof g != "function" ? function(A) {
            if (A === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return A;
          }(k) : g;
        }
        function M(k) {
          return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(g) {
            return g.__proto__ || Object.getPrototypeOf(g);
          }, M(k);
        }
        d = [u(680), u(316)], f = (function(k, g) {
          var A = function(b) {
            (function(E, C) {
              if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function");
              E.prototype = Object.create(C && C.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), C && v(E, C);
            })(P, b);
            var x, _, R = w(P);
            function P() {
              return m(this, P), R.apply(this, arguments);
            }
            return x = P, (_ = [{ key: "render", value: function(E, C, T, D, z) {
              var B = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 0 } }, W = this.getOptions(B, z), L = this.createSvg(C, T, D), S = W.valueFormatter;
              this.useTip(this.defaultTip, W), E.forEach(function(te) {
                return te.Category = te.Category || "Default";
              });
              var $ = T - W.margins.left - W.margins.right, j = D - W.margins.top - W.margins.bottom, N = k.scaleLinear().range([0, $]).domain([W.xMin || k.min(E, function(te) {
                return Math.min(te.target.min, te.compare.min);
              }), W.xMax || k.max(E, function(te) {
                return Math.max(te.target.max, te.compare.max);
              })]), q = k.scaleBand().range([0, j]).round(1 / E.length).domain(E.map(function(te) {
                return te.Category;
              })), G = k.axisBottom().scale(N).tickFormat(S).ticks(5), X = k.axisLeft().scale(q), Y = 0, Q = Y;
              if (W.showXAxis) {
                var V = L.append("g").attr("class", "axis");
                V.call(G), Y = Math.round(V.node().getBBox().height) + 2, Q = Math.round(V.node().getBBox().width) + 4, j -= Y, $ -= Math.max(0, Q - $), V.remove();
              }
              var U = 0;
              if (W.showYAxis) {
                var Z = L.append("g").attr("class", "axis");
                Z.call(X), $ -= U = Math.round(Z.node().getBBox().width), Z.remove();
              }
              var H = W.boxHeight, ee = q.bandwidth() / 2 - H / 2, ie = H / 2, re = ie / 10;
              W.showMinMarkers && ($ -= re > U ? 2 * re - U : re), N.range([0, $]), q.range([j, 0]);
              var K = L.append("g").attr("transform", `translate(
	          `.concat(W.margins.left + Math.max(U, re), `,
	          `).concat(W.margins.top, `
	        )`));
              if (W.showLegend) {
                var se = L.append("g").attr("class", "legend"), xe = se.append("g"), ke = se.append("g");
                xe.append("rect").attr("x", 0).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "target"), xe.append("text").attr("x", 15).attr("y", 9).text("Target"), ke.append("rect").attr("x", xe.node().getBBox().width + 10).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "compare"), ke.append("text").attr("x", xe.node().getBBox().width + 25).attr("y", 9).text("Compare"), se.attr("transform", `translate(
					`.concat((T - se.node().getBBox().width) / 2, `,
					0
				)`));
              }
              var ue = K.selectAll(".boxplot").data(E).enter().append("g").attr("class", "boxplot").attr("transform", function(te) {
                return "translate(0, ".concat(q(te.Category), ")");
              }), fe = this, de = k.scaleLinear().range([H / 2, 0]).domain([0, H]), ce = k.scaleLinear().range([0, H / 2]).domain([0, H]);
              q.bandwidth(), ue.each(function(te) {
                var oe = k.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(ee, ")");
                }), J = oe.append("g").datum(te.target).attr("class", "target"), ne = oe.append("g").datum(te.compare).attr("class", "compare").attr("transform", function() {
                  return "translate(0, ".concat(H / 2 + 2, ")");
                });
                [{ boxPlotData: te.target, boxplot: J, boxScale: de }, { boxPlotData: te.compare, boxplot: ne, boxScale: ce, tipDirection: "s", tipOffset: [10, 0] }].forEach(function(ye) {
                  var Ae = ye.boxPlotData, be = ye.boxplot, je = ye.boxScale;
                  Ae.LIF != Ae.q1 && (be.append("line").attr("class", "bar").attr("x1", N(Ae.LIF)).attr("y1", je(0)).attr("x2", N(Ae.LIF)).attr("y2", je(ie)), be.append("line").attr("class", "whisker").attr("x1", N(Ae.LIF)).attr("y1", je(0)).attr("x2", N(Ae.q1)).attr("y2", je(0))), be.append("rect").attr("class", "box").attr("x", N(Ae.q1)).attr("y", Math.min(je(0), je(H))).attr("width", Math.max(1, N(Ae.q3) - N(Ae.q1))).attr("height", Math.abs(je(0) - je(H))).on("mouseover", function(Oe) {
                    return fe.tip.show(Object.assign({}, Oe, { tipDirection: ye.tipDirection, tipOffset: ye.tipOffset }), event.target);
                  }).on("mouseout", function(Oe) {
                    return fe.tip.hide(Oe, event.target);
                  }), be.append("line").attr("class", "median").attr("x1", N(Ae.median)).attr("y1", je(0)).attr("x2", N(Ae.median)).attr("y2", je(H)), Ae.UIF != Ae.q3 && (be.append("line").attr("class", "bar").attr("x1", N(Ae.UIF)).attr("y1", je(0)).attr("x2", N(Ae.UIF)).attr("y2", je(ie)), be.append("line").attr("class", "whisker").attr("x1", N(Ae.q3)).attr("y1", je(0)).attr("x2", N(Ae.UIF)).attr("y2", je(0))), W.showMinMarkers && be.append("circle").attr("cx", N(Ae.min)).attr("cy", je(ie / 2)).attr("r", re), W.showMaxMarkers && be.append("circle").attr("cx", N(Ae.max)).attr("cy", je(ie / 2)).attr("r", re);
                });
              }), W.showXAxis && K.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(j, ")")).call(G), W.showYAxis && K.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(X).selectAll(".tick text").call(this.wrap, q.bandwidth() || q.range());
            } }]) && y(x.prototype, _), P;
          }(g);
          return A;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 587: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "getTipDirection", value: function(C) {
              return "n";
            } }, { key: "getTipOffset", value: function(C, T) {
              var D = event.target.getBBox(), z = T.centroid(C), B = Math.abs(D.x - z[0]) - D.width / 2;
              return [Math.abs(D.y - z[1]) - 10, B];
            } }, { key: "render", value: function(C, T, D, z, B) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var W = this.getOptions({ tooltip: function(Y) {
                return "<div>No Tooltip Set</div>";
              }, minRadians: 5e-3 }, B), L = this.createSvg(T, D, z);
              L.attr("class", "sunburst"), this.useTip(function(Y, Q) {
                Y.attr("class", "d3-tip ".concat(Q.tipClass || "")).offset(function(V) {
                  return V.tipOffset || [-10, 0];
                }).direction(function(V) {
                  return V.tipDirection || "n";
                }).html(function(V) {
                  return Q.tooltip(V);
                });
              }, W);
              var S = L.append("svg:g").attr("transform", "translate(" + D / 2 + "," + z / 2 + ")"), $ = Math.min(D, z) / 2, j = g.partition().size([2 * Math.PI, $]), N = g.arc().startAngle(function(Y) {
                return Y.x0;
              }).endAngle(function(Y) {
                return Y.x1;
              }).innerRadius(function(Y) {
                return Y.y0;
              }).outerRadius(function(Y) {
                return Y.y1;
              });
              S.append("svg:circle").attr("r", $).style("opacity", 0);
              var q = j(g.hierarchy(C).sum(function(Y) {
                return Y.size;
              }).sort(function(Y, Q) {
                return Q.value - Y.value;
              })).descendants().filter(function(Y) {
                return Y.x1 - Y.x0 > W.minRadians;
              }).reverse();
              if (W.split) {
                var G = q.reduce(function(Y, Q) {
                  var V = W.split(Q);
                  return V.length > 1 && (Q.isSplit = !0, Y = Y.concat(V.map(function(U) {
                    return Object.assign(U, { isPartialNode: !0 });
                  }))), Y;
                }, []);
                S.data([C]).selectAll("partialnode").data(G).enter().append("svg:path").attr("d", N).attr("fill-rule", "evenodd").attr("class", "partial").style("fill", function(Y) {
                  return W.colors(Y.data.name);
                });
              }
              var X = this;
              S.data([C]).selectAll("pathnode").data(q).enter().append("svg:path").attr("display", function(Y) {
                return Y.depth ? null : "none";
              }).attr("d", N).attr("fill-rule", "evenodd").attr("class", function(Y) {
                return W.nodeClass && W.nodeClass(Y) || "node";
              }).style("fill", function(Y) {
                return Y.isSplit ? "#000" : W.colors(Y.data.name);
              }).style("opacity", function(Y) {
                return Y.isSplit ? 0 : 1;
              }).on("mouseover", function(Y) {
                return X.tip.show(Object.assign({}, Y, { tipDirection: X.getTipDirection(Y), tipOffset: X.getTipOffset(Y, N) }), event.target);
              }).on("mouseout", function(Y) {
                return X.tip.hide(Y, event.target);
              }).on("click", function(Y) {
                return W.onclick && W.onclick(Y);
              });
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 312: (c, l, u) => {
        var d, f;
        function h(k) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
            return typeof g;
          } : function(g) {
            return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
          }, h(k);
        }
        function m(k, g) {
          if (!(k instanceof g)) throw new TypeError("Cannot call a class as a function");
        }
        function y(k, g) {
          for (var A = 0; A < g.length; A++) {
            var b = g[A];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(k, b.key, b);
          }
        }
        function v(k, g) {
          return v = Object.setPrototypeOf || function(A, b) {
            return A.__proto__ = b, A;
          }, v(k, g);
        }
        function w(k) {
          var g = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var A, b = M(k);
            if (g) {
              var x = M(this).constructor;
              A = Reflect.construct(b, arguments, x);
            } else A = b.apply(this, arguments);
            return I(this, A);
          };
        }
        function I(k, g) {
          return !g || h(g) !== "object" && typeof g != "function" ? function(A) {
            if (A === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return A;
          }(k) : g;
        }
        function M(k) {
          return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(g) {
            return g.__proto__ || Object.getPrototypeOf(g);
          }, M(k);
        }
        d = [u(680), u(842)], f = (function(k, g) {
          var A = function(b) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && v(C, T);
            })(E, b);
            var x, _, R, P = w(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return x = E, _ = [{ key: "render", value: function(C, T, D, z, B) {
              var W = this, L = this.getOptions(B), S = this.createSvg(T, D, z), $ = k.scaleLinear().range([0, D]), j = k.scaleLinear().range([0, z]);
              k.select(T).select(".treemap_zoomtarget").text("");
              var N = 0, q = k.treemap().round(!1).size([D, z]), G = k.hierarchy(C, function(K) {
                return K.children;
              }).sum(L.getsizevalue), X = q(G);
              function Y(K) {
                var se = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], xe = D / (K.x1 - K.x0) || D, ke = z / (K.y1 - K.y0) || z;
                K.x1 && K.y1 ? ($.domain([K.x0, K.x0 + (K.x1 - K.x0)]), j.domain([K.y0, K.y0 + (K.y1 - K.y0)])) : ($.domain([0, D]), j.domain([0, z]));
                var ue = k.select(T).select(".treemap_zoomtarget");
                if (ue.size()) if (K.data.name === "root") ue.text("");
                else {
                  var fe = ue.text();
                  ue.text("".concat(fe, " > ").concat(K.data.name));
                }
                var de = S.selectAll("g.cell, .grouper");
                se && (de = de.transition().duration(750)), de.attr("transform", function(ce) {
                  return "translate(".concat($(ce.x0), ", ").concat(j(ce.y0), ")");
                }).on("end", function() {
                  S.selectAll(".grouper").attr("display", "block");
                }), de.select("rect").attr("width", function(ce) {
                  return Math.max(0, xe * (ce.x1 - ce.x0) - 1);
                }).attr("height", function(ce) {
                  return Math.max(0, ke * (ce.y1 - ce.y0) - 1);
                }), event && event.stopPropagation(), L.onZoom && L.onZoom(K);
              }
              function Q(K) {
                var se = D / (K.x1 - K.x0), xe = z / (K.y1 - K.y0), ke = X.children.filter(function(ue) {
                  return ue.parent === K;
                });
                S.selectAll(".grouper").remove(), S.selectAll(".grouper").data(ke).enter().append("g").attr("class", "grouper").attr("transform", function(ue) {
                  return "translate(".concat(ue.x0 + 1, ", ").concat(ue.y0 + 1, ")");
                }).attr("display", "none").append("rect").attr("width", function(ue) {
                  return Math.max(0, se * (ue.x1 - ue.x0) - 1);
                }).attr("height", function(ue) {
                  return Math.max(0, xe * (ue.y1 - ue.y0) - 1);
                }).attr("title", function(ue) {
                  return ue.name;
                }).attr("id", function(ue) {
                  return ue.id;
                });
              }
              var V, U = X.leaves().filter(function(K) {
                return L.getsizevalue(K.data);
              }), Z = k.extent(U, function(K) {
                return L.getcolorvalue(K.data);
              }), H = k.median(U, function(K) {
                return L.getcolorvalue(K.data);
              });
              V = L.getcolorrange ? L.getcolorrange() : ["#E4FF7A", "#FC7F00"];
              var ee = [Z[0], H, Z[1]];
              L.getcolorscale && (ee = L.getcolorscale());
              var ie = k.scaleLinear().domain(ee).range(V), re = S.selectAll("g").data(U).enter().append("g").attr("class", "cell").attr("transform", function(K) {
                return "translate(".concat(K.x0, ", ").concat(K.y0, ")");
              });
              re.append("rect").attr("width", function(K) {
                return Math.max(0, K.x1 - K.x0 - 1);
              }).attr("height", function(K) {
                return Math.max(0, K.y1 - K.y0 - 1);
              }).attr("id", function(K) {
                return K.id;
              }).style("fill", function(K) {
                return ie(L.getcolorvalue(K.data));
              }).on("click", function(K) {
                if (L.useTip && W.tip.hide(), event.altKey) Y(G), Q(G);
                else if (event.ctrlKey) {
                  for (var se = K; se.depth !== N + 1; ) se = se.parent;
                  N = se.depth, se.children && se.children.length > 1 ? (Q(se), Y(se)) : (N = 0, Q(G), Y(G));
                } else L.onclick(K.data);
              }), L.useTip ? (this.useTip(function(K) {
                K.attr("class", "d3-tip").direction(function(se) {
                  var xe = $.domain()[1] === 1 ? D : $.domain()[1];
                  return se.x1 >= xe - xe / 10 ? "w" : se.x0 <= xe / 10 ? "e" : "n";
                }).offset([3, 0]).html(function(se) {
                  return "".concat(L.gettitle(se.data), "<br/><br/>").concat(L.getcontent(se.data));
                });
              }), re.on("mouseover", function(K) {
                return W.tip.show(K, event.target);
              }).on("mouseout", function(K) {
                return W.tip.hide(K, event.target);
              })) : re.attr("data-container", "body").attr("data-toggle", "popover").attr("data-trigger", "hover").attr("data-placement", "top").attr("data-html", !0).attr("data-title", function(K) {
                return L.gettitle(K.data);
              }).attr("data-content", function(K) {
                return L.getcontent(K.data);
              }), L.initialZoomedConcept ? (Q(L.initialZoomedConcept), Y(L.initialZoomedConcept, !1)) : Q(G), S.selectAll(".grouper").attr("display", "block");
            } }, { key: "formatters", get: function() {
              return { format_pct: k.format(".2%"), format_fixed: k.format(".2f"), format_comma: k.format(",") };
            } }], R = [{ key: "buildHierarchyFromJSON", value: function(C, T, D) {
              var z = 0, B = { name: "root", children: [] };
              return C.PERCENT_PERSONS.forEach(function(W) {
                z += W;
              }), C.CONCEPT_PATH.forEach(function(W, L) {
                for (var S = W.split("||"), $ = B, j = function(q) {
                  var G = $.children, X = S[q], Y = void 0;
                  if (q + 1 < S.length) {
                    var Q = !1;
                    G.forEach(function(V) {
                      V.name === X && (Y = V, Q = !0);
                    }), Q || (Y = { name: X, children: [] }, G.push(Y)), $ = Y;
                  } else Y = D(X, L, C), C.PERCENT_PERSONS[L] / z > T && G.push(Y);
                }, N = 0; N < S.length; N += 1) j(N);
              }), B;
            } }], _ && y(x.prototype, _), R && y(x, R), E;
          }(g);
          return A;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 775: (c, l, u) => {
        var d, f;
        function h(g) {
          return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, h(g);
        }
        function m(g, A) {
          if (!(g instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function y(g, A) {
          for (var b = 0; b < A.length; b++) {
            var x = A[b];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(g, x.key, x);
          }
        }
        function v(g, A, b) {
          return v = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(x, _, R) {
            var P = function(C, T) {
              for (; !Object.prototype.hasOwnProperty.call(C, T) && (C = k(C)) !== null; ) ;
              return C;
            }(x, _);
            if (P) {
              var E = Object.getOwnPropertyDescriptor(P, _);
              return E.get ? E.get.call(R) : E.value;
            }
          }, v(g, A, b || g);
        }
        function w(g, A) {
          return w = Object.setPrototypeOf || function(b, x) {
            return b.__proto__ = x, b;
          }, w(g, A);
        }
        function I(g) {
          var A = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var b, x = k(g);
            if (A) {
              var _ = k(this).constructor;
              b = Reflect.construct(x, arguments, _);
            } else b = x.apply(this, arguments);
            return M(this, b);
          };
        }
        function M(g, A) {
          return !A || h(A) !== "object" && typeof A != "function" ? function(b) {
            if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b;
          }(g) : A;
        }
        function k(g) {
          return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
            return A.__proto__ || Object.getPrototypeOf(A);
          }, k(g);
        }
        d = [u(680), u(842)], f = (function(g, A) {
          var b = function(x) {
            (function(C, T) {
              if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(T && T.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), T && w(C, T);
            })(E, x);
            var _, R, P = I(E);
            function E() {
              return m(this, E), P.apply(this, arguments);
            }
            return _ = E, (R = [{ key: "render", value: function(C, T, D, z, B) {
              v(k(E.prototype), "render", this).call(this, C, T, D, z, B);
              var W = { trellisSet: g.keys(C), yTicks: 4, xFormat: g.format("d"), yFormat: g.format("d"), interpolate: g.curveLinear }, L = this.getOptions(W, B), S = this.createSvg(T, D, z);
              function $() {
                var _e = ue.invert(g.mouse(event.target)[0]);
                be.selectAll(".g-label-value.g-start").call(j, _e), be.selectAll(".g-label-year.g-start").call(N, _e), be.selectAll(".g-value").attr("transform", function(Re) {
                  var Le = Re.values;
                  if (Le) {
                    var Ge = Le[X(Le, _e, 0, Le.length - 1)], Ke = Ge.Y_PREVALENCE_1000PP === 0 || Ge.Y_PREVALENCE_1000PP ? Ge.Y_PREVALENCE_1000PP : Ge.yPrevalence1000Pp;
                    return Ge && Ge.date ? "translate(" + ue(Ge.date) + "," + fe(Ke) + ")" : "translate(0,0);";
                  }
                });
              }
              function j(_e, Re) {
                var Le = g.scaleLinear().domain(ue.range()), Ge = {};
                _e.each(function(Ke, Ht) {
                  var kr = g.select(this), Mt = Ke.values, xn = X(Mt, Re, 0, Mt.length - 1), Pt = Math.round(xn / (Mt.length - 1) * (Mt.length - 12)), en = Mt[xn];
                  if (en && en.date) {
                    var Tr = ue(en.date), at = en.Y_PREVALENCE_1000PP === 0 || en.Y_PREVALENCE_1000PP ? en.Y_PREVALENCE_1000PP : en.yPrevalence1000Pp, Zr = Le.range([0, ke.bandwidth()])(Tr), Zi = fe(g.max(Mt.slice(Pt, Pt + 12), function(Ba) {
                      return at;
                    })), Xn = en.TRELLIS_NAME || en.trellisName;
                    if (Xn) {
                      !Ge[Xn] && (Ge[Xn] = []);
                      var za = en.date.getTime() === Q.getTime() ? "end" : (en.date.getTime(), Y.getTime(), "start");
                      Ge[Xn].push({ y: Zi, x: Zr, textAnchor: za, value: at, text: kr, color: L.colors(Ke.key) });
                    }
                  }
                }), Object.keys(Ge).forEach(function(Ke) {
                  var Ht = Ge[Ke];
                  Ht.sort(function(Mt, xn) {
                    return Mt.y - xn.y;
                  }), Ht.forEach(function(Mt, xn) {
                    if (xn > 0) {
                      var Pt = Ht[xn - 1].y;
                      Ht[xn].y += Math.max(0, Pt + 15 - Ht[xn].y);
                    }
                  });
                  var kr = Ht.filter(function(Mt) {
                    return Mt.value <= 20;
                  });
                  Ht.forEach(function(Mt) {
                    var xn = Mt.text, Pt = Mt.x, en = Mt.y, Tr = (Mt.color, Mt.textAnchor), at = Mt.value;
                    xn.text(L.yFormat(at)).style("display", "block").style("text-anchor", Tr).attr("transform", `translate(
	              `.concat(Tr === "start" ? Pt + 4 : Pt - 4, `,
	              `).concat(at <= 20 && kr.length !== 1 ? en - 20 : en, `
	            )`));
                  });
                });
              }
              function N(_e, Re) {
                var Le = g.scaleLinear().domain(ue.range()), Ge = C[0] && C[0].values[0] && C[0].values[0].values || [], Ke = Ge[X(Ge, Re, 0, Ge.length - 1)];
                if (Ke && Ke.date) {
                  var Ht = ue(Ke.date);
                  _e.each(function(kr) {
                    g.select(this).text(Ke.date.getFullYear()).attr("transform", `translate(
	              `.concat(Le.range([0, ke.bandwidth() - this.getComputedTextLength()])(Ht), `,
	              `).concat(xe + 6, `
	              )`)).style("display", null);
                  });
                }
              }
              var q, G, X = g.bisector(function(_e) {
                return _e.date;
              }).left, Y = g.min(C, function(_e) {
                return g.min(_e.values, function(Re) {
                  return g.min(Re.values, function(Le) {
                    return Le.date;
                  });
                });
              }), Q = g.max(C, function(_e) {
                return g.max(_e.values, function(Re) {
                  return g.max(Re.values, function(Le) {
                    return Le.date;
                  });
                });
              }), V = g.min(C, function(_e) {
                return g.min(_e.values, function(Re) {
                  return g.min(Re.values, function(Le) {
                    return Le.Y_PREVALENCE_1000PP === 0 || Le.Y_PREVALENCE_1000PP ? Le.Y_PREVALENCE_1000PP : Le.yPrevalence1000Pp;
                  });
                });
              }), U = g.max(C, function(_e) {
                return g.max(_e.values, function(Re) {
                  return g.max(Re.values, function(Le) {
                    return Le.Y_PREVALENCE_1000PP === 0 || Le.Y_PREVALENCE_1000PP ? Le.Y_PREVALENCE_1000PP : Le.yPrevalence1000Pp;
                  });
                });
              }), Z = 0;
              L.seriesLabel && ((q = S.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(L.seriesLabel), (Z = q.node()) && (Z = q.node().getBBox().height + 10));
              var H, ee, ie, re = 0;
              L.trellisLabel && ((G = S.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(L.trellisLabel), re = G.node().getBBox().height + 10), (H = S.append("g").attr("class", "g-label-trellis")).append("text").text(L.trellisSet.join("")), ee = H.node().getBBox().height + 10, H.remove();
              var K = 0;
              L.yLabel && ((ie = S.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").text(L.yLabel), K = ie.node().getBBox().height + 4);
              var se = D - L.margins.left - K - L.margins.right, xe = z - L.margins.top - re - ee - Z - 2 * L.margins.bottom, ke = g.scaleBand().domain(L.trellisSet).range([0, se]).paddingOuter(0.2).paddingInner(0.25), ue = g.scaleTime().domain([Y, Q]).range([0, ke.bandwidth()]), fe = g.scaleLinear().domain([V, U]).range([xe, 0]), de = g.axisLeft().scale(fe).tickFormat(L.yFormat).ticks(L.yTicks), ce = g.axisBottom().scale(ue), te = S.append("g").attr("class", "axis");
              te.call(ce);
              var oe = Math.round(te.node().getBBox().height), J = Math.round(te.node().getBBox().width);
              xe -= oe, se -= Math.max(0, J - se), te.remove();
              var ne = S.append("g").attr("class", "axis");
              ne.call(de);
              var ye = Math.round(ne.node().getBBox().width);
              se -= ye, ne.remove(), ke.range([0, se]).paddingOuter(0.2).paddingInner(0.25), ue.range([0, ke.bandwidth()]), fe.range([xe, 0]), L.trellisLabel && G.attr("transform", `translate(
	        `.concat(se / 2 + L.margins.left, `,
	        `).concat(L.margins.top, `
	      )`)), L.seriesLabel && q.attr("transform", `translate(
	        `.concat(se / 2 + L.margins.left, `,
	        `).concat(re + xe + oe + Z + 2 * L.margins.top, `
	      )`)), L.yLabel && (ie.attr("transform", `translate(
	        `.concat(L.margins.left, `,
	        `).concat(xe / 2 + re + ee, `
	      )`)), ie.select("text").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em"));
              var Ae = g.line().x(function(_e) {
                return ue(_e.date);
              }).y(function(_e) {
                return fe(_e.Y_PREVALENCE_1000PP === 0 || _e.Y_PREVALENCE_1000PP ? _e.Y_PREVALENCE_1000PP : _e.yPrevalence1000Pp);
              }).curve(L.interpolate), be = g.select(S.node()).append("g").attr("transform", function(_e) {
                return `translate(
	        `.concat(K + ye + L.margins.left, `,
	        `).concat(re, `
	      )`);
              }).selectAll(".g-trellis").data(ke.domain()).enter().append("g").attr("class", "g-trellis").attr("transform", function(_e) {
                return "translate(".concat(ke(_e), ", ").concat(ee, ")");
              }), je = g.axisBottom().scale(ue).tickFormat("").tickSize(-xe), Oe = g.axisLeft().scale(fe).tickFormat("").tickSize(-ke.bandwidth()).ticks(8);
              be.append("g").attr("class", "x-guide").attr("transform", "translate(0, ".concat(xe, ")")).call(je), be.append("g").attr("class", "y-guide").call(Oe);
              var Ve = be.selectAll(".g-series").data(function(_e) {
                var Re = C.filter(function(Le) {
                  return Le.key === _e;
                });
                return Re.length > 0 ? Re[0].values : [];
              }).enter().append("g").attr("class", "g-series lineplot");
              Ve.append("path").attr("class", "line").attr("d", function(_e) {
                return Ae(_e.values.sort(function(Re, Le) {
                  return g.ascending(Re.date, Le.date);
                }));
              }).style("stroke", function(_e) {
                return L.colors(_e.key);
              }), Ve.append("circle").attr("class", "g-value").attr("transform", function(_e) {
                var Re = _e.values;
                if (Re && Re[Re.length - 1] && Re[Re.length - 1].date && Re[Re.length - 1] && (Re[Re.length - 1].Y_PREVALENCE_1000PP || Re[Re.length - 1].yPrevalence1000Pp)) {
                  var Le = Re[Re.length - 1].Y_PREVALENCE_1000PP === 0 || Re[Re.length - 1].Y_PREVALENCE_1000PP ? Re[Re.length - 1].Y_PREVALENCE_1000PP : Re[Re.length - 1].yPrevalence1000Pp;
                  return "translate(".concat(ue(Re[Re.length - 1].date), ", ").concat(fe(Le), ")");
                }
                return "translate(0, 0)";
              }).attr("r", 2.5).style("display", "none"), Ve.append("text").attr("class", "g-label-value g-start").call(j, Y), Ve.append("text").attr("class", "g-label-value g-end").call(j, Q), be.append("text").attr("class", "g-label-year g-start").attr("dy", ".71em").call(N, Y), be.append("text").attr("class", "g-label-year g-end").attr("dy", ".71em").call(N, Q), be.append("g").attr("class", "x axis").append("line").attr("x2", ke.bandwidth()).attr("y1", fe(V)).attr("y2", fe(V)), be.append("g").attr("class", "g-label-trellis").attr("transform", function(_e) {
                return "translate(".concat(ke.bandwidth() / 2, ", 0)");
              }).append("text").attr("dy", "-1em").style("text-anchor", "middle").text(function(_e) {
                return _e;
              }), be.append("rect").attr("class", "g-overlay").attr("x", -4).attr("width", ke.bandwidth() + 8).attr("height", xe + 18).on("mouseover", function() {
                be.selectAll(".g-end").style("display", "none"), be.selectAll(".g-value").style("display", null), $.call(this);
              }).on("mousemove", $).on("mouseout", function() {
                be.selectAll(".g-end").style("display", null), be.selectAll(".g-label-value.g-start").call(j, Y), be.selectAll(".g-label-year.g-start").call(N, Y), be.selectAll(".g-label-year.g-end").call(N, Q), be.selectAll(".g-value").style("display", "none");
              }), g.select(be.nodes()[0]).append("g").attr("class", "y axis").attr("transform", "translate(-4,0)").call(de), S.append("g").attr("transform", "translate(".concat(L.margins.left, ", ").concat(L.margins.top, ")")).call(function(_e) {
                var Re = 0;
                L.colors.domain().forEach(function(Le) {
                  var Ge = _e.append("g").attr("class", "trellisLegend"), Ke = Ge.append("text").text(Le), Ht = Ge.node().getBBox();
                  Ke.attr("x", 12).attr("y", Ht.height), Ge.append("line").attr("x1", 0).attr("y1", 10).attr("x2", 10).attr("y2", 10).style("stroke", function() {
                    return L.colors(Le);
                  }), Ge.attr("transform", "translate(".concat(Re, ", 0)")), Re += Ge.node().getBBox().width + 5;
                });
              });
            } }]) && y(_.prototype, R), E;
          }(A);
          return b;
        }).apply(l, d), f === void 0 || (c.exports = f);
      }, 132: (c, l, u) => {
        var d, f;
        d = [u(680)], (f = (function(h) {
          var m = h.format(",.3r");
          return { wrap: function(y, v) {
            y.each(function() {
              for (var w, I = h.select(this), M = I.text().split(/\s+/).reverse(), k = [], g = 0, A = I.attr("y"), b = parseFloat(I.attr("dy")), x = I.text(null).append("tspan").attr("x", 0).attr("y", A).attr("dy", b + "em"); w = M.pop(); ) k.push(w), x.text(k.join(" ")), x.node().getComputedTextLength() > v && (k.length > 1 && (k.pop(), M.push(w), x.text(k.join(" "))), k = [], g += 1, x = I.append("tspan").attr("x", 0).attr("y", A).attr("dy", 1.1 * g + b + "em"));
            });
          }, formatInteger: function(y) {
            return m(y);
          }, formatSI: function(y) {
            return y = y || 0, function(v) {
              if (v < 1) return h.round(v, y);
              var w = h.formatPrefix(v);
              return h.round(w.scale(v), y) + w.symbol;
            };
          }, buildHierarchy: function(y, v, w) {
            for (var I = v || function(z) {
              return z[0];
            }, M = w || function(z) {
              return z[1];
            }, k = { name: "root", children: [] }, g = 0; g < y.length; g++) {
              var A = I(y[g]), b = +M(y[g]);
              if (!isNaN(b)) for (var x = A.split("-"), _ = k, R = 0; R < x.length; R++) {
                var P, E = _.children, C = x[R];
                if (R + 1 < x.length) {
                  for (var T = !1, D = 0; D < E.length; D++) if (E[D].name == C && E[D].children) {
                    P = E[D], T = !0;
                    break;
                  }
                  T || (P = { name: C, children: [] }, E.push(P)), _ = P;
                } else P = { name: C, size: b }, E.push(P);
              }
            }
            return k;
          } };
        }).apply(l, d)) === void 0 || (c.exports = f);
      }, 383: function(c, l, u) {
        var d, f, h;
        f = [u(680)], d = function(m) {
          return function() {
            var y = b, v = x, w = _, I = S(), M = null, k = null, g = null;
            function A(G) {
              M = $(G), k = M.createSVGPoint(), document.body.appendChild(I);
            }
            function b() {
              return "n";
            }
            function x() {
              return [0, 0];
            }
            function _() {
              return " ";
            }
            A.show = function() {
              var G = Array.prototype.slice.call(arguments);
              G[G.length - 1] instanceof SVGElement && (g = G.pop());
              var X, Y = w.apply(this, G), Q = v.apply(this, G), V = y.apply(this, G), U = j(), Z = P.length, H = document.documentElement.scrollTop || document.body.scrollTop, ee = document.documentElement.scrollLeft || document.body.scrollLeft;
              for (U.html(Y).style("opacity", 1).style("pointer-events", "all"); Z--; ) U.classed(P[Z], !1);
              return X = R.get(V).apply(this), U.classed(V, !0).style("top", X.top + Q[0] + H + "px").style("left", X.left + Q[1] + ee + "px"), A;
            }, A.hide = function() {
              return j().style("opacity", 0).style("pointer-events", "none"), A;
            }, A.attr = function(G, X) {
              if (arguments.length < 2 && typeof G == "string") return j().attr(G);
              var Y = Array.prototype.slice.call(arguments);
              return m.selection.prototype.attr.apply(j(), Y), A;
            }, A.style = function(G, X) {
              if (arguments.length < 2 && typeof G == "string") return j().style(G);
              var Y = Array.prototype.slice.call(arguments);
              return m.selection.prototype.style.apply(j(), Y), A;
            }, A.direction = function(G) {
              return arguments.length ? (y = G == null ? G : q(G), A) : y;
            }, A.offset = function(G) {
              return arguments.length ? (v = G == null ? G : q(G), A) : v;
            }, A.html = function(G) {
              return arguments.length ? (w = G == null ? G : q(G), A) : w;
            }, A.destroy = function() {
              return I && (j().remove(), I = null), A;
            };
            var R = m.map({ n: E, s: C, e: T, w: D, nw: z, ne: B, sw: W, se: L }), P = R.keys();
            function E() {
              var G = N();
              return { top: G.n.y - I.offsetHeight, left: G.n.x - I.offsetWidth / 2 };
            }
            function C() {
              var G = N();
              return { top: G.s.y, left: G.s.x - I.offsetWidth / 2 };
            }
            function T() {
              var G = N();
              return { top: G.e.y - I.offsetHeight / 2, left: G.e.x };
            }
            function D() {
              var G = N();
              return { top: G.w.y - I.offsetHeight / 2, left: G.w.x - I.offsetWidth };
            }
            function z() {
              var G = N();
              return { top: G.nw.y - I.offsetHeight, left: G.nw.x - I.offsetWidth };
            }
            function B() {
              var G = N();
              return { top: G.ne.y - I.offsetHeight, left: G.ne.x };
            }
            function W() {
              var G = N();
              return { top: G.sw.y, left: G.sw.x - I.offsetWidth };
            }
            function L() {
              var G = N();
              return { top: G.se.y, left: G.e.x };
            }
            function S() {
              var G = m.select(document.createElement("div"));
              return G.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box"), G.node();
            }
            function $(G) {
              return (G = G.node()).tagName.toLowerCase() === "svg" ? G : G.ownerSVGElement;
            }
            function j() {
              return I === null && (I = S(), document.body.appendChild(I)), m.select(I);
            }
            function N() {
              for (var G = g || m.event.target; G.getScreenCTM === void 0 && G.parentNode === "undefined"; ) G = G.parentNode;
              var X = {}, Y = G.getScreenCTM(), Q = G.getBBox(), V = Q.width, U = Q.height, Z = Q.x, H = Q.y;
              return k.x = Z, k.y = H, X.nw = k.matrixTransform(Y), k.x += V, X.ne = k.matrixTransform(Y), k.y += U, X.se = k.matrixTransform(Y), k.x -= V, X.sw = k.matrixTransform(Y), k.y -= U / 2, X.w = k.matrixTransform(Y), k.x += V, X.e = k.matrixTransform(Y), k.x -= V / 2, k.y -= U / 2, X.n = k.matrixTransform(Y), k.y += U, X.s = k.matrixTransform(Y), X;
            }
            function q(G) {
              return typeof G == "function" ? G : function() {
                return G;
              };
            }
            return A;
          };
        }, (h = typeof d == "function" ? d.apply(l, f) : d) === void 0 || (c.exports = h);
      }, 680: (c) => {
        c.exports = n;
      }, 756: (c) => {
        c.exports = i;
      }, 92: (c) => {
        c.exports = r;
      } }, o = {};
      function s(c) {
        if (o[c]) return o[c].exports;
        var l = o[c] = { id: c, loaded: !1, exports: {} };
        return a[c].call(l.exports, l, l.exports, s), l.loaded = !0, l.exports;
      }
      return s.nmd = (c) => (c.paths = [], c.children || (c.children = []), c), s(76);
    })();
  });
})(Ib);
var Zn = Ib.exports;
function GY(e, t = "untitled") {
  const { svgBlob: n } = GS(e), r = URL.createObjectURL(n);
  QS(r, t + ".svg");
}
function VY(e, t = "untitled") {
  const { svgData: n, width: r, height: i } = GS(e), a = window.URL || window.webkitURL || window, o = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(n)}`, s = new Image();
  s.onload = function() {
    const c = document.createElement("canvas");
    c.width = r, c.height = i;
    const l = c.getContext("2d");
    l == null || l.drawImage(s, 0, 0, r, i), c.toBlob((u) => {
      if (!u) {
        console.error("Failed to create chart PNG blob", {
          name: t,
          width: r,
          height: i
        });
        return;
      }
      const d = a.createObjectURL(u);
      QS(d, t + ".png"), window.setTimeout(() => a.revokeObjectURL(d));
    }, "image/png");
  }, s.onerror = function() {
    console.error("Failed to render chart SVG as PNG", {
      name: t,
      width: r,
      height: i
    });
  }, s.src = o;
}
function GS(e) {
  var s;
  const t = (s = e == null ? void 0 : e.current) == null ? void 0 : s.querySelector("svg");
  if (!t)
    throw new Error("Chart SVG was not found");
  const { width: n, height: r } = QY(t), i = t.cloneNode(!0);
  VS(t, i), i.setAttribute("xmlns", "http://www.w3.org/2000/svg"), i.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), i.setAttribute("width", String(n)), i.setAttribute("height", String(r)), i.getAttribute("viewBox") || i.setAttribute("viewBox", `0 0 ${n} ${r}`), qY(i, n, r);
  const a = new XMLSerializer().serializeToString(i);
  return { svgBlob: new Blob([a], {
    type: "image/svg+xml;charset=utf-8"
  }), svgData: a, width: n, height: r };
}
function QY(e) {
  var i, a, o, s, c, l, u, d;
  const t = e.getBoundingClientRect(), n = t.width || ((a = (i = e.viewBox) == null ? void 0 : i.baseVal) == null ? void 0 : a.width) || ((s = (o = e.width) == null ? void 0 : o.baseVal) == null ? void 0 : s.value) || Number(e.getAttribute("width")) || 0, r = t.height || ((l = (c = e.viewBox) == null ? void 0 : c.baseVal) == null ? void 0 : l.height) || ((d = (u = e.height) == null ? void 0 : u.baseVal) == null ? void 0 : d.value) || Number(e.getAttribute("height")) || 0;
  return {
    width: Math.ceil(n),
    height: Math.ceil(r)
  };
}
function VS(e, t) {
  const n = window.getComputedStyle(e), r = Array.from(n).map((i) => `${i}:${n.getPropertyValue(i)}`).join(";");
  t.setAttribute("style", r), Array.from(e.children).forEach((i, a) => {
    const o = t.children[a];
    o && VS(i, o);
  });
}
function qY(e, t, n) {
  const r = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "rect"
  );
  r.setAttribute("width", String(t)), r.setAttribute("height", String(n)), r.setAttribute("fill", "#fff"), e.insertBefore(r, e.firstChild);
}
function QS(e, t) {
  const n = document.createElement("a");
  n.href = e, n.download = t, document.body.appendChild(n), n.click(), document.body.removeChild(n);
}
const XY = (e) => {
  const { type: t, chartData: n, width: r, height: i, options: a, report: o = {} } = e, [s, c] = Te(null), l = sr(null), u = `${e.fileName ? e.fileName.replace(/[^A-Z0-9]+/gi, "_") + "__" : ""}${t}`, d = (f) => {
    switch (f) {
      case "line":
        return new Zn.line();
      case "donut":
        return new Zn.donut();
      case "areachart":
        return new Zn.areachart();
      case "barchart":
        return new Zn.barchart();
      case "treemap":
        return new Zn.treemap();
      case "boxplot":
        return new Zn.boxplot();
      case "histogram":
        return new Zn.histogram();
      case "scatterplot":
        return new Zn.scatterplot();
      case "trellisline":
        return new Zn.trellisline();
      case "sunburst":
        return new Zn.sunburst();
      case "splitBoxplot":
        return new Zn.splitBoxplot();
      case "horizontalBoxplot":
        return new Zn.horizontalBoxplot();
    }
  };
  return tt(() => {
    if (!l) return;
    const f = d(t);
    return c(f), () => {
      ej(f);
    };
  }, [t]), tt(() => {
    if (t === "treeMapCustom")
      return Ut(l.current).selectAll("svg").remove(), ZY(n, l.current, a, r, i);
    s && s.render(
      n || [],
      l.current,
      r,
      i,
      a == null ? void 0 : a(s)
    );
  }, [s, n, t, r, i]), /* @__PURE__ */ F(we, { className: "chart-wrapper", sx: { width: r, height: i }, children: [
    /* @__PURE__ */ F(
      EC,
      {
        sx: { position: "absolute", top: 0, right: 0 },
        className: "chart-wrapper_button-group",
        children: [
          /* @__PURE__ */ p(Ee, { onClick: () => GY(l, u), size: "small", children: "SVG" }),
          /* @__PURE__ */ p(Ee, { onClick: () => VY(l, u), size: "small", children: "PNG" })
        ]
      }
    ),
    /* @__PURE__ */ p(
      we,
      {
        ref: l,
        id: "myChart",
        sx: { width: r, height: i }
      }
    )
  ] });
};
function JY(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    e[n] === "1" && t++;
  return t;
}
function KY(e) {
  var t = JY(e), n = e.length - t;
  return t === e.length ? "#7BB209" : n === e.length ? "#FF3D19" : n === 1 ? "#95B90A" : n === 2 ? "#C9C40D" : n < 5 ? "#E77F13" : "#FF3D19";
}
function ZY(e, t, n, r, i) {
  var a = r || 300, o = i || 300;
  fl().range([0, a]), fl().range([0, o]);
  var s = F_().round(!1).size([a, o]), c = $f(e, (h) => h.children).sum((h) => h.size), l = s(c), u = l.leaves().filter((h) => h.data.size), d = Ut(t).append("svg:svg").attr("width", a).attr("height", o).attr("id", "treemap-chart").append("svg:g"), f = d.selectAll("g").data(u).enter().append("svg:g").attr("class", function(h) {
    return "cell";
  }).attr("transform", function(h) {
    return `translate(${h.x0}, ${h.y0})`;
  });
  f.append("svg:rect").attr("width", function(h) {
    return Math.max(0, h.x1 - h.x0 - 1);
  }).attr("height", function(h) {
    return Math.max(0, h.y1 - h.y0 - 1);
  }).attr("class", "rect").attr("id", function(h) {
    return h.data.name;
  }).text(function(h) {
    return h.children ? null : h.data.name;
  }).style("fill", function(h) {
    return n.colorPicker ? n.colorPicker(h.data) : KY(h.data.name);
  }).on("mouseenter", function(h) {
    Ut(this).classed("selected", !0), n.handleCellOver(h.data.name, h.data.size, h);
  }).on("mouseout", function() {
    Ut(this).classed("selected", !1), n.handleCellOut();
  });
}
function ej(e) {
  var t;
  (t = e == null ? void 0 : e.destroyTipIfExists) == null || t.call(e), e != null && e.doResize && window.removeEventListener("resize", e.doResize);
}
const SG = (e) => /* @__PURE__ */ p(nE, { children: ({ height: t, width: n }) => /* @__PURE__ */ p(XY, { ...e, height: t, width: n }) }), CG = ({ colorPicker: e, calculateRate: t }) => {
  const n = sr(null);
  function r(i, a) {
    if (i.scale.domain().length == 0 || isNaN(i.scale.domain()[0]))
      return;
    let o = 400, s = 40, c = fl().domain(i.scale.domain()).range([0, o - 30]);
    for (var l = Ut(n == null ? void 0 : n.current).append("svg:svg").attr("width", o).attr("height", s).append("svg:g").attr("transform", "translate(15,0)").attr("class", "treeLegend"), u = [], d = i.scale.domain()[1] - i.scale.domain()[0], f = d / i.scale.range().length, h = 0; h < i.scale.range().length; h++)
      u.push(i.scale.domain()[0] + h * f);
    u.push(i.scale.domain()[1]);
    for (var m = l.append("g").attr("transform", "translate(0,0)"), y = 0; y < u.length - 1; y++)
      m.append("rect").attr("x", c(u[y])).attr("width", c(u[y + 1]) - c(u[y]) - 1).attr("height", 20).style(
        "fill",
        i.scale((u[y] + u[y + 1]) / 2)
      );
    var v = Yb().scale(c).tickValues(u).tickFormat(function(w) {
      return a.calculateRate(w, 1);
    });
    l.append("g").attr("class", "axis").attr("transform", "translate(0,20)").call(v);
  }
  return tt(() => {
    n && (Ut(n.current).selectAll("svg").remove(), r(e, {
      calculateRate: t
    }));
  }, [n]), /* @__PURE__ */ p(we, { ref: n, sx: { height: 100 } });
}, EG = Kt((e) => {
  var d;
  const { onClose: t, item: n, inviteMethod: r, propId: i } = e, [a, o] = Te(ve.INITIAL), [s, c] = Te(), { enqueueSnackbar: l } = bi(), u = async () => {
    o(ve.IN_PROGRESS);
    try {
      const f = await r({
        [i]: n.id,
        message: s
      });
      o(ve.SUCCESS);
    } catch {
      o(ve.ERROR);
    }
  };
  return tt(() => {
    a === ve.SUCCESS && (l({
      message: `${n.title || n.name} successfully requested to be published`,
      variant: "success"
    }), t());
  }, [a]), /* @__PURE__ */ p(O, { container: !0, p: 2, children: /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ F(O, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "Name", textLabel: "Name", children: ((d = n == null ? void 0 : n.base) == null ? void 0 : d.title) || n.title || n.name }) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "message", textLabel: "Message", children: /* @__PURE__ */ p(
      xr,
      {
        type: "text",
        value: s || "",
        minRows: 2,
        maxRows: 4,
        multiline: !0,
        size: "medium",
        onChange: (f) => c(f.target.value),
        fullWidth: !0,
        name: "message",
        placeholder: "Enter message..."
      }
    ) }) }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, textAlign: "right", children: [
      /* @__PURE__ */ p(
        Ee,
        {
          variant: "outlined",
          onClick: t,
          disabled: a === ve.IN_PROGRESS,
          startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Ee,
        {
          onClick: u,
          variant: "contained",
          color: "success",
          disabled: a === ve.IN_PROGRESS,
          name: "save",
          sx: { ml: 1 },
          startIcon: a === ve.IN_PROGRESS ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "submit" }),
          children: "Publish"
        }
      )
    ] })
  ] }) }) });
}), th = (e, t) => {
  const n = {};
  return Object.keys(e).forEach((r) => {
    const i = e[r], a = i.type === Lt.INTEGER || i.type === Lt.STRING ? e[r].values[0] : e[r].values;
    n[r] = {
      attributeId: i.id,
      dataSourceId: t,
      type: i.type,
      required: i.required,
      values: i.type === Lt.INTEGER || i.type === Lt.STRING ? {
        valueId: a == null ? void 0 : a.id,
        value: a == null ? void 0 : a.value
      } : a.map((o) => {
        var s, c;
        return {
          valueId: o.id,
          value: (s = o.attributeOption) == null ? void 0 : s.value,
          optionId: (c = o.attributeOption) == null ? void 0 : c.id
        };
      })
    };
  }), n;
}, tj = (e) => {
  const { id: t, metaAttributes: n, onChange: r, onClose: i } = e, [a, o] = Te(!1), [s, c] = Te({
    meta: th(n, t)
  }), l = Ce(() => ({
    required: Object.values(n).filter(
      (f) => f.required
    ),
    optional: Object.values(n).filter(
      (f) => !f.required
    )
  }), [n]), u = async () => {
    o(!0);
    const f = th(n, t);
    Ys(f, s.meta) || await r({
      currentState: s,
      metaAttributes: n
    }), o(!1);
  };
  return /* @__PURE__ */ F(O, { container: !0, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      vr,
      {
        elevation: 3,
        sx: {
          borderRadius: 0,
          borderTop: "1px solid",
          borderColor: "borderColor.light"
        },
        children: /* @__PURE__ */ F(O, { container: !0, spacing: 2, px: 2, py: 1, justifyContent: "flex-end", children: [
          /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
            Ee,
            {
              variant: "outlined",
              onClick: i,
              startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
              name: "delete",
              children: "Cancel"
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
            Ee,
            {
              disabled: a || (() => {
                const f = th(n, t);
                let h = !0;
                return Object.keys(s.meta).forEach((m) => {
                  const y = s.meta[m];
                  if (y.required)
                    switch (y.type) {
                      case Lt.INTEGER:
                      case Lt.STRING:
                        y.values && y.values.value || (h = !1);
                        break;
                      case Lt.ENUM:
                      case Lt.ENUM_MULTI:
                        y.values && y.values.length > 0 || (h = !1);
                        break;
                    }
                }), !h || Ys(f, s.meta);
              })(),
              onClick: u,
              variant: "contained",
              color: "success",
              startIcon: a ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "submit" }),
              name: "save",
              children: "Save"
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ p(O, { container: !0, px: 2, py: 2, spacing: 2, children: /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ p(O, { container: !0, p: 2, spacing: 1, children: l.required && l.required.map((f) => {
        const h = f, m = s.meta[h.id], y = m.values, v = h.type === Lt.INTEGER ? "number" : "text";
        return /* @__PURE__ */ p(O, { item: !0, xs: 6, children: /* @__PURE__ */ F(
          nn,
          {
            name: h.name,
            textLabel: h.name,
            required: h.required,
            children: [
              (h.type === Lt.STRING || h.type === Lt.INTEGER) && /* @__PURE__ */ p(
                xr,
                {
                  id: h.name,
                  name: h.name,
                  type: v,
                  size: "medium",
                  value: y.value,
                  onChange: (w) => c((I) => ({
                    ...I,
                    meta: {
                      ...I.meta,
                      [h.id]: {
                        ...m,
                        values: {
                          ...y,
                          value: w.target.value
                        }
                      }
                    }
                  })),
                  fullWidth: !0
                }
              ),
              h.type === Lt.ENUM_MULTI && /* @__PURE__ */ p(
                mr,
                {
                  className: "",
                  name: "role",
                  disablePortal: !0,
                  multiple: !0,
                  id: "new-analysis-type",
                  options: h.options.map((w) => ({
                    ...w,
                    name: w.value
                  })),
                  value: y.map((w) => w.value),
                  placeholder: "Select values...",
                  onChange: (w, I) => {
                    const M = { ...m };
                    M.values = [], w.length > 0 && w.forEach((k) => {
                      const g = h.options.find(
                        (A) => k.includes(A.value)
                      );
                      M.values.push({
                        value: g.value,
                        optionId: g.id
                      });
                    }), c({
                      ...s,
                      meta: {
                        ...s.meta,
                        [h.id]: {
                          ...M
                        }
                      }
                    });
                  },
                  fullWidth: !0
                }
              ),
              h.type === Lt.ENUM && /* @__PURE__ */ p(
                mr,
                {
                  className: "",
                  name: "role",
                  disablePortal: !0,
                  id: "new-analysis-type",
                  options: h.options.map((w) => ({
                    ...w,
                    name: w.value
                  })),
                  value: y.length > 0 ? y[0].value : [],
                  placeholder: "Select type...",
                  onChange: (w, I) => {
                    const M = h.options.find(
                      (k) => k.value === w
                    );
                    c((k) => ({
                      ...k,
                      meta: {
                        ...k.meta,
                        [h.id]: {
                          ...m,
                          values: [
                            {
                              value: M.value,
                              optionId: M.id
                            }
                          ]
                        }
                      }
                    }));
                  },
                  fullWidth: !0
                }
              )
            ]
          }
        ) }, h.id);
      }) }) }),
      /* @__PURE__ */ F(lr, { children: [
        /* @__PURE__ */ p(Mv, { title: "Optional" }),
        /* @__PURE__ */ p(O, { container: !0, p: 2, spacing: 1, children: l.optional && l.optional.map((f) => {
          const h = f, m = s.meta[h.id], y = m.values, v = h.type === Lt.INTEGER ? "number" : "text";
          return /* @__PURE__ */ p(O, { item: !0, xs: 6, children: /* @__PURE__ */ F(
            nn,
            {
              name: h.name,
              textLabel: h.name,
              required: h.required,
              children: [
                (h.type === Lt.STRING || h.type === Lt.INTEGER) && /* @__PURE__ */ p(
                  xr,
                  {
                    id: h.name,
                    name: h.name,
                    type: v,
                    size: "medium",
                    value: y.value,
                    onChange: (w) => c((I) => ({
                      ...I,
                      meta: {
                        ...I.meta,
                        [h.id]: {
                          ...m,
                          values: {
                            ...y,
                            value: w.target.value
                          }
                        }
                      }
                    })),
                    fullWidth: !0
                  }
                ),
                h.type === Lt.ENUM_MULTI && /* @__PURE__ */ p(
                  mr,
                  {
                    className: "",
                    name: "role",
                    disablePortal: !0,
                    multiple: !0,
                    id: "new-analysis-type",
                    options: h.options.map((w) => ({
                      ...w,
                      name: w.value
                    })),
                    value: y.map((w) => w.value),
                    placeholder: "Select values...",
                    onChange: (w, I) => {
                      const M = { ...m };
                      M.values = [], w.length > 0 && w.forEach((k) => {
                        const g = h.options.find(
                          (A) => k.includes(A.value)
                        );
                        M.values.push({
                          value: g.value,
                          optionId: g.id
                        });
                      }), c((k) => ({
                        ...k,
                        meta: {
                          ...k.meta,
                          [h.id]: {
                            ...M
                          }
                        }
                      }));
                    },
                    fullWidth: !0
                  }
                ),
                h.type === Lt.ENUM && /* @__PURE__ */ p(
                  mr,
                  {
                    className: "",
                    name: "role",
                    disablePortal: !0,
                    id: "new-analysis-type",
                    options: h.options.map((w) => ({
                      ...w,
                      name: w.value
                    })),
                    value: y.length > 0 ? y[0].value : [],
                    placeholder: "Select type...",
                    onChange: (w, I) => {
                      const M = h.options.find(
                        (k) => k.value === w
                      );
                      c((k) => ({
                        ...k,
                        meta: {
                          ...k.meta,
                          [h.id]: {
                            ...m,
                            values: [
                              {
                                value: M.value,
                                optionId: M.id
                              }
                            ]
                          }
                        }
                      }));
                    },
                    fullWidth: !0
                  }
                )
              ]
            }
          ) }, h.id);
        }) })
      ] })
    ] }) })
  ] });
}, to = ae.div`
  /* margin: 10px; */
  label {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    width: 230px;
    display: block;
    font-size: 14px;
  }
  p {
    margin: 0;
    margin-top: 5px;
    font-size: 13px;
    line-height: 1.5;
    color: #323232;
  }
`;
ae.div`
  border-bottom: 1px solid #e7e7e7;
`;
const vA = ae.div`
  font-size: 16px;
  text-align: center;
  width: 100%;
  color: ${({ theme: e }) => e.palette.textColor.label};
`, nj = ae.div`
position: absolute;
width: 100%;
height: 100%
top: 0;
right: 0;
background: #eff8fd96;
display: flex;
align-items: center;
justify-content: center;
align-self: center;
z-index: 1000;
`, rj = ae.div`
  color: #21304f;
  font-weight: 700;
  display: block;
  font-size: 16px;
  padding-left: 21px;
  margin: 0;
  margin-top: 30px;
`, Qu = ({
  onChange: e,
  initialId: t,
  baseUrl: n,
  query: r,
  searchFilterName: i,
  sortBy: a,
  title: o,
  multiple: s,
  initialList: c
}) => {
  const [l, u] = Te(""), [d, f] = Te(""), { list: h, status: m, loadMore: y, hasMore: v, setSearch: w } = RC(
    n,
    c,
    {
      query: r,
      searchFilterName: i,
      sortBy: a
    }
  ), I = Ce(() => h == null ? void 0 : h.find((g) => (g == null ? void 0 : g.id) === t), [t, h, m]), M = m === ve.IN_PROGRESS, k = M && !(h != null && h.length) && !l;
  return tt(() => {
    const g = setTimeout(() => {
      f(l);
    }, 300);
    return () => clearTimeout(g);
  }, [l]), tt(() => {
    w(d);
  }, [d, w]), /* @__PURE__ */ p(
    zv,
    {
      className: "",
      disabled: k,
      name: "user-studies",
      id: "user-studies",
      value: I,
      placeholder: m === ve.IN_PROGRESS ? `Loading ${o} list...` : `Select ${o}...`,
      multiple: s,
      fullWidth: !0,
      isOptionEqualToValue: (g, A) => g.id === A.id,
      options: h || [],
      onChange: function(g, A) {
        e(A);
      },
      inputValue: l,
      onInputChange: (g, A) => {
        u(A || "");
      },
      ListboxProps: {
        onScroll: (g) => {
          const A = g.currentTarget, b = A.scrollTop + A.clientHeight;
          A.scrollHeight - b < 24 && v && y();
        }
      },
      filterOptions: (g) => g,
      getOptionKey: (g) => g.id,
      loading: M,
      loadingText: `Loading ${o} list...`,
      getOptionLabel: (g) => g.title || g.name
    }
  );
}, ij = (e, t = [], n) => {
  const [r, i] = Te(
    t[t.length - 1] || {}
  ), {
    status: a,
    values: o,
    getMetadataValues: s
  } = $v(r == null ? void 0 : r.id, n), c = (l) => {
    r.id !== l && i(t.find((u) => u.id == l));
  };
  return tt(() => {
    s(r.id);
  }, [r]), tt(() => {
    c(t[t.length - 1].id);
  }, [t]), {
    status: a,
    diffValues: o,
    changeCurrentEntityDiff: c,
    currentEntityDiff: r,
    diffMetadata: _v(e, o)
  };
}, xA = (e) => {
  const { attrId: t, name: n, targetValue: r, sourceValue: i } = e;
  return /* @__PURE__ */ p(O, { item: !0, xs: 4, children: /* @__PURE__ */ F(to, { children: [
    /* @__PURE__ */ F("label", { htmlFor: t, children: [
      n,
      ":"
    ] }),
    r === i ? /* @__PURE__ */ p("p", { children: /* @__PURE__ */ p(
      we,
      {
        component: "span",
        sx: {
          display: "block",
          marginRight: "6px",
          padding: "2px 5px"
        },
        children: r
      }
    ) }) : /* @__PURE__ */ F("p", { children: [
      r && /* @__PURE__ */ p(
        we,
        {
          component: "span",
          sx: {
            display: "block",
            marginRight: "6px",
            padding: "2px 5px",
            textDecoration: "line-through"
          },
          children: r
        }
      ),
      /* @__PURE__ */ p(
        we,
        {
          component: "span",
          sx: {
            background: "#b0dfe3",
            display: "inline-block",
            padding: "3px 8px",
            borderRadius: "4px",
            marginTop: "5px"
          },
          children: i
        }
      )
    ] })
  ] }) }, t);
}, aj = (e) => {
  const { options: t, value: n, onChange: r } = e;
  return /* @__PURE__ */ p(
    mr,
    {
      className: "",
      name: "diff",
      disablePortal: !0,
      id: "diff",
      options: t.map((i) => ({
        value: i.id,
        name: i.name
      })),
      value: n,
      placeholder: "Select items...",
      onChange: (i) => {
        r(i);
      }
    }
  );
}, qS = (e) => {
  const {
    diffEntities: t,
    isImport: n,
    name: r,
    values: i,
    attributes: a,
    configMetadataValuesApi: o
  } = e, {
    diffValues: s,
    status: c,
    diffMetadata: l,
    changeCurrentEntityDiff: u,
    currentEntityDiff: d
  } = ij(a, t, o);
  ot(() => t.length > 1 ? /* @__PURE__ */ p(
    aj,
    {
      options: t,
      value: d.id,
      onChange: u
    }
  ) : t == null ? void 0 : t[0].name, [t, d]);
  const f = (h) => ({
    name: h.name,
    value: h.values.map((m) => {
      var y;
      return [
        Lt.INTEGER,
        Lt.STRING
      ].includes(h.type) ? m.value : (y = m.attributeOption) == null ? void 0 : y.value;
    }).join(", ")
  });
  return tt(() => {
  }, []), [
    tr.INITIAL,
    tr.LOADING_METADATA
  ].includes(c) && n ? /* @__PURE__ */ p(cf, { children: /* @__PURE__ */ p(gt, { size: 32 }) }) : n && s.length === 0 ? /* @__PURE__ */ p(O, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(Bv, { severity: "info", children: "There is no metadata for import" }) }) : /* @__PURE__ */ p(O, { container: !0, children: /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(O, { container: !0, spacing: 3, p: 2, children: [
    [
      tr.INITIAL,
      tr.LOADING_METADATA
    ].includes(c) && /* @__PURE__ */ p(nj, { children: /* @__PURE__ */ p(gt, { size: 32 }) }),
    Object.keys(n ? l : i).map((h) => {
      const m = f(i == null ? void 0 : i[h]), y = f(l == null ? void 0 : l[h]);
      return /* @__PURE__ */ p(ze, { children: n ? y.value && /* @__PURE__ */ p(
        xA,
        {
          attrId: h,
          name: y.name,
          sourceValue: y.value,
          targetValue: m.value
        }
      ) : m.value && /* @__PURE__ */ p(
        xA,
        {
          attrId: h,
          name: m.name,
          sourceValue: m.value,
          targetValue: y.value
        }
      ) });
    })
  ] }) }) });
}, oj = (e) => {
  const {
    onCancel: t,
    getBaseUrl: n,
    title: r,
    configMetadataValuesApi: i,
    metadataAttributes: a,
    metadataValues: o,
    name: s,
    onSave: c,
    isContainer: l,
    isErrorCopy: u,
    initialTypeContainer: d = ge.WORKSPACE,
    initialParentId: f,
    initialParentName: h
  } = e, [m, y] = Te(!1), [v, w] = Te({
    typeContainer: d,
    parentId: f,
    entities: []
  }), I = Ce(
    () => v.parentId === f && h ? [{ id: f, name: h }] : void 0,
    [f, h, v.parentId]
  );
  return tt(() => {
    u && y(!1);
  }, [u]), /* @__PURE__ */ p(O, { container: !0, p: 2, children: /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ F(O, { container: !0, spacing: 2, p: 2, children: [
    l && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      nn,
      {
        name: "typeContainer",
        textLabel: "Select from",
        required: !0,
        children: /* @__PURE__ */ p(
          mr,
          {
            className: "",
            name: "typeContainer",
            disablePortal: !0,
            id: "typeContainer",
            options: Gp.filter((M) => M.value !== "ATLAS"),
            value: v.typeContainer,
            placeholder: "Select type",
            onChange: (M) => {
              w({
                ...v,
                typeContainer: M,
                parentId: void 0,
                entities: []
              });
            },
            fullWidth: !0
          }
        )
      }
    ) }),
    v.typeContainer === ge.STUDY && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "study", textLabel: "Study", required: !0, children: /* @__PURE__ */ p(
      Qu,
      {
        title: "Study",
        initialId: v.parentId,
        initialList: I,
        searchFilterName: "filter.search",
        sortBy: { id: "title", desc: !1 },
        onChange: (M) => {
          w(M ? {
            ...v,
            parentId: M.id,
            entities: []
          } : {
            ...v,
            parentId: void 0,
            entities: []
          });
        }
      }
    ) }) }),
    (v.typeContainer === ge.WORKSPACE || v.typeContainer === ge.STUDY && v.parentId) && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: r, textLabel: r, required: !0, children: /* @__PURE__ */ p(
      Qu,
      {
        title: r,
        initialId: "",
        baseUrl: n(v.typeContainer, v.parentId),
        query: "metadata.present=filter.boolean.true",
        searchFilterName: "filter.search",
        sortBy: { id: "name", desc: !1 },
        onChange: (M) => {
          w(M ? (k) => ({
            ...k,
            entities: [M]
          }) : (k) => ({
            ...k,
            entities: []
          }));
        }
      }
    ) }) }),
    v.entities.map((M) => /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      qS,
      {
        isImport: !0,
        diffEntities: [M],
        name: s,
        attributes: a,
        values: o,
        configMetadataValuesApi: i
      }
    ) })),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(nf, { children: [
      /* @__PURE__ */ p(
        Ee,
        {
          variant: "outlined",
          onClick: t,
          startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Ee,
        {
          onClick: () => {
            y(!0), c(v.entities);
          },
          variant: "contained",
          disabled: v.entities.length == 0 || m,
          color: "success",
          startIcon: m ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "submit" }),
          name: "save",
          children: "Import"
        }
      )
    ] }) })
  ] }) }) });
}, sj = (e) => {
  const {
    onCancel: t,
    getBaseUrl: n,
    title: r,
    configMetadataValuesApi: i,
    metadataAttributes: a,
    metadataValues: o,
    name: s,
    onSave: c,
    isContainer: l,
    isErrorCopy: u,
    initialTypeContainer: d = ge.WORKSPACE,
    initialParentId: f
  } = e, [h, m] = Te(!1), [y, v] = Te({
    typeContainer: d,
    parentId: f,
    entities: []
  });
  return tt(() => {
    u && m(!1);
  }, [u]), /* @__PURE__ */ p(O, { container: !0, p: 2, children: /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ F(O, { container: !0, spacing: 2, p: 2, children: [
    l && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "typeContainer", textLabel: "Container", required: !0, children: /* @__PURE__ */ p(
      mr,
      {
        className: "",
        name: "typeContainer",
        disablePortal: !0,
        id: "typeContainer",
        options: Gp.filter((w) => w.value !== "ATLAS"),
        value: y.typeContainer,
        placeholder: "Select type",
        onChange: (w) => {
          v({
            ...y,
            typeContainer: w
          });
        },
        fullWidth: !0
      }
    ) }) }),
    y.typeContainer === ge.STUDY && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "study", textLabel: "Study", required: !0, children: /* @__PURE__ */ p(
      Qu,
      {
        title: "Study",
        initialId: y.parentId,
        searchFilterName: "filter.search",
        sortBy: { id: "title", desc: !1 },
        onChange: (w) => {
          w && v({
            ...y,
            parentId: w.id,
            entities: []
          });
        }
      }
    ) }) }),
    (y.typeContainer === ge.WORKSPACE || y.typeContainer === ge.STUDY && y.parentId) && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: r, textLabel: r, required: !0, children: /* @__PURE__ */ p(
      Qu,
      {
        title: r,
        multiple: !0,
        initialId: "",
        baseUrl: n(y.typeContainer, y.parentId),
        searchFilterName: "filter.search",
        sortBy: { id: "name", desc: !1 },
        onChange: (w) => {
          v(w ? (I) => ({
            ...I,
            entities: w
          }) : (I) => ({
            ...I,
            entities: []
          }));
        }
      }
    ) }) }),
    y.entities.length > 0 && /* @__PURE__ */ F(rj, { children: [
      "Export Attributes from ",
      s,
      ":"
    ] }),
    y.entities.map((w, I) => /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      zr,
      {
        collapsible: !0,
        title: w.name,
        isDark: !0,
        defaultState: I === 0,
        size: "dense",
        children: /* @__PURE__ */ p(
          qS,
          {
            diffEntities: [w],
            name: s,
            attributes: a,
            values: o,
            configMetadataValuesApi: i
          }
        )
      }
    ) })),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(nf, { children: [
      /* @__PURE__ */ p(
        Ee,
        {
          variant: "outlined",
          onClick: t,
          startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ p(
        Ee,
        {
          onClick: () => c(y.entities),
          variant: "contained",
          color: "success",
          disabled: y.entities.length == 0 || h,
          startIcon: h ? /* @__PURE__ */ p(gt, { size: 16 }) : /* @__PURE__ */ p(he, { iconName: "submit" }),
          name: "save",
          children: "Export"
        }
      )
    ] }) })
  ] }) }) });
};
function lj(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const cj = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, uj = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, fj = {};
function bA(e, t) {
  return (fj.jsx ? uj : cj).test(e);
}
const dj = /[ \t\n\f\r]/g;
function hj(e) {
  return typeof e == "object" ? e.type === "text" ? wA(e.value) : !1 : wA(e);
}
function wA(e) {
  return e.replace(dj, "") === "";
}
class jl {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
jl.prototype.normal = {};
jl.prototype.property = {};
jl.prototype.space = void 0;
function XS(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new jl(n, r, t);
}
function Np(e) {
  return e.toLowerCase();
}
class Pn {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Pn.prototype.attribute = "";
Pn.prototype.booleanish = !1;
Pn.prototype.boolean = !1;
Pn.prototype.commaOrSpaceSeparated = !1;
Pn.prototype.commaSeparated = !1;
Pn.prototype.defined = !1;
Pn.prototype.mustUseProperty = !1;
Pn.prototype.number = !1;
Pn.prototype.overloadedBoolean = !1;
Pn.prototype.property = "";
Pn.prototype.spaceSeparated = !1;
Pn.prototype.space = void 0;
let pj = 0;
const Qe = La(), jt = La(), Op = La(), me = La(), _t = La(), mo = La(), Bn = La();
function La() {
  return 2 ** ++pj;
}
const Rp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Qe,
  booleanish: jt,
  commaOrSpaceSeparated: Bn,
  commaSeparated: mo,
  number: me,
  overloadedBoolean: Op,
  spaceSeparated: _t
}, Symbol.toStringTag, { value: "Module" })), nh = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Rp)
);
class Kg extends Pn {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), _A(this, "space", i), typeof r == "number")
      for (; ++a < nh.length; ) {
        const o = nh[a];
        _A(this, nh[a], (r & Rp[o]) === Rp[o]);
      }
  }
}
Kg.prototype.defined = !0;
function _A(e, t, n) {
  n && (e[t] = n);
}
function Fo(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new Kg(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[Np(r)] = r, n[Np(a.attribute)] = r;
  }
  return new jl(t, n, e.space);
}
const JS = Fo({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: jt,
    ariaAutoComplete: null,
    ariaBusy: jt,
    ariaChecked: jt,
    ariaColCount: me,
    ariaColIndex: me,
    ariaColSpan: me,
    ariaControls: _t,
    ariaCurrent: null,
    ariaDescribedBy: _t,
    ariaDetails: null,
    ariaDisabled: jt,
    ariaDropEffect: _t,
    ariaErrorMessage: null,
    ariaExpanded: jt,
    ariaFlowTo: _t,
    ariaGrabbed: jt,
    ariaHasPopup: null,
    ariaHidden: jt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: _t,
    ariaLevel: me,
    ariaLive: null,
    ariaModal: jt,
    ariaMultiLine: jt,
    ariaMultiSelectable: jt,
    ariaOrientation: null,
    ariaOwns: _t,
    ariaPlaceholder: null,
    ariaPosInSet: me,
    ariaPressed: jt,
    ariaReadOnly: jt,
    ariaRelevant: null,
    ariaRequired: jt,
    ariaRoleDescription: _t,
    ariaRowCount: me,
    ariaRowIndex: me,
    ariaRowSpan: me,
    ariaSelected: jt,
    ariaSetSize: me,
    ariaSort: null,
    ariaValueMax: me,
    ariaValueMin: me,
    ariaValueNow: me,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function KS(e, t) {
  return t in e ? e[t] : t;
}
function ZS(e, t) {
  return KS(e, t.toLowerCase());
}
const mj = Fo({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: mo,
    acceptCharset: _t,
    accessKey: _t,
    action: null,
    allow: null,
    allowFullScreen: Qe,
    allowPaymentRequest: Qe,
    allowUserMedia: Qe,
    alt: null,
    as: null,
    async: Qe,
    autoCapitalize: null,
    autoComplete: _t,
    autoFocus: Qe,
    autoPlay: Qe,
    blocking: _t,
    capture: null,
    charSet: null,
    checked: Qe,
    cite: null,
    className: _t,
    cols: me,
    colSpan: null,
    content: null,
    contentEditable: jt,
    controls: Qe,
    controlsList: _t,
    coords: me | mo,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Qe,
    defer: Qe,
    dir: null,
    dirName: null,
    disabled: Qe,
    download: Op,
    draggable: jt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Qe,
    formTarget: null,
    headers: _t,
    height: me,
    hidden: Op,
    high: me,
    href: null,
    hrefLang: null,
    htmlFor: _t,
    httpEquiv: _t,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Qe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Qe,
    itemId: null,
    itemProp: _t,
    itemRef: _t,
    itemScope: Qe,
    itemType: _t,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Qe,
    low: me,
    manifest: null,
    max: null,
    maxLength: me,
    media: null,
    method: null,
    min: null,
    minLength: me,
    multiple: Qe,
    muted: Qe,
    name: null,
    nonce: null,
    noModule: Qe,
    noValidate: Qe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Qe,
    optimum: me,
    pattern: null,
    ping: _t,
    placeholder: null,
    playsInline: Qe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Qe,
    referrerPolicy: null,
    rel: _t,
    required: Qe,
    reversed: Qe,
    rows: me,
    rowSpan: me,
    sandbox: _t,
    scope: null,
    scoped: Qe,
    seamless: Qe,
    selected: Qe,
    shadowRootClonable: Qe,
    shadowRootDelegatesFocus: Qe,
    shadowRootMode: null,
    shape: null,
    size: me,
    sizes: null,
    slot: null,
    span: me,
    spellCheck: jt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: me,
    step: null,
    style: null,
    tabIndex: me,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Qe,
    useMap: null,
    value: jt,
    width: me,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: _t,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: me,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: me,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Qe,
    // Lists. Use CSS to reduce space between items instead
    declare: Qe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: me,
    // `<img>` and `<object>`
    leftMargin: me,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: me,
    // `<body>`
    marginWidth: me,
    // `<body>`
    noResize: Qe,
    // `<frame>`
    noHref: Qe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Qe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Qe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: me,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: jt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: me,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: me,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Qe,
    disableRemotePlayback: Qe,
    prefix: null,
    property: null,
    results: me,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: ZS
}), gj = Fo({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Bn,
    accentHeight: me,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: me,
    amplitude: me,
    arabicForm: null,
    ascent: me,
    attributeName: null,
    attributeType: null,
    azimuth: me,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: me,
    by: null,
    calcMode: null,
    capHeight: me,
    className: _t,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: me,
    diffuseConstant: me,
    direction: null,
    display: null,
    dur: null,
    divisor: me,
    dominantBaseline: null,
    download: Qe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: me,
    enableBackground: null,
    end: null,
    event: null,
    exponent: me,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: me,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: mo,
    g2: mo,
    glyphName: mo,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: me,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: me,
    horizOriginX: me,
    horizOriginY: me,
    id: null,
    ideographic: me,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: me,
    k: me,
    k1: me,
    k2: me,
    k3: me,
    k4: me,
    kernelMatrix: Bn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: me,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: me,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: me,
    overlineThickness: me,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: me,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: _t,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: me,
    pointsAtY: me,
    pointsAtZ: me,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Bn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Bn,
    rev: Bn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Bn,
    requiredFeatures: Bn,
    requiredFonts: Bn,
    requiredFormats: Bn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: me,
    specularExponent: me,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: me,
    strikethroughThickness: me,
    string: null,
    stroke: null,
    strokeDashArray: Bn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: me,
    strokeOpacity: me,
    strokeWidth: null,
    style: null,
    surfaceScale: me,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Bn,
    tabIndex: me,
    tableValues: null,
    target: null,
    targetX: me,
    targetY: me,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Bn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: me,
    underlineThickness: me,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: me,
    values: null,
    vAlphabetic: me,
    vMathematical: me,
    vectorEffect: null,
    vHanging: me,
    vIdeographic: me,
    version: null,
    vertAdvY: me,
    vertOriginX: me,
    vertOriginY: me,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: me,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: KS
}), e2 = Fo({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), t2 = Fo({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: ZS
}), n2 = Fo({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), yj = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Aj = /[A-Z]/g, SA = /-[a-z]/g, vj = /^data[-\w.:]+$/i;
function xj(e, t) {
  const n = Np(t);
  let r = t, i = Pn;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && vj.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(SA, wj);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!SA.test(a)) {
        let o = a.replace(Aj, bj);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = Kg;
  }
  return new i(r, t);
}
function bj(e) {
  return "-" + e.toLowerCase();
}
function wj(e) {
  return e.charAt(1).toUpperCase();
}
const _j = XS([JS, mj, e2, t2, n2], "html"), Zg = XS([JS, gj, e2, t2, n2], "svg");
function Sj(e) {
  return e.join(" ").trim();
}
var e0 = {}, CA = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Cj = /\n/g, Ej = /^\s*/, kj = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Tj = /^:\s*/, Mj = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Ij = /^[;\s]*/, Nj = /^\s+|\s+$/g, Oj = `
`, EA = "/", kA = "*", ha = "", Rj = "comment", Dj = "declaration", Pj = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(m) {
    var y = m.match(Cj);
    y && (n += y.length);
    var v = m.lastIndexOf(Oj);
    r = ~v ? m.length - v : r + m.length;
  }
  function a() {
    var m = { line: n, column: r };
    return function(y) {
      return y.position = new o(m), l(), y;
    };
  }
  function o(m) {
    this.start = m, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(m) {
    var y = new Error(
      t.source + ":" + n + ":" + r + ": " + m
    );
    if (y.reason = m, y.filename = t.source, y.line = n, y.column = r, y.source = e, !t.silent) throw y;
  }
  function c(m) {
    var y = m.exec(e);
    if (y) {
      var v = y[0];
      return i(v), e = e.slice(v.length), y;
    }
  }
  function l() {
    c(Ej);
  }
  function u(m) {
    var y;
    for (m = m || []; y = d(); )
      y !== !1 && m.push(y);
    return m;
  }
  function d() {
    var m = a();
    if (!(EA != e.charAt(0) || kA != e.charAt(1))) {
      for (var y = 2; ha != e.charAt(y) && (kA != e.charAt(y) || EA != e.charAt(y + 1)); )
        ++y;
      if (y += 2, ha === e.charAt(y - 1))
        return s("End of comment missing");
      var v = e.slice(2, y - 2);
      return r += 2, i(v), e = e.slice(y), r += 2, m({
        type: Rj,
        comment: v
      });
    }
  }
  function f() {
    var m = a(), y = c(kj);
    if (y) {
      if (d(), !c(Tj)) return s("property missing ':'");
      var v = c(Mj), w = m({
        type: Dj,
        property: TA(y[0].replace(CA, ha)),
        value: v ? TA(v[0].replace(CA, ha)) : ha
      });
      return c(Ij), w;
    }
  }
  function h() {
    var m = [];
    u(m);
    for (var y; y = f(); )
      y !== !1 && (m.push(y), u(m));
    return m;
  }
  return l(), h();
};
function TA(e) {
  return e ? e.replace(Nj, ha) : ha;
}
var Lj = ba && ba.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(e0, "__esModule", { value: !0 });
e0.default = Bj;
var zj = Lj(Pj);
function Bj(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, zj.default)(e), i = typeof t == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var o = a.property, s = a.value;
      i ? t(o, s, a) : s && (n = n || {}, n[o] = s);
    }
  }), n;
}
var ed = {};
Object.defineProperty(ed, "__esModule", { value: !0 });
ed.camelCase = void 0;
var Fj = /^--[a-zA-Z0-9_-]+$/, Yj = /-([a-z])/g, jj = /^[^-]+$/, $j = /^-(webkit|moz|ms|o|khtml)-/, Wj = /^-(ms)-/, Uj = function(e) {
  return !e || jj.test(e) || Fj.test(e);
}, Hj = function(e, t) {
  return t.toUpperCase();
}, MA = function(e, t) {
  return "".concat(t, "-");
}, Gj = function(e, t) {
  return t === void 0 && (t = {}), Uj(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(Wj, MA) : e = e.replace($j, MA), e.replace(Yj, Hj));
};
ed.camelCase = Gj;
var Vj = ba && ba.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, Qj = Vj(e0), qj = ed;
function Dp(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, Qj.default)(e, function(r, i) {
    r && i && (n[(0, qj.camelCase)(r, t)] = i);
  }), n;
}
Dp.default = Dp;
var Xj = Dp;
const Jj = /* @__PURE__ */ rf(Xj), r2 = i2("end"), t0 = i2("start");
function i2(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function Kj(e) {
  const t = t0(e), n = r2(e);
  if (t && n)
    return { start: t, end: n };
}
function Ls(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? IA(e.position) : "start" in e || "end" in e ? IA(e) : "line" in e || "column" in e ? Pp(e) : "";
}
function Pp(e) {
  return NA(e && e.line) + ":" + NA(e && e.column);
}
function IA(e) {
  return Pp(e && e.start) + "-" + Pp(e && e.end);
}
function NA(e) {
  return e && typeof e == "number" ? e : 1;
}
class vn extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (o = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? a.ruleId = r : (a.source = r.slice(0, c), a.ruleId = r.slice(c + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const c = a.ancestors[a.ancestors.length - 1];
      c && (a.place = c.position);
    }
    const s = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = s ? s.line : void 0, this.name = Ls(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
vn.prototype.file = "";
vn.prototype.name = "";
vn.prototype.reason = "";
vn.prototype.message = "";
vn.prototype.stack = "";
vn.prototype.column = void 0;
vn.prototype.line = void 0;
vn.prototype.ancestors = void 0;
vn.prototype.cause = void 0;
vn.prototype.fatal = void 0;
vn.prototype.place = void 0;
vn.prototype.ruleId = void 0;
vn.prototype.source = void 0;
const n0 = {}.hasOwnProperty, Zj = /* @__PURE__ */ new Map(), e9 = /[A-Z]/g, t9 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), n9 = /* @__PURE__ */ new Set(["td", "th"]), a2 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function r9(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = f9(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = u9(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Zg : _j,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, a = o2(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function o2(e, t, n) {
  if (t.type === "element")
    return i9(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return a9(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return s9(e, t, n);
  if (t.type === "mdxjsEsm")
    return o9(e, t);
  if (t.type === "root")
    return l9(e, t, n);
  if (t.type === "text")
    return c9(e, t);
}
function i9(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Zg, e.schema = i), e.ancestors.push(t);
  const a = l2(e, t.tagName, !1), o = d9(e, t);
  let s = i0(e, t);
  return t9.has(t.tagName) && (s = s.filter(function(c) {
    return typeof c == "string" ? !hj(c) : !0;
  })), s2(e, o, a, t), r0(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function a9(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  vl(e, t.position);
}
function o9(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  vl(e, t.position);
}
function s9(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = Zg, e.schema = i), e.ancestors.push(t);
  const a = t.name === null ? e.Fragment : l2(e, t.name, !0), o = h9(e, t), s = i0(e, t);
  return s2(e, o, a, t), r0(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function l9(e, t, n) {
  const r = {};
  return r0(r, i0(e, t)), e.create(t, e.Fragment, r, n);
}
function c9(e, t) {
  return t.value;
}
function s2(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function r0(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function u9(e, t, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children) ? n : t;
    return s ? l(a, o, s) : l(a, o);
  }
}
function f9(e, t) {
  return n;
  function n(r, i, a, o) {
    const s = Array.isArray(a.children), c = t0(r);
    return t(
      i,
      a,
      o,
      s,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function d9(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && n0.call(t.properties, i)) {
      const a = p9(e, i, t.properties[i]);
      if (a) {
        const [o, s] = a;
        e.tableCellAlignToStyle && o === "align" && typeof s == "string" && n9.has(t.tagName) ? r = s : n[o] = s;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function h9(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const s = o.properties[0];
        s.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(s.argument)
        );
      } else
        vl(e, t.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const s = r.value.data.estree.body[0];
          s.type, a = e.evaluater.evaluateExpression(s.expression);
        } else
          vl(e, t.position);
      else
        a = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function i0(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : Zj;
  for (; ++r < t.children.length; ) {
    const a = t.children[r];
    let o;
    if (e.passKeys) {
      const c = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (c) {
        const l = i.get(c) || 0;
        o = c + "-" + l, i.set(c, l + 1);
      }
    }
    const s = o2(e, a, o);
    s !== void 0 && n.push(s);
  }
  return n;
}
function p9(e, t, n) {
  const r = xj(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? lj(n) : Sj(n)), r.property === "style") {
      let i = typeof n == "object" ? n : m9(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = g9(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? yj[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function m9(e, t) {
  try {
    return Jj(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new vn("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = a2 + "#cannot-parse-style-attribute", i;
  }
}
function l2(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const s = bA(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: s,
        computed: !!(a && s.type === "Literal"),
        optional: !1
      } : s;
    }
    r = o;
  } else
    r = bA(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return n0.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  vl(e);
}
function vl(e, t) {
  const n = new vn(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = a2 + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function g9(e) {
  const t = {};
  let n;
  for (n in e)
    n0.call(e, n) && (t[y9(n)] = e[n]);
  return t;
}
function y9(e) {
  let t = e.replace(e9, A9);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function A9(e) {
  return "-" + e.toLowerCase();
}
const rh = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, v9 = {};
function x9(e, t) {
  const n = v9, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return c2(e, r, i);
}
function c2(e, t, n) {
  if (b9(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return OA(e.children, t, n);
  }
  return Array.isArray(e) ? OA(e, t, n) : "";
}
function OA(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = c2(e[i], t, n);
  return r.join("");
}
function b9(e) {
  return !!(e && typeof e == "object");
}
const RA = document.createElement("i");
function a0(e) {
  const t = "&" + e + ";";
  RA.innerHTML = t;
  const n = RA.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function qr(e, t, n, r) {
  const i = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function ir(e, t) {
  return e.length > 0 ? (qr(e, e.length, 0, t), e) : t;
}
const DA = {}.hasOwnProperty;
function w9(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    _9(t, e[n]);
  return t;
}
function _9(e, t) {
  let n;
  for (n in t) {
    const i = (DA.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        DA.call(i, o) || (i[o] = []);
        const s = a[o];
        S9(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function S9(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  qr(e, 0, 0, r);
}
function u2(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function go(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const $r = Ki(/[A-Za-z]/), Hn = Ki(/[\dA-Za-z]/), C9 = Ki(/[#-'*+\--9=?A-Z^-~]/);
function Lp(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const zp = Ki(/\d/), E9 = Ki(/[\dA-Fa-f]/), k9 = Ki(/[!-/:-@[-`{-~]/);
function He(e) {
  return e !== null && e < -2;
}
function On(e) {
  return e !== null && (e < 0 || e === 32);
}
function ft(e) {
  return e === -2 || e === -1 || e === 32;
}
const T9 = Ki(new RegExp("\\p{P}|\\p{S}", "u")), M9 = Ki(/\s/);
function Ki(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Yo(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && Hn(e.charCodeAt(n + 1)) && Hn(e.charCodeAt(n + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const s = e.charCodeAt(n + 1);
      a < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(a, s), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function St(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(c) {
    return ft(c) ? (e.enter(n), s(c)) : t(c);
  }
  function s(c) {
    return ft(c) && a++ < i ? (e.consume(c), s) : (e.exit(n), t(c));
  }
}
const I9 = {
  tokenize: N9
};
function N9(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), St(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), a(s);
  }
  function a(s) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return He(s) ? (e.consume(s), e.exit("chunkText"), a) : (e.consume(s), o);
  }
}
const O9 = {
  tokenize: R9
}, PA = {
  tokenize: D9
};
function R9(e) {
  const t = this, n = [];
  let r = 0, i, a, o;
  return s;
  function s(M) {
    if (r < n.length) {
      const k = n[r];
      return t.containerState = k[1], e.attempt(k[0].continuation, c, l)(M);
    }
    return l(M);
  }
  function c(M) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && I();
      const k = t.events.length;
      let g = k, A;
      for (; g--; )
        if (t.events[g][0] === "exit" && t.events[g][1].type === "chunkFlow") {
          A = t.events[g][1].end;
          break;
        }
      w(r);
      let b = k;
      for (; b < t.events.length; )
        t.events[b][1].end = {
          ...A
        }, b++;
      return qr(t.events, g + 1, 0, t.events.slice(k)), t.events.length = b, l(M);
    }
    return s(M);
  }
  function l(M) {
    if (r === n.length) {
      if (!i)
        return f(M);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return m(M);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(PA, u, d)(M);
  }
  function u(M) {
    return i && I(), w(r), f(M);
  }
  function d(M) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, m(M);
  }
  function f(M) {
    return t.containerState = {}, e.attempt(PA, h, m)(M);
  }
  function h(M) {
    return r++, n.push([t.currentConstruct, t.containerState]), f(M);
  }
  function m(M) {
    if (M === null) {
      i && I(), w(0), e.consume(M);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: a
    }), y(M);
  }
  function y(M) {
    if (M === null) {
      v(e.exit("chunkFlow"), !0), w(0), e.consume(M);
      return;
    }
    return He(M) ? (e.consume(M), v(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(M), y);
  }
  function v(M, k) {
    const g = t.sliceStream(M);
    if (k && g.push(null), M.previous = a, a && (a.next = M), a = M, i.defineSkip(M.start), i.write(g), t.parser.lazy[M.start.line]) {
      let A = i.events.length;
      for (; A--; )
        if (
          // The token starts before the line ending…
          i.events[A][1].start.offset < o && // …and either is not ended yet…
          (!i.events[A][1].end || // …or ends after it.
          i.events[A][1].end.offset > o)
        )
          return;
      const b = t.events.length;
      let x = b, _, R;
      for (; x--; )
        if (t.events[x][0] === "exit" && t.events[x][1].type === "chunkFlow") {
          if (_) {
            R = t.events[x][1].end;
            break;
          }
          _ = !0;
        }
      for (w(r), A = b; A < t.events.length; )
        t.events[A][1].end = {
          ...R
        }, A++;
      qr(t.events, x + 1, 0, t.events.slice(b)), t.events.length = A;
    }
  }
  function w(M) {
    let k = n.length;
    for (; k-- > M; ) {
      const g = n[k];
      t.containerState = g[1], g[0].exit.call(t, e);
    }
    n.length = M;
  }
  function I() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function D9(e, t, n) {
  return St(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function LA(e) {
  if (e === null || On(e) || M9(e))
    return 1;
  if (T9(e))
    return 2;
}
function o0(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const Bp = {
  name: "attention",
  resolveAll: P9,
  tokenize: L9
};
function P9(e, t) {
  let n = -1, r, i, a, o, s, c, l, u;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = {
            ...e[r][1].end
          }, f = {
            ...e[n][1].start
          };
          zA(d, -c), zA(f, c), o = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: {
              ...e[r][1].end
            }
          }, s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: f
          }, a = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...s.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...s.end
          }, l = [], e[r][1].end.offset - e[r][1].start.offset && (l = ir(l, [["enter", e[r][1], t], ["exit", e[r][1], t]])), l = ir(l, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), l = ir(l, o0(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = ir(l, [["exit", a, t], ["enter", s, t], ["exit", s, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, l = ir(l, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : u = 0, qr(e, r - 1, n - r + 3, l), n = r + l.length - u - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function L9(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = LA(r);
  let a;
  return o;
  function o(c) {
    return a = c, e.enter("attentionSequence"), s(c);
  }
  function s(c) {
    if (c === a)
      return e.consume(c), s;
    const l = e.exit("attentionSequence"), u = LA(c), d = !u || u === 2 && i || n.includes(c), f = !i || i === 2 && u || n.includes(r);
    return l._open = !!(a === 42 ? d : d && (i || !f)), l._close = !!(a === 42 ? f : f && (u || !d)), t(c);
  }
}
function zA(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const z9 = {
  name: "autolink",
  tokenize: B9
};
function B9(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(h) {
    return $r(h) ? (e.consume(h), o) : h === 64 ? n(h) : l(h);
  }
  function o(h) {
    return h === 43 || h === 45 || h === 46 || Hn(h) ? (r = 1, s(h)) : l(h);
  }
  function s(h) {
    return h === 58 ? (e.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Hn(h)) && r++ < 32 ? (e.consume(h), s) : (r = 0, l(h));
  }
  function c(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || Lp(h) ? n(h) : (e.consume(h), c);
  }
  function l(h) {
    return h === 64 ? (e.consume(h), u) : C9(h) ? (e.consume(h), l) : n(h);
  }
  function u(h) {
    return Hn(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (e.consume(h), r = 0, u) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(h);
  }
  function f(h) {
    if ((h === 45 || Hn(h)) && r++ < 63) {
      const m = h === 45 ? f : d;
      return e.consume(h), m;
    }
    return n(h);
  }
}
const td = {
  partial: !0,
  tokenize: F9
};
function F9(e, t, n) {
  return r;
  function r(a) {
    return ft(a) ? St(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || He(a) ? t(a) : n(a);
  }
}
const f2 = {
  continuation: {
    tokenize: j9
  },
  exit: $9,
  name: "blockQuote",
  tokenize: Y9
};
function Y9(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return ft(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function j9(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return ft(o) ? St(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(f2, t, n)(o);
  }
}
function $9(e) {
  e.exit("blockQuote");
}
const d2 = {
  name: "characterEscape",
  tokenize: W9
};
function W9(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return k9(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const h2 = {
  name: "characterReference",
  tokenize: U9
};
function U9(e, t, n) {
  const r = this;
  let i = 0, a, o;
  return s;
  function s(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), c;
  }
  function c(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), a = 31, o = Hn, u(d));
  }
  function l(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = E9, u) : (e.enter("characterReferenceValue"), a = 7, o = zp, u(d));
  }
  function u(d) {
    if (d === 59 && i) {
      const f = e.exit("characterReferenceValue");
      return o === Hn && !a0(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(d) && i++ < a ? (e.consume(d), u) : n(d);
  }
}
const BA = {
  partial: !0,
  tokenize: G9
}, FA = {
  concrete: !0,
  name: "codeFenced",
  tokenize: H9
};
function H9(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: g
  };
  let a = 0, o = 0, s;
  return c;
  function c(A) {
    return l(A);
  }
  function l(A) {
    const b = r.events[r.events.length - 1];
    return a = b && b[1].type === "linePrefix" ? b[2].sliceSerialize(b[1], !0).length : 0, s = A, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(A);
  }
  function u(A) {
    return A === s ? (o++, e.consume(A), u) : o < 3 ? n(A) : (e.exit("codeFencedFenceSequence"), ft(A) ? St(e, d, "whitespace")(A) : d(A));
  }
  function d(A) {
    return A === null || He(A) ? (e.exit("codeFencedFence"), r.interrupt ? t(A) : e.check(BA, y, k)(A)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(A));
  }
  function f(A) {
    return A === null || He(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(A)) : ft(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), St(e, h, "whitespace")(A)) : A === 96 && A === s ? n(A) : (e.consume(A), f);
  }
  function h(A) {
    return A === null || He(A) ? d(A) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), m(A));
  }
  function m(A) {
    return A === null || He(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(A)) : A === 96 && A === s ? n(A) : (e.consume(A), m);
  }
  function y(A) {
    return e.attempt(i, k, v)(A);
  }
  function v(A) {
    return e.enter("lineEnding"), e.consume(A), e.exit("lineEnding"), w;
  }
  function w(A) {
    return a > 0 && ft(A) ? St(e, I, "linePrefix", a + 1)(A) : I(A);
  }
  function I(A) {
    return A === null || He(A) ? e.check(BA, y, k)(A) : (e.enter("codeFlowValue"), M(A));
  }
  function M(A) {
    return A === null || He(A) ? (e.exit("codeFlowValue"), I(A)) : (e.consume(A), M);
  }
  function k(A) {
    return e.exit("codeFenced"), t(A);
  }
  function g(A, b, x) {
    let _ = 0;
    return R;
    function R(D) {
      return A.enter("lineEnding"), A.consume(D), A.exit("lineEnding"), P;
    }
    function P(D) {
      return A.enter("codeFencedFence"), ft(D) ? St(A, E, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : E(D);
    }
    function E(D) {
      return D === s ? (A.enter("codeFencedFenceSequence"), C(D)) : x(D);
    }
    function C(D) {
      return D === s ? (_++, A.consume(D), C) : _ >= o ? (A.exit("codeFencedFenceSequence"), ft(D) ? St(A, T, "whitespace")(D) : T(D)) : x(D);
    }
    function T(D) {
      return D === null || He(D) ? (A.exit("codeFencedFence"), b(D)) : x(D);
    }
  }
}
function G9(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const ih = {
  name: "codeIndented",
  tokenize: Q9
}, V9 = {
  partial: !0,
  tokenize: q9
};
function Q9(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("codeIndented"), St(e, a, "linePrefix", 5)(l);
  }
  function a(l) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? o(l) : n(l);
  }
  function o(l) {
    return l === null ? c(l) : He(l) ? e.attempt(V9, o, c)(l) : (e.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || He(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), s);
  }
  function c(l) {
    return e.exit("codeIndented"), t(l);
  }
}
function q9(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : He(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : St(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : He(o) ? i(o) : n(o);
  }
}
const X9 = {
  name: "codeText",
  previous: K9,
  resolve: J9,
  tokenize: Z9
};
function J9(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function K9(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Z9(e, t, n) {
  let r = 0, i, a;
  return o;
  function o(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(d);
  }
  function s(d) {
    return d === 96 ? (e.consume(d), r++, s) : (e.exit("codeTextSequence"), c(d));
  }
  function c(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), c) : d === 96 ? (a = e.enter("codeTextSequence"), i = 0, u(d)) : He(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), c) : (e.enter("codeTextData"), l(d));
  }
  function l(d) {
    return d === null || d === 32 || d === 96 || He(d) ? (e.exit("codeTextData"), c(d)) : (e.consume(d), l);
  }
  function u(d) {
    return d === 96 ? (e.consume(d), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (a.type = "codeTextData", l(d));
  }
}
class e7 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && us(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), us(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), us(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        us(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        us(this.left, n.reverse());
      }
  }
}
function us(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function p2(e) {
  const t = {};
  let n = -1, r, i, a, o, s, c, l;
  const u = new e7(e);
  for (; ++n < u.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, a = 0, a < c.length && c[a][1].type === "lineEndingBlank" && (a += 2), a < c.length && c[a][1].type === "content"))
      for (; ++a < c.length && c[a][1].type !== "content"; )
        c[a][1].type === "chunkText" && (c[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, t7(u, n)), n = t[n], l = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a--; )
        if (o = u.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...u.get(i)[1].start
      }, s = u.slice(i, n), s.unshift(r), u.splice(i, n - i + 1, s));
    }
  }
  return qr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !l;
}
function t7(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const a = [];
  let o = n._tokenizer;
  o || (o = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const s = o.events, c = [], l = {};
  let u, d, f = -1, h = n, m = 0, y = 0;
  const v = [y];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    a.push(i), h._tokenizer || (u = r.sliceStream(h), h.next || u.push(null), d && o.defineSkip(h.start), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < s.length; )
    // Find a void token that includes a break.
    s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (y = f + 1, v.push(y), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (o.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : v.pop(), f = v.length; f--; ) {
    const w = s.slice(v[f], v[f + 1]), I = a.pop();
    c.push([I, I + w.length - 1]), e.splice(I, 2, w);
  }
  for (c.reverse(), f = -1; ++f < c.length; )
    l[m + c[f][0]] = m + c[f][1], m += c[f][1] - c[f][0] - 1;
  return l;
}
const n7 = {
  resolve: i7,
  tokenize: a7
}, r7 = {
  partial: !0,
  tokenize: o7
};
function i7(e) {
  return p2(e), e;
}
function a7(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? a(s) : He(s) ? e.check(r7, o, a)(s) : (e.consume(s), i);
  }
  function a(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function o7(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), St(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || He(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function m2(e, t, n, r, i, a, o, s, c) {
  const l = c || Number.POSITIVE_INFINITY;
  let u = 0;
  return d;
  function d(w) {
    return w === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(w), e.exit(a), f) : w === null || w === 32 || w === 41 || Lp(w) ? n(w) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), y(w));
  }
  function f(w) {
    return w === 62 ? (e.enter(a), e.consume(w), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), h(w));
  }
  function h(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(s), f(w)) : w === null || w === 60 || He(w) ? n(w) : (e.consume(w), w === 92 ? m : h);
  }
  function m(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), h) : h(w);
  }
  function y(w) {
    return !u && (w === null || w === 41 || On(w)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(w)) : u < l && w === 40 ? (e.consume(w), u++, y) : w === 41 ? (e.consume(w), u--, y) : w === null || w === 32 || w === 40 || Lp(w) ? n(w) : (e.consume(w), w === 92 ? v : y);
  }
  function v(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), y) : y(w);
  }
}
function g2(e, t, n, r, i, a) {
  const o = this;
  let s = 0, c;
  return l;
  function l(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(a), u;
  }
  function u(h) {
    return s > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(h) : h === 93 ? (e.exit(a), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : He(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || He(h) || s++ > 999 ? (e.exit("chunkString"), u(h)) : (e.consume(h), c || (c = !ft(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), s++, d) : d(h);
  }
}
function y2(e, t, n, r, i, a) {
  let o;
  return s;
  function s(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(i), e.consume(f), e.exit(i), o = f === 40 ? 41 : f, c) : n(f);
  }
  function c(f) {
    return f === o ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : (e.enter(a), l(f));
  }
  function l(f) {
    return f === o ? (e.exit(a), c(o)) : f === null ? n(f) : He(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), St(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(f));
  }
  function u(f) {
    return f === o || f === null || He(f) ? (e.exit("chunkString"), l(f)) : (e.consume(f), f === 92 ? d : u);
  }
  function d(f) {
    return f === o || f === 92 ? (e.consume(f), u) : u(f);
  }
}
function zs(e, t) {
  let n;
  return r;
  function r(i) {
    return He(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : ft(i) ? St(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const s7 = {
  name: "definition",
  tokenize: c7
}, l7 = {
  partial: !0,
  tokenize: u7
};
function c7(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(h) {
    return e.enter("definition"), o(h);
  }
  function o(h) {
    return g2.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function s(h) {
    return i = go(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return On(h) ? zs(e, l)(h) : l(h);
  }
  function l(h) {
    return m2(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function u(h) {
    return e.attempt(l7, d, d)(h);
  }
  function d(h) {
    return ft(h) ? St(e, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || He(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function u7(e, t, n) {
  return r;
  function r(s) {
    return On(s) ? zs(e, i)(s) : n(s);
  }
  function i(s) {
    return y2(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function a(s) {
    return ft(s) ? St(e, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || He(s) ? t(s) : n(s);
  }
}
const f7 = {
  name: "hardBreakEscape",
  tokenize: d7
};
function d7(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return He(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const h7 = {
  name: "headingAtx",
  resolve: p7,
  tokenize: m7
};
function p7(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, qr(e, r, n - r + 1, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]])), e;
}
function m7(e, t, n) {
  let r = 0;
  return i;
  function i(u) {
    return e.enter("atxHeading"), a(u);
  }
  function a(u) {
    return e.enter("atxHeadingSequence"), o(u);
  }
  function o(u) {
    return u === 35 && r++ < 6 ? (e.consume(u), o) : u === null || On(u) ? (e.exit("atxHeadingSequence"), s(u)) : n(u);
  }
  function s(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), c(u)) : u === null || He(u) ? (e.exit("atxHeading"), t(u)) : ft(u) ? St(e, s, "whitespace")(u) : (e.enter("atxHeadingText"), l(u));
  }
  function c(u) {
    return u === 35 ? (e.consume(u), c) : (e.exit("atxHeadingSequence"), s(u));
  }
  function l(u) {
    return u === null || u === 35 || On(u) ? (e.exit("atxHeadingText"), s(u)) : (e.consume(u), l);
  }
}
const g7 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], YA = ["pre", "script", "style", "textarea"], y7 = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: x7,
  tokenize: b7
}, A7 = {
  partial: !0,
  tokenize: _7
}, v7 = {
  partial: !0,
  tokenize: w7
};
function x7(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function b7(e, t, n) {
  const r = this;
  let i, a, o, s, c;
  return l;
  function l(N) {
    return u(N);
  }
  function u(N) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(N), d;
  }
  function d(N) {
    return N === 33 ? (e.consume(N), f) : N === 47 ? (e.consume(N), a = !0, y) : N === 63 ? (e.consume(N), i = 3, r.interrupt ? t : S) : $r(N) ? (e.consume(N), o = String.fromCharCode(N), v) : n(N);
  }
  function f(N) {
    return N === 45 ? (e.consume(N), i = 2, h) : N === 91 ? (e.consume(N), i = 5, s = 0, m) : $r(N) ? (e.consume(N), i = 4, r.interrupt ? t : S) : n(N);
  }
  function h(N) {
    return N === 45 ? (e.consume(N), r.interrupt ? t : S) : n(N);
  }
  function m(N) {
    const q = "CDATA[";
    return N === q.charCodeAt(s++) ? (e.consume(N), s === q.length ? r.interrupt ? t : E : m) : n(N);
  }
  function y(N) {
    return $r(N) ? (e.consume(N), o = String.fromCharCode(N), v) : n(N);
  }
  function v(N) {
    if (N === null || N === 47 || N === 62 || On(N)) {
      const q = N === 47, G = o.toLowerCase();
      return !q && !a && YA.includes(G) ? (i = 1, r.interrupt ? t(N) : E(N)) : g7.includes(o.toLowerCase()) ? (i = 6, q ? (e.consume(N), w) : r.interrupt ? t(N) : E(N)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(N) : a ? I(N) : M(N));
    }
    return N === 45 || Hn(N) ? (e.consume(N), o += String.fromCharCode(N), v) : n(N);
  }
  function w(N) {
    return N === 62 ? (e.consume(N), r.interrupt ? t : E) : n(N);
  }
  function I(N) {
    return ft(N) ? (e.consume(N), I) : R(N);
  }
  function M(N) {
    return N === 47 ? (e.consume(N), R) : N === 58 || N === 95 || $r(N) ? (e.consume(N), k) : ft(N) ? (e.consume(N), M) : R(N);
  }
  function k(N) {
    return N === 45 || N === 46 || N === 58 || N === 95 || Hn(N) ? (e.consume(N), k) : g(N);
  }
  function g(N) {
    return N === 61 ? (e.consume(N), A) : ft(N) ? (e.consume(N), g) : M(N);
  }
  function A(N) {
    return N === null || N === 60 || N === 61 || N === 62 || N === 96 ? n(N) : N === 34 || N === 39 ? (e.consume(N), c = N, b) : ft(N) ? (e.consume(N), A) : x(N);
  }
  function b(N) {
    return N === c ? (e.consume(N), c = null, _) : N === null || He(N) ? n(N) : (e.consume(N), b);
  }
  function x(N) {
    return N === null || N === 34 || N === 39 || N === 47 || N === 60 || N === 61 || N === 62 || N === 96 || On(N) ? g(N) : (e.consume(N), x);
  }
  function _(N) {
    return N === 47 || N === 62 || ft(N) ? M(N) : n(N);
  }
  function R(N) {
    return N === 62 ? (e.consume(N), P) : n(N);
  }
  function P(N) {
    return N === null || He(N) ? E(N) : ft(N) ? (e.consume(N), P) : n(N);
  }
  function E(N) {
    return N === 45 && i === 2 ? (e.consume(N), z) : N === 60 && i === 1 ? (e.consume(N), B) : N === 62 && i === 4 ? (e.consume(N), $) : N === 63 && i === 3 ? (e.consume(N), S) : N === 93 && i === 5 ? (e.consume(N), L) : He(N) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(A7, j, C)(N)) : N === null || He(N) ? (e.exit("htmlFlowData"), C(N)) : (e.consume(N), E);
  }
  function C(N) {
    return e.check(v7, T, j)(N);
  }
  function T(N) {
    return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), D;
  }
  function D(N) {
    return N === null || He(N) ? C(N) : (e.enter("htmlFlowData"), E(N));
  }
  function z(N) {
    return N === 45 ? (e.consume(N), S) : E(N);
  }
  function B(N) {
    return N === 47 ? (e.consume(N), o = "", W) : E(N);
  }
  function W(N) {
    if (N === 62) {
      const q = o.toLowerCase();
      return YA.includes(q) ? (e.consume(N), $) : E(N);
    }
    return $r(N) && o.length < 8 ? (e.consume(N), o += String.fromCharCode(N), W) : E(N);
  }
  function L(N) {
    return N === 93 ? (e.consume(N), S) : E(N);
  }
  function S(N) {
    return N === 62 ? (e.consume(N), $) : N === 45 && i === 2 ? (e.consume(N), S) : E(N);
  }
  function $(N) {
    return N === null || He(N) ? (e.exit("htmlFlowData"), j(N)) : (e.consume(N), $);
  }
  function j(N) {
    return e.exit("htmlFlow"), t(N);
  }
}
function w7(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return He(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function _7(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(td, t, n);
  }
}
const S7 = {
  name: "htmlText",
  tokenize: C7
};
function C7(e, t, n) {
  const r = this;
  let i, a, o;
  return s;
  function s(S) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(S), c;
  }
  function c(S) {
    return S === 33 ? (e.consume(S), l) : S === 47 ? (e.consume(S), g) : S === 63 ? (e.consume(S), M) : $r(S) ? (e.consume(S), x) : n(S);
  }
  function l(S) {
    return S === 45 ? (e.consume(S), u) : S === 91 ? (e.consume(S), a = 0, m) : $r(S) ? (e.consume(S), I) : n(S);
  }
  function u(S) {
    return S === 45 ? (e.consume(S), h) : n(S);
  }
  function d(S) {
    return S === null ? n(S) : S === 45 ? (e.consume(S), f) : He(S) ? (o = d, B(S)) : (e.consume(S), d);
  }
  function f(S) {
    return S === 45 ? (e.consume(S), h) : d(S);
  }
  function h(S) {
    return S === 62 ? z(S) : S === 45 ? f(S) : d(S);
  }
  function m(S) {
    const $ = "CDATA[";
    return S === $.charCodeAt(a++) ? (e.consume(S), a === $.length ? y : m) : n(S);
  }
  function y(S) {
    return S === null ? n(S) : S === 93 ? (e.consume(S), v) : He(S) ? (o = y, B(S)) : (e.consume(S), y);
  }
  function v(S) {
    return S === 93 ? (e.consume(S), w) : y(S);
  }
  function w(S) {
    return S === 62 ? z(S) : S === 93 ? (e.consume(S), w) : y(S);
  }
  function I(S) {
    return S === null || S === 62 ? z(S) : He(S) ? (o = I, B(S)) : (e.consume(S), I);
  }
  function M(S) {
    return S === null ? n(S) : S === 63 ? (e.consume(S), k) : He(S) ? (o = M, B(S)) : (e.consume(S), M);
  }
  function k(S) {
    return S === 62 ? z(S) : M(S);
  }
  function g(S) {
    return $r(S) ? (e.consume(S), A) : n(S);
  }
  function A(S) {
    return S === 45 || Hn(S) ? (e.consume(S), A) : b(S);
  }
  function b(S) {
    return He(S) ? (o = b, B(S)) : ft(S) ? (e.consume(S), b) : z(S);
  }
  function x(S) {
    return S === 45 || Hn(S) ? (e.consume(S), x) : S === 47 || S === 62 || On(S) ? _(S) : n(S);
  }
  function _(S) {
    return S === 47 ? (e.consume(S), z) : S === 58 || S === 95 || $r(S) ? (e.consume(S), R) : He(S) ? (o = _, B(S)) : ft(S) ? (e.consume(S), _) : z(S);
  }
  function R(S) {
    return S === 45 || S === 46 || S === 58 || S === 95 || Hn(S) ? (e.consume(S), R) : P(S);
  }
  function P(S) {
    return S === 61 ? (e.consume(S), E) : He(S) ? (o = P, B(S)) : ft(S) ? (e.consume(S), P) : _(S);
  }
  function E(S) {
    return S === null || S === 60 || S === 61 || S === 62 || S === 96 ? n(S) : S === 34 || S === 39 ? (e.consume(S), i = S, C) : He(S) ? (o = E, B(S)) : ft(S) ? (e.consume(S), E) : (e.consume(S), T);
  }
  function C(S) {
    return S === i ? (e.consume(S), i = void 0, D) : S === null ? n(S) : He(S) ? (o = C, B(S)) : (e.consume(S), C);
  }
  function T(S) {
    return S === null || S === 34 || S === 39 || S === 60 || S === 61 || S === 96 ? n(S) : S === 47 || S === 62 || On(S) ? _(S) : (e.consume(S), T);
  }
  function D(S) {
    return S === 47 || S === 62 || On(S) ? _(S) : n(S);
  }
  function z(S) {
    return S === 62 ? (e.consume(S), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(S);
  }
  function B(S) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), W;
  }
  function W(S) {
    return ft(S) ? St(e, L, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(S) : L(S);
  }
  function L(S) {
    return e.enter("htmlTextData"), o(S);
  }
}
const s0 = {
  name: "labelEnd",
  resolveAll: M7,
  resolveTo: I7,
  tokenize: N7
}, E7 = {
  tokenize: O7
}, k7 = {
  tokenize: R7
}, T7 = {
  tokenize: D7
};
function M7(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && qr(e, 0, e.length, n), e;
}
function I7(e, t) {
  let n = e.length, r = 0, i, a, o, s;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = n);
  const c = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, l = {
    type: "label",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[a + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return s = [["enter", c, t], ["enter", l, t]], s = ir(s, e.slice(a + 1, a + r + 3)), s = ir(s, [["enter", u, t]]), s = ir(s, o0(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), s = ir(s, [["exit", u, t], e[o - 2], e[o - 1], ["exit", l, t]]), s = ir(s, e.slice(o + 1)), s = ir(s, [["exit", c, t]]), qr(e, a, e.length, s), e;
}
function N7(e, t, n) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return s;
  function s(f) {
    return a ? a._inactive ? d(f) : (o = r.parser.defined.includes(go(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(f);
  }
  function c(f) {
    return f === 40 ? e.attempt(E7, u, o ? u : d)(f) : f === 91 ? e.attempt(k7, u, o ? l : d)(f) : o ? u(f) : d(f);
  }
  function l(f) {
    return e.attempt(T7, u, d)(f);
  }
  function u(f) {
    return t(f);
  }
  function d(f) {
    return a._balanced = !0, n(f);
  }
}
function O7(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return On(d) ? zs(e, a)(d) : a(d);
  }
  function a(d) {
    return d === 41 ? u(d) : m2(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function o(d) {
    return On(d) ? zs(e, c)(d) : u(d);
  }
  function s(d) {
    return n(d);
  }
  function c(d) {
    return d === 34 || d === 39 || d === 40 ? y2(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : u(d);
  }
  function l(d) {
    return On(d) ? zs(e, u)(d) : u(d);
  }
  function u(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function R7(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return g2.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(s);
  }
  function a(s) {
    return r.parser.defined.includes(go(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(s) : n(s);
  }
  function o(s) {
    return n(s);
  }
}
function D7(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const P7 = {
  name: "labelStartImage",
  resolveAll: s0.resolveAll,
  tokenize: L7
};
function L7(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), a;
  }
  function a(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const z7 = {
  name: "labelStartLink",
  resolveAll: s0.resolveAll,
  tokenize: B7
};
function B7(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const ah = {
  name: "lineEnding",
  tokenize: F7
};
function F7(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), St(e, t, "linePrefix");
  }
}
const Hc = {
  name: "thematicBreak",
  tokenize: Y7
};
function Y7(e, t, n) {
  let r = 0, i;
  return a;
  function a(l) {
    return e.enter("thematicBreak"), o(l);
  }
  function o(l) {
    return i = l, s(l);
  }
  function s(l) {
    return l === i ? (e.enter("thematicBreakSequence"), c(l)) : r >= 3 && (l === null || He(l)) ? (e.exit("thematicBreak"), t(l)) : n(l);
  }
  function c(l) {
    return l === i ? (e.consume(l), r++, c) : (e.exit("thematicBreakSequence"), ft(l) ? St(e, s, "whitespace")(l) : s(l));
  }
}
const Mn = {
  continuation: {
    tokenize: U7
  },
  exit: G7,
  name: "list",
  tokenize: W7
}, j7 = {
  partial: !0,
  tokenize: V7
}, $7 = {
  partial: !0,
  tokenize: H7
};
function W7(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return s;
  function s(h) {
    const m = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (m === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : zp(h)) {
      if (r.containerState.type || (r.containerState.type = m, e.enter(m, {
        _container: !0
      })), m === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Hc, n, l)(h) : l(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return zp(h) && ++o < 10 ? (e.consume(h), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), l(h)) : n(h);
  }
  function l(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      td,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      e.attempt(j7, f, d)
    );
  }
  function u(h) {
    return r.containerState.initialBlankLine = !0, a++, f(h);
  }
  function d(h) {
    return ft(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function U7(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(td, i, a);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, St(e, t, "listItemIndent", r.containerState.size + 1)(s);
  }
  function a(s) {
    return r.containerState.furtherBlankLines || !ft(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt($7, t, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, St(e, e.attempt(Mn, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function H7(e, t, n) {
  const r = this;
  return St(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function G7(e) {
  e.exit(this.containerState.type);
}
function V7(e, t, n) {
  const r = this;
  return St(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !ft(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const jA = {
  name: "setextUnderline",
  resolveTo: Q7,
  tokenize: q7
};
function Q7(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[a][1].end
  }) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function q7(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(l) {
    let u = r.events.length, d;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        d = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = l, o(l)) : n(l);
  }
  function o(l) {
    return e.enter("setextHeadingLineSequence"), s(l);
  }
  function s(l) {
    return l === i ? (e.consume(l), s) : (e.exit("setextHeadingLineSequence"), ft(l) ? St(e, c, "lineSuffix")(l) : c(l));
  }
  function c(l) {
    return l === null || He(l) ? (e.exit("setextHeadingLine"), t(l)) : n(l);
  }
}
const X7 = {
  tokenize: J7
};
function J7(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    td,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, St(e, e.attempt(this.parser.constructs.flow, i, e.attempt(n7, i)), "linePrefix"))
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const K7 = {
  resolveAll: v2()
}, Z7 = A2("string"), e$ = A2("text");
function A2(e) {
  return {
    resolveAll: v2(e === "text" ? t$ : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, o, s);
    return o;
    function o(u) {
      return l(u) ? a(u) : s(u);
    }
    function s(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), c;
    }
    function c(u) {
      return l(u) ? (n.exit("data"), a(u)) : (n.consume(u), c);
    }
    function l(u) {
      if (u === null)
        return !0;
      const d = i[u];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function v2(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function t$(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, o = -1, s = 0, c;
      for (; a--; ) {
        const l = i[a];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o) break;
          o = -1;
        } else if (l === -2)
          c = !0, s++;
        else if (l !== -1) {
          a++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (s = 0), s) {
        const l = {
          type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: a ? o : r.start._bufferIndex + o,
            _index: r.start._index + a,
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...l.start
        }, r.start.offset === r.end.offset ? Object.assign(r, l) : (e.splice(n, 0, ["enter", l, t], ["exit", l, t]), n += 2);
      }
      n++;
    }
  return e;
}
const n$ = {
  42: Mn,
  43: Mn,
  45: Mn,
  48: Mn,
  49: Mn,
  50: Mn,
  51: Mn,
  52: Mn,
  53: Mn,
  54: Mn,
  55: Mn,
  56: Mn,
  57: Mn,
  62: f2
}, r$ = {
  91: s7
}, i$ = {
  [-2]: ih,
  [-1]: ih,
  32: ih
}, a$ = {
  35: h7,
  42: Hc,
  45: [jA, Hc],
  60: y7,
  61: jA,
  95: Hc,
  96: FA,
  126: FA
}, o$ = {
  38: h2,
  92: d2
}, s$ = {
  [-5]: ah,
  [-4]: ah,
  [-3]: ah,
  33: P7,
  38: h2,
  42: Bp,
  60: [z9, S7],
  91: z7,
  92: [f7, d2],
  93: s0,
  95: Bp,
  96: X9
}, l$ = {
  null: [Bp, K7]
}, c$ = {
  null: [42, 95]
}, u$ = {
  null: []
}, f$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: c$,
  contentInitial: r$,
  disable: u$,
  document: n$,
  flow: a$,
  flowInitial: i$,
  insideSpan: l$,
  string: o$,
  text: s$
}, Symbol.toStringTag, { value: "Module" }));
function d$(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, a = [];
  let o = [], s = [];
  const c = {
    attempt: b(g),
    check: b(A),
    consume: I,
    enter: M,
    exit: k,
    interrupt: b(A, {
      interrupt: !0
    })
  }, l = {
    code: null,
    containerState: {},
    defineSkip: y,
    events: [],
    now: m,
    parser: e,
    previous: null,
    sliceSerialize: f,
    sliceStream: h,
    write: d
  };
  let u = t.tokenize.call(l, c);
  return t.resolveAll && a.push(t), l;
  function d(P) {
    return o = ir(o, P), v(), o[o.length - 1] !== null ? [] : (x(t, 0), l.events = o0(a, l.events, l), l.events);
  }
  function f(P, E) {
    return p$(h(P), E);
  }
  function h(P) {
    return h$(o, P);
  }
  function m() {
    const {
      _bufferIndex: P,
      _index: E,
      line: C,
      column: T,
      offset: D
    } = r;
    return {
      _bufferIndex: P,
      _index: E,
      line: C,
      column: T,
      offset: D
    };
  }
  function y(P) {
    i[P.line] = P.column, R();
  }
  function v() {
    let P;
    for (; r._index < o.length; ) {
      const E = o[r._index];
      if (typeof E == "string")
        for (P = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === P && r._bufferIndex < E.length; )
          w(E.charCodeAt(r._bufferIndex));
      else
        w(E);
    }
  }
  function w(P) {
    u = u(P);
  }
  function I(P) {
    He(P) ? (r.line++, r.column = 1, r.offset += P === -3 ? 2 : 1, R()) : P !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = P;
  }
  function M(P, E) {
    const C = E || {};
    return C.type = P, C.start = m(), l.events.push(["enter", C, l]), s.push(C), C;
  }
  function k(P) {
    const E = s.pop();
    return E.end = m(), l.events.push(["exit", E, l]), E;
  }
  function g(P, E) {
    x(P, E.from);
  }
  function A(P, E) {
    E.restore();
  }
  function b(P, E) {
    return C;
    function C(T, D, z) {
      let B, W, L, S;
      return Array.isArray(T) ? (
        /* c8 ignore next 1 */
        j(T)
      ) : "tokenize" in T ? (
        // Looks like a construct.
        j([
          /** @type {Construct} */
          T
        ])
      ) : $(T);
      function $(X) {
        return Y;
        function Y(Q) {
          const V = Q !== null && X[Q], U = Q !== null && X.null, Z = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(V) ? V : V ? [V] : [],
            ...Array.isArray(U) ? U : U ? [U] : []
          ];
          return j(Z)(Q);
        }
      }
      function j(X) {
        return B = X, W = 0, X.length === 0 ? z : N(X[W]);
      }
      function N(X) {
        return Y;
        function Y(Q) {
          return S = _(), L = X, X.partial || (l.currentConstruct = X), X.name && l.parser.constructs.disable.null.includes(X.name) ? G() : X.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            E ? Object.assign(Object.create(l), E) : l,
            c,
            q,
            G
          )(Q);
        }
      }
      function q(X) {
        return P(L, S), D;
      }
      function G(X) {
        return S.restore(), ++W < B.length ? N(B[W]) : z;
      }
    }
  }
  function x(P, E) {
    P.resolveAll && !a.includes(P) && a.push(P), P.resolve && qr(l.events, E, l.events.length - E, P.resolve(l.events.slice(E), l)), P.resolveTo && (l.events = P.resolveTo(l.events, l));
  }
  function _() {
    const P = m(), E = l.previous, C = l.currentConstruct, T = l.events.length, D = Array.from(s);
    return {
      from: T,
      restore: z
    };
    function z() {
      r = P, l.previous = E, l.currentConstruct = C, l.events.length = T, s = D, R();
    }
  }
  function R() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function h$(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, a)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function p$(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else switch (a) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(a);
    }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
function m$(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      w9([f$, ...(e || {}).extensions || []])
    ),
    content: i(I9),
    defined: [],
    document: i(O9),
    flow: i(X7),
    lazy: {},
    string: i(Z7),
    text: i(e$)
  };
  return r;
  function i(a) {
    return o;
    function o(s) {
      return d$(r, a, s);
    }
  }
}
function g$(e) {
  for (; !p2(e); )
    ;
  return e;
}
const $A = /[\0\t\n\r]/g;
function y$() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, o, s) {
    const c = [];
    let l, u, d, f, h;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), d = 0, t = "", n && (a.charCodeAt(0) === 65279 && d++, n = void 0); d < a.length; ) {
      if ($A.lastIndex = d, l = $A.exec(a), f = l && l.index !== void 0 ? l.index : a.length, h = a.charCodeAt(f), !l) {
        t = a.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), d < f && (c.push(a.slice(d, f)), e += f - d), h) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, c.push(-2); e++ < u; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return s && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const A$ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function v$(e) {
  return e.replace(A$, x$);
}
function x$(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return u2(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return a0(n) || e;
}
const x2 = {}.hasOwnProperty;
function b$(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), w$(n)(g$(m$(n).document().write(y$()(e, t, !0))));
}
function w$(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(ke),
      autolinkProtocol: _,
      autolinkEmail: _,
      atxHeading: a(re),
      blockQuote: a(U),
      characterEscape: _,
      characterReference: _,
      codeFenced: a(Z),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(Z, o),
      codeText: a(H, o),
      codeTextData: _,
      data: _,
      codeFlowValue: _,
      definition: a(ee),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(ie),
      hardBreakEscape: a(K),
      hardBreakTrailing: a(K),
      htmlFlow: a(se, o),
      htmlFlowData: _,
      htmlText: a(se, o),
      htmlTextData: _,
      image: a(xe),
      label: o,
      link: a(ke),
      listItem: a(fe),
      listItemValue: f,
      listOrdered: a(ue, d),
      listUnordered: a(ue),
      paragraph: a(de),
      reference: N,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(re),
      strong: a(ce),
      thematicBreak: a(oe)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: g,
      autolink: c(),
      autolinkEmail: V,
      autolinkProtocol: Q,
      blockQuote: c(),
      characterEscapeValue: R,
      characterReferenceMarkerHexadecimal: G,
      characterReferenceMarkerNumeric: G,
      characterReferenceValue: X,
      characterReference: Y,
      codeFenced: c(v),
      codeFencedFence: y,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: m,
      codeFlowValue: R,
      codeIndented: c(w),
      codeText: c(D),
      codeTextData: R,
      data: R,
      definition: c(),
      definitionDestinationString: k,
      definitionLabelString: I,
      definitionTitleString: M,
      emphasis: c(),
      hardBreakEscape: c(E),
      hardBreakTrailing: c(E),
      htmlFlow: c(C),
      htmlFlowData: R,
      htmlText: c(T),
      htmlTextData: R,
      image: c(B),
      label: L,
      labelText: W,
      lineEnding: P,
      link: c(z),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: q,
      resourceDestinationString: S,
      resourceTitleString: $,
      resource: j,
      setextHeading: c(x),
      setextHeadingLineSequence: b,
      setextHeadingText: A,
      strong: c(),
      thematicBreak: c()
    }
  };
  b2(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(J) {
    let ne = {
      type: "root",
      children: []
    };
    const ye = {
      stack: [ne],
      tokenStack: [],
      config: t,
      enter: s,
      exit: l,
      buffer: o,
      resume: u,
      data: n
    }, Ae = [];
    let be = -1;
    for (; ++be < J.length; )
      if (J[be][1].type === "listOrdered" || J[be][1].type === "listUnordered")
        if (J[be][0] === "enter")
          Ae.push(be);
        else {
          const je = Ae.pop();
          be = i(J, je, be);
        }
    for (be = -1; ++be < J.length; ) {
      const je = t[J[be][0]];
      x2.call(je, J[be][1].type) && je[J[be][1].type].call(Object.assign({
        sliceSerialize: J[be][2].sliceSerialize
      }, ye), J[be][1]);
    }
    if (ye.tokenStack.length > 0) {
      const je = ye.tokenStack[ye.tokenStack.length - 1];
      (je[1] || WA).call(ye, void 0, je[0]);
    }
    for (ne.position = {
      start: Ei(J.length > 0 ? J[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Ei(J.length > 0 ? J[J.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, be = -1; ++be < t.transforms.length; )
      ne = t.transforms[be](ne) || ne;
    return ne;
  }
  function i(J, ne, ye) {
    let Ae = ne - 1, be = -1, je = !1, Oe, Ve, _e, Re;
    for (; ++Ae <= ye; ) {
      const Le = J[Ae];
      switch (Le[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Le[0] === "enter" ? be++ : be--, Re = void 0;
          break;
        }
        case "lineEndingBlank": {
          Le[0] === "enter" && (Oe && !Re && !be && !_e && (_e = Ae), Re = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Re = void 0;
      }
      if (!be && Le[0] === "enter" && Le[1].type === "listItemPrefix" || be === -1 && Le[0] === "exit" && (Le[1].type === "listUnordered" || Le[1].type === "listOrdered")) {
        if (Oe) {
          let Ge = Ae;
          for (Ve = void 0; Ge--; ) {
            const Ke = J[Ge];
            if (Ke[1].type === "lineEnding" || Ke[1].type === "lineEndingBlank") {
              if (Ke[0] === "exit") continue;
              Ve && (J[Ve][1].type = "lineEndingBlank", je = !0), Ke[1].type = "lineEnding", Ve = Ge;
            } else if (!(Ke[1].type === "linePrefix" || Ke[1].type === "blockQuotePrefix" || Ke[1].type === "blockQuotePrefixWhitespace" || Ke[1].type === "blockQuoteMarker" || Ke[1].type === "listItemIndent")) break;
          }
          _e && (!Ve || _e < Ve) && (Oe._spread = !0), Oe.end = Object.assign({}, Ve ? J[Ve][1].start : Le[1].end), J.splice(Ve || Ae, 0, ["exit", Oe, Le[2]]), Ae++, ye++;
        }
        if (Le[1].type === "listItemPrefix") {
          const Ge = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Le[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Oe = Ge, J.splice(Ae, 0, ["enter", Ge, Le[2]]), Ae++, ye++, _e = void 0, Re = !0;
        }
      }
    }
    return J[ne][1]._spread = je, ye;
  }
  function a(J, ne) {
    return ye;
    function ye(Ae) {
      s.call(this, J(Ae), Ae), ne && ne.call(this, Ae);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(J, ne, ye) {
    this.stack[this.stack.length - 1].children.push(J), this.stack.push(J), this.tokenStack.push([ne, ye || void 0]), J.position = {
      start: Ei(ne.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(J) {
    return ne;
    function ne(ye) {
      J && J.call(this, ye), l.call(this, ye);
    }
  }
  function l(J, ne) {
    const ye = this.stack.pop(), Ae = this.tokenStack.pop();
    if (Ae)
      Ae[0].type !== J.type && (ne ? ne.call(this, J, Ae[0]) : (Ae[1] || WA).call(this, J, Ae[0]));
    else throw new Error("Cannot close `" + J.type + "` (" + Ls({
      start: J.start,
      end: J.end
    }) + "): it’s not open");
    ye.position.end = Ei(J.end);
  }
  function u() {
    return x9(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(J) {
    if (this.data.expectingFirstListItemValue) {
      const ne = this.stack[this.stack.length - 2];
      ne.start = Number.parseInt(this.sliceSerialize(J), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.lang = J;
  }
  function m() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.meta = J;
  }
  function y() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function v() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.value = J.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.value = J.replace(/(\r?\n|\r)$/g, "");
  }
  function I(J) {
    const ne = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = ne, ye.identifier = go(this.sliceSerialize(J)).toLowerCase();
  }
  function M() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.title = J;
  }
  function k() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.url = J;
  }
  function g(J) {
    const ne = this.stack[this.stack.length - 1];
    if (!ne.depth) {
      const ye = this.sliceSerialize(J).length;
      ne.depth = ye;
    }
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function b(J) {
    const ne = this.stack[this.stack.length - 1];
    ne.depth = this.sliceSerialize(J).codePointAt(0) === 61 ? 1 : 2;
  }
  function x() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function _(J) {
    const ye = this.stack[this.stack.length - 1].children;
    let Ae = ye[ye.length - 1];
    (!Ae || Ae.type !== "text") && (Ae = te(), Ae.position = {
      start: Ei(J.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ye.push(Ae)), this.stack.push(Ae);
  }
  function R(J) {
    const ne = this.stack.pop();
    ne.value += this.sliceSerialize(J), ne.position.end = Ei(J.end);
  }
  function P(J) {
    const ne = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ye = ne.children[ne.children.length - 1];
      ye.position.end = Ei(J.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(ne.type) && (_.call(this, J), R.call(this, J));
  }
  function E() {
    this.data.atHardBreak = !0;
  }
  function C() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.value = J;
  }
  function T() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.value = J;
  }
  function D() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.value = J;
  }
  function z() {
    const J = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ne = this.data.referenceType || "shortcut";
      J.type += "Reference", J.referenceType = ne, delete J.url, delete J.title;
    } else
      delete J.identifier, delete J.label;
    this.data.referenceType = void 0;
  }
  function B() {
    const J = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ne = this.data.referenceType || "shortcut";
      J.type += "Reference", J.referenceType = ne, delete J.url, delete J.title;
    } else
      delete J.identifier, delete J.label;
    this.data.referenceType = void 0;
  }
  function W(J) {
    const ne = this.sliceSerialize(J), ye = this.stack[this.stack.length - 2];
    ye.label = v$(ne), ye.identifier = go(ne).toLowerCase();
  }
  function L() {
    const J = this.stack[this.stack.length - 1], ne = this.resume(), ye = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ye.type === "link") {
      const Ae = J.children;
      ye.children = Ae;
    } else
      ye.alt = ne;
  }
  function S() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.url = J;
  }
  function $() {
    const J = this.resume(), ne = this.stack[this.stack.length - 1];
    ne.title = J;
  }
  function j() {
    this.data.inReference = void 0;
  }
  function N() {
    this.data.referenceType = "collapsed";
  }
  function q(J) {
    const ne = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = ne, ye.identifier = go(this.sliceSerialize(J)).toLowerCase(), this.data.referenceType = "full";
  }
  function G(J) {
    this.data.characterReferenceType = J.type;
  }
  function X(J) {
    const ne = this.sliceSerialize(J), ye = this.data.characterReferenceType;
    let Ae;
    ye ? (Ae = u2(ne, ye === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Ae = a0(ne);
    const be = this.stack[this.stack.length - 1];
    be.value += Ae;
  }
  function Y(J) {
    const ne = this.stack.pop();
    ne.position.end = Ei(J.end);
  }
  function Q(J) {
    R.call(this, J);
    const ne = this.stack[this.stack.length - 1];
    ne.url = this.sliceSerialize(J);
  }
  function V(J) {
    R.call(this, J);
    const ne = this.stack[this.stack.length - 1];
    ne.url = "mailto:" + this.sliceSerialize(J);
  }
  function U() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Z() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function H() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ee() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ie() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function re() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function K() {
    return {
      type: "break"
    };
  }
  function se() {
    return {
      type: "html",
      value: ""
    };
  }
  function xe() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ke() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ue(J) {
    return {
      type: "list",
      ordered: J.type === "listOrdered",
      start: null,
      spread: J._spread,
      children: []
    };
  }
  function fe(J) {
    return {
      type: "listItem",
      spread: J._spread,
      checked: null,
      children: []
    };
  }
  function de() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function ce() {
    return {
      type: "strong",
      children: []
    };
  }
  function te() {
    return {
      type: "text",
      value: ""
    };
  }
  function oe() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ei(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function b2(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? b2(e, r) : _$(e, r);
  }
}
function _$(e, t) {
  let n;
  for (n in t)
    if (x2.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function WA(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ls({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Ls({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Ls({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function S$(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return b$(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function C$(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function E$(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function k$(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function T$(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function M$(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function I$(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Yo(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, s = e.footnoteCounts.get(r);
  s === void 0 ? (s = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, s += 1, e.footnoteCounts.set(r, s);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, c);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, l), e.applyData(t, l);
}
function N$(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function O$(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function w2(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function R$(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return w2(e, t);
  const i = { src: Yo(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function D$(e, t) {
  const n = { src: Yo(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function P$(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function L$(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return w2(e, t);
  const i = { href: Yo(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function z$(e, t) {
  const n = { href: Yo(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function B$(e, t, n) {
  const r = e.all(t), i = n ? F$(n) : _2(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const u = r[0];
    let d;
    u && u.type === "element" && u.tagName === "p" ? d = u : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const u = r[s];
    (i || s !== 0 || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !i ? o.push(...u.children) : o.push(u);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, l), e.applyData(t, l);
}
function F$(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = _2(n[r]);
  }
  return t;
}
function _2(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Y$(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function j$(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function $$(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function W$(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function U$(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = t0(t.children[1]), c = r2(t.children[t.children.length - 1]);
    s && c && (o.position = { start: s, end: c }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function H$(e, t, n) {
  const r = n ? n.children : void 0, a = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, s = o ? o.length : t.children.length;
  let c = -1;
  const l = [];
  for (; ++c < s; ) {
    const d = t.children[c], f = {}, h = o ? o[c] : void 0;
    h && (f.align = h);
    let m = { type: "element", tagName: a, properties: f, children: [] };
    d && (m.children = e.all(d), e.patch(d, m), m = e.applyData(d, m)), l.push(m);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, u), e.applyData(t, u);
}
function G$(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const UA = 9, HA = 32;
function V$(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const a = [];
  for (; r; )
    a.push(
      GA(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return a.push(GA(t.slice(i), i > 0, !1)), a.join("");
}
function GA(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let a = e.codePointAt(r);
    for (; a === UA || a === HA; )
      r++, a = e.codePointAt(r);
  }
  if (n) {
    let a = e.codePointAt(i - 1);
    for (; a === UA || a === HA; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Q$(e, t) {
  const n = { type: "text", value: V$(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function q$(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const X$ = {
  blockquote: C$,
  break: E$,
  code: k$,
  delete: T$,
  emphasis: M$,
  footnoteReference: I$,
  heading: N$,
  html: O$,
  imageReference: R$,
  image: D$,
  inlineCode: P$,
  linkReference: L$,
  link: z$,
  listItem: B$,
  list: Y$,
  paragraph: j$,
  // @ts-expect-error: root is different, but hard to type.
  root: $$,
  strong: W$,
  table: U$,
  tableCell: G$,
  tableRow: H$,
  text: Q$,
  thematicBreak: q$,
  toml: _c,
  yaml: _c,
  definition: _c,
  footnoteDefinition: _c
};
function _c() {
}
const S2 = -1, nd = 0, Bs = 1, qu = 2, l0 = 3, c0 = 4, u0 = 5, f0 = 6, C2 = 7, E2 = 8, VA = typeof self == "object" ? self : globalThis, J$ = (e, t) => {
  const n = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = t[i];
    switch (a) {
      case nd:
      case S2:
        return n(o, i);
      case Bs: {
        const s = n([], i);
        for (const c of o)
          s.push(r(c));
        return s;
      }
      case qu: {
        const s = n({}, i);
        for (const [c, l] of o)
          s[r(c)] = r(l);
        return s;
      }
      case l0:
        return n(new Date(o), i);
      case c0: {
        const { source: s, flags: c } = o;
        return n(new RegExp(s, c), i);
      }
      case u0: {
        const s = n(/* @__PURE__ */ new Map(), i);
        for (const [c, l] of o)
          s.set(r(c), r(l));
        return s;
      }
      case f0: {
        const s = n(/* @__PURE__ */ new Set(), i);
        for (const c of o)
          s.add(r(c));
        return s;
      }
      case C2: {
        const { name: s, message: c } = o;
        return n(new VA[s](c), i);
      }
      case E2:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: s } = new Uint8Array(o);
        return n(new DataView(s), o);
      }
    }
    return n(new VA[a](o), i);
  };
  return r;
}, QA = (e) => J$(/* @__PURE__ */ new Map(), e)(0), Va = "", { toString: K$ } = {}, { keys: Z$ } = Object, fs = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [nd, t];
  const n = K$.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Bs, Va];
    case "Object":
      return [qu, Va];
    case "Date":
      return [l0, Va];
    case "RegExp":
      return [c0, Va];
    case "Map":
      return [u0, Va];
    case "Set":
      return [f0, Va];
    case "DataView":
      return [Bs, n];
  }
  return n.includes("Array") ? [Bs, n] : n.includes("Error") ? [C2, n] : [qu, n];
}, Sc = ([e, t]) => e === nd && (t === "function" || t === "symbol"), eW = (e, t, n, r) => {
  const i = (o, s) => {
    const c = r.push(o) - 1;
    return n.set(s, c), c;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [s, c] = fs(o);
    switch (s) {
      case nd: {
        let u = o;
        switch (c) {
          case "bigint":
            s = E2, u = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            u = null;
            break;
          case "undefined":
            return i([S2], o);
        }
        return i([s, u], o);
      }
      case Bs: {
        if (c) {
          let f = o;
          return c === "DataView" ? f = new Uint8Array(o.buffer) : c === "ArrayBuffer" && (f = new Uint8Array(o)), i([c, [...f]], o);
        }
        const u = [], d = i([s, u], o);
        for (const f of o)
          u.push(a(f));
        return d;
      }
      case qu: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const u = [], d = i([s, u], o);
        for (const f of Z$(o))
          (e || !Sc(fs(o[f]))) && u.push([a(f), a(o[f])]);
        return d;
      }
      case l0:
        return i([s, o.toISOString()], o);
      case c0: {
        const { source: u, flags: d } = o;
        return i([s, { source: u, flags: d }], o);
      }
      case u0: {
        const u = [], d = i([s, u], o);
        for (const [f, h] of o)
          (e || !(Sc(fs(f)) || Sc(fs(h)))) && u.push([a(f), a(h)]);
        return d;
      }
      case f0: {
        const u = [], d = i([s, u], o);
        for (const f of o)
          (e || !Sc(fs(f))) && u.push(a(f));
        return d;
      }
    }
    const { message: l } = o;
    return i([s, { name: c, message: l }], o);
  };
  return a;
}, qA = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return eW(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Xu = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? QA(qA(e, t)) : structuredClone(e)
) : (e, t) => QA(qA(e, t));
function tW(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function nW(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function rW(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || tW, r = e.options.footnoteBackLabel || nW, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const l = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!l)
      continue;
    const u = e.all(l), d = String(l.identifier).toUpperCase(), f = Yo(d.toLowerCase());
    let h = 0;
    const m = [], y = e.footnoteCounts.get(d);
    for (; y !== void 0 && ++h <= y; ) {
      m.length > 0 && m.push({ type: "text", value: " " });
      let I = typeof n == "string" ? n : n(c, h);
      typeof I == "string" && (I = { type: "text", value: I }), m.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + f + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const v = u[u.length - 1];
    if (v && v.type === "element" && v.tagName === "p") {
      const I = v.children[v.children.length - 1];
      I && I.type === "text" ? I.value += " " : v.children.push({ type: "text", value: " " }), v.children.push(...m);
    } else
      u.push(...m);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + f },
      children: e.wrap(u, !0)
    };
    e.patch(l, w), s.push(w);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...Xu(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const k2 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return sW;
    if (typeof e == "function")
      return rd(e);
    if (typeof e == "object")
      return Array.isArray(e) ? iW(e) : aW(e);
    if (typeof e == "string")
      return oW(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function iW(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = k2(e[n]);
  return rd(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i)) return !0;
    return !1;
  }
}
function aW(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return rd(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== t[a]) return !1;
    return !0;
  }
}
function oW(e) {
  return rd(t);
  function t(n) {
    return n && n.type === e;
  }
}
function rd(e) {
  return t;
  function t(n, r, i) {
    return !!(lW(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function sW() {
  return !0;
}
function lW(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const T2 = [], cW = !0, XA = !1, uW = "skip";
function fW(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const a = k2(i), o = r ? -1 : 1;
  s(e, void 0, [])();
  function s(c, l, u) {
    const d = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (c.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let h = T2, m, y, v;
      if ((!t || a(c, l, u[u.length - 1] || void 0)) && (h = dW(n(c, u)), h[0] === XA))
        return h;
      if ("children" in c && c.children) {
        const w = (
          /** @type {UnistParent} */
          c
        );
        if (w.children && h[0] !== uW)
          for (y = (r ? w.children.length : -1) + o, v = u.concat(w); y > -1 && y < w.children.length; ) {
            const I = w.children[y];
            if (m = s(I, y, v)(), m[0] === XA)
              return m;
            y = typeof m[1] == "number" ? m[1] : y + o;
          }
      }
      return h;
    }
  }
}
function dW(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [cW, e] : e == null ? T2 : [e];
}
function M2(e, t, n, r) {
  let i, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), fW(e, a, s, i);
  function s(c, l) {
    const u = l[l.length - 1], d = u ? u.children.indexOf(c) : void 0;
    return o(c, d, u);
  }
}
const Fp = {}.hasOwnProperty, hW = {};
function pW(e, t) {
  const n = t || hW, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...X$, ...n.handlers }, s = {
    all: l,
    applyData: gW,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: c,
    options: n,
    patch: mW,
    wrap: AW
  };
  return M2(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const d = u.type === "definition" ? r : i, f = String(u.identifier).toUpperCase();
      d.has(f) || d.set(f, u);
    }
  }), s;
  function c(u, d) {
    const f = u.type, h = s.handlers[f];
    if (Fp.call(s.handlers, f) && h)
      return h(s, u, d);
    if (s.options.passThrough && s.options.passThrough.includes(f)) {
      if ("children" in u) {
        const { children: y, ...v } = u, w = Xu(v);
        return w.children = s.all(u), w;
      }
      return Xu(u);
    }
    return (s.options.unknownHandler || yW)(s, u, d);
  }
  function l(u) {
    const d = [];
    if ("children" in u) {
      const f = u.children;
      let h = -1;
      for (; ++h < f.length; ) {
        const m = s.one(f[h], u);
        if (m) {
          if (h && f[h - 1].type === "break" && (!Array.isArray(m) && m.type === "text" && (m.value = JA(m.value)), !Array.isArray(m) && m.type === "element")) {
            const y = m.children[0];
            y && y.type === "text" && (y.value = JA(y.value));
          }
          Array.isArray(m) ? d.push(...m) : d.push(m);
        }
      }
    }
    return d;
  }
}
function mW(e, t) {
  e.position && (t.position = Kj(e));
}
function gW(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, Xu(a)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function yW(e, t) {
  const n = t.data || {}, r = "value" in t && !(Fp.call(n, "hProperties") || Fp.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function AW(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function JA(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function KA(e, t) {
  const n = pW(e, t), r = n.one(e, void 0), i = rW(n), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function vW(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      KA(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      KA(n, { file: r, ...e || t })
    );
  };
}
function ZA(e) {
  if (e)
    throw e;
}
var Gc = Object.prototype.hasOwnProperty, I2 = Object.prototype.toString, ev = Object.defineProperty, tv = Object.getOwnPropertyDescriptor, nv = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : I2.call(t) === "[object Array]";
}, rv = function(t) {
  if (!t || I2.call(t) !== "[object Object]")
    return !1;
  var n = Gc.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Gc.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Gc.call(t, i);
}, iv = function(t, n) {
  ev && n.name === "__proto__" ? ev(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, av = function(t, n) {
  if (n === "__proto__")
    if (Gc.call(t, n)) {
      if (tv)
        return tv(t, n).value;
    } else return;
  return t[n];
}, xW = function e() {
  var t, n, r, i, a, o, s = arguments[0], c = 1, l = arguments.length, u = !1;
  for (typeof s == "boolean" && (u = s, s = arguments[1] || {}, c = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); c < l; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = av(s, n), i = av(t, n), s !== i && (u && i && (rv(i) || (a = nv(i))) ? (a ? (a = !1, o = r && nv(r) ? r : []) : o = r && rv(r) ? r : {}, iv(s, { name: n, newValue: e(u, o, i) })) : typeof i < "u" && iv(s, { name: n, newValue: i }));
  return s;
};
const oh = /* @__PURE__ */ rf(xW);
function Yp(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function bW() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...i);
    function s(c, ...l) {
      const u = e[++a];
      let d = -1;
      if (c) {
        o(c);
        return;
      }
      for (; ++d < i.length; )
        (l[d] === null || l[d] === void 0) && (l[d] = i[d]);
      i = l, u ? wW(u, s)(...l) : o(null, ...l);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function wW(e, t) {
  let n;
  return r;
  function r(...o) {
    const s = e.length > o.length;
    let c;
    s && o.push(i);
    try {
      c = e.apply(this, o);
    } catch (l) {
      const u = (
        /** @type {Error} */
        l
      );
      if (s && n)
        throw u;
      return i(u);
    }
    s || (c && c.then && typeof c.then == "function" ? c.then(a, i) : c instanceof Error ? i(c) : a(c));
  }
  function i(o, ...s) {
    n || (n = !0, t(o, ...s));
  }
  function a(o) {
    i(null, o);
  }
}
const Rr = { basename: _W, dirname: SW, extname: CW, join: EW, sep: "/" };
function _W(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  $l(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, s = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function SW(e) {
  if ($l(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function CW(e) {
  $l(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), s === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function EW(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    $l(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : kW(n);
}
function kW(e) {
  $l(e);
  const t = e.codePointAt(0) === 47;
  let n = TW(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function TW(e, t) {
  let n = "", r = 0, i = -1, a = 0, o = -1, s, c;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      s = e.codePointAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = o, a = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else s === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function $l(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const MW = { cwd: IW };
function IW() {
  return "/";
}
function jp(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function NW(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!jp(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return OW(e);
}
function OW(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const sh = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class N2 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? jp(t) ? n = { path: t } : typeof t == "string" || RW(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : MW.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < sh.length; ) {
      const a = sh[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      sh.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Rr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    ch(t, "basename"), lh(t, "basename"), this.path = Rr.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Rr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    ov(this.basename, "dirname"), this.path = Rr.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Rr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (lh(t, "extname"), ov(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Rr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    jp(t) && (t = NW(t)), ch(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Rr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    ch(t, "stem"), lh(t, "stem"), this.path = Rr.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new vn(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function lh(e, t) {
  if (e && e.includes(Rr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Rr.sep + "`"
    );
}
function ch(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function ov(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function RW(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const DW = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  }
), PW = {}.hasOwnProperty;
class d0 extends DW {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = bW();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new d0()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(oh(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (dh("data", this.frozen), this.namespace[t] = n, this) : PW.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (dh("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Cc(t), r = this.parser || this.Parser;
    return uh("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), uh("process", this.parser || this.Parser), fh("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, o) {
      const s = Cc(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(s)
      );
      r.run(c, s, function(u, d, f) {
        if (u || !d || !f)
          return l(u);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), m = r.stringify(h, f);
        BW(m) ? f.value = m : f.result = m, l(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function l(u, d) {
        u || !d ? o(u) : a ? a(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), uh("processSync", this.parser || this.Parser), fh("processSync", this.compiler || this.Compiler), this.process(t, i), lv("processSync", "process", n), r;
    function i(a, o) {
      n = !0, ZA(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    sv(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const c = Cc(n);
      i.run(t, c, l);
      function l(u, d, f) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        u ? s(u) : o ? o(h) : r(void 0, h, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), lv("runSync", "run", r), i;
    function a(o, s) {
      ZA(o), i = s, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Cc(n), i = this.compiler || this.Compiler;
    return fh("stringify", i), sv(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (dh("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? s(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(l) {
      if (typeof l == "function")
        c(l, []);
      else if (typeof l == "object")
        if (Array.isArray(l)) {
          const [u, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            l
          );
          c(u, d);
        } else
          o(l);
      else
        throw new TypeError("Expected usable value, not `" + l + "`");
    }
    function o(l) {
      if (!("plugins" in l) && !("settings" in l))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(l.plugins), l.settings && (i.settings = oh(!0, i.settings, l.settings));
    }
    function s(l) {
      let u = -1;
      if (l != null) if (Array.isArray(l))
        for (; ++u < l.length; ) {
          const d = l[u];
          a(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + l + "`");
    }
    function c(l, u) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === l) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([l, ...u]);
      else if (u.length > 0) {
        let [h, ...m] = u;
        const y = r[f][1];
        Yp(y) && Yp(h) && (h = oh(!0, y, h)), r[f] = [l, h, ...m];
      }
    }
  }
}
const LW = new d0().freeze();
function uh(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function fh(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function dh(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function sv(e) {
  if (!Yp(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function lv(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Cc(e) {
  return zW(e) ? e : new N2(e);
}
function zW(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function BW(e) {
  return typeof e == "string" || FW(e);
}
function FW(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const YW = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", cv = [], uv = { allowDangerousHtml: !0 }, jW = /^(https?|ircs?|mailto|xmpp)$/i, $W = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function WW(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, s = e.rehypePlugins || cv, c = e.remarkPlugins || cv, l = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...uv } : uv, u = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || UW, h = LW().use(S$).use(c).use(vW, l).use(s), m = new N2();
  typeof r == "string" && (m.value = r);
  for (const I of $W)
    Object.hasOwn(e, I.from) && ("" + I.from + (I.to ? "use `" + I.to + "` instead" : "remove it") + YW + I.id, void 0);
  const y = h.parse(m);
  let v = h.runSync(y, m);
  return i && (v = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      v.type === "root" ? v.children : [v]
    )
  }), M2(v, w), r9(v, {
    Fragment: Di.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: a,
    ignoreInvalidStyle: !0,
    jsx: Di.jsx,
    jsxs: Di.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(I, M, k) {
    if (I.type === "raw" && k && typeof M == "number")
      return u ? k.children.splice(M, 1) : k.children[M] = { type: "text", value: I.value }, M;
    if (I.type === "element") {
      let g;
      for (g in rh)
        if (Object.hasOwn(rh, g) && Object.hasOwn(I.properties, g)) {
          const A = I.properties[g], b = rh[g];
          (b === null || b.includes(I.tagName)) && (I.properties[g] = f(String(A || ""), g, I));
        }
    }
    if (I.type === "element") {
      let g = t ? !t.includes(I.tagName) : o ? o.includes(I.tagName) : !1;
      if (!g && n && typeof M == "number" && (g = !n(I, M, k)), g && k && typeof M == "number")
        return d && I.children ? k.children.splice(M, 1, ...I.children) : k.children.splice(M, 1), M;
    }
  }
}
function UW(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    jW.test(e.slice(0, t)) ? e : ""
  );
}
const $p = ae.pre`
  margin: 5px 0 0;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  color: #323232;
`, Wp = ae($p)`
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.35;
`, HW = ae.div`
  margin-top: 5px;
  font-size: 13px;
  line-height: 1.5;
  color: #323232;

  p,
  li,
  ol,
  ul,
  a {
    font-size: inherit;
    line-height: inherit;
    color: inherit;
  }

  p {
    margin: 0 0 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ol,
  ul {
    margin: 0 0 8px;
    padding-left: 24px;
  }
`, GW = [
  { name: "ai-reasoning", type: "markdown", size: 12 },
  { name: "ai-raw-output", type: "json", size: 12 },
  { name: "ai-error", type: "json", size: 12 }
], VW = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return { error: "Invalid JSON", output: e };
  }
}, QW = [
  "CohortGenerationService Version",
  "CohortGenerator LLM Version",
  "ConceptSetGenerationService Version",
  "ConceptSetGenerator LLM Version"
], O2 = /^\s*(?:#{1,6}\s*)?(?:\d+[.)]\s*)?(?:Sources|Resources|References)(?:\s*(?:and|\/)\s*(?:Sources|Resources|References))*\s*:?\s*$/i, R2 = /^(?:[-*\u2022]|\d+[.)])/, D2 = (e) => {
  const t = e.split(`
`), n = t.findIndex(
    (a) => O2.test(a.trim())
  );
  if (n === -1)
    return e;
  let r = !1, i = n + 1;
  for (; i < t.length && (R2.test(t[i].trim()) || t[i].trim() === ""); ) {
    const a = t[i].trim(), o = a.match(/https?:\/\/[^\s)]+/);
    if (o && !a.includes("](")) {
      const s = o[0], l = a.replace(/^(?:[-*\u2022]|\d+[.)])\s*/, "").replace(s, "").trim().replace(/[:\-.]+$/, "") || s;
      t[i] = `- [${l}](${s})`, r = !0;
    }
    i++;
  }
  return r ? t.join(`
`) : e;
}, qW = (e, t) => {
  const n = `https://clinicaltrials.gov/study/${t}`, r = D2(e), i = r.split(`
`), a = i.findIndex(
    (s) => O2.test(s.trim())
  );
  if (a === -1)
    return `${r.trim()}

## Sources:
- [ClinicalTrials.gov reference: ${n}](${n})`;
  let o = a + 1;
  for (; o < i.length && (R2.test(i[o].trim()) || i[o].trim() === ""); )
    o++;
  return i.some((s) => s.includes(n)) || i.splice(
    o,
    0,
    `- [ClinicalTrials.gov reference: ${n}](${n})`
  ), i.join(`
`);
}, XW = (e) => {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true")
      return !0;
    if (t === "false")
      return !1;
  }
}, fv = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
}, P2 = (e) => {
  if (Array.isArray(e))
    return e.map((n) => String(n).trim()).filter(Boolean);
  if (typeof e != "string")
    return null;
  const t = e.trim();
  if (!t)
    return [];
  try {
    const n = JSON.parse(t);
    if (Array.isArray(n))
      return n.map((r) => String(r).trim()).filter(Boolean);
  } catch {
  }
  if (t.startsWith("[") && t.endsWith("]")) {
    const n = t.slice(1, -1).trim();
    return n ? n.split(",").map((r) => r.trim().replace(/^['"]|['"]$/g, "")).filter(Boolean) : [];
  }
  return null;
}, xi = (e) => {
  if (e == null)
    return !1;
  if (typeof e == "string") {
    const t = P2(e);
    return t ? t.length > 0 : e.trim() !== "";
  }
  return Array.isArray(e) ? e.length > 0 : !0;
}, Qa = (e) => {
  if (!xi(e))
    return "";
  const t = P2(e);
  return t ? t.join(", ") : Array.isArray(e) ? e.filter((n) => n != null && n !== "").join(", ") : String(e);
}, JW = (e) => e.filter((t) => xi(t.value)).map((t) => `${t.label}: ${t.value}`).join(`\r
`), KW = (e) => {
  var i;
  const t = e.trim();
  if (!t)
    return "";
  const r = (((i = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : i.pathname) || "").match(/^\/study-manager\/([^/]+)\//);
  return r != null && r[1] ? `/study-manager/${r[1]}/cohorts/${encodeURIComponent(t)}` : `/workspace/cohorts/${encodeURIComponent(t)}`;
}, ZW = (e) => {
  try {
    const t = JSON.parse(e);
    if (t && typeof t == "object" && !Array.isArray(t))
      return t;
  } catch {
    return null;
  }
  return null;
}, h0 = (e) => e !== ef.COHORT, eU = (e) => {
  const t = fv(e["Search precision"]);
  return t !== void 0 && t >= 0 && t < S0.length ? S0[t] : {
    skipVectorSearch: XW(e["~ai_skip_vector_search"]),
    vectorSearchResultLimit: fv(
      e["~vector_search_result_limit"]
    )
  };
}, tU = (e, t) => {
  const n = t.map((r) => r.toLowerCase());
  return e.find(
    (r) => typeof r == "object" && r !== null && "name" in r && n.includes(
      String(r.name).toLowerCase()
    )
  );
}, nU = (e, t, n, r) => {
  const i = eU(e), a = [], o = Qa(e.Domain), s = Qa(e.Vocabulary), c = Qa(e["Standard concept"]), l = Qa(e["NCT number"]) || r, u = Qa(i.vectorSearchResultLimit) || mn(t, [
    "~vector_search_result_limit",
    "vector_search_result_limit",
    "ai-vector-search-result-limit"
  ]), d = Qa(i.skipVectorSearch) || mn(t, [
    "~ai_skip_vector_search",
    "ai_skip_vector_search",
    "ai-skip-vector-search"
  ]);
  return n === ef.COHORT ? l && a.push({ label: "ai-clinical-trials-id", value: l }) : h0(n) && o && a.push({ label: "ai-domains", value: o }), s && a.push({ label: "ai-vocabularies", value: s }), c && a.push({ label: "ai-standard-concepts", value: c }), xi(u) && a.push({
    label: "ai-vector-search-result-limit",
    value: u
  }), xi(d) && a.push({
    label: "ai-skip-vector-search",
    value: d
  }), a;
}, mn = (e, t) => {
  var a, o, s, c;
  const n = tU(e, t);
  if (!((a = n == null ? void 0 : n.values) != null && a.length))
    return "";
  const r = (o = n.values.find(
    (l) => (l == null ? void 0 : l.value) !== null && (l == null ? void 0 : l.value) !== void 0 && l.value !== ""
  )) == null ? void 0 : o.value;
  if (typeof r == "string")
    return r;
  const i = (c = (s = n.values.find(
    (l) => {
      var u, d;
      return ((u = l == null ? void 0 : l.attributeOption) == null ? void 0 : u.value) !== null && ((d = l == null ? void 0 : l.attributeOption) == null ? void 0 : d.value) !== void 0 && l.attributeOption.value !== "";
    }
  )) == null ? void 0 : s.attributeOption) == null ? void 0 : c.value;
  return typeof i == "string" ? i : "";
}, rU = (e, t, n) => {
  const r = [], i = mn(e, ["Domain", "ai-domains"]), a = mn(e, [
    "Vocabulary",
    "ai-vocabularies"
  ]), o = mn(e, [
    "Standard concept",
    "ai-standard-concepts"
  ]), s = mn(e, ["NCT number", "ai-clinical-trials-id"]) || n, c = mn(e, [
    "~vector_search_result_limit",
    "vector_search_result_limit",
    "ai-vector-search-result-limit"
  ]), l = mn(e, [
    "~ai_skip_vector_search",
    "ai_skip_vector_search",
    "ai-skip-vector-search"
  ]);
  return t === ef.COHORT ? s && r.push({ label: "ai-clinical-trials-id", value: s }) : h0(t) && i && r.push({ label: "ai-domains", value: i }), a && r.push({ label: "ai-vocabularies", value: a }), o && r.push({ label: "ai-standard-concepts", value: o }), xi(c) && r.push({
    label: "ai-vector-search-result-limit",
    value: c
  }), xi(l) && r.push({
    label: "ai-skip-vector-search",
    value: l
  }), r;
}, iU = (e, t) => {
  const n = [...e];
  return t.forEach((r) => {
    xi(r.value) && !n.some((i) => i.label === r.label) && n.push(r);
  }), n;
}, aU = (e, t) => {
  const n = VW(t), r = [
    {
      label: "ai-job-id",
      value: mn(e, ["ai-job-id"])
    },
    {
      label: "ai-status",
      value: mn(e, ["ai-status"])
    },
    {
      label: "ai-generated-as-part-of-cohort",
      value: mn(e, [
        "ai-generated-as-part-of-cohort"
      ])
    },
    {
      label: "ai-generation-complete-timestamp",
      value: mn(e, [
        "ai-generation-complete-timestamp"
      ])
    }
  ];
  if (!(n != null && n.error)) {
    const i = QW.filter(
      (a) => typeof n[a] == "string" && n[a]
    ).map((a) => `${a}: ${n[a]}`).filter(Boolean).join(`\r
`);
    i && r.push({
      label: "ai-version-info",
      value: i
    });
  }
  return r.filter((i) => xi(i.value));
}, oU = (e, t, n) => e ? t ? typeof t.Description == "string" && t.Description.trim() ? t.Description : Object.entries(t).filter(
  ([r]) => h0(n) ? !0 : r !== "Domain"
).filter(([r, i]) => r !== "Description" && !oC(i)).map(([r, i]) => `${r}: ${i}`).join(`\r
`) : e : "", sU = (e) => {
  const t = e.map(
    (n) => n.label === "ai-generation-complete-timestamp" ? {
      ...n,
      value: Vn(n.value)
    } : n
  );
  return /* @__PURE__ */ p(Wp, { as: "div", children: t.map((n, r) => {
    const i = n.label === "ai-generated-as-part-of-cohort" && xi(n.value), a = i ? KW(n.value) : "";
    return /* @__PURE__ */ F(qe.Fragment, { children: [
      n.label,
      ":",
      " ",
      i && a ? /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(
          "a",
          {
            href: a,
            target: "_blank",
            rel: "noreferrer",
            style: {
              color: "#1976d2",
              textDecoration: "underline"
            },
            children: n.value
          }
        ),
        " ",
        /* @__PURE__ */ p(
          "a",
          {
            href: a,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": `Open cohort ${n.value} in a new tab`,
            style: {
              color: "#98A2B3",
              textDecoration: "none",
              display: "inline-flex",
              verticalAlign: "text-bottom",
              marginBottom: "5px"
            },
            children: /* @__PURE__ */ F(
              "svg",
              {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                children: [
                  /* @__PURE__ */ p(
                    "path",
                    {
                      d: "M14 3H21V10",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  ),
                  /* @__PURE__ */ p(
                    "path",
                    {
                      d: "M10 14L21 3",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  ),
                  /* @__PURE__ */ p(
                    "path",
                    {
                      d: "M21 14V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H10",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  )
                ]
              }
            )
          }
        )
      ] }) : n.value,
      r < t.length - 1 ? `
` : ""
    ] }, n.label);
  }) });
}, lU = ({
  meta: e,
  name: t,
  type: n
}) => {
  const r = Object.values(e), i = Ce(
    () => Zu(tn.JSON),
    []
  ), a = Ce(() => mn(r, ["ai-clinical-trials-id"]).trim(), [r]), o = Ce(() => mn(r, ["ai-prompt"]), [r]), s = Ce(
    () => o ? ZW(o) : null,
    [o]
  ), c = Ce(
    () => oU(o, s, n),
    [o, s, n]
  ), l = Ce(
    () => s ? nU(
      s,
      r,
      n,
      a
    ) : [],
    [s, r, n, a]
  ), u = Ce(
    () => iU(
      l,
      rU(r, n, a)
    ),
    [r, n, a, l]
  ), d = Ce(
    () => aU(
      r,
      mn(r, ["ai-version-info"])
    ),
    [r]
  ), f = Ce(() => {
    const h = [
      c,
      u.length,
      d.length
    ].filter(Boolean).length;
    return h <= 1 ? 12 : h === 2 ? 6 : 4;
  }, [c, u.length, d.length]);
  return /* @__PURE__ */ F(O, { container: !0, spacing: 3, children: [
    c && /* @__PURE__ */ p(O, { item: !0, xs: 12, md: f, children: /* @__PURE__ */ F(to, { children: [
      /* @__PURE__ */ p("label", { children: "ai-prompt:" }),
      /* @__PURE__ */ p(Wp, { children: c })
    ] }) }),
    u.length > 0 && /* @__PURE__ */ p(O, { item: !0, xs: 12, md: f, children: /* @__PURE__ */ F(to, { children: [
      /* @__PURE__ */ p("label", { children: "ai-generation-options:" }),
      /* @__PURE__ */ p(Wp, { children: JW(u) })
    ] }) }),
    d.length > 0 && /* @__PURE__ */ p(O, { item: !0, xs: 12, md: f, children: /* @__PURE__ */ F(to, { children: [
      /* @__PURE__ */ p("label", { children: "ai-generation-details:" }),
      sU(d)
    ] }) }),
    GW.map(({ name: h, type: m, size: y }) => {
      const v = mn(r, [h]) || null, w = m === "markdown" && v ? a ? qW(v, a) : D2(v) : v, I = m === "json" ? v : null;
      return /* @__PURE__ */ p(qe.Fragment, { children: (I && m == "json" || v && m != "json") && /* @__PURE__ */ p(O, { item: !0, xs: y, children: /* @__PURE__ */ F(to, { children: [
        /* @__PURE__ */ F("label", { children: [
          h,
          ":"
        ] }),
        (() => {
          switch (m) {
            case "markdown":
              return n == ef.CONCEPT_SET ? /* @__PURE__ */ p($p, { children: w }) : /* @__PURE__ */ p(HW, { children: /* @__PURE__ */ p(
                WW,
                {
                  components: {
                    a: ({ node: M, ...k }) => /* @__PURE__ */ p(
                      "a",
                      {
                        ...k,
                        target: "_blank",
                        rel: "noreferrer",
                        style: {
                          color: "#1976d2",
                          textDecoration: "underline"
                        }
                      }
                    )
                  },
                  children: w
                }
              ) });
            case "json":
              return /* @__PURE__ */ p("p", { children: /* @__PURE__ */ p(
                _l,
                {
                  data: I,
                  fileName: t,
                  language: i,
                  readOnly: !0,
                  fileExtension: tn.JSON
                }
              ) });
            default:
              return /* @__PURE__ */ p($p, { children: v });
          }
        })()
      ] }) }) }, h);
    })
  ] });
}, kG = (e) => {
  const {
    id: t,
    name: n,
    title: r,
    getBaseUrl: i,
    metadataSubject: a,
    canUpdate: o,
    configMetadataValuesApi: s,
    callback: c,
    url: l,
    initialTypeContainer: u,
    initialParentId: d,
    initialParentName: f,
    aiMode: h
  } = e, { openModal: m, closeModal: y } = Mo(Jp), { enqueueSnackbar: v } = bi(), [w, I] = Te({}), { status: M, data: k } = Yv(
    `&filter.metadata.subject=${a}`,
    h,
    !1
  ), {
    status: g,
    values: A,
    isLoading: b,
    saveMetadataValue: x,
    getMetadataValues: _,
    copyMetadataValues: R
  } = $v(t, s, h), P = u === ge.STUDY ? ge.STUDY : ge.WORKSPACE, E = P === ge.STUDY ? d : void 0, C = () => {
    m(
      () => /* @__PURE__ */ p(
        tj,
        {
          id: t,
          metaAttributes: w,
          onChange: async (z) => {
            var B;
            await x(
              (B = z.currentState) == null ? void 0 : B.meta,
              z.metaAttributes
            ), c == null || c(), y(), v({
              message: "Meta attributes updated",
              variant: "success"
            });
          },
          onClose: y
        }
      ),
      "Update metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: y
      }
    );
  }, T = () => {
    m(
      () => /* @__PURE__ */ p(
        oj,
        {
          isContainer: !0,
          name: n,
          title: r,
          getBaseUrl: i,
          onCancel: y,
          metadataAttributes: k,
          metadataValues: w,
          url: l,
          initialTypeContainer: P,
          initialParentId: E,
          initialParentName: f,
          configMetadataValuesApi: s,
          isErrorCopy: g === tr.ERROR_LOADED_COPY_METADATA,
          onSave: async (z) => {
            await R(z[0].id, [{ id: t }]);
          }
        }
      ),
      "Import metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: y
      }
    );
  }, D = () => {
    m(
      () => /* @__PURE__ */ p(
        sj,
        {
          isContainer: !0,
          name: n,
          title: r,
          getBaseUrl: i,
          onCancel: y,
          metadataAttributes: k,
          metadataValues: w,
          initialTypeContainer: P,
          initialParentId: E,
          isErrorCopy: g === tr.ERROR_LOADED_COPY_METADATA,
          configMetadataValuesApi: s,
          onSave: async (z) => {
            await R(t, z), c == null || c(), y(), v({
              message: "Meta attributes copied",
              variant: "success"
            });
          }
        }
      ),
      "Export metadata values",
      {
        width: "700px",
        closeOnClickOutside: !0,
        onClose: y
      }
    );
  };
  return tt(() => {
    g === tr.LOADED_COPY_METADATA && (_(t), c == null || c(), y(), v({
      message: "Meta attributes copied",
      variant: "success"
    })), g === tr.ERROR_LOADED_COPY_METADATA && v({
      message: "Meta attributes not copied",
      variant: "error"
    });
  }, [g]), tt(() => {
    ![
      tr.INITIAL,
      tr.LOADING_METADATA
    ].includes(g) && ![ve.INITIAL, ve.IN_PROGRESS].includes(M) && I(_v(k, A));
  }, [g, M]), [
    tr.INITIAL,
    tr.LOADING_METADATA
  ].includes(g) || [ve.INITIAL, ve.IN_PROGRESS].includes(M) ? /* @__PURE__ */ p(cf, { children: /* @__PURE__ */ p(gt, { size: 32 }) }) : /* @__PURE__ */ p(hm, { children: /* @__PURE__ */ p(
    zr,
    {
      outlined: !0,
      title: h ? "Generative AI" : "Metadata",
      actions: /* @__PURE__ */ F(O, { container: !0, spacing: 1, children: [
        !h && /* @__PURE__ */ F(ze, { children: [
          /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
            Ee,
            {
              className: "update-metadata",
              variant: "contained",
              onClick: C,
              disabled: !o || Object.keys(w).length === 0,
              color: "info",
              startIcon: /* @__PURE__ */ p(he, { iconName: "edit", name: "edit", sx: { fontSize: 22 } }),
              children: "Update"
            }
          ) }),
          /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
            Ee,
            {
              className: "import-metadata",
              variant: "contained",
              onClick: T,
              disabled: !o || Object.keys(w).length === 0,
              color: "info",
              startIcon: /* @__PURE__ */ p(
                he,
                {
                  iconName: "import",
                  name: "import",
                  sx: { fontSize: 22 }
                }
              ),
              children: "Import"
            }
          ) })
        ] }),
        !h && /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
          Ee,
          {
            className: "export-metadata",
            variant: "contained",
            onClick: D,
            disabled: !o || Object.keys(w).length === 0 || A.length === 0,
            color: "info",
            startIcon: /* @__PURE__ */ p(
              he,
              {
                iconName: "export",
                name: "export",
                sx: { fontSize: 22 }
              }
            ),
            children: "Export"
          }
        ) })
      ] }),
      children: /* @__PURE__ */ F(O, { container: !0, children: [
        w && !h && /* @__PURE__ */ p(O, { container: !0, spacing: 3, children: Object.keys(w).map((z) => {
          const B = w == null ? void 0 : w[z];
          if (!(Array.isArray(B.values) && B.values.length > 0))
            return null;
          const L = B.values.map((S) => {
            var $;
            return B.type == Lt.INTEGER || B.type == Lt.STRING ? S.value : ($ = S.attributeOption) == null ? void 0 : $.value;
          }).filter(
            (S) => S != null && S !== ""
          ).join(", ");
          return /* @__PURE__ */ p(O, { item: !0, xs: 4, children: /* @__PURE__ */ F(to, { children: [
            /* @__PURE__ */ F("label", { htmlFor: "", children: [
              B.name || B.title || z,
              ":"
            ] }),
            /* @__PURE__ */ p("p", { children: L || "-" })
          ] }) }, z);
        }) }),
        w && h && /* @__PURE__ */ p(lU, { type: a, meta: w, name: n }),
        !w || Object.keys(w).length === 0 && /* @__PURE__ */ p(vA, { children: "No specified metadata" }),
        Object.keys(w).length > 0 && A.length === 0 && /* @__PURE__ */ p(vA, { children: "No values" })
      ] })
    }
  ) });
}, L2 = ae.div`
  font-size: 70px;
  font-weight: 800;
  color: ${({ theme: e }) => {
  var t, n;
  return IC(0.1, ((n = (t = e.palette) == null ? void 0 : t.backgroundColor) == null ? void 0 : n.main) || "#F7F8FA");
}};
  margin-right: 8px;
`, z2 = ae.div`
  font-size: 28px;
  font-weight: 800;
  /* margin-bottom: 50px; */
  color: ${({ theme: e }) => {
  var t, n;
  return Yn(0.1, ((n = (t = e.palette) == null ? void 0 : t.textColor) == null ? void 0 : n.label) || "#798395");
}};
`, B2 = ae.div`
  font-size: 20px;
  padding: 0 40px;
  /* margin-bottom: 16px; */
  color: ${({ theme: e }) => {
  var t, n;
  return ((n = (t = e.palette) == null ? void 0 : t.textColor) == null ? void 0 : n.label) || "#798395";
}};
`, cU = (e) => {
  const { status: t, statusText: n, message: r, data: i, path: a, noAction: o = !1 } = e, s = (i == null ? void 0 : i.message) || r || "", c = Hi(), l = cr();
  return /* @__PURE__ */ F(
    O,
    {
      container: !0,
      direction: "row",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      spacing: 1,
      py: 2,
      children: [
        /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
          /* @__PURE__ */ p(L2, { children: t }),
          /* @__PURE__ */ p(z2, { children: n })
        ] }),
        s && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(B2, { children: s }) }),
        !o && /* @__PURE__ */ F(
          O,
          {
            item: !0,
            xs: 12,
            container: !0,
            justifyContent: "center",
            spacing: 2,
            mt: 1,
            sx: {
              zIndex: 10,
              position: "relative"
            },
            children: [
              t === 406 && /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
                Ee,
                {
                  onClick: () => {
                    var u, d;
                    c(QC((d = (u = i.tenants) == null ? void 0 : u[0]) == null ? void 0 : d.id));
                  },
                  variant: "outlined",
                  size: "medium",
                  startIcon: /* @__PURE__ */ p(he, { iconName: "reload" }),
                  children: "Switch tenant"
                }
              ) }),
              t === 42 ? /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
                Ee,
                {
                  onClick: () => {
                    l("/");
                  },
                  variant: "outlined",
                  size: "medium",
                  startIcon: /* @__PURE__ */ p(he, { iconName: "list" }),
                  children: "Go to home"
                }
              ) }) : /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
                Ee,
                {
                  onClick: () => {
                    l(`/${a}`);
                  },
                  variant: "outlined",
                  size: "medium",
                  startIcon: /* @__PURE__ */ p(he, { iconName: "list" }),
                  children: "Go to list"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, TG = (e) => {
  const { status: t, statusText: n, message: r, data: i, path: a } = e;
  return /* @__PURE__ */ F(
    O,
    {
      container: !0,
      direction: "row",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      children: [
        /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
          /* @__PURE__ */ p(L2, { children: t }),
          /* @__PURE__ */ p(z2, { children: n })
        ] }),
        /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
          /* @__PURE__ */ p(B2, { children: r }),
          /* @__PURE__ */ p(O, { container: !0, justifyContent: "center", spacing: 2, children: /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
            Ee,
            {
              onClick: () => {
                window.location.href = "/";
              },
              variant: "outlined",
              size: "medium",
              startIcon: /* @__PURE__ */ p(he, { iconName: "list" }),
              children: "Go to home"
            }
          ) }) })
        ] })
      ]
    }
  );
}, MG = Kt((e) => {
  var a;
  const { data: t } = e, n = Ce(() => t, [t]), r = Ce(() => {
    var o;
    return (o = t == null ? void 0 : t.base) == null ? void 0 : o.title;
  }, [(a = t == null ? void 0 : t.base) == null ? void 0 : a.title]), i = Ce(
    () => Zu(tn.JSON),
    []
  );
  return /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    _l,
    {
      data: n,
      fileName: r,
      language: i,
      readOnly: !0,
      fileExtension: tn.JSON
    }
  ) });
}), F2 = Kt((e) => {
  const {
    onChange: t,
    typeContainer: n,
    parentId: r,
    createListMethods: i,
    createListFiltersMethod: a,
    cols: o,
    disableRowSelect: s,
    isSelect: c = !1,
    titleTable: l = "All",
    titleExtra: u,
    footerStart: d,
    loadingMessage: f = "Loading",
    buttonImportText: h = "Add",
    isLoadingButton: m = !1,
    idSelector: y = "id",
    children: v,
    isOutsideLoading: w,
    reloadId: I,
    hideHeader: M = !1,
    hideEmptyTable: k = !1,
    toggleSelectionOnRowClick: g = !1
  } = e, A = Ce(() => o, []), b = Ce(() => i(n, r), [n, r]), x = qe.useMemo(() => a(n, r), [n, r]), { selectedConcepts: _, detectSelectedAction: R, clear: P, init: E } = DC({}, y), {
    data: { tableData: C, filtersData: T },
    filters: D,
    status: z,
    pageCount: B,
    pageSize: W,
    getEntity: L,
    totalElements: S,
    numberOfElements: $,
    updateFilters: j,
    resetState: N
  } = jv(
    {
      get: b.fetch,
      remove: () => {
      },
      getFilters: x && x.getFilters
    },
    I,
    !1
  ), q = Object.values(D).some(
    (H) => (H == null ? void 0 : H.length) > 0
  ), G = z === ve.IN_PROGRESS || z === ve.IN_PROGRESS_RELOAD || w, X = k && !G && !q && Number(S || 0) === 0, Y = ot(
    (H) => {
      var ee;
      if (c) {
        t(Object.keys(_).map((ie) => _[ie]));
        return;
      }
      if (!(!(H != null && H.original) || ((ee = H == null ? void 0 : H.original) == null ? void 0 : ee[y]) == null)) {
        if (g) {
          const ie = String(H.original[y]);
          if (!!_[ie]) {
            E({}), t([]);
            return;
          }
          E({ [ie]: H.original }), t([H.original]);
          return;
        }
        E({ [H.original[y]]: H.original }), t([H.original]);
      }
    },
    [
      y,
      E,
      c,
      t,
      _,
      g
    ]
  ), Q = ot((H, ee) => {
    const ie = {};
    H == null || H.forEach((re) => {
      ie[re[y]] = re;
    }), R(ie, ee);
  }, []), V = Object.keys(_).length;
  tt(() => () => {
    N();
  }, [n]);
  const { otherFilters: U, searchFilter: Z } = wv(T);
  return /* @__PURE__ */ F(O, { container: !0, sx: { position: "relative" }, children: [
    m && /* @__PURE__ */ p(cM, { children: /* @__PURE__ */ p(gt, { size: 62 }) }),
    !M && /* @__PURE__ */ p(O, { item: !0, xs: 12, mt: -1, children: /* @__PURE__ */ p(
      Mb,
      {
        title: l,
        titleExtra: u,
        customButtons: v
      }
    ) }),
    /* @__PURE__ */ p(
      wD,
      {
        onAdd: () => {
          Y();
        },
        disabled: m,
        onClear: P,
        selectedConceptsCount: c ? V : 0,
        buttonText: h,
        buttonStartIcon: null,
        startContent: c && V > 0 ? d : void 0,
        width: V != null ? "calc(100% - 250px)" : window.innerWidth - 250 + "px"
      }
    ),
    /* @__PURE__ */ p(
      O,
      {
        container: !0,
        className: "table-list-widget",
        pb: V ? 4 : 2,
        mt: M ? 1 : 2,
        children: /* @__PURE__ */ p(O, { item: !0, xs: 12, className: "table-data-list-widget", children: !X && /* @__PURE__ */ p(
          ua,
          {
            enableRowSelection: c,
            showFilterToggle: !0,
            variant: "controlled",
            data: C,
            className: "import-concepts-table",
            columns: A,
            pageCount: B,
            pageSize: W,
            fetchData: L,
            getRowId: (H) => String(H[y]),
            totalElements: S,
            loadingMessage: f,
            onRowSelect: Q,
            disableRowSelect: s,
            onRowClick: c ? () => {
            } : Y,
            loading: G,
            hasFilters: q,
            noDataText: q ? "The result listing is empty because of the filter you applied" : "No data currently available",
            selectedRowIds: Object.keys(_).reduce(
              (H, ee) => (H[ee] = !0, H),
              {}
            ),
            searchComponent: Z && /* @__PURE__ */ p(
              Lv,
              {
                ...Z,
                value: D == null ? void 0 : D[Z == null ? void 0 : Z.name],
                onChange: (H) => j({ [Z == null ? void 0 : Z.name]: H })
              }
            ),
            children: /* @__PURE__ */ p(
              Vp,
              {
                filters: U,
                value: D,
                isReloading: z === ve.IN_PROGRESS_RELOAD,
                isLoading: z === ve.IN_PROGRESS || w,
                onChange: (H, ee) => j({ [H]: ee })
              }
            )
          }
        ) })
      }
    )
  ] });
}), uU = () => Nn.get("/atlases"), fU = (e, t, n, r, i, a, o, s) => {
  const c = [];
  return t && c.push({
    value: si.LOCAL,
    title: "Local",
    onTabClick: i
  }), a === ge.WORKSPACE && (n.includes(ge.WORKSPACE) && c.push({
    value: ge.WORKSPACE,
    title: "Workspace",
    onTabClick: i
  }), n.includes(ge.STUDY) && c.push({
    value: ge.STUDY,
    title: "Studies",
    onTabClick: i
  })), a === ge.STUDY && (n.includes(ge.STUDY) && c.push({
    value: ge.STUDY,
    title: "Studies",
    onTabClick: i
  }), n.includes(ge.WORKSPACE) && c.push({
    value: ge.WORKSPACE,
    title: "Workspace",
    onTabClick: i
  })), a === ge.LIBRARY && (n.includes(ge.STUDY) && c.push({
    value: ge.STUDY,
    title: "Studies",
    onTabClick: i
  }), n.includes(ge.WORKSPACE) && c.push({
    value: ge.WORKSPACE,
    title: "Workspace",
    onTabClick: i
  })), n.includes(ge.LIBRARY) && c.push({
    value: ge.LIBRARY,
    title: "Artifacts library",
    onTabClick: i
  }), r && !s && c.push({
    value: si.ATLAS,
    title: "Atlas",
    onTabClick: i
  }), e && !o && c.push({
    value: si.MANUAL,
    title: "Manual",
    onTabClick: i
  }), c;
}, dU = (e, t, n) => {
  const { pageNumber: r, pageSize: i, sortBy: a, query: o } = n, s = sC(a), c = `/atlas/${e}/assets/${t}?size=${i || ""}&page=${r || 0}&sort=${s}&${o || ""}`;
  return Nn.get(c).then((l) => ({
    ...l,
    content: l.content.map((u) => ({
      ...u,
      type: t
    }))
  }));
}, hU = (e, t) => Nn.get(`/atlas/${e}/assets/${t}/last-refresh`), pU = (e, t) => Nn.post(`/atlas/${e}/assets/${t}/refresh`), mU = (e, t, n, r, i, a) => {
  const o = (() => {
    switch (a) {
      case Ct.CREATE_NEW_OBJECT:
        return Ct.CREATE_NEW_OBJECT;
      case Ct.CREATE_NEW_VERSION:
        return Ct.CREATE_NEW_VERSION;
      default:
        return a;
    }
  })(), s = o ? `?resolution=${encodeURIComponent(o)}` : "";
  switch (e) {
    case ge.WORKSPACE:
      return Nn.post(
        `/atlas/${t}/assets/${n}/${r}/import-to-workspace${s}`
      );
    case ge.STUDY:
      return Nn.post(
        `/atlas/${t}/assets/${n}/${r}/import-to-study/${i}${s}`
      );
  }
}, dv = (e) => {
  switch (e) {
    case ki.CS:
      return wt.CONCEPT_SET;
    case ki.COHORT:
      return wt.COHORT;
    case ki.CC:
      return pa.COHORT_CHARACTERIZATION;
    case ki.PATHWAY:
      return pa.PATHWAY;
    case ki.IR:
      return pa.INCIDENCE_RATE;
    case ki.PLE:
      return pa.ESTIMATION;
  }
}, hh = {
  createCrudMethod: (e, t) => ({
    fetch: (n, r, i, a) => dU(t, e, {
      pageNumber: n,
      pageSize: r,
      sortBy: i,
      query: a
    })
  }),
  createFiltersPanel: (e, t) => ({
    getFilters: (n) => {
      const r = `/atlas/${t}/assets/${e}/filter?${n}`;
      return Nn.get(r);
    }
  }),
  cols: [
    aI({
      accessorKey: "type",
      id: "typeIcon",
      cell: ({ getValue: e }) => [ki.CS, ki.COHORT].includes(
        e()
      ) ? /* @__PURE__ */ p(
        Gi,
        {
          value: dv(e()),
          size: 26,
          cell: !0
        }
      ) : /* @__PURE__ */ p(
        Pv,
        {
          value: dv(e()),
          size: 26,
          cell: !0
        }
      )
    }),
    zx({ accessorKey: "externalId", id: "externalId" }),
    cm(),
    fm(),
    um(),
    dm()
  ]
}, gU = (e) => {
  const {
    atlasList: t,
    entity: n,
    isLoadingButton: r,
    onChange: i,
    message: a,
    typeContainer: o,
    parentId: s,
    isSelect: c,
    resolution: l,
    titleExtra: u,
    footerStart: d,
    hideListHeader: f = !1,
    buttonImportText: h
  } = e, { t: m } = Ma(), [y, v] = Te(
    t.length > 0 ? t[0].value : null
  ), { enqueueSnackbar: w } = bi(), [I, M] = Te(n[0]), [k, g] = Te(ve.INITIAL), [A, b] = Te(null), [x, _] = Te(!1), [R, P] = Te(), E = n.length > 1 ? 4 : 6, C = async (T) => {
    g(ve.IN_PROGRESS);
    const D = [];
    try {
      T.forEach((B) => {
        D.push(
          mU(
            o,
            y,
            I,
            B.id || B.externalId,
            s,
            l
          )
        );
      });
      const z = await Promise.all(D);
      i(z), g(ve.SUCCESS);
    } catch (z) {
      w({
        message: m("messages.atlas_error_import"),
        variant: "error"
      }), g(ve.ERROR), console.log(z);
    }
  };
  return tt(() => {
    hU(y, I).then((T) => {
      b(`Last update ${Se(T.lastRefreshedAt).fromNow()}`);
    });
  }, [y, I, x]), /* @__PURE__ */ F(O, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, md: E, children: /* @__PURE__ */ p(nn, { name: "atlas", textLabel: m("forms.atlas"), required: !0, children: /* @__PURE__ */ p(
      mr,
      {
        className: "",
        name: "atlas",
        disablePortal: !0,
        id: "atlas",
        options: t,
        value: y,
        placeholder: m("forms.atlas_placeholder"),
        onChange: (T) => {
          v(T);
        },
        fullWidth: !0
      }
    ) }) }),
    n.length > 1 && /* @__PURE__ */ p(O, { item: !0, xs: 12, md: E, children: /* @__PURE__ */ p(nn, { name: "asset", textLabel: m("forms.asset"), required: !0, children: /* @__PURE__ */ p(
      mr,
      {
        className: "",
        name: "asset",
        disablePortal: !0,
        id: "asset",
        options: cC.filter(
          (T) => n.includes(T.value)
        ),
        value: I,
        placeholder: m("forms.asset_placeholder"),
        onChange: (T) => {
          M(T);
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ p(
      O,
      {
        item: !0,
        xs: 12,
        md: E,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: { xs: "flex-start", md: "flex-end" },
        children: /* @__PURE__ */ p(we, { sx: { minHeight: 40, display: "flex", alignItems: "center" }, children: x ? /* @__PURE__ */ p(gt, { size: 12 }) : /* @__PURE__ */ F(
          Us,
          {
            size: "small",
            onClick: async () => {
              try {
                _(!0), await pU(y, I), P(xv()), _(!1);
              } catch {
                _(!1);
              }
            },
            name: "reload",
            children: [
              /* @__PURE__ */ p(
                we,
                {
                  component: "span",
                  sx: { display: "inline-block", paddingRight: "10px" },
                  children: A
                }
              ),
              /* @__PURE__ */ p(yt, { text: "reload", children: /* @__PURE__ */ p(he, { iconName: "reload", sx: { fontSize: 12 } }) })
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
      /* @__PURE__ */ p(xa, {}),
      /* @__PURE__ */ p(
        F2,
        {
          titleTable: m("features.atlas_import.all_elements", {
            message: a
          }),
          titleExtra: u,
          footerStart: d,
          loadingMessage: m("features.atlas_import.loading_message", {
            message: a
          }),
          buttonImportText: h || m("features.atlas_import.add_button", {
            message: a
          }),
          isLoadingButton: r || k === ve.IN_PROGRESS,
          isSelect: c,
          onChange: async (T) => {
            await C(T);
          },
          typeContainer: I,
          parentId: y,
          isOutsideLoading: x,
          hideHeader: f,
          reloadId: R,
          idSelector: "externalId",
          createListMethods: hh.createCrudMethod,
          cols: hh.cols,
          createListFiltersMethod: hh.createFiltersPanel
        }
      )
    ] })
  ] });
}, yU = (e) => {
  switch (e) {
    case Ct.CREATE_NEW_OBJECT:
      return Ct.CREATE_NEW_OBJECT;
    case Ct.CREATE_NEW_VERSION:
      return Ct.CREATE_NEW_VERSION;
    default:
      return e;
  }
}, AU = (e, t, n, r, i) => (a, o, s) => {
  const c = yU(s), l = c ? `?resolution=${encodeURIComponent(c)}` : "";
  switch (t) {
    case ge.STUDY:
      return Nn.post(
        `/studies/${n}/${e}/copy/${a}${l}`,
        o ? { name: o } : {}
      );
    case ge.WORKSPACE:
      return Nn.post(
        `/workspace/${e}/copy/${a}${l}`,
        o ? { name: o } : {}
      );
    case si.ATLAS:
      return Nn.post(
        `/atlas/${r}/assets/${i}/export?id=${a}&name=${o}`
      );
  }
}, IG = (e) => {
  const {
    name: t,
    manualImport: n = !1,
    localImport: r = !1,
    currentContainer: i,
    parentId: a,
    isSelect: o = !1,
    onChange: s,
    subModules: c,
    analysisMode: l,
    atlasEntity: u,
    successMessage: d,
    analysesTypes: f,
    disableImportContainer: h,
    localImportComponent: m,
    manualImportComponent: y,
    cols: v,
    createListMethods: w,
    createListFiltersMethod: I,
    createMethodCreate: M,
    getEntity: k,
    disableRowSelect: g,
    disableRowSelectOnSameContainerOnly: A = !1,
    alertText: b,
    disableManualImport: x,
    disableAltasImport: _,
    defaultResolution: R = Ct.CREATE_NEW_OBJECT,
    hideConflictResolutionMethod: P = !1,
    hideConflictResolutionControls: E = !1,
    hidePendingCancelButton: C = !1,
    toggleSingleSelectionOnRowClick: T = !1,
    disableCopy: D = !1
  } = e, { enqueueSnackbar: z } = bi(), [B, W] = Te([]), [L, S] = Te(!1), [$, j] = Te(R), N = Ct.CREATE_NEW_OBJECT, q = Ce(
    () => ["cohorts", "concept-sets"].includes(t),
    [t]
  ), G = Ce(
    () => ["cohorts", "concept-sets", "analyses"].includes(t),
    [t]
  ), X = Ce(
    () => ["cohorts", "concept-sets", "analyses"].includes(t),
    [t]
  ), Y = Ce(() => t === "cohorts" ? "cohorts" : t === "concept-sets" ? "concept-sets" : "objects", [t]), Q = Ce(() => t === "cohorts" ? "Fully identical cohort(s) will not be created, instead existing ones will be reused. Cohort(s) with the same name, but different content will create a new version of the existing ones." : t === "concept-sets" ? "Fully identical concept set(s) will not be created, instead existing ones will be reused. Concept set(s) with the same name, but different content will create a new version of the existing ones and Cohort design will reference these newly created versions." : "Fully identical objects will not be created, instead existing ones will be reused.", [t]), V = Ce(() => t === "cohorts" ? "New cohort(s) will be created, even if identical cohort(s) exist." : t === "concept-sets" ? "New concept set(s) will be created, even if identical concept set(s) exist." : "New objects will be created, even if identical objects exist.", [t]), U = Ce(
    () => t === "concept-sets" || t === "cohorts" || t === "analyses" ? "Import" : `Add ${t}`,
    [t]
  ), Z = Ce(() => d || (t === "concept-sets" ? "Concept set(s) successfully imported." : t === "cohorts" ? "Cohort(s) successfully imported." : "Successfully copied"), [t, d]), [H, ee] = Te(
    r ? si.LOCAL : l ? i === ge.WORKSPACE ? ge.WORKSPACE : i === ge.LIBRARY ? ge.LIBRARY : ge.STUDY : i === ge.WORKSPACE ? ge.STUDY : i === ge.LIBRARY ? ge.LIBRARY : ge.WORKSPACE
  ), [ie, re] = Te(
    i === ge.STUDY ? a : void 0
  ), K = Ce(
    () => H !== ge.STUDY || !!ie,
    [H, ie]
  ), se = Ce(
    () => X && H === ge.STUDY && !ie,
    [X, H, ie]
  ), [xe, ke] = Te([]), ue = Ce(
    () => !E && q && [
      ge.WORKSPACE,
      ge.STUDY,
      ge.LIBRARY,
      si.ATLAS
    ].includes(H),
    [H, E, q]
  ), fe = Ce(() => H === ge.WORKSPACE ? i === ge.WORKSPACE : H === ge.STUDY ? i === ge.STUDY && ie === a : !1, [H, i, a, ie]), de = Ce(() => {
    if (g)
      return A ? fe ? g : void 0 : g;
  }, [
    g,
    A,
    fe
  ]), ce = (c == null ? void 0 : c.study) || /* @__PURE__ */ p(ze, {}), te = Ce(() => AU(t, i, a), [i, a]), oe = Ce(() => M(i, a), [i, a]), J = Ce(() => {
    if (!l && i === ge.WORKSPACE)
      return h ? [ge.STUDY] : [ge.STUDY, ge.LIBRARY];
    const Oe = h ? [ge.WORKSPACE, ge.STUDY] : [
      ge.WORKSPACE,
      ge.STUDY,
      ge.LIBRARY
    ];
    return h && i === ge.LIBRARY && !Oe.includes(ge.LIBRARY) ? [...Oe, ge.LIBRARY] : Oe;
  }, [l, i, h]), ne = Ce(() => fU(
    n,
    r,
    J,
    B.length,
    ee,
    i,
    x,
    _
  ), [B, x, _]), ye = Ce(() => D ? !1 : t === "concept-sets" || t === "cohorts" ? i !== ge.LIBRARY : !(l && i === H && (H === ge.WORKSPACE || H === ge.STUDY && a === ie)), [
    t,
    l,
    i,
    H,
    D,
    a,
    ie
  ]);
  tt(() => {
    _ || uU().then((Oe) => {
      W(
        Oe.map((Ve) => ({
          value: Ve.id,
          name: Ve.url
        }))
      );
    }).catch(() => {
      z({
        message: "Atlas list have not loaded",
        variant: "error"
      });
    });
  }, [_, z]);
  const Ae = async (Oe, Ve) => {
    const _e = q ? P ? N : fe ? Ct.CREATE_NEW_VERSION : $ : void 0;
    try {
      const Re = Oe.map((Ge) => {
        const Ke = te == null ? void 0 : te(Ge.id, void 0, _e);
        return !Ke || typeof Ke.then != "function" ? Promise.resolve(null) : Ke.catch((Ht) => (z({
          message: `Something wrong. ${Ge.name} was not copied!`,
          variant: "error"
        }), console.error(Ht), null));
      }), Le = await Promise.all(Re);
      s(Le.filter((Ge) => Ge)), z({
        message: Z,
        variant: "success"
      });
    } catch {
      s(null), z({
        message: "Oops! Something wrong",
        variant: "error"
      });
    } finally {
      S(!1);
    }
  }, be = async (Oe) => {
    try {
      return k ? await Promise.all(Oe.map((Ve) => k(Ve.id))) : Oe;
    } catch (Ve) {
      return console.log(Ve), Oe;
    }
  }, je = /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", columnGap: 1.5, flexWrap: "wrap", children: [
    /* @__PURE__ */ p(le, { variant: "caption", sx: { whiteSpace: "nowrap" }, children: "Select conflict resolution method:" }),
    /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
      /* @__PURE__ */ p(
        Vc,
        {
          checked: $ === Ct.CREATE_NEW_VERSION,
          onChange: () => j(Ct.CREATE_NEW_VERSION),
          name: "import-resolution",
          size: "small",
          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
        }
      ),
      /* @__PURE__ */ p(le, { variant: "caption", children: `Overwrite existing ${Y}` }),
      /* @__PURE__ */ p(yt, { text: Q, children: /* @__PURE__ */ p(
        he,
        {
          iconName: "info",
          sx: { fontSize: 12, color: "text.secondary" }
        }
      ) })
    ] }),
    /* @__PURE__ */ F(we, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
      /* @__PURE__ */ p(
        Vc,
        {
          checked: $ === Ct.CREATE_NEW_OBJECT,
          onChange: () => j(Ct.CREATE_NEW_OBJECT),
          name: "import-resolution",
          size: "small",
          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
        }
      ),
      /* @__PURE__ */ p(le, { variant: "caption", children: `Create new ${Y}` }),
      /* @__PURE__ */ p(yt, { text: V, children: /* @__PURE__ */ p(
        he,
        {
          iconName: "info",
          sx: { fontSize: 12, color: "text.secondary" }
        }
      ) })
    ] })
  ] });
  return /* @__PURE__ */ F(O, { container: !0, children: [
    /* @__PURE__ */ p(vr, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ p(ff, { tabs: ne, active: H }) }),
    /* @__PURE__ */ p(O, { container: !0, p: 2, children: H === si.LOCAL ? /* @__PURE__ */ p(O, { item: !0, xs: 12, children: m }) : /* @__PURE__ */ p(lr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ F(O, { item: !0, container: !0, xs: 12, p: 2, children: [
      b && /* @__PURE__ */ p(O, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ p(Bv, { severity: "warning", children: b }) }),
      H === si.MANUAL && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: qe.isValidElement(y) ? qe.cloneElement(y, {
        resolution: q ? P ? N : $ : void 0,
        onResolutionChange: q && !P && !E ? j : void 0
      }) : y }),
      H === ge.STUDY && /* @__PURE__ */ p(O, { item: !0, xs: 12, pb: 2, children: /* @__PURE__ */ p(
        ce,
        {
          type: "component",
          name: "studies-list-select",
          subModules: c,
          config: {
            onChange: (Oe) => {
              re(Oe || void 0);
            },
            analysisMode: l,
            studyInitialId: ie,
            pureControl: !0
          }
        }
      ) }),
      [
        ge.WORKSPACE,
        ge.STUDY,
        ge.LIBRARY
      ].includes(H) && K && /* @__PURE__ */ F(O, { item: !0, xs: 12, children: [
        /* @__PURE__ */ p(
          F2,
          {
            titleTable: `All ${t}`,
            loadingMessage: `Loading ${t}`,
            buttonImportText: U,
            hideHeader: G,
            footerStart: ue && o ? je : void 0,
            hideEmptyTable: se,
            isLoadingButton: L,
            isSelect: o,
            toggleSelectionOnRowClick: T,
            disableRowSelect: de,
            onChange: async (Oe) => {
              const Ve = await be(Oe);
              if (te && ye) {
                if (!Array.isArray(Ve) || Ve.length === 0)
                  return;
                S(!0), await Ae(Ve);
              } else
                s(Ve);
            },
            typeContainer: H,
            parentId: ie || void 0,
            createListMethods: w,
            cols: v,
            createListFiltersMethod: I
          },
          `${H}-${ie || "empty"}`
        ),
        xe.length > 0 && /* @__PURE__ */ F(
          we,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: ue ? "space-between" : "flex-end",
            sx: {
              position: "sticky",
              bottom: 0,
              zIndex: 3,
              px: 2,
              py: 1,
              borderTop: 1,
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 -2px 8px rgba(15, 23, 42, 0.08)"
            },
            children: [
              ue && je,
              /* @__PURE__ */ F(we, { display: "flex", gap: 1, ml: 2, children: [
                !C && /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "outlined",
                    size: "small",
                    onClick: () => ke([]),
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "contained",
                    size: "small",
                    disabled: L,
                    onClick: async () => {
                      S(!0), await Ae(xe), ke([]);
                    },
                    children: "Add"
                  }
                )
              ] })
            ]
          }
        )
      ] }),
      H === si.ATLAS && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
        gU,
        {
          message: t,
          buttonImportText: U,
          hideListHeader: G,
          isLoadingButton: L,
          resolution: q ? P ? N : $ : void 0,
          footerStart: ue ? je : void 0,
          atlasList: B,
          entity: u,
          createMethod: oe,
          analysesTypes: f,
          typeContainer: i,
          parentId: a,
          isSelect: o,
          onChange: (Oe) => {
            s(Oe), z({
              message: Z,
              variant: "success"
            });
          }
        }
      ) })
    ] }) }) })
  ] });
}, vU = () => Nn.get("/atlases"), xU = (e) => (e = e ? "&analysis.type=" + e : "", Nn.get("studies/export-list?size=10000" + e)), bU = (e, t, n) => {
  const r = [
    {
      value: "CONTAINER",
      title: "Export",
      onTabClick: t
    },
    {
      value: "JSON",
      title: e,
      onTabClick: t
    }
  ];
  return n && r.push({
    value: "SQL",
    title: "SQL",
    onTabClick: t
  }), r;
}, yo = (e) => typeof e == "object" && e !== null, wU = (e) => e === ge.WORKSPACE || e === ge.STUDY || e === ge.LIBRARY || e === ge.DETACHED || e === "ATLAS", _U = (e) => {
  if (!yo(e))
    return "Oops! Something wrong";
  const t = e.response;
  if (!yo(t))
    return "Oops! Something wrong";
  const n = t.data;
  return yo(n) && typeof n.message == "string" ? n.message : "Oops! Something wrong";
}, SU = (e) => Array.isArray(e) ? e.map((t) => {
  if (!yo(t))
    return null;
  const n = t.id, r = t.url;
  return typeof n != "string" && typeof n != "number" || typeof r != "string" ? null : {
    value: n,
    name: r
  };
}).filter((t) => t !== null) : [], CU = (e) => !yo(e) || !Array.isArray(e.content) ? [] : e.content.map((t) => {
  if (!yo(t))
    return null;
  const n = t.id, r = t.title;
  return typeof n != "string" && typeof n != "number" || typeof r != "string" ? null : {
    ...t,
    id: n,
    value: n,
    name: r
  };
}).filter((t) => t !== null), NG = ({
  id: e,
  name: t,
  jsonImportTabName: n = "JSON",
  currentContainer: r,
  parentId: i,
  createCopyMethod: a,
  successMessage: o = "Successfully copied",
  onChange: s,
  typeEntity: c,
  analysisType: l,
  entityAtlas: u,
  validateName: d,
  exportJson: f,
  exportSql: h,
  customAction: m,
  defaultResolution: y,
  hideConflictResolutionControls: v = !1
}) => {
  const w = cr(), { enqueueSnackbar: I } = bi(), [M, k] = Te("CONTAINER"), [g, A] = Te({
    typeContainer: r,
    studyId: i,
    title: t
  }), [b, x] = Te(ve.INITIAL), [_, R] = Te([]), [P, E] = Te(null), [C, T] = Te(
    []
  ), [D, z] = Te(""), [B, W] = Te(
    y ?? (c === "concept-sets" ? Ct.CREATE_NEW_OBJECT : Ct.CREATE_NEW_VERSION)
  ), [L, S] = Te(""), [$, j] = Te(null), N = ot((se) => {
    (se === "JSON" || se === "SQL" || se === "CONTAINER") && k(se);
  }, []), q = Ce(
    () => bU(n, N, !!h),
    [n, N, h]
  ), G = Ce(
    () => g.typeContainer === "ATLAS" ? a(
      g.typeContainer,
      g.studyId,
      P,
      u
    ) : a(g.typeContainer, g.studyId),
    [
      g.typeContainer,
      g.studyId,
      P,
      u,
      a
    ]
  ), X = Ce(() => g.typeContainer === ge.WORKSPACE ? `/workspace/${c}/` : g.typeContainer === ge.STUDY && g.studyId ? `/study-manager/${g.studyId}/${c}/` : null, [g.typeContainer, g.studyId, c]);
  tt(() => {
    vU().then((se) => {
      var ke;
      const xe = SU(se);
      R(xe), E(((ke = xe[0]) == null ? void 0 : ke.value) ?? null);
    }).catch(() => {
      I({
        message: "Atlas list have not loaded",
        variant: "error"
      });
    }), xU(l || "").then((se) => {
      T(CU(se));
    }).catch(() => {
      I({
        message: "Export Study list have not loaded",
        variant: "error"
      });
    });
  }, [l, I]), tt(() => {
    b === ve.SUCCESS && I({
      message: o,
      variant: "success"
    });
  }, [b, o, I]);
  const Y = ["concept-sets", "cohorts"].includes(c) && g.typeContainer !== "ATLAS", Q = B === Ct.CREATE_NEW_OBJECT, V = ot(() => {
    z(""), S("");
  }, []);
  tt(() => {
    Q || V();
  }, [Q, V]);
  const U = async () => {
    x(ve.IN_PROGRESS);
    const se = g.title.trim(), xe = !!d && g.typeContainer !== "ATLAS" && (!Y || Q), ke = Y ? Q ? Ct.CREATE_NEW_OBJECT : Ct.CREATE_NEW_VERSION : Ct.CREATE_NEW_OBJECT;
    try {
      if (d && xe) {
        const fe = await Promise.resolve(
          d({
            typeContainer: g.typeContainer,
            studyId: g.studyId,
            name: se
          })
        );
        if (!(fe != null && fe.isValid)) {
          z(
            (fe == null ? void 0 : fe.message) || "Error! Name is already used by another object."
          ), S(se), x(ve.INITIAL);
          return;
        }
        V();
      }
      const ue = await Promise.resolve(
        G(e, se, ke)
      );
      x(ve.SUCCESS), g.typeContainer !== "ATLAS" && X && ue && typeof ue == "object" && "id" in ue && w(`${X}${ue.id}`), s();
    } catch (ue) {
      I({
        message: _U(ue),
        variant: "error"
      }), x(ve.ERROR);
    }
  }, Z = Ce(() => !!(g.typeContainer === ge.WORKSPACE || g.typeContainer === "ATLAS" || g.typeContainer === ge.STUDY && g.studyId), [g.typeContainer, g.studyId]), H = "Select conflict resolution method:", ee = "concept-sets", ie = "Fully identical concept set(s) will not be created, instead existing ones will be reused. Concept set(s) with the same name, but different content will create a new version of the existing ones and Cohort design will reference these newly created versions.", re = "New concept set(s) will be created, even if identical concept set(s) exist.", K = Q && D.length > 0 && g.title.trim().length > 0 && g.title.trim() === L;
  return /* @__PURE__ */ F(O, { container: !0, children: [
    /* @__PURE__ */ p(vr, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ F(O, { container: !0, justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ p(ff, { tabs: q, active: M }),
      /* @__PURE__ */ p(O, { item: !0, children: m })
    ] }) }),
    /* @__PURE__ */ F(O, { item: !0, xs: 12, p: 2, children: [
      M === "CONTAINER" && /* @__PURE__ */ p(lr, { children: /* @__PURE__ */ F(O, { container: !0, spacing: 1, p: 2, children: [
        /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
          nn,
          {
            name: "typeContainer",
            textLabel: "Export to",
            required: !0,
            children: /* @__PURE__ */ p(
              mr,
              {
                name: "typeContainer",
                disablePortal: !0,
                id: "typeContainer",
                options: Gp.filter(
                  (se) => u ? se : se.value !== "ATLAS"
                ),
                value: g.typeContainer,
                placeholder: "Select type",
                onChange: (se) => {
                  wU(se) && (A((xe) => ({
                    ...xe,
                    typeContainer: se
                  })), V());
                },
                fullWidth: !0
              }
            )
          }
        ) }),
        g.typeContainer === ge.STUDY && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(nn, { name: "study", textLabel: "Study", children: /* @__PURE__ */ p(
          zv,
          {
            name: "studies",
            id: "studies",
            options: C,
            value: $,
            placeholder: "Select study...",
            fullWidth: !0,
            isOptionEqualToValue: (se, xe) => se.value === xe.value,
            onChange: (se, xe) => {
              j(xe), A((ke) => ({
                ...ke,
                studyId: xe == null ? void 0 : xe.id
              })), V();
            },
            getOptionLabel: (se) => se.name
          }
        ) }) }),
        g.typeContainer === "ATLAS" && u && /* @__PURE__ */ p(O, { item: !0, xs: 5, children: /* @__PURE__ */ p(nn, { name: "atlas", textLabel: "Atlas", required: !0, children: /* @__PURE__ */ p(
          mr,
          {
            name: "atlas",
            disablePortal: !0,
            id: "atlas",
            options: _,
            value: P,
            placeholder: "Select atlas resource",
            onChange: (se) => {
              typeof se != "string" && typeof se != "number" || E(se);
            },
            fullWidth: !0
          }
        ) }) }),
        Z && /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(nn, { name: "title", textLabel: "Title", required: !0, children: [
          /* @__PURE__ */ p(
            xr,
            {
              id: "title",
              name: "title",
              type: "text",
              size: "medium",
              placeholder: "Enter title",
              value: g.title,
              onChange: (se) => {
                A((xe) => ({
                  ...xe,
                  title: se.target.value
                })), se.target.value.trim() !== L && V();
              },
              fullWidth: !0,
              required: !0
            }
          ),
          D && /* @__PURE__ */ p(le, { color: "error.main", variant: "caption", children: D })
        ] }) }),
        /* @__PURE__ */ p(O, { item: !0, xs: 12, mt: 0.5, children: /* @__PURE__ */ F(
          O,
          {
            container: !0,
            alignItems: "center",
            justifyContent: "space-between",
            columnSpacing: 2,
            rowSpacing: 1,
            children: [
              /* @__PURE__ */ p(O, { item: !0, xs: 12, md: !0, children: Y && !v && /* @__PURE__ */ F(
                O,
                {
                  display: "flex",
                  alignItems: "center",
                  columnGap: 1.5,
                  flexWrap: "nowrap",
                  sx: { maxWidth: "100%", overflowX: "auto", py: 0.25 },
                  children: [
                    /* @__PURE__ */ p(
                      le,
                      {
                        variant: "caption",
                        sx: { whiteSpace: "nowrap" },
                        children: H
                      }
                    ),
                    /* @__PURE__ */ F(
                      O,
                      {
                        display: "flex",
                        alignItems: "center",
                        columnGap: 1.5,
                        sx: { whiteSpace: "nowrap" },
                        children: [
                          /* @__PURE__ */ F(
                            O,
                            {
                              display: "flex",
                              alignItems: "center",
                              columnGap: 0.75,
                              children: [
                                /* @__PURE__ */ p(
                                  Vc,
                                  {
                                    checked: B === Ct.CREATE_NEW_VERSION,
                                    onChange: () => W(
                                      Ct.CREATE_NEW_VERSION
                                    ),
                                    name: "export-resolution",
                                    size: "small",
                                    sx: {
                                      p: 0.25,
                                      "& .MuiSvgIcon-root": { fontSize: 16 }
                                    }
                                  }
                                ),
                                /* @__PURE__ */ p(le, { variant: "caption", children: `Overwrite existing ${ee}` }),
                                /* @__PURE__ */ p(
                                  yt,
                                  {
                                    text: ie,
                                    children: /* @__PURE__ */ p(
                                      he,
                                      {
                                        iconName: "info",
                                        sx: { fontSize: 12, color: "text.secondary" }
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ F(
                            O,
                            {
                              display: "flex",
                              alignItems: "center",
                              columnGap: 0.75,
                              children: [
                                /* @__PURE__ */ p(
                                  Vc,
                                  {
                                    checked: B === Ct.CREATE_NEW_OBJECT,
                                    onChange: () => W(
                                      Ct.CREATE_NEW_OBJECT
                                    ),
                                    name: "export-resolution",
                                    size: "small",
                                    sx: {
                                      p: 0.25,
                                      "& .MuiSvgIcon-root": { fontSize: 16 }
                                    }
                                  }
                                ),
                                /* @__PURE__ */ p(le, { variant: "caption", children: `Create new ${ee}` }),
                                /* @__PURE__ */ p(
                                  yt,
                                  {
                                    text: re,
                                    children: /* @__PURE__ */ p(
                                      he,
                                      {
                                        iconName: "info",
                                        sx: { fontSize: 12, color: "text.secondary" }
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ) }),
              /* @__PURE__ */ p(O, { item: !0, xs: 12, md: "auto", children: /* @__PURE__ */ F(nf, { children: [
                /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "outlined",
                    onClick: s,
                    size: "small",
                    startIcon: /* @__PURE__ */ p(he, { iconName: "deactivate" }),
                    name: "cancel",
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ p(
                  Ee,
                  {
                    disabled: !Z || ve.IN_PROGRESS === b || K,
                    onClick: U,
                    variant: "contained",
                    size: "small",
                    color: "success",
                    startIcon: /* @__PURE__ */ p(he, { iconName: "submit" }),
                    name: "export",
                    children: "Export"
                  }
                )
              ] }) })
            ]
          }
        ) })
      ] }) }),
      M === "JSON" && /* @__PURE__ */ p(vr, { elevation: 3, children: f }),
      M === "SQL" && h && /* @__PURE__ */ p(vr, { elevation: 3, children: h })
    ] })
  ] });
}, Y2 = ae(Us)`
  &:hover {
    background: transparent;
  }
`, OG = ({
  title: e,
  onClick: t,
  iconName: n,
  description: r,
  buttonName: i
}) => /* @__PURE__ */ p(vr, { elevation: 3, sx: { minHeight: "100%" }, children: /* @__PURE__ */ p(O, { container: !0, p: 3, children: /* @__PURE__ */ F(
  O,
  {
    item: !0,
    xs: 12,
    justifyContent: "space-between",
    container: !0,
    sx: { cursor: "default" },
    children: [
      /* @__PURE__ */ p(Y2, { onClick: t, children: /* @__PURE__ */ p(
        tf,
        {
          iconName: n,
          sx: { fontSize: "80px", pl: 1.5, alignSelf: "start", pt: 1 }
        }
      ) }),
      /* @__PURE__ */ F(O, { item: !0, container: !0, maxWidth: "calc(100% - 116px)", spacing: 1, children: [
        /* @__PURE__ */ p(
          O,
          {
            item: !0,
            xs: 12,
            fontSize: 20,
            fontWeight: 400,
            color: "textColor.header",
            children: e
          }
        ),
        /* @__PURE__ */ p(
          O,
          {
            item: !0,
            xs: 12,
            sx: (a) => ({ color: a.palette.grey[600], fontSize: 13 }),
            children: r
          }
        ),
        /* @__PURE__ */ p(O, { item: !0, xs: 12, children: i && /* @__PURE__ */ p(O, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ p(
          Ee,
          {
            onClick: () => t == null ? void 0 : t(),
            variant: "outlined",
            name: "save",
            children: i
          }
        ) }) })
      ] })
    ]
  }
) }) }), RG = ({ children: e, title: t, description: n, actions: r, iconName: i, onClick: a }) => /* @__PURE__ */ p(vr, { elevation: 3, sx: { minHeight: e ? "100%" : "auto" }, children: /* @__PURE__ */ F(O, { container: !0, p: 3, children: [
  /* @__PURE__ */ F(
    O,
    {
      item: !0,
      xs: 12,
      borderBottom: e ? "1px solid" : "none",
      borderColor: "borderColor.main",
      justifyContent: "space-between",
      pb: e ? 2 : 0,
      container: !0,
      sx: { cursor: "default" },
      children: [
        /* @__PURE__ */ p(Y2, { onClick: a, children: /* @__PURE__ */ p(
          tf,
          {
            iconName: i,
            sx: { fontSize: "80px", pl: 1.5, alignSelf: "start", pt: 1 }
          }
        ) }),
        /* @__PURE__ */ F(O, { item: !0, container: !0, maxWidth: "calc(100% - 116px)", spacing: 1, children: [
          /* @__PURE__ */ p(
            O,
            {
              item: !0,
              xs: 12,
              fontSize: 20,
              fontWeight: 400,
              color: "textColor.header",
              children: t
            }
          ),
          /* @__PURE__ */ p(
            O,
            {
              item: !0,
              xs: 12,
              sx: (o) => ({ color: o.palette.grey[600], fontSize: 13 }),
              children: n
            }
          ),
          /* @__PURE__ */ p(O, { item: !0, xs: 12, children: r })
        ] })
      ]
    }
  ),
  e
] }) }), DG = ({ children: e, title: t, description: n, iconName: r, onCardClick: i }) => /* @__PURE__ */ p(
  O,
  {
    container: !0,
    item: !0,
    xs: 12,
    sx: (a) => ({
      padding: 1.5,
      "&:hover": {
        backgroundColor: a.palette.info.light + 50,
        ".description": {
          color: a.palette.grey[800]
        }
      }
    }),
    onClick: (a) => {
      a.stopPropagation(), i(a);
    },
    children: /* @__PURE__ */ F(
      O,
      {
        container: !0,
        spacing: 2,
        flexWrap: "nowrap",
        alignItems: "center",
        flexDirection: { xs: "row", md: "column", lg: "row" },
        sx: { cursor: "pointer" },
        children: [
          /* @__PURE__ */ F(
            O,
            {
              item: !0,
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "center",
              xs: 12,
              children: [
                /* @__PURE__ */ p(O, { item: !0, mr: 2, className: "icon-container", children: /* @__PURE__ */ p(
                  tf,
                  {
                    iconName: r,
                    sx: { fontSize: 48 },
                    color: "secondary"
                  }
                ) }),
                /* @__PURE__ */ F(
                  O,
                  {
                    item: !0,
                    sx: (a) => ({
                      ".title": {
                        fontSize: 14,
                        fontWeight: 500,
                        color: "textColor.header",
                        marginBottom: 0.5
                      },
                      ".description": {
                        fontSize: 12,
                        color: a.palette.grey[600]
                      }
                    }),
                    children: [
                      /* @__PURE__ */ p("div", { className: "title", children: t }),
                      /* @__PURE__ */ p("div", { className: "description", children: n })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ p(O, { item: !0, children: e })
        ]
      }
    )
  }
), PG = ae((e) => /* @__PURE__ */ p(O, { item: !0, xs: 12, pt: 1.5, children: /* @__PURE__ */ p(O, { container: !0, spacing: 1, ...e, children: e.children }) }))({}), LG = ae((e) => /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p("div", { ...e, children: e.children }) }))(
  ({ theme: e, light: t }) => ({
    maxWidth: "100%",
    fontSize: 13,
    fontWeight: "bold",
    color: e.palette.grey[900],
    backgroundColor: t ? "#f6f8fa" : e.palette.backgroundColor.main,
    padding: "8px 12px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: e.palette.info.main + 20
    },
    ".light-text": {
      fontWeight: 300
    },
    ".list-item-section": {
      display: "flex",
      alignItems: "center",
      height: 24,
      "&.nowrap": {
        overflow: "hidden"
      },
      "> *:not(:last-child)": {
        marginRight: 12
      },
      ".list-item-title": {
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        paddingRight: "4px"
      }
    }
  })
), EU = [
  {
    Header: "Type",
    accessor: "entityType",
    Cell: Gi,
    width: "5%",
    minWidth: 40
  },
  cm({ Cell: nI }),
  fm({ Header: "Date" }),
  um(),
  dm()
], zG = ({ getList: e }) => {
  const t = cr(), n = PC({
    methods: {
      read: {
        method: e,
        // todo
        formatter: ([a, o, s, c]) => [
          ...(a == null ? void 0 : a.content.map((u) => ({
            ...u,
            entityType: wt.COHORT
          }))) || [],
          ...(s == null ? void 0 : s.content.map((u) => ({
            ...u,
            entityType: wt.CONCEPT_SET
          }))) || [],
          ...(o == null ? void 0 : o.content.map((u) => ({
            ...u,
            entityType: wt.ANALYSIS,
            name: u.title
          }))) || [],
          ...(c == null ? void 0 : c.content.map((u) => ({
            ...u,
            entityType: wt.ANALYSIS_SUBMISSION,
            name: u.analysisTitle + " executed"
          }))) || []
        ]
      }
    },
    primaryKey: "id"
  }), r = qe.useMemo(
    () => Object.values(n.data.byId),
    [n.data.byId]
  ), i = (a) => {
    switch (a.original.entityType) {
      case wt.ANALYSIS_SUBMISSION: {
        t(
          `${hy[a.original.entityType]}/${a.original.analysisId}/executions`
        );
        break;
      }
      default:
        t(
          `${hy[a.original.entityType]}/${a.original.id}`
        );
    }
  };
  return qe.useEffect(() => {
    n.getEntityList();
  }, []), /* @__PURE__ */ F(O, { container: !0, item: !0, xs: 12, children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, mb: 1.5, children: /* @__PURE__ */ p(le, { variant: "h2", children: "Latest activity" }) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
      xl,
      {
        data: r,
        columns: EU,
        initialSort: { id: "modified.timestamp", desc: !0 },
        pageSize: 8,
        isLoading: n.isLoading,
        onRowClick: i,
        hiddenColumns: { "created.timestamp": !1 },
        skeletonRows: 8,
        skeletonVariant: "default",
        skeletonShowHeader: !0,
        skeletonColumnWidths: ["56px", "minmax(0, 1fr)", "190px", "210px"],
        skeletonColumnKinds: ["type-icon", "double-text", "text", "text"],
        skeletonColumnAlignments: ["left", "left", "left", "left"]
      }
    ) })
  ] });
}, kU = ae.div`
  /* margin: 3px; */
`, Ts = ae.div`
  text-align: center;
  opacity: 0.2;
  font-size: 20px;
  margin: 100px 0;
`;
class TU extends qe.Component {
  constructor(n) {
    super(n);
    m0(this, "state", {});
    this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0 };
  }
  componentDidCatch(n, r) {
    console.error(n, r);
  }
  render() {
    var n, r;
    return this.state.hasError ? (n = this.props) == null ? void 0 : n.fallback : (r = this.props) == null ? void 0 : r.children;
  }
}
const MU = (e) => {
  switch (e) {
    case tn.CSV:
      return "CSV";
    case tn.PDF:
      return "PDF";
    case tn.HTML:
    case tn.JSON:
    case tn.JS:
    case tn.SQL:
    case tn.R:
    case tn.RPROFILE:
    case tn.TXT:
      return "CODE";
    case tn.ZIP:
    case tn.JAR:
      return "ARCHIVE";
    default:
      return "CODE";
  }
}, IU = (e) => {
  const { fileContent: t, fileMetadata: n, status: r, pdfLink: i, height: a } = e, [o, s] = Te();
  return tt(() => {
    n != null && n.ext && s(MU(n.ext));
  }, [n]), r === "LOADING_FILE" ? /* @__PURE__ */ p(Ts, { children: "Loading..." }) : /* @__PURE__ */ p(kU, { children: /* @__PURE__ */ p(
    TU,
    {
      fallback: /* @__PURE__ */ p(Ts, { children: "Content of this file cannot be displayed" }),
      children: /* @__PURE__ */ F(ze, { children: [
        (!t || !o) && /* @__PURE__ */ p(Ts, { children: "Select file to display content" }),
        t && o && /* @__PURE__ */ F(ze, { children: [
          o === "CODE" && /* @__PURE__ */ p(
            _l,
            {
              data: t,
              height: a || "80vh",
              containerStyles: { padding: 0 },
              enableDownload: !1,
              enableCopy: !0,
              language: Zu(n.ext)
            }
          ),
          o === "CSV" && /* @__PURE__ */ p(hx, { data: t, height: 550 }),
          o === "PDF" && /* @__PURE__ */ p(we, { sx: { height: "600px" }, children: /* @__PURE__ */ p(
            mx,
            {
              data: n,
              height: "80vh",
              linkDownload: i,
              scaleDefault: 0.7,
              scroll: !0
            }
          ) }),
          o === "ARCHIVE" && /* @__PURE__ */ p(Ts, { children: "Content of this file cannot be displayed" })
        ] })
      ] })
    }
  ) });
}, NU = ae.div`
  box-shadow: ${(e) => e.subList ? "2px 0px 4px -3px transparent;" : "2px 0px 4px -3px transparent"};
  max-height: ${(e) => e.subList ? "auto" : "calc(100vh - 250px)"}; // not good
  overflow: hidden;
  overflow-y: auto;
  border-left: ${(e) => e.subList ? "1px solid #232323" : "0px solid #232323"};
  z-index: 2;
  section {
    height: calc(100vh - 250px);
  }
`, OU = ae.div`
  padding: 5px 10px;
  display: flex;
`, RU = ae.div`
  margin-left: 15px;
`, DU = ae.div`
  width: 5px;
  height: 1px;
  border-bottom: 1px solid #343434;
  position: relative;
  top: 17px;
`;
ae.div`
  display: flex;
  flex-direction: row;
`;
const hv = ae.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: ${(e) => e.selectedFile ? "600" : "300"};
  margin-top: 2px;
  margin-left: 7px;
  margin-right: 7px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`, PU = ae.span`
  font-weight: 700;
  font-size: 10px;
`, LU = ae.div`
  padding: 0px 7px 0px;
  font-size: 11px;
  background: #3a4452;
  color: #ffffff;
  /* width: 18px; */
  /* height: 16px; */
  text-align: center;
  border-radius: 4px;
  padding-top: 2px;
  margin-top: 6px;
  position: relative;
  top: -4px;
`, zU = ae.div``, BU = ae.div`
  background: #3a4452;
  color: #ffffff;
  padding: 10px 10px;
`, pv = ae.div`
  display: inline-block;
  position: relative;
  top: 2px;
  margin-left: ${(e) => e.marginLeft};
`, mv = ae.div`
  display: unline-block;
  float: right;
`, FU = (e) => {
  const { item: t, selectFile: n, selectedFile: r, status: i, files: a, subList: o } = e, [s, c] = Te(!1), l = (d) => {
    d.__type__ === "FOLDER" && c((f) => !f), d.__type__ === "FILE" && n(d);
  }, u = (d) => {
    var h;
    const f = v0((h = t == null ? void 0 : t.fileMetadata) == null ? void 0 : h.length, 2);
    return d.__type__ === "FILE" ? `${t.__name__} (${f})` : `${t.__name__}`;
  };
  return t ? /* @__PURE__ */ F(ze, { children: [
    o && /* @__PURE__ */ p(DU, {}),
    /* @__PURE__ */ F(
      OU,
      {
        title: u(t),
        onClick: () => l(t),
        children: [
          t.__type__ === "FOLDER" && /* @__PURE__ */ F(ze, { children: [
            /* @__PURE__ */ p(zU, { children: /* @__PURE__ */ p(
              he,
              {
                iconName: "folder",
                sx: { "&.MuiSvgIcon-root": { fontSize: 20 } }
              }
            ) }),
            /* @__PURE__ */ p(
              hv,
              {
                selectedFile: t.id && r && r.id === t.id,
                children: t.__name__
              }
            ),
            /* @__PURE__ */ p(LU, { children: t.__size__ })
          ] }),
          t.__type__ === "FILE" && /* @__PURE__ */ F(ze, { children: [
            (r == null ? void 0 : r.id) === t.id && i === LC.LOADING_FILE ? /* @__PURE__ */ p(gt, { size: 18 }) : /* @__PURE__ */ p(
              he,
              {
                iconName: t.ext,
                sx: { "&.MuiSvgIcon-root": { fontSize: 20 } }
              }
            ),
            /* @__PURE__ */ F(hv, { selectedFile: t.id && (r == null ? void 0 : r.id) === t.id, children: [
              t.__name__,
              " ",
              /* @__PURE__ */ p(PU, { children: " (" + v0(t.fileMetadata.length, 2) + ")" })
            ] })
          ] })
        ]
      }
    ),
    s && /* @__PURE__ */ p(RU, { children: /* @__PURE__ */ p(
      j2,
      {
        subList: !0,
        fileTree: t,
        selectedFile: r,
        selectFile: n,
        status: i
      }
    ) })
  ] }) : /* @__PURE__ */ p(ze, {});
}, j2 = (e) => {
  const { selectedFile: t, selectFile: n, status: r, subList: i, fileTree: a } = e, { t: o } = Ma(), s = (a == null ? void 0 : a.__size__) > 0 ? Object.values(a) : [];
  return s.sort((c, l) => c.__type__ < l.__type__ ? 1 : c.__type__ > l.__type__ ? -1 : 0), /* @__PURE__ */ p(NU, { subList: i, children: /* @__PURE__ */ p(O, { container: !0, children: (s == null ? void 0 : s.length) > 0 ? s.map((c, l) => /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    FU,
    {
      subList: i,
      files: a,
      selectedFile: t,
      selectFile: n,
      item: c,
      status: r
    }
  ) }, l)) : /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(le, { py: 3, variant: "h2", align: "center", children: o("features.file_explorer.no_files_to_display") }) }) }) });
}, BG = (e) => {
  const { t } = Ma(), {
    submissionId: n,
    url: r,
    noDataMessage: i = t("messages.result_empty"),
    files: a,
    heightCount: o = 250
  } = e, { fileTree: s, status: c, selectedFile: l, filesContent: u, selectFile: d } = zC(n, r, a);
  return [ve.INITIAL, ve.IN_PROGRESS].includes(c) ? /* @__PURE__ */ p(O, { item: !0, xs: 12, py: "100px", children: /* @__PURE__ */ p(cf, { children: /* @__PURE__ */ p(gt, { size: 30 }) }) }) : /* @__PURE__ */ p(vr, { elevation: 0, sx: { p: 2 }, children: (s == null ? void 0 : s.__size__) === 0 ? /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(Ts, { children: i }) }) : /* @__PURE__ */ F(O, { container: !0, border: "1px solid", borderColor: "borderColor.main", children: [
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(BU, { children: /* @__PURE__ */ F(O, { container: !0, children: [
      /* @__PURE__ */ F(
        O,
        {
          item: !0,
          xs: 3,
          sx: {
            paddingRight: "21px",
            borderRight: "1px solid"
          },
          children: [
            /* @__PURE__ */ p(pv, { children: t("features.file_explorer.header") }),
            /* @__PURE__ */ p(mv, { children: /* @__PURE__ */ p(
              "a",
              {
                href: `/api/${r}/${n}/results/download`,
                target: "_blank",
                children: /* @__PURE__ */ p(
                  Ee,
                  {
                    variant: "outlined",
                    size: "small",
                    name: "download-all-result-files",
                    startIcon: /* @__PURE__ */ p(he, { iconName: "import" }),
                    children: t("buttons.download_all")
                  }
                )
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ p(O, { item: !0, xs: 9, children: l && /* @__PURE__ */ F(ze, { children: [
        /* @__PURE__ */ p(pv, { marginLeft: "20px", children: l.__name__ }),
        /* @__PURE__ */ p(mv, { children: /* @__PURE__ */ p(
          "a",
          {
            href: `/api/${r}/${n}/results/${l == null ? void 0 : l.id}/download`,
            target: "_blank",
            children: /* @__PURE__ */ p(
              Ee,
              {
                variant: "outlined",
                size: "small",
                startIcon: /* @__PURE__ */ p(he, { iconName: "import" }),
                children: t("buttons.download")
              }
            )
          }
        ) })
      ] }) })
    ] }) }) }),
    /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ F(O, { container: !0, children: [
      /* @__PURE__ */ p(
        O,
        {
          item: !0,
          xs: 3,
          borderRight: "1px solid",
          borderColor: "borderColor.main",
          sx: { height: "80vh", overflowY: "auto" },
          children: /* @__PURE__ */ p(
            j2,
            {
              fileTree: s,
              status: c,
              selectedFile: l,
              selectFile: d
            }
          )
        }
      ),
      /* @__PURE__ */ p(
        O,
        {
          item: !0,
          xs: 9,
          sx: { height: `calc(100vh - ${o}px)` },
          children: /* @__PURE__ */ p(
            IU,
            {
              fileContent: u == null ? void 0 : u[l.id],
              fileMetadata: l,
              status: c,
              pdfLink: `/api/${r}/${n}/results/${l == null ? void 0 : l.id}/download`,
              height: `calc(100vh - ${o}px)`
            }
          )
        }
      )
    ] }) })
  ] }) });
}, FG = ({
  tooltipText: e
}) => /* @__PURE__ */ p(yt, { text: e || "", children: /* @__PURE__ */ p(
  bl,
  {
    sx: (t) => ({
      backgroundColor: t.palette.grey[200],
      borderRadius: "50%",
      width: 20,
      height: 20,
      p: "4px",
      ":hover": {
        backgroundColor: t.palette.grey[300]
      }
    }),
    children: /* @__PURE__ */ p(he, { iconName: "message", sx: { fontSize: 12, color: "grey" } })
  }
) }), YG = (e) => {
  const {
    onChange: t,
    titleButton: n = "Upload file",
    initialTextFile: r,
    required: i = !1
  } = e, a = sr(null), o = () => {
    a && a.current && (a.current.value = "");
  }, { enqueueSnackbar: s } = bi(), [c, l] = Te(
    r ? {
      name: r
    } : null
  ), u = (d) => {
    const f = new FileReader();
    f.readAsText(d), f.onload = function() {
      try {
        const h = JSON.parse(f.result);
        t(h, d), l(d);
      } catch {
        s({
          message: "invalid JSON",
          variant: "error"
        });
      }
    }, f.onerror = function() {
      s({
        message: f.error,
        variant: "error"
      });
    };
  };
  return /* @__PURE__ */ p(O, { container: !0, children: /* @__PURE__ */ F(
    O,
    {
      item: !0,
      xs: 12,
      p: 1.5,
      borderRadius: 1,
      bgcolor: "backgroundColor.main",
      container: !0,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ F(O, { item: !0, children: [
          /* @__PURE__ */ F(
            Ee,
            {
              variant: "contained",
              component: "label",
              color: "info",
              size: "small",
              startIcon: /* @__PURE__ */ p(he, { iconName: "upload" }),
              sx: { minWidth: 150 },
              children: [
                n,
                /* @__PURE__ */ p(
                  "input",
                  {
                    type: "file",
                    accept: "application/json",
                    ref: a,
                    onChange: (d) => {
                      const f = d.target.files[0];
                      u(f);
                    },
                    hidden: !0
                  }
                )
              ]
            }
          ),
          " "
        ] }),
        /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, ml: 2, display: "flex", alignItems: "center", children: c ? /* @__PURE__ */ F(ze, { children: [
          /* @__PURE__ */ p(
            le,
            {
              sx: { maxWidth: "calc(100% - 30px)", wordBreak: "break-all" },
              children: c == null ? void 0 : c.name
            }
          ),
          /* @__PURE__ */ p(
            bl,
            {
              size: "small",
              color: "error",
              sx: { p: 0.5, ml: 1 },
              onClick: () => {
                l(null), t(null), o();
              },
              children: /* @__PURE__ */ p(he, { iconName: "delete", sx: { fontSize: 14 } })
            }
          )
        ] }) : /* @__PURE__ */ F(
          le,
          {
            variant: "subtitle2",
            sx: { sup: { color: "error.main", fontSize: 12 } },
            children: [
              "Choose file to upload",
              i && /* @__PURE__ */ p("sup", { children: "*" })
            ]
          }
        ) })
      ]
    }
  ) });
}, YU = ae(we, {
  shouldForwardProp(e) {
    return e !== "count" && e !== "fontSize";
  }
})(({ theme: e, count: t = 0, fontSize: n }) => ({
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  position: "relative",
  ":before": {
    content: '""',
    display: "block",
    paddingBottom: "100%",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #40527F 18.33%, #2F467C 23.38%, #5E89EF 98.5%)"
  },
  ":after": {
    content: `'${t}'`,
    color: e.palette.textColor.secondary,
    fontSize: n || "40px",
    fontWeight: 700,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    top: 0,
    width: "calc(100% - 24px)",
    height: "calc(100% - 24px)",
    margin: "12px",
    borderRadius: "50%",
    textAlign: "center",
    background: "#ffffff",
    transform: "scale(100%)"
  }
})), p0 = ({ infoText: e, placement: t }) => {
  function n() {
    switch (t) {
      case "top-left":
        return {
          top: 6,
          left: 6
        };
      case "top-right":
        return {
          top: 6,
          right: 6
        };
      case "bottom-right":
        return {
          bottom: 6,
          right: 6
        };
      case "bottom-left":
        return {
          bottom: 6,
          left: 6
        };
    }
  }
  return /* @__PURE__ */ p(yt, { text: e, children: /* @__PURE__ */ p(
    he,
    {
      iconName: "info",
      sx: {
        fontSize: 18,
        position: "absolute",
        ...n(),
        color: "#9fa8bd",
        cursor: "pointer",
        "&:hover": {
          color: "#808ba7"
        }
      }
    }
  ) });
}, jU = ({ count: e = 0, infoText: t, loading: n, title: r }) => {
  const [i, a] = Te(0), o = ot(
    (s) => {
      s !== null && a(
        Math.round(
          s.getBoundingClientRect().width * 1.05 / (String(e).length || 1)
        )
      );
    },
    [e]
  );
  return /* @__PURE__ */ F(
    vr,
    {
      variant: "outlined",
      sx: (s) => ({
        position: "relative",
        height: "100%",
        boxShadow: s.customShadows[3]
      }),
      children: [
        /* @__PURE__ */ p(p0, { infoText: t, placement: "bottom-right" }),
        /* @__PURE__ */ F(we, { p: 1.2, children: [
          /* @__PURE__ */ p(le, { fontSize: 12, children: r }),
          /* @__PURE__ */ F(le, { fontSize: 12, children: [
            "Total number: ",
            /* @__PURE__ */ p("b", { children: e })
          ] })
        ] }),
        /* @__PURE__ */ p(we, { px: 5, py: 2, pt: 1.5, children: n ? /* @__PURE__ */ p(gt, { size: 116, thickness: 4.4, color: "secondary" }) : /* @__PURE__ */ p(
          YU,
          {
            ref: o,
            count: e,
            fontSize: i > 40 ? 40 : i
          }
        ) })
      ]
    }
  );
};
function $U(e, t) {
  let n = String(e).length, r = Math.round(t / (n || 1));
  try {
    return r > 23 ? 40 : r < 3 ? 5 : 30 * r * 0.95 / 16.85;
  } catch (i) {
    return console.log(i), 30;
  }
}
const gv = ({ count: e = 0, title: t, infoText: n, iconName: r, loading: i }) => {
  const [a, o] = Te(0), s = ot(
    (c) => {
      c !== null && o($U(e, c.getBoundingClientRect().width));
    },
    [e]
  );
  return /* @__PURE__ */ F(
    vr,
    {
      variant: "outlined",
      sx: (c) => ({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexGrow: 1,
        maxWidth: "100%",
        boxShadow: c.customShadows[3]
      }),
      children: [
        /* @__PURE__ */ p(p0, { infoText: n, placement: "top-right" }),
        /* @__PURE__ */ p(O, { item: !0, p: 1.2, children: /* @__PURE__ */ p(le, { fontSize: 12, children: t }) }),
        /* @__PURE__ */ F(
          O,
          {
            container: !0,
            justifyContent: "space-between",
            alignItems: "flex-end",
            px: 1.2,
            pb: 0.5,
            flexWrap: "nowrap",
            children: [
              /* @__PURE__ */ p(
                O,
                {
                  item: !0,
                  flexGrow: 1,
                  fontSize: a,
                  fontWeight: 700,
                  color: "textColor.secondary",
                  lineHeight: "1em",
                  ref: s,
                  maxWidth: "calc(100% - 30px)",
                  children: i ? /* @__PURE__ */ p(
                    ii,
                    {
                      height: 36,
                      sx: { mb: 0.5, maxWidth: 100, bgcolor: "secondary.main" }
                    }
                  ) : e
                }
              ),
              /* @__PURE__ */ p(O, { item: !0, children: /* @__PURE__ */ p(
                he,
                {
                  iconName: r,
                  sx: { fontSize: 24, color: "#40527F" },
                  color: "primary"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, WU = () => {
  const [e, t] = Te([]), n = ot((r) => {
    if (r !== null) {
      let i = [];
      for (let a = 0; a < r.getBoundingClientRect().width / 50; a++)
        i.push(Math.floor(Math.random() * 101 + 20));
      t(i);
    }
  }, []);
  return /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(
    O,
    {
      container: !0,
      spacing: 1,
      alignItems: "flex-end",
      height: 175,
      ref: n,
      children: e.map((r, i) => /* @__PURE__ */ p(O, { item: !0, flexGrow: 1, children: /* @__PURE__ */ p(
        ii,
        {
          sx: { bgcolor: "secondary.main" },
          width: "80%",
          height: r
        }
      ) }, i))
    }
  ) });
}, UU = ({ data: e, loading: t, title: n, infoText: r }) => /* @__PURE__ */ F(
  vr,
  {
    variant: "outlined",
    sx: (i) => ({
      flexGrow: 1,
      p: 1.2,
      maxWidth: "calc(100% - 16px)",
      position: "relative",
      boxShadow: i.customShadows[3]
    }),
    children: [
      /* @__PURE__ */ p(p0, { placement: "top-right", infoText: r }),
      /* @__PURE__ */ p(le, { fontSize: 12, children: n }),
      /* @__PURE__ */ p(we, { children: t ? /* @__PURE__ */ p(WU, {}) : /* @__PURE__ */ p(JC, { width: "100%", height: 165, children: /* @__PURE__ */ F(
        Gv,
        {
          data: e,
          margin: { top: 15, left: 0, right: 10, bottom: 0 },
          children: [
            /* @__PURE__ */ p(KC, { strokeDasharray: "3 3", vertical: !1 }),
            /* @__PURE__ */ p(
              ZC,
              {
                dataKey: "weeksAgo",
                fontSize: 10,
                padding: { left: 20, right: 20 },
                tickLine: !1,
                height: 20,
                fill: "white",
                axisLine: !1,
                tickFormatter: (i) => i === 0 ? "Current week" : i === e.length - 1 ? i === 1 ? i + " week ago" : i + " weeks ago" : ""
              }
            ),
            /* @__PURE__ */ p(eE, { fontSize: 10, width: 30 }),
            /* @__PURE__ */ p(
              tE,
              {
                labelFormatter: (i) => {
                  switch (i) {
                    case 0:
                      return "Current week";
                    case 1:
                      return i + " week ago";
                    default:
                      return i + " weeks ago";
                  }
                }
              }
            ),
            /* @__PURE__ */ p(
              Vv,
              {
                type: "linear",
                dataKey: "count",
                stroke: "#1054A8",
                strokeWidth: 5,
                dot: {
                  stroke: "white",
                  strokeWidth: 2,
                  r: 4,
                  fill: "#1054A8",
                  strokeDasharray: ""
                }
              }
            )
          ]
        }
      ) }) })
    ]
  }
), ph = 210, HU = 233, GU = ({
  data: { chart: e, topLeft: t, bottomLeft: n, score: r },
  status: i
}) => {
  const a = i === ve.IN_PROGRESS || i === ve.INITIAL;
  return /* @__PURE__ */ F(O, { container: !0, spacing: 1.5, height: HU, children: [
    /* @__PURE__ */ F(
      O,
      {
        item: !0,
        maxWidth: ph,
        flexGrow: 1,
        flexDirection: "column",
        display: "flex",
        children: [
          /* @__PURE__ */ p(O, { item: !0, xs: 12, flexGrow: 1, display: "flex", mb: 1.5, children: /* @__PURE__ */ p(gv, { ...t, loading: a }) }),
          /* @__PURE__ */ p(O, { item: !0, xs: 12, flexGrow: 1, display: "flex", children: /* @__PURE__ */ p(gv, { ...n, loading: a }) })
        ]
      }
    ),
    /* @__PURE__ */ p(
      O,
      {
        container: !0,
        item: !0,
        flexDirection: "column",
        flexGrow: 2,
        maxWidth: `calc(100% - ${ph * 2}px)`,
        children: /* @__PURE__ */ p(UU, { loading: a, ...e })
      }
    ),
    /* @__PURE__ */ p(O, { flexGrow: 1, item: !0, maxWidth: ph, children: /* @__PURE__ */ p(jU, { ...r, loading: a }) })
  ] });
}, jG = ({ children: e }) => /* @__PURE__ */ p(zr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ F(we, { sx: { display: "flex", alignItems: "center" }, children: [
  /* @__PURE__ */ p(Pm, {}),
  /* @__PURE__ */ p(le, { sx: { ml: 1.5 }, variant: "body2", children: e })
] }) }), VU = ({ list: e, status: t }) => {
  var i, a;
  const [n, r] = Te("study");
  return /* @__PURE__ */ F(lr, { elevated: !0, outlined: !0, children: [
    /* @__PURE__ */ p(
      ff,
      {
        active: n,
        tabs: [
          {
            value: "study",
            title: /* @__PURE__ */ p(
              _h,
              {
                title: "By Studies",
                count: (i = e.study) == null ? void 0 : i.length,
                status: t
              }
            ),
            onTabClick: () => r("study")
          },
          {
            value: "workspace",
            title: /* @__PURE__ */ p(
              _h,
              {
                title: "By Users",
                count: (a = e.workspace) == null ? void 0 : a.length,
                status: t
              }
            ),
            onTabClick: () => r("workspace")
          }
        ],
        secondary: !0
      }
    ),
    /* @__PURE__ */ p(xa, {}),
    /* @__PURE__ */ p(
      xl,
      {
        data: e[n],
        enablePagination: !0,
        enableSorting: !0,
        initialSort: { id: "lastUsed", desc: !0 },
        isLoading: t === ve.IN_PROGRESS,
        columns: [
          // {
          //   Header: '',
          //   accessor: 'object.type',
          //   Cell: ContainerIcon,
          //   isCropped: true,
          //   width: '3%',
          //   minWidth: 50,
          //   maxWidth: 50,
          // },
          {
            Header: "Name",
            accessor: "object.name",
            Cell: Ih,
            isCropped: !0,
            width: "45%",
            minWidth: 200,
            maxWidth: 250
          },
          {
            Header: "# of analyses",
            accessor: "analyses"
          },
          {
            Header: "# of derived objects",
            accessor: "derived"
          },
          {
            Header: "Last used",
            accessor: "lastUsed",
            Cell: Fi
          }
        ]
      }
    )
  ] });
}, $G = ({ status: e, board: t, list: n }) => /* @__PURE__ */ p(hm, { children: /* @__PURE__ */ F(ze, { children: [
  /* @__PURE__ */ p(O, { item: !0, xs: 12, children: /* @__PURE__ */ p(GU, { status: e, data: t }) }),
  /* @__PURE__ */ p(O, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ p(VU, { list: n, status: e }) })
] }) }), Fs = (e) => String(e ?? "").toLowerCase().replace(/[^a-z]/g, ""), QU = (e) => String(e ?? "").trim().replace(/\s+/g, " ").toLowerCase(), no = (e) => {
  if (typeof e == "boolean") return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true") return !0;
    if (t === "false") return !1;
  }
}, Ju = (e) => e.map(QU).filter((t, n, r) => t && r.indexOf(t) === n), Ku = (e, t) => [e, t].filter(Boolean).join(" "), qU = (e) => Ju([
  Ku(e == null ? void 0 : e.firstName, e == null ? void 0 : e.lastName),
  Ku(e == null ? void 0 : e.lastName, e == null ? void 0 : e.firstName),
  e == null ? void 0 : e.name,
  e == null ? void 0 : e.title,
  e == null ? void 0 : e.displayName,
  e == null ? void 0 : e.username,
  e == null ? void 0 : e.login,
  e == null ? void 0 : e.email
]), XU = (e) => {
  var t, n, r, i;
  return Ju([
    (t = e == null ? void 0 : e.object) == null ? void 0 : t.title,
    e == null ? void 0 : e.title,
    e == null ? void 0 : e.name,
    e == null ? void 0 : e.displayName,
    Ku(e == null ? void 0 : e.firstName, e == null ? void 0 : e.lastName),
    Ku((n = e == null ? void 0 : e.object) == null ? void 0 : n.firstName, (r = e == null ? void 0 : e.object) == null ? void 0 : r.lastName),
    (i = e == null ? void 0 : e.object) == null ? void 0 : i.email,
    e == null ? void 0 : e.email
  ]);
}, JU = (e, t) => {
  var o, s, c;
  const n = Ju([
    t == null ? void 0 : t.id,
    (o = t == null ? void 0 : t.object) == null ? void 0 : o.id,
    t == null ? void 0 : t.userId
  ]);
  if (Ju([
    (s = e == null ? void 0 : e.object) == null ? void 0 : s.id,
    e == null ? void 0 : e.id,
    e == null ? void 0 : e.userId,
    (c = e == null ? void 0 : e.object) == null ? void 0 : c.userId
  ]).some((l) => n.includes(l))) return !0;
  const i = qU(t);
  return XU(e).some((l) => i.includes(l));
}, KU = (e) => {
  const t = no(e);
  if (t !== void 0) return t;
  if (Array.isArray(e))
    return e.some((n) => {
      const r = Fs(n);
      return r.includes("datasteward") || r.includes("steward") || r.includes("owner");
    });
  if (typeof e == "string") {
    const n = Fs(e);
    return n.includes("datasteward") || n.includes("steward") || n.includes("owner");
  }
  return !!(no(e == null ? void 0 : e.dataSteward) ?? no(e == null ? void 0 : e.steward) ?? no(e == null ? void 0 : e.owner));
}, ZU = (e, t) => {
  if (Array.isArray(t) && t.some((r) => Fs(r) === "admin"))
    return !0;
  const n = no(e);
  return n !== void 0 ? n : Array.isArray(e) ? e.some((r) => Fs(r).includes("admin")) : typeof e == "string" ? Fs(e).includes("admin") : !!no(e == null ? void 0 : e.admin);
}, eH = (e, t) => e == null ? void 0 : e.find((n) => JU(n, t)), tH = (e) => {
  var i, a, o, s, c, l, u;
  const t = (e == null ? void 0 : e.roles) ?? ((i = e == null ? void 0 : e.object) == null ? void 0 : i.roles), n = KU(
    (e == null ? void 0 : e.dataSteward) ?? (e == null ? void 0 : e.steward) ?? (e == null ? void 0 : e.owner) ?? ((a = e == null ? void 0 : e.object) == null ? void 0 : a.dataSteward) ?? ((o = e == null ? void 0 : e.object) == null ? void 0 : o.steward) ?? ((s = e == null ? void 0 : e.object) == null ? void 0 : s.owner) ?? t
  ), r = ZU(
    (e == null ? void 0 : e.admin) ?? ((c = e == null ? void 0 : e.object) == null ? void 0 : c.admin) ?? t ?? (e == null ? void 0 : e.actions) ?? ((l = e == null ? void 0 : e.object) == null ? void 0 : l.actions),
    (e == null ? void 0 : e.moduleIds) ?? ((u = e == null ? void 0 : e.object) == null ? void 0 : u.moduleIds)
  );
  return { steward: n, admin: r };
}, $2 = () => {
  const e = Ot((r) => r.user.data), [t, n] = Te({ steward: !1, admin: !1 });
  return tt(() => {
    if (!(e != null && e.activeTenant)) {
      n({ steward: !1, admin: !1 });
      return;
    }
    let r = !1;
    return Nn.get(`/users/tenant/${e.activeTenant}`).then((i) => {
      if (r) return;
      const a = Array.isArray(i) ? i : (i == null ? void 0 : i.data) ?? [], o = eH(a, e);
      if (!o) {
        n({ steward: !1, admin: !1 });
        return;
      }
      n(tH(o));
    }).catch(() => {
      r || n({ steward: !1, admin: !1 });
    }), () => {
      r = !0;
    };
  }, [e == null ? void 0 : e.activeTenant, e == null ? void 0 : e.id, e == null ? void 0 : e.email]), t;
};
function nH() {
  const { steward: e, admin: t } = $2();
  return e || t;
}
function WG() {
  const { steward: e } = $2();
  return e;
}
const rH = /* @__PURE__ */ F(ze, { children: [
  /* @__PURE__ */ p(le, { variant: "body1", gutterBottom: !0, children: "Are you sure you want to archive this published artifact?" }),
  /* @__PURE__ */ p(le, { variant: "body2", color: "text.secondary", children: "Basic users will no longer be able to see it in the library. Data stewards and Administrators will be able to see it in read-only mode with “Show archived” filter enabled." })
] }), iH = (e) => {
  var r;
  const t = e == null ? void 0 : e.response, n = (r = t == null ? void 0 : t.data) == null ? void 0 : r.message;
  return typeof n == "string" ? n : "Failed to archive. Please try again.";
};
function UG(e, t, n) {
  const r = nH(), { showDialog: i, hideDialog: a } = Mo(Xp), o = cr(), [s] = Hv(), { enqueueSnackbar: c } = bi(), l = !!s.get("typePublish");
  if (!(!t || !r || !e || l))
    return () => i(nm, {
      onSubmit: async () => {
        try {
          await Nn.delete(`/library/members/${e}`), a(), o(`/${n}`);
        } catch (u) {
          a(), c({
            message: iH(u),
            variant: "error"
          });
        }
      },
      onClose: a,
      title: "Archive artifact",
      text: rH,
      confirmButtonText: "ARCHIVE",
      variant: "warning"
    });
}
export {
  dm as AUTHOR_COLUMN,
  PH as AcceptConsentDialog,
  fM as Access,
  KM as ActionCell,
  iI as AliasCell,
  cG as AnalysisBaseInfo,
  hG as AnalysisResultsBaseInfo,
  Qk as AnalysisSubmissionStatusBadge,
  py as AuthorCell,
  ZH as AuthorCellWithIcon,
  rG as BaseContentWrapper,
  iG as BaseEntityContent,
  kH as BaseFormUpdateTitle,
  nG as BaseInfoWrapper,
  fm as CREATED_COLUMN,
  SG as Chart,
  _l as CodeEditor,
  uG as CohortBaseInfo,
  DH as CohortImport,
  qH as Compare,
  dG as ConceptSetBaseInfo,
  nm as ConfirmationDialog,
  EH as Content,
  Nc as Count,
  BH as CreateStudyFormBackdrop,
  hx as CsvViewer,
  yG as CustomCodeBaseInfo,
  tG as DATE_COLUMN,
  fG as DataCatalogBaseInfo,
  gx as DataSourceLabel,
  hI as DataSourceLogo,
  mG as DatabaseBaseInfo,
  Fi as DateCell,
  jG as DescriptionCard,
  FH as Dropzone,
  io as ENTITY_TO_ROUTE,
  wk as EditButton,
  Ix as EmptyListPlaceholder,
  bk as EntityImport,
  NH as EntityMessages,
  ci as EntityMessagesActionType,
  IH as EntityMessagesCntBadge,
  lk as EntityMessagesIcon,
  MH as EntityMessagesTab,
  uk as EntityMessagesText,
  Gi as EntityTypeCell,
  TU as ErrorBoundary,
  cU as ErrorPage,
  MG as Export,
  Qu as ExportListControl,
  sj as ExportMetadata,
  NG as ExportMultipleSource,
  sG as ExportWrapper,
  TG as FallbackErrorPage,
  HH as Favorite,
  UH as FavoritesHeader,
  pG as FeatureAnalysisBaseInfo,
  fx as FileContentType,
  BG as FileExplorer,
  jH as FileItem,
  IU as FileViewer,
  xD as FloatingBlock,
  wD as FloatingButton,
  nf as FormActionsContainer,
  nn as FormElement,
  rE as FormElementContainer,
  OH as FormLabel,
  PG as HomePageWidgetList,
  LG as HomePageWidgetListItem,
  aI as ICON_COLUMN,
  zx as ID_COLUMN,
  CG as IRChartScale,
  VG as IconActionButton,
  Us as IconButton,
  Y2 as IconButtonStyled,
  Pk as ImageViewer,
  YG as ImportJsonFile,
  F2 as ImportList,
  oj as ImportMetadata,
  IG as ImportMultipleSource,
  gv as InfoCard,
  Pm as InfoIcon,
  RH as InlineFormElement,
  $H as InlineSpinner,
  VH as Invitations,
  YH as ItemsCart,
  zG as LastInteracted,
  eG as LineChartCell,
  Kc as Link,
  JH as ListCell,
  Rx as ListContainer,
  zH as ListEntityBackdrop,
  mD as ListHeaderDescription,
  pD as ListHeaderPrimary,
  Mb as ListHeaderSecondary,
  Nx as ListItemContainer,
  Ox as ListItemDate,
  LH as MediaViewer,
  FG as MessageIcon,
  kG as MetaAttributes,
  RG as ModuleDescriptionCard,
  cm as NAME_COLUMN,
  Ih as NameCell,
  KH as NameWithAliasCell,
  nI as NameWithSubtitleCell,
  oG as NestedInfoWrapper,
  XH as NoData,
  QH as Notifications,
  om as NotificationsButton,
  xG as PageList,
  mx as PdfViewer,
  am as PopupContainer,
  Mx as PopupContainerHeader,
  cI as PrimaryButton,
  EG as PublishEntity,
  _k as RemoveButton,
  jU as ScoreCard,
  uI as SecondaryButton,
  hm as SecondaryContentWrapper,
  bG as Section,
  aG as ShortListWrapper,
  OG as SimpleRedirectBlock,
  cM as SpinnerContainer,
  WH as SpinnerFullContainer,
  cf as SpinnerWidgetContainer,
  $G as Statistics,
  GU as StatisticsBoard,
  lG as StudyBaseInfo,
  AG as StudyDetails,
  DG as SubModuleDescriptionBlock,
  _h as TabWithCounter,
  ff as TabsNavigationNew,
  GM as TitleWithCount,
  um as UPDATED_COLUMN,
  tj as UpdateMetaAttributes,
  dI as UseInAnalysis,
  GH as UserForm,
  _G as VersionCopyLink,
  Cl as VersionPreviewButtons,
  yD as VersionPreviewLink,
  wG as Versions,
  gG as VocabularyManagementBaseInfo,
  vG as WorkspaceDetails,
  Qv as entityMessagesInitialState,
  my as initialStorage,
  tI as lastInteractedEntityMapping,
  hy as lastInteractedPathMapping,
  oI as pageListConfig,
  SM as parseMessageEntity,
  UG as useArchiveLibraryMember,
  TH as useEntityMessages,
  nH as useIsLibraryAdmin,
  WG as useIsLibraryDataSteward,
  sI as useLocalStorage
};
//# sourceMappingURL=features.js.map
